(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("_"));
	else if(typeof define === 'function' && define.amd)
		define(["_"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("_")) : factory(root["_"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_0__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 197);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_0__;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _module$exports;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//----------------------------------------------------------------------
//
// This source file is part of the Folktale project.
//
// Licensed under MIT. See LICENCE for full licence information.
// See CONTRIBUTORS for the list of contributors to the project.
//
//----------------------------------------------------------------------


var Maybe = __webpack_require__(34);

var _require = __webpack_require__(8),
    typeSymbol = _require.typeSymbol;

/*~
 * stability: stable
 * authors:
 *   - "@boris-marinov"
 *   - Quildreen Motta
 * 
 * name: module folktale/maybe
 */


module.exports = (_module$exports = {
  Just: Maybe.Just,
  Nothing: Maybe.Nothing,
  hasInstance: Maybe.hasInstance,
  of: Maybe.of,
  empty: Maybe.empty,
  fromJSON: Maybe.fromJSON
}, _defineProperty(_module$exports, typeSymbol, Maybe[typeSymbol]), _defineProperty(_module$exports, 'fantasy-land/of', Maybe['fantasy-land/of']), _defineProperty(_module$exports, 'fromNullable', function fromNullable(aNullable) {
  return __webpack_require__(226)(aNullable);
}), _defineProperty(_module$exports, 'fromResult', function fromResult(aResult) {
  return __webpack_require__(103)(aResult);
}), _defineProperty(_module$exports, 'fromValidation', function fromValidation(aValidation) {
  return __webpack_require__(101)(aValidation);
}), _module$exports);

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(114),
    combineReducers = _require.combineReducers;

var records = __webpack_require__(121);
var config = __webpack_require__(287);
var dependencyResolution = __webpack_require__(288);
var connectedComponents = __webpack_require__(289);
var dynamicPages = __webpack_require__(130);

module.exports = combineReducers({
  records: records,
  config: config,
  dependencyResolution: dependencyResolution,
  connectedComponents: connectedComponents,
  dynamicPages: dynamicPages
});

var areDependenciesResolved = function areDependenciesResolved(state) {
  return dependencyResolution.areDependenciesResolved(state.dependencyResolution);
};
var getCollectionName = function getCollectionName(state) {
  return config.getCollectionName(state.config);
};
var getConfig = function getConfig(state) {
  return config.getConfig(state.config);
};
var getConnectedComponents = function getConnectedComponents(state) {
  return connectedComponents.getConnectedComponents(state.connectedComponents);
};
var getCurrentPageSize = function getCurrentPageSize(state) {
  return records.getCurrentPageSize(state.records);
};
var getNumberOfPagesToShow = function getNumberOfPagesToShow(state) {
  return records.getNumberOfPagesToShow(state.records);
};
var getTotalPageCount = function getTotalPageCount(state, itemsCount) {
  return Math.ceil(itemsCount / getCurrentPageSize(state));
};
var getCurrentPageIndex = function getCurrentPageIndex(state) {
  return records.getCurrentPage(state.records);
};
var getFixedFilterItem = function getFixedFilterItem(state) {
  return config.getFixedFilterItem(state.config);
};
var getIncludes = function getIncludes(state) {
  return getConfig(state).includes || [];
};
var getPageSize = function getPageSize(state) {
  return config.getPageSize(state.config);
};
var getPaginationData = function getPaginationData(state) {
  return records.getPaginationData(state.records);
};
var getCurrentPage = function getCurrentPage(state) {
  return records.getCurrentPage(state.records);
};
var getReadWriteMode = function getReadWriteMode(state) {
  return config.getReadWriteMode(state.config);
};
var hasCurrentRecord = function hasCurrentRecord(state) {
  return records.hasCurrentRecord(state.records);
};
var isDatasetConfigured = function isDatasetConfigured(state) {
  return config.isDatasetConfigured(state.config);
};
var isDatasetReady = function isDatasetReady(state) {
  return config.isDatasetReady(state.config);
};
var isDuringSave = function isDuringSave(state) {
  return config.isDuringSave(state.config);
};
var isReadOnly = function isReadOnly(state) {
  return config.isReadOnly(state.config);
};
var isWriteOnly = function isWriteOnly(state) {
  return config.isWriteOnly(state.config);
};
var selectCurrentRecord = function selectCurrentRecord(state) {
  return records.selectCurrentRecord(state.records);
};
var selectCurrentRecordIndex = function selectCurrentRecordIndex(state) {
  return records.selectCurrentRecordIndex(state.records);
};
var selectDefaultDraft = function selectDefaultDraft(state) {
  return records.selectDefaultDraft(state.records);
};
var selectFieldsToUpdate = function selectFieldsToUpdate(state) {
  return records.selectFieldsToUpdate(state.records);
};
var selectLastSavedRecord = function selectLastSavedRecord(state) {
  return records.selectLastSavedRecord(state.records);
};
var selectUpdateSource = function selectUpdateSource(state) {
  return records.selectUpdateSource(state.records);
};
var selectNextDynamicPageUrl = function selectNextDynamicPageUrl(state) {
  return dynamicPages.selectNextDynamicPageUrl(state.dynamicPages);
};
var selectPreviousDynamicPageUrl = function selectPreviousDynamicPageUrl(state) {
  return dynamicPages.selectPreviousDynamicPageUrl(state.dynamicPages);
};

module.exports.areDependenciesResolved = areDependenciesResolved;
module.exports.getCollectionName = getCollectionName;
module.exports.getConfig = getConfig;
module.exports.getConnectedComponents = getConnectedComponents;
module.exports.getCurrentPageSize = getCurrentPageSize;
module.exports.getNumberOfPagesToShow = getNumberOfPagesToShow;
module.exports.getTotalPageCount = getTotalPageCount;
module.exports.getCurrentPageIndex = getCurrentPageIndex;
module.exports.getFixedFilterItem = getFixedFilterItem;
module.exports.getIncludes = getIncludes;
module.exports.getPageSize = getPageSize;
module.exports.getPaginationData = getPaginationData;
module.exports.getCurrentPage = getCurrentPage;
module.exports.getReadWriteMode = getReadWriteMode;
module.exports.hasCurrentRecord = hasCurrentRecord;
module.exports.isDatasetConfigured = isDatasetConfigured;
module.exports.isDatasetReady = isDatasetReady;
module.exports.isDuringSave = isDuringSave;
module.exports.isReadOnly = isReadOnly;
module.exports.isWriteOnly = isWriteOnly;
module.exports.selectCurrentRecord = selectCurrentRecord;
module.exports.selectCurrentRecordIndex = selectCurrentRecordIndex;
module.exports.selectDefaultDraft = selectDefaultDraft;
module.exports.selectFieldsToUpdate = selectFieldsToUpdate;
module.exports.selectLastSavedRecord = selectLastSavedRecord;
module.exports.selectUpdateSource = selectUpdateSource;
module.exports.selectNextDynamicPageUrl = selectNextDynamicPageUrl;
module.exports.selectPreviousDynamicPageUrl = selectPreviousDynamicPageUrl;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(149);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 4 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 5 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
var envFallback = {};

var env = function env() {

  if (typeof window !== 'undefined') {

    return window;
  } else if (typeof global !== 'undefined') {

    return global;
  } else if (typeof WorkerGlobalScope !== 'undefined') {

    /* global WorkerGlobalScope */
    return WorkerGlobalScope;
  } else {

    return envFallback;
  }
};

exports.env = env;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 7 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _defineEnumerableProperties(obj, descs) { for (var key in descs) { var desc = descs[key]; desc.configurable = desc.enumerable = true; if ("value" in desc) desc.writable = true; Object.defineProperty(obj, key, desc); } return obj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//----------------------------------------------------------------------
//
// This source file is part of the Folktale project.
//
// Licensed under MIT. See LICENCE for full licence information.
// See CONTRIBUTORS for the list of contributors to the project.
//
//----------------------------------------------------------------------

// --[ Dependencies ]---------------------------------------------------
var warnDeprecation = __webpack_require__(19);
var extend = __webpack_require__(23);

// --[ Constants and Aliases ]------------------------------------------
var TYPE = Symbol.for('@@folktale:adt:type');
var TAG = Symbol.for('@@folktale:adt:tag');
var META = Symbol.for('@@meta:magical');

var keys = Object.keys;

// --[ Helpers ]--------------------------------------------------------

//
// Returns an array of own enumerable values in an object.
//
function values(object) {
  return keys(object).map(function (key) {
    return object[key];
  });
}

//
// Transforms own enumerable key/value pairs.
//
function mapObject(object, transform) {
  return keys(object).reduce(function (result, key) {
    result[key] = transform(key, object[key]);
    return result;
  }, {});
}

// --[ Variant implementation ]-----------------------------------------

//
// Defines the variants given a set of patterns and an ADT namespace.
//
function defineVariants(typeId, patterns, adt) {
  return mapObject(patterns, function (name, constructor) {
    var _constructor, _ref, _extend, _mutatorMap, _tag, _type, _constructor2, _extend2, _mutatorMap2;

    // ---[ Variant Internals ]-----------------------------------------
    function InternalConstructor() {}
    InternalConstructor.prototype = Object.create(adt);

    extend(InternalConstructor.prototype, (_extend = {}, _defineProperty(_extend, TAG, name), _constructor = 'constructor', _mutatorMap = {}, _mutatorMap[_constructor] = _mutatorMap[_constructor] || {}, _mutatorMap[_constructor].get = function () {
      return constructor;
    }, _ref = 'is' + name, _mutatorMap[_ref] = _mutatorMap[_ref] || {}, _mutatorMap[_ref].get = function () {
      warnDeprecation('.is' + name + ' is deprecated. Use ' + name + '.hasInstance(value)\ninstead to check if a value belongs to the ADT variant.');
      return true;
    }, _defineProperty(_extend, 'matchWith', function matchWith(pattern) {
      return pattern[name](this);
    }), _defineEnumerableProperties(_extend, _mutatorMap), _extend));

    function makeInstance() {
      var result = new InternalConstructor(); // eslint-disable-line prefer-const
      extend(result, constructor.apply(undefined, arguments) || {});
      return result;
    }

    extend(makeInstance, (_extend2 = {}, _defineProperty(_extend2, META, constructor[META]), _tag = 'tag', _mutatorMap2 = {}, _mutatorMap2[_tag] = _mutatorMap2[_tag] || {}, _mutatorMap2[_tag].get = function () {
      return name;
    }, _type = 'type', _mutatorMap2[_type] = _mutatorMap2[_type] || {}, _mutatorMap2[_type].get = function () {
      return typeId;
    }, _constructor2 = 'constructor', _mutatorMap2[_constructor2] = _mutatorMap2[_constructor2] || {}, _mutatorMap2[_constructor2].get = function () {
      return constructor;
    }, _defineProperty(_extend2, 'prototype', InternalConstructor.prototype), _defineProperty(_extend2, 'hasInstance', function hasInstance(value) {
      return Boolean(value) && adt.hasInstance(value) && value[TAG] === name;
    }), _defineEnumerableProperties(_extend2, _mutatorMap2), _extend2));

    return makeInstance;
  });
}

// --[ ADT Implementation ]--------------------------------------------

/*~
 * authors:
 *   - Quildreen Motta
 * 
 * stability: experimental
 * type: |
 *   (String, Object (Array String)) => Union
 */
var union = function union(typeId, patterns) {
  var _extend3;

  var UnionNamespace = Object.create(Union);
  var variants = defineVariants(typeId, patterns, UnionNamespace);

  extend(UnionNamespace, variants, (_extend3 = {}, _defineProperty(_extend3, TYPE, typeId), _defineProperty(_extend3, 'variants', values(variants)), _defineProperty(_extend3, 'hasInstance', function hasInstance(value) {
    return Boolean(value) && value[TYPE] === this[TYPE];
  }), _extend3));

  return UnionNamespace;
};

/*~ ~belongsTo : union */
var Union = {
  /*~
   * type: |
   *   Union . (...(Variant, Union) => Any) => Union
   */
  derive: function derive() {
    var _this = this;

    for (var _len = arguments.length, derivations = Array(_len), _key = 0; _key < _len; _key++) {
      derivations[_key] = arguments[_key];
    }

    derivations.forEach(function (derivation) {
      _this.variants.forEach(function (variant) {
        return derivation(variant, _this);
      });
    });
    return this;
  }
};

// --[ Exports ]--------------------------------------------------------
union.Union = Union;
union.typeSymbol = TYPE;
union.tagSymbol = TAG;

module.exports = union;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});
exports.wixDataError = wixDataError;
exports.validationError = validationError;
exports.schemaNotFoundError = schemaNotFoundError;
exports.BulkError = BulkError;

var _sharedTypeUtils = __webpack_require__(14);

var messages = {
  siteIsInTemplateMode: function siteIsInTemplateMode() {
    return 'The current site is in template mode. Please save it to modify data.';
  },
  collectionNameMustBeAString: function collectionNameMustBeAString() {
    return 'Collection name must be a string.';
  },
  itemIdMustBeAString: function itemIdMustBeAString() {
    return 'ItemId must be a string.';
  },
  itemMustBeAnObject: function itemMustBeAnObject(item, collectionName) {
    return 'Failed to save [' + item + '] into [' + collectionName + '].\nItems must be JavaScript objects.';
  },
  itemsMustBeArrayOfObjects: function itemsMustBeArrayOfObjects(collectionName) {
    return 'Failed to bulk save items into [' + collectionName + '].\nItems must be an array of JavaScript objects and itemIds must be strings if present.';
  },
  itemsMustBeLessThanThousand: function itemsMustBeLessThanThousand(collectionName) {
    return 'Failed to bulk save items into [' + collectionName + '].\nCannot insert more than 1000 items in one request';
  },
  updateItemInvalid: function updateItemInvalid() {
    return 'Invalid update. Updated object must have a string _id property.';
  },
  invalidArgumentLength: function invalidArgumentLength(method, from, to, actual) {
    return 'wixData.' + method + ' expects between ' + from + ' and ' + to + ' arguments, but was called with ' + actual + '.';
  },
  schemaDoesNotExist: function schemaDoesNotExist(collectionName) {
    return 'The ' + collectionName + ' collection does not exist. You cannot work with a collection using the Data API before it is created in the Editor.';
  },
  collectionDeleted: function collectionDeleted(collectionName) {
    return 'The ' + collectionName + ' collection was removed, so you cannot work with it. To restore its data, create a new collection with the same name.';
  },
  permissionDenied: function permissionDenied(action, collectionName) {
    return 'The current user does not have permissions to ' + action + ' on the ' + collectionName + ' collection.';
  },
  internalError: function internalError(message) {
    return 'Internal wixData error: ' + message;
  },
  serverApiError: function serverApiError(message) {
    return message;
  },
  serverGeneralError: function serverGeneralError() {
    return 'The server could not fulfill the request.';
  },
  serverInvalidResponse: function serverInvalidResponse() {
    return 'Failed to parse server response.';
  },
  serverAuthorizationProblem: function serverAuthorizationProblem(responseJson) {
    return 'You are not authorized to access the requested resource: ' + responseJson;
  },
  serverAuthenticationProblem: function serverAuthenticationProblem() {
    return 'Authentication failed.';
  },
  internalAuthorizationProblem: function internalAuthorizationProblem() {
    return 'An internal error has occurred while trying to check authorization.';
  },
  errorConnectingToServer: function errorConnectingToServer() {
    return 'Error connecting to server.';
  },
  queryInvalid: function queryInvalid(collectionName, invalidArguments) {
    return 'Failed to perform query on [' + collectionName + '].\n' + invalidArguments.join('\n');
  },
  filterBuilderInvalid: function filterBuilderInvalid(invalidArguments) {
    return 'Failed to build a filter.\n' + invalidArguments.join('\n') + '.';
  },
  filterMustBeAnObject: function filterMustBeAnObject() {
    return 'Filter must be an object.';
  },
  sortBuilderInvalid: function sortBuilderInvalid(invalidArguments) {
    return 'Failed to build a sort.\n' + invalidArguments.join('\n') + '.';
  },
  optionsInvalid: function optionsInvalid(properties) {
    return 'Options must be an object with one or all of the following boolean properties: ' + properties.join(', ') + '.';
  },
  referenceOperationParameterError: function referenceOperationParameterError() {
    return 'Reference operation takes a string ID or an object with an ID to be connected';
  },
  multipleMultiRefIncludeError: function multipleMultiRefIncludeError() {
    return 'Unable to execute a query. Only single multi-reference field can be included.';
  },
  multiRefItemLimitError: function multiRefItemLimitError() {
    return 'Can not fetch more than 50 elements when include is being used on multi-reference field';
  },
  fieldIsDeleted: function fieldIsDeleted() {
    return 'Field is deleted';
  },
  queryValidations: {
    collectionNameIsRequired: function collectionNameIsRequired() {
      return 'Collection name is required and must be a string.';
    },
    isNumber: function isNumber(operatorName, specifier, operand) {
      return 'Invalid ' + operatorName + ' parameter [' + (0, _sharedTypeUtils.typeForDisplay)(operand) + ']. ' + operatorName + ' parameter must be a ' + specifier + ' number.';
    },
    isPositiveNumber: function isPositiveNumber(operatorName, operand) {
      return 'Invalid ' + operatorName + ' parameter [' + operand + ']. ' + operatorName + ' parameter must be a positive number.';
    },
    isNonNegativeNumber: function isNonNegativeNumber(operatorName, operand) {
      return 'Invalid ' + operatorName + ' parameter [' + operand + ']. ' + operatorName + ' parameter must be a non-negative number.';
    },
    isInteger: function isInteger(operatorName, operand) {
      return 'Invalid ' + operatorName + ' parameter [' + operand + ']. ' + operatorName + ' parameter must be an integer.';
    },
    notGreaterThan: function notGreaterThan(operatorName, operand, value) {
      return 'Invalid ' + operatorName + ' parameter [' + operand + ']. ' + operatorName + ' parameter cannot exceed ' + value + '.';
    }
  },
  arityValidations: {
    arityIsOne: function arityIsOne(operatorName) {
      return 'Invalid ' + operatorName + ' usage. ' + operatorName + ' requires one parameter.';
    },
    arityIsTwo: function arityIsTwo(operatorName) {
      return 'Invalid ' + operatorName + ' usage. ' + operatorName + ' requires two parameters.';
    },
    arityIsThree: function arityIsThree(operatorName) {
      return 'Invalid ' + operatorName + ' usage. ' + operatorName + ' requires three parameters.';
    },
    arityIsAtLeastTwo: function arityIsAtLeastTwo(operatorName) {
      return 'Invalid ' + operatorName + ' usage. ' + operatorName + ' requires at least two parameters.';
    },
    arityIsAtLeastOne: function arityIsAtLeastOne(operatorName) {
      return 'Invalid ' + operatorName + ' usage. ' + operatorName + ' requires at least one parameter.';
    }
  },
  filterValidations: {
    typeIsString: function typeIsString(operatorName, value) {
      return 'Invalid ' + operatorName + ' parameter value [' + (0, _sharedTypeUtils.typeForDisplay)(value) + ']. ' + operatorName + ' parameter must be a String.';
    },
    typeIsStringNumberOrDate: function typeIsStringNumberOrDate(operatorName, value) {
      return 'Invalid ' + operatorName + ' parameter value [' + (0, _sharedTypeUtils.typeForDisplay)(value) + ']. Valid ' + operatorName + ' parameter types are String, Number or Date.';
    },
    sameType: function sameType(operatorName, first, second) {
      return 'Invalid ' + operatorName + ' parameter values [' + (0, _sharedTypeUtils.typeForDisplay)(first) + '] and [' + (0, _sharedTypeUtils.typeForDisplay)(second) + ']. Both parameters must be of the same type.';
    },
    typeIsStringNumberOrDateForAll: function typeIsStringNumberOrDateForAll(operatorName) {
      return 'Invalid ' + operatorName + ' usage. ' + operatorName + ' supports only Number, String or Date items.';
    },
    validFieldName: function validFieldName(operatorName, field) {
      return 'Invalid ' + operatorName + ' field value [' + (0, _sharedTypeUtils.typeForDisplay)(field) + ']. ' + operatorName + ' field must be a String.';
    },
    isInstanceOfSameClass: function isInstanceOfSameClass(operatorName, constructorName, obj) {
      return 'Invalid ' + operatorName + ' parameter [' + (0, _sharedTypeUtils.typeForDisplay)(obj) + ']. ' + operatorName + ' expects ' + constructorName + ' only.';
    },
    isForCollection: function isForCollection(operatorName, constructorName, collectionName) {
      return 'Invalid ' + operatorName + ' parameter query for [' + collectionName + ']. ' + operatorName + ' accepts ' + constructorName + ' for the same collection only.';
    }
  },
  sortValidations: {
    typeIsStringOrArrayOfStrings: function typeIsStringOrArrayOfStrings(operatorName, effectiveArgs) {
      return 'Invalid ' + operatorName + ' parameters [' + effectiveArgs.map(_sharedTypeUtils.typeForDisplay) + ']. Valid ' + operatorName + ' values are String, Array of String or varargs String.';
    }
  }

};

exports.messages = messages;
var codes = {
  ItemDoesNotExist: 'WD_ITEM_DOES_NOT_EXIST',
  ItemAlreadyExists: 'WD_ITEM_ALREADY_EXISTS',
  SiteInTemplateMode: 'WD_SITE_IN_TEMPLATE_MODE',
  UnknownError: 'WD_UNKNOWN_ERROR',
  ValidationError: 'WD_VALIDATION_ERROR',
  CollectionDeleted: 'WD_COLLECTION_DELETED',
  SchemaDoesNotExist: 'WD_SCHEMA_DOES_NOT_EXIST',
  PermissionDenied: 'WD_PERMISSION_DENIED'
};

exports.codes = codes;
// todo add code

function wixDataError(message, code) {
  return errorWithCode(message, code);
}

function validationError(message) {
  return errorWithCode(message, codes.ValidationError);
}

function errorWithCode(message, code) {
  var error = new Error(message);
  error.code = code;
  return error;
}

function schemaNotFoundError(collectionName) {
  return wixDataError('Failed to load schema for collection ' + collectionName, codes.SchemaDoesNotExist);
}

function BulkError(message, code, item) {
  var errorInstance = new Error(message, code);
  errorInstance.item = item;
  Object.setPrototypeOf(errorInstance, Object.getPrototypeOf(this));
  Error.captureStackTrace(errorInstance, BulkError);
  return errorInstance;
}

BulkError.prototype = Object.create(Error.prototype, {
  constructor: {
    value: Error,
    enumerable: false,
    writable: true,
    configurable: true
  }
});

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createMiddleware = __webpack_require__(281);
var combineSubscribers = __webpack_require__(283);

var _require = __webpack_require__(285),
    createImmediateCmd = _require.createImmediateCmd,
    createQueuedCmd = _require.createQueuedCmd;

var _require2 = __webpack_require__(123),
    matchAction = _require2.match;

module.exports.createMiddleware = createMiddleware;
module.exports.combineSubscribers = combineSubscribers;
module.exports.createImmediateCmd = createImmediateCmd;
module.exports.createQueuedCmd = createQueuedCmd;

module.exports.matchAction = matchAction;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(21),
    getRawTag = __webpack_require__(341),
    objectToString = __webpack_require__(342);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 12 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ExtendableError = __webpack_require__(230);
var ERROR_TYPE = 'DatasetError';

var DatasetError = function (_ExtendableError) {
  _inherits(DatasetError, _ExtendableError);

  function DatasetError(code, message) {
    _classCallCheck(this, DatasetError);

    var _this = _possibleConstructorReturn(this, (DatasetError.__proto__ || Object.getPrototypeOf(DatasetError)).call(this, message));

    _this.name = ERROR_TYPE;
    _this.code = code;
    return _this;
  }

  return DatasetError;
}(ExtendableError);

module.exports = DatasetError;

module.exports.isDatasetError = function (errorType) {
  return errorType === ERROR_TYPE;
};

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});
exports.isObject = isObject;
exports.isArray = isArray;
exports.isDate = isDate;
exports.isNumber = isNumber;
exports.isBoolean = isBoolean;
exports.isString = isString;
exports.isFunction = isFunction;
exports.typeForDisplay = typeForDisplay;
exports.isUndefined = isUndefined;
exports.isNull = isNull;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _kindOf = __webpack_require__(249);

var _kindOf2 = _interopRequireDefault(_kindOf);

function isObject(obj) {
  return (0, _kindOf2['default'])(obj) === 'object';
}

function isArray(arr) {
  return (0, _kindOf2['default'])(arr) === 'array';
}

function isDate(obj) {
  return (0, _kindOf2['default'])(obj) === 'date';
}

function isNumber(obj) {
  return (0, _kindOf2['default'])(obj) === 'number';
}

function isBoolean(obj) {
  return (0, _kindOf2['default'])(obj) === 'boolean';
}

function isString(obj) {
  return (0, _kindOf2['default'])(obj) === 'string';
}

function isFunction(obj) {
  return (0, _kindOf2['default'])(obj) === 'function';
}

function typeForDisplay(obj) {
  return upperCaseFirst((0, _kindOf2['default'])(obj));
}

function isUndefined(obj) {
  return (0, _kindOf2['default'])(obj) === 'undefined';
}

function isNull(obj) {
  return (0, _kindOf2['default'])(obj) === 'null';
}

function upperCaseFirst(str) {
  if (!isString(str)) {
    return str;
  }
  var first = str.slice(0, 1).toUpperCase();
  var rest = str.slice(1, str.length);
  return first + rest;
}

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (component, listener, handler, _ref) {
  var applicationCodeZone = _ref.applicationCodeZone;
  return component[listener](applicationCodeZone(handler));
};

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(340),
    getValue = __webpack_require__(345);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _dataItem = __webpack_require__(95);

var _dataItem2 = _interopRequireDefault(_dataItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Represents bi events from the "fed monitoring" source:
 * http://bo.wix.com/bi-catalog-webapp/#/sources/72
 */
var BiBaseDataItem = function (_DataItem) {
  _inherits(BiBaseDataItem, _DataItem);

  function BiBaseDataItem(evid, sessionId) {
    _classCallCheck(this, BiBaseDataItem);

    return _possibleConstructorReturn(this, (BiBaseDataItem.__proto__ || Object.getPrototypeOf(BiBaseDataItem)).call(this, {
      src: 72,
      evid: evid,
      session_id: sessionId, // eslint-disable-line
      _: new Date().getTime() // cache buster
    }));
  }

  return BiBaseDataItem;
}(_dataItem2.default);

exports.default = BiBaseDataItem;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _module$exports;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//----------------------------------------------------------------------
//
// This source file is part of the Folktale project.
//
// Licensed under MIT. See LICENCE for full licence information.
// See CONTRIBUTORS for the list of contributors to the project.
//
//----------------------------------------------------------------------

var Result = __webpack_require__(22);

var _require = __webpack_require__(8),
    typeSymbol = _require.typeSymbol;

/*~
 * stability: stable
 * name: module folktale/result
 */


module.exports = (_module$exports = {
  Error: Result.Error,
  Ok: Result.Ok,
  hasInstance: Result.hasInstance,
  of: Result.of,
  fromJSON: Result.fromJSON
}, _defineProperty(_module$exports, typeSymbol, Result[typeSymbol]), _defineProperty(_module$exports, 'try', __webpack_require__(217)), _defineProperty(_module$exports, 'fromNullable', function fromNullable(aNullable, fallbackValue) {
  var nullableToResult = __webpack_require__(218);

  if (arguments.length > 1) {
    // eslint-disable-line prefer-rest-params 
    return nullableToResult(aNullable, fallbackValue);
  } else {
    return nullableToResult(aNullable);
  }
}), _defineProperty(_module$exports, 'fromValidation', function fromValidation(aValidation) {
  return __webpack_require__(100)(aValidation);
}), _defineProperty(_module$exports, 'fromMaybe', function fromMaybe(aMaybe, failureValue) {
  return __webpack_require__(102)(aMaybe, failureValue);
}), _module$exports);

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//----------------------------------------------------------------------
//
// This source file is part of the Folktale project.
//
// Licensed under MIT. See LICENCE for full licence information.
// See CONTRIBUTORS for the list of contributors to the project.
//
//----------------------------------------------------------------------

var BLAME_FUNCTION_INDEX = 3; // [current, parent, *error*, caller to blame, …]

function warnDeprecation(reason) {
  // eslint-disable-line max-statements
  if (Object({"NODE_ENV":"production"}).FOLKTALE_ASSERTIONS !== 'none') {
    var stack = new Error('').stack;
    var offender = void 0;
    if (stack) {
      var lines = stack.split('\n');
      offender = lines[BLAME_FUNCTION_INDEX];
    }

    if (offender) {
      console.warn(reason + '\n    Blame: ' + offender.trim());
    } else {
      console.warn(reason);
    }
  }
}

module.exports = warnDeprecation;

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var mapValues_ = __webpack_require__(0).mapValues;
var mapKeys_ = __webpack_require__(0).mapKeys;
var maybe = __webpack_require__(1);

var types = {
  Text: {
    viewerType: ['wysiwyg.viewer.components.WRichText'],
    sdkType: '$w.Text'
  },
  Image: {
    viewerType: ['wysiwyg.viewer.components.WPhoto'],
    sdkType: '$w.Image'
  },
  TextInput: {
    viewerType: ['wysiwyg.viewer.components.inputs.TextInput'],
    sdkType: '$w.TextInput'
  },
  Button: {
    viewerType: ['wysiwyg.viewer.components.SiteButton'],
    sdkType: '$w.Button'
  },
  IconButton: {
    viewerType: ['wysiwyg.common.components.imagebutton.viewer.ImageButton'],
    sdkType: '$w.IconButton'
  },
  RatingsDisplay: {
    viewerType: ['wixui.RatingsDisplay'],
    sdkType: '$w.RatingsDisplay'
  },
  VerticalMenu: {
    viewerType: ['wysiwyg.common.components.verticalmenu.viewer.VerticalMenu'],
    sdkType: '$w.VerticalMenu'
  },
  Checkbox: {
    viewerType: ['wysiwyg.viewer.components.inputs.Checkbox'],
    sdkType: '$w.Checkbox'
  },
  Gallery: {
    viewerType: ['wysiwyg.viewer.components.MatrixGallery', 'wysiwyg.viewer.components.SliderGallery', 'wysiwyg.viewer.components.SlideShowGallery', 'wysiwyg.viewer.components.PaginatedGridGallery', 'wysiwyg.viewer.components.tpapps.TPAWidget'],
    sdkType: '$w.Gallery'
  },
  Dropdown: {
    viewerType: ['wysiwyg.viewer.components.inputs.ComboBoxInput'],
    sdkType: '$w.Dropdown'
  },
  TextBox: {
    viewerType: ['wysiwyg.viewer.components.inputs.TextAreaInput'],
    sdkType: '$w.TextBox'
  },
  Table: {
    viewerType: ['wysiwyg.viewer.components.Grid'],
    sdkType: '$w.Table'
  },
  DatePicker: {
    viewerType: ['wysiwyg.viewer.components.inputs.DatePicker'],
    sdkType: '$w.DatePicker'
  },
  RadioButtonGroup: {
    viewerType: ['wysiwyg.viewer.components.inputs.RadioGroup'],
    sdkType: '$w.RadioButtonGroup'
  },
  UploadButton: {
    viewerType: ['wysiwyg.viewer.components.inputs.UploadButton'],
    sdkType: '$w.UploadButton'
  },
  Column: {
    viewerType: ['wysiwyg.viewer.components.Column'],
    sdkType: '$w.Column'
  },
  Video: {
    viewerType: ['wysiwyg.viewer.components.Video'],
    sdkType: '$w.Video'
  },
  Repeater: {
    viewerType: ['we-should-not-rely-on-this.Repeater' /*wysiwyg.viewer.components.Repeater*/
    ],
    sdkType: '$w.Repeater'
  },
  Pagination: {
    viewerType: ['wixui.Pagination'],
    sdkType: '$w.Pagination'
  },
  Page: {
    viewerType: ['mobile.core.components.Page'],
    sdkType: '$w.Page'
  },
  Document: {
    viewerType: ['fake-document-type'],
    sdkType: '$w.Document'
  },
  MediaContainer: {
    viewerType: ['wysiwyg.viewer.components.MediaContainer'],
    sdkType: '$w.Container'
  },
  StripColumnsContainer: {
    viewerType: ['wysiwyg.viewer.components.StripColumnsContainer'],
    sdkType: '$w.ColumnStrip'
  },
  ToggleSwitch: {
    viewerType: ['wixui.ToggleSwitch'],
    sdkType: '$w.Switch'
  },
  Slider: {
    viewerType: ['wixui.Slider'],
    sdkType: '$w.Slider'
  }
};

module.exports = mapValues_(types, function (_ref) {
  var sdkType = _ref.sdkType;
  return sdkType;
});

module.exports.getSdkTypeByViewerType = function (viewerType) {
  return maybe.fromNullable(Object.keys(types).filter(function (key) {
    return types[key].viewerType.indexOf(viewerType) >= 0;
  }).map(function (key) {
    return types[key].sdkType;
  })[0]);
};

module.exports.getViewerTypeBySdkType = function (sdkType) {
  return maybe.fromNullable(Object.keys(types).filter(function (key) {
    return types[key].sdkType === sdkType;
  }).map(function (key) {
    return types[key].viewerType[0];
  })[0]);
};

module.exports.getViewerTypes = Object.keys(types).reduce(function (acc, val) {
  acc.concat(types[val].viewerType);
  return acc;
}, []);

module.exports.viewerTypes = Object.keys(types).map(function (key) {
  return types[key].viewerType;
}).reduce(function (acc, val) {
  return acc.concat(val);
}, []).reduce(function (acc, type) {
  acc[type.split('.').reverse()[0]] = type;
  return acc;
}, {});

module.exports.isSdkTypeSupported = function (sdkType) {
  return !!mapKeys_(types, function (_ref2) {
    var sdkType = _ref2.sdkType;
    return sdkType;
  })[sdkType];
};

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(3);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//----------------------------------------------------------------------
//
// This source file is part of the Folktale project.
//
// Licensed under MIT. See LICENCE for full licence information.
// See CONTRIBUTORS for the list of contributors to the project.
//
//----------------------------------------------------------------------

var assertType = __webpack_require__(32);
var assertFunction = __webpack_require__(58);

var _require = __webpack_require__(59),
    union = _require.union,
    derivations = _require.derivations;

var provideAliases = __webpack_require__(33);
var adtMethods = __webpack_require__(60);
var extend = __webpack_require__(23);
var warnDeprecation = __webpack_require__(19);

var equality = derivations.equality,
    debugRepresentation = derivations.debugRepresentation,
    serialization = derivations.serialization;

/*~ stability: experimental */

var Result = union('folktale:Result', {
  /*~
   * stability: experimental
   * type: |
   *   forall a, b: (a) => Result a b
   */
  Error: function Error(value) {
    return { value: value };
  },


  /*~
   * stability: experimental
   * type: |
   *   forall a, b: (b) => Result a b
   */
  Ok: function Ok(value) {
    return { value: value };
  }
}).derive(equality, debugRepresentation, serialization);

var Error = Result.Error,
    Ok = Result.Ok;


var assertResult = assertType(Result);

extend(Error.prototype, {
  /*~
   * isRequired: true
   * type: |
   *   forall a, b: get (Result a b) => a
   */
  get value() {
    throw new TypeError('`value` can’t be accessed in an abstract instance of Result.Error');
  }
});

extend(Ok.prototype, {
  /*~
   * isRequired: true
   * type: |
   *   forall a, b: get (Result a b) => b
   */
  get value() {
    throw new TypeError('`value` can’t be accessed in an abstract instance of Result.Ok');
  }
});

/*~
 * ~belongsTo: Result
 */
adtMethods(Result, {
  /*~
   * stability: experimental
   * type: |
   *   forall a, b, c:
   *     (Result a b).((b) => c) => Result a c
   */
  map: {
    /*~*/
    Error: function map(f) {
      assertFunction('Result.Error#map', f);
      return this;
    },

    /*~*/
    Ok: function map(f) {
      assertFunction('Result.Ok#map', f);
      return Ok(f(this.value));
    }
  },

  /*~
   * stability: experimental
   * type: |
   *   forall a, b, c:
   *     (Result a ((b) => c)).(Result a b) => Result a c
   */
  apply: {
    /*~*/
    Error: function apply(anResult) {
      assertResult('Result.Error#apply', anResult);
      return this;
    },

    /*~*/
    Ok: function apply(anResult) {
      assertResult('Result.Ok#apply', anResult);
      return anResult.map(this.value);
    }
  },

  /*~
   * stability: experimental
   * type: |
   *   forall a, b, c:
   *     (Result a b).((b) => Result a c) => Result a c
   */
  chain: {
    /*~*/
    Error: function chain(f) {
      assertFunction('Result.Error#chain', f);
      return this;
    },

    /*~*/
    Ok: function chain(f) {
      assertFunction('Result.Ok#chain', f);
      return f(this.value);
    }
  },

  /*~
   * stability: experimental
   * type: |
   *   forall a, b: (Result a b).() => b :: throws TypeError
   */
  unsafeGet: {
    /*~*/
    Error: function unsafeGet() {
      throw new TypeError('Can\'t extract the value of an Error.\n\nError does not contain a normal value - it contains an error.\nYou might consider switching from Result#unsafeGet to Result#getOrElse,\nor some other method that is not partial.\n      ');
    },

    /*~*/
    Ok: function unsafeGet() {
      return this.value;
    }
  },

  /*~
   * stability: experimental
   * type: |
   *   forall a, b: (Result a b).(b) => b
   */
  getOrElse: {
    /*~*/
    Error: function getOrElse(_default) {
      return _default;
    },

    /*~*/
    Ok: function getOrElse(_default) {
      return this.value;
    }
  },

  /*~
   * stability: experimental
   * type: |
   *   forall a, b, c:
   *     (Result a b).((a) => Result c b) => Result c b
   */
  orElse: {
    /*~*/
    Error: function orElse(handler) {
      assertFunction('Result.Error#orElse', handler);
      return handler(this.value);
    },

    /*~*/
    Ok: function orElse(handler) {
      assertFunction('Result.Ok#orElse', handler);
      return this;
    }
  },

  /*~
   * stability: stable
   * type: |
   *   forall a, b: (Result a b).(Result a b) => Result a b
   *   where b is Semigroup
   */
  concat: {
    /*~*/
    Error: function concat(aResult) {
      assertResult('Result.Error#concat', aResult);
      return this;
    },

    /*~*/
    Ok: function concat(aResult) {
      var _this = this;

      assertResult('Result.Ok#concat', aResult);
      return aResult.map(function (xs) {
        return _this.value.concat(xs);
      });
    }
  },

  /*~
   * stability: experimental
   * type: |
   *   forall a, b, c:
   *     (Result a b).((a) => c, (b) => c) => c
   */
  fold: {
    /*~*/
    Error: function fold(f, g) {
      assertFunction('Result.Error#fold', f);
      assertFunction('Result.Error#fold', g);
      return f(this.value);
    },

    /*~*/
    Ok: function fold(f, g) {
      assertFunction('Result.Ok#fold', f);
      assertFunction('Result.Ok#fold', g);
      return g(this.value);
    }
  },

  /*~
   * stability: experimental
   * type: |
   *   forall a, b: (Result a b).() => Result b a
   */
  swap: {
    /*~*/
    Error: function swap() {
      return Ok(this.value);
    },

    /*~*/
    Ok: function swap() {
      return Error(this.value);
    }
  },

  /*~
   * stability: experimental
   * type: |
   *   (Result a b).((a) => c, (b) => d) => Result c d
   */
  bimap: {
    /*~*/
    Error: function bimap(f, g) {
      assertFunction('Result.Error#bimap', f);
      assertFunction('Result.Error#bimap', g);
      return Error(f(this.value));
    },

    /*~*/
    Ok: function bimap(f, g) {
      assertFunction('Result.Ok#bimap', f);
      assertFunction('Result.Ok#bimap', g);
      return Ok(g(this.value));
    }
  },

  /*~
   * stability: experimental
   * type: |
   *   forall a, b, c:
   *     (Result a b).((a) => c) => Result c b
   */
  mapError: {
    /*~*/
    Error: function mapError(f) {
      assertFunction('Result.Error#mapError', f);
      return Error(f(this.value));
    },

    /*~*/
    Ok: function mapError(f) {
      assertFunction('Result.Ok#mapError', f);
      return this;
    }
  },

  /*~
   * stability: experimental
   * type: |
   *   forall a: (Maybe a).((a) => Boolean) => Maybe a
   */
  filter: {
    /*~*/
    Error: function filter(predicate) {
      assertFunction('Result.Error#filter', predicate);
      return this;
    },

    /*~*/
    Ok: function filter(predicate) {
      assertFunction('Result.Ok#filter', predicate);
      return predicate(this.value) ? this : Error();
    }
  }
});

Object.assign(Result, {
  /*~
   * stability: experimental
   * type: |
   *   forall a, b: (b) => Result a b
   */
  of: function of(value) {
    return Ok(value);
  },


  /*~
   * deprecated:
   *   since: 2.0.0
   *   replacedBy: .unsafeGet()
   * type: |
   *   forall a, b: (Result a b).() => b :: (throws TypeError)
   */
  'get': function get() {
    warnDeprecation('`.get()` is deprecated, and has been renamed to `.unsafeGet()`.');
    return this.unsafeGet();
  },


  /*~
   * stability: experimental
   * type: |
   *   forall a, b: (Result a b).() => a or b
   */
  merge: function merge() {
    return this.value;
  },


  /*~
   * stability: experimental
   * type: |
   *   forall a, b: (Result a b).() => Validation a b
   */
  toValidation: function toValidation() {
    return __webpack_require__(215)(this);
  },


  /*~
   * stability: experimental
   * type: |
   *   forall a, b: (Result a b).() => Maybe b
   */
  toMaybe: function toMaybe() {
    return __webpack_require__(103)(this);
  }
});

provideAliases(Error.prototype);
provideAliases(Ok.prototype);
provideAliases(Result);

module.exports = Result;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//----------------------------------------------------------------------
//
// This source file is part of the Folktale project.
//
// Licensed under MIT. See LICENCE for full licence information.
// See CONTRIBUTORS for the list of contributors to the project.
//
//----------------------------------------------------------------------

var keys = Object.keys;
var symbols = Object.getOwnPropertySymbols;
var defineProperty = Object.defineProperty;
var property = Object.getOwnPropertyDescriptor;

/*
 * Extends an objects with own enumerable key/value pairs from other sources.
 *
 * This is used to define objects for the ADTs througout this file, and there
 * are some important differences from Object.assign:
 *
 *   - This code is only concerned with own enumerable property *names*.
 *   - Additionally this code copies all own symbols (important for tags).
 *
 * When copying, this function copies **whole property descriptors**, which
 * means getters/setters are not executed during the copying. The only
 * exception is when the property name is `prototype`, which is not
 * configurable in functions by default.
 *
 * This code only special cases `prototype` because any other non-configurable
 * property is considered an error, and should crash the program so it can be
 * fixed.
 */
function extend(target) {
  for (var _len = arguments.length, sources = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    sources[_key - 1] = arguments[_key];
  }

  sources.forEach(function (source) {
    keys(source).forEach(function (key) {
      if (key === 'prototype') {
        target[key] = source[key];
      } else {
        defineProperty(target, key, property(source, key));
      }
    });
    symbols(source).forEach(function (symbol) {
      defineProperty(target, symbol, property(source, symbol));
    });
  });
  return target;
}

module.exports = extend;

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  READ_WRITE: 'READ_WRITE',
  READ: 'READ',
  WRITE: 'WRITE'
};

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var _require = __webpack_require__(2),
    getCurrentPageSize = _require.getCurrentPageSize,
    getPaginationData = _require.getPaginationData,
    selectCurrentRecordIndex = _require.selectCurrentRecordIndex,
    selectDefaultDraft = _require.selectDefaultDraft,
    isWriteOnly = _require.isWriteOnly,
    getNumberOfPagesToShow = _require.getNumberOfPagesToShow;

var actionTypes = __webpack_require__(42);
var queue = __webpack_require__(132);
var initAdapters = __webpack_require__(291);
var queryResults = __webpack_require__(26);

var setCurrentIndex = function setCurrentIndex(index) {
  var suppressRefreshView = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return {
    type: actionTypes.GO_TO_INDEX,
    index: index,
    suppressRefreshView: suppressRefreshView
  };
};

var refreshCurrentRecord = function refreshCurrentRecord() {
  return {
    type: actionTypes.REFRESH_CURRENT_RECORD
  };
};

var refreshCurrentView = function refreshCurrentView() {
  return {
    type: actionTypes.REFRESH_CURRENT_VIEW
  };
};

var setCurrentRecord = function setCurrentRecord(record, recordIndex) {
  return {
    type: actionTypes.SET_CURRENT_RECORD,
    record: record,
    recordIndex: recordIndex
  };
};

var updateFields = function updateFields(fieldsToUpdate, updateSource) {
  return {
    type: actionTypes.UPDATE_FIELDS,
    fieldsToUpdate: fieldsToUpdate,
    updateSource: updateSource
  };
};

var incrementNumOfPagesToShow = function incrementNumOfPagesToShow() {
  return {
    type: actionTypes.INCREMENT_NUM_PAGES_TO_SHOW
  };
};

var nextPage = function nextPage() {
  return {
    type: actionTypes.GO_TO_NEXT_PAGE
  };
};

var previousPage = function previousPage() {
  return {
    type: actionTypes.GO_TO_PREVIOUS_PAGE
  };
};

var loadPage = function loadPage(pageNumber) {
  return {
    type: actionTypes.LOAD_PAGE,
    pageNumber: pageNumber
  };
};

var revert = function revert() {
  return {
    type: actionTypes.REVERT_CHANGES
  };
};

var flushDraft = function flushDraft() {
  return {
    type: actionTypes.SAVE_RECORD
  };
};

var setDefaultRecord = function setDefaultRecord(record) {
  return {
    type: actionTypes.SET_DEFAULT_RECORD,
    record: record
  };
};

var newRecord = function newRecord(atIndex) {
  return {
    type: actionTypes.NEW_RECORD,
    atIndex: atIndex
  };
};

var remove = function remove() {
  return {
    type: actionTypes.REMOVE_CURRENT_RECORD
  };
};

var doFetch = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(recordStore, fromIndex, length, byRefField) {
    var fetchedItems;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return recordStore(byRefField).matchWith({
              Nothing: function Nothing() {
                return queryResults.Empty();
              },
              Just: function () {
                var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref2) {
                  var service = _ref2.value;
                  var queryResult;
                  return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return service.getRecords(fromIndex, length);

                        case 2:
                          queryResult = _context.sent;
                          return _context.abrupt('return', queryResult);

                        case 4:
                        case 'end':
                          return _context.stop();
                      }
                    }
                  }, _callee, undefined);
                }));

                function Just(_x6) {
                  return _ref3.apply(this, arguments);
                }

                return Just;
              }()
            });

          case 2:
            fetchedItems = _context2.sent;
            return _context2.abrupt('return', fetchedItems.get());

          case 4:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, undefined);
  }));

  return function doFetch(_x2, _x3, _x4, _x5) {
    return _ref.apply(this, arguments);
  };
}();

var fetchCurrentPage = function fetchCurrentPage(recordStore, state) {
  var pageSize = getCurrentPageSize(state) * getNumberOfPagesToShow(state);

  var _getPaginationData = getPaginationData(state),
      offset = _getPaginationData.offset;

  return doFetch(recordStore, offset, pageSize);
};

var updateComponentsBasedOnRecord = function updateComponentsBasedOnRecord(adapterApi) {
  return function (componentIdToExcludeFromUpdatingComponentsBasedOnRecord, updatedFields) {
    adapterApi().currentRecordModified(updatedFields, componentIdToExcludeFromUpdatingComponentsBasedOnRecord);
  };
};
exports.updateComponentsBasedOnRecord = updateComponentsBasedOnRecord;

exports.fetchInitialDataAndSetInitialCurrentRecord = function (hasPrefetchedData, errorReporter) {
  if (hasPrefetchedData) {
    return setInitialCurrentRecord;
  }

  return queue(fetchInitialDataAndSetInitialCurrentRecord(errorReporter));
};

var setInitialCurrentRecord = function setInitialCurrentRecord(dispatch, getState, _ref4) {
  var recordStore = _ref4.recordStore;
  return recordStore().matchWith({
    Nothing: function Nothing() {
      return Promise.resolve();
    },
    Just: function Just(_ref5) {
      var service = _ref5.value;
      return service.getSeedRecords().chain(function (_ref6) {
        var items = _ref6.items;
        return dispatch(setCurrentRecord(items[0], 0));
      });
    }
  });
};

var fetchInitialDataAndSetInitialCurrentRecord = function fetchInitialDataAndSetInitialCurrentRecord(errorReporter) {
  return function (dispatch, getState, _ref7) {
    var recordStore = _ref7.recordStore,
        fedopsLogger = _ref7.fedopsLogger;

    var _fedopsLogger$interac = fedopsLogger.interactionStarted('dataset/pageReady/getData'),
        timeoutId = _fedopsLogger$interac.timeoutId;

    return recordStore().matchWith({
      Nothing: function Nothing() {
        return Promise.resolve();
      },
      Just: function Just(_ref8) {
        var service = _ref8.value;
        return service.seed().then(function () {
          return service.getRecords(0, 1).then(function (queryResult) {
            return queryResult.chain(function (_ref9) {
              var items = _ref9.items;
              return dispatch(setCurrentRecord(items[0], 0));
            });
          }).then(function () {
            return fedopsLogger.interactionEnded('dataset/pageReady/getData', {
              timeoutId: timeoutId
            });
          });
        }).catch(function (e) {
          return errorReporter('Failed to load initial data', e);
        });
      }
    });
  };
};

exports.initWriteOnly = function (isScoped) {
  return queue(function () {
    var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(dispatch, getState, _ref10) {
      var _this = this;

      var recordStore = _ref10.recordStore;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return recordStore().matchWith({
                Nothing: function Nothing() {
                  throw new Error('Record store service not ready yet');
                },
                Just: function () {
                  var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(_ref12) {
                    var service = _ref12.value;
                    return regeneratorRuntime.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            if (!isScoped) {
                              service.newRecord(0, selectDefaultDraft(getState()));
                            }
                            _context3.next = 3;
                            return dispatch(setCurrentIndex(0));

                          case 3:
                          case 'end':
                            return _context3.stop();
                        }
                      }
                    }, _callee3, _this);
                  }));

                  function Just(_x10) {
                    return _ref13.apply(this, arguments);
                  }

                  return Just;
                }()
              });

            case 2:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    return function (_x7, _x8, _x9) {
      return _ref11.apply(this, arguments);
    };
  }());
};

exports.reInitWriteOnly = function () {
  return queue(function () {
    var _ref14 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(dispatch, getState) {
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              dispatch(newRecord(0));

            case 1:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, this);
    }));

    return function (_x11, _x12) {
      return _ref14.apply(this, arguments);
    };
  }());
};

var initAdaptersThunk = function initAdaptersThunk(dispatch, getState, _ref15) {
  var adapterApi = _ref15.adapterApi;

  return initAdapters(adapterApi);
};

exports.initAdapters = function (hasPrefetchedData) {
  return hasPrefetchedData ? initAdaptersThunk : queue(initAdaptersThunk);
};

exports.refresh = function () {
  return queue(function () {
    var _ref17 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(dispatch, getState, _ref16) {
      var _this2 = this;

      var adapterApi = _ref16.adapterApi,
          fireEvent = _ref16.eventListeners.fireEvent,
          recordStore = _ref16.recordStore;
      return regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return recordStore().chain(function () {
                var _ref18 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(service) {
                  return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                      switch (_context6.prev = _context6.next) {
                        case 0:
                          service.resetDraft(selectCurrentRecordIndex(getState()), selectDefaultDraft(getState()));
                          service.reset();

                          if (isWriteOnly(getState())) {
                            service.newRecord(0, selectDefaultDraft(getState()));
                          }
                          _context6.next = 5;
                          return dispatch(setCurrentIndex(0, true));

                        case 5:
                          _context6.next = 7;
                          return Promise.all(adapterApi().recordSetLoaded());

                        case 7:

                          fireEvent('currentIndexChanged', 0);

                        case 8:
                        case 'end':
                          return _context6.stop();
                      }
                    }
                  }, _callee6, _this2);
                }));

                return function (_x16) {
                  return _ref18.apply(this, arguments);
                };
              }());

            case 2:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, this);
    }));

    return function (_x13, _x14, _x15) {
      return _ref17.apply(this, arguments);
    };
  }());
};

exports.fetchCurrentPage = fetchCurrentPage;
exports.doFetch = doFetch;
exports.flushDraft = flushDraft;
exports.incrementNumOfPagesToShow = incrementNumOfPagesToShow;
exports.nextPage = nextPage;
exports.previousPage = previousPage;
exports.loadPage = loadPage;
exports.refreshCurrentRecord = refreshCurrentRecord;
exports.refreshCurrentView = refreshCurrentView;
exports.revert = revert;
exports.setCurrentIndex = setCurrentIndex;
exports.setCurrentRecord = setCurrentRecord;
exports.setDefaultRecord = setDefaultRecord;
exports.updateFields = updateFields;
exports.remove = remove;
exports.newRecord = newRecord;

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var union = __webpack_require__(8);

var deriveMethods = __webpack_require__(131);

var QueryResults = union('QueryResults', {
  Empty: function Empty() {
    return {};
  },
  Results: function Results(items, totalCount) {
    var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    return { items: items, totalCount: totalCount, offset: offset };
  }
});

deriveMethods(QueryResults, {
  chain: {
    Empty: function chain(fn) {
      return this;
    },
    Results: function chain(fn) {
      return fn({
        items: this.items,
        totalCount: this.totalCount,
        offset: this.offset
      });
    }
  },

  map: {
    Empty: function map(fn) {
      return this;
    },
    Results: function map(fn) {
      var _fn = fn({
        items: this.items,
        totalCount: this.totalCount,
        offset: this.offset
      }),
          items = _fn.items,
          totalCount = _fn.totalCount,
          offset = _fn.offset;

      return QueryResults.Results(items || this.items, totalCount || this.totalCount, offset || this.offset);
    }
  },

  filter: {
    Empty: function filter(fn) {
      return this;
    },
    Results: function filter(fn) {
      return fn({
        items: this.items,
        totalCount: this.totalCount,
        offset: this.offset
      }) ? this : QueryResults.Empty();
    }
  },

  orElse: {
    Empty: function orElse(fn) {
      return fn();
    },
    Results: function orElse(fn) {
      return this;
    }
  }
});

Object.assign(QueryResults, {
  of: function of(_ref) {
    var items = _ref.items,
        totalCount = _ref.totalCount,
        offset = _ref.offset;

    return totalCount > 0 && Array.isArray(items) ? QueryResults.Results(items, totalCount, offset) : QueryResults.Empty();
  },
  fromWixDataQueryResults: function fromWixDataQueryResults(wixDataQueryResults, offset) {
    return wixDataQueryResults ? this.of({
      items: wixDataQueryResults.items,
      totalCount: wixDataQueryResults.totalCount,
      offset: offset
    }) : QueryResults.Empty();
  },
  get: function get() {
    return this.matchWith({
      Empty: function Empty() {
        return { items: [], totalCount: 0, offset: 0 };
      },
      Results: function Results(results) {
        return results;
      }
    });
  }
});

module.exports = QueryResults;

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var uuid = __webpack_require__(331);
var omit_ = __webpack_require__(0).omit;

var _require = __webpack_require__(333),
    isPristine = _require.isPristine;

// getRecordId :: Record -> RecordId


var getRecordId = function getRecordId(record) {
  return record._id;
};

// hasDraft :: Record -> Bool
var hasDraft = function hasDraft(record) {
  return typeof record[isPristine] === 'boolean';
};

// isPristine :: Record -> Boolean
var isRecordPristine = function isRecordPristine(record) {
  return !hasDraft(record) || record[isPristine];
};

// setPristineState :: (Record, Boolean) -> Record
var markRecordDirty = function markRecordDirty(record) {
  return Object.assign({}, record, _defineProperty({}, isPristine, false));
};

// createDraft :: (Record, Record) -> Record
var createDraft = function createDraft(record, defaultDraft) {
  return Object.assign({}, defaultDraft, _defineProperty({
    _id: record._id || uuid.v4()
  }, isPristine, true));
};

// isSameRecord :: (Record, Record) -> Boolean
var isSameRecord = function isSameRecord(a, b) {
  return a && b && a._id === b._id;
};

var cleanseRecord = function cleanseRecord(record) {
  return record != null ? omit_(record, [isPristine]) : null;
};

module.exports.cleanseRecord = cleanseRecord;
module.exports.createDraft = createDraft;
module.exports.getRecordId = getRecordId;
module.exports.hasDraft = hasDraft;
module.exports.isRecordPristine = isRecordPristine;
module.exports.isSameRecord = isSameRecord;
module.exports.markRecordDirty = markRecordDirty;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(11),
    isObjectLike = __webpack_require__(5);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(167),
    baseKeys = __webpack_require__(169),
    isArrayLike = __webpack_require__(85);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(405),
    Map = __webpack_require__(87),
    Promise = __webpack_require__(406),
    Set = __webpack_require__(407),
    WeakMap = __webpack_require__(148),
    baseGetTag = __webpack_require__(11),
    toSource = __webpack_require__(150);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(28);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//----------------------------------------------------------------------
//
// This source file is part of the Folktale project.
//
// Licensed under MIT. See LICENCE for full licence information.
// See CONTRIBUTORS for the list of contributors to the project.
//
//----------------------------------------------------------------------

var _require = __webpack_require__(8),
    typeSymbol = _require.typeSymbol;

module.exports = function (type) {
  return function (method, value) {
    var typeName = type[typeSymbol];
    if (Object({"NODE_ENV":"production"}).FOLKTALE_ASSERTIONS !== 'none' && !type.isPrototypeOf(value)) {
      console.warn(typeName + '.' + method + ' expects a value of the same type, but was given ' + value + '.');

      if (Object({"NODE_ENV":"production"}).FOLKTALE_ASSERTIONS !== 'minimal') {
        console.warn('\nThis could mean that you\'ve provided the wrong value to the method, in\nwhich case this is a bug in your program, and you should try to track\ndown why the wrong value is getting here.\n\nBut this could also mean that you have more than one ' + typeName + ' library\ninstantiated in your program. This is not **necessarily** a bug, it\ncould happen for several reasons:\n\n 1) You\'re loading the library in Node, and Node\'s cache didn\'t give\n    you back the same instance you had previously requested.\n\n 2) You have more than one Code Realm in your program, and objects\n    created from the same library, in different realms, are interacting.\n\n 3) You have a version conflict of folktale libraries, and objects\n    created from different versions of the library are interacting.\n\nIf your situation fits the cases (1) or (2), you are okay, as long as\nthe objects originate from the same version of the library. Folktale\ndoes not rely on reference checking, only structural checking. However\nyou\'ll want to watch out if you\'re modifying the ' + typeName + '\'s prototype,\nbecause you\'ll have more than one of them, and you\'ll want to make\nsure you do the same change in all of them \u2014 ideally you shouldn\'t\nbe modifying the object, though.\n\nIf your situation fits the case (3), you are *probably* okay if the\nversion difference isn\'t a major one. However, at this point the\nbehaviour of your program using ' + typeName + ' is undefined, and you should\ntry looking into why the version conflict is happening.\n\nParametric modules can help ensuring your program only has a single\ninstance of the folktale library. Check out the Folktale Architecture\ndocumentation for more information.\n      ');
      }
    }
  };
};

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//----------------------------------------------------------------------
//
// This source file is part of the Folktale project.
//
// Licensed under MIT. See LICENCE for full licence information.
// See CONTRIBUTORS for the list of contributors to the project.
//
//----------------------------------------------------------------------


var aliases = {
  equals: {
    /*~
     * module: null
     * type: |
     *   ('S 'a).('S 'a) => Boolean
     *   where 'S is Setoid
     */
    'fantasy-land/equals': function fantasyLandEquals(that) {
      return this.equals(that);
    }
  },

  concat: {
    /*~
     * module: null
     * type: |
     *   ('S 'a).('S 'a) => 'S 'a
     *   where 'S is Semigroup
     */
    'fantasy-land/concat': function fantasyLandConcat(that) {
      return this.concat(that);
    }
  },

  empty: {
    /*~
     * module: null
     * type: |
     *   ('M).() => 'M a
     *   where 'M is Monoid
     */
    'fantasy-land/empty': function fantasyLandEmpty() {
      return this.empty();
    }
  },

  map: {
    /*~
     * module: null
     * type: |
     *   ('F 'a).(('a) => 'b) => 'F 'b
     *   where 'F is Functor
     */
    'fantasy-land/map': function fantasyLandMap(transformation) {
      return this.map(transformation);
    }
  },

  apply: {
    /*~
     * module: null
     * type: |
     *   ('F ('a) => b).('F 'a) => 'F 'b
     *   where 'F is Apply
     */
    ap: function ap(that) {
      return this.apply(that);
    },


    /*~
     * module: null
     * type: |
     *   ('F 'a).('F ('a) => 'b) => 'F 'b
     *   where 'F is Apply
     */
    'fantasy-land/ap': function fantasyLandAp(that) {
      return that.apply(this);
    }
  },

  of: {
    /*~
     * module: null
     * type: |
     *   forall F, a:
     *     (F).(a) => F a
     *   where F is Applicative 
     */
    'fantasy-land/of': function fantasyLandOf(value) {
      return this.of(value);
    }
  },

  reduce: {
    /*~
     * module: null
     * type: |
     *   forall F, a, b:
     *     (F a).((b, a) => b, b) => b
     *   where F is Foldable  
     */
    'fantasy-land/reduce': function fantasyLandReduce(combinator, initial) {
      return this.reduce(combinator, initial);
    }
  },

  traverse: {
    /*~
     * module: null
     * type: |
     *   forall F, T, a, b:
     *     (T a).((a) => F b, (c) => F c) => F (T b)
     *   where F is Apply, T is Traversable
     */
    'fantasy-land/traverse': function fantasyLandTraverse(transformation, lift) {
      return this.traverse(transformation, lift);
    }
  },

  chain: {
    /*~
     * module: null
     * type: |
     *   forall M, a, b:
     *     (M a).((a) => M b) => M b
     *   where M is Chain
     */
    'fantasy-land/chain': function fantasyLandChain(transformation) {
      return this.chain(transformation);
    }
  },

  chainRecursively: {
    /*~
     * module: null
     * type: |
     *   forall M, a, b, c:
     *     (M).(
     *       Step:    ((a) => c, (b) => c, a) => M c,
     *       Initial: a
     *     ) => M b
     *   where M is ChainRec 
     */
    chainRec: function chainRec(step, initial) {
      return this.chainRecursively(step, initial);
    },


    /*~
     * module: null
     * type: |
     *   forall M, a, b, c:
     *     (M).(
     *       Step:    ((a) => c, (b) => c, a) => M c,
     *       Initial: a
     *     ) => M b
     *   where M is ChainRec 
     */
    'fantasy-land/chainRec': function fantasyLandChainRec(step, initial) {
      return this.chainRecursively(step, initial);
    }
  },

  extend: {
    /*~
     * module: null
     * type: |
     *   forall W, a, b:
     *     (W a).((W a) => b) => W b
     *   where W is Extend
     */
    'fantasy-land/extend': function fantasyLandExtend(transformation) {
      return this.extend(transformation);
    }
  },

  extract: {
    /*~
     * module: null
     * type: |
     *   forall W, a, b:
     *     (W a).() => a
     *   where W is Comonad
     */
    'fantasy-land/extract': function fantasyLandExtract() {
      return this.extract();
    }
  },

  bimap: {
    /*~
     * module: null
     * type: |
     *   forall F, a, b, c, d:
     *     (F a b).((a) => c, (b) => d) => F c d
     *   where F is Bifunctor
     */
    'fantasy-land/bimap': function fantasyLandBimap(f, g) {
      return this.bimap(f, g);
    }
  },

  promap: {
    /*~
     * module: null
     * type: |
     *   forall P, a, b, c, d:
     *     (P a b).((c) => a, (b) => d) => P c d
     */
    'fantasy-land/promap': function fantasyLandPromap(f, g) {
      return this.promap(f, g);
    }
  }
};

var provideAliases = function provideAliases(structure) {
  Object.keys(aliases).forEach(function (method) {
    if (typeof structure[method] === 'function') {
      Object.keys(aliases[method]).forEach(function (alias) {
        structure[alias] = aliases[method][alias];
      });
    }
  });
};

module.exports = provideAliases;

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//----------------------------------------------------------------------
//
// This source file is part of the Folktale project.
//
// Licensed under MIT. See LICENCE for full licence information.
// See CONTRIBUTORS for the list of contributors to the project.
//
//----------------------------------------------------------------------

var assertType = __webpack_require__(32);
var assertFunction = __webpack_require__(58);

var _require = __webpack_require__(59),
    union = _require.union,
    derivations = _require.derivations;

var provideAliases = __webpack_require__(33);
var warnDeprecation = __webpack_require__(19);
var adtMethods = __webpack_require__(60);
var extend = __webpack_require__(23);

var equality = derivations.equality,
    debugRepresentation = derivations.debugRepresentation,
    serialization = derivations.serialization;

/*~ stability: stable */

var Maybe = union('folktale:Maybe', {
  /*~
   * type: |
   *   forall a: () => Maybe a
   */
  Nothing: function Nothing() {},


  /*~
   * type: |
   *   forall a: (a) => Maybe a
   */
  Just: function Just(value) {
    return { value: value };
  }
}).derive(equality, debugRepresentation, serialization);

var Nothing = Maybe.Nothing,
    _Just = Maybe.Just;

var assertMaybe = assertType(Maybe);

extend(_Just.prototype, {
  /*~
   * isRequired: true
   * type: |
   *   forall a: get (Maybe a) => a
   */
  get value() {
    throw new TypeError('`value` can’t be accessed in an abstract instance of Maybe.Just');
  }
});

/*~~belongsTo: Maybe */
adtMethods(Maybe, {
  /*~
   * stability: stable
   * type: |
   *   forall a, b: (Maybe a).((a) => b) => Maybe b
   */
  map: {
    /*~*/
    Nothing: function map(transformation) {
      assertFunction('Maybe.Nothing#map', transformation);
      return this;
    },

    /*~*/
    Just: function map(transformation) {
      assertFunction('Maybe.Just#map', transformation);
      return _Just(transformation(this.value));
    }
  },

  /*~
   * stability: stable
   * type: |
   *   forall a, b: (Maybe (a) => b).(Maybe a) => Maybe b
   */
  apply: {
    /*~*/
    Nothing: function apply(aMaybe) {
      assertMaybe('Maybe.Nothing#apply', aMaybe);
      return this;
    },

    /*~*/
    Just: function apply(aMaybe) {
      assertMaybe('Maybe.Just#apply', aMaybe);
      return aMaybe.map(this.value);
    }
  },

  /*~
   * stability: stable
   * type: |
   *   forall a, b: (Maybe a).((a) => Maybe b) => Maybe b
   */
  chain: {
    /*~*/
    Nothing: function chain(transformation) {
      assertFunction('Maybe.Nothing#chain', transformation);
      return this;
    },

    /*~*/
    Just: function chain(transformation) {
      assertFunction('Maybe.Just#chain', transformation);
      return transformation(this.value);
    }
  },

  /*~
   * type: |
   *   forall a: (Maybe a).() => a :: (throws TypeError)
   */
  unsafeGet: {
    /*~*/
    Nothing: function unsafeGet() {
      throw new TypeError('Can\'t extract the value of a Nothing.\n\n    Since Nothing holds no values, it\'s not possible to extract one from them.\n    You might consider switching from Maybe#get to Maybe#getOrElse, or some other method\n    that is not partial.\n      ');
    },

    /*~*/
    Just: function unsafeGet() {
      return this.value;
    }
  },

  /*~
   * type: |
   *   forall a: (Maybe a).(a) => a
   */
  getOrElse: {
    /*~*/
    Nothing: function getOrElse(_default) {
      return _default;
    },

    /*~*/
    Just: function getOrElse(_default) {
      return this.value;
    }
  },

  /*~
   * type: |
   *   forall a: (Maybe a).((a) => Maybe a) => Maybe a
   */
  orElse: {
    /*~*/
    Nothing: function orElse(handler) {
      assertFunction('Maybe.Nothing#orElse', handler);
      return handler(this.value);
    },

    /*~*/
    Just: function orElse(handler) {
      assertFunction('Maybe.Nothing#orElse', handler);
      return this;
    }
  },

  /*~
   * authors:
   *   - "@diasbruno"
   * type: |
   *   forall a: (Maybe a).(Maybe a) => Maybe a
   *   where a is Semigroup
   */
  concat: {
    /*~*/
    Nothing: function concat(aMaybe) {
      assertMaybe('Maybe.Nothing#concat', aMaybe);
      return aMaybe;
    },

    /*~*/
    Just: function concat(aMaybe) {
      var _this = this;

      assertMaybe('Maybe.Just#concat', aMaybe);
      return aMaybe.matchWith({
        Nothing: function Nothing() {
          return _Just(_this.value);
        },
        Just: function Just(a) {
          return _Just(_this.value.concat(a.value));
        }
      });
    }
  },

  /*~
   * deprecated:
   *   since: 2.0.0
   *   replacedBy: .matchWith(pattern)
   * 
   * type: |
   *   forall a, b:
   *     (Maybe a).({
   *       Nothing: () => b,
   *       Just: (a) => b
   *     }) => b
   */
  cata: {
    /*~*/
    Nothing: function cata(pattern) {
      warnDeprecation('`.cata(pattern)` is deprecated. Use `.matchWith(pattern)` instead.');
      return pattern.Nothing();
    },

    /*~*/
    Just: function cata(pattern) {
      warnDeprecation('`.cata(pattern)` is deprecated. Use `.matchWith(pattern)` instead.');
      return pattern.Just(this.value);
    }
  },

  /*~
   * type: |
   *   forall a, b: (Maybe a).(() => b, (a) => b) => b
   */
  fold: {
    /*~*/
    Nothing: function Nothing(transformNothing, transformJust) {
      assertFunction('Maybe.Nothing#fold', transformNothing);
      assertFunction('Maybe.Nothing#fold', transformJust);
      return transformNothing();
    },

    /*~*/
    Just: function Just(transformNothing, transformJust) {
      assertFunction('Maybe.Just#fold', transformNothing);
      assertFunction('Maybe.Just#fold', transformJust);
      return transformJust(this.value);
    }
  },

  /*~
   * stability: experimental
   * type: |
   *   forall a: (Maybe a).((a) => Boolean) => Maybe a
   */
  filter: {
    /*~*/
    Nothing: function filter(predicate) {
      assertFunction('Maybe.Nothing#filter', predicate);
      return this;
    },

    /*~*/
    Just: function filter(predicate) {
      assertFunction('Maybe.Just#filter', predicate);
      return predicate(this.value) ? this : Nothing();
    }
  }
});

Object.assign(Maybe, {
  /*~
   * stability: stable
   * type: |
   *   forall a: (a) => Maybe a
   */
  of: function of(value) {
    return _Just(value);
  },


  /*~
   * authors:
   *   - "@diasbruno"
   * type: |
   *   forall a: () => Maybe a
   */
  empty: function empty() {
    return Nothing();
  },


  /*~
   * deprecated:
   *   since: 2.0.0
   *   replacedBy: .unsafeGet()
   * type: |
   *   forall a: (Maybe a).() => a :: (throws TypeError)
   */
  'get': function get() {
    warnDeprecation('`.get()` is deprecated, and has been renamed to `.unsafeGet()`.');
    return this.unsafeGet();
  },


  /*~
   * stability: experimental
   * type: |
   *   forall a, b: (Maybe a).(b) => Result b a
   */
  toResult: function toResult(fallbackValue) {
    return __webpack_require__(102)(this, fallbackValue);
  },


  /*~
   * stability: experimental
   * type: |
   *   forall a, b: (Maybe a).(b) => Result b a
   */
  toValidation: function toValidation(fallbackValue) {
    return __webpack_require__(216)(this, fallbackValue);
  }
});

provideAliases(_Just.prototype);
provideAliases(Nothing.prototype);
provideAliases(Maybe);

module.exports = Maybe;

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getStackTrace = function getStackTrace() {
  var dummyError = new Error();
  return dummyError.stack ? dummyError.stack.toString() : '';
};

module.exports.getAppUrl = function (appName) {
  var urlMatches = getStackTrace().match(new RegExp('https?://.*?' + appName + '.*?.js'));
  return urlMatches ? urlMatches[0] : '';
};

module.exports.isLocalhost = function () {
  return (/https?:\/\/localhost/.test(getStackTrace())
  );
};

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setHost = setHost;
exports.getHost = getHost;
exports.isWebWorker = isWebWorker;
exports.provideBrowsingContext = provideBrowsingContext;
var host = 'frog.wix.com';

function setHost(_host) {
  host = _host;
}

function getHost() {
  return host;
}

function isWebWorker() {
  /* global WorkerGlobalScope */

  //At the moment, this is the most reliable way of detecting if current code is run in a worker
  //Taken from here: https://stackoverflow.com/a/18002694
  return typeof WorkerGlobalScope !== 'undefined' && self instanceof WorkerGlobalScope;
}

/**
 * Provides a window object to the callback iff current window is the topmost one
 * Otherwise returns null
 */
function provideBrowsingContext(cb) {
  if (typeof window !== 'undefined' && window) {
    try {
      return window.top === window.self ? cb ? cb(window) : window : null;
    } catch (e) {
      return null;
    }
  }

  return null;
}

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = clone;

var _sharedTypeUtils = __webpack_require__(14);

function clone(obj) {
  if (obj == null || typeof obj !== 'object') {
    return obj;
  }

  var temp = null;

  if ((0, _sharedTypeUtils.isDate)(obj)) {
    temp = new Date(obj.getTime());
  } else {
    temp = obj.constructor();
    for (var key in obj) {
      temp[key] = clone(obj[key]);
    }
  }

  return temp;
}

module.exports = exports['default'];

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var Ref = (function () {
  function Ref(object) {
    _classCallCheck(this, Ref);

    this.__ctorName = 'Ref';
    this._id = null;
    this._item = null;

    if (typeof object === 'string') {
      this._id = object;
    } else if (object != null && typeof object === 'object' && object.hasOwnProperty('_id')) {
      this._id = object._id;
      this._item = object;
    }
  }

  _createClass(Ref, [{
    key: 'get',
    value: function get() {
      return this._item;
    }
  }, {
    key: 'toJSON',
    value: function toJSON() {
      if (this._item) {
        return {
          ref: this._id,
          item: this._item
        };
      } else {
        return {
          ref: this._id
        };
      }
    }
  }, {
    key: 'id',
    get: function get() {
      return this._id;
    }
  }], [{
    key: 'fromJSON',
    value: function fromJSON(obj) {
      var ref = new Ref(obj.ref);
      ref._item = obj.item || null;
      return ref;
    }
  }]);

  return Ref;
})();

exports.Ref = Ref;

/***/ }),
/* 39 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var _clone = __webpack_require__(37);

var _clone2 = _interopRequireDefault(_clone);

var _errors = __webpack_require__(9);

var BaseValidator = (function () {
  function BaseValidator() {
    _classCallCheck(this, BaseValidator);

    this._validations = [];
  }

  _createClass(BaseValidator, [{
    key: 'arityIsOne',
    value: function arityIsOne(args) {
      var _this = this;

      return this.addValidation(function () {
        return args.length === 1;
      }, function () {
        return _errors.messages.arityValidations.arityIsOne(_this.operatorName);
      });
    }
  }, {
    key: 'arityIsTwo',
    value: function arityIsTwo(args) {
      var _this2 = this;

      return this.addValidation(function () {
        return args.length === 2;
      }, function () {
        return _errors.messages.arityValidations.arityIsTwo(_this2.operatorName);
      });
    }
  }, {
    key: 'arityIsThree',
    value: function arityIsThree(args) {
      var _this3 = this;

      return this.addValidation(function () {
        return args.length === 3;
      }, function () {
        return _errors.messages.arityValidations.arityIsThree(_this3.operatorName);
      });
    }
  }, {
    key: 'arityIsAtLeastTwo',
    value: function arityIsAtLeastTwo(args) {
      var _this4 = this;

      return this.addValidation(function () {
        return args.length >= 2;
      }, function () {
        return _errors.messages.arityValidations.arityIsAtLeastTwo(_this4.operatorName);
      });
    }
  }, {
    key: 'arityIsAtLeastOne',
    value: function arityIsAtLeastOne(args) {
      var _this5 = this;

      return this.addValidation(function () {
        return args.length >= 1;
      }, function () {
        return _errors.messages.arityValidations.arityIsAtLeastOne(_this5.operatorName);
      });
    }
  }, {
    key: 'addValidation',
    value: function addValidation(predicateFn, messageFn) {
      this._validations.push({
        predicateFn: predicateFn,
        messageFn: messageFn
      });
      return this;
    }
  }]);

  return BaseValidator;
})();

var AggregatingValidator = (function (_BaseValidator) {
  _inherits(AggregatingValidator, _BaseValidator);

  function AggregatingValidator(previousInvalidArguments) {
    _classCallCheck(this, AggregatingValidator);

    _get(Object.getPrototypeOf(AggregatingValidator.prototype), 'constructor', this).call(this);
    this._invalidArguments = (0, _clone2['default'])(previousInvalidArguments);
  }

  _createClass(AggregatingValidator, [{
    key: 'validateAndAggregate',
    value: function validateAndAggregate() {
      var _this6 = this;

      var valid = this._validations.every(function (_ref) {
        var predicateFn = _ref.predicateFn;
        var messageFn = _ref.messageFn;
        return _this6._appendIfInvalid(predicateFn(), messageFn());
      });
      return [this._invalidArguments, valid];
    }
  }, {
    key: '_appendIfInvalid',
    value: function _appendIfInvalid(valid, message) {
      if (!valid) {
        this._invalidArguments.push(message);
        return false;
      }
      return true;
    }
  }]);

  return AggregatingValidator;
})(BaseValidator);

exports.AggregatingValidator = AggregatingValidator;

var RejectingValidator = (function (_BaseValidator2) {
  _inherits(RejectingValidator, _BaseValidator2);

  function RejectingValidator() {
    _classCallCheck(this, RejectingValidator);

    _get(Object.getPrototypeOf(RejectingValidator.prototype), 'constructor', this).apply(this, arguments);
  }

  _createClass(RejectingValidator, [{
    key: 'validateAndReject',
    value: function validateAndReject() {
      var _this7 = this;

      return Promise.resolve().then(function () {
        _this7._validations.forEach(function (_ref2) {
          var predicateFn = _ref2.predicateFn;
          var messageFn = _ref2.messageFn;

          if (!predicateFn()) {
            throw (0, _errors.validationError)(messageFn());
          }
        });
      });
    }
  }]);

  return RejectingValidator;
})(BaseValidator);

exports.RejectingValidator = RejectingValidator;

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  DATASET: 'dataset',
  ROUTER_DATASET: 'router_dataset'
};

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  SET_CURRENT_RECORD: 'SET_CURRENT_RECORD',
  UPDATE_FIELDS: 'UPDATE_FIELDS',
  CLEAR_CURRENT_RECORD: 'CLEAR_CURRENT_RECORD',
  REFRESH_CURRENT_RECORD: 'REFRESH_CURRENT_RECORD',
  REFRESH_CURRENT_VIEW: 'REFRESH_CURRENT_VIEW',
  RESET_REFRESH_CURRENT_VIEW: 'RESET_REFRESH_CURRENT_VIEW',
  INCREMENT_NUM_PAGES_TO_SHOW: 'INCREMENT_NUM_PAGES_TO_SHOW',
  SET_DEFAULT_RECORD: 'SET_DEFAULT_RECORD',
  GO_TO_INDEX: 'GO_TO_INDEX',
  GO_TO_NEXT_PAGE: 'GO_TO_NEXT_PAGE',
  GO_TO_PREVIOUS_PAGE: 'GO_TO_PREVIOUS_PAGE',
  LOAD_PAGE: 'LOAD_PAGE',
  GET_RECORD_BY_INDEX_RESULT: 'GET_RECORD_BY_INDEX_RESULT',
  CURRENT_VIEW_UPDATED: 'CURRENT_VIEW_UPDATED',
  REVERT_CHANGES: 'REVERT_CHANGES',
  RECORD_REVERTED: 'RECORD_REVERTED',
  SAVE_RECORD: 'SAVE_RECORD',
  CALL_BEFORE_SAVE_HOOKS_RESULT: 'CALL_BEFORE_SAVE_HOOKS_RESULT',
  CHECK_HAS_DRAFT_RESULT: 'CHECK_HAS_DRAFT_RESULT',
  ASSERT_VALIDITY_RESULT: 'ASSERT_VALIDITY_RESULT',
  SAVE_RECORD_RESULT: 'SAVE_RECORD_RESULT',
  REMOVE_CURRENT_RECORD: 'REMOVE_CURRENT_RECORD',
  REMOVE_CURRENT_RECORD_RESULT: 'REMOVE_CURRENT_RECORD_RESULT',
  NEW_RECORD: 'NEW_RECORD',
  NEW_RECORD_RESULT: 'NEW_RECORD_RESULT'
};

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var actionTypes = {
  SET_CONTROLLER_CONFIG: 'SET_CONTROLLER_CONFIG',
  SET_PAGINATION_DATA: 'SET_PAGINATION_DATA'
};

var setConfig = function setConfig(config) {
  return {
    type: actionTypes.SET_CONTROLLER_CONFIG,
    config: config
  };
};

var setPaginationData = function setPaginationData(paginationData) {
  return {
    type: actionTypes.SET_PAGINATION_DATA,
    paginationData: paginationData
  };
};

module.exports.actionTypes = actionTypes;

module.exports.setConfig = setConfig;
module.exports.setPaginationData = setPaginationData;

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  GRID: 'gridRole',
  DROPDOWN_OPTIONS: 'dropdownOptionsRole',
  GALLERY: 'galleryRole',
  UPLOAD_BUTTON: 'uploadButtonRole',
  DETAILS_DATASET: 'detailsDatasetRole',
  REPEATER: 'repeaterRole',
  PAGINATION: 'paginationRole',
  DETAILS_REPEATER: 'detailsRepeaterRole',
  PAGE: 'pageRole'
};

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var get_ = __webpack_require__(0).get;
var isObject_ = __webpack_require__(0).isObject;
var maybe = __webpack_require__(1);

var _require = __webpack_require__(66),
    isFieldFromReferencedCollection = _require.isFieldFromReferencedCollection,
    getReferenceFieldName = _require.getReferenceFieldName,
    getFieldFromReferencedCollectionName = _require.getFieldFromReferencedCollectionName;

var getFieldValue = function getFieldValue(fieldName) {
  return function (record) {
    return get_(record, fieldName);
  };
};

var getReference = function getReference(fieldPath) {
  return function (record) {
    return maybe.fromNullable(get_(record, getReferenceFieldName(fieldPath)));
  };
};

var getFieldFromReference = function getFieldFromReference(fieldPath) {
  return function (reference) {
    return maybe.fromNullable(reference).chain(function (reference) {
      return isObject_(reference) ? maybe.Just(reference) : maybe.Nothing();
    }).map(function (referencedRecord) {
      return getFieldValue(getFieldFromReferencedCollectionName(fieldPath))(referencedRecord);
    }).getOrElse(undefined);
  };
};

module.exports = function (record, fieldPath) {
  return isFieldFromReferencedCollection(fieldPath) ? getReference(fieldPath)(record).map(getFieldFromReference(fieldPath)).getOrElse(undefined) : getFieldValue(fieldPath)(record);
};

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(47),
    isObject = __webpack_require__(12);

/**
 * Creates a function that produces an instance of `Ctor` regardless of
 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
 *
 * @private
 * @param {Function} Ctor The constructor to wrap.
 * @returns {Function} Returns the new wrapped function.
 */
function createCtor(Ctor) {
  return function() {
    // Use a `switch` statement to work with class constructors. See
    // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
    // for more details.
    var args = arguments;
    switch (args.length) {
      case 0: return new Ctor;
      case 1: return new Ctor(args[0]);
      case 2: return new Ctor(args[0], args[1]);
      case 3: return new Ctor(args[0], args[1], args[2]);
      case 4: return new Ctor(args[0], args[1], args[2], args[3]);
      case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
      case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
      case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
    }
    var thisBinding = baseCreate(Ctor.prototype),
        result = Ctor.apply(thisBinding, args);

    // Mimic the constructor's `return` behavior.
    // See https://es5.github.io/#x13.2.2 for more details.
    return isObject(result) ? result : thisBinding;
  };
}

module.exports = createCtor;


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(12);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),
/* 48 */
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(165),
    baseAssignValue = __webpack_require__(166);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(375),
    listCacheDelete = __webpack_require__(376),
    listCacheGet = __webpack_require__(377),
    listCacheHas = __webpack_require__(378),
    listCacheSet = __webpack_require__(379);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(78);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(16);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(393);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// assign :: a -> Object -> Object

var assign = function assign(props) {
  return function (object) {
    return Object.assign({}, object, props);
  };
};

// bind :: (a -> b) -> (b -> a -> c) -> a -> c
var bind = function bind(f, g) {
  return function (o) {
    return g(f(o))(o);
  };
};

var registrar = function registrar(list) {
  return function (fn) {
    list.push(fn);
    return function () {
      var index = list.indexOf(fn);
      if (index >= 0) {
        list.splice(index, 1);
      }
    };
  };
};

module.exports.assign = assign;
module.exports.bind = bind;
module.exports.registrar = registrar;

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _env = __webpack_require__(6);

function isRunningInChrome() {
  var userAgentHasChrome = (0, _env.env)() && (0, _env.env)().navigator && (0, _env.env)().navigator.userAgent && (0, _env.env)().navigator.userAgent.match(/Chrome\/([0-9]+)(\.[0-9]+)+/) !== null;
  var userAgentHasChromium = (0, _env.env)() && (0, _env.env)().navigator && (0, _env.env)().navigator.userAgent && (0, _env.env)().navigator.userAgent.match(/Chromium\/([0-9]+)(\.[0-9]+)+/) !== null;

  return userAgentHasChrome && !userAgentHasChromium;
}

/**
 * env().performance wrappers
 */
exports.default = {
  getNavigation: function getNavigation() {
    return typeof (0, _env.env)() !== 'undefined' && (0, _env.env)().performance ? (0, _env.env)().performance.navigation : {};
  },


  /**
   * get all loaded resources
   */
  getResources: function getResources() {
    var emptyVal = [];
    try {
      return (0, _env.env)() && (0, _env.env)().performance && (0, _env.env)().performance.getEntriesByType && (0, _env.env)().performance.getEntriesByType('resource') || emptyVal;
    } catch (e) {
      return emptyVal;
    }
  },
  getTiming: function getTiming() {
    return (0, _env.env)() && (0, _env.env)().performance ? (0, _env.env)().performance.timing : {};
  },


  /**
   * Duration relative to navigation start (env().performance.timing.navigationStart)
   * fallback to: performance.now -> now (nodejs) -> getTime()
   */
  now: function now() {
    if ((0, _env.env)() && (0, _env.env)().performance && (0, _env.env)().performance.now) {
      return (0, _env.env)().performance.now();
    } else if (typeof performance !== 'undefined' && performance && performance.now) {
      return performance.now();
    }

    return new Date().getTime();
  },


  /**
   * Create a performance timestamp
   */
  mark: function mark(name) {
    if (isRunningInChrome()) {
      (0, _env.env)() && (0, _env.env)().performance && (0, _env.env)().performance.mark && (0, _env.env)().performance.mark(name);
    }
  },


  /**
   * Record a performance measurement
   */
  measure: function measure(name, startMark, endMark) {
    if (isRunningInChrome()) {
      (0, _env.env)() && (0, _env.env)().performance && (0, _env.env)().performance.measure && (0, _env.env)().performance.measure(name, startMark, endMark);
    }
  }
};

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var stringify = __webpack_require__(96);

var _window =
  typeof window !== 'undefined'
    ? window
    : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function isObject(what) {
  return typeof what === 'object' && what !== null;
}

// Yanked from https://git.io/vS8DV re-used under CC0
// with some tiny modifications
function isError(value) {
  switch ({}.toString.call(value)) {
    case '[object Error]':
      return true;
    case '[object Exception]':
      return true;
    case '[object DOMException]':
      return true;
    default:
      return value instanceof Error;
  }
}

function isErrorEvent(value) {
  return supportsErrorEvent() && {}.toString.call(value) === '[object ErrorEvent]';
}

function isUndefined(what) {
  return what === void 0;
}

function isFunction(what) {
  return typeof what === 'function';
}

function isPlainObject(what) {
  return Object.prototype.toString.call(what) === '[object Object]';
}

function isString(what) {
  return Object.prototype.toString.call(what) === '[object String]';
}

function isArray(what) {
  return Object.prototype.toString.call(what) === '[object Array]';
}

function isEmptyObject(what) {
  if (!isPlainObject(what)) return false;

  for (var _ in what) {
    if (what.hasOwnProperty(_)) {
      return false;
    }
  }
  return true;
}

function supportsErrorEvent() {
  try {
    new ErrorEvent(''); // eslint-disable-line no-new
    return true;
  } catch (e) {
    return false;
  }
}

function supportsFetch() {
  if (!('fetch' in _window)) return false;

  try {
    new Headers(); // eslint-disable-line no-new
    new Request(''); // eslint-disable-line no-new
    new Response(); // eslint-disable-line no-new
    return true;
  } catch (e) {
    return false;
  }
}

// Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default
// https://caniuse.com/#feat=referrer-policy
// It doesn't. And it throw exception instead of ignoring this parameter...
// REF: https://github.com/getsentry/raven-js/issues/1233
function supportsReferrerPolicy() {
  if (!supportsFetch()) return false;

  try {
    // eslint-disable-next-line no-new
    new Request('pickleRick', {
      referrerPolicy: 'origin'
    });
    return true;
  } catch (e) {
    return false;
  }
}

function supportsPromiseRejectionEvent() {
  return typeof PromiseRejectionEvent === 'function';
}

function wrappedCallback(callback) {
  function dataCallback(data, original) {
    var normalizedData = callback(data) || data;
    if (original) {
      return original(normalizedData) || normalizedData;
    }
    return normalizedData;
  }

  return dataCallback;
}

function each(obj, callback) {
  var i, j;

  if (isUndefined(obj.length)) {
    for (i in obj) {
      if (hasKey(obj, i)) {
        callback.call(null, i, obj[i]);
      }
    }
  } else {
    j = obj.length;
    if (j) {
      for (i = 0; i < j; i++) {
        callback.call(null, i, obj[i]);
      }
    }
  }
}

function objectMerge(obj1, obj2) {
  if (!obj2) {
    return obj1;
  }
  each(obj2, function(key, value) {
    obj1[key] = value;
  });
  return obj1;
}

/**
 * This function is only used for react-native.
 * react-native freezes object that have already been sent over the
 * js bridge. We need this function in order to check if the object is frozen.
 * So it's ok that objectFrozen returns false if Object.isFrozen is not
 * supported because it's not relevant for other "platforms". See related issue:
 * https://github.com/getsentry/react-native-sentry/issues/57
 */
function objectFrozen(obj) {
  if (!Object.isFrozen) {
    return false;
  }
  return Object.isFrozen(obj);
}

function truncate(str, max) {
  if (typeof max !== 'number') {
    throw new Error('2nd argument to `truncate` function should be a number');
  }
  if (typeof str !== 'string' || max === 0) {
    return str;
  }
  return str.length <= max ? str : str.substr(0, max) + '\u2026';
}

/**
 * hasKey, a better form of hasOwnProperty
 * Example: hasKey(MainHostObject, property) === true/false
 *
 * @param {Object} host object to check property
 * @param {string} key to check
 */
function hasKey(object, key) {
  return Object.prototype.hasOwnProperty.call(object, key);
}

function joinRegExp(patterns) {
  // Combine an array of regular expressions and strings into one large regexp
  // Be mad.
  var sources = [],
    i = 0,
    len = patterns.length,
    pattern;

  for (; i < len; i++) {
    pattern = patterns[i];
    if (isString(pattern)) {
      // If it's a string, we need to escape it
      // Taken from: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions
      sources.push(pattern.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, '\\$1'));
    } else if (pattern && pattern.source) {
      // If it's a regexp already, we want to extract the source
      sources.push(pattern.source);
    }
    // Intentionally skip other cases
  }
  return new RegExp(sources.join('|'), 'i');
}

function urlencode(o) {
  var pairs = [];
  each(o, function(key, value) {
    pairs.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
  });
  return pairs.join('&');
}

// borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
// intentionally using regex and not <a/> href parsing trick because React Native and other
// environments where DOM might not be available
function parseUrl(url) {
  if (typeof url !== 'string') return {};
  var match = url.match(/^(([^:\/?#]+):)?(\/\/([^\/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);

  // coerce to undefined values to empty string so we don't get 'undefined'
  var query = match[6] || '';
  var fragment = match[8] || '';
  return {
    protocol: match[2],
    host: match[4],
    path: match[5],
    relative: match[5] + query + fragment // everything minus origin
  };
}
function uuid4() {
  var crypto = _window.crypto || _window.msCrypto;

  if (!isUndefined(crypto) && crypto.getRandomValues) {
    // Use window.crypto API if available
    // eslint-disable-next-line no-undef
    var arr = new Uint16Array(8);
    crypto.getRandomValues(arr);

    // set 4 in byte 7
    arr[3] = (arr[3] & 0xfff) | 0x4000;
    // set 2 most significant bits of byte 9 to '10'
    arr[4] = (arr[4] & 0x3fff) | 0x8000;

    var pad = function(num) {
      var v = num.toString(16);
      while (v.length < 4) {
        v = '0' + v;
      }
      return v;
    };

    return (
      pad(arr[0]) +
      pad(arr[1]) +
      pad(arr[2]) +
      pad(arr[3]) +
      pad(arr[4]) +
      pad(arr[5]) +
      pad(arr[6]) +
      pad(arr[7])
    );
  } else {
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = (Math.random() * 16) | 0,
        v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }
}

/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @param elem
 * @returns {string}
 */
function htmlTreeAsString(elem) {
  /* eslint no-extra-parens:0*/
  var MAX_TRAVERSE_HEIGHT = 5,
    MAX_OUTPUT_LEN = 80,
    out = [],
    height = 0,
    len = 0,
    separator = ' > ',
    sepLength = separator.length,
    nextStr;

  while (elem && height++ < MAX_TRAVERSE_HEIGHT) {
    nextStr = htmlElementAsString(elem);
    // bail out if
    // - nextStr is the 'html' element
    // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
    //   (ignore this limit if we are on the first iteration)
    if (
      nextStr === 'html' ||
      (height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN)
    ) {
      break;
    }

    out.push(nextStr);

    len += nextStr.length;
    elem = elem.parentNode;
  }

  return out.reverse().join(separator);
}

/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @param HTMLElement
 * @returns {string}
 */
function htmlElementAsString(elem) {
  var out = [],
    className,
    classes,
    key,
    attr,
    i;

  if (!elem || !elem.tagName) {
    return '';
  }

  out.push(elem.tagName.toLowerCase());
  if (elem.id) {
    out.push('#' + elem.id);
  }

  className = elem.className;
  if (className && isString(className)) {
    classes = className.split(/\s+/);
    for (i = 0; i < classes.length; i++) {
      out.push('.' + classes[i]);
    }
  }
  var attrWhitelist = ['type', 'name', 'title', 'alt'];
  for (i = 0; i < attrWhitelist.length; i++) {
    key = attrWhitelist[i];
    attr = elem.getAttribute(key);
    if (attr) {
      out.push('[' + key + '="' + attr + '"]');
    }
  }
  return out.join('');
}

/**
 * Returns true if either a OR b is truthy, but not both
 */
function isOnlyOneTruthy(a, b) {
  return !!(!!a ^ !!b);
}

/**
 * Returns true if both parameters are undefined
 */
function isBothUndefined(a, b) {
  return isUndefined(a) && isUndefined(b);
}

/**
 * Returns true if the two input exception interfaces have the same content
 */
function isSameException(ex1, ex2) {
  if (isOnlyOneTruthy(ex1, ex2)) return false;

  ex1 = ex1.values[0];
  ex2 = ex2.values[0];

  if (ex1.type !== ex2.type || ex1.value !== ex2.value) return false;

  // in case both stacktraces are undefined, we can't decide so default to false
  if (isBothUndefined(ex1.stacktrace, ex2.stacktrace)) return false;

  return isSameStacktrace(ex1.stacktrace, ex2.stacktrace);
}

/**
 * Returns true if the two input stack trace interfaces have the same content
 */
function isSameStacktrace(stack1, stack2) {
  if (isOnlyOneTruthy(stack1, stack2)) return false;

  var frames1 = stack1.frames;
  var frames2 = stack2.frames;

  // Exit early if frame count differs
  if (frames1.length !== frames2.length) return false;

  // Iterate through every frame; bail out if anything differs
  var a, b;
  for (var i = 0; i < frames1.length; i++) {
    a = frames1[i];
    b = frames2[i];
    if (
      a.filename !== b.filename ||
      a.lineno !== b.lineno ||
      a.colno !== b.colno ||
      a['function'] !== b['function']
    )
      return false;
  }
  return true;
}

/**
 * Polyfill a method
 * @param obj object e.g. `document`
 * @param name method name present on object e.g. `addEventListener`
 * @param replacement replacement function
 * @param track {optional} record instrumentation to an array
 */
function fill(obj, name, replacement, track) {
  if (obj == null) return;
  var orig = obj[name];
  obj[name] = replacement(orig);
  obj[name].__raven__ = true;
  obj[name].__orig__ = orig;
  if (track) {
    track.push([obj, name, orig]);
  }
}

/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns {string}
 */
function safeJoin(input, delimiter) {
  if (!isArray(input)) return '';

  var output = [];

  for (var i = 0; i < input.length; i++) {
    try {
      output.push(String(input[i]));
    } catch (e) {
      output.push('[value cannot be serialized]');
    }
  }

  return output.join(delimiter);
}

// Default Node.js REPL depth
var MAX_SERIALIZE_EXCEPTION_DEPTH = 3;
// 50kB, as 100kB is max payload size, so half sounds reasonable
var MAX_SERIALIZE_EXCEPTION_SIZE = 50 * 1024;
var MAX_SERIALIZE_KEYS_LENGTH = 40;

function utf8Length(value) {
  return ~-encodeURI(value).split(/%..|./).length;
}

function jsonSize(value) {
  return utf8Length(JSON.stringify(value));
}

function serializeValue(value) {
  if (typeof value === 'string') {
    var maxLength = 40;
    return truncate(value, maxLength);
  } else if (
    typeof value === 'number' ||
    typeof value === 'boolean' ||
    typeof value === 'undefined'
  ) {
    return value;
  }

  var type = Object.prototype.toString.call(value);

  // Node.js REPL notation
  if (type === '[object Object]') return '[Object]';
  if (type === '[object Array]') return '[Array]';
  if (type === '[object Function]')
    return value.name ? '[Function: ' + value.name + ']' : '[Function]';

  return value;
}

function serializeObject(value, depth) {
  if (depth === 0) return serializeValue(value);

  if (isPlainObject(value)) {
    return Object.keys(value).reduce(function(acc, key) {
      acc[key] = serializeObject(value[key], depth - 1);
      return acc;
    }, {});
  } else if (Array.isArray(value)) {
    return value.map(function(val) {
      return serializeObject(val, depth - 1);
    });
  }

  return serializeValue(value);
}

function serializeException(ex, depth, maxSize) {
  if (!isPlainObject(ex)) return ex;

  depth = typeof depth !== 'number' ? MAX_SERIALIZE_EXCEPTION_DEPTH : depth;
  maxSize = typeof depth !== 'number' ? MAX_SERIALIZE_EXCEPTION_SIZE : maxSize;

  var serialized = serializeObject(ex, depth);

  if (jsonSize(stringify(serialized)) > maxSize) {
    return serializeException(ex, depth - 1);
  }

  return serialized;
}

function serializeKeysForMessage(keys, maxLength) {
  if (typeof keys === 'number' || typeof keys === 'string') return keys.toString();
  if (!Array.isArray(keys)) return '';

  keys = keys.filter(function(key) {
    return typeof key === 'string';
  });
  if (keys.length === 0) return '[object has no keys]';

  maxLength = typeof maxLength !== 'number' ? MAX_SERIALIZE_KEYS_LENGTH : maxLength;
  if (keys[0].length >= maxLength) return keys[0];

  for (var usedKeys = keys.length; usedKeys > 0; usedKeys--) {
    var serialized = keys.slice(0, usedKeys).join(', ');
    if (serialized.length > maxLength) continue;
    if (usedKeys === keys.length) return serialized;
    return serialized + '\u2026';
  }

  return '';
}

function sanitize(input, sanitizeKeys) {
  if (!isArray(sanitizeKeys) || (isArray(sanitizeKeys) && sanitizeKeys.length === 0))
    return input;

  var sanitizeRegExp = joinRegExp(sanitizeKeys);
  var sanitizeMask = '********';
  var safeInput;

  try {
    safeInput = JSON.parse(stringify(input));
  } catch (o_O) {
    return input;
  }

  function sanitizeWorker(workerInput) {
    if (isArray(workerInput)) {
      return workerInput.map(function(val) {
        return sanitizeWorker(val);
      });
    }

    if (isPlainObject(workerInput)) {
      return Object.keys(workerInput).reduce(function(acc, k) {
        if (sanitizeRegExp.test(k)) {
          acc[k] = sanitizeMask;
        } else {
          acc[k] = sanitizeWorker(workerInput[k]);
        }
        return acc;
      }, {});
    }

    return workerInput;
  }

  return sanitizeWorker(safeInput);
}

module.exports = {
  isObject: isObject,
  isError: isError,
  isErrorEvent: isErrorEvent,
  isUndefined: isUndefined,
  isFunction: isFunction,
  isPlainObject: isPlainObject,
  isString: isString,
  isArray: isArray,
  isEmptyObject: isEmptyObject,
  supportsErrorEvent: supportsErrorEvent,
  supportsFetch: supportsFetch,
  supportsReferrerPolicy: supportsReferrerPolicy,
  supportsPromiseRejectionEvent: supportsPromiseRejectionEvent,
  wrappedCallback: wrappedCallback,
  each: each,
  objectMerge: objectMerge,
  truncate: truncate,
  objectFrozen: objectFrozen,
  hasKey: hasKey,
  joinRegExp: joinRegExp,
  urlencode: urlencode,
  uuid4: uuid4,
  htmlTreeAsString: htmlTreeAsString,
  htmlElementAsString: htmlElementAsString,
  isSameException: isSameException,
  isSameStacktrace: isSameStacktrace,
  parseUrl: parseUrl,
  fill: fill,
  safeJoin: safeJoin,
  serializeException: serializeException,
  serializeKeysForMessage: serializeKeysForMessage,
  sanitize: sanitize
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var identity_ = __webpack_require__(0).identity;
var result = __webpack_require__(18);

var configureRaven = __webpack_require__(219);

var _require = __webpack_require__(35),
    isLocalhost = _require.isLocalhost;

var getSantaVersionFromWorkerUrl = function getSantaVersionFromWorkerUrl(workerUrl) {
  var santaVersionMatch = workerUrl.match(/santa\/([^/]*)/);
  return santaVersionMatch ? santaVersionMatch[1] : 'unknown';
};

var tryOrGetUnknown = function tryOrGetUnknown(callback) {
  return result.try(callback).getOrElse('unknown');
};
var tryOrGetError = function tryOrGetError(callback) {
  return result.try(callback).matchWith({
    Ok: function Ok(_ref) {
      var value = _ref.value;
      return value;
    },
    Error: function Error(_ref2) {
      var error = _ref2.value;
      return error.message;
    }
  });
};

var getExtraDebugData = function getExtraDebugData(globalScope) {
  return {
    referrer: tryOrGetError(function () {
      return globalScope['wix-window'].referrer;
    }),
    workerUrl: tryOrGetError(function () {
      return globalScope.location.href;
    })
  };
};

var getTags = function getTags(globalScope) {
  return {
    viewMode: tryOrGetUnknown(function () {
      return globalScope['wix-window'].viewMode;
    }),
    santaVersion: tryOrGetUnknown(function () {
      return getSantaVersionFromWorkerUrl(globalScope.location.href);
    })
  };
};

module.exports = function (Raven, globalScope, dsn) {
  var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var appName = arguments[4];

  if (isLocalhost()) {
    return;
  }

  configureRaven({
    Raven: Raven,
    appName: appName,
    browserUrlGetter: function browserUrlGetter() {
      return tryOrGetUnknown(function () {
        return globalScope['wix-location'].url;
      });
    },
    dsn: dsn,
    params: params
  });

  Raven.setDataCallback(function (data) {
    var originalCallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : identity_;

    data.extra = Object.assign(data.extra || {}, getExtraDebugData(globalScope));
    data.tags = Object.assign(data.tags || {}, getTags(globalScope));

    return originalCallback(data);
  });
};

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//----------------------------------------------------------------------
//
// This source file is part of the Folktale project.
//
// Licensed under MIT. See LICENCE for full licence information.
// See CONTRIBUTORS for the list of contributors to the project.
//
//----------------------------------------------------------------------

module.exports = function (method, transformation) {
  if (typeof transformation !== 'function') {
    throw new TypeError(method + ' expects a function, but was given ' + transformation + '.');
  }
};

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//----------------------------------------------------------------------
//
// This source file is part of the Folktale project.
//
// Licensed under MIT. See LICENCE for full licence information.
// See CONTRIBUTORS for the list of contributors to the project.
//
//----------------------------------------------------------------------

/*~
 * stability: experimental
 * name: module folktale/adt/union
 */
module.exports = {
  union: __webpack_require__(8),
  derivations: __webpack_require__(205)
};

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//----------------------------------------------------------------------
//
// This source file is part of the Folktale project.
//
// Licensed under MIT. See LICENCE for full licence information.
// See CONTRIBUTORS for the list of contributors to the project.
//
//----------------------------------------------------------------------

var copyDocs = __webpack_require__(98);

var defineAdtMethod = function defineAdtMethod(adt, definitions) {
  Object.keys(definitions).forEach(function (name) {
    var methods = definitions[name];
    adt.variants.forEach(function (variant) {
      var method = methods[variant.tag];
      if (!method) {
        throw new TypeError('Method ' + name + ' not defined for ' + variant.tag);
      }
      copyDocs(methods, method);
      variant.prototype[name] = method;
    });
  });
};

module.exports = defineAdtMethod;

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (initialState, actionsByType) {
  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    var fn = actionsByType[action.type];

    if (fn) {
      return fn(state, action);
    } else {
      return state;
    }
  };
};

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  NEXT_DYNAMIC_PAGE_URL_RESULT: 'NEXT_DYNAMIC_PAGE_URL_RESULT',
  PREVIOUS_DYNAMIC_PAGE_URL_RESULT: 'PREVIOUS_DYNAMIC_PAGE_URL_RESULT',
  INITIALIZE: 'INITIALIZE'
};

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var result = __webpack_require__(18);
var set_ = __webpack_require__(0).set;

var addBreadcrumbResult = function addBreadcrumbResult(value, breadcrumb) {
  return value == null ? breadcrumb : set_(breadcrumb, ['data', 'result'], value);
};

// :: (Raven, (String, [*]) -> Breadcrumb, * -> *) -> { Wrapper, AsyncWrapper }
module.exports = function (Raven, createBreadcrumb, sanitise) {
  return {
    // withBreadcrumbs :: (String, [*] -> *) -> [*] -> *
    withBreadcrumbs: function withBreadcrumbs(name, fn) {
      return function () {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        var breadcrumb = createBreadcrumb(name, args);

        return result.try(function () {
          return fn.apply(undefined, args);
        }).matchWith({
          Error: function Error(_ref) {
            var message = _ref.value;

            breadcrumb.data = breadcrumb.data || {};
            breadcrumb.data.exception = message;
            breadcrumb.level = 'error';
            Raven.captureBreadcrumb(breadcrumb);
            throw message;
          },
          Ok: function Ok(_ref2) {
            var value = _ref2.value;

            var resultBreadcrumb = addBreadcrumbResult(sanitise(value), breadcrumb);
            Raven.captureBreadcrumb(resultBreadcrumb);
            return value;
          }
        });
      };
    },

    // withBreadcrumbsAsync :: (String, [*] -> *) -> [*] -> Promise *
    withBreadcrumbsAsync: function withBreadcrumbsAsync(name, fn) {
      return function () {
        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        var breadcrumb = createBreadcrumb(name, args);

        return fn.apply(undefined, args).then(function (value) {
          var resultBreadcrumb = addBreadcrumbResult(sanitise(value), breadcrumb);
          Raven.captureBreadcrumb(resultBreadcrumb);
          return value;
        }, function (message) {
          breadcrumb.data = breadcrumb.data || {};
          breadcrumb.data.exception = message;
          breadcrumb.level = 'error';
          Raven.captureBreadcrumb(breadcrumb);
          throw message;
        });
      };
    }
  };
};

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var includes_ = __webpack_require__(0).includes;
var componentInputTypes = __webpack_require__(296);

module.exports = function (component) {
  return includes_(componentInputTypes, component.type);
};

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (value) {
  return value == null ? '' : value.toString();
};

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var last_ = __webpack_require__(0).last;
var head_ = __webpack_require__(0).head;
var includes_ = __webpack_require__(0).includes;

var FIELD_PATH_SEPARATOR = '.';

var toFieldPath = function toFieldPath(fieldName, referenceFieldName) {
  return referenceFieldName ? [referenceFieldName, fieldName].join(FIELD_PATH_SEPARATOR) : fieldName;
};

var isFieldFromReferencedCollection = function isFieldFromReferencedCollection(fieldPath) {
  return includes_(fieldPath, FIELD_PATH_SEPARATOR);
};

var getFieldFromReferencedCollectionName = function getFieldFromReferencedCollectionName(fieldPath) {
  return last_(fieldPath.split(FIELD_PATH_SEPARATOR));
};

var getReferenceFieldName = function getReferenceFieldName(fieldPath) {
  return head_(fieldPath.split(FIELD_PATH_SEPARATOR));
};

module.exports.FIELD_PATH_SEPARATOR = FIELD_PATH_SEPARATOR;
module.exports.toFieldPath = toFieldPath;
module.exports.isFieldFromReferencedCollection = isFieldFromReferencedCollection;
module.exports.getFieldFromReferencedCollectionName = getFieldFromReferencedCollectionName;
module.exports.getReferenceFieldName = getReferenceFieldName;

/***/ }),
/* 67 */
/***/ (function(module, exports) {

/**
 * The default argument placeholder value for methods.
 *
 * @type {Object}
 */
module.exports = {};


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetData = __webpack_require__(146),
    createBind = __webpack_require__(346),
    createCurry = __webpack_require__(347),
    createHybrid = __webpack_require__(151),
    createPartial = __webpack_require__(365),
    getData = __webpack_require__(155),
    mergeData = __webpack_require__(366),
    setData = __webpack_require__(157),
    setWrapToString = __webpack_require__(159),
    toInteger = __webpack_require__(77);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Creates a function that either curries or invokes `func` with optional
 * `this` binding and partially applied arguments.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags.
 *    1 - `_.bind`
 *    2 - `_.bindKey`
 *    4 - `_.curry` or `_.curryRight` of a bound function
 *    8 - `_.curry`
 *   16 - `_.curryRight`
 *   32 - `_.partial`
 *   64 - `_.partialRight`
 *  128 - `_.rearg`
 *  256 - `_.ary`
 *  512 - `_.flip`
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to be partially applied.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
  var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
  if (!isBindKey && typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var length = partials ? partials.length : 0;
  if (!length) {
    bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
    partials = holders = undefined;
  }
  ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
  arity = arity === undefined ? arity : toInteger(arity);
  length -= holders ? holders.length : 0;

  if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
    var partialsRight = partials,
        holdersRight = holders;

    partials = holders = undefined;
  }
  var data = isBindKey ? undefined : getData(func);

  var newData = [
    func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
    argPos, ary, arity
  ];

  if (data) {
    mergeData(newData, data);
  }
  func = newData[0];
  bitmask = newData[1];
  thisArg = newData[2];
  partials = newData[3];
  holders = newData[4];
  arity = newData[9] = newData[9] === undefined
    ? (isBindKey ? 0 : func.length)
    : nativeMax(newData[9] - length, 0);

  if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
    bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
  }
  if (!bitmask || bitmask == WRAP_BIND_FLAG) {
    var result = createBind(func, bitmask, thisArg);
  } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
    result = createCurry(func, bitmask, arity);
  } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
    result = createPartial(func, bitmask, thisArg, partials);
  } else {
    result = createHybrid.apply(undefined, newData);
  }
  var setter = data ? baseSetData : setData;
  return setWrapToString(setter(result, newData), func, bitmask);
}

module.exports = createWrap;


/***/ }),
/* 69 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(11),
    isObject = __webpack_require__(12);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 71 */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(47),
    baseLodash = __webpack_require__(73);

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295;

/**
 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
 *
 * @private
 * @constructor
 * @param {*} value The value to wrap.
 */
function LazyWrapper(value) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__dir__ = 1;
  this.__filtered__ = false;
  this.__iteratees__ = [];
  this.__takeCount__ = MAX_ARRAY_LENGTH;
  this.__views__ = [];
}

// Ensure `LazyWrapper` is an instance of `baseLodash`.
LazyWrapper.prototype = baseCreate(baseLodash.prototype);
LazyWrapper.prototype.constructor = LazyWrapper;

module.exports = LazyWrapper;


/***/ }),
/* 73 */
/***/ (function(module, exports) {

/**
 * The function whose prototype chain sequence wrappers inherit from.
 *
 * @private
 */
function baseLodash() {
  // No operation performed.
}

module.exports = baseLodash;


/***/ }),
/* 74 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),
/* 75 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 76 */
/***/ (function(module, exports) {

/** Used as the internal argument placeholder. */
var PLACEHOLDER = '__lodash_placeholder__';

/**
 * Replaces all `placeholder` elements in `array` with an internal placeholder
 * and returns an array of their indexes.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {*} placeholder The placeholder to replace.
 * @returns {Array} Returns the new array of placeholder indexes.
 */
function replaceHolders(array, placeholder) {
  var index = -1,
      length = array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (value === placeholder || value === PLACEHOLDER) {
      array[index] = PLACEHOLDER;
      result[resIndex++] = index;
    }
  }
  return result;
}

module.exports = replaceHolders;


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

var toFinite = __webpack_require__(367);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


/***/ }),
/* 78 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(370),
    isObjectLike = __webpack_require__(5);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(3),
    stubFalse = __webpack_require__(371);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(39)(module)))

/***/ }),
/* 81 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 82 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(149);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(39)(module)))

/***/ }),
/* 84 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(70),
    isLength = __webpack_require__(81);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(50),
    stackClear = __webpack_require__(380),
    stackDelete = __webpack_require__(381),
    stackGet = __webpack_require__(382),
    stackHas = __webpack_require__(383),
    stackSet = __webpack_require__(384);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(16),
    root = __webpack_require__(3);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(385),
    mapCacheDelete = __webpack_require__(392),
    mapCacheGet = __webpack_require__(394),
    mapCacheHas = __webpack_require__(395),
    mapCacheSet = __webpack_require__(396);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(402),
    stubArray = __webpack_require__(173);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 90 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(170);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

var Uint8Array = __webpack_require__(177);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(4),
    isSymbol = __webpack_require__(28);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 94 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DataItem = function () {
  function DataItem() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;

    _classCallCheck(this, DataItem);

    this.data = data;
  }

  _createClass(DataItem, [{
    key: 'isActive',
    value: function isActive() {
      return true;
    }
  }, {
    key: 'export',
    value: function _export() {
      return this.data;
    }
  }]);

  return DataItem;
}();

exports.default = DataItem;

/***/ }),
/* 96 */
/***/ (function(module, exports) {

/*
 json-stringify-safe
 Like JSON.stringify, but doesn't throw on circular references.

 Originally forked from https://github.com/isaacs/json-stringify-safe
 version 5.0.1 on 3/8/2017 and modified to handle Errors serialization
 and IE8 compatibility. Tests for this are in test/vendor.

 ISC license: https://github.com/isaacs/json-stringify-safe/blob/master/LICENSE
*/

exports = module.exports = stringify;
exports.getSerialize = serializer;

function indexOf(haystack, needle) {
  for (var i = 0; i < haystack.length; ++i) {
    if (haystack[i] === needle) return i;
  }
  return -1;
}

function stringify(obj, replacer, spaces, cycleReplacer) {
  return JSON.stringify(obj, serializer(replacer, cycleReplacer), spaces);
}

// https://github.com/ftlabs/js-abbreviate/blob/fa709e5f139e7770a71827b1893f22418097fbda/index.js#L95-L106
function stringifyError(value) {
  var err = {
    // These properties are implemented as magical getters and don't show up in for in
    stack: value.stack,
    message: value.message,
    name: value.name
  };

  for (var i in value) {
    if (Object.prototype.hasOwnProperty.call(value, i)) {
      err[i] = value[i];
    }
  }

  return err;
}

function serializer(replacer, cycleReplacer) {
  var stack = [];
  var keys = [];

  if (cycleReplacer == null) {
    cycleReplacer = function(key, value) {
      if (stack[0] === value) {
        return '[Circular ~]';
      }
      return '[Circular ~.' + keys.slice(0, indexOf(stack, value)).join('.') + ']';
    };
  }

  return function(key, value) {
    if (stack.length > 0) {
      var thisPos = indexOf(stack, this);
      ~thisPos ? stack.splice(thisPos + 1) : stack.push(this);
      ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key);

      if (~indexOf(stack, value)) {
        value = cycleReplacer.call(this, key, value);
      }
    } else {
      stack.push(value);
    }

    return replacer == null
      ? value instanceof Error ? stringifyError(value) : value
      : replacer.call(this, key, value);
  };
}


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//----------------------------------------------------------------------
//
// This source file is part of the Folktale project.
//
// Licensed under MIT. See LICENCE for full licence information.
// See CONTRIBUTORS for the list of contributors to the project.
//
//----------------------------------------------------------------------

module.exports = {
  equals: 'fantasy-land/equals',
  concat: 'fantasy-land/concat',
  empty: 'fantasy-land/empty',
  map: 'fantasy-land/map',
  ap: 'fantasy-land/ap',
  of: 'fantasy-land/of',
  reduce: 'fantasy-land/reduce',
  traverse: 'fantasy-land/traverse',
  chain: 'fantasy-land/chain',
  chainRec: 'fantasy-land/chainRec',
  extend: 'fantasy-land/extend',
  extract: 'fantasy-land/extract',
  bimap: 'fantasy-land/bimap',
  promap: 'fantasy-land/promap'
};

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//----------------------------------------------------------------------
//
// This source file is part of the Folktale project.
//
// Licensed under MIT. See LICENCE for full licence information.
// See CONTRIBUTORS for the list of contributors to the project.
//
//----------------------------------------------------------------------

var mm = Symbol.for('@@meta:magical');

var copyDocumentation = function copyDocumentation(source, target) {
  var extensions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (Object({"NODE_ENV":"production"}).FOLKTALE_DOCS !== 'false') {
    target[mm] = Object.assign({}, source[mm] || {}, extensions);
  }
};

module.exports = copyDocumentation;

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//----------------------------------------------------------------------
//
// This source file is part of the Folktale project.
//
// Licensed under MIT. See LICENCE for full licence information.
// See CONTRIBUTORS for the list of contributors to the project.
//
//----------------------------------------------------------------------

var assertType = __webpack_require__(32);
var assertFunction = __webpack_require__(58);

var _require = __webpack_require__(59),
    union = _require.union,
    derivations = _require.derivations;

var provideAliases = __webpack_require__(33);
var adtMethods = __webpack_require__(60);
var extend = __webpack_require__(23);
var warnDeprecation = __webpack_require__(19);

var equality = derivations.equality,
    debugRepresentation = derivations.debugRepresentation,
    serialization = derivations.serialization;

/*~ stability: experimental */

var Validation = union('folktale:Validation', {
  /*~
   * type: |
   *   forall a, b: (a) => Validation a b
   */
  Failure: function Failure(value) {
    return { value: value };
  },


  /*~
   * type: |
   *   forall a, b: (b) => Validation a b
   */
  Success: function Success(value) {
    return { value: value };
  }
}).derive(equality, debugRepresentation, serialization);

var Success = Validation.Success,
    Failure = Validation.Failure;

var assertValidation = assertType(Validation);

extend(Failure.prototype, {
  /*~
   * isRequired: true
   * type: |
   *   forall a, b: get (Validation a b) => a
   */
  get value() {
    throw new TypeError('`value` can’t be accessed in an abstract instance of Validation.Failure');
  }
});

extend(Success.prototype, {
  /*~
   * isRequired: true
   * type: |
   *   forall a, b: get (Validation a b) => b
   */
  get value() {
    throw new TypeError('`value` can’t be accessed in an abstract instance of Validation.Success');
  }
});

/*~~belongsTo: Validation */
adtMethods(Validation, {
  /*~
   * type: |
   *   forall a, b, c: (Validation a b).((b) => c) => Validation a c
   */
  map: {
    /*~*/
    Failure: function map(transformation) {
      assertFunction('Validation.Failure#map', transformation);
      return this;
    },

    /*~*/
    Success: function map(transformation) {
      assertFunction('Validation.Success#map', transformation);
      return Success(transformation(this.value));
    }
  },

  /*~
   * type: |
   *   forall a, b, c: (Validation (b) => c).(Validation a b) => Validation a c
   */
  apply: {
    /*~*/
    Failure: function apply(aValidation) {
      assertValidation('Failure#apply', aValidation);
      return Failure.hasInstance(aValidation) ? Failure(this.value.concat(aValidation.value)) : /* otherwise */this;
    },

    /*~*/
    Success: function apply(aValidation) {
      assertValidation('Success#apply', aValidation);
      return Failure.hasInstance(aValidation) ? aValidation : /* otherwise */aValidation.map(this.value);
    }
  },

  /*~
   * type: |
   *   forall a, b: (Validation a b).() => b :: throws TypeError
   */
  unsafeGet: {
    /*~*/
    Failure: function unsafeGet() {
      throw new TypeError('Can\'t extract the value of a Failure.\n\n    Failure does not contain a normal value - it contains an error.\n    You might consider switching from Validation#get to Validation#getOrElse, or some other method\n    that is not partial.\n      ');
    },

    /*~*/
    Success: function unsafeGet() {
      return this.value;
    }
  },

  /*~
   * type: |
   *   forall a, b: (Validation a b).(b) => b
   */
  getOrElse: {
    /*~*/
    Failure: function getOrElse(_default) {
      return _default;
    },

    /*~*/
    Success: function getOrElse(_default) {
      return this.value;
    }
  },

  /*~
   * type: |
   *   forall a, b, c:
   *     (Validation a b).((a) => Validation c b) => Validation c b
   */
  orElse: {
    /*~*/
    Failure: function orElse(handler) {
      assertFunction('Validation.Failure#orElse', handler);
      return handler(this.value);
    },

    /*~*/
    Success: function orElse(handler) {
      assertFunction('Validation.Success#orElse', handler);
      return this;
    }
  },

  /*~
   * type: |
   *   forall a, b:
   *     (Validation a b).(Validation a b) => Validation a b
   *   where a is Semigroup
   */
  concat: {
    /*~*/
    Failure: function concat(aValidation) {
      assertValidation('Validation.Failure#concat', aValidation);
      if (Failure.hasInstance(aValidation)) {
        return Failure(this.value.concat(aValidation.value));
      } else {
        return this;
      }
    },

    /*~*/
    Success: function concat(aValidation) {
      assertValidation('Validation.Success#concat', aValidation);
      return aValidation;
    }
  },

  /*~
   * type: |
   *   forall a, b, c:
   *     (Validation a b).((a) => c, (b) => c) => c
   */
  fold: {
    /*~*/
    Failure: function fold(failureTransformation, successTransformation) {
      assertFunction('Validation.Failure#fold', failureTransformation);
      assertFunction('Validation.Failure#fold', successTransformation);
      return failureTransformation(this.value);
    },

    /*~*/
    Success: function fold(failureTransformation, successTransformation) {
      assertFunction('Validation.Success#fold', failureTransformation);
      assertFunction('Validation.Success#fold', successTransformation);
      return successTransformation(this.value);
    }
  },

  /*~
   * type: |
   *   forall a, b: (Validation a b).() => Validation b a
   */
  swap: {
    /*~*/
    Failure: function swap() {
      return Success(this.value);
    },

    /*~*/
    Success: function swap() {
      return Failure(this.value);
    }
  },

  /*~
   * type: |
   *   forall a, b, c, d:
   *     (Validation a b).((a) => c, (b) => d) => Validation c d
   */
  bimap: {
    /*~*/
    Failure: function bimap(failureTransformation, successTransformation) {
      assertFunction('Validation.Failure#fold', failureTransformation);
      assertFunction('Validation.Failure#fold', successTransformation);
      return Failure(failureTransformation(this.value));
    },

    /*~*/
    Success: function bimap(failureTransformation, successTransformation) {
      assertFunction('Validation.Success#fold', failureTransformation);
      assertFunction('Validation.Success#fold', successTransformation);
      return Success(successTransformation(this.value));
    }
  },

  /*~
   * type: |
   *   forall a, b, c:
   *     (Validation a b).((a) => c) Validation c b
   */
  mapFailure: {
    /*~*/
    Failure: function mapFailure(transformation) {
      assertFunction('Validation.Failure#mapFailure', transformation);
      return Failure(transformation(this.value));
    },

    /*~*/
    Success: function mapFailure(transformation) {
      assertFunction('Validation.Failure#mapFailure', transformation);
      return this;
    }
  }
});

Object.assign(Validation, {
  /*~
   * type: |
   *   forall a, b: (b) => Validation a b
   */
  of: function of(value) {
    return Success(value);
  },


  /*~
   * type: |
   *   forall a, b: (Validation a b).() => b :: throws TypeError
   */
  'get': function get() {
    warnDeprecation('`.get()` is deprecated, and has been renamed to `.unsafeGet()`.');
    return this.unsafeGet();
  },


  /*~
   * type: |
   *   forall a, b: (Validation a b).() => a or b
   */
  merge: function merge() {
    return this.value;
  },


  /*~
   * type: |
   *   forall a, b: (Validation a b).() => Result a b
   */
  toResult: function toResult() {
    return __webpack_require__(100)(this);
  },


  /*~
   * type: |
   *   forall a, b: (Validation a b).() => Maybe b
   */
  toMaybe: function toMaybe() {
    return __webpack_require__(101)(this);
  }
});

provideAliases(Success.prototype);
provideAliases(Failure.prototype);
provideAliases(Validation);

module.exports = Validation;

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//----------------------------------------------------------------------
//
// This source file is part of the Folktale project.
//
// Licensed under MIT. See LICENCE for full licence information.
// See CONTRIBUTORS for the list of contributors to the project.
//
//----------------------------------------------------------------------

var _require = __webpack_require__(22),
    Error = _require.Error,
    Ok = _require.Ok;

/*~
 * stability: stable
 * authors:
 *   - "@boris-marinov"
 * 
 * type: |
 *   forall a, b:
 *      (Validation a b) => Result a b
 */


var validationToResult = function validationToResult(aValidation) {
  return aValidation.matchWith({
    Failure: function Failure(_ref) {
      var value = _ref.value;
      return Error(value);
    },
    Success: function Success(_ref2) {
      var value = _ref2.value;
      return Ok(value);
    }
  });
};

module.exports = validationToResult;

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//----------------------------------------------------------------------
//
// This source file is part of the Folktale project.
//
// Licensed under MIT. See LICENCE for full licence information.
// See CONTRIBUTORS for the list of contributors to the project.
//
//----------------------------------------------------------------------

var _require = __webpack_require__(34),
    Just = _require.Just,
    Nothing = _require.Nothing;

/*~
 * stability: stable
 * authors: 
 *   - "@boris-marinov"
 * 
 * type: |
 *   forall a, b:
 *     (Validation a b) => Maybe b
 */


var validationToMaybe = function validationToMaybe(aValidation) {
  return aValidation.matchWith({
    Failure: function Failure() {
      return Nothing();
    },
    Success: function Success(_ref) {
      var value = _ref.value;
      return Just(value);
    }
  });
};

module.exports = validationToMaybe;

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//----------------------------------------------------------------------
//
// This source file is part of the Folktale project.
//
// Licensed under MIT. See LICENCE for full licence information.
// See CONTRIBUTORS for the list of contributors to the project.
//
//----------------------------------------------------------------------

var _require = __webpack_require__(22),
    Error = _require.Error,
    Ok = _require.Ok;

/*~
 * stability: stable
 * authors:
 *   - "@boris-marinov"
 * 
 * type: |
 *   forall a, b:
 *     (Maybe a, b) => Result b a
 */


var maybeToResult = function maybeToResult(aMaybe, failureValue) {
  return aMaybe.matchWith({
    Nothing: function Nothing() {
      return Error(failureValue);
    },
    Just: function Just(_ref) {
      var value = _ref.value;
      return Ok(value);
    }
  });
};

module.exports = maybeToResult;

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//----------------------------------------------------------------------
//
// This source file is part of the Folktale project.
//
// Licensed under MIT. See LICENCE for full licence information.
// See CONTRIBUTORS for the list of contributors to the project.
//
//----------------------------------------------------------------------

var _require = __webpack_require__(34),
    Just = _require.Just,
    Nothing = _require.Nothing;

/*~
 * stability: stable
 * authors:
 *   - "@boris-marinov"
 *
 * type: |
 *   forall a, b:
 *     (Result a b) => Maybe b
 */


var resultToMaybe = function resultToMaybe(aResult) {
  return aResult.matchWith({
    Error: function Error(_ref) {
      var _ = _ref.value;
      return Nothing();
    },
    Ok: function Ok(_ref2) {
      var value = _ref2.value;
      return Just(value);
    }
  });
};

module.exports = resultToMaybe;

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var UNKNOWN_VERSION = 'unknown';
var isValidVersionString = function isValidVersionString(version) {
  return (/^\d+\.\d+\.\d+$/.test(version)
  );
};

module.exports = function (url) {
  try {
    var split = url.split('/');
    var possibleVersion = split[split.length - 2];
    return isValidVersionString(possibleVersion) ? possibleVersion : UNKNOWN_VERSION;
  } catch (e) {
    return UNKNOWN_VERSION;
  }
};

module.exports.UNKNOWN_VERSION = UNKNOWN_VERSION;

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isError_ = __webpack_require__(0).isError;
var errorBoundaries = __webpack_require__(229);

var _require = __webpack_require__(13),
    isDatasetError = _require.isDatasetError;

var USER_SCOPE = 'userCodeZone';
var APPLICATION_SCOPE = 'applicationCodeZone';
var WIX_DATA_SCOPE = 'wixDataCodeZone';
var WIX_DATA_USER_ERROR_CODES = ['WD_SITE_IN_TEMPLATE_MODE', 'WD_PERMISSION_DENIED'];
var WIX_DATA_UNKNOWN_ERROR = 'WD_UNKNOWN_ERROR';
var handled = Symbol('error was handled');

var isErrorHandled = function isErrorHandled(e) {
  return e[handled];
};

var isUserError = function isUserError(error, scope) {
  return isDatasetError(error.name) || scope === USER_SCOPE || scope === WIX_DATA_SCOPE && WIX_DATA_USER_ERROR_CODES.includes(error.code);
};

var isWixDataError = function isWixDataError(error) {
  return error.code === WIX_DATA_UNKNOWN_ERROR;
};

var reportException = function reportException(raven, e) {
  raven.captureException(e);
  e[handled] = true;
};

var dbsmViewerErrorHandler = function dbsmViewerErrorHandler(ravenInstances, e, scope) {
  var Raven = ravenInstances.Raven,
      UserRaven = ravenInstances.UserRaven,
      WixDataRaven = ravenInstances.WixDataRaven;

  if (!isError_(e) || isErrorHandled(e)) {
    return;
  }
  if (isUserError(e, scope)) {
    reportException(UserRaven, e);
  } else if (isWixDataError(e)) {
    reportException(WixDataRaven, e);
  } else if (scope === APPLICATION_SCOPE) {
    reportException(Raven, e);
  }
};

module.exports = function (ravenInstances) {
  return errorBoundaries({
    scopes: [USER_SCOPE, APPLICATION_SCOPE, WIX_DATA_SCOPE],
    errorHandler: dbsmViewerErrorHandler.bind(undefined, ravenInstances)
  });
};

module.exports.isErrorHandled = isErrorHandled;

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AssertionError = function (_Error) {
  _inherits(AssertionError, _Error);

  function AssertionError(message) {
    _classCallCheck(this, AssertionError);

    var _this = _possibleConstructorReturn(this, (AssertionError.__proto__ || Object.getPrototypeOf(AssertionError)).call(this, message));

    _this.name = _this.constructor.name;
    return _this;
  }

  return AssertionError;
}(Error);

function assertDefined(target, message) {
  if (target === undefined) {
    throw new AssertionError(message);
  }
}

function assertObject(target, message) {
  if (target !== undefined && ((typeof target === 'undefined' ? 'undefined' : _typeof(target)) !== 'object' || Array.isArray(target) || target === null)) {
    throw new AssertionError(message);
  }
}

function assertOk(target, message) {
  if (!target) {
    throw new AssertionError(message);
  }
}

module.exports.defined = assertDefined;
module.exports.object = assertObject;
module.exports.ok = assertOk;
module.exports.AssertionError = AssertionError;
//# sourceMappingURL=assert.js.map

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildUrl = buildUrl;
exports.guid = guid;

var _performance = __webpack_require__(240);

var _env = __webpack_require__(36);

var DEFAULT_ENDPOINT = '';

var cacheKillerCounter = 0;

function addParam(url, key, value) {
  var separator = url.indexOf('?') === -1 ? '?' : '&';
  return '' + url + separator + encodeURIComponent(key) + '=' + encodeURIComponent(value);
}

function buildUrl(_ref, params) {
  var host = _ref.host,
      _ref$endpoint = _ref.endpoint,
      endpoint = _ref$endpoint === undefined ? DEFAULT_ENDPOINT : _ref$endpoint;

  host = host || (0, _env.getHost)();

  params._ = '' + new Date().getTime() + cacheKillerCounter++;
  params.ms = Math.round((0, _performance.now)());

  var prefix = '//' + host + '/' + endpoint;
  return Object.keys(params).reduce(function (url, key) {
    return addParam(url, key, params[key]);
  }, prefix);
}

function guid() {
  /*eslint-disable */
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0;
    var v = c === 'x' ? r : r & 0x3 | 0x8;
    return v.toString(16);
  });
  /*eslint-enable */
}

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.listen = listen;
exports.sendBeacon = sendBeacon;

var _env = __webpack_require__(36);

function hook(obj, fnName, hook) {
  if (!obj || !obj[fnName]) {
    return;
  }

  var original = obj[fnName];
  obj[fnName] = function () {
    hook.apply(null, arguments);
    return original.apply(obj, arguments);
  };
}

function onLoad(cb) {
  setTimeout(function () {
    return (0, _env.provideBrowsingContext)(function (window) {
      return cb(window.location.href);
    });
  });
}

function onPushState(cb) {
  (0, _env.provideBrowsingContext)(function (_ref) {
    var history = _ref.history;
    return ['pushState', 'replaceState'].forEach(function (fnName) {
      hook(history, fnName, function (_, __, url) {
        return cb(url);
      });
    });
  });
}

function onPopState(cb) {
  (0, _env.provideBrowsingContext)(function (window) {
    return window.addEventListener('popstate', function () {
      return cb(window.location.href);
    });
  });
}

function listen(cb) {
  (0, _env.provideBrowsingContext)(function (window) {
    var fromUrl = window.document.referrer;

    [onLoad, onPushState, onPopState].forEach(function (event) {
      return event(function (toUrl) {
        cb(fromUrl, toUrl);
        fromUrl = toUrl;
      });
    });
  });
}

function sendBeacon(url) {
  if (typeof navigator === 'undefined' || !navigator || !navigator.sendBeacon) {
    return false;
  }

  return navigator.sendBeacon(url);
}

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});
exports.wrapAndDeduplicate = wrapAndDeduplicate;

var _refTransformer = __webpack_require__(110);

var _wixDataWebmethodStructures = __webpack_require__(38);

function wrapAndDeduplicate(items, schema, references) {
  return items.map(function (item) {
    var wrappedItem = (0, _refTransformer.wrapAllReferences)(schema, item);
    if (references) {
      Object.keys(references).filter(function (includedField) {
        return wrappedItem[includedField] && wrappedItem[includedField] instanceof _wixDataWebmethodStructures.Ref;
      }).forEach(function (includedField) {
        var referencedItemId = wrappedItem[includedField].id;
        var referencedItem = references[includedField][referencedItemId];
        wrappedItem[includedField] = new _wixDataWebmethodStructures.Ref(referencedItem || referencedItemId);
      });
    }
    return wrappedItem;
  });
}

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});
exports.forEachReferenceField = forEachReferenceField;
exports.wrapReferenceField = wrapReferenceField;
exports.unwrapReferenceField = unwrapReferenceField;
exports.wrapAllReferences = wrapAllReferences;
exports.unwrapAllReferences = unwrapAllReferences;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _wixDataWebmethodStructures = __webpack_require__(38);

var _lodashClonedeep = __webpack_require__(250);

var _lodashClonedeep2 = _interopRequireDefault(_lodashClonedeep);

function forEachReferenceField(schema, callback) {
  if (schema.fields) {
    Object.keys(schema.fields || {}).map(function (field) {
      return [field, schema.fields[field]];
    }).filter(function (field) {
      return field[1].type === 'reference';
    }).map(function (field) {
      return field[0];
    }).forEach(callback);
  }
}

function wrapReferenceField(item, fieldName) {
  if (!(item[fieldName] instanceof _wixDataWebmethodStructures.Ref)) {
    var fieldValue = item[fieldName];

    if (fieldValue === null) {
      item[fieldName] = null;
    } else {
      var bestMatchForReferenceParameter = isObject(fieldValue) ? fieldValue._item || fieldValue.item || fieldValue._id || fieldValue.ref : typeof fieldValue === 'string' ? fieldValue : undefined;

      if (typeof bestMatchForReferenceParameter !== 'undefined') {
        item[fieldName] = new _wixDataWebmethodStructures.Ref(bestMatchForReferenceParameter);
      } else if (typeof fieldValue !== 'undefined') {
        item[fieldName] = fieldValue;
      }
    }
  }
  return item;
}

function unwrapReferenceField(item, fieldName) {
  if (item.hasOwnProperty(fieldName) && item[fieldName]) {

    if (item[fieldName].hasOwnProperty('_id')) {
      item[fieldName] = item[fieldName]._id;
    } else if (item[fieldName].hasOwnProperty('ref')) {
      // Temporary compatibility mode.
      item[fieldName] = item[fieldName].ref;
    }

    // if (isFunction(item[fieldName].toJSON)) {
    //   item[fieldName] = item[fieldName].toJSON()
    // }
    // delete item[fieldName].item
  }

  return item;
}

function wrapAllReferences(schema, item) {
  var resultingItem = (0, _lodashClonedeep2['default'])(item);

  if (!reflessJoinsEnabled()) {
    forEachReferenceField(schema, wrapReferenceField.bind(null, resultingItem));
  }

  return resultingItem;
}

function unwrapAllReferences(schema, item) {
  var resultingItem = (0, _lodashClonedeep2['default'])(item);

  forEachReferenceField(schema, unwrapReferenceField.bind(null, resultingItem));

  return resultingItem;
}

function isObject(param) {
  return typeof param === 'object';
}

function reflessJoinsEnabled() {
  //return process && process.env && process.env.NEW_JOINS
  return true;
}

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});
var _slice = Array.prototype.slice;

var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x3, _x4, _x5) { var _again = true; _function: while (_again) { var object = _x3, property = _x4, receiver = _x5; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x3 = parent; _x4 = property; _x5 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var _sharedTypeUtils = __webpack_require__(14);

var _utilsClone = __webpack_require__(37);

var _utilsClone2 = _interopRequireDefault(_utilsClone);

var _utilsBaseValidator = __webpack_require__(40);

var _errors = __webpack_require__(9);

var _ref = __webpack_require__(251);

/**
 * @class WixDataFilter
 * @description Provides functionality for filtering a query.
 * @memberof wix-data
 */
var filterMixin = function filterMixin() {
  var Base = arguments.length <= 0 || arguments[0] === undefined ? (function () {
    function _class() {
      _classCallCheck(this, _class);
    }

    return _class;
  })() : arguments[0];
  return (function (_Base) {
    _inherits(_class2, _Base);

    function _class2() {
      var obj = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

      _classCallCheck(this, _class2);

      _get(Object.getPrototypeOf(_class2.prototype), 'constructor', this).call(this, obj);
      this.filterTree = obj.filterTree || { '$and': [] };
      this.invalidArguments = obj.invalidArguments || [];
    }

    /**
     * @function eq
     * @syntax
     * function eq(propertyName: string, value: *): WixDataQuery
     * @summary Refines a query or filter to match items whose specified property value equals the specified value.
     * @param {external:String} propertyName The property whose value will be compared with `value`.
     * @param {} value The value to match against.
     * @returns {wix-data.WixDataQuery} A `WixDataQuery` object representing the refined query.
     * @description
     *  The `eq()` function refines a `WixDataQuery` or `WixDataFilter` to only
     *  match items where the value of the specified property equals the specified `value`.
     *
     *  It only matches values of the same type. For example, a number value stored
     *  as a String type does not match the same number stored as a Number type.
     *
     *  If the value of the `propertyName` property is an Array, `eq()` includes items
     *  in which any of the elements of the Array match the specified `value`.
     * @snippet [FilterMixin-eq.es6=Add an equals filter to a query]
     * @snippet [FilterMixin-eq_scenario.es6=Create a query, add an equals filter, and run it]
     * @snippet [FilterMixin-eq_scenario_plus.es6=Create a query, add an equals filter, and run it]
     * @memberof wix-data.WixDataFilter
     * @instance
     */

    _createClass(_class2, [{
      key: 'eq',
      value: function eq(field, value) {
        return this._binaryAnd('$eq', '.eq', arguments);
      }

      /**
       * @function ne
       * @syntax
       * function ne(propertyName: string, value: *): WixDataQuery
       * @summary Refines a query or filter to match items whose specified property value does not equal the specified value.
       * @param {external:String} propertyName The property whose value will be compared with `value`.
       * @param {} value The value to match against.
       * @returns {wix-data.WixDataQuery} A `WixDataQuery` object representing the refined query.
       * @description
       *  The `ne()` function refines a `WixDataQuery` or `WixDataFilter` to only
       *  match items where the value of the specified property does not equal the specified `value`.
       *
       *  It only matches values of the same type. For example, a number value stored
       *  as a String type is considered not equal to the same number stored as a Number type.
       *
       *  If the value of the `propertyName` property is an Array, `ne()` includes items
       *  in which none of the elements of the Array match the specified `value`.
       * @snippet [FilterMixin-ne.es6=Add a not equals filter to a query]
       * @snippet [FilterMixin-ne_scenario.es6=Create a query, add a not equals filter, and run it]
       * @snippet [FilterMixin-ne_scenario_plus.es6=Create a query, add a not equals filter, and run it]
       * @memberof wix-data.WixDataFilter
       * @instance
       */
    }, {
      key: 'ne',
      value: function ne(field, value) {
        return this._binaryAnd('$ne', '.ne', arguments);
      }

      /**
       * @function ge
       * @syntax
       * function ge(propertyName: string, value: string|number|date): WixDataQuery
       * @summary Refines a query or filter to match items whose specified property value is greater than or equal to the specified value.
       * @param {external:String} propertyName The property whose value will be compared with `value`.
       * @param {external:String|external:Number|external:Date} value The value to match against.
       * @returns {wix-data.WixDataQuery} A `WixDataQuery` object representing the refined query.
       * @description
       *  The `ge()` function refines a `WixDataQuery` or `WixDataFilter` to only
       *  match items where the value of the specified property is greater than or
       *  equal to the specified `value`.
       *
       *  It only matches values of the same type. For example, a number value stored
       *  as a String type does not match the same number stored as a Number type.
       *
       *  If a property contains a number as a String, that value will be compared
       *  alphabetically and not numerically. Items that do not have a value for the
       *  specified property are ranked lowest.
       *
       *  The following types of items can be compared:
       *
       *  + Number: Compares numerically.
       *  + Date: Compares JavaScript Date objects.
       *  + String: Compares alphabetically. The sort is based on the JavaScript sort methodology, which is a lexicographical sort that compares Unicode characters by their code points.
       *  + Reference: Compares by the ID of the referenced item as a String.
       *
       *
       * @snippet [FilterMixin-ge.es6=Add a greater than or equals filter to a query]
       * @snippet [FilterMixin-ge_scenario.es6=Create a query, add a greater than or equals filter, and run it]
       * @snippet [FilterMixin-ge_scenario_plus.es6=Create a query, add a greater than or equals filter, and run it]
       * @memberof wix-data.WixDataFilter
       * @instance
       */
    }, {
      key: 'ge',
      value: function ge(field, value) {
        return this._AndLogicalEquivalence('$gte', '.ge', arguments);
      }

      /**
       * @function gt
       * @syntax
       * function gt(propertyName: string, value: string|number|date): WixDataQuery
       * @summary Refines a query or filter to match items whose specified property value is greater than the specified value.
       * @param {external:String} propertyName The property whose value will be compared with `value`.
       * @param {external:String|external:Number|external:Date} value The value to match against.
       * @returns {wix-data.WixDataQuery} A `WixDataQuery` object with the query definition, based on the supplied parameters.
       * @description
       *  The `gt()` function refines a `WixDataQuery` or `WixDataFilter` to only match items where the value
       *  of the specified property is greater than the specified `value`.
       *
       *  It only matches values of the same type. For example, a number value stored
       *  as a String type does not match the same number stored as a Number type.
       *
       *  If a property contains a number as a String, that value will be compared
       *  alphabetically and not numerically. Items that do not have a value for the
       *  specified property are ranked lowest.
       *
       *  The following types of items can be compared:
       *
       *  + Number: Compares numerically.
       *  + Date: Compares JavaScript Date objects.
       *  + String: Compares alphabetically. The sort is based on the JavaScript sort methodology, which is a lexicographical sort that compares Unicode characters by their code points.
       *  + Reference: Compares by the ID of the referenced item as a String.
       *
       *
       * @snippet [FilterMixin-gt.es6=Add a greater than filter to a query]
       * @snippet [FilterMixin-gt_scenario.es6=Create a query, add a greater than filter, and run it]
       * @snippet [FilterMixin-gt_scenario_plus.es6=Create a query, add a greater than filter, and run it]
       * @memberof wix-data.WixDataFilter
       * @instance
       */
    }, {
      key: 'gt',
      value: function gt(field, value) {
        return this._AndLogicalEquivalence('$gt', '.gt', arguments);
      }

      /**
      * @function le
      * @syntax
      * function le(propertyName: string, value: string|number|date): WixDataQuery
      * @summary Refines a query or filter to match items whose specified property value is less than or equal to the specified value.
      * @param {external:String} propertyName The property whose value will be compared with `value`.
      * @param {external:String|external:Number|external:Date} value The value to match against.
      * @returns {wix-data.WixDataQuery} A `WixDataQuery` object representing the refined query.
      * @description
      *  The `le()` function refines a `WixDataQuery` or `WixDataFilter` to only match items where the value
      *  of the specified property is less than or equal to the specified `value`.
      *
      *  It only matches values of the same type. For example, a number value stored
      *  as a String type does not match the same number stored as a Number type.
      *
      *  If a property contains a number as a String, that value will be compared
      *  alphabetically and not numerically. Items that do not have a value for the
      *  specified property are ranked lowest.
      *
      *  The following types of items can be compared:
      *
      *  + Number: Compares numerically.
      *  + Date: Compares JavaScript Date objects.
      *  + String: Compares alphabetically. The sort is based on the JavaScript sort methodology, which is a lexicographical sort that compares Unicode characters by their code points.
      *  + Reference: Compares by the ID of the referenced item as a String.
      *
      *
      * @snippet [FilterMixin-le.es6=Add a less than or equals filter to a query]
      * @snippet [FilterMixin-le_scenario.es6=Create a query, add a less than or equals filter, and run it]
      * @snippet [FilterMixin-le_scenario_plus.es6=Create a query, add a less than or equals filter, and run it]
      * @memberof wix-data.WixDataFilter
      * @instance
       */
    }, {
      key: 'le',
      value: function le(field, value) {
        return this._AndLogicalEquivalence('$lte', '.le', arguments);
      }

      /**
      * @function lt
      * @syntax
      * function lt(propertyName: string, value: string|number|date): WixDataQuery
      * @summary Refines a query or filter to match items whose specified property value is less than the specified value.
      * @param {external:String} propertyName The property whose value will be compared with `value`.
      * @param {external:String|external:Number|external:Date} value The value to match against.
      * @returns {wix-data.WixDataQuery} A `WixDataQuery` object with the query definition, based on the supplied parameters.
      * @description
      *  The `lt()` function refines a `WixDataQuery` or `WixDataFilter` to only match items where the value
      *  of the specified property is less than the specified `value`.
      *
      *  It only matches values of the same type. For example, a number value stored
      *  as a String type does not match the same number stored as a Number type.
      *
      *  If a property contains a number as a String, that value will be compared
      *  alphabetically and not numerically. Items that do not have a value for the
      *  specified property are ranked lowest.
      *
      *  The following types of items can be compared:
      *
      *  + Number: Compares numerically.
      *  + Date: Compares JavaScript Date objects.
      *  + String: Compares alphabetically. The sort is based on the JavaScript sort methodology, which is a lexicographical sort that compares Unicode characters by their code points.
      *  + Reference: Compares by the ID of the referenced item as a String.
      *
      *
      * @snippet [FilterMixin-lt.es6=Add a less than filter to a query]
      * @snippet [FilterMixin-lt_scenario.es6=Create a query, add a less than filter, and run it]
      * @snippet [FilterMixin-lt_scenario_plus.es6=Create a query, add a less than filter, and run it]
      * @memberof wix-data.WixDataFilter
      * @instance
       */
    }, {
      key: 'lt',
      value: function lt(field, value) {
        return this._AndLogicalEquivalence('$lt', '.lt', arguments);
      }

      /**
       * @function isNotEmpty
       * @syntax
       * function isNotEmpty(propertyName: string): WixDataQuery
       * @summary Refines a query or filter to match items whose specified property has any value.
       * @param {external:String} propertyName The name of the property to check for a value.
       * @returns {wix-data.WixDataQuery} A `WixDataQuery` object representing the refined query.
       * @description
       *  The `isNotEmpty()` function refines a `WixDataQuery` or `WixDataFilter` to only match items where the
       *  value of the specified property is not `null` or `undefined`.
       *
       *  If the property contains any value at all for a given item, including the
       *  empty string or an invalid value, that item will match the query.
       * @snippet [FilterMixin-isNotEmpty.es6=Add an isNotEmpty filter to a query]
       * @snippet [FilterMixin-isNotEmpty_scenario.es6=Create a query, add an isNotEmpty filter, and run it]
       * @snippet [FilterMixin-isNotEmpty_scenario_plus.es6=Create a query, add an isNotEmpty filter, and run it]
       * @memberof wix-data.WixDataFilter
       * @instance
       */
    }, {
      key: 'isNotEmpty',
      value: function isNotEmpty(field) {
        var _filterValidator$arityIsOne$validFieldName$validateAndAggregate = this._filterValidator('.isNotEmpty').arityIsOne(arguments).validFieldName(field).validateAndAggregate(this.invalidArguments);

        var _filterValidator$arityIsOne$validFieldName$validateAndAggregate2 = _slicedToArray(_filterValidator$arityIsOne$validFieldName$validateAndAggregate, 2);

        var newInvalidArguments = _filterValidator$arityIsOne$validFieldName$validateAndAggregate2[0];
        var valid = _filterValidator$arityIsOne$validFieldName$validateAndAggregate2[1];

        if (valid) {
          return this.ne(field, null);
        }

        return this._copy(this.filterTree, newInvalidArguments);
      }

      /**
       * @function isEmpty
       * @syntax
       * function isEmpty(propertyName: string): WixDataQuery
       * @summary Refines a query or filter to match items whose specified property does not exist or does not have any value.
       * @param {external:String} propertyName The name of the property to check for a value.
       * @returns {wix-data.WixDataQuery} A `WixDataQuery` object representing the refined query.
       * @description
       *  The `isEmpty()` function refines a `WixDataQuery` or `WixDataFilter` to only match items where the
       *  value of the specified property is `null` or `undefined` or the property does
       *  not exist.
       *
       *  If the property contains any value at all for a given item, including the
       *  empty string or an invalid value, that item will match the query.
       * @snippet [FilterMixin-isEmpty.es6=Add an isEmpty filter to a query]
       * @snippet [FilterMixin-isEmpty_scenario.es6=Create a query, add an isEmpty filter, and run it]
       * @snippet [FilterMixin-isEmpty_scenario_plus.es6=Create a query, add an isEmpty filter, and run it]
       * @memberof wix-data.WixDataFilter
       * @instance
       */
    }, {
      key: 'isEmpty',
      value: function isEmpty(field) {
        var _filterValidator$arityIsOne$validFieldName$validateAndAggregate3 = this._filterValidator('.isEmpty').arityIsOne(arguments).validFieldName(field).validateAndAggregate();

        var _filterValidator$arityIsOne$validFieldName$validateAndAggregate32 = _slicedToArray(_filterValidator$arityIsOne$validFieldName$validateAndAggregate3, 2);

        var newInvalidArguments = _filterValidator$arityIsOne$validFieldName$validateAndAggregate32[0];
        var valid = _filterValidator$arityIsOne$validFieldName$validateAndAggregate32[1];

        if (valid) {
          return this.eq(field, null);
        }

        return this._copy(this.filterTree, newInvalidArguments);
      }

      /**
       * @function startsWith
       * @syntax
       * function startsWith(propertyName: string, string: string): WixDataQuery
       * @summary Refines a query or filter to match items whose specified property value starts with a specified string.
       * @param {external:String} propertyName The property whose value will be compared with the string.
       * @param {external:String} string  The string to look for at the beginning of the specified property value.
       * @returns {wix-data.WixDataQuery} A `WixDataQuery` object representing the refined query.
       * @description
       *  The `startsWith()` function refines a `WixDataQuery` or `WixDataFilter` to only match items where the value
       *  of the specified property starts with the defined `string`.
       *
       *  You can only use `startsWith()` with a property whose value is a String or Reference.
       *  When using a Reference, `startsWith()` matches by the ID of the referenced item as Strings.
       *
       * @snippet [FilterMixin-startsWith.es6=Add a starts with filter to a query]
       * @snippet [FilterMixin-startsWith_scenario.es6=Create a query, add a starts with filter, and run it]
       * @snippet [FilterMixin-startsWith_scenario_plus.es6=Create a query, add a starts with filter, and run it]
       * @memberof wix-data.WixDataFilter
       * @instance
       */
    }, {
      key: 'startsWith',
      value: function startsWith(field, value) {
        return this._AndStringOperand('$startsWith', '.startsWith', arguments);
      }

      /**
        * @function endsWith
        * @syntax
        * function endsWith(propertyName: string, string: string): WixDataQuery
        * @summary Refines a query or filter to match items whose specified property value ends with a specified string.
        * @param {external:String} propertyName The property whose value will be compared with the string.
        * @param {external:String} string  The string to look for at the beginning of the specified property value.
        * @returns {wix-data.WixDataQuery} A `WixDataQuery` object representing the refined query.
        * @description
        *  The `endsWith()` function refines a `WixDataQuery` or `WixDataFilter` to only match items where the value
        *  of the specified property ends with the specified `string`.
        *
        *  You can only use `endsWith()` with a property whose value is a String or Reference.
        *  When using a Reference, `endsWith()` matches by the ID of the referenced item as Strings.
        *
        * @snippet [FilterMixin-endsWith.es6=Add an ends with filter to a query]
        * @snippet [FilterMixin-endsWith_scenario.es6=Create a query, add an ends with filter, and run it]
        * @snippet [FilterMixin-endsWith_scenario_plus.es6=Create a query, add an ends with filter, and run it]
        * @memberof wix-data.WixDataFilter
        * @instance
        */
    }, {
      key: 'endsWith',
      value: function endsWith(field, value) {
        return this._AndStringOperand('$endsWith', '.endsWith', arguments);
      }

      /**
        * @function contains
        * @syntax
        * function contains(propertyName: string, string: string): WixDataQuery
        * @summary Refines a query or filter to match items whose specified property value contains a specified string.
        * @param {external:String} propertyName The property whose value will be compared with the string.
        * @param {external:String} string  The string to look for inside the specified property value.
        * @returns {wix-data.WixDataQuery} A `WixDataQuery` object representing the refined query.
        * @description
        *  The `contains()` function refines a `WixDataQuery` or `WixDataFilter` to only match items where the value
        *  of the specified property contains the specified `string`.
        *
        *  You can only use `contains()` with a property whose value is a String or Reference.
        *  When using a Reference, `contains()` matches by the ID of the referenced item as Strings.
        *
        * @snippet [FilterMixin-contains.es6=Add a contains filter to a query]
        * @snippet [FilterMixin-contains_scenario.es6=Create a query, add a contains filter, and run it]
        * @snippet [FilterMixin-contains_scenario_plus.es6=Create a query, add a contains filter, and run it]
        * @memberof wix-data.WixDataFilter
        * @instance
        */
    }, {
      key: 'contains',
      value: function contains(field, value) {
        return this._AndStringOperand('$contains', '.contains', arguments);
      }

      /**
       * @function hasSome
       * @syntax
       * function hasSome(propertyName: string, ...value: *): WixDataQuery
       * @summary Refines a query or filter to match items whose specified property value equals any of the specified `value` parameters.
       * @param {external:String} propertyName The name of the property whose value will be compared with `value`.
       * @param {...external:String|external:Number|external:Date|external:Array} value The values to match against.
       * @returns {wix-data.WixDataQuery} A `WixDataQuery` object representing the refined query.
       * @description
       *  The `hasSome()` function refines a `WixDataQuery` or `WixDataFilter` to
       *  only match items where the value of the specified property equals any of
       *  the specified values.
       *
       *  If the value of the specified property is an array, `hasSome()` will match
       *  if any of the elements of that array match any of the specified values.
       *
       *  You can specify a list of values to match by providing comma-separated
       *  String, Number, or Date types as the `value` parameters. You can also
       *  specify a list of these values by including them in an array and providing
       *  the array as the `value`.
       *
       * @snippet [FilterMixin-hasSome.es6=Add a has some filter to a query]
       * @snippet [FilterMixin-hasSome_scenario.es6=Create a query, add a has some filter, and run it]
       * @snippet [FilterMixin-hasSome_scenario_plus.es6=Create a query, add a has some filter, and run it]
       * @memberof wix-data.WixDataFilter
       * @instance
       */
    }, {
      key: 'hasSome',
      value: function hasSome(field, values) {
        return this._AndSetOperand('$hasSome', '.hasSome', arguments);
      }

      /**
       * @function hasAll
       * @syntax
       * function hasAll(propertyName: string, ...value: *): WixDataQuery
       * @summary Refines a query or filter to match items whose specified property values equals all of the specified `value` parameters.
       * @param {external:String} propertyName The name of the property whose value will be compared with `value`.
       * @param {...external:String|external:Number|external:Date|external:Array} value The values to match against.
       * @returns {wix-data.WixDataQuery} A `WixDataQuery` object representing the refined query.
       * @description
       *  The `hasAll()` function refines a `WixDataQuery` or `WixDataFilter` to
       *  only match items where the value of the specified property equals all of
       *  the specified values.
       *
       *  If the value of the specified property is an array, `hasAll()` will match
       *  if there is a match in the elements of that array for all of the specified
       *  values.
       *
       *  You can specify a list of values to match by providing comma-separated
       *  String, Number, or Date types as the `value` parameters. You can also
       *  specify a list of these values by including them in an array and providing
       *  the array as the `value`.
       * @snippet [FilterMixin-hasAll.es6=Add a has all filter to a query]
       * @snippet [FilterMixin-hasAll_scenario.es6=Create a query, add a has all filter, and run it]
       * @snippet [FilterMixin-hasAll_scenario_plus.es6=Create a query, add a has all filter, and run it]
       * @memberof wix-data.WixDataFilter
       * @instance
       */
    }, {
      key: 'hasAll',
      value: function hasAll(field, values) {
        return this._AndSetOperand('$hasAll', '.hasAll', arguments);
      }

      /*eslint no-unused-vars: 0*/

      /**
       * @function or
       * @syntax
       * function or(query WixDataQuery): WixDataQuery
       * @summary Adds an `or` condition to the query or filter.
       * @param {wix-data.WixDataQuery} query A query to add to the initial query as an `or` condition.
       * @returns {wix-data.WixDataQuery} A `WixDataQuery` object representing the refined query.
       * @description
       *  The `or()` function adds an inclusive `or` condition to a `WixDataQuery` or `WixDataFilter`. A query or filter
       *  with an `or` returns all the items that match the query or filter as defined up to
       *  the `or` function, the items that match the query or filter passed to the `or`
       *  function, and the items that match both.
       *
       *  If the query or filter only contains an `or()` function, it returns all the items in the collection.
       *
       *  The collections referenced by both the initial query and the query passed
       *  to the `or` function must be the same.
       * @snippet [FilterMixin-or.es6=Add an or to a query]
       * @snippet [FilterMixin-or_scenario.es6=Create a query, add an or, and run it]
       * @memberof wix-data.WixDataFilter
       * @instance
       */
    }, {
      key: 'or',
      value: function or(otherQuery) {
        var _filterValidator$arityIsOne$isInstanceOfSameClass$isForCollection$validateAndAggregate = this._filterValidator('.or').arityIsOne(arguments).isInstanceOfSameClass(otherQuery).isForCollection(otherQuery, this.collectionName).validateAndAggregate();

        var _filterValidator$arityIsOne$isInstanceOfSameClass$isForCollection$validateAndAggregate2 = _slicedToArray(_filterValidator$arityIsOne$isInstanceOfSameClass$isForCollection$validateAndAggregate, 2);

        var newInvalidArguments = _filterValidator$arityIsOne$isInstanceOfSameClass$isForCollection$validateAndAggregate2[0];
        var valid = _filterValidator$arityIsOne$isInstanceOfSameClass$isForCollection$validateAndAggregate2[1];

        if (valid) {
          return this._copy(inAnd({ '$or': [this.filterTree, otherQuery.filterTree] }), newInvalidArguments.concat(otherQuery.invalidArguments));
        } else {
          return this._copy(this.filterTree, newInvalidArguments);
        }
      }

      /**
       * @function not
       * @syntax
       * function not(query WixDataQuery): WixDataQuery
       * @summary Adds a `not` condition to the query or filter.
       * @param {wix-data.WixDataQuery} query A query to add to the initial query as a `not` condition.
       * @returns {wix-data.WixDataQuery} A `WixDataQuery` object representing the refined query.
       * @description
       *  The `not()` function adds a `not` condition to a `WixDataQuery` or `WixDataFilter`. A query or filter with a `not`
       *  returns all the items that match the query or filter as defined up to the `not`
       *  function, but don't match the query or filter passed to the `not` function.
       *
       *  If the query or filter only contains a `not()` function, it returns all the items
       *  that don't match the query defined by the `not` method.
       *
       *  The collections referenced by both the initial query and the query passed
       *  to the `not` function must be the same.
       * @snippet [FilterMixin-not.es6=Add a not to a query]
       * @snippet [FilterMixin-not_scenario.es6=Create a query, add a not, and run it]
       * @memberof wix-data.WixDataFilter
       * @instance
       */

    }, {
      key: 'not',
      value: function not(otherQuery) {
        var _filterValidator$arityIsOne$isInstanceOfSameClass$isForCollection$validateAndAggregate3 = this._filterValidator('.not').arityIsOne(arguments).isInstanceOfSameClass(otherQuery).isForCollection(otherQuery, this.collectionName).validateAndAggregate();

        var _filterValidator$arityIsOne$isInstanceOfSameClass$isForCollection$validateAndAggregate32 = _slicedToArray(_filterValidator$arityIsOne$isInstanceOfSameClass$isForCollection$validateAndAggregate3, 2);

        var newInvalidArguments = _filterValidator$arityIsOne$isInstanceOfSameClass$isForCollection$validateAndAggregate32[0];
        var valid = _filterValidator$arityIsOne$isInstanceOfSameClass$isForCollection$validateAndAggregate32[1];

        if (valid) {
          var newFilterTree = (0, _utilsClone2['default'])(this.filterTree);
          var notClause = { '$not': [otherQuery.filterTree] };
          var resultingFilter = inAndOptimized(newFilterTree, notClause);

          return this._copy(resultingFilter, newInvalidArguments.concat(otherQuery.invalidArguments));
        } else {
          return this._copy(this.filterTree, newInvalidArguments);
        }
      }

      /**
      * @function between
      * @syntax
      * function between(propertyName: string, rangeStart: string|number|date,
      *   rangeEnd: string|number|date): WixDataQuery
      * @summary Refines a query or filter to match items whose specified property value is within a specified range.
      * @param {external:String} propertyName The property whose value will be compared with `rangeStart` and `rangeEnd`.
      * @param {external:String|external:Number|external:Date} rangeStart The beginning value of the range to match against.
      * @param {external:String|external:Number|external:Date} rangeEnd The ending value of the range to match against.
      * @returns {wix-data.WixDataQuery} A `WixDataQuery` object representing the refined query.
      * @description
      *  The `between()` function refines a `WixDataQuery` or `WixDataFilter` to only match items where the value
      *  of the specified property is greater than or equal to `rangeStart` and less
      *  than or equal to `rangeEnd`.
      *
      *  It only matches values of the same type. For example, a number value stored
      *  as a String type does not match the same number stored as a Number type.
      *
      *  If a property contains a number as a String, that value will be compared
      *  alphabetically and not numerically. Items that do not have a value for the
      *  specified property are ranked lowest.
      *
      *  The following types of items can be compared:
      *
      *  + Number: Compares numerically.
      *  + Date: Compares JavaScript Date objects.
      *  + String: Compares alphabetically. The sort is based on the JavaScript sort methodology, which is a lexicographical sort that compares Unicode characters by their code points.
      *
      *
      * @snippet [FilterMixin-between.es6=Add a between filter to a query]
      * @snippet [FilterMixin-between_scenario.es6=Create a query, add a between filter, and run it]
      * @snippet [FilterMixin-between_scenario_plus.es6=Create a query, add a between filter, and run it]
      * @memberof wix-data.WixDataFilter
      * @instance
       */

    }, {
      key: 'between',
      value: function between(field, rangeStart, rangeEnd) {
        var _filterValidator$arityIsThree$sameType$typeIsStringNumberOrDate$typeIsStringNumberOrDate$validateAndAggregate = this._filterValidator('.between').arityIsThree(arguments).sameType(rangeStart, rangeEnd).typeIsStringNumberOrDate(rangeStart).typeIsStringNumberOrDate(rangeEnd).validateAndAggregate();

        var _filterValidator$arityIsThree$sameType$typeIsStringNumberOrDate$typeIsStringNumberOrDate$validateAndAggregate2 = _slicedToArray(_filterValidator$arityIsThree$sameType$typeIsStringNumberOrDate$typeIsStringNumberOrDate$validateAndAggregate, 2);

        var newInvalidArguments = _filterValidator$arityIsThree$sameType$typeIsStringNumberOrDate$typeIsStringNumberOrDate$validateAndAggregate2[0];
        var valid = _filterValidator$arityIsThree$sameType$typeIsStringNumberOrDate$typeIsStringNumberOrDate$validateAndAggregate2[1];

        if (valid) {
          return this.ge(field, rangeStart).lt(field, rangeEnd);
        }

        return this._copy(this.filterTree, newInvalidArguments);
      }

      // used only from data binding router internally
    }, {
      key: '_matchesUrlized',
      value: function _matchesUrlized(field, operand) {
        var _filterValidator$arityIsTwo$validFieldName$typeIsString$validateAndAggregate = this._filterValidator('._matchesUrlized').arityIsTwo(arguments).validFieldName(field).typeIsString(operand).validateAndAggregate();

        var _filterValidator$arityIsTwo$validFieldName$typeIsString$validateAndAggregate2 = _slicedToArray(_filterValidator$arityIsTwo$validFieldName$typeIsString$validateAndAggregate, 2);

        var newInvalidArguments = _filterValidator$arityIsTwo$validFieldName$typeIsString$validateAndAggregate2[0];
        var valid = _filterValidator$arityIsTwo$validFieldName$typeIsString$validateAndAggregate2[1];

        if (valid) {
          var newFilterTree = this._makeNewFilter.apply(this, [field].concat(_toConsumableArray(createMatchesOrInFilter(operand))));
          return this._copy(newFilterTree, newInvalidArguments);
        }

        return this._copy(this.filterTree, newInvalidArguments);
      }
    }, {
      key: '_binaryAnd',
      value: function _binaryAnd(filterOperatorSymbol, operatorName, args) {
        var _Array$prototype$slice$call = Array.prototype.slice.call(args);

        var _Array$prototype$slice$call2 = _slicedToArray(_Array$prototype$slice$call, 2);

        var field = _Array$prototype$slice$call2[0];
        var operand = _Array$prototype$slice$call2[1];

        var _filterValidator$arityIsTwo$validFieldName$validateAndAggregate = this._filterValidator(operatorName).arityIsTwo(args).validFieldName(field).validateAndAggregate();

        var _filterValidator$arityIsTwo$validFieldName$validateAndAggregate2 = _slicedToArray(_filterValidator$arityIsTwo$validFieldName$validateAndAggregate, 1);

        var newInvalidArguments = _filterValidator$arityIsTwo$validFieldName$validateAndAggregate2[0];

        var newFilterTree = this._makeNewFilter(field, filterOperatorSymbol, operand);

        return this._copy(newFilterTree, newInvalidArguments);
      }
    }, {
      key: '_AndLogicalEquivalence',
      value: function _AndLogicalEquivalence(filterOperatorSymbol, operatorName, args) {
        var _Array$prototype$slice$call3 = Array.prototype.slice.call(args);

        var _Array$prototype$slice$call32 = _slicedToArray(_Array$prototype$slice$call3, 2);

        var field = _Array$prototype$slice$call32[0];
        var operand = _Array$prototype$slice$call32[1];

        var _filterValidator$arityIsTwo$validFieldName$typeIsStringNumberOrDate$validateAndAggregate = this._filterValidator(operatorName).arityIsTwo(args).validFieldName(field).typeIsStringNumberOrDate(operand).validateAndAggregate();

        var _filterValidator$arityIsTwo$validFieldName$typeIsStringNumberOrDate$validateAndAggregate2 = _slicedToArray(_filterValidator$arityIsTwo$validFieldName$typeIsStringNumberOrDate$validateAndAggregate, 1);

        var newInvalidArguments = _filterValidator$arityIsTwo$validFieldName$typeIsStringNumberOrDate$validateAndAggregate2[0];

        var newFilterTree = this._makeNewFilter(field, filterOperatorSymbol, operand);
        return this._copy(newFilterTree, newInvalidArguments);
      }
    }, {
      key: '_AndStringOperand',
      value: function _AndStringOperand(filterOperatorName, operatorName, args) {
        var _Array$prototype$slice$call4 = Array.prototype.slice.call(args);

        var _Array$prototype$slice$call42 = _slicedToArray(_Array$prototype$slice$call4, 2);

        var field = _Array$prototype$slice$call42[0];
        var operand = _Array$prototype$slice$call42[1];

        var _filterValidator$arityIsTwo$validFieldName$typeIsString$validateAndAggregate3 = this._filterValidator(operatorName).arityIsTwo(args).validFieldName(field).typeIsString(operand).validateAndAggregate();

        var _filterValidator$arityIsTwo$validFieldName$typeIsString$validateAndAggregate32 = _slicedToArray(_filterValidator$arityIsTwo$validFieldName$typeIsString$validateAndAggregate3, 1);

        var newInvalidArguments = _filterValidator$arityIsTwo$validFieldName$typeIsString$validateAndAggregate32[0];

        var newFilterTree = this._makeNewFilter(field, filterOperatorName, operand);

        return this._copy(newFilterTree, newInvalidArguments);
      }
    }, {
      key: '_AndSetOperand',
      value: function _AndSetOperand(filterOperatorName, operatorName, args) {
        var _Array$prototype$slice$call5 = Array.prototype.slice.call(args);

        var _Array$prototype$slice$call52 = _toArray(_Array$prototype$slice$call5);

        var field = _Array$prototype$slice$call52[0];

        var rawOperands = _Array$prototype$slice$call52.slice(1);

        var operands = (0, _sharedTypeUtils.isArray)(rawOperands[0]) ? rawOperands[0] : rawOperands;

        var _filterValidator$arityIsAtLeastTwo$validFieldName$typeIsStringNumberOrDateForAll$validateAndAggregate = this._filterValidator(operatorName).arityIsAtLeastTwo(args).validFieldName(field).typeIsStringNumberOrDateForAll(operands).validateAndAggregate();

        var _filterValidator$arityIsAtLeastTwo$validFieldName$typeIsStringNumberOrDateForAll$validateAndAggregate2 = _slicedToArray(_filterValidator$arityIsAtLeastTwo$validFieldName$typeIsStringNumberOrDateForAll$validateAndAggregate, 1);

        var newInvalidArguments = _filterValidator$arityIsAtLeastTwo$validFieldName$typeIsStringNumberOrDateForAll$validateAndAggregate2[0];

        var newFilterTree = this._makeNewFilter(field, filterOperatorName, operands);
        return this._copy(newFilterTree, newInvalidArguments);
      }
    }, {
      key: '_makeNewFilter',
      value: function _makeNewFilter(field, filterOperatorName, operand) {
        var newFilterTree = (0, _utilsClone2['default'])(this.filterTree);

        var newFilter = this._buildFilter(field, filterOperatorName, operand);

        if ((0, _sharedTypeUtils.isArray)(newFilterTree['$and'])) {
          newFilterTree['$and'].push(newFilter);
          return newFilterTree;
        } else {
          var result = isEmptyObject(newFilterTree) ? inAnd(newFilter) : inAnd(newFilterTree, newFilter);
          return result;
        }
      }
    }, {
      key: '_buildFilter',
      value: function _buildFilter(field, filterOperatorName, operand) {
        if (filterOperatorName !== '$eq') {
          var newFilter = {};
          newFilter[field] = {};
          newFilter[field][filterOperatorName] = this._replaceRefs(operand);
          return newFilter;
        } else {
          var newFilter = {};
          newFilter[field] = this._replaceRefs(operand);
          return newFilter;
        }
      }
    }, {
      key: '_replaceRefs',
      value: function _replaceRefs(operand) {
        var _this = this;

        if (operand instanceof _ref.Ref) {
          return operand.id;
        } else if ((0, _sharedTypeUtils.isArray)(operand)) {
          return operand.map(function (operand) {
            return _this._replaceRefs(operand);
          });
        } else {
          return operand;
        }
      }
    }, {
      key: '_copy',
      value: function _copy(filterTree, invalidArguments) {
        return new this.constructor(Object.assign({}, this, {
          filterTree: filterTree,
          invalidArguments: invalidArguments
        }));
      }
    }, {
      key: '_filterValidator',
      value: function _filterValidator(filterOperatorName) {
        return new FilterValidator(filterOperatorName, this.invalidArguments, this.constructor, this.constructorName);
      }
    }]);

    return _class2;
  })(Base);
};

function createMatchesOrInFilter(operand) {
  if (looksLikeAnInteger(operand)) {
    return ['$in', [operand, Number.parseInt(operand)]];
  } else {
    return ['$matches', {
      ignoreCase: true,
      spec: createMatchSpec(operand)
    }];
  }

  function looksLikeAnInteger(str) {
    return (/^-?[0-9]{1,16}$/.test(str)
    );
  }
}

function createMatchSpec(fieldValue) {
  var literals = fieldValue.split('-');
  var result = [];

  for (var i = 0; i < literals.length - 1; i++) {
    appendLiteralSegment(result, literals[i]);
    appendAnyOfSegment(result);
  }
  appendLiteralSegment(result, literals[literals.length - 1]);

  return result;

  function appendLiteralSegment(result, literalValue) {
    if (literalValue.length !== 0) {
      result.push({ type: 'literal', value: literalValue });
    }
  }

  function appendAnyOfSegment(result) {
    result.push({ type: 'anyOf', value: ' -' });
  }
}

function isConjunctiveFormFilter(filterTree) {
  return (0, _sharedTypeUtils.isArray)(filterTree['$and']);
}

function isEmptyObject(obj) {
  return Object.keys(obj).length === 0;
}

function inAnd() {
  return {
    '$and': [].concat(_slice.call(arguments))
  };
}

function inAndOptimized() {
  return {
    '$and': [].concat(_slice.call(arguments)).reduce(function (aggr, val) {
      return isConjunctiveFormFilter(val) ? aggr.concat(val['$and']) : aggr.concat([val]);
    }, [])
  };
}

var FilterValidator = (function (_AggregatingValidator) {
  _inherits(FilterValidator, _AggregatingValidator);

  function FilterValidator(operatorName, previousInvalidArguments, ctor, constructorName) {
    _classCallCheck(this, FilterValidator);

    _get(Object.getPrototypeOf(FilterValidator.prototype), 'constructor', this).call(this, previousInvalidArguments);
    this.operatorName = operatorName;
    this.ctor = ctor;
    this.constructorName = constructorName;
  }

  _createClass(FilterValidator, [{
    key: 'typeIsString',
    value: function typeIsString(value) {
      var _this2 = this;

      return this.addValidation(function () {
        return (0, _sharedTypeUtils.isString)(value);
      }, function () {
        return _errors.messages.filterValidations.typeIsString(_this2.operatorName, value);
      });
    }
  }, {
    key: 'typeIsStringNumberOrDate',
    value: function typeIsStringNumberOrDate(value) {
      var _this3 = this;

      return this.addValidation(function () {
        return isDateStringOrNumber(value);
      }, function () {
        return _errors.messages.filterValidations.typeIsStringNumberOrDate(_this3.operatorName, value);
      });
    }
  }, {
    key: 'sameType',
    value: function sameType(first, second) {
      var _this4 = this;

      return this.addValidation(function () {
        return (0, _sharedTypeUtils.typeForDisplay)(first) === (0, _sharedTypeUtils.typeForDisplay)(second);
      }, function () {
        return _errors.messages.filterValidations.sameType(_this4.operatorName, first, second);
      });
    }
  }, {
    key: 'typeIsStringNumberOrDateForAll',
    value: function typeIsStringNumberOrDateForAll(values) {
      var _this5 = this;

      return this.addValidation(function () {
        return values.every(isDateStringOrNumber);
      }, function () {
        return _errors.messages.filterValidations.typeIsStringNumberOrDateForAll(_this5.operatorName);
      });
    }
  }, {
    key: 'validFieldName',
    value: function validFieldName(field) {
      var _this6 = this;

      return this.addValidation(function () {
        return (0, _sharedTypeUtils.isString)(field);
      }, function () {
        return _errors.messages.filterValidations.validFieldName(_this6.operatorName, field);
      });
    }
  }, {
    key: 'isInstanceOfSameClass',
    value: function isInstanceOfSameClass(obj) {
      var _this7 = this;

      return this.addValidation(function () {
        return obj instanceof _this7.ctor;
      }, function () {
        return _errors.messages.filterValidations.isInstanceOfSameClass(_this7.operatorName, _this7.constructorName, obj);
      });
    }
  }, {
    key: 'isForCollection',
    value: function isForCollection(otherFilterBuilder, expectedCollectionName) {
      var _this8 = this;

      return this.addValidation(function () {
        return otherFilterBuilder.collectionName === expectedCollectionName;
      }, function () {
        return _errors.messages.filterValidations.isForCollection(_this8.operatorName, _this8.constructorName, otherFilterBuilder.collectionName);
      });
    }
  }]);

  return FilterValidator;
})(_utilsBaseValidator.AggregatingValidator);

function isDateStringOrNumber(value) {
  return (0, _sharedTypeUtils.isString)(value) || (0, _sharedTypeUtils.isNumber)(value) || (0, _sharedTypeUtils.isDate)(value);
}

exports['default'] = filterMixin;
module.exports = exports['default'];

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});

var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x3, _x4, _x5) { var _again = true; _function: while (_again) { var object = _x3, property = _x4, receiver = _x5; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x3 = parent; _x4 = property; _x5 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var _sharedTypeUtils = __webpack_require__(14);

var _utilsClone = __webpack_require__(37);

var _utilsClone2 = _interopRequireDefault(_utilsClone);

var _utilsBaseValidator = __webpack_require__(40);

var _errors = __webpack_require__(9);

/**
 * @class WixDataSort
 * @description Provides functionality for sorting a query.
 * @memberof wix-data
 */
var sortMixin = function sortMixin() {
  var Base = arguments.length <= 0 || arguments[0] === undefined ? (function () {
    function _class() {
      _classCallCheck(this, _class);
    }

    return _class;
  })() : arguments[0];
  return (function (_Base) {
    _inherits(_class2, _Base);

    function _class2() {
      var obj = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

      _classCallCheck(this, _class2);

      _get(Object.getPrototypeOf(_class2.prototype), 'constructor', this).call(this, obj);
      this.orderBy = obj.orderBy || [];
      this.invalidArguments = obj.invalidArguments || [];
    }

    /**
     * @function ascending
     * @syntax
     * function ascending(...propertyName: String): WixDataQuery
     * @summary Adds a sort to a query or sort, sorting by the specified properties in ascending order.
     * @param {...external:String} propertyName The properties that will be used in the sort.
     * @returns {wix-data.WixDataQuery} A `WixDataQuery` object representing the refined query.
     * @description
     *  The `ascending()` function refines a `WixDataQuery` or `WixDataSort` to sort in ascending order of
     *  the specified properties. If you specify more than one property,
     *  `ascending()` sorts the results in ascending order by each property in the
     *  order they are listed.
     *
     *  You can sort the following types:
     *
     *  + Number: Sorts numerically.
     *  + Date: Sorts by date and time.
     *  + String: Sorts alphabetically. The sort is based on the JavaScript sort methodology, which is a lexicographical sort that compares Unicode characters by their code points.
     *  + Reference: Compares by the ID of the referenced item as a String.
     *
     *
     *  If a property contains a number as a String, that value will be sorted
     *  alphabetically and not numerically. Items that do not have a value for the
     *  specified sort property are ranked lowest.
     * @snippet [SortMixin-ascending.es6=Add an ascending sort to a query]
     * @snippet [SortMixin-ascending_scenario.es6=Create a query, add an ascending sort, and run it]
     * @snippet [SortMixin-ascending_scenario_plus.es6=Create a query, add an ascending sort, and run it]
     * @memberof wix-data.WixDataSort
     * @instance
     */

    _createClass(_class2, [{
      key: 'ascending',
      value: function ascending(fields) {
        return this._sortClause('asc', '.ascending', arguments);
      }

      /**
       * @function descending
       * @syntax
       * function descending(...propertyName: String): WixDataQuery
       * @summary Adds a sort to a query or sort, sorting by the specified properties in descending order.
       * @param {...external:String} propertyName The properties that will be used in the sort.
       * @returns {wix-data.WixDataQuery} A `WixDataQuery` object representing the refined query.
       * @description
       *  The `descending()` function refines a `WixDataQuery` or `WixDataSort` to sort in descending order of
       *  the specified properties. If you specify more than one property,
       *  `descending()` sorts the results in descending order by each property in the
       *  order they are listed.
       *
       *  You can sort the following types:
       *
       *  + Number: Sorts numerically.
       *  + Date: Sorts by date and time.
       *  + String: Sorts alphabetically. The sort is based on the JavaScript sort methodology, which is a lexicographical sort that compares Unicode characters by their code points.
       *  + Reference: Compares by the ID of the referenced item as a String.
       *
       *
       *  If a property contains a number as a String, that value will be sorted
       *  alphabetically and not numerically. Items that do not have a value for the
       *  specified sort property are ranked lowest.
       * @snippet [SortMixin-descending.es6=Add an descending sort to a query]
       * @snippet [SortMixin-descending_scenario.es6=Create a query, add an descending sort, and run it]
       * @snippet [SortMixin-descending_scenario_plus.es6=Create a query, add an descending sort, and run it]
       * @memberof wix-data.WixDataSort
       * @instance
       */
    }, {
      key: 'descending',
      value: function descending(fields) {
        return this._sortClause('desc', '.descending', arguments);
      }
    }, {
      key: '_sortClause',
      value: function _sortClause(operatorSymbol, operatorName, args) {
        var orderBy = [];
        if (this.orderBy) {
          orderBy = (0, _utilsClone2['default'])(this.orderBy);
        }

        var appendClause = createAppendClauseFn(orderBy, operatorSymbol);
        var effectiveArgs = (0, _sharedTypeUtils.isArray)(args[0]) && args.length === 1 ? args[0] : Array.prototype.slice.call(args, 0);

        var _sortValidator$arityIsAtLeastOne$allStrings$validateAndAggregate = this._sortValidator(operatorName).arityIsAtLeastOne(args).allStrings(effectiveArgs).validateAndAggregate();

        var _sortValidator$arityIsAtLeastOne$allStrings$validateAndAggregate2 = _slicedToArray(_sortValidator$arityIsAtLeastOne$allStrings$validateAndAggregate, 2);

        var newInvalidArguments = _sortValidator$arityIsAtLeastOne$allStrings$validateAndAggregate2[0];
        var valid = _sortValidator$arityIsAtLeastOne$allStrings$validateAndAggregate2[1];

        if (valid) {
          effectiveArgs.forEach(appendClause);
        }

        return new this.constructor(Object.assign({}, this, { orderBy: orderBy, invalidArguments: newInvalidArguments }));
      }
    }, {
      key: '_sortValidator',
      value: function _sortValidator(operatorName) {
        return new SortValidator(operatorName, this.invalidArguments);
      }
    }]);

    return _class2;
  })(Base);
};

function createAppendClauseFn(destination, direction) {
  return function (field) {
    var spec = {};
    spec[field] = direction;
    destination.push(spec);
  };
}

var SortValidator = (function (_AggregatingValidator) {
  _inherits(SortValidator, _AggregatingValidator);

  function SortValidator(operatorName, previousInvalidArguments) {
    _classCallCheck(this, SortValidator);

    _get(Object.getPrototypeOf(SortValidator.prototype), 'constructor', this).call(this, previousInvalidArguments);
    this.operatorName = operatorName;
  }

  _createClass(SortValidator, [{
    key: 'allStrings',
    value: function allStrings(effectiveArgs) {
      var _this = this;

      return this.addValidation(function () {
        return effectiveArgs.every(_sharedTypeUtils.isString);
      }, function () {
        return _errors.messages.sortValidations.typeIsStringOrArrayOfStrings(_this.operatorName, effectiveArgs);
      });
    }
  }]);

  return SortValidator;
})(_utilsBaseValidator.AggregatingValidator);

exports['default'] = sortMixin;
module.exports = exports['default'];

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

exports.apiValidator = apiValidator;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _errors = __webpack_require__(9);

var _typeUtils = __webpack_require__(14);

var _utilsBaseValidator = __webpack_require__(40);

var ApiValidator = (function (_RejectingValidator) {
  _inherits(ApiValidator, _RejectingValidator);

  function ApiValidator() {
    _classCallCheck(this, ApiValidator);

    _get(Object.getPrototypeOf(ApiValidator.prototype), 'constructor', this).apply(this, arguments);
  }

  _createClass(ApiValidator, [{
    key: 'arity',
    value: function arity(method, args, from, to) {
      return this.addValidation(function () {
        return args.length <= to && args.length >= from;
      }, function () {
        return _errors.messages.invalidArgumentLength(method, from, to, args.length);
      });
    }
  }, {
    key: '_isObject',
    value: function _isObject(item, collectionName) {
      return this.addValidation(function () {
        return (0, _typeUtils.isObject)(item);
      }, function () {
        return _errors.messages.itemMustBeAnObject(item, collectionName);
      });
    }
  }, {
    key: 'item',
    value: function item(_item, collectionName, requireId) {
      return this._isObject(_item, collectionName).addValidation(function () {
        return _item._id !== undefined ? (0, _typeUtils.isString)(_item._id) : !requireId;
      }, function () {
        return _errors.messages.updateItemInvalid();
      });
    }
  }, {
    key: 'items',
    value: function items(_items, collectionName) {
      return this.addValidation(function () {
        return (0, _typeUtils.isArray)(_items) && _items.every(function (item) {
          return (0, _typeUtils.isObject)(item) && (item._id === undefined || item._id === null || (0, _typeUtils.isString)(item._id));
        });
      }, function () {
        return _errors.messages.itemsMustBeArrayOfObjects(collectionName);
      }).addValidation(function () {
        return _items.length <= 1000;
      }, function () {
        return _errors.messages.itemsMustBeLessThanThousand(collectionName);
      });
    }
  }, {
    key: 'itemId',
    value: function itemId(_itemId) {
      return this.addValidation(function () {
        return (0, _typeUtils.isString)(_itemId);
      }, function () {
        return _errors.messages.itemIdMustBeAString();
      });
    }
  }, {
    key: '_options',
    value: function _options(options, flags) {
      return this.addValidation(function () {
        var validOptions = (0, _typeUtils.isObject)(options) && flags.every(function (flag) {
          return isBooleanIfDefined(options[flag]);
        });
        return options == null || validOptions;
      }, function () {
        return _errors.messages.optionsInvalid(flags);
      });
    }
  }, {
    key: 'referenceParameter',
    value: function referenceParameter(parameter) {
      return this.addValidation(function () {
        return (0, _typeUtils.isString)(parameter) || (0, _typeUtils.isObject)(parameter) && parameter.hasOwnProperty('_id');
      }, _errors.messages.referenceOperationParameterError);
    }
  }, {
    key: 'options',
    value: function options(_options2) {
      return this._options(_options2, ['suppressAuth', 'suppressHooks']);
    }
  }, {
    key: 'bulkInsertOptions',
    value: function bulkInsertOptions(options) {
      return this._options(options, ['suppressAuth', 'suppressHooks', 'overrideExisting']);
    }
  }, {
    key: 'collectionName',
    value: function collectionName(_collectionName) {
      return this.addValidation(function () {
        return (0, _typeUtils.isString)(_collectionName);
      }, function () {
        return _errors.messages.collectionNameMustBeAString();
      });
    }
  }, {
    key: 'filter',
    value: function filter(_filter) {
      return this.addValidation(function () {
        return (0, _typeUtils.isNull)(_filter) || (0, _typeUtils.isUndefined)(_filter) || (0, _typeUtils.isObject)(_filter);
      }, function () {
        return _errors.messages.filterMustBeAnObject();
      });
    }
  }]);

  return ApiValidator;
})(_utilsBaseValidator.RejectingValidator);

function apiValidator() {
  return new ApiValidator();
}

function isBooleanIfDefined(value) {
  return value == null || (0, _typeUtils.isBoolean)(value);
}

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__combineReducers__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__compose__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_warning__ = __webpack_require__(118);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createStore", function() { return __WEBPACK_IMPORTED_MODULE_0__createStore__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "combineReducers", function() { return __WEBPACK_IMPORTED_MODULE_1__combineReducers__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "bindActionCreators", function() { return __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "applyMiddleware", function() { return __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "compose", function() { return __WEBPACK_IMPORTED_MODULE_4__compose__["a"]; });







/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/
function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}



/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionTypes; });
/* harmony export (immutable) */ __webpack_exports__["b"] = createStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable__ = __webpack_require__(270);



/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT'

  /**
   * Creates a Redux store that holds the state tree.
   * The only way to change the data in the store is to call `dispatch()` on it.
   *
   * There should only be a single store in your app. To specify how different
   * parts of the state tree respond to actions, you may combine several reducers
   * into a single reducer function by using `combineReducers`.
   *
   * @param {Function} reducer A function that returns the next state tree, given
   * the current state tree and the action to handle.
   *
   * @param {any} [preloadedState] The initial state. You may optionally specify it
   * to hydrate the state from the server in universal apps, or to restore a
   * previously serialized user session.
   * If you use `combineReducers` to produce the root reducer function, this must be
   * an object with the same shape as `combineReducers` keys.
   *
   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
   * to enhance the store with third-party capabilities such as middleware,
   * time travel, persistence, etc. The only store enhancer that ships with Redux
   * is `applyMiddleware()`.
   *
   * @returns {Store} A Redux store that lets you read the state, dispatch actions
   * and subscribe to changes.
   */
};function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.INIT });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["a" /* default */]] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["a" /* default */]] = observable, _ref2;
}

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(269);




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) != objectTag) {
    return false;
  }
  var proto = Object(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["a"] = (isPlainObject);


/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(263);


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);


/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compose;
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var queuedFuncCreator = __webpack_require__(278);
var queueProperty = Symbol('queuedThunkQueue');

exports.queuedThunkMiddleware = function (extra) {
  var queuedFunc = queuedFuncCreator();
  return function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        if (typeof action !== 'function' || !action[queueProperty]) {
          return next(action);
        }
        var queueKey = action[queueProperty];

        return queuedFunc(function () {
          return action(dispatch, getState, extra);
        }, queueKey);
      };
    };
  };
};

exports.queueThunk = function (thunkFunc, queueKey) {
  var wrapperFunc = function wrapperFunc() {
    return thunkFunc.apply(undefined, arguments);
  };
  wrapperFunc[queueProperty] = queueKey;

  return wrapperFunc;
};

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var inRange_ = __webpack_require__(0).inRange;

var _require = __webpack_require__(10),
    matchAction = _require.matchAction;

var defaultDatasetConfiguration = __webpack_require__(125);
var actionTypes = __webpack_require__(42);

var _require2 = __webpack_require__(126),
    saveStates = _require2.saveStates,
    isNone = _require2.isNone,
    isError = _require2.isError;

var rootActions = __webpack_require__(43);

var initialRecordsState = {
  currentRecord: {
    index: undefined,
    data: undefined,
    fieldsToUpdate: undefined,
    updateSource: undefined
  },
  lastSavedRecord: {
    index: undefined,
    data: undefined
  },
  desiredIndex: undefined,
  refreshCurrentRecord: false,
  removeCurrentRecord: false,
  newRecordIndex: null,
  refreshCurrentView: false,
  revertChanges: false,
  saveState: saveStates.SAVE_STATE_NONE,
  defaultRecord: undefined,
  page: {
    numPagesToShow: 1,
    offset: 0,
    size: defaultDatasetConfiguration.pageSize
  },
  schema: undefined
};
var getDefaultDraft = function getDefaultDraft(state) {
  return Object.assign({}, state.defaultRecord);
};

var isIndexInView = function isIndexInView(index, state) {
  return inRange_(index, getPaginationData(state).offset, getPaginationData(state).offset + getPaginationData(state).size);
};

var isCurrentIndexInView = function isCurrentIndexInView(state) {
  return isIndexInView(selectCurrentRecordIndex(state), state);
};

var setCurrentRecord = function setCurrentRecord(state, index, record) {
  var newState = Object.assign({}, state, {
    currentRecord: { index: index, data: record },
    desiredIndex: index,
    refreshCurrentRecord: false
  });

  return isCurrentIndexInView(newState) ? newState : Object.assign({}, newState, {
    page: Object.assign({}, newState.page, {
      offset: Math.floor(newState.currentRecord.index / newState.page.size) * newState.page.size,
      numPagesToShow: 1
    })
  });
};

module.exports = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialRecordsState;
  var action = arguments[1];

  switch (action.type) {
    case actionTypes.SET_CURRENT_RECORD:
      {
        var recordIndex = action.recordIndex,
            record = action.record;

        return setCurrentRecord(state, recordIndex, record);
      }

    case actionTypes.NEW_RECORD:
      {
        return Object.assign({}, state, {
          newRecordIndex: action.atIndex
        });
      }

    case actionTypes.NEW_RECORD_RESULT:
      {
        return matchAction(action, {
          Error: function Error() {
            return Object.assign({}, state, {
              newRecordIndex: null
            });
          },
          Ok: function Ok(record) {
            return Object.assign({}, setCurrentRecord(state, state.newRecordIndex, record), {
              newRecordIndex: null
            });
          }
        });
      }

    case actionTypes.UPDATE_FIELDS:
      {
        var fieldsToUpdate = action.fieldsToUpdate,
            updateSource = action.updateSource;


        return Object.assign({}, state, {
          currentRecord: Object.assign({}, state.currentRecord, {
            fieldsToUpdate: fieldsToUpdate,
            updateSource: updateSource
          })
        });
      }

    case actionTypes.GO_TO_INDEX:
      {
        return Object.assign({}, state, {
          desiredIndex: action.index,
          refreshCurrentRecord: true
        });
      }

    case actionTypes.GET_RECORD_BY_INDEX_RESULT:
      {
        return matchAction(action, {
          Error: function Error() {
            return Object.assign({}, state, {
              desiredIndex: state.currentRecord.index,
              refreshCurrentRecord: false
            });
          },
          Ok: function Ok(_ref) {
            var index = _ref.index,
                record = _ref.record;

            return setCurrentRecord(state, index, record);
          }
        });
      }

    case actionTypes.REFRESH_CURRENT_RECORD:
      {
        return Object.assign({}, state, { refreshCurrentRecord: true });
      }

    case actionTypes.REMOVE_CURRENT_RECORD:
      {
        return Object.assign({}, state, { removeCurrentRecord: true });
      }

    case actionTypes.REMOVE_CURRENT_RECORD_RESULT:
      {
        return matchAction(action, {
          Error: function Error() {
            return Object.assign({}, state, {
              removeCurrentRecord: false
            });
          },
          Ok: function Ok() {
            return Object.assign({}, state, {
              removeCurrentRecord: false,
              refreshCurrentRecord: true
            });
          }
        });
      }

    case actionTypes.REFRESH_CURRENT_VIEW:
      {
        return Object.assign({}, state, { refreshCurrentView: true });
      }

    case actionTypes.CURRENT_VIEW_UPDATED:
      {
        return Object.assign({}, state, { refreshCurrentView: false });
      }

    case actionTypes.REVERT_CHANGES:
      {
        return Object.assign({}, state, { revertChanges: true });
      }

    case actionTypes.RECORD_REVERTED:
      {
        return Object.assign({}, state, { revertChanges: false });
      }

    case actionTypes.SET_DEFAULT_RECORD:
      {
        var _record = action.record;


        return Object.assign({}, state, { defaultRecord: _record });
      }

    case rootActions.actionTypes.SET_CONTROLLER_CONFIG:
      {
        var pageSize = action.config.pageSize;

        return Object.assign({}, state, {
          page: Object.assign({}, state.page, {
            size: pageSize || state.page.size
          })
        });
      }

    case rootActions.actionTypes.SET_PAGINATION_DATA:
      {
        var newState = Object.assign({}, state, {
          page: Object.assign({}, state.page, action.paginationData)
        });

        return isCurrentIndexInView(newState) ? newState : Object.assign({}, newState, {
          desiredIndex: newState.page.offset,
          refreshCurrentRecord: true
        });
      }

    case actionTypes.GO_TO_NEXT_PAGE:
      {
        var paginationData = getPaginationData(state);
        var currentPageSize = getCurrentPageSize(state);
        var offset = paginationData.offset + currentPageSize;

        var _newState = Object.assign({}, state, {
          page: Object.assign({}, state.page, {
            numPagesToShow: 1,
            offset: offset
          })
        });

        return isCurrentIndexInView(_newState) ? _newState : Object.assign({}, _newState, {
          desiredIndex: _newState.page.offset,
          refreshCurrentRecord: true
        });
      }

    case actionTypes.GO_TO_PREVIOUS_PAGE:
      {
        var _paginationData = getPaginationData(state);
        var _offset = Math.max(0, _paginationData.offset - _paginationData.size);

        var _newState2 = Object.assign({}, state, {
          page: Object.assign({}, state.page, {
            numPagesToShow: 1,
            offset: _offset
          })
        });

        return isCurrentIndexInView(_newState2) ? _newState2 : Object.assign({}, _newState2, {
          desiredIndex: _newState2.page.offset,
          refreshCurrentRecord: true
        });
      }

    case actionTypes.LOAD_PAGE:
      {
        var _getPaginationData = getPaginationData(state),
            size = _getPaginationData.size;

        var _newState3 = Object.assign({}, state, {
          page: Object.assign({}, state.page, {
            numPagesToShow: 1,
            offset: size * (action.pageNumber - 1)
          })
        });

        return isCurrentIndexInView(_newState3) ? _newState3 : Object.assign({}, _newState3, {
          desiredIndex: _newState3.page.offset,
          refreshCurrentRecord: true
        });
      }

    case actionTypes.INCREMENT_NUM_PAGES_TO_SHOW:
      {
        return Object.assign({}, state, {
          page: Object.assign({}, state.page, {
            numPagesToShow: state.page.numPagesToShow + 1
          })
        });
      }

    case actionTypes.SAVE_RECORD:
      {
        if (isNone(state.saveState) || isError(state.saveState)) {
          return Object.assign({}, state, {
            saveState: saveStates.SAVE_STATE_CALL_BEFORE_SAVE_HOOKS,
            lastSavedRecord: {
              index: undefined,
              data: undefined
            }
          });
        }
        return state;
      }

    case actionTypes.CALL_BEFORE_SAVE_HOOKS_RESULT:
      {
        return matchAction(action, {
          Error: function Error() {
            return Object.assign({}, state, { saveState: saveStates.SAVE_STATE_NONE });
          },
          Ok: function Ok() {
            return Object.assign({}, state, {
              saveState: saveStates.SAVE_STATE_CHECK_HAS_DRAFT
            });
          }
        });
      }

    case actionTypes.CHECK_HAS_DRAFT_RESULT:
      {
        return matchAction(action, {
          Error: function Error() {
            return Object.assign({}, state, { saveState: saveStates.SAVE_STATE_ERROR });
          },
          Ok: function Ok(hasDraft) {
            return Object.assign({}, state, {
              saveState: hasDraft ? saveStates.SAVE_STATE_ASSERT_VALIDITY : saveStates.SAVE_STATE_NONE
            });
          }
        });
      }

    case actionTypes.ASSERT_VALIDITY_RESULT:
      {
        return matchAction(action, {
          Error: function Error() {
            return Object.assign({}, state, { saveState: saveStates.SAVE_STATE_NONE });
          },
          Ok: function Ok() {
            return Object.assign({}, state, {
              saveState: saveStates.SAVE_STATE_SAVE_RECORD
            });
          }
        });
      }

    case actionTypes.SAVE_RECORD_RESULT:
      {
        return matchAction(action, {
          Error: function Error() {
            return Object.assign({}, state, { saveState: saveStates.SAVE_STATE_ERROR });
          },
          Ok: function Ok(savedRecord) {
            return Object.assign({}, state, {
              saveState: saveStates.SAVE_STATE_NONE,
              lastSavedRecord: {
                index: state.currentRecord.index,
                data: savedRecord
              }
            });
          }
        });
      }

    default:
      return state;
  }
};

var getCurrentPageSize = function getCurrentPageSize(state) {
  return state.page.size;
};
var getNumberOfPagesToShow = function getNumberOfPagesToShow(state) {
  return state.page.numPagesToShow;
};
var getPaginationData = function getPaginationData(state) {
  return state.page;
};
var getCurrentPage = function getCurrentPage(state) {
  return state.page.offset / getCurrentPageSize(state) + getNumberOfPagesToShow(state);
};
var hasCurrentRecord = function hasCurrentRecord(state) {
  return !!selectCurrentRecord(state);
};
var selectCurrentRecord = function selectCurrentRecord(state) {
  return state.currentRecord.data;
};
var selectCurrentRecordIndex = function selectCurrentRecordIndex(state) {
  return state.currentRecord.index;
};
var selectDesiredRecordIndex = function selectDesiredRecordIndex(state) {
  return state.desiredIndex;
};
var selectFieldsToUpdate = function selectFieldsToUpdate(state) {
  return state.currentRecord.fieldsToUpdate;
};
var selectLastSavedRecord = function selectLastSavedRecord(state) {
  return state.lastSavedRecord.data;
};
var selectLastSavedRecordIndex = function selectLastSavedRecordIndex(state) {
  return state.lastSavedRecord.index;
};
var selectRefreshCurrentRecord = function selectRefreshCurrentRecord(state) {
  return state.refreshCurrentRecord;
};
var selectRemoveCurrentRecord = function selectRemoveCurrentRecord(state) {
  return state.removeCurrentRecord;
};
var selectRefreshCurrentView = function selectRefreshCurrentView(state) {
  return state.refreshCurrentView;
};
var selectRevertChanges = function selectRevertChanges(state) {
  return state.revertChanges;
};
var selectSaveState = function selectSaveState(state) {
  return state.saveState;
};
var selectUpdateSource = function selectUpdateSource(state) {
  return state.currentRecord.updateSource;
};
var selectNewRecordIndex = function selectNewRecordIndex(state) {
  return state.newRecordIndex;
};
module.exports.getCurrentPageSize = getCurrentPageSize;
module.exports.getNumberOfPagesToShow = getNumberOfPagesToShow;
module.exports.getPaginationData = getPaginationData;
module.exports.getCurrentPage = getCurrentPage;
module.exports.hasCurrentRecord = hasCurrentRecord;
module.exports.selectCurrentRecord = selectCurrentRecord;
module.exports.selectCurrentRecordIndex = selectCurrentRecordIndex;
module.exports.selectDefaultDraft = getDefaultDraft;
module.exports.selectDesiredRecordIndex = selectDesiredRecordIndex;
module.exports.selectFieldsToUpdate = selectFieldsToUpdate;
module.exports.selectLastSavedRecord = selectLastSavedRecord;
module.exports.selectLastSavedRecordIndex = selectLastSavedRecordIndex;
module.exports.selectRefreshCurrentRecord = selectRefreshCurrentRecord;
module.exports.selectRemoveCurrentRecord = selectRemoveCurrentRecord;
module.exports.selectRefreshCurrentView = selectRefreshCurrentView;
module.exports.selectRevertChanges = selectRevertChanges;
module.exports.selectSaveState = selectSaveState;
module.exports.selectUpdateSource = selectUpdateSource;
module.exports.selectNewRecordIndex = selectNewRecordIndex;

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var sink = function sink() {};

var _match = function _match(either, patterns) {
  return either.fold(patterns.Error || sink, patterns.Ok || sink);
};

var left = function left(value) {
  return {
    map: function map(fn) {
      return this;
    },
    fold: function fold(f, g) {
      return f(value);
    },
    chain: function chain(fn) {
      return this;
    },
    match: function match(patterns) {
      return _match(this, patterns);
    },

    value: value
  };
};

var right = function right(value) {
  return {
    map: function map(fn) {
      return Right(fn(value));
    },
    fold: function fold(f, g) {
      return g(value);
    },
    chain: function chain(fn) {
      return fn(value);
    },
    match: function match(patterns) {
      return _match(this, patterns);
    },

    value: value
  };
};

var Left = function Left(value) {
  return Object.assign(Object.create(null), left(value));
};
var Right = function Right(value) {
  return Object.assign(Object.create(null), right(value));
};

var sequence = function sequence(eitherList) {
  return eitherList.reduce(function (acc, either) {
    return acc.chain(function (list) {
      return either.map(function (value) {
        return list.concat(value);
      });
    });
  }, Right([]));
};

var try_ = function try_(fn) {
  try {
    return Right(fn());
  } catch (e) {
    return Left(e);
  }
};

var Either = {
  Left: Left,
  Right: Right
};

module.exports.Either = Either;
module.exports.sequence = sequence;
module.exports.try_ = try_;

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(122),
    Either = _require.Either;

var fromError = function fromError(type, error) {
  return {
    type: type,
    error: true,
    payload: error
  };
};
var fromSuccess = function fromSuccess(type, value) {
  return {
    type: type,
    payload: value
  };
};

var toEither = function toEither(action) {
  if (action.error === true) {
    return Either.Left(action.payload);
  } else {
    return Either.Right(action.payload);
  }
};

var match = function match(action, patterns) {
  return toEither(action).match(patterns);
};

module.exports.fromError = fromError;
module.exports.fromSuccess = fromSuccess;
module.exports.match = match;

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (from, to) {
  var transition = {
    from: from,
    to: to,
    hasChanged: function hasChanged(selector) {
      return selector(from) !== selector(to);
    },
    hasChangedToMatch: function hasChangedToMatch(selector, predicate) {
      return transition.hasChanged(selector) && predicate(selector(to));
    },
    hasChangedToTrue: function hasChangedToTrue(selector) {
      return transition.hasChangedToMatch(selector, function (_) {
        return _ === true;
      });
    },
    hasChangedToFalse: function hasChangedToFalse(selector) {
      return transition.hasChangedToMatch(selector, function (_) {
        return _ === false;
      });
    },
    hasChangedToNull: function hasChangedToNull(selector) {
      return transition.hasChangedToMatch(selector, function (_) {
        return _ === null;
      });
    },
    hasChangedToNotNull: function hasChangedToNotNull(selector) {
      return transition.hasChangedToMatch(selector, function (_) {
        return _ !== null;
      });
    }
  };

  return transition;
};

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(24),
    READ = _require.READ;

var _require2 = __webpack_require__(286),
    DEFAULT_PAGE_SIZE = _require2.DEFAULT_PAGE_SIZE;

module.exports = {
  collectionName: null,
  readWriteType: READ,
  filter: null,
  sort: null,
  includes: null,
  pageSize: DEFAULT_PAGE_SIZE
};

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var saveStates = {
  SAVE_STATE_NONE: 'SAVE_STATE_NONE',
  SAVE_STATE_CALL_BEFORE_SAVE_HOOKS: 'SAVE_STATE_CALL_BEFORE_SAVE_HOOKS',
  SAVE_STATE_CHECK_HAS_DRAFT: 'SAVE_STATE_CHECK_HAS_DRAFT',
  SAVE_STATE_ASSERT_VALIDITY: 'SAVE_STATE_ASSERT_VALIDITY',
  SAVE_STATE_SAVE_RECORD: 'SAVE_STATE_SAVE_RECORD',
  SAVE_STATE_ERROR: 'SAVE_STATE_ERROR'
};

var isNone = function isNone(saveState) {
  return saveState === saveStates.SAVE_STATE_NONE;
};
var isError = function isError(saveState) {
  return saveState === saveStates.SAVE_STATE_ERROR;
};
var isAssertValidity = function isAssertValidity(saveState) {
  return saveState === saveStates.SAVE_STATE_ASSERT_VALIDITY;
};
var isCallBeforeSaveHooks = function isCallBeforeSaveHooks(saveState) {
  return saveState === saveStates.SAVE_STATE_CALL_BEFORE_SAVE_HOOKS;
};
var isCheckHasDraft = function isCheckHasDraft(saveState) {
  return saveState === saveStates.SAVE_STATE_CHECK_HAS_DRAFT;
};
var isSaveRecord = function isSaveRecord(saveState) {
  return saveState === saveStates.SAVE_STATE_SAVE_RECORD;
};

module.exports.saveStates = saveStates;

module.exports.isNone = isNone;
module.exports.isError = isError;
module.exports.isAssertValidity = isAssertValidity;
module.exports.isCallBeforeSaveHooks = isCallBeforeSaveHooks;
module.exports.isCheckHasDraft = isCheckHasDraft;
module.exports.isSaveRecord = isSaveRecord;

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  SET_FILTER: 'SET_FILTER',
  SET_SORT: 'SET_SORT',
  SET_IS_DURING_SAVE: 'SET_IS_DURING_SAVE',
  SET_IS_DATASET_READY: 'SET_IS_DATASET_READY',
  SET_FIXED_FILTER_ITEM: 'SET_FIXED_FILTER_ITEM'
};

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  RESOLVE_DEPENDENCIES: 'RESOLVE_DEPENDENCIES',
  SET_DEPENDENCIES: 'SET_DEPENDENCIES',
  PERFORM_HANDSHAKES: 'PERFORM_HANDSHAKES',
  RESOLVE_MISSING_DEPENDENCIES: 'RESOLVE_MISSING_DEPENDENCIES'
};

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  SET_CONNECTED_COMPONENTS: 'SET_CONNECTED_COMPONENTS'
};

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var get_ = __webpack_require__(0).get;
var actionTypes = __webpack_require__(62);
var DynamicPageUrlLoadState = __webpack_require__(290);

var initialDynamicPagesState = {
  nextDynamicPageUrl: DynamicPageUrlLoadState.Empty(),
  previousDynamicPageUrl: DynamicPageUrlLoadState.Empty()

  // uniqueOnClickActionsFromConnections :: (Array) -> Set
};var uniqueOnClickActionsFromConnections = function uniqueOnClickActionsFromConnections(connections) {
  var onClickConnectedComponents = connections.filter(function (c) {
    return !!get_(c, 'config.events.onClick.action');
  });
  return new Set(onClickConnectedComponents.map(function (connection) {
    return get_(connection, 'config.events.onClick.action');
  }));
};

var getUrlFetchingState = function getUrlFetchingState(connections) {
  var uniqueActions = uniqueOnClickActionsFromConnections(connections);
  var getUrlState = function getUrlState(shouldLoad) {
    return shouldLoad ? DynamicPageUrlLoadState.Loading() : DynamicPageUrlLoadState.Empty();
  };

  return {
    nextDynamicPageUrl: getUrlState(uniqueActions.has('nextDynamicPage')),
    previousDynamicPageUrl: getUrlState(uniqueActions.has('previousDynamicPage'))
  };
};

module.exports = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialDynamicPagesState;
  var action = arguments[1];

  switch (action.type) {
    case actionTypes.INITIALIZE:
      return Object.assign({}, state, getUrlFetchingState(action.connections));

    case actionTypes.NEXT_DYNAMIC_PAGE_URL_RESULT:
      {
        return Object.assign({}, state, {
          nextDynamicPageUrl: DynamicPageUrlLoadState.fromUrl(action.payload)
        });
      }

    case actionTypes.PREVIOUS_DYNAMIC_PAGE_URL_RESULT:
      {
        return Object.assign({}, state, {
          previousDynamicPageUrl: DynamicPageUrlLoadState.fromUrl(action.payload)
        });
      }

    default:
      return state;
  }
};

var selectNextDynamicPageUrl = function selectNextDynamicPageUrl(state) {
  return state.nextDynamicPageUrl;
};
var selectPreviousDynamicPageUrl = function selectPreviousDynamicPageUrl(state) {
  return state.previousDynamicPageUrl;
};

module.exports.selectNextDynamicPageUrl = selectNextDynamicPageUrl;
module.exports.selectPreviousDynamicPageUrl = selectPreviousDynamicPageUrl;

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var deriveMethods = function deriveMethods(adt, definitions) {
  Object.keys(definitions).forEach(function (name) {
    adt.variants.forEach(function (variant) {
      variant.prototype[name] = definitions[name][variant.tag];
    });
  });
};

module.exports = deriveMethods;

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(120),
    queueThunk = _require.queueThunk;

var ACTION_QUEUE = Symbol('action-queue');

module.exports = function (thunk) {
  return queueThunk(thunk, ACTION_QUEUE);
};

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var mapValues_ = __webpack_require__(0).mapValues;
var isEqual_ = __webpack_require__(0).isEqual;
var isBoolean_ = __webpack_require__(0).isBoolean;

var _require = __webpack_require__(10),
    createImmediateCmd = _require.createImmediateCmd,
    createQueuedCmd = _require.createQueuedCmd;

var breadcrumbWrapper = __webpack_require__(63);

var DatasetError = __webpack_require__(13);

var actionTypes = __webpack_require__(42);
var cmdTypes = __webpack_require__(293);

var _require2 = __webpack_require__(25),
    updateComponentsBasedOnRecord = _require2.updateComponentsBasedOnRecord;

var TYPE = 'RECORDS';

var isFalse = function isFalse(val) {
  return isEqual_(false, val);
};

var convertToFieldType = function convertToFieldType(fieldType, value) {
  switch (fieldType) {
    case 'number':
      {
        return Number(value);
      }

    case 'boolean':
      {
        if (typeof value === 'string') {
          return value.toLowerCase() === 'true' || value.toLowerCase() === '1';
        }
        break;
      }

    case 'text':
      {
        if (value != null && typeof value.toString === 'function') {
          return value.toString();
        }
        break;
      }
  }

  return value;
};

var ensureSchemaTypes = function ensureSchemaTypes(getFieldType, record) {
  return mapValues_(record, function (value, fieldName) {
    return convertToFieldType(getFieldType(fieldName), value);
  });
};

var executor = function executor(recordStore, adapterApi, getFieldType, executeHooks, Raven, controllerId) {
  var updateComponents = updateComponentsBasedOnRecord(adapterApi);

  var sanitiseUserData = ['setFieldsInCurrentRecord'];
  // createBreadcrumb :: (String, [*]) -> Breadcrumb
  var createBreadcrumb = function createBreadcrumb(fnName, args) {
    return {
      category: 'recordsExecutor',
      level: 'info',
      message: fnName + '(' + (sanitiseUserData.includes(fnName) ? '..' + args.length + ' arguments..' : args.map(JSON.stringify)) + ') (' + controllerId + ')',
      data: {}
    };
  };

  var _breadcrumbWrapper = breadcrumbWrapper(Raven, createBreadcrumb, function (_) {
    return _;
  }),
      withBreadcrumbs = _breadcrumbWrapper.withBreadcrumbs,
      withBreadcrumbsAsync = _breadcrumbWrapper.withBreadcrumbsAsync;

  var executeGetRecordByIndex = withBreadcrumbsAsync('getRecordByIndex', function (index) {
    return recordStore().matchWith({
      Nothing: function Nothing() {
        throw new Error('Record store service not ready yet');
      },
      Just: function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref) {
          var service = _ref.value;
          var queryResult;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return service.getRecords(index, 1);

                case 2:
                  queryResult = _context.sent;
                  return _context.abrupt('return', queryResult.matchWith({
                    Empty: function Empty() {
                      return { index: null, record: null };
                    },
                    Results: function Results(_ref3) {
                      var items = _ref3.items;

                      return { index: index, record: items[0] };
                    }
                  }));

                case 4:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, undefined);
        }));

        function Just(_x) {
          return _ref2.apply(this, arguments);
        }

        return Just;
      }()
    });
  });

  var executeSetFieldsInCurrentRecord = withBreadcrumbs('setFieldsInCurrentRecord', function (index, fields, source) {
    var convertedFieldValues = ensureSchemaTypes(getFieldType, fields);

    return recordStore().chain(function (service) {
      return service.setFieldsValues(index, convertedFieldValues, source).fold(function (e) {
        throw e;
      }, function (_) {});
    });
  });

  var executeBeforeSaveHooks = withBreadcrumbsAsync('executeBeforeSaveHooks', function (executeHooks) {
    return executeHooks('beforeSave').then(function (hookResults) {
      return hookResults.some(isFalse);
    }).catch(function (e) {
      return { error: e };
    }).then(function (shouldCancelSave) {
      if (shouldCancelSave) {
        throw new DatasetError('DS_OPERATION_CANCELLED', 'Operation cancelled by user code. ' + (isBoolean_(shouldCancelSave) ? '' : shouldCancelSave.error));
      }
    });
  });

  var checkHasDraft = withBreadcrumbs('checkHasDraft', function (index) {
    return recordStore().matchWith({
      Nothing: function Nothing() {
        return false;
      },
      Just: function Just(_ref4) {
        var service = _ref4.value;
        return service.hasDraft(index);
      }
    });
  });

  var saveRecord = withBreadcrumbsAsync('saveRecord', function (index) {
    return recordStore().matchWith({
      Nothing: function Nothing() {
        return Promise.reject(new Error('Record store service not ready yet'));
      },
      Just: function Just(_ref5) {
        var service = _ref5.value;
        return service.saveRecord(index);
      }
    });
  });

  var removeRecordByIndex = withBreadcrumbsAsync('removeRecordByIndex', function (index) {
    return recordStore().matchWith({
      Nothing: function Nothing() {
        return Promise.reject(new Error('Record store service not ready yet'));
      },
      Just: function () {
        var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(_ref6) {
          var service = _ref6.value;
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return service.removeRecord(index);

                case 2:
                  return _context2.abrupt('return', _context2.sent);

                case 3:
                case 'end':
                  return _context2.stop();
              }
            }
          }, _callee2, undefined);
        }));

        function Just(_x2) {
          return _ref7.apply(this, arguments);
        }

        return Just;
      }()
    });
  });

  var newRecordAtIndex = withBreadcrumbs('newRecordAtIndex', function (atIndex, defaultDraft) {
    return recordStore().matchWith({
      Nothing: function Nothing() {
        return Promise.reject(new Error('Record store service not ready yet'));
      },
      Just: function Just(_ref8) {
        var service = _ref8.value;
        return service.newRecord(atIndex, defaultDraft);
      }
    });
  });

  return {
    type: TYPE,
    execute: function execute(cmd) {
      switch (cmd.type) {
        case cmdTypes.GET_RECORD_BY_INDEX:
          return executeGetRecordByIndex(cmd.index);

        case cmdTypes.SET_FIELDS_IN_CURRENT_RECORD:
          return executeSetFieldsInCurrentRecord(cmd.index, cmd.fields, cmd.source);

        case cmdTypes.REVERT_CHANGES:
          recordStore().chain(function (service) {
            return service.resetDraft(cmd.index, cmd.defaultDraft);
          });

          // This updateComponentsBasedOnRecord is still needed because of upload buttons' behaviour.
          // Upload buttons, when a file is selected, do not update the record data, but still
          // need to be reverted to clear that selection. Therefore, the revert action must always
          // call the adapters' currentRecordModified event.
          updateComponents();
          break;

        case cmdTypes.CALL_BEFORE_SAVE_HOOKS:
          return executeBeforeSaveHooks(executeHooks);

        case cmdTypes.CHECK_HAS_DRAFT:
          return checkHasDraft(cmd.index);

        case cmdTypes.SAVE_RECORD:
          return saveRecord(cmd.index);
        case cmdTypes.REMOVE_RECORD:
          return removeRecordByIndex(cmd.index);
        case cmdTypes.NEW_RECORD:
          return newRecordAtIndex(cmd.atIndex, cmd.defaultDraft);
      }
    }
  };
};

var getRecordByIndexCmd = function getRecordByIndexCmd(index) {
  return createQueuedCmd(TYPE, {
    type: cmdTypes.GET_RECORD_BY_INDEX,
    index: index
  }, actionTypes.GET_RECORD_BY_INDEX_RESULT);
};

var setFieldsInCurrentRecordCmd = function setFieldsInCurrentRecordCmd(fields, index, source) {
  return createImmediateCmd(TYPE, {
    type: cmdTypes.SET_FIELDS_IN_CURRENT_RECORD,
    fields: fields,
    index: index,
    source: source
  });
};

var revertChangesCmd = function revertChangesCmd(index, defaultDraft) {
  return createImmediateCmd(TYPE, {
    type: cmdTypes.REVERT_CHANGES,
    index: index,
    defaultDraft: defaultDraft
  }, actionTypes.RECORD_REVERTED);
};

var callBeforeSaveHooksCmd = function callBeforeSaveHooksCmd() {
  return createQueuedCmd(TYPE, {
    type: cmdTypes.CALL_BEFORE_SAVE_HOOKS
  }, actionTypes.CALL_BEFORE_SAVE_HOOKS_RESULT);
};

var checkHasDraftCmd = function checkHasDraftCmd(index) {
  return createQueuedCmd(TYPE, {
    type: cmdTypes.CHECK_HAS_DRAFT,
    index: index
  }, actionTypes.CHECK_HAS_DRAFT_RESULT);
};

var saveRecordCmd = function saveRecordCmd(index) {
  return createQueuedCmd(TYPE, {
    type: cmdTypes.SAVE_RECORD,
    index: index
  }, actionTypes.SAVE_RECORD_RESULT);
};

var removeCurrentRecordCmd = function removeCurrentRecordCmd(index) {
  return createQueuedCmd(TYPE, {
    type: cmdTypes.REMOVE_RECORD,
    index: index
  }, actionTypes.REMOVE_CURRENT_RECORD_RESULT);
};
var newRecordCmd = function newRecordCmd(atIndex, defaultDraft) {
  return createQueuedCmd(TYPE, { type: cmdTypes.NEW_RECORD, atIndex: atIndex, defaultDraft: defaultDraft }, actionTypes.NEW_RECORD_RESULT);
};

module.exports.executor = executor;

module.exports.callBeforeSaveHooksCmd = callBeforeSaveHooksCmd;
module.exports.checkHasDraftCmd = checkHasDraftCmd;
module.exports.getRecordByIndexCmd = getRecordByIndexCmd;
module.exports.revertChangesCmd = revertChangesCmd;
module.exports.saveRecordCmd = saveRecordCmd;
module.exports.setFieldsInCurrentRecordCmd = setFieldsInCurrentRecordCmd;
module.exports.removeCurrentRecordCmd = removeCurrentRecordCmd;
module.exports.newRecordCmd = newRecordCmd;

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var actionTypes = __webpack_require__(127);

module.exports.setFilter = function (filter) {
  return {
    type: actionTypes.SET_FILTER,
    filter: filter
  };
};

module.exports.setSort = function (sort) {
  return {
    type: actionTypes.SET_SORT,
    sort: sort
  };
};

module.exports.setIsDuringSave = function (isDuringSave) {
  return {
    type: actionTypes.SET_IS_DURING_SAVE,
    isDuringSave: isDuringSave
  };
};

module.exports.setIsDatasetReady = function (isDatasetReady) {
  return {
    type: actionTypes.SET_IS_DATASET_READY,
    isDatasetReady: isDatasetReady
  };
};

module.exports.setFixedFilterItem = function (fixedFilterItem) {
  return {
    type: actionTypes.SET_FIXED_FILTER_ITEM,
    fixedFilterItem: fixedFilterItem
  };
};

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var mapValues_ = __webpack_require__(0).mapValues;
var get_ = __webpack_require__(0).get;
var recordActions = __webpack_require__(25);
var actionTypes = __webpack_require__(128);
var componentRoles = __webpack_require__(44);
var queue = __webpack_require__(132);

var _require = __webpack_require__(2),
    areDependenciesResolved = _require.areDependenciesResolved;

var createDependencyEntries = function createDependencyEntries(_ref) {
  var controllerApi = _ref.controllerApi,
      connectionConfig = _ref.connectionConfig;
  return mapValues_(connectionConfig.filters, function (_ref2) {
    var fieldName = _ref2.fieldName;
    return {
      fieldName: fieldName,
      controllerApi: controllerApi
    };
  });
};

var refreshDatasetOnControllerEvent = function refreshDatasetOnControllerEvent(controller, event, dispatch) {
  try {
    return controller[event](function () {
      return dispatch(recordActions.refresh());
    });
  } catch (ex) {
    // registering to onItemValuesChanged when the dataset is in read only mode will throw error
    // ignore dataset errors and return empty unsubscribe handle
    if (get_(ex, 'code') === 'OPERATION_NOT_ALLOWED') {
      return function () {};
    }
    throw ex;
  }
};

var resolveDependencies = function resolveDependencies(dependenciesIds) {
  return {
    type: actionTypes.RESOLVE_DEPENDENCIES,
    dependenciesIds: dependenciesIds
  };
};

var performHandshakes = function performHandshakes(dependenciesIds) {
  return {
    type: actionTypes.PERFORM_HANDSHAKES,
    dependenciesIds: dependenciesIds
  };
};

module.exports.resolveMissingDependencies = function () {
  return {
    type: actionTypes.RESOLVE_MISSING_DEPENDENCIES
  };
};

module.exports.setDependencies = function (dependenciesIds) {
  return {
    type: actionTypes.SET_DEPENDENCIES,
    dependenciesIds: dependenciesIds
  };
};

module.exports.performHandshake = function (_ref3) {
  var controllerApi = _ref3.controllerApi,
      connectionConfig = _ref3.connectionConfig,
      role = _ref3.role;
  return function (dispatch, getState, _ref4) {
    var dependenciesManager = _ref4.dependenciesManager;

    if (role === componentRoles.DETAILS_DATASET) {
      var entries = createDependencyEntries({ controllerApi: controllerApi, connectionConfig: connectionConfig });
      var dependenciesIds = Object.keys(entries);

      dependenciesManager.add(entries);
      dispatch(performHandshakes(dependenciesIds));

      var onReadyHandle = controllerApi.onReady(function () {
        dispatch(resolveDependencies(dependenciesIds));

        var indexHandle = refreshDatasetOnControllerEvent(controllerApi, 'onCurrentIndexChanged', dispatch);
        var valuesHandle = refreshDatasetOnControllerEvent(controllerApi, 'onItemValuesChanged', dispatch);

        dependenciesManager.saveHandle(indexHandle);
        dependenciesManager.saveHandle(valuesHandle);
      });
      dependenciesManager.saveHandle(onReadyHandle);
    }
  };
};

module.exports.waitForDependencies = function (store) {
  return queue(function () {
    return new Promise(function (resolve) {
      if (areDependenciesResolved(store.getState())) {
        resolve();
      } else {
        var unsubscribe = store.subscribe(function () {
          if (areDependenciesResolved(store.getState())) {
            unsubscribe();
            resolve();
          }
        });
      }
    });
  });
};

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _TYPE_TRANSLATIONS;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var values_ = __webpack_require__(0).values;

var FIELD_TYPES = {
  TEXT: 'text',
  IMAGE: 'image',
  BOOLEAN: 'boolean',
  NUMBER: 'number',
  DATETIME: 'datetime',
  RICHTEXT: 'richtext',
  COLOR: 'color',
  REFERENCE: 'reference',
  MULTI_REFERENCE: 'multi-reference',
  PAGELINK: 'pagelink',
  URL: 'url',
  DOCUMENT: 'document',
  VIDEO: 'video',
  ADDRESS: 'address',
  OBJECT: 'object'
};

var TYPE_TRANSLATIONS = (_TYPE_TRANSLATIONS = {}, _defineProperty(_TYPE_TRANSLATIONS, FIELD_TYPES.TEXT, 'Datatype_Name_Text'), _defineProperty(_TYPE_TRANSLATIONS, FIELD_TYPES.NUMBER, 'Datatype_Name_Number'), _defineProperty(_TYPE_TRANSLATIONS, FIELD_TYPES.IMAGE, 'Datatype_Name_Image'), _defineProperty(_TYPE_TRANSLATIONS, FIELD_TYPES.DATETIME, 'Datatype_Name_DateTime'), _defineProperty(_TYPE_TRANSLATIONS, FIELD_TYPES.BOOLEAN, 'Datatype_Name_Boolean'), _defineProperty(_TYPE_TRANSLATIONS, FIELD_TYPES.RICHTEXT, 'Datatype_Name_RichText'), _defineProperty(_TYPE_TRANSLATIONS, FIELD_TYPES.URL, 'Datatype_Name_URL'), _defineProperty(_TYPE_TRANSLATIONS, FIELD_TYPES.DOCUMENT, 'Datatype_Name_Document'), _defineProperty(_TYPE_TRANSLATIONS, FIELD_TYPES.VIDEO, 'Datatype_Name_Video'), _defineProperty(_TYPE_TRANSLATIONS, FIELD_TYPES.COLOR, 'Datatype_Name_Color'), _defineProperty(_TYPE_TRANSLATIONS, FIELD_TYPES.REFERENCE, 'Datatype_Name_Reference'), _defineProperty(_TYPE_TRANSLATIONS, FIELD_TYPES.ADDRESS, 'Datatype_Name_Address'), _defineProperty(_TYPE_TRANSLATIONS, FIELD_TYPES.OBJECT, 'Datatype_Name_JSObject'), _TYPE_TRANSLATIONS);

var ALL_FIELD_TYPES = values_(FIELD_TYPES);

module.exports.ALL_FIELD_TYPES = ALL_FIELD_TYPES;
module.exports.FIELD_TYPES = FIELD_TYPES;
module.exports.TYPE_TRANSLATIONS = TYPE_TRANSLATIONS;

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(10),
    createImmediateCmd = _require.createImmediateCmd,
    createQueuedCmd = _require.createQueuedCmd;

var DatasetError = __webpack_require__(13);
var isComponentValid = __webpack_require__(305);

var cmdTypes = __webpack_require__(306);
var recordsActionTypes = __webpack_require__(42);

var TYPE = 'ADAPTER_API';

var assertComponentsValid = function assertComponentsValid(componentAdapterContexts, currentRecord) {
  var nonValidComponentAdapterContexts = componentAdapterContexts.filter(function (cac) {
    return !isComponentValid(cac, currentRecord);
  });
  nonValidComponentAdapterContexts.forEach(function (_ref) {
    var component = _ref.component;
    return component.updateValidityIndication();
  });

  if (nonValidComponentAdapterContexts.length) {
    throw new DatasetError('DS_VALIDATION_ERROR', 'Some of the elements validation failed');
  }
};

var executor = function executor(adapterApi, componentAdapterContexts) {
  return {
    type: TYPE,
    execute: function execute(cmd) {
      switch (cmd.type) {
        case cmdTypes.BIND_TO_COMPONENT:
          return adapterApi().bindToComponent();

        case cmdTypes.CURRENT_RECORD_MODIFIED:
          return adapterApi().currentRecordModified(cmd.updatedFields, cmd.filteredComponent);

        case cmdTypes.RECORD_SET_LOADED:
          return Promise.all(adapterApi().recordSetLoaded());

        case cmdTypes.CURRENT_VIEW_CHANGED:
          return Promise.all(adapterApi().currentViewChanged());

        case cmdTypes.CURRENT_INDEX_CHANGED:
          return adapterApi().currentIndexChanged();

        case cmdTypes.ASSERT_INPUT_VALIDITY:
          return assertComponentsValid(componentAdapterContexts, cmd.record);
      }
    }
  };
};

var assertValidityCmd = function assertValidityCmd(record) {
  return createQueuedCmd(TYPE, {
    type: cmdTypes.ASSERT_INPUT_VALIDITY,
    record: record
  }, recordsActionTypes.ASSERT_VALIDITY_RESULT);
};

var bindToComponentCmd = function bindToComponentCmd() {
  return createImmediateCmd(TYPE, {
    type: cmdTypes.BIND_TO_COMPONENT
  });
};

var currentRecordModifiedCmd = function currentRecordModifiedCmd(updatedFields, filteredComponent) {
  return createImmediateCmd(TYPE, {
    type: cmdTypes.CURRENT_RECORD_MODIFIED,
    updatedFields: updatedFields,
    filteredComponent: filteredComponent
  });
};

var notifyRecordSetLoadedCmd = function notifyRecordSetLoadedCmd() {
  return createQueuedCmd(TYPE, {
    type: cmdTypes.RECORD_SET_LOADED
  });
};

var updateCurrentViewCmd = function updateCurrentViewCmd(actionType) {
  return createQueuedCmd(TYPE, {
    type: cmdTypes.CURRENT_VIEW_CHANGED
  }, recordsActionTypes.CURRENT_VIEW_UPDATED);
};

var notifyIndexChangeCmd = function notifyIndexChangeCmd() {
  return createImmediateCmd(TYPE, {
    type: cmdTypes.CURRENT_INDEX_CHANGED
  });
};

module.exports.executor = executor;

module.exports.assertValidityCmd = assertValidityCmd;
module.exports.bindToComponentCmd = bindToComponentCmd;
module.exports.currentRecordModifiedCmd = currentRecordModifiedCmd;
module.exports.notifyIndexChangeCmd = notifyIndexChangeCmd;
module.exports.notifyRecordSetLoadedCmd = notifyRecordSetLoadedCmd;
module.exports.updateCurrentViewCmd = updateCurrentViewCmd;

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var _require = __webpack_require__(10),
    createQueuedCmd = _require.createQueuedCmd;

var cmdTypes = __webpack_require__(307);
var actionTypes = __webpack_require__(62);

var TYPE = 'DYNAMIC_PAGES';

var executor = function executor(recordStore) {
  return {
    type: TYPE,
    execute: function execute(cmd) {
      switch (cmd.type) {
        case cmdTypes.SHOULD_GET_NEXT_DYNAMIC_PAGE_URL:
          return recordStore().matchWith({
            Nothing: function Nothing() {
              return Promise.reject(new Error('Record store service not ready yet'));
            },
            Just: function () {
              var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref) {
                var service = _ref.value;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return service.getNextDynamicPage();

                      case 2:
                        return _context.abrupt('return', _context.sent);

                      case 3:
                      case 'end':
                        return _context.stop();
                    }
                  }
                }, _callee, undefined);
              }));

              function Just(_x) {
                return _ref2.apply(this, arguments);
              }

              return Just;
            }()
          });
        case cmdTypes.SHOULD_GET_PREVIOUS_DYNAMIC_PAGE_URL:
          return recordStore().matchWith({
            Nothing: function Nothing() {
              return Promise.reject(new Error('Record store service not ready yet'));
            },
            Just: function () {
              var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(_ref3) {
                var service = _ref3.value;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        _context2.next = 2;
                        return service.getPreviousDynamicPage();

                      case 2:
                        return _context2.abrupt('return', _context2.sent);

                      case 3:
                      case 'end':
                        return _context2.stop();
                    }
                  }
                }, _callee2, undefined);
              }));

              function Just(_x2) {
                return _ref4.apply(this, arguments);
              }

              return Just;
            }()
          });
      }
    }
  };
};

var getNextDynamicPageCmd = function getNextDynamicPageCmd() {
  return createQueuedCmd(TYPE, {
    type: cmdTypes.SHOULD_GET_NEXT_DYNAMIC_PAGE_URL
  }, actionTypes.NEXT_DYNAMIC_PAGE_URL_RESULT);
};

var getPreviousDynamicPageCmd = function getPreviousDynamicPageCmd() {
  return createQueuedCmd(TYPE, {
    type: cmdTypes.SHOULD_GET_PREVIOUS_DYNAMIC_PAGE_URL
  }, actionTypes.PREVIOUS_DYNAMIC_PAGE_URL_RESULT);
};

module.exports.executor = executor;

module.exports.getNextDynamicPageCmd = getNextDynamicPageCmd;
module.exports.getPreviousDynamicPageCmd = getPreviousDynamicPageCmd;

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _datasetModeToMessage;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var includes_ = __webpack_require__(0).includes;
var isFunction_ = __webpack_require__(0).isFunction;
var isNumber_ = __webpack_require__(0).isNumber;
var isInteger_ = __webpack_require__(0).isInteger;

var reducer = __webpack_require__(2);
var DATASET_TYPES = __webpack_require__(41);
var DatasetError = __webpack_require__(13);

var _require = __webpack_require__(24),
    READ = _require.READ,
    WRITE = _require.WRITE,
    READ_WRITE = _require.READ_WRITE;

var datasetModeToMessage = (_datasetModeToMessage = {}, _defineProperty(_datasetModeToMessage, READ, 'read-only'), _defineProperty(_datasetModeToMessage, WRITE, 'write-only'), _defineProperty(_datasetModeToMessage, READ_WRITE, 'read-write'), _datasetModeToMessage);

var assertDatasetConfigured = function assertDatasetConfigured(getState, operationName) {
  if (!reducer.isDatasetConfigured(getState())) {
    throw new DatasetError('OPERATION_NOT_ALLOWED', 'Operation (' + operationName + ') not allowed on an unconfigured dataset');
  }
};

var assertDatasetMode = function assertDatasetMode(getState, operationName) {
  var allowedModes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  var readWriteMode = reducer.getReadWriteMode(getState());
  if (!includes_(allowedModes, readWriteMode)) {
    throw new DatasetError('OPERATION_NOT_ALLOWED', 'Operation (' + operationName + ') not allowed on ' + datasetModeToMessage[readWriteMode] + ' dataset');
  }
};

var assertSaveNotInProgress = function assertSaveNotInProgress(getState, operationName) {
  if (reducer.isDuringSave(getState())) {
    throw new DatasetError('OPERATION_NOT_ALLOWED', 'Operation (' + operationName + ') not allowed during save');
  }
};

var assertDatasetLimitations = function assertDatasetLimitations(getState) {
  var operationName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var allowedModes = arguments[2];
  var isSupportedDuringSave = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

  assertDatasetConfigured(getState, operationName);
  assertDatasetMode(getState, operationName, allowedModes);
  if (!isSupportedDuringSave) {
    assertSaveNotInProgress(getState, operationName);
  }
};

var assertValidIndex = function assertValidIndex(index) {
  if (!isInteger_(index)) {
    throw new DatasetError('PARAMETER_NOT_ALLOWED', 'Parameter (' + index + ') must be a number');
  }
};

var assertValidNumberArgument = function assertValidNumberArgument(argName, argValue) {
  if (!isNumber_(argValue)) {
    throw new DatasetError('DS_INVALID_ARGUMENT', 'Parameter (' + argName + ') must be a number');
  }
};

var assertValidNaturalNumber = function assertValidNaturalNumber(argName, argValue) {
  if (!isInteger_(argValue) || argValue < 1) {
    throw new DatasetError('DS_INVALID_ARGUMENT', 'Parameter (' + argName + ') must be a positive integer number');
  }
};

var assertValidPageIndex = function assertValidPageIndex(pageIndex, totalPageCount) {
  assertValidNaturalNumber('pageNumber', pageIndex);
  if (pageIndex > totalPageCount) {
    throw new DatasetError('NO_SUCH_PAGE', 'Page ' + pageIndex + ' does not exist');
  }
};

var assertValidCallback = function assertValidCallback(operationName, cb) {
  if (!isFunction_(cb)) {
    throw new DatasetError('DS_INVALID_ARGUMENT', 'The callback passed to (' + operationName + ') must be a function');
  }
};

var assertValidFilter = function assertValidFilter(filter) {
  if (!filter || !isFunction_(filter._build)) {
    throw new DatasetError('DS_INVALID_ARGUMENT', 'The given filter object is invalid');
  }
};

var assertValidSort = function assertValidSort(sort) {
  if (!sort || !isFunction_(sort._build)) {
    throw new DatasetError('DS_INVALID_ARGUMENT', 'The given sort object is invalid');
  }
};

var assertDatasetReady = function assertDatasetReady(getState, operationName) {
  if (!reducer.isDatasetReady(getState())) {
    throw new DatasetError('DS_NOT_LOADED', 'The dataset didn\'t load yet. You need to call ' + operationName + ' inside the onReady for the dataset.');
  }
};

var assertHasCurrentItem = function assertHasCurrentItem(getState) {
  var index = reducer.selectCurrentRecordIndex(getState());
  if (index == null) {
    throw new DatasetError('DS_NO_CURRENT_ITEM', 'There is no current item');
  }
};

var assertScopeIsNotFixedItem = function assertScopeIsNotFixedItem(isFixedItem, operationName) {
  if (isFixedItem) {
    throw new DatasetError('OPERATION_NOT_ALLOWED', 'The "' + operationName + '" function cannot be called on the dataset because the dataset was selected using a repeated item scope selector.\nRead more about repeated item scope selectors: http://wix.to/94BuAAs/$w.Repeater.html#repeated-item-scope');
  }
};

var assertDatasetTypeIsRouter = function assertDatasetTypeIsRouter(datasetType, operationName) {
  if (datasetType !== DATASET_TYPES.ROUTER_DATASET) {
    throw new DatasetError('OPERATION_NOT_ALLOWED', '"' + operationName + '" function on the dataset is not allowed. "' + operationName + '" can only be called on a Dynamic Page Dataset.');
  }
};

module.exports.assertDatasetLimitations = assertDatasetLimitations;
module.exports.assertDatasetReady = assertDatasetReady;
module.exports.assertHasCurrentItem = assertHasCurrentItem;
module.exports.assertScopeIsNotFixedItem = assertScopeIsNotFixedItem;
module.exports.assertValidCallback = assertValidCallback;
module.exports.assertValidFilter = assertValidFilter;
module.exports.assertValidIndex = assertValidIndex;
module.exports.assertValidNumberArgument = assertValidNumberArgument;
module.exports.assertValidSort = assertValidSort;
module.exports.assertScopeIsNotFixedItem = assertScopeIsNotFixedItem;
module.exports.assertValidNaturalNumber = assertValidNaturalNumber;
module.exports.assertValidPageIndex = assertValidPageIndex;
module.exports.assertDatasetTypeIsRouter = assertDatasetTypeIsRouter;

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var reportCallbackError = function reportCallbackError(eventName, errorReporter) {
  return function (e) {
    errorReporter("An error occurred in one of " + eventName + " callbacks", e);
  };
};

exports.reportCallbackError = reportCallbackError;

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var uniqBy_ = __webpack_require__(0).uniqBy;

module.exports = function (components) {
  return uniqBy_(components, 'id');
};

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (message, datasetId) {
  return message + ' (' + datasetId + ')';
};

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = '@resolver';

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var COLLECTION_FIELD = /[^{}]+(?=\})/g;
var COLLECTION_FIELD_INCLUDING_BRACES = /\{[^{}]+(?=\})\}/g;
var NON_LETTER_OR_NUMBER = /[^a-zA-Z0-9]/g;

var cleanUrl = function cleanUrl(url) {
  return url.replace(/(\/{2,})/g, '/').replace(/^\//, '');
};

var parseUrlPattern = function parseUrlPattern(pattern) {
  pattern = cleanUrl(pattern);
  return {
    fields: pattern.match(COLLECTION_FIELD) || [],
    nonFields: pattern.replace(COLLECTION_FIELD, '').split(NON_LETTER_OR_NUMBER).filter(function (x) {
      return !!x;
    })
  };
};

var parseUrl = function parseUrl(url) {
  url = cleanUrl(url);
  var urlParts = url.split('/').filter(function (s) {
    return s.length > 0;
  });
  var pattern = '/' + urlParts.slice(1).join('/');
  return {
    prefix: urlParts[0],
    pattern: pattern
  };
};

var buildUrl = function buildUrl(prefix, pattern) {
  return cleanUrl(prefix + '/' + pattern);
};

var constructUrl = function constructUrl(record, dynamicUrl) {
  return '/' + cleanUrl(dynamicUrl).replace(COLLECTION_FIELD_INCLUDING_BRACES, function (match) {
    var fieldName = match.substring(1, match.length - 1);
    return record[fieldName];
  }).replace(' ', '-');
};

var addField = function addField(url, field) {
  return cleanUrl(url + '/{' + field + '}');
};

var isEqual = function isEqual(url1, url2) {
  return cleanUrl(url1) === cleanUrl(url2);
};

// exports

module.exports = {
  cleanUrl: cleanUrl,
  buildUrl: buildUrl,
  addField: addField,
  isEqual: isEqual,
  parseUrl: parseUrl,
  parseUrlPattern: parseUrlPattern,
  constructUrl: constructUrl
};

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

var baseConvert = __webpack_require__(336),
    util = __webpack_require__(338);

/**
 * Converts `func` of `name` to an immutable auto-curried iteratee-first data-last
 * version with conversion `options` applied. If `name` is an object its methods
 * will be converted.
 *
 * @param {string} name The name of the function to wrap.
 * @param {Function} [func] The function to wrap.
 * @param {Object} [options] The options object. See `baseConvert` for more details.
 * @returns {Function|Object} Returns the converted function or object.
 */
function convert(name, func, options) {
  return baseConvert(util, name, func, options);
}

module.exports = convert;


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(69),
    metaMap = __webpack_require__(147);

/**
 * The base implementation of `setData` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */
var baseSetData = !metaMap ? identity : function(func, data) {
  metaMap.set(func, data);
  return func;
};

module.exports = baseSetData;


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

var WeakMap = __webpack_require__(148);

/** Used to store function metadata. */
var metaMap = WeakMap && new WeakMap;

module.exports = metaMap;


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(16),
    root = __webpack_require__(3);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 150 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

var composeArgs = __webpack_require__(152),
    composeArgsRight = __webpack_require__(153),
    countHolders = __webpack_require__(348),
    createCtor = __webpack_require__(46),
    createRecurry = __webpack_require__(154),
    getHolder = __webpack_require__(163),
    reorder = __webpack_require__(364),
    replaceHolders = __webpack_require__(76),
    root = __webpack_require__(3);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_ARY_FLAG = 128,
    WRAP_FLIP_FLAG = 512;

/**
 * Creates a function that wraps `func` to invoke it with optional `this`
 * binding of `thisArg`, partial application, and currying.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [partialsRight] The arguments to append to those provided
 *  to the new function.
 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
  var isAry = bitmask & WRAP_ARY_FLAG,
      isBind = bitmask & WRAP_BIND_FLAG,
      isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
      isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
      isFlip = bitmask & WRAP_FLIP_FLAG,
      Ctor = isBindKey ? undefined : createCtor(func);

  function wrapper() {
    var length = arguments.length,
        args = Array(length),
        index = length;

    while (index--) {
      args[index] = arguments[index];
    }
    if (isCurried) {
      var placeholder = getHolder(wrapper),
          holdersCount = countHolders(args, placeholder);
    }
    if (partials) {
      args = composeArgs(args, partials, holders, isCurried);
    }
    if (partialsRight) {
      args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
    }
    length -= holdersCount;
    if (isCurried && length < arity) {
      var newHolders = replaceHolders(args, placeholder);
      return createRecurry(
        func, bitmask, createHybrid, wrapper.placeholder, thisArg,
        args, newHolders, argPos, ary, arity - length
      );
    }
    var thisBinding = isBind ? thisArg : this,
        fn = isBindKey ? thisBinding[func] : func;

    length = args.length;
    if (argPos) {
      args = reorder(args, argPos);
    } else if (isFlip && length > 1) {
      args.reverse();
    }
    if (isAry && ary < length) {
      args.length = ary;
    }
    if (this && this !== root && this instanceof wrapper) {
      fn = Ctor || createCtor(fn);
    }
    return fn.apply(thisBinding, args);
  }
  return wrapper;
}

module.exports = createHybrid;


/***/ }),
/* 152 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Creates an array that is the composition of partially applied arguments,
 * placeholders, and provided arguments into a single array of arguments.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to prepend to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgs(args, partials, holders, isCurried) {
  var argsIndex = -1,
      argsLength = args.length,
      holdersLength = holders.length,
      leftIndex = -1,
      leftLength = partials.length,
      rangeLength = nativeMax(argsLength - holdersLength, 0),
      result = Array(leftLength + rangeLength),
      isUncurried = !isCurried;

  while (++leftIndex < leftLength) {
    result[leftIndex] = partials[leftIndex];
  }
  while (++argsIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[holders[argsIndex]] = args[argsIndex];
    }
  }
  while (rangeLength--) {
    result[leftIndex++] = args[argsIndex++];
  }
  return result;
}

module.exports = composeArgs;


/***/ }),
/* 153 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This function is like `composeArgs` except that the arguments composition
 * is tailored for `_.partialRight`.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to append to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgsRight(args, partials, holders, isCurried) {
  var argsIndex = -1,
      argsLength = args.length,
      holdersIndex = -1,
      holdersLength = holders.length,
      rightIndex = -1,
      rightLength = partials.length,
      rangeLength = nativeMax(argsLength - holdersLength, 0),
      result = Array(rangeLength + rightLength),
      isUncurried = !isCurried;

  while (++argsIndex < rangeLength) {
    result[argsIndex] = args[argsIndex];
  }
  var offset = argsIndex;
  while (++rightIndex < rightLength) {
    result[offset + rightIndex] = partials[rightIndex];
  }
  while (++holdersIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[offset + holders[holdersIndex]] = args[argsIndex++];
    }
  }
  return result;
}

module.exports = composeArgsRight;


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

var isLaziable = __webpack_require__(349),
    setData = __webpack_require__(157),
    setWrapToString = __webpack_require__(159);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_BOUND_FLAG = 4,
    WRAP_CURRY_FLAG = 8,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64;

/**
 * Creates a function that wraps `func` to continue currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {Function} wrapFunc The function to create the `func` wrapper.
 * @param {*} placeholder The placeholder value.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
  var isCurry = bitmask & WRAP_CURRY_FLAG,
      newHolders = isCurry ? holders : undefined,
      newHoldersRight = isCurry ? undefined : holders,
      newPartials = isCurry ? partials : undefined,
      newPartialsRight = isCurry ? undefined : partials;

  bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
  bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

  if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
    bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
  }
  var newData = [
    func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
    newHoldersRight, argPos, ary, arity
  ];

  var result = wrapFunc.apply(undefined, newData);
  if (isLaziable(func)) {
    setData(result, newData);
  }
  result.placeholder = placeholder;
  return setWrapToString(result, func, bitmask);
}

module.exports = createRecurry;


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

var metaMap = __webpack_require__(147),
    noop = __webpack_require__(350);

/**
 * Gets metadata for `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {*} Returns the metadata for `func`.
 */
var getData = !metaMap ? noop : function(func) {
  return metaMap.get(func);
};

module.exports = getData;


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(47),
    baseLodash = __webpack_require__(73);

/**
 * The base constructor for creating `lodash` wrapper objects.
 *
 * @private
 * @param {*} value The value to wrap.
 * @param {boolean} [chainAll] Enable explicit method chain sequences.
 */
function LodashWrapper(value, chainAll) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__chain__ = !!chainAll;
  this.__index__ = 0;
  this.__values__ = undefined;
}

LodashWrapper.prototype = baseCreate(baseLodash.prototype);
LodashWrapper.prototype.constructor = LodashWrapper;

module.exports = LodashWrapper;


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetData = __webpack_require__(146),
    shortOut = __webpack_require__(158);

/**
 * Sets metadata for `func`.
 *
 * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
 * period of time, it will trip its breaker and transition to an identity
 * function to avoid garbage collection pauses in V8. See
 * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
 * for more details.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */
var setData = shortOut(baseSetData);

module.exports = setData;


/***/ }),
/* 158 */
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

var getWrapDetails = __webpack_require__(355),
    insertWrapDetails = __webpack_require__(356),
    setToString = __webpack_require__(160),
    updateWrapDetails = __webpack_require__(359);

/**
 * Sets the `toString` method of `wrapper` to mimic the source of `reference`
 * with wrapper details in a comment at the top of the source body.
 *
 * @private
 * @param {Function} wrapper The function to modify.
 * @param {Function} reference The reference function.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Function} Returns `wrapper`.
 */
function setWrapToString(wrapper, reference, bitmask) {
  var source = (reference + '');
  return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
}

module.exports = setWrapToString;


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__(357),
    shortOut = __webpack_require__(158);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(16);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(361),
    baseIsNaN = __webpack_require__(362),
    strictIndexOf = __webpack_require__(363);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),
/* 163 */
/***/ (function(module, exports) {

/**
 * Gets the argument placeholder value for `func`.
 *
 * @private
 * @param {Function} func The function to inspect.
 * @returns {*} Returns the placeholder value.
 */
function getHolder(func) {
  var object = func;
  return object.placeholder;
}

module.exports = getHolder;


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(49),
    keys = __webpack_require__(29);

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

module.exports = baseAssign;


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(166),
    eq = __webpack_require__(78);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(161);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(369),
    isArguments = __webpack_require__(79),
    isArray = __webpack_require__(4),
    isBuffer = __webpack_require__(80),
    isIndex = __webpack_require__(75),
    isTypedArray = __webpack_require__(168);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(372),
    baseUnary = __webpack_require__(82),
    nodeUtil = __webpack_require__(83);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(84),
    nativeKeys = __webpack_require__(373);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 170 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(86),
    arrayEach = __webpack_require__(74),
    assignValue = __webpack_require__(165),
    baseAssign = __webpack_require__(164),
    baseAssignIn = __webpack_require__(397),
    cloneBuffer = __webpack_require__(400),
    copyArray = __webpack_require__(48),
    copySymbols = __webpack_require__(401),
    copySymbolsIn = __webpack_require__(403),
    getAllKeys = __webpack_require__(175),
    getAllKeysIn = __webpack_require__(404),
    getTag = __webpack_require__(30),
    initCloneArray = __webpack_require__(408),
    initCloneByTag = __webpack_require__(409),
    initCloneObject = __webpack_require__(414),
    isArray = __webpack_require__(4),
    isBuffer = __webpack_require__(80),
    isMap = __webpack_require__(415),
    isObject = __webpack_require__(12),
    isSet = __webpack_require__(417),
    keys = __webpack_require__(29);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });

    return result;
  }

  if (isMap(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });

    return result;
  }

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

module.exports = baseClone;


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(167),
    baseKeysIn = __webpack_require__(398),
    isArrayLike = __webpack_require__(85);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),
/* 173 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(90),
    getPrototype = __webpack_require__(91),
    getSymbols = __webpack_require__(89),
    stubArray = __webpack_require__(173);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

module.exports = getSymbolsIn;


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(176),
    getSymbols = __webpack_require__(89),
    keys = __webpack_require__(29);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(90),
    isArray = __webpack_require__(4);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(3);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(424),
    baseMatchesProperty = __webpack_require__(437),
    identity = __webpack_require__(69),
    isArray = __webpack_require__(4),
    property = __webpack_require__(445);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(426),
    isObjectLike = __webpack_require__(5);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(427),
    arraySome = __webpack_require__(430),
    cacheHas = __webpack_require__(431);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(12);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 182 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(184),
    toKey = __webpack_require__(31);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(4),
    isKey = __webpack_require__(93),
    stringToPath = __webpack_require__(185),
    toString = __webpack_require__(186);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(439);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(441);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var flow_ = __webpack_require__(0).flow;
var isPlainObject_ = __webpack_require__(0).isPlainObject;
var includes_ = __webpack_require__(458);
var curry_ = __webpack_require__(0).curry;
var maybe = __webpack_require__(1);

var queryResults = __webpack_require__(26);

var _require = __webpack_require__(54),
    assign = _require.assign,
    bind = _require.bind;

var _require2 = __webpack_require__(27),
    cleanseRecord = _require2.cleanseRecord,
    createDraft = _require2.createDraft,
    getRecordId = _require2.getRecordId,
    markRecordDirty = _require2.markRecordDirty;

// freshCollection :: () -> Collection


var freshCollection = function freshCollection() {
  return {
    records: {},
    drafts: {},
    scopes: {}
  };
};

// insertToObjectMap :: ((Object -> Object), Id) -> Object -> Object
var insertToObjectMap = function insertToObjectMap(accessor, idFn, items) {
  return function (object) {
    return Object.assign.apply(Object, [{}, accessor(object)].concat(_toConsumableArray(items.map(function (item) {
      return _defineProperty({}, idFn(item), item);
    }))));
  };
};

// updateInObjectMap :: ((Object -> Object), Id, Record -> Record) -> Object -> Object
var updateInObjectMap = function updateInObjectMap(accessor, id, updateFn) {
  return function (object) {
    return Object.assign({}, accessor(object), _defineProperty({}, id, updateFn(accessor(object)[id])));
  };
};

// removeFromObjectMap :: ((Object -> Object), Id) -> Object -> Object
var removeFromObjectMap = function removeFromObjectMap(accessor, id) {
  return function (object) {
    return Object.assign.apply(Object, [{}].concat(_toConsumableArray(Object.keys(accessor(object)).filter(function (mapId) {
      return mapId !== id;
    }).map(function (mapId) {
      return _defineProperty({}, mapId, accessor(object)[mapId]);
    }))));
  };
};

// setCollectionRecords :: RecordsObject -> Collection -> Collection
var setCollectionRecords = function setCollectionRecords(records) {
  return assign({ records: records });
};

// setDrafts :: DraftsObject -> Collection -> Collection
var setDrafts = function setDrafts(drafts) {
  return assign({ drafts: drafts });
};

// setScope :: (ScopeKey, Scope) -> Collection -> Collection
var setScope = curry_(function (key, scope, collection) {
  return assign({
    scopes: Object.assign({}, collection.scopes, _defineProperty({}, key, scope))
  })(collection);
});

// getScope :: ScopeKey -> Collection -> Scope
var getScope = curry_(function (scopeKey, collection) {
  return collection.scopes[scopeKey];
});

// iterateScopes :: ((Scope, ScopeKey) -> *, (Scope, ScopeKey) -> Bool) -> Collection -> [*]
var iterateScopes = curry_(function (iterateFn, predicate, collection) {
  return Object.keys(collection.scopes).filter(function (key) {
    return predicate(collection.scopes[key], key);
  }).map(function (key) {
    return iterateFn(collection.scopes[key], key);
  });
});

// insertRecords :: [Record] -> Collection -> Collection
var insertRecords = function insertRecords(records) {
  return bind(insertToObjectMap(function (_ref3) {
    var records = _ref3.records;
    return records;
  }, getRecordId, records), setCollectionRecords);
};

// insertRecord :: Record -> Collection -> Collection
var insertRecord = function insertRecord(record) {
  return insertRecords([record]);
};

// insertDrafts :: [Draft] -> Collection -> Collection
var insertDrafts = function insertDrafts(drafts) {
  return bind(insertToObjectMap(function (_ref4) {
    var drafts = _ref4.drafts;
    return drafts;
  }, getRecordId, drafts), setDrafts);
};

// insertDraft :: Draft -> Collection -> Collection
var insertDraft = function insertDraft(draft) {
  return insertDrafts([draft]);
};

// removeRecord :: RecordId -> Collection -> Collection
var removeRecord = function removeRecord(recordId) {
  return bind(removeFromObjectMap(function (_ref5) {
    var records = _ref5.records;
    return records;
  }, recordId), setCollectionRecords);
};

// removeDraft :: Draft -> Collection -> Collection
var removeDraft = function removeDraft(draft) {
  return bind(removeFromObjectMap(function (_ref6) {
    var drafts = _ref6.drafts;
    return drafts;
  }, getRecordId(draft)), setDrafts);
};

// resetDraft :: (Draft, DefaultDraft) -> Collection -> Collection
var resetDraft = function resetDraft(draft, defaultDraft) {
  return bind(updateInObjectMap(function (_ref7) {
    var drafts = _ref7.drafts;
    return drafts;
  }, getRecordId(draft), function (d) {
    return createDraft(d, defaultDraft);
  }), setDrafts);
};

// updateScope :: ScopeKey -> (Scope -> Scope) -> Collection -> Collection
var updateScope = curry_(function (scopeKey, updateFn) {
  return bind(flow_(getScope(scopeKey), updateFn), setScope(scopeKey));
});

// storeQueryResults :: QueryResults -> Collection -> Collection
var storeQueryResults = function storeQueryResults(queryResult) {
  return queryResult.matchWith({
    Empty: function Empty() {
      return function (_) {
        return _;
      };
    },
    Results: function Results(_ref8) {
      var items = _ref8.items,
          totalCount = _ref8.totalCount,
          offset = _ref8.offset;
      return items.length > 0 ? insertRecords(items) : function (_) {
        return _;
      };
    }
  });
};

// updateRecordFields :: (RecordId, FieldsValues) -> Collection -> Collection
var updateRecordFields = function updateRecordFields(recordId, fieldValues) {
  return bind(updateInObjectMap(function (_ref9) {
    var drafts = _ref9.drafts;
    return drafts;
  }, recordId, function (draft) {
    return Object.assign({}, markRecordDirty(draft), fieldValues);
  }), setDrafts);
};

// doesRecordExist :: (Id, Collection) -> Bool
var doesRecordExist = function doesRecordExist(id, collection) {
  return !!collection.records[id];
};

// getDraftOrRecord :: (RecordOrDraftId, Collection) -> Maybe MergedRecord
var getDraftOrRecord = function getDraftOrRecord(id, collection) {
  if (isPlainObject_(collection.records[id])) {
    var mergedRecord = Object.assign({}, collection.records[id], collection.drafts[id]);

    return maybe.Just(mergedRecord);
  } else {
    return isPlainObject_(collection.drafts[id]) ? maybe.Just(Object.assign({}, collection.drafts[id])) : maybe.Nothing();
  }
};

// readFromCollection :: ScopeKey -> Integer -> Integer -> Collection -> Boolean -> QueryResults
var readFromCollection = curry_(function (scopeKey, fromIndex, toIndex, collection) {
  var allowMissing = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  var scope = getScope(scopeKey, collection);
  var numRequestedRecords = toIndex - fromIndex;
  var matchingRecords = scope.records.slice(fromIndex, toIndex);

  var hasRequestedMatchingItems = function hasRequestedMatchingItems(_ref10) {
    var items = _ref10.items;
    return allowMissing || numRequestedRecords > 0 && items.length >= numRequestedRecords;
  };
  var isNotSparse = function isNotSparse(_ref11) {
    var items = _ref11.items;
    return !(includes_(null, items) || includes_(undefined, items));
  };

  return queryResults.of({
    items: matchingRecords,
    totalCount: scope.numMatchingRecords,
    offset: fromIndex
  }).filter(hasRequestedMatchingItems).map(function (_ref12) {
    var items = _ref12.items,
        totalCount = _ref12.totalCount,
        offset = _ref12.offset;
    return {
      items: items.map(function (id) {
        return cleanseRecord(getDraftOrRecord(id, collection).getOrElse({}));
      }),
      totalCount: totalCount,
      offset: offset
    };
  }).filter(isNotSparse);
});

module.exports.doesRecordExist = doesRecordExist;
module.exports.freshCollection = freshCollection;
module.exports.getDraftOrRecord = getDraftOrRecord;
module.exports.getScope = getScope;
module.exports.insertDraft = insertDraft;
module.exports.insertRecord = insertRecord;
module.exports.iterateScopes = iterateScopes;
module.exports.readFromCollection = readFromCollection;
module.exports.removeDraft = removeDraft;
module.exports.removeRecord = removeRecord;
module.exports.resetDraft = resetDraft;
module.exports.setScope = setScope;
module.exports.storeQueryResults = storeQueryResults;
module.exports.updateRecordFields = updateRecordFields;
module.exports.updateScope = updateScope;

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var _require = __webpack_require__(10),
    createImmediateCmd = _require.createImmediateCmd;

var TYPE = 'FIRE_EVENT';
var executor = function executor(fireEvent, errorBoundaries) {
  return {
    type: TYPE,
    execute: function execute(cmd) {
      return errorBoundaries.userCodeZone(fireEvent).apply(undefined, [cmd.type].concat(_toConsumableArray(cmd.payload)));
    }
  };
};

var fireEventCmd = function fireEventCmd(type) {
  for (var _len = arguments.length, payload = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    payload[_key - 1] = arguments[_key];
  }

  return createImmediateCmd(TYPE, {
    type: type,
    payload: payload
  });
};

module.exports.executor = executor;

module.exports.fireEventCmd = fireEventCmd;

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Converts object to query string
 *
 * @param   {Object} data   a map to convert
 * @returns {String}        query string
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});
function mapToQuery(data) {
  var res = [];

  for (var key in data) {
    if (data.hasOwnProperty(key)) {
      // eslint-disable-line
      res.push(key + '=' + encodeURIComponent(data[key]));
    }
  }

  return res.join('&');
}

/**
 * Generates a valid GUID
 *
 * @returns {String}  GUID
 */
function generateGuid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0,
        v = c === 'x' ? r : r & 0x3 | 0x8; // eslint-disable-line
    return v.toString(16);
  });
}

exports.default = {
  mapToQuery: mapToQuery,
  generateGuid: generateGuid
};

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.publisherTypes = undefined;
exports.getPublisherByType = getPublisherByType;
exports.imagePublisher = imagePublisher;
exports.beaconPublisher = beaconPublisher;
exports.fetchPublisher = fetchPublisher;

var _pixel = __webpack_require__(483);

var _pixel2 = _interopRequireDefault(_pixel);

var _tools = __webpack_require__(189);

var _tools2 = _interopRequireDefault(_tools);

var _navigator = __webpack_require__(484);

var _env = __webpack_require__(191);

var _env2 = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var publisherTypes = exports.publisherTypes = {
  image: 'image',
  beacon: 'beacon',
  fetch: 'fetch'
};

function getPublisherByType(type) {
  var publisher = void 0;

  switch (type) {
    case publisherTypes.beacon:
      {
        publisher = beaconPublisher;
        break;
      }
    case publisherTypes.fetch:
      {
        publisher = fetchPublisher;
        break;
      }
    case publisherTypes.image:
      {
        publisher = imagePublisher;
        break;
      }
    default:
      {
        if ((0, _env.isWebWorker)() || !(0, _env2.env)().Image) {
          publisher = fetchPublisher;
        } else {
          publisher = imagePublisher;
        }
      }
  }

  return publisher;
}

function imagePublisher(baseUrl, data) {
  // eslint-disable-line func-names
  return _pixel2.default.fetch(baseUrl + '?' + _tools2.default.mapToQuery(data));
}

function beaconPublisher(baseUrl, data) {
  // eslint-disable-line func-names
  var url = baseUrl + '?' + _tools2.default.mapToQuery(data);
  return new Promise(function (resolve, reject) {
    return (0, _navigator.sendBeacon)(url) ? resolve(url) : reject(url);
  }).catch(function () {
    return imagePublisher(baseUrl, data);
  }).catch(function () {
    return fetchPublisher(baseUrl, data);
  });
}

function fetchPublisher(baseUrl, data) {
  // eslint-disable-line func-names
  return fetch(baseUrl + '?' + _tools2.default.mapToQuery(data), { credentials: 'include', method: 'GET' }).then(function (response) {
    if (!response.ok) {
      throw Error(response.status);
    }
    return response;
  });
}

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setHost = setHost;
exports.getHost = getHost;
exports.isWebWorker = isWebWorker;
exports.provideBrowsingContext = provideBrowsingContext;

var _env = __webpack_require__(6);

var host = 'frog.wix.com';

function setHost(_host) {
  host = _host;
}

function getHost() {
  return host;
}

function isWebWorker() {
  /* global WorkerGlobalScope */

  //At the moment, this is the most reliable way of detecting if current code is run in a worker
  //Taken from here: https://stackoverflow.com/a/18002694
  return typeof WorkerGlobalScope !== 'undefined' && self instanceof WorkerGlobalScope;
}

/**
 * Provides a window object to the callback iff current window is the topmost one
 * Otherwise returns null
 */
function provideBrowsingContext(cb) {
  if (typeof (0, _env.env)() !== 'undefined' && (0, _env.env)()) {
    try {
      return (0, _env.env)().top === (0, _env.env)().self ? cb ? cb((0, _env.env)()) : (0, _env.env)() : null;
    } catch (e) {
      return null;
    }
  }

  return null;
}

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dataSource = __webpack_require__(486);

var _dataSource2 = _interopRequireDefault(_dataSource);

var _biLoadPhaseItem = __webpack_require__(487);

var _biLoadPhaseItem2 = _interopRequireDefault(_biLoadPhaseItem);

var _durationItem = __webpack_require__(193);

var _durationItem2 = _interopRequireDefault(_durationItem);

var _biErrorItem = __webpack_require__(196);

var _biErrorItem2 = _interopRequireDefault(_biErrorItem);

var _performance = __webpack_require__(55);

var _performance2 = _interopRequireDefault(_performance);

var _resourceItem = __webpack_require__(488);

var _resourceItem2 = _interopRequireDefault(_resourceItem);

var _env = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Base Logger
 *
 * Before adding new parameters to the reported events, please make sure the BI schema supports them:
 * http://bo.wix.com/bi-catalog-webapp/#/sources/72
 */
var BaseLogger = function () {
  function BaseLogger(appName, appVersion, reporter, _ref) {
    var sessionId = _ref.sessionId,
        errorHandlerToggle = _ref.errorHandlerToggle,
        disableAutoLoadFinish = _ref.disableAutoLoadFinish;

    _classCallCheck(this, BaseLogger);

    this.appName = appName;
    this.appVersion = appVersion;
    this.reporter = reporter;
    this.params = { sessionId: sessionId };
    this.errorHandlerToggle = errorHandlerToggle;
    this.disableAutoLoadFinish = disableAutoLoadFinish;
    this.dataSource = new _dataSource2.default({ appName: appName });
    if (errorHandlerToggle) {
      (0, _env.env)().fedopsLoggerErrorHandler.subscribeListener(appName, this.reportError.bind(this));
    }
  }

  _createClass(BaseLogger, [{
    key: 'reportNetworkAnalysis',
    value: function reportNetworkAnalysis() {
      var _this = this;

      var resources = _performance2.default.getResources();
      setTimeout(function () {
        try {
          var resourceDataItem = new _resourceItem2.default(_this.sessionId);
          var analysis = resourceDataItem.performNetworkAnalysis(resources);
          if (!analysis) {
            return;
          }
          var dataSource = _this.dataSource.clone().addItem(resourceDataItem).addItem(analysis);
          _this._report(dataSource);
        } catch (e) {
          console.error('[fedops] Failed to report resource metrics', e);
        }
      }, 1000);
    }
  }, {
    key: 'reportError',
    value: function reportError(error, errorType, errorInfo) {
      var interactionName = void 0;

      if (!this._appLoadedCalled) {
        interactionName = '[APP LOAD]';
      } else {
        interactionName = Object.keys(this._outgoingInteractions)[0];
      }

      var dataSource = this.dataSource.clone().addItem({ interactionName: interactionName }).addItem({ errorType: errorType }).addItem({ errorInfo: errorInfo }).addItem(new _biErrorItem2.default(this.sessionId));

      // const stackTrace = error.stack;

      if (interactionName) {
        this._report(dataSource);
      }
    }
  }, {
    key: '_report',
    value: function _report(dataSource) {
      return this.reporter.report(dataSource.mergeItems());
    }
  }, {
    key: 'getAppName',
    value: function getAppName() {
      return this.appName;
    }
  }, {
    key: 'getAppVersion',
    value: function getAppVersion() {
      return this.appVersion;
    }
  }, {
    key: 'getReporter',
    value: function getReporter() {
      return this.reporter;
    }
  }, {
    key: 'getParam',
    value: function getParam(paramName) {
      return this.params[paramName];
    }
  }, {
    key: '_isDisableAutoLoadFinish',
    value: function _isDisableAutoLoadFinish() {
      return this.disableAutoLoadFinish;
    }
  }, {
    key: 'appLoadingPhase',


    /**
     * Custom phase (http://bo.wix.com/bi-catalog-webapp/#/sources/72/events/13)
     * Call this method to report custom phases during initial application load.
     *
     * @param {String} phaseName  phase name
     */
    value: function appLoadingPhase(phaseName) {
      var dataSource = this.dataSource.clone().addItem({ name: phaseName }).addItem(new _biLoadPhaseItem2.default(this.sessionId)).addItem(new _durationItem2.default());

      return this._report(dataSource);
    }
  }, {
    key: 'sessionId',
    get: function get() {
      return this.getParam('sessionId');
    }
  }]);

  return BaseLogger;
}();

exports.default = BaseLogger;

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _time = __webpack_require__(194);

var _time2 = _interopRequireDefault(_time);

var _dataItem = __webpack_require__(95);

var _dataItem2 = _interopRequireDefault(_dataItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DurationDataItem = function (_DataItem) {
  _inherits(DurationDataItem, _DataItem);

  function DurationDataItem(appName) {
    _classCallCheck(this, DurationDataItem);

    var _this = _possibleConstructorReturn(this, (DurationDataItem.__proto__ || Object.getPrototypeOf(DurationDataItem)).call(this, {
      duration: Math.floor(_time2.default.appLoadTime(appName))
    }));

    _this.appName = appName;
    return _this;
  }

  _createClass(DurationDataItem, [{
    key: 'setFirstRequestDuration',
    value: function setFirstRequestDuration() {
      this.data.frd = Math.floor(_time2.default.firstRequestDuration(this.appName));
      return this;
    }
  }]);

  return DurationDataItem;
}(_dataItem2.default);

exports.default = DurationDataItem;

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _appData = __webpack_require__(195);

var _appData2 = _interopRequireDefault(_appData);

var _performance = __webpack_require__(55);

var _performance2 = _interopRequireDefault(_performance);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function startLoadTime(appName) {
  return _appData2.default.getStartLoadTime(appName) || 0;
}

function endLoadTime() {
  return _performance2.default.now();
}

/**
 * calculates the app load time
 */
exports.default = {
  appLoadTime: function appLoadTime(appName) {
    return endLoadTime() - startLoadTime(appName);
  },
  loadStarted: function loadStarted(appName) {
    _appData2.default.setStartLoadTime(appName, _performance2.default.now());
  },
  firstRequestDuration: function firstRequestDuration(appName) {
    return startLoadTime(appName);
  }
};

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _env = __webpack_require__(6);

/**
 * env().fedops.apps wrapper (for tests mainly)
 */
function getAppData(appName) {
  return (0, _env.env)().fedops.apps[appName];
}

exports.default = {
  init: function init(appName) {
    (0, _env.env)().fedops.apps[appName] = (0, _env.env)().fedops.apps[appName] || {};
  },
  getStartLoadTime: function getStartLoadTime(appName) {
    var appData = getAppData(appName);
    if (!appData) {
      return null;
    }
    return appData.startLoadTime;
  },
  setStartLoadTime: function setStartLoadTime(appName, startLoadTime) {
    return getAppData(appName).startLoadTime = startLoadTime;
  }
};

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EVID = undefined;

var _biBaseItem = __webpack_require__(17);

var _biBaseItem2 = _interopRequireDefault(_biBaseItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EVID = exports.EVID = 17;
/**
 * Represents the "load finished" bi event:
 * http://bo.wix.com/bi-catalog-webapp/#/sources/72/events/11
 *
 * It should be used to monitor the initial application load.
 */

var BiErrorItem = function (_BiBaseDataItem) {
  _inherits(BiErrorItem, _BiBaseDataItem);

  function BiErrorItem(sessionId) {
    _classCallCheck(this, BiErrorItem);

    return _possibleConstructorReturn(this, (BiErrorItem.__proto__ || Object.getPrototypeOf(BiErrorItem)).call(this, EVID, sessionId));
  }

  return BiErrorItem;
}(_biBaseItem2.default);

exports.default = BiErrorItem;

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(198);
module.exports = __webpack_require__(199);


/***/ }),
/* 198 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ')
    preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = options.status === undefined ? 200 : options.status
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {
/* global SENTRY_DSN, USER_SENTRY_DSN, WIX_DATA_SENTRY_DSN, self */

var appName = 'dbsm-viewer-app';
var RavenConstructor = __webpack_require__(200);
var Raven = new RavenConstructor();
__webpack_require__(57)(Raven, self, "https://0821d2edbaaf494aa59dc98cacbcb7af@sentry.io/139045", {}, appName);
__webpack_require__(227)(Raven, self, appName);
var UserRaven = new RavenConstructor();
__webpack_require__(231)(UserRaven, self, "https://ab287a7d15904db8abf8f43937c14146@sentry.io/240637", {}, appName);
var WixDataRaven = new RavenConstructor();
__webpack_require__(57)(WixDataRaven, self, "https://b58591105c1c42be95f1e7a3d5b3755e@sentry.io/286440", {}, appName);

var _require = __webpack_require__(232),
    setupBiLogger = _require.setupBiLogger,
    setupErrorBiLogger = _require.setupErrorBiLogger;

var createWixData = __webpack_require__(245);
var createWixDataSchemas = __webpack_require__(256);
var createApp = __webpack_require__(260);

var errorReporter = function errorReporter(message, error) {
  return console.error(message, error);
}; // eslint-disable-line no-console

var app = createApp({
  wixDataCreator: function wixDataCreator() {
    return {
      wixData: createWixData(global.elementorySupport),
      wixDataSchemas: createWixDataSchemas(global.elementorySupport)
    };
  },
  elementorySupport: global.elementorySupport,
  errorReporter: errorReporter,
  Raven: Raven,
  UserRaven: UserRaven,
  WixDataRaven: WixDataRaven,
  biLogger: setupBiLogger(),
  errorBiLogger: setupErrorBiLogger()
});

module.exports = app;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/*global XDomainRequest:false */

var TraceKit = __webpack_require__(201);
var stringify = __webpack_require__(96);
var md5 = __webpack_require__(202);
var RavenConfigError = __webpack_require__(203);

var utils = __webpack_require__(56);
var isError = utils.isError;
var isObject = utils.isObject;
var isPlainObject = utils.isPlainObject;
var isErrorEvent = utils.isErrorEvent;
var isUndefined = utils.isUndefined;
var isFunction = utils.isFunction;
var isString = utils.isString;
var isArray = utils.isArray;
var isEmptyObject = utils.isEmptyObject;
var each = utils.each;
var objectMerge = utils.objectMerge;
var truncate = utils.truncate;
var objectFrozen = utils.objectFrozen;
var hasKey = utils.hasKey;
var joinRegExp = utils.joinRegExp;
var urlencode = utils.urlencode;
var uuid4 = utils.uuid4;
var htmlTreeAsString = utils.htmlTreeAsString;
var isSameException = utils.isSameException;
var isSameStacktrace = utils.isSameStacktrace;
var parseUrl = utils.parseUrl;
var fill = utils.fill;
var supportsFetch = utils.supportsFetch;
var supportsReferrerPolicy = utils.supportsReferrerPolicy;
var serializeKeysForMessage = utils.serializeKeysForMessage;
var serializeException = utils.serializeException;
var sanitize = utils.sanitize;

var wrapConsoleMethod = __webpack_require__(204).wrapMethod;

var dsnKeys = 'source protocol user pass host port path'.split(' '),
  dsnPattern = /^(?:(\w+):)?\/\/(?:(\w+)(:\w+)?@)?([\w\.-]+)(?::(\d+))?(\/.*)/;

function now() {
  return +new Date();
}

// This is to be defensive in environments where window does not exist (see https://github.com/getsentry/raven-js/pull/785)
var _window =
  typeof window !== 'undefined'
    ? window
    : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
var _document = _window.document;
var _navigator = _window.navigator;

function keepOriginalCallback(original, callback) {
  return isFunction(callback)
    ? function(data) {
        return callback(data, original);
      }
    : callback;
}

// First, check for JSON support
// If there is no JSON, we no-op the core features of Raven
// since JSON is required to encode the payload
function Raven() {
  this._hasJSON = !!(typeof JSON === 'object' && JSON.stringify);
  // Raven can run in contexts where there's no document (react-native)
  this._hasDocument = !isUndefined(_document);
  this._hasNavigator = !isUndefined(_navigator);
  this._lastCapturedException = null;
  this._lastData = null;
  this._lastEventId = null;
  this._globalServer = null;
  this._globalKey = null;
  this._globalProject = null;
  this._globalContext = {};
  this._globalOptions = {
    // SENTRY_RELEASE can be injected by https://github.com/getsentry/sentry-webpack-plugin
    release: _window.SENTRY_RELEASE && _window.SENTRY_RELEASE.id,
    logger: 'javascript',
    ignoreErrors: [],
    ignoreUrls: [],
    whitelistUrls: [],
    includePaths: [],
    headers: null,
    collectWindowErrors: true,
    captureUnhandledRejections: true,
    maxMessageLength: 0,
    // By default, truncates URL values to 250 chars
    maxUrlLength: 250,
    stackTraceLimit: 50,
    autoBreadcrumbs: true,
    instrument: true,
    sampleRate: 1,
    sanitizeKeys: []
  };
  this._fetchDefaults = {
    method: 'POST',
    keepalive: true,
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default
    // https://caniuse.com/#feat=referrer-policy
    // It doesn't. And it throw exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    referrerPolicy: supportsReferrerPolicy() ? 'origin' : ''
  };
  this._ignoreOnError = 0;
  this._isRavenInstalled = false;
  this._originalErrorStackTraceLimit = Error.stackTraceLimit;
  // capture references to window.console *and* all its methods first
  // before the console plugin has a chance to monkey patch
  this._originalConsole = _window.console || {};
  this._originalConsoleMethods = {};
  this._plugins = [];
  this._startTime = now();
  this._wrappedBuiltIns = [];
  this._breadcrumbs = [];
  this._lastCapturedEvent = null;
  this._keypressTimeout;
  this._location = _window.location;
  this._lastHref = this._location && this._location.href;
  this._resetBackoff();

  // eslint-disable-next-line guard-for-in
  for (var method in this._originalConsole) {
    this._originalConsoleMethods[method] = this._originalConsole[method];
  }
}

/*
 * The core Raven singleton
 *
 * @this {Raven}
 */

Raven.prototype = {
  // Hardcode version string so that raven source can be loaded directly via
  // webpack (using a build step causes webpack #1617). Grunt verifies that
  // this value matches package.json during build.
  //   See: https://github.com/getsentry/raven-js/issues/465
  VERSION: '3.24.2',

  debug: false,

  TraceKit: TraceKit, // alias to TraceKit

  /*
     * Configure Raven with a DSN and extra options
     *
     * @param {string} dsn The public Sentry DSN
     * @param {object} options Set of global options [optional]
     * @return {Raven}
     */
  config: function(dsn, options) {
    var self = this;

    if (self._globalServer) {
      this._logDebug('error', 'Error: Raven has already been configured');
      return self;
    }
    if (!dsn) return self;

    var globalOptions = self._globalOptions;

    // merge in options
    if (options) {
      each(options, function(key, value) {
        // tags and extra are special and need to be put into context
        if (key === 'tags' || key === 'extra' || key === 'user') {
          self._globalContext[key] = value;
        } else {
          globalOptions[key] = value;
        }
      });
    }

    self.setDSN(dsn);

    // "Script error." is hard coded into browsers for errors that it can't read.
    // this is the result of a script being pulled in from an external domain and CORS.
    globalOptions.ignoreErrors.push(/^Script error\.?$/);
    globalOptions.ignoreErrors.push(/^Javascript error: Script error\.? on line 0$/);

    // join regexp rules into one big rule
    globalOptions.ignoreErrors = joinRegExp(globalOptions.ignoreErrors);
    globalOptions.ignoreUrls = globalOptions.ignoreUrls.length
      ? joinRegExp(globalOptions.ignoreUrls)
      : false;
    globalOptions.whitelistUrls = globalOptions.whitelistUrls.length
      ? joinRegExp(globalOptions.whitelistUrls)
      : false;
    globalOptions.includePaths = joinRegExp(globalOptions.includePaths);
    globalOptions.maxBreadcrumbs = Math.max(
      0,
      Math.min(globalOptions.maxBreadcrumbs || 100, 100)
    ); // default and hard limit is 100

    var autoBreadcrumbDefaults = {
      xhr: true,
      console: true,
      dom: true,
      location: true,
      sentry: true
    };

    var autoBreadcrumbs = globalOptions.autoBreadcrumbs;
    if ({}.toString.call(autoBreadcrumbs) === '[object Object]') {
      autoBreadcrumbs = objectMerge(autoBreadcrumbDefaults, autoBreadcrumbs);
    } else if (autoBreadcrumbs !== false) {
      autoBreadcrumbs = autoBreadcrumbDefaults;
    }
    globalOptions.autoBreadcrumbs = autoBreadcrumbs;

    var instrumentDefaults = {
      tryCatch: true
    };

    var instrument = globalOptions.instrument;
    if ({}.toString.call(instrument) === '[object Object]') {
      instrument = objectMerge(instrumentDefaults, instrument);
    } else if (instrument !== false) {
      instrument = instrumentDefaults;
    }
    globalOptions.instrument = instrument;

    TraceKit.collectWindowErrors = !!globalOptions.collectWindowErrors;

    // return for chaining
    return self;
  },

  /*
     * Installs a global window.onerror error handler
     * to capture and report uncaught exceptions.
     * At this point, install() is required to be called due
     * to the way TraceKit is set up.
     *
     * @return {Raven}
     */
  install: function() {
    var self = this;
    if (self.isSetup() && !self._isRavenInstalled) {
      TraceKit.report.subscribe(function() {
        self._handleOnErrorStackInfo.apply(self, arguments);
      });

      if (self._globalOptions.captureUnhandledRejections) {
        self._attachPromiseRejectionHandler();
      }

      self._patchFunctionToString();

      if (self._globalOptions.instrument && self._globalOptions.instrument.tryCatch) {
        self._instrumentTryCatch();
      }

      if (self._globalOptions.autoBreadcrumbs) self._instrumentBreadcrumbs();

      // Install all of the plugins
      self._drainPlugins();

      self._isRavenInstalled = true;
    }

    Error.stackTraceLimit = self._globalOptions.stackTraceLimit;
    return this;
  },

  /*
     * Set the DSN (can be called multiple time unlike config)
     *
     * @param {string} dsn The public Sentry DSN
     */
  setDSN: function(dsn) {
    var self = this,
      uri = self._parseDSN(dsn),
      lastSlash = uri.path.lastIndexOf('/'),
      path = uri.path.substr(1, lastSlash);

    self._dsn = dsn;
    self._globalKey = uri.user;
    self._globalSecret = uri.pass && uri.pass.substr(1);
    self._globalProject = uri.path.substr(lastSlash + 1);

    self._globalServer = self._getGlobalServer(uri);

    self._globalEndpoint =
      self._globalServer + '/' + path + 'api/' + self._globalProject + '/store/';

    // Reset backoff state since we may be pointing at a
    // new project/server
    this._resetBackoff();
  },

  /*
     * Wrap code within a context so Raven can capture errors
     * reliably across domains that is executed immediately.
     *
     * @param {object} options A specific set of options for this context [optional]
     * @param {function} func The callback to be immediately executed within the context
     * @param {array} args An array of arguments to be called with the callback [optional]
     */
  context: function(options, func, args) {
    if (isFunction(options)) {
      args = func || [];
      func = options;
      options = undefined;
    }

    return this.wrap(options, func).apply(this, args);
  },

  /*
     * Wrap code within a context and returns back a new function to be executed
     *
     * @param {object} options A specific set of options for this context [optional]
     * @param {function} func The function to be wrapped in a new context
     * @param {function} func A function to call before the try/catch wrapper [optional, private]
     * @return {function} The newly wrapped functions with a context
     */
  wrap: function(options, func, _before) {
    var self = this;
    // 1 argument has been passed, and it's not a function
    // so just return it
    if (isUndefined(func) && !isFunction(options)) {
      return options;
    }

    // options is optional
    if (isFunction(options)) {
      func = options;
      options = undefined;
    }

    // At this point, we've passed along 2 arguments, and the second one
    // is not a function either, so we'll just return the second argument.
    if (!isFunction(func)) {
      return func;
    }

    // We don't wanna wrap it twice!
    try {
      if (func.__raven__) {
        return func;
      }

      // If this has already been wrapped in the past, return that
      if (func.__raven_wrapper__) {
        return func.__raven_wrapper__;
      }
    } catch (e) {
      // Just accessing custom props in some Selenium environments
      // can cause a "Permission denied" exception (see raven-js#495).
      // Bail on wrapping and return the function as-is (defers to window.onerror).
      return func;
    }

    function wrapped() {
      var args = [],
        i = arguments.length,
        deep = !options || (options && options.deep !== false);

      if (_before && isFunction(_before)) {
        _before.apply(this, arguments);
      }

      // Recursively wrap all of a function's arguments that are
      // functions themselves.
      while (i--) args[i] = deep ? self.wrap(options, arguments[i]) : arguments[i];

      try {
        // Attempt to invoke user-land function
        // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
        //       means Raven caught an error invoking your application code. This is
        //       expected behavior and NOT indicative of a bug with Raven.js.
        return func.apply(this, args);
      } catch (e) {
        self._ignoreNextOnError();
        self.captureException(e, options);
        throw e;
      }
    }

    // copy over properties of the old function
    for (var property in func) {
      if (hasKey(func, property)) {
        wrapped[property] = func[property];
      }
    }
    wrapped.prototype = func.prototype;

    func.__raven_wrapper__ = wrapped;
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    wrapped.__raven__ = true;
    wrapped.__orig__ = func;

    return wrapped;
  },

  /**
   * Uninstalls the global error handler.
   *
   * @return {Raven}
   */
  uninstall: function() {
    TraceKit.report.uninstall();

    this._detachPromiseRejectionHandler();
    this._unpatchFunctionToString();
    this._restoreBuiltIns();
    this._restoreConsole();

    Error.stackTraceLimit = this._originalErrorStackTraceLimit;
    this._isRavenInstalled = false;

    return this;
  },

  /**
   * Callback used for `unhandledrejection` event
   *
   * @param {PromiseRejectionEvent} event An object containing
   *   promise: the Promise that was rejected
   *   reason: the value with which the Promise was rejected
   * @return void
   */
  _promiseRejectionHandler: function(event) {
    this._logDebug('debug', 'Raven caught unhandled promise rejection:', event);
    this.captureException(event.reason, {
      extra: {
        unhandledPromiseRejection: true
      }
    });
  },

  /**
   * Installs the global promise rejection handler.
   *
   * @return {raven}
   */
  _attachPromiseRejectionHandler: function() {
    this._promiseRejectionHandler = this._promiseRejectionHandler.bind(this);
    _window.addEventListener &&
      _window.addEventListener('unhandledrejection', this._promiseRejectionHandler);
    return this;
  },

  /**
   * Uninstalls the global promise rejection handler.
   *
   * @return {raven}
   */
  _detachPromiseRejectionHandler: function() {
    _window.removeEventListener &&
      _window.removeEventListener('unhandledrejection', this._promiseRejectionHandler);
    return this;
  },

  /**
   * Manually capture an exception and send it over to Sentry
   *
   * @param {error} ex An exception to be logged
   * @param {object} options A specific set of options for this error [optional]
   * @return {Raven}
   */
  captureException: function(ex, options) {
    options = objectMerge({trimHeadFrames: 0}, options ? options : {});

    if (isErrorEvent(ex) && ex.error) {
      // If it is an ErrorEvent with `error` property, extract it to get actual Error
      ex = ex.error;
    } else if (isError(ex)) {
      // we have a real Error object
      ex = ex;
    } else if (isPlainObject(ex)) {
      // If it is plain Object, serialize it manually and extract options
      // This will allow us to group events based on top-level keys
      // which is much better than creating new group when any key/value change
      options = this._getCaptureExceptionOptionsFromPlainObject(options, ex);
      ex = new Error(options.message);
    } else {
      // If none of previous checks were valid, then it means that
      // it's not a plain Object
      // it's not a valid ErrorEvent (one with an error property)
      // it's not an Error
      // So bail out and capture it as a simple message:
      return this.captureMessage(
        ex,
        objectMerge(options, {
          stacktrace: true, // if we fall back to captureMessage, default to attempting a new trace
          trimHeadFrames: options.trimHeadFrames + 1
        })
      );
    }

    // Store the raw exception object for potential debugging and introspection
    this._lastCapturedException = ex;

    // TraceKit.report will re-raise any exception passed to it,
    // which means you have to wrap it in try/catch. Instead, we
    // can wrap it here and only re-raise if TraceKit.report
    // raises an exception different from the one we asked to
    // report on.
    try {
      var stack = TraceKit.computeStackTrace(ex);
      this._handleStackInfo(stack, options);
    } catch (ex1) {
      if (ex !== ex1) {
        throw ex1;
      }
    }

    return this;
  },

  _getCaptureExceptionOptionsFromPlainObject: function(currentOptions, ex) {
    var exKeys = Object.keys(ex).sort();
    var options = objectMerge(currentOptions, {
      message:
        'Non-Error exception captured with keys: ' + serializeKeysForMessage(exKeys),
      fingerprint: [md5(exKeys)],
      extra: currentOptions.extra || {}
    });
    options.extra.__serialized__ = serializeException(ex);

    return options;
  },

  /*
     * Manually send a message to Sentry
     *
     * @param {string} msg A plain message to be captured in Sentry
     * @param {object} options A specific set of options for this message [optional]
     * @return {Raven}
     */
  captureMessage: function(msg, options) {
    // config() automagically converts ignoreErrors from a list to a RegExp so we need to test for an
    // early call; we'll error on the side of logging anything called before configuration since it's
    // probably something you should see:
    if (
      !!this._globalOptions.ignoreErrors.test &&
      this._globalOptions.ignoreErrors.test(msg)
    ) {
      return;
    }

    options = options || {};
    msg = msg + ''; // Make sure it's actually a string

    var data = objectMerge(
      {
        message: msg
      },
      options
    );

    var ex;
    // Generate a "synthetic" stack trace from this point.
    // NOTE: If you are a Sentry user, and you are seeing this stack frame, it is NOT indicative
    //       of a bug with Raven.js. Sentry generates synthetic traces either by configuration,
    //       or if it catches a thrown object without a "stack" property.
    try {
      throw new Error(msg);
    } catch (ex1) {
      ex = ex1;
    }

    // null exception name so `Error` isn't prefixed to msg
    ex.name = null;
    var stack = TraceKit.computeStackTrace(ex);

    // stack[0] is `throw new Error(msg)` call itself, we are interested in the frame that was just before that, stack[1]
    var initialCall = isArray(stack.stack) && stack.stack[1];

    // if stack[1] is `Raven.captureException`, it means that someone passed a string to it and we redirected that call
    // to be handled by `captureMessage`, thus `initialCall` is the 3rd one, not 2nd
    // initialCall => captureException(string) => captureMessage(string)
    if (initialCall && initialCall.func === 'Raven.captureException') {
      initialCall = stack.stack[2];
    }

    var fileurl = (initialCall && initialCall.url) || '';

    if (
      !!this._globalOptions.ignoreUrls.test &&
      this._globalOptions.ignoreUrls.test(fileurl)
    ) {
      return;
    }

    if (
      !!this._globalOptions.whitelistUrls.test &&
      !this._globalOptions.whitelistUrls.test(fileurl)
    ) {
      return;
    }

    if (this._globalOptions.stacktrace || (options && options.stacktrace)) {
      // fingerprint on msg, not stack trace (legacy behavior, could be revisited)
      data.fingerprint = data.fingerprint == null ? msg : data.fingerprint;

      options = objectMerge(
        {
          trimHeadFrames: 0
        },
        options
      );
      // Since we know this is a synthetic trace, the top frame (this function call)
      // MUST be from Raven.js, so mark it for trimming
      // We add to the trim counter so that callers can choose to trim extra frames, such
      // as utility functions.
      options.trimHeadFrames += 1;

      var frames = this._prepareFrames(stack, options);
      data.stacktrace = {
        // Sentry expects frames oldest to newest
        frames: frames.reverse()
      };
    }

    // Make sure that fingerprint is always wrapped in an array
    if (data.fingerprint) {
      data.fingerprint = isArray(data.fingerprint)
        ? data.fingerprint
        : [data.fingerprint];
    }

    // Fire away!
    this._send(data);

    return this;
  },

  captureBreadcrumb: function(obj) {
    var crumb = objectMerge(
      {
        timestamp: now() / 1000
      },
      obj
    );

    if (isFunction(this._globalOptions.breadcrumbCallback)) {
      var result = this._globalOptions.breadcrumbCallback(crumb);

      if (isObject(result) && !isEmptyObject(result)) {
        crumb = result;
      } else if (result === false) {
        return this;
      }
    }

    this._breadcrumbs.push(crumb);
    if (this._breadcrumbs.length > this._globalOptions.maxBreadcrumbs) {
      this._breadcrumbs.shift();
    }
    return this;
  },

  addPlugin: function(plugin /*arg1, arg2, ... argN*/) {
    var pluginArgs = [].slice.call(arguments, 1);

    this._plugins.push([plugin, pluginArgs]);
    if (this._isRavenInstalled) {
      this._drainPlugins();
    }

    return this;
  },

  /*
     * Set/clear a user to be sent along with the payload.
     *
     * @param {object} user An object representing user data [optional]
     * @return {Raven}
     */
  setUserContext: function(user) {
    // Intentionally do not merge here since that's an unexpected behavior.
    this._globalContext.user = user;

    return this;
  },

  /*
     * Merge extra attributes to be sent along with the payload.
     *
     * @param {object} extra An object representing extra data [optional]
     * @return {Raven}
     */
  setExtraContext: function(extra) {
    this._mergeContext('extra', extra);

    return this;
  },

  /*
     * Merge tags to be sent along with the payload.
     *
     * @param {object} tags An object representing tags [optional]
     * @return {Raven}
     */
  setTagsContext: function(tags) {
    this._mergeContext('tags', tags);

    return this;
  },

  /*
     * Clear all of the context.
     *
     * @return {Raven}
     */
  clearContext: function() {
    this._globalContext = {};

    return this;
  },

  /*
     * Get a copy of the current context. This cannot be mutated.
     *
     * @return {object} copy of context
     */
  getContext: function() {
    // lol javascript
    return JSON.parse(stringify(this._globalContext));
  },

  /*
     * Set environment of application
     *
     * @param {string} environment Typically something like 'production'.
     * @return {Raven}
     */
  setEnvironment: function(environment) {
    this._globalOptions.environment = environment;

    return this;
  },

  /*
     * Set release version of application
     *
     * @param {string} release Typically something like a git SHA to identify version
     * @return {Raven}
     */
  setRelease: function(release) {
    this._globalOptions.release = release;

    return this;
  },

  /*
     * Set the dataCallback option
     *
     * @param {function} callback The callback to run which allows the
     *                            data blob to be mutated before sending
     * @return {Raven}
     */
  setDataCallback: function(callback) {
    var original = this._globalOptions.dataCallback;
    this._globalOptions.dataCallback = keepOriginalCallback(original, callback);
    return this;
  },

  /*
     * Set the breadcrumbCallback option
     *
     * @param {function} callback The callback to run which allows filtering
     *                            or mutating breadcrumbs
     * @return {Raven}
     */
  setBreadcrumbCallback: function(callback) {
    var original = this._globalOptions.breadcrumbCallback;
    this._globalOptions.breadcrumbCallback = keepOriginalCallback(original, callback);
    return this;
  },

  /*
     * Set the shouldSendCallback option
     *
     * @param {function} callback The callback to run which allows
     *                            introspecting the blob before sending
     * @return {Raven}
     */
  setShouldSendCallback: function(callback) {
    var original = this._globalOptions.shouldSendCallback;
    this._globalOptions.shouldSendCallback = keepOriginalCallback(original, callback);
    return this;
  },

  /**
   * Override the default HTTP transport mechanism that transmits data
   * to the Sentry server.
   *
   * @param {function} transport Function invoked instead of the default
   *                             `makeRequest` handler.
   *
   * @return {Raven}
   */
  setTransport: function(transport) {
    this._globalOptions.transport = transport;

    return this;
  },

  /*
     * Get the latest raw exception that was captured by Raven.
     *
     * @return {error}
     */
  lastException: function() {
    return this._lastCapturedException;
  },

  /*
     * Get the last event id
     *
     * @return {string}
     */
  lastEventId: function() {
    return this._lastEventId;
  },

  /*
     * Determine if Raven is setup and ready to go.
     *
     * @return {boolean}
     */
  isSetup: function() {
    if (!this._hasJSON) return false; // needs JSON support
    if (!this._globalServer) {
      if (!this.ravenNotConfiguredError) {
        this.ravenNotConfiguredError = true;
        this._logDebug('error', 'Error: Raven has not been configured.');
      }
      return false;
    }
    return true;
  },

  afterLoad: function() {
    // TODO: remove window dependence?

    // Attempt to initialize Raven on load
    var RavenConfig = _window.RavenConfig;
    if (RavenConfig) {
      this.config(RavenConfig.dsn, RavenConfig.config).install();
    }
  },

  showReportDialog: function(options) {
    if (
      !_document // doesn't work without a document (React native)
    )
      return;

    options = options || {};

    var lastEventId = options.eventId || this.lastEventId();
    if (!lastEventId) {
      throw new RavenConfigError('Missing eventId');
    }

    var dsn = options.dsn || this._dsn;
    if (!dsn) {
      throw new RavenConfigError('Missing DSN');
    }

    var encode = encodeURIComponent;
    var qs = '';
    qs += '?eventId=' + encode(lastEventId);
    qs += '&dsn=' + encode(dsn);

    var user = options.user || this._globalContext.user;
    if (user) {
      if (user.name) qs += '&name=' + encode(user.name);
      if (user.email) qs += '&email=' + encode(user.email);
    }

    var globalServer = this._getGlobalServer(this._parseDSN(dsn));

    var script = _document.createElement('script');
    script.async = true;
    script.src = globalServer + '/api/embed/error-page/' + qs;
    (_document.head || _document.body).appendChild(script);
  },

  /**** Private functions ****/
  _ignoreNextOnError: function() {
    var self = this;
    this._ignoreOnError += 1;
    setTimeout(function() {
      // onerror should trigger before setTimeout
      self._ignoreOnError -= 1;
    });
  },

  _triggerEvent: function(eventType, options) {
    // NOTE: `event` is a native browser thing, so let's avoid conflicting wiht it
    var evt, key;

    if (!this._hasDocument) return;

    options = options || {};

    eventType = 'raven' + eventType.substr(0, 1).toUpperCase() + eventType.substr(1);

    if (_document.createEvent) {
      evt = _document.createEvent('HTMLEvents');
      evt.initEvent(eventType, true, true);
    } else {
      evt = _document.createEventObject();
      evt.eventType = eventType;
    }

    for (key in options)
      if (hasKey(options, key)) {
        evt[key] = options[key];
      }

    if (_document.createEvent) {
      // IE9 if standards
      _document.dispatchEvent(evt);
    } else {
      // IE8 regardless of Quirks or Standards
      // IE9 if quirks
      try {
        _document.fireEvent('on' + evt.eventType.toLowerCase(), evt);
      } catch (e) {
        // Do nothing
      }
    }
  },

  /**
   * Wraps addEventListener to capture UI breadcrumbs
   * @param evtName the event name (e.g. "click")
   * @returns {Function}
   * @private
   */
  _breadcrumbEventHandler: function(evtName) {
    var self = this;
    return function(evt) {
      // reset keypress timeout; e.g. triggering a 'click' after
      // a 'keypress' will reset the keypress debounce so that a new
      // set of keypresses can be recorded
      self._keypressTimeout = null;

      // It's possible this handler might trigger multiple times for the same
      // event (e.g. event propagation through node ancestors). Ignore if we've
      // already captured the event.
      if (self._lastCapturedEvent === evt) return;

      self._lastCapturedEvent = evt;

      // try/catch both:
      // - accessing evt.target (see getsentry/raven-js#838, #768)
      // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
      //   can throw an exception in some circumstances.
      var target;
      try {
        target = htmlTreeAsString(evt.target);
      } catch (e) {
        target = '<unknown>';
      }

      self.captureBreadcrumb({
        category: 'ui.' + evtName, // e.g. ui.click, ui.input
        message: target
      });
    };
  },

  /**
   * Wraps addEventListener to capture keypress UI events
   * @returns {Function}
   * @private
   */
  _keypressEventHandler: function() {
    var self = this,
      debounceDuration = 1000; // milliseconds

    // TODO: if somehow user switches keypress target before
    //       debounce timeout is triggered, we will only capture
    //       a single breadcrumb from the FIRST target (acceptable?)
    return function(evt) {
      var target;
      try {
        target = evt.target;
      } catch (e) {
        // just accessing event properties can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/raven-js/issues/838
        return;
      }
      var tagName = target && target.tagName;

      // only consider keypress events on actual input elements
      // this will disregard keypresses targeting body (e.g. tabbing
      // through elements, hotkeys, etc)
      if (
        !tagName ||
        (tagName !== 'INPUT' && tagName !== 'TEXTAREA' && !target.isContentEditable)
      )
        return;

      // record first keypress in a series, but ignore subsequent
      // keypresses until debounce clears
      var timeout = self._keypressTimeout;
      if (!timeout) {
        self._breadcrumbEventHandler('input')(evt);
      }
      clearTimeout(timeout);
      self._keypressTimeout = setTimeout(function() {
        self._keypressTimeout = null;
      }, debounceDuration);
    };
  },

  /**
   * Captures a breadcrumb of type "navigation", normalizing input URLs
   * @param to the originating URL
   * @param from the target URL
   * @private
   */
  _captureUrlChange: function(from, to) {
    var parsedLoc = parseUrl(this._location.href);
    var parsedTo = parseUrl(to);
    var parsedFrom = parseUrl(from);

    // because onpopstate only tells you the "new" (to) value of location.href, and
    // not the previous (from) value, we need to track the value of the current URL
    // state ourselves
    this._lastHref = to;

    // Use only the path component of the URL if the URL matches the current
    // document (almost all the time when using pushState)
    if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host)
      to = parsedTo.relative;
    if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host)
      from = parsedFrom.relative;

    this.captureBreadcrumb({
      category: 'navigation',
      data: {
        to: to,
        from: from
      }
    });
  },

  _patchFunctionToString: function() {
    var self = this;
    self._originalFunctionToString = Function.prototype.toString;
    // eslint-disable-next-line no-extend-native
    Function.prototype.toString = function() {
      if (typeof this === 'function' && this.__raven__) {
        return self._originalFunctionToString.apply(this.__orig__, arguments);
      }
      return self._originalFunctionToString.apply(this, arguments);
    };
  },

  _unpatchFunctionToString: function() {
    if (this._originalFunctionToString) {
      // eslint-disable-next-line no-extend-native
      Function.prototype.toString = this._originalFunctionToString;
    }
  },

  /**
   * Wrap timer functions and event targets to catch errors and provide
   * better metadata.
   */
  _instrumentTryCatch: function() {
    var self = this;

    var wrappedBuiltIns = self._wrappedBuiltIns;

    function wrapTimeFn(orig) {
      return function(fn, t) {
        // preserve arity
        // Make a copy of the arguments to prevent deoptimization
        // https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#32-leaking-arguments
        var args = new Array(arguments.length);
        for (var i = 0; i < args.length; ++i) {
          args[i] = arguments[i];
        }
        var originalCallback = args[0];
        if (isFunction(originalCallback)) {
          args[0] = self.wrap(originalCallback);
        }

        // IE < 9 doesn't support .call/.apply on setInterval/setTimeout, but it
        // also supports only two arguments and doesn't care what this is, so we
        // can just call the original function directly.
        if (orig.apply) {
          return orig.apply(this, args);
        } else {
          return orig(args[0], args[1]);
        }
      };
    }

    var autoBreadcrumbs = this._globalOptions.autoBreadcrumbs;

    function wrapEventTarget(global) {
      var proto = _window[global] && _window[global].prototype;
      if (proto && proto.hasOwnProperty && proto.hasOwnProperty('addEventListener')) {
        fill(
          proto,
          'addEventListener',
          function(orig) {
            return function(evtName, fn, capture, secure) {
              // preserve arity
              try {
                if (fn && fn.handleEvent) {
                  fn.handleEvent = self.wrap(fn.handleEvent);
                }
              } catch (err) {
                // can sometimes get 'Permission denied to access property "handle Event'
              }

              // More breadcrumb DOM capture ... done here and not in `_instrumentBreadcrumbs`
              // so that we don't have more than one wrapper function
              var before, clickHandler, keypressHandler;

              if (
                autoBreadcrumbs &&
                autoBreadcrumbs.dom &&
                (global === 'EventTarget' || global === 'Node')
              ) {
                // NOTE: generating multiple handlers per addEventListener invocation, should
                //       revisit and verify we can just use one (almost certainly)
                clickHandler = self._breadcrumbEventHandler('click');
                keypressHandler = self._keypressEventHandler();
                before = function(evt) {
                  // need to intercept every DOM event in `before` argument, in case that
                  // same wrapped method is re-used for different events (e.g. mousemove THEN click)
                  // see #724
                  if (!evt) return;

                  var eventType;
                  try {
                    eventType = evt.type;
                  } catch (e) {
                    // just accessing event properties can throw an exception in some rare circumstances
                    // see: https://github.com/getsentry/raven-js/issues/838
                    return;
                  }
                  if (eventType === 'click') return clickHandler(evt);
                  else if (eventType === 'keypress') return keypressHandler(evt);
                };
              }
              return orig.call(
                this,
                evtName,
                self.wrap(fn, undefined, before),
                capture,
                secure
              );
            };
          },
          wrappedBuiltIns
        );
        fill(
          proto,
          'removeEventListener',
          function(orig) {
            return function(evt, fn, capture, secure) {
              try {
                fn = fn && (fn.__raven_wrapper__ ? fn.__raven_wrapper__ : fn);
              } catch (e) {
                // ignore, accessing __raven_wrapper__ will throw in some Selenium environments
              }
              return orig.call(this, evt, fn, capture, secure);
            };
          },
          wrappedBuiltIns
        );
      }
    }

    fill(_window, 'setTimeout', wrapTimeFn, wrappedBuiltIns);
    fill(_window, 'setInterval', wrapTimeFn, wrappedBuiltIns);
    if (_window.requestAnimationFrame) {
      fill(
        _window,
        'requestAnimationFrame',
        function(orig) {
          return function(cb) {
            return orig(self.wrap(cb));
          };
        },
        wrappedBuiltIns
      );
    }

    // event targets borrowed from bugsnag-js:
    // https://github.com/bugsnag/bugsnag-js/blob/master/src/bugsnag.js#L666
    var eventTargets = [
      'EventTarget',
      'Window',
      'Node',
      'ApplicationCache',
      'AudioTrackList',
      'ChannelMergerNode',
      'CryptoOperation',
      'EventSource',
      'FileReader',
      'HTMLUnknownElement',
      'IDBDatabase',
      'IDBRequest',
      'IDBTransaction',
      'KeyOperation',
      'MediaController',
      'MessagePort',
      'ModalWindow',
      'Notification',
      'SVGElementInstance',
      'Screen',
      'TextTrack',
      'TextTrackCue',
      'TextTrackList',
      'WebSocket',
      'WebSocketWorker',
      'Worker',
      'XMLHttpRequest',
      'XMLHttpRequestEventTarget',
      'XMLHttpRequestUpload'
    ];
    for (var i = 0; i < eventTargets.length; i++) {
      wrapEventTarget(eventTargets[i]);
    }
  },

  /**
   * Instrument browser built-ins w/ breadcrumb capturing
   *  - XMLHttpRequests
   *  - DOM interactions (click/typing)
   *  - window.location changes
   *  - console
   *
   * Can be disabled or individually configured via the `autoBreadcrumbs` config option
   */
  _instrumentBreadcrumbs: function() {
    var self = this;
    var autoBreadcrumbs = this._globalOptions.autoBreadcrumbs;

    var wrappedBuiltIns = self._wrappedBuiltIns;

    function wrapProp(prop, xhr) {
      if (prop in xhr && isFunction(xhr[prop])) {
        fill(xhr, prop, function(orig) {
          return self.wrap(orig);
        }); // intentionally don't track filled methods on XHR instances
      }
    }

    if (autoBreadcrumbs.xhr && 'XMLHttpRequest' in _window) {
      var xhrproto = _window.XMLHttpRequest && _window.XMLHttpRequest.prototype;
      fill(
        xhrproto,
        'open',
        function(origOpen) {
          return function(method, url) {
            // preserve arity

            // if Sentry key appears in URL, don't capture
            if (isString(url) && url.indexOf(self._globalKey) === -1) {
              this.__raven_xhr = {
                method: method,
                url: url,
                status_code: null
              };
            }

            return origOpen.apply(this, arguments);
          };
        },
        wrappedBuiltIns
      );

      fill(
        xhrproto,
        'send',
        function(origSend) {
          return function() {
            // preserve arity
            var xhr = this;

            function onreadystatechangeHandler() {
              if (xhr.__raven_xhr && xhr.readyState === 4) {
                try {
                  // touching statusCode in some platforms throws
                  // an exception
                  xhr.__raven_xhr.status_code = xhr.status;
                } catch (e) {
                  /* do nothing */
                }

                self.captureBreadcrumb({
                  type: 'http',
                  category: 'xhr',
                  data: xhr.__raven_xhr
                });
              }
            }

            var props = ['onload', 'onerror', 'onprogress'];
            for (var j = 0; j < props.length; j++) {
              wrapProp(props[j], xhr);
            }

            if ('onreadystatechange' in xhr && isFunction(xhr.onreadystatechange)) {
              fill(
                xhr,
                'onreadystatechange',
                function(orig) {
                  return self.wrap(orig, undefined, onreadystatechangeHandler);
                } /* intentionally don't track this instrumentation */
              );
            } else {
              // if onreadystatechange wasn't actually set by the page on this xhr, we
              // are free to set our own and capture the breadcrumb
              xhr.onreadystatechange = onreadystatechangeHandler;
            }

            return origSend.apply(this, arguments);
          };
        },
        wrappedBuiltIns
      );
    }

    if (autoBreadcrumbs.xhr && supportsFetch()) {
      fill(
        _window,
        'fetch',
        function(origFetch) {
          return function() {
            // preserve arity
            // Make a copy of the arguments to prevent deoptimization
            // https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#32-leaking-arguments
            var args = new Array(arguments.length);
            for (var i = 0; i < args.length; ++i) {
              args[i] = arguments[i];
            }

            var fetchInput = args[0];
            var method = 'GET';
            var url;

            if (typeof fetchInput === 'string') {
              url = fetchInput;
            } else if ('Request' in _window && fetchInput instanceof _window.Request) {
              url = fetchInput.url;
              if (fetchInput.method) {
                method = fetchInput.method;
              }
            } else {
              url = '' + fetchInput;
            }

            // if Sentry key appears in URL, don't capture, as it's our own request
            if (url.indexOf(self._globalKey) !== -1) {
              return origFetch.apply(this, args);
            }

            if (args[1] && args[1].method) {
              method = args[1].method;
            }

            var fetchData = {
              method: method,
              url: url,
              status_code: null
            };

            return origFetch
              .apply(this, args)
              .then(function(response) {
                fetchData.status_code = response.status;

                self.captureBreadcrumb({
                  type: 'http',
                  category: 'fetch',
                  data: fetchData
                });

                return response;
              })
              ['catch'](function(err) {
                // if there is an error performing the request
                self.captureBreadcrumb({
                  type: 'http',
                  category: 'fetch',
                  data: fetchData,
                  level: 'error'
                });

                throw err;
              });
          };
        },
        wrappedBuiltIns
      );
    }

    // Capture breadcrumbs from any click that is unhandled / bubbled up all the way
    // to the document. Do this before we instrument addEventListener.
    if (autoBreadcrumbs.dom && this._hasDocument) {
      if (_document.addEventListener) {
        _document.addEventListener('click', self._breadcrumbEventHandler('click'), false);
        _document.addEventListener('keypress', self._keypressEventHandler(), false);
      } else if (_document.attachEvent) {
        // IE8 Compatibility
        _document.attachEvent('onclick', self._breadcrumbEventHandler('click'));
        _document.attachEvent('onkeypress', self._keypressEventHandler());
      }
    }

    // record navigation (URL) changes
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    var chrome = _window.chrome;
    var isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
    var hasPushAndReplaceState =
      !isChromePackagedApp &&
      _window.history &&
      history.pushState &&
      history.replaceState;
    if (autoBreadcrumbs.location && hasPushAndReplaceState) {
      // TODO: remove onpopstate handler on uninstall()
      var oldOnPopState = _window.onpopstate;
      _window.onpopstate = function() {
        var currentHref = self._location.href;
        self._captureUrlChange(self._lastHref, currentHref);

        if (oldOnPopState) {
          return oldOnPopState.apply(this, arguments);
        }
      };

      var historyReplacementFunction = function(origHistFunction) {
        // note history.pushState.length is 0; intentionally not declaring
        // params to preserve 0 arity
        return function(/* state, title, url */) {
          var url = arguments.length > 2 ? arguments[2] : undefined;

          // url argument is optional
          if (url) {
            // coerce to string (this is what pushState does)
            self._captureUrlChange(self._lastHref, url + '');
          }

          return origHistFunction.apply(this, arguments);
        };
      };

      fill(history, 'pushState', historyReplacementFunction, wrappedBuiltIns);
      fill(history, 'replaceState', historyReplacementFunction, wrappedBuiltIns);
    }

    if (autoBreadcrumbs.console && 'console' in _window && console.log) {
      // console
      var consoleMethodCallback = function(msg, data) {
        self.captureBreadcrumb({
          message: msg,
          level: data.level,
          category: 'console'
        });
      };

      each(['debug', 'info', 'warn', 'error', 'log'], function(_, level) {
        wrapConsoleMethod(console, level, consoleMethodCallback);
      });
    }
  },

  _restoreBuiltIns: function() {
    // restore any wrapped builtins
    var builtin;
    while (this._wrappedBuiltIns.length) {
      builtin = this._wrappedBuiltIns.shift();

      var obj = builtin[0],
        name = builtin[1],
        orig = builtin[2];

      obj[name] = orig;
    }
  },

  _restoreConsole: function() {
    // eslint-disable-next-line guard-for-in
    for (var method in this._originalConsoleMethods) {
      this._originalConsole[method] = this._originalConsoleMethods[method];
    }
  },

  _drainPlugins: function() {
    var self = this;

    // FIX ME TODO
    each(this._plugins, function(_, plugin) {
      var installer = plugin[0];
      var args = plugin[1];
      installer.apply(self, [self].concat(args));
    });
  },

  _parseDSN: function(str) {
    var m = dsnPattern.exec(str),
      dsn = {},
      i = 7;

    try {
      while (i--) dsn[dsnKeys[i]] = m[i] || '';
    } catch (e) {
      throw new RavenConfigError('Invalid DSN: ' + str);
    }

    if (dsn.pass && !this._globalOptions.allowSecretKey) {
      throw new RavenConfigError(
        'Do not specify your secret key in the DSN. See: http://bit.ly/raven-secret-key'
      );
    }

    return dsn;
  },

  _getGlobalServer: function(uri) {
    // assemble the endpoint from the uri pieces
    var globalServer = '//' + uri.host + (uri.port ? ':' + uri.port : '');

    if (uri.protocol) {
      globalServer = uri.protocol + ':' + globalServer;
    }
    return globalServer;
  },

  _handleOnErrorStackInfo: function() {
    // if we are intentionally ignoring errors via onerror, bail out
    if (!this._ignoreOnError) {
      this._handleStackInfo.apply(this, arguments);
    }
  },

  _handleStackInfo: function(stackInfo, options) {
    var frames = this._prepareFrames(stackInfo, options);

    this._triggerEvent('handle', {
      stackInfo: stackInfo,
      options: options
    });

    this._processException(
      stackInfo.name,
      stackInfo.message,
      stackInfo.url,
      stackInfo.lineno,
      frames,
      options
    );
  },

  _prepareFrames: function(stackInfo, options) {
    var self = this;
    var frames = [];
    if (stackInfo.stack && stackInfo.stack.length) {
      each(stackInfo.stack, function(i, stack) {
        var frame = self._normalizeFrame(stack, stackInfo.url);
        if (frame) {
          frames.push(frame);
        }
      });

      // e.g. frames captured via captureMessage throw
      if (options && options.trimHeadFrames) {
        for (var j = 0; j < options.trimHeadFrames && j < frames.length; j++) {
          frames[j].in_app = false;
        }
      }
    }
    frames = frames.slice(0, this._globalOptions.stackTraceLimit);
    return frames;
  },

  _normalizeFrame: function(frame, stackInfoUrl) {
    // normalize the frames data
    var normalized = {
      filename: frame.url,
      lineno: frame.line,
      colno: frame.column,
      function: frame.func || '?'
    };

    // Case when we don't have any information about the error
    // E.g. throwing a string or raw object, instead of an `Error` in Firefox
    // Generating synthetic error doesn't add any value here
    //
    // We should probably somehow let a user know that they should fix their code
    if (!frame.url) {
      normalized.filename = stackInfoUrl; // fallback to whole stacks url from onerror handler
    }

    normalized.in_app = !// determine if an exception came from outside of our app
    // first we check the global includePaths list.
    (
      (!!this._globalOptions.includePaths.test &&
        !this._globalOptions.includePaths.test(normalized.filename)) ||
      // Now we check for fun, if the function name is Raven or TraceKit
      /(Raven|TraceKit)\./.test(normalized['function']) ||
      // finally, we do a last ditch effort and check for raven.min.js
      /raven\.(min\.)?js$/.test(normalized.filename)
    );

    return normalized;
  },

  _processException: function(type, message, fileurl, lineno, frames, options) {
    var prefixedMessage = (type ? type + ': ' : '') + (message || '');
    if (
      !!this._globalOptions.ignoreErrors.test &&
      (this._globalOptions.ignoreErrors.test(message) ||
        this._globalOptions.ignoreErrors.test(prefixedMessage))
    ) {
      return;
    }

    var stacktrace;

    if (frames && frames.length) {
      fileurl = frames[0].filename || fileurl;
      // Sentry expects frames oldest to newest
      // and JS sends them as newest to oldest
      frames.reverse();
      stacktrace = {frames: frames};
    } else if (fileurl) {
      stacktrace = {
        frames: [
          {
            filename: fileurl,
            lineno: lineno,
            in_app: true
          }
        ]
      };
    }

    if (
      !!this._globalOptions.ignoreUrls.test &&
      this._globalOptions.ignoreUrls.test(fileurl)
    ) {
      return;
    }

    if (
      !!this._globalOptions.whitelistUrls.test &&
      !this._globalOptions.whitelistUrls.test(fileurl)
    ) {
      return;
    }

    var data = objectMerge(
      {
        // sentry.interfaces.Exception
        exception: {
          values: [
            {
              type: type,
              value: message,
              stacktrace: stacktrace
            }
          ]
        },
        culprit: fileurl
      },
      options
    );

    // Fire away!
    this._send(data);
  },

  _trimPacket: function(data) {
    // For now, we only want to truncate the two different messages
    // but this could/should be expanded to just trim everything
    var max = this._globalOptions.maxMessageLength;
    if (data.message) {
      data.message = truncate(data.message, max);
    }
    if (data.exception) {
      var exception = data.exception.values[0];
      exception.value = truncate(exception.value, max);
    }

    var request = data.request;
    if (request) {
      if (request.url) {
        request.url = truncate(request.url, this._globalOptions.maxUrlLength);
      }
      if (request.Referer) {
        request.Referer = truncate(request.Referer, this._globalOptions.maxUrlLength);
      }
    }

    if (data.breadcrumbs && data.breadcrumbs.values)
      this._trimBreadcrumbs(data.breadcrumbs);

    return data;
  },

  /**
   * Truncate breadcrumb values (right now just URLs)
   */
  _trimBreadcrumbs: function(breadcrumbs) {
    // known breadcrumb properties with urls
    // TODO: also consider arbitrary prop values that start with (https?)?://
    var urlProps = ['to', 'from', 'url'],
      urlProp,
      crumb,
      data;

    for (var i = 0; i < breadcrumbs.values.length; ++i) {
      crumb = breadcrumbs.values[i];
      if (
        !crumb.hasOwnProperty('data') ||
        !isObject(crumb.data) ||
        objectFrozen(crumb.data)
      )
        continue;

      data = objectMerge({}, crumb.data);
      for (var j = 0; j < urlProps.length; ++j) {
        urlProp = urlProps[j];
        if (data.hasOwnProperty(urlProp) && data[urlProp]) {
          data[urlProp] = truncate(data[urlProp], this._globalOptions.maxUrlLength);
        }
      }
      breadcrumbs.values[i].data = data;
    }
  },

  _getHttpData: function() {
    if (!this._hasNavigator && !this._hasDocument) return;
    var httpData = {};

    if (this._hasNavigator && _navigator.userAgent) {
      httpData.headers = {
        'User-Agent': navigator.userAgent
      };
    }

    // Check in `window` instead of `document`, as we may be in ServiceWorker environment
    if (_window.location && _window.location.href) {
      httpData.url = _window.location.href;
    }

    if (this._hasDocument && _document.referrer) {
      if (!httpData.headers) httpData.headers = {};
      httpData.headers.Referer = _document.referrer;
    }

    return httpData;
  },

  _resetBackoff: function() {
    this._backoffDuration = 0;
    this._backoffStart = null;
  },

  _shouldBackoff: function() {
    return this._backoffDuration && now() - this._backoffStart < this._backoffDuration;
  },

  /**
   * Returns true if the in-process data payload matches the signature
   * of the previously-sent data
   *
   * NOTE: This has to be done at this level because TraceKit can generate
   *       data from window.onerror WITHOUT an exception object (IE8, IE9,
   *       other old browsers). This can take the form of an "exception"
   *       data object with a single frame (derived from the onerror args).
   */
  _isRepeatData: function(current) {
    var last = this._lastData;

    if (
      !last ||
      current.message !== last.message || // defined for captureMessage
      current.culprit !== last.culprit // defined for captureException/onerror
    )
      return false;

    // Stacktrace interface (i.e. from captureMessage)
    if (current.stacktrace || last.stacktrace) {
      return isSameStacktrace(current.stacktrace, last.stacktrace);
    } else if (current.exception || last.exception) {
      // Exception interface (i.e. from captureException/onerror)
      return isSameException(current.exception, last.exception);
    }

    return true;
  },

  _setBackoffState: function(request) {
    // If we are already in a backoff state, don't change anything
    if (this._shouldBackoff()) {
      return;
    }

    var status = request.status;

    // 400 - project_id doesn't exist or some other fatal
    // 401 - invalid/revoked dsn
    // 429 - too many requests
    if (!(status === 400 || status === 401 || status === 429)) return;

    var retry;
    try {
      // If Retry-After is not in Access-Control-Expose-Headers, most
      // browsers will throw an exception trying to access it
      if (supportsFetch()) {
        retry = request.headers.get('Retry-After');
      } else {
        retry = request.getResponseHeader('Retry-After');
      }

      // Retry-After is returned in seconds
      retry = parseInt(retry, 10) * 1000;
    } catch (e) {
      /* eslint no-empty:0 */
    }

    this._backoffDuration = retry
      ? // If Sentry server returned a Retry-After value, use it
        retry
      : // Otherwise, double the last backoff duration (starts at 1 sec)
        this._backoffDuration * 2 || 1000;

    this._backoffStart = now();
  },

  _send: function(data) {
    var globalOptions = this._globalOptions;

    var baseData = {
        project: this._globalProject,
        logger: globalOptions.logger,
        platform: 'javascript'
      },
      httpData = this._getHttpData();

    if (httpData) {
      baseData.request = httpData;
    }

    // HACK: delete `trimHeadFrames` to prevent from appearing in outbound payload
    if (data.trimHeadFrames) delete data.trimHeadFrames;

    data = objectMerge(baseData, data);

    // Merge in the tags and extra separately since objectMerge doesn't handle a deep merge
    data.tags = objectMerge(objectMerge({}, this._globalContext.tags), data.tags);
    data.extra = objectMerge(objectMerge({}, this._globalContext.extra), data.extra);

    // Send along our own collected metadata with extra
    data.extra['session:duration'] = now() - this._startTime;

    if (this._breadcrumbs && this._breadcrumbs.length > 0) {
      // intentionally make shallow copy so that additions
      // to breadcrumbs aren't accidentally sent in this request
      data.breadcrumbs = {
        values: [].slice.call(this._breadcrumbs, 0)
      };
    }

    if (this._globalContext.user) {
      // sentry.interfaces.User
      data.user = this._globalContext.user;
    }

    // Include the environment if it's defined in globalOptions
    if (globalOptions.environment) data.environment = globalOptions.environment;

    // Include the release if it's defined in globalOptions
    if (globalOptions.release) data.release = globalOptions.release;

    // Include server_name if it's defined in globalOptions
    if (globalOptions.serverName) data.server_name = globalOptions.serverName;

    data = this._sanitizeData(data);

    // Cleanup empty properties before sending them to the server
    Object.keys(data).forEach(function(key) {
      if (data[key] == null || data[key] === '' || isEmptyObject(data[key])) {
        delete data[key];
      }
    });

    if (isFunction(globalOptions.dataCallback)) {
      data = globalOptions.dataCallback(data) || data;
    }

    // Why??????????
    if (!data || isEmptyObject(data)) {
      return;
    }

    // Check if the request should be filtered or not
    if (
      isFunction(globalOptions.shouldSendCallback) &&
      !globalOptions.shouldSendCallback(data)
    ) {
      return;
    }

    // Backoff state: Sentry server previously responded w/ an error (e.g. 429 - too many requests),
    // so drop requests until "cool-off" period has elapsed.
    if (this._shouldBackoff()) {
      this._logDebug('warn', 'Raven dropped error due to backoff: ', data);
      return;
    }

    if (typeof globalOptions.sampleRate === 'number') {
      if (Math.random() < globalOptions.sampleRate) {
        this._sendProcessedPayload(data);
      }
    } else {
      this._sendProcessedPayload(data);
    }
  },

  _sanitizeData: function(data) {
    return sanitize(data, this._globalOptions.sanitizeKeys);
  },

  _getUuid: function() {
    return uuid4();
  },

  _sendProcessedPayload: function(data, callback) {
    var self = this;
    var globalOptions = this._globalOptions;

    if (!this.isSetup()) return;

    // Try and clean up the packet before sending by truncating long values
    data = this._trimPacket(data);

    // ideally duplicate error testing should occur *before* dataCallback/shouldSendCallback,
    // but this would require copying an un-truncated copy of the data packet, which can be
    // arbitrarily deep (extra_data) -- could be worthwhile? will revisit
    if (!this._globalOptions.allowDuplicates && this._isRepeatData(data)) {
      this._logDebug('warn', 'Raven dropped repeat event: ', data);
      return;
    }

    // Send along an event_id if not explicitly passed.
    // This event_id can be used to reference the error within Sentry itself.
    // Set lastEventId after we know the error should actually be sent
    this._lastEventId = data.event_id || (data.event_id = this._getUuid());

    // Store outbound payload after trim
    this._lastData = data;

    this._logDebug('debug', 'Raven about to send:', data);

    var auth = {
      sentry_version: '7',
      sentry_client: 'raven-js/' + this.VERSION,
      sentry_key: this._globalKey
    };

    if (this._globalSecret) {
      auth.sentry_secret = this._globalSecret;
    }

    var exception = data.exception && data.exception.values[0];

    // only capture 'sentry' breadcrumb is autoBreadcrumbs is truthy
    if (
      this._globalOptions.autoBreadcrumbs &&
      this._globalOptions.autoBreadcrumbs.sentry
    ) {
      this.captureBreadcrumb({
        category: 'sentry',
        message: exception
          ? (exception.type ? exception.type + ': ' : '') + exception.value
          : data.message,
        event_id: data.event_id,
        level: data.level || 'error' // presume error unless specified
      });
    }

    var url = this._globalEndpoint;
    (globalOptions.transport || this._makeRequest).call(this, {
      url: url,
      auth: auth,
      data: data,
      options: globalOptions,
      onSuccess: function success() {
        self._resetBackoff();

        self._triggerEvent('success', {
          data: data,
          src: url
        });
        callback && callback();
      },
      onError: function failure(error) {
        self._logDebug('error', 'Raven transport failed to send: ', error);

        if (error.request) {
          self._setBackoffState(error.request);
        }

        self._triggerEvent('failure', {
          data: data,
          src: url
        });
        error = error || new Error('Raven send failed (no additional details provided)');
        callback && callback(error);
      }
    });
  },

  _makeRequest: function(opts) {
    // Auth is intentionally sent as part of query string (NOT as custom HTTP header) to avoid preflight CORS requests
    var url = opts.url + '?' + urlencode(opts.auth);

    var evaluatedHeaders = null;
    var evaluatedFetchParameters = {};

    if (opts.options.headers) {
      evaluatedHeaders = this._evaluateHash(opts.options.headers);
    }

    if (opts.options.fetchParameters) {
      evaluatedFetchParameters = this._evaluateHash(opts.options.fetchParameters);
    }

    if (supportsFetch()) {
      evaluatedFetchParameters.body = stringify(opts.data);

      var defaultFetchOptions = objectMerge({}, this._fetchDefaults);
      var fetchOptions = objectMerge(defaultFetchOptions, evaluatedFetchParameters);

      if (evaluatedHeaders) {
        fetchOptions.headers = evaluatedHeaders;
      }

      return _window
        .fetch(url, fetchOptions)
        .then(function(response) {
          if (response.ok) {
            opts.onSuccess && opts.onSuccess();
          } else {
            var error = new Error('Sentry error code: ' + response.status);
            // It's called request only to keep compatibility with XHR interface
            // and not add more redundant checks in setBackoffState method
            error.request = response;
            opts.onError && opts.onError(error);
          }
        })
        ['catch'](function() {
          opts.onError &&
            opts.onError(new Error('Sentry error code: network unavailable'));
        });
    }

    var request = _window.XMLHttpRequest && new _window.XMLHttpRequest();
    if (!request) return;

    // if browser doesn't support CORS (e.g. IE7), we are out of luck
    var hasCORS = 'withCredentials' in request || typeof XDomainRequest !== 'undefined';

    if (!hasCORS) return;

    if ('withCredentials' in request) {
      request.onreadystatechange = function() {
        if (request.readyState !== 4) {
          return;
        } else if (request.status === 200) {
          opts.onSuccess && opts.onSuccess();
        } else if (opts.onError) {
          var err = new Error('Sentry error code: ' + request.status);
          err.request = request;
          opts.onError(err);
        }
      };
    } else {
      request = new XDomainRequest();
      // xdomainrequest cannot go http -> https (or vice versa),
      // so always use protocol relative
      url = url.replace(/^https?:/, '');

      // onreadystatechange not supported by XDomainRequest
      if (opts.onSuccess) {
        request.onload = opts.onSuccess;
      }
      if (opts.onError) {
        request.onerror = function() {
          var err = new Error('Sentry error code: XDomainRequest');
          err.request = request;
          opts.onError(err);
        };
      }
    }

    request.open('POST', url);

    if (evaluatedHeaders) {
      each(evaluatedHeaders, function(key, value) {
        request.setRequestHeader(key, value);
      });
    }

    request.send(stringify(opts.data));
  },

  _evaluateHash: function(hash) {
    var evaluated = {};

    for (var key in hash) {
      if (hash.hasOwnProperty(key)) {
        var value = hash[key];
        evaluated[key] = typeof value === 'function' ? value() : value;
      }
    }

    return evaluated;
  },

  _logDebug: function(level) {
    // We allow `Raven.debug` and `Raven.config(DSN, { debug: true })` to not make backward incompatible API change
    if (
      this._originalConsoleMethods[level] &&
      (this.debug || this._globalOptions.debug)
    ) {
      // In IE<10 console methods do not have their own 'apply' method
      Function.prototype.apply.call(
        this._originalConsoleMethods[level],
        this._originalConsole,
        [].slice.call(arguments, 1)
      );
    }
  },

  _mergeContext: function(key, context) {
    if (isUndefined(context)) {
      delete this._globalContext[key];
    } else {
      this._globalContext[key] = objectMerge(this._globalContext[key] || {}, context);
    }
  }
};

// Deprecations
Raven.prototype.setUser = Raven.prototype.setUserContext;
Raven.prototype.setReleaseContext = Raven.prototype.setRelease;

module.exports = Raven;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var utils = __webpack_require__(56);

/*
 TraceKit - Cross brower stack traces

 This was originally forked from github.com/occ/TraceKit, but has since been
 largely re-written and is now maintained as part of raven-js.  Tests for
 this are in test/vendor.

 MIT license
*/

var TraceKit = {
  collectWindowErrors: true,
  debug: false
};

// This is to be defensive in environments where window does not exist (see https://github.com/getsentry/raven-js/pull/785)
var _window =
  typeof window !== 'undefined'
    ? window
    : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

// global reference to slice
var _slice = [].slice;
var UNKNOWN_FUNCTION = '?';

// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Error_types
var ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/;

function getLocationHref() {
  if (typeof document === 'undefined' || document.location == null) return '';

  return document.location.href;
}

/**
 * TraceKit.report: cross-browser processing of unhandled exceptions
 *
 * Syntax:
 *   TraceKit.report.subscribe(function(stackInfo) { ... })
 *   TraceKit.report.unsubscribe(function(stackInfo) { ... })
 *   TraceKit.report(exception)
 *   try { ...code... } catch(ex) { TraceKit.report(ex); }
 *
 * Supports:
 *   - Firefox: full stack trace with line numbers, plus column number
 *              on top frame; column number is not guaranteed
 *   - Opera:   full stack trace with line and column numbers
 *   - Chrome:  full stack trace with line and column numbers
 *   - Safari:  line and column number for the top frame only; some frames
 *              may be missing, and column number is not guaranteed
 *   - IE:      line and column number for the top frame only; some frames
 *              may be missing, and column number is not guaranteed
 *
 * In theory, TraceKit should work on all of the following versions:
 *   - IE5.5+ (only 8.0 tested)
 *   - Firefox 0.9+ (only 3.5+ tested)
 *   - Opera 7+ (only 10.50 tested; versions 9 and earlier may require
 *     Exceptions Have Stacktrace to be enabled in opera:config)
 *   - Safari 3+ (only 4+ tested)
 *   - Chrome 1+ (only 5+ tested)
 *   - Konqueror 3.5+ (untested)
 *
 * Requires TraceKit.computeStackTrace.
 *
 * Tries to catch all unhandled exceptions and report them to the
 * subscribed handlers. Please note that TraceKit.report will rethrow the
 * exception. This is REQUIRED in order to get a useful stack trace in IE.
 * If the exception does not reach the top of the browser, you will only
 * get a stack trace from the point where TraceKit.report was called.
 *
 * Handlers receive a stackInfo object as described in the
 * TraceKit.computeStackTrace docs.
 */
TraceKit.report = (function reportModuleWrapper() {
  var handlers = [],
    lastArgs = null,
    lastException = null,
    lastExceptionStack = null;

  /**
   * Add a crash handler.
   * @param {Function} handler
   */
  function subscribe(handler) {
    installGlobalHandler();
    handlers.push(handler);
  }

  /**
   * Remove a crash handler.
   * @param {Function} handler
   */
  function unsubscribe(handler) {
    for (var i = handlers.length - 1; i >= 0; --i) {
      if (handlers[i] === handler) {
        handlers.splice(i, 1);
      }
    }
  }

  /**
   * Remove all crash handlers.
   */
  function unsubscribeAll() {
    uninstallGlobalHandler();
    handlers = [];
  }

  /**
   * Dispatch stack information to all handlers.
   * @param {Object.<string, *>} stack
   */
  function notifyHandlers(stack, isWindowError) {
    var exception = null;
    if (isWindowError && !TraceKit.collectWindowErrors) {
      return;
    }
    for (var i in handlers) {
      if (handlers.hasOwnProperty(i)) {
        try {
          handlers[i].apply(null, [stack].concat(_slice.call(arguments, 2)));
        } catch (inner) {
          exception = inner;
        }
      }
    }

    if (exception) {
      throw exception;
    }
  }

  var _oldOnerrorHandler, _onErrorHandlerInstalled;

  /**
   * Ensures all global unhandled exceptions are recorded.
   * Supported by Gecko and IE.
   * @param {string} msg Error message.
   * @param {string} url URL of script that generated the exception.
   * @param {(number|string)} lineNo The line number at which the error
   * occurred.
   * @param {?(number|string)} colNo The column number at which the error
   * occurred.
   * @param {?Error} ex The actual Error object.
   */
  function traceKitWindowOnError(msg, url, lineNo, colNo, ex) {
    var stack = null;
    // If 'ex' is ErrorEvent, get real Error from inside
    var exception = utils.isErrorEvent(ex) ? ex.error : ex;
    // If 'msg' is ErrorEvent, get real message from inside
    var message = utils.isErrorEvent(msg) ? msg.message : msg;

    if (lastExceptionStack) {
      TraceKit.computeStackTrace.augmentStackTraceWithInitialElement(
        lastExceptionStack,
        url,
        lineNo,
        message
      );
      processLastException();
    } else if (exception && utils.isError(exception)) {
      // non-string `exception` arg; attempt to extract stack trace

      // New chrome and blink send along a real error object
      // Let's just report that like a normal error.
      // See: https://mikewest.org/2013/08/debugging-runtime-errors-with-window-onerror
      stack = TraceKit.computeStackTrace(exception);
      notifyHandlers(stack, true);
    } else {
      var location = {
        url: url,
        line: lineNo,
        column: colNo
      };

      var name = undefined;
      var groups;

      if ({}.toString.call(message) === '[object String]') {
        var groups = message.match(ERROR_TYPES_RE);
        if (groups) {
          name = groups[1];
          message = groups[2];
        }
      }

      location.func = UNKNOWN_FUNCTION;

      stack = {
        name: name,
        message: message,
        url: getLocationHref(),
        stack: [location]
      };
      notifyHandlers(stack, true);
    }

    if (_oldOnerrorHandler) {
      return _oldOnerrorHandler.apply(this, arguments);
    }

    return false;
  }

  function installGlobalHandler() {
    if (_onErrorHandlerInstalled) {
      return;
    }
    _oldOnerrorHandler = _window.onerror;
    _window.onerror = traceKitWindowOnError;
    _onErrorHandlerInstalled = true;
  }

  function uninstallGlobalHandler() {
    if (!_onErrorHandlerInstalled) {
      return;
    }
    _window.onerror = _oldOnerrorHandler;
    _onErrorHandlerInstalled = false;
    _oldOnerrorHandler = undefined;
  }

  function processLastException() {
    var _lastExceptionStack = lastExceptionStack,
      _lastArgs = lastArgs;
    lastArgs = null;
    lastExceptionStack = null;
    lastException = null;
    notifyHandlers.apply(null, [_lastExceptionStack, false].concat(_lastArgs));
  }

  /**
   * Reports an unhandled Error to TraceKit.
   * @param {Error} ex
   * @param {?boolean} rethrow If false, do not re-throw the exception.
   * Only used for window.onerror to not cause an infinite loop of
   * rethrowing.
   */
  function report(ex, rethrow) {
    var args = _slice.call(arguments, 1);
    if (lastExceptionStack) {
      if (lastException === ex) {
        return; // already caught by an inner catch block, ignore
      } else {
        processLastException();
      }
    }

    var stack = TraceKit.computeStackTrace(ex);
    lastExceptionStack = stack;
    lastException = ex;
    lastArgs = args;

    // If the stack trace is incomplete, wait for 2 seconds for
    // slow slow IE to see if onerror occurs or not before reporting
    // this exception; otherwise, we will end up with an incomplete
    // stack trace
    setTimeout(function() {
      if (lastException === ex) {
        processLastException();
      }
    }, stack.incomplete ? 2000 : 0);

    if (rethrow !== false) {
      throw ex; // re-throw to propagate to the top level (and cause window.onerror)
    }
  }

  report.subscribe = subscribe;
  report.unsubscribe = unsubscribe;
  report.uninstall = unsubscribeAll;
  return report;
})();

/**
 * TraceKit.computeStackTrace: cross-browser stack traces in JavaScript
 *
 * Syntax:
 *   s = TraceKit.computeStackTrace(exception) // consider using TraceKit.report instead (see below)
 * Returns:
 *   s.name              - exception name
 *   s.message           - exception message
 *   s.stack[i].url      - JavaScript or HTML file URL
 *   s.stack[i].func     - function name, or empty for anonymous functions (if guessing did not work)
 *   s.stack[i].args     - arguments passed to the function, if known
 *   s.stack[i].line     - line number, if known
 *   s.stack[i].column   - column number, if known
 *
 * Supports:
 *   - Firefox:  full stack trace with line numbers and unreliable column
 *               number on top frame
 *   - Opera 10: full stack trace with line and column numbers
 *   - Opera 9-: full stack trace with line numbers
 *   - Chrome:   full stack trace with line and column numbers
 *   - Safari:   line and column number for the topmost stacktrace element
 *               only
 *   - IE:       no line numbers whatsoever
 *
 * Tries to guess names of anonymous functions by looking for assignments
 * in the source code. In IE and Safari, we have to guess source file names
 * by searching for function bodies inside all page scripts. This will not
 * work for scripts that are loaded cross-domain.
 * Here be dragons: some function names may be guessed incorrectly, and
 * duplicate functions may be mismatched.
 *
 * TraceKit.computeStackTrace should only be used for tracing purposes.
 * Logging of unhandled exceptions should be done with TraceKit.report,
 * which builds on top of TraceKit.computeStackTrace and provides better
 * IE support by utilizing the window.onerror event to retrieve information
 * about the top of the stack.
 *
 * Note: In IE and Safari, no stack trace is recorded on the Error object,
 * so computeStackTrace instead walks its *own* chain of callers.
 * This means that:
 *  * in Safari, some methods may be missing from the stack trace;
 *  * in IE, the topmost function in the stack trace will always be the
 *    caller of computeStackTrace.
 *
 * This is okay for tracing (because you are likely to be calling
 * computeStackTrace from the function you want to be the topmost element
 * of the stack trace anyway), but not okay for logging unhandled
 * exceptions (because your catch block will likely be far away from the
 * inner function that actually caused the exception).
 *
 */
TraceKit.computeStackTrace = (function computeStackTraceWrapper() {
  // Contents of Exception in various browsers.
  //
  // SAFARI:
  // ex.message = Can't find variable: qq
  // ex.line = 59
  // ex.sourceId = 580238192
  // ex.sourceURL = http://...
  // ex.expressionBeginOffset = 96
  // ex.expressionCaretOffset = 98
  // ex.expressionEndOffset = 98
  // ex.name = ReferenceError
  //
  // FIREFOX:
  // ex.message = qq is not defined
  // ex.fileName = http://...
  // ex.lineNumber = 59
  // ex.columnNumber = 69
  // ex.stack = ...stack trace... (see the example below)
  // ex.name = ReferenceError
  //
  // CHROME:
  // ex.message = qq is not defined
  // ex.name = ReferenceError
  // ex.type = not_defined
  // ex.arguments = ['aa']
  // ex.stack = ...stack trace...
  //
  // INTERNET EXPLORER:
  // ex.message = ...
  // ex.name = ReferenceError
  //
  // OPERA:
  // ex.message = ...message... (see the example below)
  // ex.name = ReferenceError
  // ex.opera#sourceloc = 11  (pretty much useless, duplicates the info in ex.message)
  // ex.stacktrace = n/a; see 'opera:config#UserPrefs|Exceptions Have Stacktrace'

  /**
   * Computes stack trace information from the stack property.
   * Chrome and Gecko use this property.
   * @param {Error} ex
   * @return {?Object.<string, *>} Stack trace information.
   */
  function computeStackTraceFromStackProp(ex) {
    if (typeof ex.stack === 'undefined' || !ex.stack) return;

    var chrome = /^\s*at (?:(.*?) ?\()?((?:file|https?|blob|chrome-extension|native|eval|webpack|<anonymous>|[a-z]:|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
    var winjs = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx(?:-web)|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
    // NOTE: blob urls are now supposed to always have an origin, therefore it's format
    // which is `blob:http://url/path/with-some-uuid`, is matched by `blob.*?:\/` as well
    var gecko = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)((?:file|https?|blob|chrome|webpack|resource|moz-extension).*?:\/.*?|\[native code\]|[^@]*bundle)(?::(\d+))?(?::(\d+))?\s*$/i;
    // Used to additionally parse URL/line/column from eval frames
    var geckoEval = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
    var chromeEval = /\((\S*)(?::(\d+))(?::(\d+))\)/;
    var lines = ex.stack.split('\n');
    var stack = [];
    var submatch;
    var parts;
    var element;
    var reference = /^(.*) is undefined$/.exec(ex.message);

    for (var i = 0, j = lines.length; i < j; ++i) {
      if ((parts = chrome.exec(lines[i]))) {
        var isNative = parts[2] && parts[2].indexOf('native') === 0; // start of line
        var isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
        if (isEval && (submatch = chromeEval.exec(parts[2]))) {
          // throw out eval line/column and use top-most line/column number
          parts[2] = submatch[1]; // url
          parts[3] = submatch[2]; // line
          parts[4] = submatch[3]; // column
        }
        element = {
          url: !isNative ? parts[2] : null,
          func: parts[1] || UNKNOWN_FUNCTION,
          args: isNative ? [parts[2]] : [],
          line: parts[3] ? +parts[3] : null,
          column: parts[4] ? +parts[4] : null
        };
      } else if ((parts = winjs.exec(lines[i]))) {
        element = {
          url: parts[2],
          func: parts[1] || UNKNOWN_FUNCTION,
          args: [],
          line: +parts[3],
          column: parts[4] ? +parts[4] : null
        };
      } else if ((parts = gecko.exec(lines[i]))) {
        var isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
        if (isEval && (submatch = geckoEval.exec(parts[3]))) {
          // throw out eval line/column and use top-most line number
          parts[3] = submatch[1];
          parts[4] = submatch[2];
          parts[5] = null; // no column when eval
        } else if (i === 0 && !parts[5] && typeof ex.columnNumber !== 'undefined') {
          // FireFox uses this awesome columnNumber property for its top frame
          // Also note, Firefox's column number is 0-based and everything else expects 1-based,
          // so adding 1
          // NOTE: this hack doesn't work if top-most frame is eval
          stack[0].column = ex.columnNumber + 1;
        }
        element = {
          url: parts[3],
          func: parts[1] || UNKNOWN_FUNCTION,
          args: parts[2] ? parts[2].split(',') : [],
          line: parts[4] ? +parts[4] : null,
          column: parts[5] ? +parts[5] : null
        };
      } else {
        continue;
      }

      if (!element.func && element.line) {
        element.func = UNKNOWN_FUNCTION;
      }

      stack.push(element);
    }

    if (!stack.length) {
      return null;
    }

    return {
      name: ex.name,
      message: ex.message,
      url: getLocationHref(),
      stack: stack
    };
  }

  /**
   * Adds information about the first frame to incomplete stack traces.
   * Safari and IE require this to get complete data on the first frame.
   * @param {Object.<string, *>} stackInfo Stack trace information from
   * one of the compute* methods.
   * @param {string} url The URL of the script that caused an error.
   * @param {(number|string)} lineNo The line number of the script that
   * caused an error.
   * @param {string=} message The error generated by the browser, which
   * hopefully contains the name of the object that caused the error.
   * @return {boolean} Whether or not the stack information was
   * augmented.
   */
  function augmentStackTraceWithInitialElement(stackInfo, url, lineNo, message) {
    var initial = {
      url: url,
      line: lineNo
    };

    if (initial.url && initial.line) {
      stackInfo.incomplete = false;

      if (!initial.func) {
        initial.func = UNKNOWN_FUNCTION;
      }

      if (stackInfo.stack.length > 0) {
        if (stackInfo.stack[0].url === initial.url) {
          if (stackInfo.stack[0].line === initial.line) {
            return false; // already in stack trace
          } else if (
            !stackInfo.stack[0].line &&
            stackInfo.stack[0].func === initial.func
          ) {
            stackInfo.stack[0].line = initial.line;
            return false;
          }
        }
      }

      stackInfo.stack.unshift(initial);
      stackInfo.partial = true;
      return true;
    } else {
      stackInfo.incomplete = true;
    }

    return false;
  }

  /**
   * Computes stack trace information by walking the arguments.caller
   * chain at the time the exception occurred. This will cause earlier
   * frames to be missed but is the only way to get any stack trace in
   * Safari and IE. The top frame is restored by
   * {@link augmentStackTraceWithInitialElement}.
   * @param {Error} ex
   * @return {?Object.<string, *>} Stack trace information.
   */
  function computeStackTraceByWalkingCallerChain(ex, depth) {
    var functionName = /function\s+([_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*)?\s*\(/i,
      stack = [],
      funcs = {},
      recursion = false,
      parts,
      item,
      source;

    for (
      var curr = computeStackTraceByWalkingCallerChain.caller;
      curr && !recursion;
      curr = curr.caller
    ) {
      if (curr === computeStackTrace || curr === TraceKit.report) {
        // console.log('skipping internal function');
        continue;
      }

      item = {
        url: null,
        func: UNKNOWN_FUNCTION,
        line: null,
        column: null
      };

      if (curr.name) {
        item.func = curr.name;
      } else if ((parts = functionName.exec(curr.toString()))) {
        item.func = parts[1];
      }

      if (typeof item.func === 'undefined') {
        try {
          item.func = parts.input.substring(0, parts.input.indexOf('{'));
        } catch (e) {}
      }

      if (funcs['' + curr]) {
        recursion = true;
      } else {
        funcs['' + curr] = true;
      }

      stack.push(item);
    }

    if (depth) {
      // console.log('depth is ' + depth);
      // console.log('stack is ' + stack.length);
      stack.splice(0, depth);
    }

    var result = {
      name: ex.name,
      message: ex.message,
      url: getLocationHref(),
      stack: stack
    };
    augmentStackTraceWithInitialElement(
      result,
      ex.sourceURL || ex.fileName,
      ex.line || ex.lineNumber,
      ex.message || ex.description
    );
    return result;
  }

  /**
   * Computes a stack trace for an exception.
   * @param {Error} ex
   * @param {(string|number)=} depth
   */
  function computeStackTrace(ex, depth) {
    var stack = null;
    depth = depth == null ? 0 : +depth;

    try {
      stack = computeStackTraceFromStackProp(ex);
      if (stack) {
        return stack;
      }
    } catch (e) {
      if (TraceKit.debug) {
        throw e;
      }
    }

    try {
      stack = computeStackTraceByWalkingCallerChain(ex, depth + 1);
      if (stack) {
        return stack;
      }
    } catch (e) {
      if (TraceKit.debug) {
        throw e;
      }
    }
    return {
      name: ex.name,
      message: ex.message,
      url: getLocationHref()
    };
  }

  computeStackTrace.augmentStackTraceWithInitialElement = augmentStackTraceWithInitialElement;
  computeStackTrace.computeStackTraceFromStackProp = computeStackTraceFromStackProp;

  return computeStackTrace;
})();

module.exports = TraceKit;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 202 */
/***/ (function(module, exports) {

/*
 * JavaScript MD5
 * https://github.com/blueimp/JavaScript-MD5
 *
 * Copyright 2011, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 *
 * Based on
 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
 * Digest Algorithm, as defined in RFC 1321.
 * Version 2.2 Copyright (C) Paul Johnston 1999 - 2009
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for more info.
 */

/*
* Add integers, wrapping at 2^32. This uses 16-bit operations internally
* to work around bugs in some JS interpreters.
*/
function safeAdd(x, y) {
  var lsw = (x & 0xffff) + (y & 0xffff);
  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
  return (msw << 16) | (lsw & 0xffff);
}

/*
* Bitwise rotate a 32-bit number to the left.
*/
function bitRotateLeft(num, cnt) {
  return (num << cnt) | (num >>> (32 - cnt));
}

/*
* These functions implement the four basic operations the algorithm uses.
*/
function md5cmn(q, a, b, x, s, t) {
  return safeAdd(bitRotateLeft(safeAdd(safeAdd(a, q), safeAdd(x, t)), s), b);
}
function md5ff(a, b, c, d, x, s, t) {
  return md5cmn((b & c) | (~b & d), a, b, x, s, t);
}
function md5gg(a, b, c, d, x, s, t) {
  return md5cmn((b & d) | (c & ~d), a, b, x, s, t);
}
function md5hh(a, b, c, d, x, s, t) {
  return md5cmn(b ^ c ^ d, a, b, x, s, t);
}
function md5ii(a, b, c, d, x, s, t) {
  return md5cmn(c ^ (b | ~d), a, b, x, s, t);
}

/*
* Calculate the MD5 of an array of little-endian words, and a bit length.
*/
function binlMD5(x, len) {
  /* append padding */
  x[len >> 5] |= 0x80 << (len % 32);
  x[(((len + 64) >>> 9) << 4) + 14] = len;

  var i;
  var olda;
  var oldb;
  var oldc;
  var oldd;
  var a = 1732584193;
  var b = -271733879;
  var c = -1732584194;
  var d = 271733878;

  for (i = 0; i < x.length; i += 16) {
    olda = a;
    oldb = b;
    oldc = c;
    oldd = d;

    a = md5ff(a, b, c, d, x[i], 7, -680876936);
    d = md5ff(d, a, b, c, x[i + 1], 12, -389564586);
    c = md5ff(c, d, a, b, x[i + 2], 17, 606105819);
    b = md5ff(b, c, d, a, x[i + 3], 22, -1044525330);
    a = md5ff(a, b, c, d, x[i + 4], 7, -176418897);
    d = md5ff(d, a, b, c, x[i + 5], 12, 1200080426);
    c = md5ff(c, d, a, b, x[i + 6], 17, -1473231341);
    b = md5ff(b, c, d, a, x[i + 7], 22, -45705983);
    a = md5ff(a, b, c, d, x[i + 8], 7, 1770035416);
    d = md5ff(d, a, b, c, x[i + 9], 12, -1958414417);
    c = md5ff(c, d, a, b, x[i + 10], 17, -42063);
    b = md5ff(b, c, d, a, x[i + 11], 22, -1990404162);
    a = md5ff(a, b, c, d, x[i + 12], 7, 1804603682);
    d = md5ff(d, a, b, c, x[i + 13], 12, -40341101);
    c = md5ff(c, d, a, b, x[i + 14], 17, -1502002290);
    b = md5ff(b, c, d, a, x[i + 15], 22, 1236535329);

    a = md5gg(a, b, c, d, x[i + 1], 5, -165796510);
    d = md5gg(d, a, b, c, x[i + 6], 9, -1069501632);
    c = md5gg(c, d, a, b, x[i + 11], 14, 643717713);
    b = md5gg(b, c, d, a, x[i], 20, -373897302);
    a = md5gg(a, b, c, d, x[i + 5], 5, -701558691);
    d = md5gg(d, a, b, c, x[i + 10], 9, 38016083);
    c = md5gg(c, d, a, b, x[i + 15], 14, -660478335);
    b = md5gg(b, c, d, a, x[i + 4], 20, -405537848);
    a = md5gg(a, b, c, d, x[i + 9], 5, 568446438);
    d = md5gg(d, a, b, c, x[i + 14], 9, -1019803690);
    c = md5gg(c, d, a, b, x[i + 3], 14, -187363961);
    b = md5gg(b, c, d, a, x[i + 8], 20, 1163531501);
    a = md5gg(a, b, c, d, x[i + 13], 5, -1444681467);
    d = md5gg(d, a, b, c, x[i + 2], 9, -51403784);
    c = md5gg(c, d, a, b, x[i + 7], 14, 1735328473);
    b = md5gg(b, c, d, a, x[i + 12], 20, -1926607734);

    a = md5hh(a, b, c, d, x[i + 5], 4, -378558);
    d = md5hh(d, a, b, c, x[i + 8], 11, -2022574463);
    c = md5hh(c, d, a, b, x[i + 11], 16, 1839030562);
    b = md5hh(b, c, d, a, x[i + 14], 23, -35309556);
    a = md5hh(a, b, c, d, x[i + 1], 4, -1530992060);
    d = md5hh(d, a, b, c, x[i + 4], 11, 1272893353);
    c = md5hh(c, d, a, b, x[i + 7], 16, -155497632);
    b = md5hh(b, c, d, a, x[i + 10], 23, -1094730640);
    a = md5hh(a, b, c, d, x[i + 13], 4, 681279174);
    d = md5hh(d, a, b, c, x[i], 11, -358537222);
    c = md5hh(c, d, a, b, x[i + 3], 16, -722521979);
    b = md5hh(b, c, d, a, x[i + 6], 23, 76029189);
    a = md5hh(a, b, c, d, x[i + 9], 4, -640364487);
    d = md5hh(d, a, b, c, x[i + 12], 11, -421815835);
    c = md5hh(c, d, a, b, x[i + 15], 16, 530742520);
    b = md5hh(b, c, d, a, x[i + 2], 23, -995338651);

    a = md5ii(a, b, c, d, x[i], 6, -198630844);
    d = md5ii(d, a, b, c, x[i + 7], 10, 1126891415);
    c = md5ii(c, d, a, b, x[i + 14], 15, -1416354905);
    b = md5ii(b, c, d, a, x[i + 5], 21, -57434055);
    a = md5ii(a, b, c, d, x[i + 12], 6, 1700485571);
    d = md5ii(d, a, b, c, x[i + 3], 10, -1894986606);
    c = md5ii(c, d, a, b, x[i + 10], 15, -1051523);
    b = md5ii(b, c, d, a, x[i + 1], 21, -2054922799);
    a = md5ii(a, b, c, d, x[i + 8], 6, 1873313359);
    d = md5ii(d, a, b, c, x[i + 15], 10, -30611744);
    c = md5ii(c, d, a, b, x[i + 6], 15, -1560198380);
    b = md5ii(b, c, d, a, x[i + 13], 21, 1309151649);
    a = md5ii(a, b, c, d, x[i + 4], 6, -145523070);
    d = md5ii(d, a, b, c, x[i + 11], 10, -1120210379);
    c = md5ii(c, d, a, b, x[i + 2], 15, 718787259);
    b = md5ii(b, c, d, a, x[i + 9], 21, -343485551);

    a = safeAdd(a, olda);
    b = safeAdd(b, oldb);
    c = safeAdd(c, oldc);
    d = safeAdd(d, oldd);
  }
  return [a, b, c, d];
}

/*
* Convert an array of little-endian words to a string
*/
function binl2rstr(input) {
  var i;
  var output = '';
  var length32 = input.length * 32;
  for (i = 0; i < length32; i += 8) {
    output += String.fromCharCode((input[i >> 5] >>> (i % 32)) & 0xff);
  }
  return output;
}

/*
* Convert a raw string to an array of little-endian words
* Characters >255 have their high-byte silently ignored.
*/
function rstr2binl(input) {
  var i;
  var output = [];
  output[(input.length >> 2) - 1] = undefined;
  for (i = 0; i < output.length; i += 1) {
    output[i] = 0;
  }
  var length8 = input.length * 8;
  for (i = 0; i < length8; i += 8) {
    output[i >> 5] |= (input.charCodeAt(i / 8) & 0xff) << (i % 32);
  }
  return output;
}

/*
* Calculate the MD5 of a raw string
*/
function rstrMD5(s) {
  return binl2rstr(binlMD5(rstr2binl(s), s.length * 8));
}

/*
* Calculate the HMAC-MD5, of a key and some data (raw strings)
*/
function rstrHMACMD5(key, data) {
  var i;
  var bkey = rstr2binl(key);
  var ipad = [];
  var opad = [];
  var hash;
  ipad[15] = opad[15] = undefined;
  if (bkey.length > 16) {
    bkey = binlMD5(bkey, key.length * 8);
  }
  for (i = 0; i < 16; i += 1) {
    ipad[i] = bkey[i] ^ 0x36363636;
    opad[i] = bkey[i] ^ 0x5c5c5c5c;
  }
  hash = binlMD5(ipad.concat(rstr2binl(data)), 512 + data.length * 8);
  return binl2rstr(binlMD5(opad.concat(hash), 512 + 128));
}

/*
* Convert a raw string to a hex string
*/
function rstr2hex(input) {
  var hexTab = '0123456789abcdef';
  var output = '';
  var x;
  var i;
  for (i = 0; i < input.length; i += 1) {
    x = input.charCodeAt(i);
    output += hexTab.charAt((x >>> 4) & 0x0f) + hexTab.charAt(x & 0x0f);
  }
  return output;
}

/*
* Encode a string as utf-8
*/
function str2rstrUTF8(input) {
  return unescape(encodeURIComponent(input));
}

/*
* Take string arguments and return either raw or hex encoded strings
*/
function rawMD5(s) {
  return rstrMD5(str2rstrUTF8(s));
}
function hexMD5(s) {
  return rstr2hex(rawMD5(s));
}
function rawHMACMD5(k, d) {
  return rstrHMACMD5(str2rstrUTF8(k), str2rstrUTF8(d));
}
function hexHMACMD5(k, d) {
  return rstr2hex(rawHMACMD5(k, d));
}

function md5(string, key, raw) {
  if (!key) {
    if (!raw) {
      return hexMD5(string);
    }
    return rawMD5(string);
  }
  if (!raw) {
    return hexHMACMD5(key, string);
  }
  return rawHMACMD5(key, string);
}

module.exports = md5;


/***/ }),
/* 203 */
/***/ (function(module, exports) {

function RavenConfigError(message) {
  this.name = 'RavenConfigError';
  this.message = message;
}
RavenConfigError.prototype = new Error();
RavenConfigError.prototype.constructor = RavenConfigError;

module.exports = RavenConfigError;


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

var utils = __webpack_require__(56);

var wrapMethod = function(console, level, callback) {
  var originalConsoleLevel = console[level];
  var originalConsole = console;

  if (!(level in console)) {
    return;
  }

  var sentryLevel = level === 'warn' ? 'warning' : level;

  console[level] = function() {
    var args = [].slice.call(arguments);

    var msg = utils.safeJoin(args, ' ');
    var data = {level: sentryLevel, logger: 'console', extra: {arguments: args}};

    if (level === 'assert') {
      if (args[0] === false) {
        // Default browsers message
        msg =
          'Assertion failed: ' + (utils.safeJoin(args.slice(1), ' ') || 'console.assert');
        data.extra.arguments = args.slice(1);
        callback && callback(msg, data);
      }
    } else {
      callback && callback(msg, data);
    }

    // this fails for some browsers. :(
    if (originalConsoleLevel) {
      // IE9 doesn't allow calling apply on console functions directly
      // See: https://stackoverflow.com/questions/5472938/does-ie9-support-console-log-and-is-it-a-real-function#answer-5473193
      Function.prototype.apply.call(originalConsoleLevel, originalConsole, args);
    }
  };
};

module.exports = {
  wrapMethod: wrapMethod
};


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//----------------------------------------------------------------------
//
// This source file is part of the Folktale project.
//
// Licensed under MIT. See LICENCE for full licence information.
// See CONTRIBUTORS for the list of contributors to the project.
//
//----------------------------------------------------------------------

/*~
 * stability: experimental
 * name: module folktale/adt/union/derivations
 */
module.exports = {
  serialization: __webpack_require__(206),
  equality: __webpack_require__(209),
  debugRepresentation: __webpack_require__(214)
};

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//----------------------------------------------------------------------
//
// This source file is part of the Folktale project.
//
// Licensed under MIT. See LICENCE for full licence information.
// See CONTRIBUTORS for the list of contributors to the project.
//
//----------------------------------------------------------------------

// --[ Dependencies ]---------------------------------------------------
var _require = __webpack_require__(8),
    tagSymbol = _require.tagSymbol,
    typeSymbol = _require.typeSymbol;

var mapValues = __webpack_require__(207);
var values = __webpack_require__(208);
var extend = __webpack_require__(23);

// --[ Constants ]------------------------------------------------------
var typeJsonKey = '@@type';
var tagJsonKey = '@@tag';
var valueJsonKey = '@@value';

// --[ Helpers ]--------------------------------------------------------

/*~
 * type: ((Object 'a) => 'b) => ([Object 'a]) => Object 'b  
 */
var arrayToObject = function arrayToObject(extractKey) {
  return function (array) {
    return array.reduce(function (object, element) {
      object[extractKey(element)] = element;
      return object;
    }, {});
  };
};

/*~
 * type: (String) => (Object 'a) => 'a | None 
 */
var property = function property(propertyName) {
  return function (object) {
    return object[propertyName];
  };
};

/*~
 * type: ([Object 'a]) => Object 'a 
 */
var indexByType = arrayToObject(property(typeSymbol));

/*~
 * type: (String, String) => Bool
 */
var assertType = function assertType(given, expected) {
  if (expected !== given) {
    throw new TypeError('\n       The JSON structure was generated from ' + expected + '.\n       You are trying to parse it as ' + given + '. \n    ');
  }
};

/*~
 * type: |
 *   type JSONSerialisation = {
 *     "@@type":  String,
 *     "@@tag":   String,
 *     "@@value": Object Any
 *   }
 *   type JSONParser = {
 *     fromJSON: (JSONSerialisation, Array JSONParser) => Variant
 *   }
 * 
 *   (Object JSONParser) => (JSONSerialisation) => Any
 */
var parseValue = function parseValue(parsers) {
  return function (value) {
    if (value !== null && typeof value[typeJsonKey] === 'string') {
      var type = value[typeJsonKey];
      if (parsers[type]) {
        return parsers[type].fromJSON(value, parsers, true);
      } else {
        return value;
      }
    } else {
      return value;
    }
  };
};

/*~
 * type: ('a) => JSON
 */
var serializeValue = function serializeValue(value) {
  return value === undefined ? null : value !== null && typeof value.toJSON === 'function' ? value.toJSON() : /* otherwise */value;
};

// --[ Implementation ]-------------------------------------------------

/*~
 * stability: experimental
 * authors:
 *   - "@boris-marinov"
 * 
 * type: |
 *   (Variant, ADT) => Void 
 */
var serialization = function serialization(variant, adt) {
  var typeName = adt[typeSymbol];
  var tagName = variant.prototype[tagSymbol];

  /*~
   * stability: experimental
   * module: null
   * authors:
   *   - "@boris-marinov"
   * 
   * type: |
   *   type JSONSerialisation = {
   *     "@@type":  String,
   *     "@@tag":   String,
   *     "@@value": Object Any
   *   }
   * 
   *   Variant . () => JSONSerialisation
   */
  variant.prototype.toJSON = function () {
    var _ref;

    return _ref = {}, _defineProperty(_ref, typeJsonKey, typeName), _defineProperty(_ref, tagJsonKey, tagName), _defineProperty(_ref, valueJsonKey, mapValues(this, serializeValue)), _ref;
  };

  /*~
   * stability: experimental
   * module: null
   * authors:
   *   - "@boris-marinov"
   * 
   * type: |
   *   type JSONSerialisation = {
   *     "@@type":  String,
   *     "@@tag":   String,
   *     "@@value": Object Any
   *   }
   *   type JSONParser = {
   *     fromJSON: (JSONSerialisation, Array JSONParser) => Variant
   *   }
   * 
   *   (JSONSerialisation, Array JSONParser) => Variant
   */
  adt.fromJSON = function (value) {
    var parsers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _defineProperty({}, typeName, adt);
    var keysIndicateType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    var valueTypeName = value[typeJsonKey];
    var valueTagName = value[tagJsonKey];
    var valueContents = value[valueJsonKey];
    assertType(typeName, valueTypeName);
    var parsersByType = keysIndicateType ? parsers : /*otherwise*/indexByType(values(parsers));

    var parsedValue = mapValues(valueContents, parseValue(parsersByType));
    return extend(Object.create(adt[valueTagName].prototype), parsedValue);
  };
};

// --[ Exports ]--------------------------------------------------------
module.exports = serialization;

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//----------------------------------------------------------------------
//
// This source file is part of the Folktale project.
//
// Licensed under MIT. See LICENCE for full licence information.
// See CONTRIBUTORS for the list of contributors to the project.
//
//----------------------------------------------------------------------

/*~
 * stability: stable
 * authors:
 *   - Quildreen Motta
 *
 * complexity: O(n), n is the number of own enumerable properties.
 * type: |
 *   (Object 'a, ('a) => 'b) => Object 'b
 */
var mapValues = function mapValues(object, transformation) {
  var keys = Object.keys(object);
  var result = {};

  for (var i = 0; i < keys.length; ++i) {
    var key = keys[i];
    result[key] = transformation(object[key]);
  }

  return result;
};

// --[ Convenience ]---------------------------------------------------

/*~
 * stability: stable
 * authors:
 *   - Quildreen Motta
 * 
 * complexity: O(n), n is the number of own enumerable properties.
 * type: |
 *   (Object 'a) . (('a) => 'b) => Object 'b
 */
mapValues.infix = function (transformation) {
  return mapValues(this, transformation);
};

// --[ Exports ]-------------------------------------------------------
module.exports = mapValues;

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//----------------------------------------------------------------------
//
// This source file is part of the Folktale project.
//
// Licensed under MIT. See LICENCE for full licence information.
// See CONTRIBUTORS for the list of contributors to the project.
//
//----------------------------------------------------------------------

/*~
 * stability : stable
 * authors:
 *   - Quildreen Motta
 *
 * complexity : O(n), n is the number of own enumerable properties.
 * type: |
 *   (Object 'a) => Array 'a
 */
var values = function values(object) {
  return Object.keys(object).map(function (k) {
    return object[k];
  });
};

// --[ Exports ]-------------------------------------------------------
module.exports = values;

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//----------------------------------------------------------------------
//
// This source file is part of the Folktale project.
//
// Licensed under MIT. See LICENCE for full licence information.
// See CONTRIBUTORS for the list of contributors to the project.
//
//----------------------------------------------------------------------

// --[ Dependencies ]---------------------------------------------------
var assertType = __webpack_require__(32);
var flEquals = __webpack_require__(210);
var fl = __webpack_require__(97);
var provideAliases = __webpack_require__(33);
var copyDocs = __webpack_require__(98);

var _require = __webpack_require__(8),
    tagSymbol = _require.tagSymbol,
    typeSymbol = _require.typeSymbol;

var toString = Object.prototype.toString;
var prototypeOf = Object.getPrototypeOf;

// --[ Helpers ]--------------------------------------------------------

/*~
 * type: (Any) => Boolean
 */
var isSetoid = function isSetoid(value) {
  return value != null && (typeof value[fl.equals] === 'function' || typeof value.equals === 'function');
};

/*~
 * type: (Variant, Variant) => Boolean
 */
var sameType = function sameType(a, b) {
  return a[typeSymbol] === b[typeSymbol] && a[tagSymbol] === b[tagSymbol];
};

var isPlainObject = function isPlainObject(object) {
  if (Object(object) !== object) return false;

  return !prototypeOf(object) || !object.toString || toString.call(object) === object.toString();
};

var deepEquals = function deepEquals(a, b) {
  if (a === b) return true;

  var leftSetoid = isSetoid(a);
  var rightSetoid = isSetoid(b);
  if (leftSetoid) {
    if (rightSetoid) return flEquals(a, b);else return false;
  }

  if (Array.isArray(a) && Array.isArray(b)) {
    return a.length === b.length && a.every(function (x, i) {
      return deepEquals(x, b[i]);
    });
  }

  if (isPlainObject(a) && isPlainObject(b)) {
    var keysA = Object.keys(a);
    var keysB = Object.keys(b);
    var setB = new Set(keysB);
    return keysA.length === keysB.length && prototypeOf(a) === prototypeOf(b) && keysA.every(function (k) {
      return setB.has(k) && a[k] === b[k];
    });
  }

  return false;
};

// --[ Implementation ]------------------------------------------------
/*~
 * stability: experimental
 * authors:
 *   - "@boris-marinov"
 * 
 * type: |
 *   (('a, 'a) => Boolean) => (Variant, Union) => Void
 */
var createDerivation = function createDerivation(valuesEqual) {
  /*~
   * type: ('a, 'a) => Boolean
   */
  var equals = function equals(a, b) {
    // identical objects must be equal
    if (a === b) return true;

    // we require both values to be setoids if one of them is
    var leftSetoid = isSetoid(a);
    var rightSetoid = isSetoid(b);
    if (leftSetoid) {
      if (rightSetoid) return flEquals(a, b);else return false;
    }

    // fall back to the provided equality
    return valuesEqual(a, b);
  };

  /*~
   * type: (Object Any, Object Any, Array String) => Boolean
   */
  var compositesEqual = function compositesEqual(a, b, keys) {
    for (var i = 0; i < keys.length; ++i) {
      var keyA = a[keys[i]];
      var keyB = b[keys[i]];
      if (!equals(keyA, keyB)) {
        return false;
      }
    }
    return true;
  };

  var derivation = function derivation(variant, adt) {
    /*~
     * stability: experimental
     * module: null
     * authors:
     *   - "@boris-marinov"
     *   - Quildreen Motta
     * 
     * type: |
     *   forall S, a:
     *     (S a).(S a) => Boolean
     *   where S is Setoid
     */
    variant.prototype.equals = function (value) {
      assertType(adt)(this[tagSymbol] + '#equals', value);
      return sameType(this, value) && compositesEqual(this, value, Object.keys(this));
    };
    provideAliases(variant.prototype);
    return variant;
  };
  copyDocs(createDerivation, derivation, {
    type: '(Variant, Union) => Void'
  });

  return derivation;
};

// --[ Exports ]-------------------------------------------------------

/*~~inheritsMeta: createDerivation */
module.exports = createDerivation(deepEquals);

module.exports.withCustomComparison = createDerivation;

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//----------------------------------------------------------------------
//
// This source file is part of the Folktale project.
//
// Licensed under MIT. See LICENCE for full licence information.
// See CONTRIBUTORS for the list of contributors to the project.
//
//----------------------------------------------------------------------

var _require = __webpack_require__(97),
    flEquals = _require.equals;

var curry = __webpack_require__(211);
var warn = __webpack_require__(212)('equals');
var unsupported = __webpack_require__(213)('equals');

var isNew = function isNew(a) {
  return typeof a[flEquals] === 'function';
};
var isOld = function isOld(a) {
  return typeof a.equals === 'function';
};

/*~
 * stability: experimental
 * authors:
 *   - "@boris-marinov"
 *   - Quildreen Motta
 * 
 * type: |
 *   forall S, a:
 *     (S a, S a) => Boolean
 *   where S is Setoid
 */
var equals = function equals(setoidLeft, setoidRight) {
  return isNew(setoidLeft) ? setoidLeft[flEquals](setoidRight) : isOld(setoidLeft) ? warn(setoidLeft.equals(setoidRight)) : /*otherwise*/unsupported(setoidLeft);
};

/*~
 * stability: experimental
 * authors:
 *   - "@boris-marinov"
 *   - Quildreen Motta
 * 
 * type: |
 *   forall S, a:
 *     (S a) => (S a) => Boolean
 *   where S is Setoid
 */
equals.curried = curry(2, function (setoidRight, setoidLeft) {
  return (// eslint-disable-line no-magic-numbers
    equals(setoidLeft, setoidRight)
  );
});

/*~
 * stability: experimental
 * authors:
 *   - Quildreen Motta
 * 
 * type: |
 *   forall S, a:
 *     (S a).(S a) => Boolean
 *   where S is Setoid
 */
equals.infix = function (aSetoid) {
  return equals(this, aSetoid);
};

module.exports = equals;

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//----------------------------------------------------------------------
//
// This source file is part of the Folktale project.
//
// Licensed under MIT. See LICENCE for full licence information.
// See CONTRIBUTORS for the list of contributors to the project.
//
//----------------------------------------------------------------------

/*~
 * stability: experimental
 * authors:
 *   - Quildreen Motta
 *
 * type: |
 *   (Number, (Any...) => 'a) => Any... => 'a or ((Any...) => 'a)
 */
var curry = function curry(arity, fn) {
  var curried = function curried(oldArgs) {
    return function () {
      for (var _len = arguments.length, newArgs = Array(_len), _key = 0; _key < _len; _key++) {
        newArgs[_key] = arguments[_key];
      }

      var allArgs = oldArgs.concat(newArgs);
      var argCount = allArgs.length;

      return argCount < arity ? curried(allArgs) : /* otherwise */fn.apply(undefined, _toConsumableArray(allArgs));
    };
  };

  return curried([]);
};

// --[ Exports ]-------------------------------------------------------
module.exports = curry;

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//----------------------------------------------------------------------
//
// This source file is part of the Folktale project.
//
// Licensed under MIT. See LICENCE for full licence information.
// See CONTRIBUTORS for the list of contributors to the project.
//
//----------------------------------------------------------------------

var deprecated = __webpack_require__(19);

module.exports = function (methodName) {
  return function (result) {
    deprecated('Type.' + methodName + '() is being deprecated in favour of Type[\'fantasy-land/' + methodName + '\'](). \n    Your data structure is using the old-style fantasy-land methods,\n    and these won\'t be supported in Folktale 3');
    return result;
  };
};

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//----------------------------------------------------------------------
//
// This source file is part of the Folktale project.
//
// Licensed under MIT. See LICENCE for full licence information.
// See CONTRIBUTORS for the list of contributors to the project.
//
//----------------------------------------------------------------------

module.exports = function (methodName) {
  return function (object) {
    throw new TypeError(object + " does not have a method '" + methodName + "'.");
  };
};

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//----------------------------------------------------------------------
//
// This source file is part of the Folktale project.
//
// Licensed under MIT. See LICENCE for full licence information.
// See CONTRIBUTORS for the list of contributors to the project.
//
//----------------------------------------------------------------------

// --[ Dependencies ]---------------------------------------------------
var _require = __webpack_require__(8),
    tagSymbol = _require.tagSymbol,
    typeSymbol = _require.typeSymbol;

// --[ Helpers ]--------------------------------------------------------
/*~
 * type: (Object Any) => String
 */


var objectToKeyValuePairs = function objectToKeyValuePairs(object) {
  return Object.keys(object).map(function (key) {
    return key + ': ' + showValue(object[key]);
  }).join(', ');
};

/*~
 * type: (Object Any).() => String
 */
var plainObjectToString = function plainObjectToString() {
  return '{ ' + objectToKeyValuePairs(this) + ' }';
};

/*~
 * type: (Array Any).() => String
 */
var arrayToString = function arrayToString() {
  return '[' + this.map(showValue).join(', ') + ']';
};

/*~
 * type: (Function) => String
 */
var functionNameToString = function functionNameToString(fn) {
  return fn.name !== '' ? ': ' + fn.name : '';
};

/*~
 * type: (Function) => String
 */
var functionToString = function functionToString(fn) {
  return '[Function' + functionNameToString(fn) + ']';
};

/*~
 * type: () => String
 */
var nullToString = function nullToString() {
  return 'null';
};

/*~
 * type: (Any) => Bool
 */
var isPlainObject = function isPlainObject(object) {
  return !object.toString || object.toString === Object.prototype.toString;
};

/*~
 * type: (Null | Object Any) => String
 */
var objectToString = function objectToString(object) {
  return object === null ? nullToString : Array.isArray(object) ? arrayToString : isPlainObject(object) ? plainObjectToString : /* otherwise */object.toString;
};

/*~
 * type: (Any) => String
 */
var showValue = function showValue(value) {
  return typeof value === 'undefined' ? 'undefined' : typeof value === 'function' ? functionToString(value) : (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'symbol' ? value.toString() : (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' ? objectToString(value).call(value) : /* otherwise */JSON.stringify(value);
};

// --[ Implementation ]------------------------------------------------

/*~
 * stability: experimental
 * authors:
 *   - "@boris-marinov"
 * 
 * type: |
 *   (Variant, Union) => Void
 */
var debugRepresentation = function debugRepresentation(variant, adt) {
  // eslint-disable-line max-statements
  var typeName = adt[typeSymbol];
  var variantName = adt[typeSymbol] + '.' + variant.prototype[tagSymbol];

  // (for Object.prototype.toString)
  adt[Symbol.toStringTag] = typeName;
  variant.prototype[Symbol.toStringTag] = variantName;

  // (regular JavaScript representations)
  /*~
   * stability: experimental
   * module: null
   * authors:
   *   - "@boris-marinov"
   * 
   * type: |
   *   () => String
   */
  adt.toString = function () {
    return typeName;
  };

  /*~
   * stability: experimental
   * mmodule: null
   * authors:
   *   - "@boris-marinov"
   * 
   * type: |
   *   () => String
   */
  variant.toString = function () {
    return variantName;
  };

  /*~
   * stability: experimental
   * module: null
   * authors:
   *   - "@boris-marinov"
   * 
   * type: |
   *   (Union).() => String
   */
  variant.prototype.toString = function () {
    return variantName + '(' + plainObjectToString.call(this) + ')';
  };

  // (Node REPL representations)
  adt.inspect = adt.toString;
  variant.inspect = variant.toString;
  variant.prototype.inspect = variant.prototype.toString;

  return variant;
};

// --[ Exports ]-------------------------------------------------------
module.exports = debugRepresentation;

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//----------------------------------------------------------------------
//
// This source file is part of the Folktale project.
//
// Licensed under MIT. See LICENCE for full licence information.
// See CONTRIBUTORS for the list of contributors to the project.
//
//----------------------------------------------------------------------

var _require = __webpack_require__(99),
    Success = _require.Success,
    Failure = _require.Failure;

/*~
 * stability: stable
 * authors:
 *   - "@boris-marinov"
 * 
 * type: |
 *   forall a, b:
 *     (Result a b) => Validation a b
 */


var resultToValidation = function resultToValidation(aResult) {
  return aResult.matchWith({
    Error: function Error(_ref) {
      var value = _ref.value;
      return Failure(value);
    },
    Ok: function Ok(_ref2) {
      var value = _ref2.value;
      return Success(value);
    }
  });
};

module.exports = resultToValidation;

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//----------------------------------------------------------------------
//
// This source file is part of the Folktale project.
//
// Licensed under MIT. See LICENCE for full licence information.
// See CONTRIBUTORS for the list of contributors to the project.
//
//----------------------------------------------------------------------

var _require = __webpack_require__(99),
    Success = _require.Success,
    Failure = _require.Failure;

/*~
 * stability: stable
 * authors:
 *   - "@boris-marinov"
 * 
 * type: |
 *   forall a, b:
 *     (Maybe a, b) => Validation b a
 */


var maybeToValidation = function maybeToValidation(aMaybe, failureValue) {
  return aMaybe.matchWith({
    Nothing: function Nothing() {
      return Failure(failureValue);
    },
    Just: function Just(_ref) {
      var value = _ref.value;
      return Success(value);
    }
  });
};

module.exports = maybeToValidation;

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//----------------------------------------------------------------------
//
// This source file is part of the Folktale project.
//
// Licensed under MIT. See LICENCE for full licence information.
// See CONTRIBUTORS for the list of contributors to the project.
//
//----------------------------------------------------------------------

var _require = __webpack_require__(22),
    Error = _require.Error,
    Ok = _require.Ok;

/*~
 * stability: experimental
 * authors:
 *   - "@boris-marinov"
 * 
 * type: |
 *   forall a, b: (() => b :: throws a) => Result a b
 */


var _try = function _try(f) {
  try {
    return Ok(f());
  } catch (e) {
    return Error(e);
  }
};

module.exports = _try;

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//----------------------------------------------------------------------
//
// This source file is part of the Folktale project.
//
// Licensed under MIT. See LICENCE for full licence information.
// See CONTRIBUTORS for the list of contributors to the project.
//
//----------------------------------------------------------------------

var _require = __webpack_require__(22),
    Error = _require.Error,
    Ok = _require.Ok;

var deprecated = __webpack_require__(19);

/*~
 * stability: stable
 * authors:
 *   - "@boris-marinov"
 * 
 * type: |
 *   forall a, b:
 *     (a or None, b) => Result b a
 *   & (a or None) => Result None a
 */
var nullableToResult = function nullableToResult(a, givenFallback) {
  var oldBehaviour = arguments.length < 2; // eslint-disable-line prefer-rest-params
  if (oldBehaviour) {
    deprecated('nullableToResult(value) is being deprecated in favour of providing an explicit fallback value.\nnullableToResult(value, fallback) is the new preferred form of this function.\n');
  }

  var fallback = oldBehaviour ? a : givenFallback;
  return a != null ? Ok(a) : /* else */Error(fallback);
};

module.exports = nullableToResult;

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var identity_ = __webpack_require__(0).identity;
var baseParams = __webpack_require__(220);
var getAppVersion = __webpack_require__(104);

var _require = __webpack_require__(35),
    getAppUrl = _require.getAppUrl;

var shouldSendReport = __webpack_require__(221);

module.exports = function (_ref) {
  var Raven = _ref.Raven,
      appName = _ref.appName,
      browserUrlGetter = _ref.browserUrlGetter,
      dsn = _ref.dsn,
      params = _ref.params;

  var appUrl = getAppUrl(appName);
  var appVersion = getAppVersion(appUrl);

  // do not install(), we want to control the error reporting ourselves
  // instead of Raven hooking to everything
  Raven.config(dsn, Object.assign(baseParams, { release: appVersion, captureUnhandledRejections: false }, params));

  Raven.setShouldSendCallback(shouldSendReport);

  Raven.setDataCallback(function (data) {
    var originalCallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : identity_;

    //in a worker raven does not set this required field which leads to sentry bugs
    data.request = Object.assign(data.request || {}, {
      url: browserUrlGetter()
    });

    return originalCallback(data);
  });

  return Raven;
};

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  //the default was 250, increased to 1000 to support long Santa urls with overrides
  maxUrlLength: 1000
};

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(222),
    extract = _require.extract,
    parse = _require.parse;

var get_ = __webpack_require__(0).get;
var includes_ = __webpack_require__(0).includes;
var identity_ = __webpack_require__(0).identity;
var result = __webpack_require__(18);
var maybe = __webpack_require__(1);

var DEV_QUERY_PARAMS = ['ReactSource', 'EditorSource', 'experiments', 'petri_ovr', 'WixCodeRuntimeSource', 'js-wixcode-sdk-override', 'debug'];

var doesNotContainDevQueryParameter = function doesNotContainDevQueryParameter(queryParameters) {
  return Object.keys(queryParameters).every(function (key) {
    return !includes_(DEV_QUERY_PARAMS, key);
  });
};

var getUrlsFromData = function getUrlsFromData(data) {
  return [get_(data, ['request', 'headers', 'Referer']), get_(data, ['request', 'url'])];
};

var shouldSendReportByUrl = function shouldSendReportByUrl(url) {
  return maybe.fromNullable(url).chain(function (url) {
    return result.try(function () {
      return parse(extract(url));
    });
  }).map(function (queryParameters) {
    return doesNotContainDevQueryParameter(queryParameters);
  }).getOrElse(true);
};

var shouldSendReportByUrls = function shouldSendReportByUrls(data) {
  return getUrlsFromData(data).every(shouldSendReportByUrl);
};

var validators = [shouldSendReportByUrls];

var shouldSendReport = function shouldSendReport(data) {
  var originalCallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : identity_;
  return validators.concat(originalCallback).every(function (v) {
    return v(data);
  });
};

module.exports = shouldSendReport;

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strictUriEncode = __webpack_require__(223);
var objectAssign = __webpack_require__(224);
var decodeComponent = __webpack_require__(225);

function encoderForArrayFormat(opts) {
	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, index) {
				return value === null ? [
					encode(key, opts),
					'[',
					index,
					']'
				].join('') : [
					encode(key, opts),
					'[',
					encode(index, opts),
					']=',
					encode(value, opts)
				].join('');
			};

		case 'bracket':
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'[]=',
					encode(value, opts)
				].join('');
			};

		default:
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'=',
					encode(value, opts)
				].join('');
			};
	}
}

function parserForArrayFormat(opts) {
	var result;

	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, accumulator) {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return function (key, value, accumulator) {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				} else if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		default:
			return function (key, value, accumulator) {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function encode(value, opts) {
	if (opts.encode) {
		return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	} else if (typeof input === 'object') {
		return keysSorter(Object.keys(input)).sort(function (a, b) {
			return Number(a) - Number(b);
		}).map(function (key) {
			return input[key];
		});
	}

	return input;
}

function extract(str) {
	var queryStart = str.indexOf('?');
	if (queryStart === -1) {
		return '';
	}
	return str.slice(queryStart + 1);
}

function parse(str, opts) {
	opts = objectAssign({arrayFormat: 'none'}, opts);

	var formatter = parserForArrayFormat(opts);

	// Create an object with no prototype
	// https://github.com/sindresorhus/query-string/issues/47
	var ret = Object.create(null);

	if (typeof str !== 'string') {
		return ret;
	}

	str = str.trim().replace(/^[?#&]/, '');

	if (!str) {
		return ret;
	}

	str.split('&').forEach(function (param) {
		var parts = param.replace(/\+/g, ' ').split('=');
		// Firefox (pre 40) decodes `%3D` to `=`
		// https://github.com/sindresorhus/query-string/pull/37
		var key = parts.shift();
		var val = parts.length > 0 ? parts.join('=') : undefined;

		// missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		val = val === undefined ? null : decodeComponent(val);

		formatter(decodeComponent(key), val, ret);
	});

	return Object.keys(ret).sort().reduce(function (result, key) {
		var val = ret[key];
		if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
			// Sort object keys, not values
			result[key] = keysSorter(val);
		} else {
			result[key] = val;
		}

		return result;
	}, Object.create(null));
}

exports.extract = extract;
exports.parse = parse;

exports.stringify = function (obj, opts) {
	var defaults = {
		encode: true,
		strict: true,
		arrayFormat: 'none'
	};

	opts = objectAssign(defaults, opts);

	if (opts.sort === false) {
		opts.sort = function () {};
	}

	var formatter = encoderForArrayFormat(opts);

	return obj ? Object.keys(obj).sort(opts.sort).map(function (key) {
		var val = obj[key];

		if (val === undefined) {
			return '';
		}

		if (val === null) {
			return encode(key, opts);
		}

		if (Array.isArray(val)) {
			var result = [];

			val.slice().forEach(function (val2) {
				if (val2 === undefined) {
					return;
				}

				result.push(formatter(key, val2, result.length));
			});

			return result.join('&');
		}

		return encode(key, opts) + '=' + encode(val, opts);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&') : '';
};

exports.parseUrl = function (str, opts) {
	return {
		url: str.split('?')[0] || '',
		query: parse(extract(str), opts)
	};
};


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (str) {
	return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
		return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	});
};


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var token = '%[a-f0-9]{2}';
var singleMatcher = new RegExp(token, 'gi');
var multiMatcher = new RegExp('(' + token + ')+', 'gi');

function decodeComponents(components, split) {
	try {
		// Try to decode the entire string first
		return decodeURIComponent(components.join(''));
	} catch (err) {
		// Do nothing
	}

	if (components.length === 1) {
		return components;
	}

	split = split || 1;

	// Split the array in 2 parts
	var left = components.slice(0, split);
	var right = components.slice(split);

	return Array.prototype.concat.call([], decodeComponents(left), decodeComponents(right));
}

function decode(input) {
	try {
		return decodeURIComponent(input);
	} catch (err) {
		var tokens = input.match(singleMatcher);

		for (var i = 1; i < tokens.length; i++) {
			input = decodeComponents(tokens, i).join('');

			tokens = input.match(singleMatcher);
		}

		return input;
	}
}

function customDecodeURIComponent(input) {
	// Keep track of all the replacements and prefill the map with the `BOM`
	var replaceMap = {
		'%FE%FF': '\uFFFD\uFFFD',
		'%FF%FE': '\uFFFD\uFFFD'
	};

	var match = multiMatcher.exec(input);
	while (match) {
		try {
			// Decode as big chunks as possible
			replaceMap[match[0]] = decodeURIComponent(match[0]);
		} catch (err) {
			var result = decode(match[0]);

			if (result !== match[0]) {
				replaceMap[match[0]] = result;
			}
		}

		match = multiMatcher.exec(input);
	}

	// Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
	replaceMap['%C2'] = '\uFFFD';

	var entries = Object.keys(replaceMap);

	for (var i = 0; i < entries.length; i++) {
		// Replace all decoded components
		var key = entries[i];
		input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
	}

	return input;
}

module.exports = function (encodedURI) {
	if (typeof encodedURI !== 'string') {
		throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
	}

	try {
		encodedURI = encodedURI.replace(/\+/g, ' ');

		// Try the built in decoder first
		return decodeURIComponent(encodedURI);
	} catch (err) {
		// Fallback to a more advanced decoder
		return customDecodeURIComponent(encodedURI);
	}
};


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//----------------------------------------------------------------------
//
// This source file is part of the Folktale project.
//
// Licensed under MIT. See LICENCE for full licence information.
// See CONTRIBUTORS for the list of contributors to the project.
//
//----------------------------------------------------------------------

var _require = __webpack_require__(34),
    Nothing = _require.Nothing,
    Just = _require.Just;

/*~
 * stability: stable
 * authors:
 *   - Quildreen Motta
 * 
 * type: |
 *   forall a:
 *     (a or None) => Maybe a
 */


var nullableToMaybe = function nullableToMaybe(a) {
  return a != null ? Just(a) : /*else*/Nothing();
};

module.exports = nullableToMaybe;

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var isError_ = __webpack_require__(0).isError;
var negate_ = __webpack_require__(0).negate;

var _require = __webpack_require__(228),
    extendConsoleError = _require.extendConsoleError,
    isAppInvolvedWithError = _require.isAppInvolvedWithError,
    addUnhandledRejectionListener = _require.addUnhandledRejectionListener,
    shouldReportException = _require.shouldReportException,
    reportException = _require.reportException;

var isErrorHandled = __webpack_require__(105);

module.exports = function (Raven, globalScope, appName) {
  var handleException = function handleException(error) {
    if (shouldReportException(error, isError_, negate_(isErrorHandled), isAppInvolvedWithError(appName))) {
      reportException(error, appName, Raven, {
        tags: { errorBoundaries: 'non-scoped' }
      });
    }
  };

  extendConsoleError(globalScope, function () {
    return handleException(arguments.length <= 0 ? undefined : arguments[0]);
  });
  addUnhandledRejectionListener(global, function (evt) {
    return handleException(evt.reason);
  });
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var invoke_ = __webpack_require__(0).invoke;

function getErrorStacktraceFirstLine(err) {
  var printedError = err.stack.toString();
  return printedError.substring(printedError.indexOf('https://')).split('\n')[0];
}

var isAppInFirstLineInStacktrace = function isAppInFirstLineInStacktrace(appName) {
  return function (err) {
    return getErrorStacktraceFirstLine(err).includes(appName);
  };
};

module.exports.isAppInvolvedWithError = function (appName) {
  return function (err) {
    return err.stack && err.stack.toString().includes(appName);
  };
};

module.exports.addUnhandledRejectionListener = function (workerGlobalScope, callback) {
  return invoke_(workerGlobalScope, 'addEventListener', 'unhandledrejection', callback);
};

module.exports.extendConsoleError = function (workerGlobalScope, callback) {
  var console = workerGlobalScope.console;
  var originalConsoleError = console.error.bind(console);
  console.error = function () {
    try {
      callback.apply(undefined, arguments);
    } catch (e) {
      originalConsoleError(e);
    }
    originalConsoleError.apply(undefined, arguments);
  };
};

module.exports.shouldReportException = function (error) {
  for (var _len = arguments.length, functions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    functions[_key - 1] = arguments[_key];
  }

  return functions.reduce(function (res, func) {
    return res && func(error);
  }, true);
};

module.exports.reportException = function (error, appName, Raven) {
  var ravenOptions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  ravenOptions.tags = Object.assign(ravenOptions.tags || {}, {
    'errorBoundaries.isInFirstLine': isAppInFirstLineInStacktrace(appName)(error)
  });

  Raven.captureException(error, ravenOptions);
};

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function isPromise(something) {
	return something && typeof something.then === 'function';
}

var errorScopingFactory = function errorScopingFactory(scope, errorHandler) {
	return function (func) {
		return function () {
			try {
				var result = func.apply(undefined, arguments);
				if (isPromise(result)) {
					return result.catch(function (e) {
						errorHandler(e, scope);
						throw e;
					});
				}

				return result;
			} catch (e) {
				errorHandler(e, scope);
				throw e;
			}
		};
	};
};

function errorBoundaries(_ref) {
	var scopes = _ref.scopes,
	    errorHandler = _ref.errorHandler;

	var boundaries = {};
	scopes.forEach(function (scope) {
		boundaries[scope] = errorScopingFactory(scope, errorHandler);
	});

	return boundaries;
}

module.exports = errorBoundaries;

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _extendableBuiltin(cls) {
  function ExtendableBuiltin() {
    cls.apply(this, arguments);
  }

  ExtendableBuiltin.prototype = Object.create(cls.prototype, {
    constructor: {
      value: cls,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });

  if (Object.setPrototypeOf) {
    Object.setPrototypeOf(ExtendableBuiltin, cls);
  } else {
    ExtendableBuiltin.__proto__ = cls;
  }

  return ExtendableBuiltin;
}

var ExtendableError = function (_extendableBuiltin2) {
  _inherits(ExtendableError, _extendableBuiltin2);

  function ExtendableError() {
    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    _classCallCheck(this, ExtendableError);

    // extending Error is weird and does not propagate `message`
    var _this = _possibleConstructorReturn(this, (ExtendableError.__proto__ || Object.getPrototypeOf(ExtendableError)).call(this, message));

    Object.defineProperty(_this, 'message', {
      configurable: true,
      enumerable: false,
      value: message,
      writable: true
    });

    Object.defineProperty(_this, 'name', {
      configurable: true,
      enumerable: false,
      value: _this.constructor.name,
      writable: true
    });

    if (Error.hasOwnProperty('captureStackTrace')) {
      Error.captureStackTrace(_this, _this.constructor);
      return _possibleConstructorReturn(_this);
    }

    Object.defineProperty(_this, 'stack', {
      configurable: true,
      enumerable: false,
      value: new Error(message).stack,
      writable: true
    });
    return _this;
  }

  return ExtendableError;
}(_extendableBuiltin(Error));

exports.default = ExtendableError;
module.exports = exports['default'];


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var identity_ = __webpack_require__(0).identity;
var get_ = __webpack_require__(0).get;

var setupRaven = __webpack_require__(57);

var _require = __webpack_require__(13),
    isDatasetError = _require.isDatasetError;

module.exports = function (Raven, globalScope, dsn) {
  var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var appName = arguments[4];

  setupRaven(Raven, globalScope, dsn, params, appName);
  Raven.setDataCallback(function (data) {
    var originalCallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : identity_;

    if (isDatasetError(get_(data, ['exception', 'values', 0, 'type']))) {
      data.level = 'info';
    }

    return originalCallback(data);
  });
};

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var webBiLogger = __webpack_require__(233).default;

var _require = __webpack_require__(244),
    BI_SOURCE = _require.BI_SOURCE,
    BI_VIEWER_ENDPOINT = _require.BI_VIEWER_ENDPOINT,
    BI_ERROR_ENDPOINT = _require.BI_ERROR_ENDPOINT,
    workerLoggerFactory = _require.workerLoggerFactory;

var _require2 = __webpack_require__(35),
    getAppUrl = _require2.getAppUrl;

var getAppVersion = __webpack_require__(104);

var APP_NAME = 'dbsm-viewer-app';

var biDefaults = {
  src: BI_SOURCE,
  ver: getAppVersion(getAppUrl(APP_NAME)),
  app_name: APP_NAME,
  app_id: 'dataBinding'
};

var setupBiLogger = function setupBiLogger() {
  return workerLoggerFactory(webBiLogger.factory({ endpoint: BI_VIEWER_ENDPOINT }).updateDefaults(biDefaults));
};

var setupErrorBiLogger = function setupErrorBiLogger() {
  return workerLoggerFactory(webBiLogger.factory({ endpoint: BI_ERROR_ENDPOINT }).updateDefaults(biDefaults).updateDefaults({ evid: 10 }));
};

module.exports.setupBiLogger = setupBiLogger;
module.exports.setupErrorBiLogger = setupErrorBiLogger;

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _biLoggerFactory = __webpack_require__(234);

var _biLoggerFactory2 = _interopRequireDefault(_biLoggerFactory);

var _env = __webpack_require__(36);

var _publishers = __webpack_require__(239);

var _browsingSession = __webpack_require__(242);

var browsingSession = _interopRequireWildcard(_browsingSession);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getPublisher() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var publisher = void 0;

  if ((0, _env.isWebWorker)()) {
    publisher = _publishers.fetchPublisher;
  } else if (options.useBeacon) {
    publisher = _publishers.beaconPublisher;
  } else {
    publisher = _publishers.imagePublisher;
  }

  return publisher(options);
}

var _factory = function _factory(options) {
  return new _biLoggerFactory2.default().addPublisher(getPublisher(options));
};

var logger = {
  factory: function factory() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var trackSession = options.trackSession || typeof options.trackSession === 'undefined';

    if (trackSession) {
      browsingSession.track(_factory);
    }

    return _factory(options);
  },
  setHost: _env.setHost
};

exports.default = logger;

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var assert = __webpack_require__(106);
var BiLogger = __webpack_require__(235);

var BiLoggerFactory = function () {
  function BiLoggerFactory() {
    _classCallCheck(this, BiLoggerFactory);

    this._publishers = [];
    this._validators = [];
    this._defaults = {};
    this._events = {};
  }

  _createClass(BiLoggerFactory, [{
    key: 'addPublisher',
    value: function addPublisher(publisher) {
      assert.defined(publisher, 'Publisher must be provided');
      assert.ok(typeof publisher === 'function', 'Expected a publisher function');
      this._publishers.push(publisher);
      return this;
    }
  }, {
    key: 'addValidator',
    value: function addValidator(validator) {
      assert.defined(validator, 'Validator must be provided');
      assert.ok((typeof validator === 'undefined' ? 'undefined' : _typeof(validator)) === 'object' && validator, 'Expected a validator object');
      assert.ok(validator.execute && validator.match, 'Provided validator does not match the interface');
      this._validators.push(validator);
      return this;
    }
  }, {
    key: 'setDefaults',
    value: function setDefaults(defaults) {
      assert.defined(defaults, 'Defaults must be provided');
      assert.object(defaults, 'Defaults must be an object');
      this._defaults = defaults;
      return this;
    }
  }, {
    key: 'updateDefaults',
    value: function updateDefaults(defaults) {
      assert.defined(defaults, 'Defaults must be provided');
      assert.object(defaults, 'Defaults must be an object');
      Object.assign(this._defaults, defaults);
      return this;
    }
  }, {
    key: 'setEvents',
    value: function setEvents(events) {
      assert.defined(events, 'Events must be provided');
      assert.object(events, 'Events must be an object');
      this._events = events;
      return this;
    }
  }, {
    key: 'setDefaultValueTimeout',
    value: function setDefaultValueTimeout(defaultValueTimeout) {
      assert.defined(defaultValueTimeout, 'Default Value Timeout must be provided');
      this._defaultValueTimeout = defaultValueTimeout;
      return this;
    }
  }, {
    key: 'setDefaultContinueOnFail',
    value: function setDefaultContinueOnFail(defaultContinueOnFail) {
      assert.defined(defaultContinueOnFail, 'Default Continue On Fail must be provided');
      this._defaultContinueOnFail = defaultContinueOnFail;
      return this;
    }
  }, {
    key: 'logger',
    value: function logger(context) {
      return new BiLogger({
        publishers: this._publishers,
        validators: this._validators,
        defaults: this._defaults,
        events: this._events,
        defaultValueTimeout: this._defaultValueTimeout,
        defaultContinueOnFail: this._defaultContinueOnFail
      }, context);
    }
  }]);

  return BiLoggerFactory;
}();

module.exports = BiLoggerFactory;
//# sourceMappingURL=bi-logger-factory.js.map

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var assert = __webpack_require__(106);

var _require = __webpack_require__(236),
    mapValues = _require.mapValues;

var promise = __webpack_require__(237);

var _require2 = __webpack_require__(238),
    log = _require2.log;

var BiLogger = function () {
  //TODO: validate args
  function BiLogger(options, context) {
    _classCallCheck(this, BiLogger);

    this._publishers = options.publishers;
    this._validators = options.validators || [];
    this._defaults = options.defaults;
    this._events = options.events || {};
    this._context = context;
    this._defaultValueTimeout = options.defaultValueTimeout || 5000;
    this._defaultContinueOnFail = options.defaultContinueOnFail || false;
  }

  _createClass(BiLogger, [{
    key: 'log',
    value: function log(eventOrKey, eventOrUndefined) {
      var _this = this;

      assert.defined(eventOrKey, 'Event object or event key must be provided.');
      var event = this._eventOrExtractFromEvents(eventOrKey, eventOrUndefined);

      return this._getDefaults().then(function (defaults) {
        var fullEvent = Object.assign({}, defaults, event);

        var validatorsResult = _this._validators.length === 0 ? true : _this._validators.some(function (validator) {
          return validator.match(fullEvent) && (validator.execute(fullEvent) || true);
        });

        if (!validatorsResult) {
          throw new Error('No validator accepted the event. Source: ' + fullEvent.src + ' Evid: ' + (fullEvent.evid || fullEvent.evtId));
        }

        return Promise.all(_this._publishers.map(function (publish) {
          var cloned = Object.assign({}, fullEvent);

          return Promise.resolve().then(function () {
            return publish(cloned, _this._context);
          }).catch(function (error) {
            if (error && error.message && error.stack) {
              error.message = 'Publisher \'' + publish.name + '\' failed with error: \'' + error.message + '\'';
            }

            return Promise.reject(error);
          });
        }));
      });
    }
  }, {
    key: '_eventOrExtractFromEvents',
    value: function _eventOrExtractFromEvents(eventOrKey, eventOrUndefined) {
      if (typeof eventOrKey !== 'string') {
        return eventOrKey;
      }
      var event = this._events[eventOrKey];
      if (!event) {
        throw new assert.AssertionError('Event with key \'' + eventOrKey + '\' not found in event map.');
      }

      if (eventOrUndefined) {
        return Object.assign({}, event, eventOrUndefined);
      } else {
        return event;
      }
    }
  }, {
    key: '_handleDefaultsError',
    value: function _handleDefaultsError(err) {
      if (this._defaultContinueOnFail) {
        log.error(err);
        return null;
      }
      return Promise.reject(err);
    }
  }, {
    key: '_getDefaults',
    value: function _getDefaults() {
      var _this2 = this;

      if (!this._defaults) {
        return Promise.resolve({});
      }

      var promises = mapValues(this._defaults, function (value, key) {
        if (typeof value === 'function') {
          try {
            value = value();
          } catch (err) {
            return _this2._handleDefaultsError(err);
          }
        }
        if (value && typeof value.then !== 'function') {
          return value;
        }
        return promise.timedPromise(value, {
          message: 'Cannot get default value \'' + key + ' for BI Event\'',
          timeout: _this2._defaultValueTimeout
        }).catch(function (err) {
          return _this2._handleDefaultsError(err);
        });
      });

      return promise.allAsObject(promises);
    }
  }]);

  return BiLogger;
}();

module.exports = BiLogger;
//# sourceMappingURL=bi-logger.js.map

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * This callback type is called `requestCallback` and is displayed as a global symbol.
 *
 * @callback iterateeCallback
 * @param {*} Value
 * @param {string} Key
 * @param {object} Original object
 */
/**
 * Iterates over object values
 * @param {Object} collection
 * @param {iterateeCallback} iteratee
 * @return {Object} iterated object
 */
module.exports.mapValues = function (collection, iteratee) {
  if (!collection) {
    return {};
  }
  return Object.keys(collection).reduce(function (acc, key) {
    acc[key] = iteratee(collection[key], key, collection);
    return acc;
  }, {});
};
//# sourceMappingURL=collections.js.map

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * rejects original promise after specified timeout
 * @param {Promise<R>} promise Original promise
 * @param {string} [message] Additional message for timeout reject
 * @param {number} timeout Time for reject
 * @return {Promise<R>}
 */
module.exports.timedPromise = function (promise, _ref) {
  var message = _ref.message,
      timeout = _ref.timeout;

  var timeoutPromise = new Promise(function (resolve, reject) {
    setTimeout(reject, timeout, message ? 'Timeout: ' + message : 'Timeout');
  });
  return Promise.race([promise, timeoutPromise]);
};

/**
 * Works like Promise.all expect uses object insetead of array.
 * @param {Object} promiseObject
 * @return {Promise} Promise wiht original keys and resolved values
 */
module.exports.allAsObject = function (promiseObject) {
  var keys = Object.keys(promiseObject);
  return Promise.all(keys.map(function (key) {
    return promiseObject[key];
  })).then(function (resolved) {
    return resolved.reduce(function (acc, value, i) {
      acc[keys[i]] = value;
      return acc;
    }, {});
  });
};
//# sourceMappingURL=promise.js.map

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports.log = {
  error: function error() {
    if (console && console.error) {
      var _console;

      (_console = console).error.apply(_console, arguments);
    }
  }
};
//# sourceMappingURL=log.js.map

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.imagePublisher = imagePublisher;
exports.beaconPublisher = beaconPublisher;
exports.fetchPublisher = fetchPublisher;

var _utils = __webpack_require__(107);

var _transport = __webpack_require__(241);

function imagePublisher() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return function imagePublisher(params) {
    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // eslint-disable-line func-names
    var url = (0, _utils.buildUrl)(options, params);
    return (0, _transport.pixel)(url, context.image);
  };
}

function beaconPublisher() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return function beaconPublisher(params) {
    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // eslint-disable-line func-names
    var url = (0, _utils.buildUrl)(options, params);
    return (0, _transport.beacon)(url).catch(function () {
      return (0, _transport.pixel)(url, context.image);
    });
  };
}

function fetchPublisher() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return function fetchPublisher(params) {
    // eslint-disable-line func-names
    var url = (0, _utils.buildUrl)(options, params);
    return fetch(url, { credentials: 'include' }).then(function (response) {
      if (!response.ok) {
        throw Error(response.status);
      }
      return response;
    });
  };
}

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.now = now;
function now() {
  return typeof performance !== 'undefined' && performance && performance.now ? performance.now() : -1;
}

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.beacon = beacon;
exports.pixel = pixel;

var _navigator = __webpack_require__(108);

function beacon(url) {
  return new Promise(function (resolve, reject) {
    return (0, _navigator.sendBeacon)(url) ? resolve(url) : reject(url);
  });
}

function pixel(url, image) {
  return new Promise(function (resolve, reject) {
    var biImage = image || new Image(0, 0);
    biImage.onload = resolve;
    biImage.onerror = reject;
    biImage.src = url;
  });
}

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.track = track;

var _utils = __webpack_require__(107);

var _navigator = __webpack_require__(108);

var _env = __webpack_require__(36);

var _screen = __webpack_require__(243);

var IS_TRACKING = '__isTrackingBiBrowsingSession__';
var ENDPOINT = 'p';
var SOURCE = 19;
var EVID = 3;

function shouldTrack() {
  return !(0, _env.isWebWorker)() && (0, _env.provideBrowsingContext)(function (window) {
    return !window[IS_TRACKING];
  });
}

function setIsTracking() {
  return (0, _env.provideBrowsingContext)(function (window) {
    return window[IS_TRACKING] = true;
  });
}

function getLogger(loggerFactory) {
  return loggerFactory({ endpoint: ENDPOINT, useBeacon: true }).setDefaults({ src: SOURCE, evid: EVID, vsi: (0, _utils.guid)() }).logger();
}

function trackBrowsingSession(loggerFactory) {
  var logger = getLogger(loggerFactory);
  var firstInSession = 1;

  (0, _navigator.listen)(function (fromUrl, toUrl) {
    var _provideBrowsingConte = (0, _env.provideBrowsingContext)(function (window) {
      return { sr: (0, _screen.getDesktopSize)(window), wr: (0, _screen.getWindowSize)(window) };
    }),
        sr = _provideBrowsingConte.sr,
        wr = _provideBrowsingConte.wr;

    logger.log({ from: fromUrl, to: toUrl, fis: firstInSession, sr: sr, wr: wr });
    firstInSession = 0;
  });
}

/**
 * Sends a page view event on initial load and on every page switch
 * BI event definition: http://bo.wix.com/bi-catalog-webapp/#/sources/19/events/3
 */
function track(loggerFactory) {
  if (shouldTrack()) {
    setIsTracking();
    trackBrowsingSession(loggerFactory);
  }
}

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDesktopSize = getDesktopSize;
exports.getWindowSize = getWindowSize;
function getDesktopSize(window) {
  var width = window.screen && window.screen.width || 0;
  var height = window.screen && window.screen.height || 0;

  return width + "x" + height;
}

function getWindowSize(window) {
  var width = 0;
  var height = 0;

  if (window.innerWidth) {
    width = window.innerWidth;
    height = window.innerHeight;
  } else if (window.document) {
    if (window.document.documentElement && window.document.documentElement.clientWidth) {
      width = window.document.documentElement.clientWidth;
      height = window.document.documentElement.clientHeight;
    } else if (window.document.body && window.document.body.clientWidth) {
      width = window.document.body.clientWidth;
      height = window.document.body.clientHeight;
    }
  }

  return width + "x" + height;
}

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(35),
    checkLocalhostInWorker = _require.isLocalhost;

var undefinedFilterMutator = function undefinedFilterMutator() {
  var next = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (x) {
    return x;
  };
  return function (params) {
    var filteredParams = Object.assign({}, params);
    Object.keys(filteredParams).forEach(function (key) {
      return filteredParams[key] === undefined && delete filteredParams[key];
    });

    return next(filteredParams);
  };
};

var timestampDeltaMutator = function timestampDeltaMutator(editorTimestamp) {
  var next = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (x) {
    return x;
  };
  return function (params) {
    return next(Object.assign({}, params, { ts: new Date().getTime() - editorTimestamp }));
  };
};

var localhostLogger = function localhostLogger() {
  return Promise.resolve();
};

var loggerFactoryImpl = function loggerFactoryImpl(isLocalhost, biFactory) {
  var mutator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (x) {
    return x;
  };

  var logger = biFactory.logger();

  return isLocalhost ? localhostLogger : function (params) {
    return logger.log(mutator(params));
  };
};

var panelLoggerFactory = function panelLoggerFactory(biFactory, mutator) {
  var appUrl = window.location.href;
  var isLocalhost = appUrl.indexOf('http://localhost') === 0;
  return loggerFactoryImpl(isLocalhost, biFactory, mutator);
};

var workerLoggerFactory = function workerLoggerFactory(biFactory, mutator) {
  var isLocalhost = checkLocalhostInWorker();
  return loggerFactoryImpl(isLocalhost, biFactory, mutator);
};

module.exports.BI_ENDPOINT = 'platform';
module.exports.BI_VIEWER_ENDPOINT = 'platform-viewer';
module.exports.BI_ERROR_ENDPOINT = 'trg';
module.exports.BI_SOURCE = 79;
module.exports.biExceptionLogger = function () {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  throw new Error('Attempt to call BI logger too soon. Arguments: ' + JSON.stringify(args));
};
module.exports.undefinedFilterMutator = undefinedFilterMutator;
module.exports.timestampDeltaMutator = timestampDeltaMutator;
module.exports.loggerFactory = panelLoggerFactory;
module.exports.workerLoggerFactory = workerLoggerFactory;

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(246).default


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createWixData;
var WixDataApi = __webpack_require__(247);

var _require = __webpack_require__(255),
    createWixDataProxy = _require.createWixDataProxy;

function createWixData(elementorySupportInstance) {
  return new WixDataApi(createWixDataProxy(elementorySupportInstance));
}

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var _query = __webpack_require__(248);

var _filterFilterBuilder = __webpack_require__(252);

var _filterFilterBuilder2 = _interopRequireDefault(_filterFilterBuilder);

var _sortSortBuilder = __webpack_require__(253);

var _sortSortBuilder2 = _interopRequireDefault(_sortSortBuilder);

var _postprocessingRefTransformer = __webpack_require__(110);

var _postprocessingRefDeduplicator = __webpack_require__(109);

var _wixDataWebmethodStructures = __webpack_require__(38);

var _sharedValidations = __webpack_require__(113);

var _errors = __webpack_require__(9);

var _sharedTypeUtils = __webpack_require__(14);

var _multiref = __webpack_require__(254);

/**
 * The built-in String object.
 * @external String
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String|MDN String}
 */

/**
 * The built-in Array object.
 * @external Array
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array|MDN Array}
 */

/**
 * The built-in Function object.
 * @external Function
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function|MDN Function}
 */

/**
 * The Promise object is used for deferred and asynchronous computations.
 * @description A Promise represents a value that is not necessarily known when the promise is created because it depends on asynchronous communication. To learn more, see <a href="https://support.wix.com/en/article/working-with-promises-in-wix-code">Working with Promises in Wix Code</a>.
 *
 * @external Promise
 * @see {@link https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/Promise|MDN Promise}
 */

/**
 * The built-in Boolean object.
 * @external Boolean
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Boolean|MDN Boolean}
 */

/**
 * The built-in Object object.
 * @external Object
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object|MDN Object}
 */

/**
 * The built-in Number object.
 * @external Number
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number|MDN Number}
 */

/**
 * The built-in Date object.
 * @external Date
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date|MDN Date}
 */

/**
 * The built-in Error object.
 * @external Error
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error|MDN Error}
 */

/**
 * The Node.js Buffer object.
 * @external Buffer
 * @see {@link https://nodejs.org/api/buffer.html|Node.js Buffer}
 */

/**
 * @typedef wix-data~WixDataOptions
 * @summary An object that you pass as the `options` parameter that modifies how an operation is performed.
 * @property {external:Boolean} suppressAuth Prevents <a href="https://www.wix.com/support/html5/article/how-do-i-work-with-wix-data-permissions" target="_blank">permission</a> checks from running for the operation.
 * @property {external:Boolean} suppressHooks Prevents <a href="https://www.wix.com/support/html5/article/how-do-i-work-with-hooks" target="_blank">hooks</a> from running for the operation.
 * @memberof wix-data
 * @description
 *  The `options` parameter is an optional parameter that can be used when
 *  calling some wix-data functions. To use `options`, pass it a `WixDataOptions`
 *  object with one or both of the following key:value pairs:
 *
 *  + `"suppressAuth"`: `true`/`false`
 *  + `"suppressHooks"`: `true`/`false`
 *
 *
 *  The `options` parameter can only be used in backend code. Permission checks
 *  and hooks always run for wix-data functions called from Page, Site and
 *  Public code.
 * @snippet [WixDataOptions.es6=Create a data options object]
 * @snippet [WixDataOptions_get.es6=Use data options to prevent permission checks and hooks from running]
 */

// ======================================================================================================================

/**
 * @namespace wix-data
 *
 * @summary The wix-data module contains functionality for working with data in collections.
 * @description
 *  To use the data module, import `wixData` from the `wix-data` module:
 *
 *    ``` javascript
 *    import wixData from 'wix-data';
 *    ```
 *
 *  The wix-data API can be used in your site’s front-end or backend code.
 *
 *  The wix-data API includes fuctions for managing the data in your collections,
 *  building queries on collections, and registering hooks.
 *
 *  For more information, see <a href="https://www.wix.com/support/html5/article/working-with-the-data-api" target="_blank">Working with the Data API</a>.
 *
 *  <h3 id="data-types">Data Types</h3>
 *
 *  The following is a list of the field types from database collections and their
 *  corresponding JavaScript data types. When you retrieve data from a collection,
 *  that data will be represented in the JavaScript data types that correspond
 *  to your collection's field types. When you add or update data in a collection,
 *  you provide the data using the JavaScript data types that correspond to your
 *  collection's field types.
 *
 *  <table style="border-collapse: collapse;">
 *    <tr>
 *      <td><b>Field Type</b></td>
 *      <td><b>Data Type</b></td>
 *      <td><b>Notes</b></td>
 *    </tr>
 *    <tr>
 *      <td>Text</td>
 *      <td>JavaScript string</td>
 *      <td></td>
 *    </tr>
 *    <tr>
 *      <td>Image</td>
 *      <td>JavaScript string</td>
 *      <td>An image URL as described <a href="/$w.Image.html#src">here</a>.</td>
 *    </tr>
 *    <tr>
 *      <td>Boolean</td>
 *      <td>JavaScript boolean</td>
 *      <td></td>
 *    </tr>
 *    <tr>
 *      <td>Number</td>
 *      <td>JavaScript number</td>
 *      <td></td>
 *    </tr>
 *    <tr>
 *      <td>Date and Time</td>
 *      <td>JavaScript Date object</td>
 *      <td></td>
 *    </tr>
 *    <tr>
 *      <td>Rich Text</td>
 *      <td>JavaScript string</td>
 *      <td>A string which can contain a [subset of HTML tags]($w.Text.html#formatting-text).</td>
 *    </tr>
 *    <tr>
 *      <td>URL</td>
 *      <td>JavaScript string</td>
 *      <td>A valid URL.</td>
 *    </tr>
 *    <tr>
 *      <td>Document</td>
 *      <td>JavaScript string</td>
 *      <td>A Media Manager document URL as described <a href="/$w.LinkableMixin.html#link">here</a>.</td>
 *    </tr>
 *    <tr>
 *      <td>Reference</td>
 *      <td>JavaScript string</td>
 *      <td>An item ID from the referenced collection.</td>
 *    </tr>
 *  </table>
 *
 */

var WixDataApi = (function () {
  function WixDataApi(provider) {
    _classCallCheck(this, WixDataApi);

    this.provider = provider;
  }

  /**
   * @function get
   * @syntax
   * function get(collectionName: String, itemId: String,
   *   [options:WixDataOptions]): Promise&lt;Object&gt;
   * @summary Retrieves an item from a collection.
   * @description
   *  The `get()` function returns a Promise that resolves to the item with ID
   *  `itemId` from collection `collectionName`. The Promise is rejected if the
   *  current user does not have read permissions for the collection.
   *
   *  Calling the `get()` function triggers the [`beforeGet()`](wix-data.Hooks.html#beforeGet)
   *  and [`afterGet()`](wix-data.Hooks.html#afterGet) hooks if they have been defined.
   *
   *  Use the `options` parameter to run `get()` without checking for permissions
   *  or without its registered hooks.
   * @snippet [WixData-get.es6=Get an item from a collection]
   * @snippet [WixData-get_options.es6=Get an item from a collection using data options]
   * @param {external:String} collectionName - The name of the collection to retrieve the item from.
   * @param {external:String} itemId - The ID of the item to retrieve.
   * @param {wix-data~WixDataOptions} [options] - An object with one or both of the following boolean properties: suppressAuth, suppressHooks.
   * @returns {external:Promise}
   * @fulfill {external:Object} The retrieved item.
   * @reject {external:Error} The error that caused the rejection.
   * @memberof wix-data
   * @instance
   */

  _createClass(WixDataApi, [{
    key: 'get',
    value: function get(collectionName, itemId, options) {
      var _this = this;

      return (0, _sharedValidations.apiValidator)().arity('get', arguments, 2, 3).collectionName(collectionName).itemId(itemId).options(options).validateAndReject().then(function () {
        return _this.provider.get(collectionName, itemId, options);
      }).then(passOrWrap);
    }

    /**
     * @function insert
     * @syntax
     * function insert(collectionName: String, item: Object,
     *   [options:WixDataOptions]): Promise&lt;Object&gt;
     * @summary Adds an item to a collection.
     * @description
     *  The `insert()` function returns a Promise that resolves to the inserted item
     *  after the specified item has been added to the collection `collectionName`. The
     *  Promise is rejected with an error if:
     *
     *  + The specified collection does not exist.
     *  + The specified item is not of type `Object`.
     *  + The specified item includes an `_id` property whose value matches an existing ID in the collection. Meaning, `insert()` cannot overwrite an existing item in the collection.
     *  + The current user does not have create permissions for the collection.
     *
     *
     *  Calling the `insert()` function triggers the [`beforeInsert()`](wix-data.Hooks.html#beforeInsert)
     *  and [`afterInsert()`](wix-data.Hooks.html#afterInsert) hooks if they have been defined.
     *
     *  Use the `options` parameter to run `insert()` without checking for permissions
     *  or without its registered hooks.
     *
     *  When inserting an item into a collection that has a reference field, set
     *  the value of the reference field to the referenced item's `_id` value or
     *  the entire referenced item object.
     *
     *  The `insert()` function adds the following properties and values to the item
     *  when it adds it to the collection:
     *
     *  + `_id`: A unique identifier for the item with collection, if the item does not include one. You can optionally provide your own ID. Once an ID is assigned to an item it cannot be changed.
     *  + `_createdDate`: The date the item was added to the collection.
     *  + `_updatedDate`:  The date the item was modified. When the item is first added, the `createdDate` and `updatedDate` are the same.
     *
     *
     *  Any valid JavaScript object can be added as a property value. The `insert()`
     *  function maintains the structure of the specified object. For example,
     *  objects that contain nested objects, Arrays, or Arrays with nested objects
     *  are all added to the collection as defined.
     *
     * The maximum size of an item that you can add to a collection is 200kb.
     * @snippet [WixData-insert.es6=Insert an item into a collection]
     * @snippet [WixData-insert_id.es6=Insert an item with a specified ID into a collection]
     * @snippet [WixData-insert_options.es6=Insert an item into a collection using data options]
     * @snippet [WixData-insert_ref_id.es6=Insert an item including a reference to another item]
     * @snippet [WixData-insert_ref_item.es6=Insert an item including a reference to another item]
     * @param {external:String} collectionName - The name of the collection to add the item to.
     * @param {external:Object} item - The item to add.
     * @param {wix-data~WixDataOptions} [options] - An object with one or both of the following boolean properties: suppressAuth, suppressHooks.
     * @returns {external:Promise}
     * @fulfill {external:Object} The item that was added.
     * @reject {external:Error} The error that caused the rejection.
     * @memberof wix-data
     * @instance
     */
  }, {
    key: 'insert',
    value: function insert(collectionName, item, options) {
      var _this2 = this;

      return (0, _sharedValidations.apiValidator)().arity('insert', arguments, 2, 3).validateAndReject().then(function () {
        return mutate(_this2.provider, 'insert')(collectionName, item, options);
      });
    }

    /**
     * @function query
     * @syntax
     * function query(collectionName: String): WixDataQuery
     * @summary Creates a query.
     * @description
     *  The `query()` function builds a query on the specified collection and returns
     *  a {@link wix-data.WixDataQuery|WixDataQuery} object.
     *
     *  The returned object contains the query definition which is typically used
     *  to run the query using the [`find()`](wix-data.WixDataQuery.html#find)
     *  function.
     *
     *  You can refine the query by chaining {@link wix-data.WixDataQuery|WixDataQuery}
     *  functions on to the query. `WixDataQuery` functions enable you to sort,
     *  filter, and control the number of results a query returns.
     *
     *  The `query()` runs with the following {@link wix-data.WixDataQuery|WixDataQuery}
     *  defaults that you can override:
     *
     *  + [**skip**](wix-data.WixDataQuery.html#skip) - `0`
     *  + [**limit**](wix-data.WixDataQuery.html#limit) - `50`
     *  + [**descending**](wix-data.WixDataQuery.html#descending) - by `_createdDate`
     *  + [**include**](wix-data.WixDataQuery.html#skip) - none
     *
     *
     *
     *  The functions that are chained to `query()` are applied in the order they
     *  are called. For example, if you sort on an `age` property in ascending
     *  order and then on a `name` property in descending order, the results are
     *  sorted first by the age of the items and then, if there are multiple
     *  results with the same age, the items are sorted by name in descending
     *  order, per age value.
     * @snippet [WixData-query.es6=Build a query]
     * @snippet [WixData-query_find.es6=Build and perform a query]
     * @snippet [WixData-query_chain.es6=Build and perform a query using data options]
     * @snippet [WixData-query_build.es6=Build a query incrementally]
     *  This example builds a query based on certain conditions. It then performs the
     *  query and uses the results to populate a table.
     * @param {external:String} collectionName - The collection you want to run the query on.
     * @returns {wix-data.WixDataQuery} A query object.
     * @memberof wix-data
     * @instance
     */
  }, {
    key: 'query',
    value: function query(collectionName) {
      return (0, _query.queryFactory)(this.provider, collectionName);
    }
  }, {
    key: 'ref',
    value: function ref(obj) {
      if (reflessJoinsEnabled()) {
        return obj;
      } else {
        return new _wixDataWebmethodStructures.Ref(obj);
      }
    }

    /**
     * @function filter
     * @syntax
     * function filter(): WixDataFilter
     * @summary Creates a filter to be used with the dataset `setFilter()` function.
     * @description
     *  This function is not used on its own. It is only used to create a filter
     *  for a dataset using the [`setFilter()`](wix-dataset.html#setFilter) function.
     * @snippet [WixData-filter.es6=Filter a dataset]
     * @returns {wix-data.WixDataFilter} A filter object.
     * @memberof wix-data
     * @instance
     */
  }, {
    key: 'filter',
    value: function filter() {
      return (0, _filterFilterBuilder2['default'])();
    }

    /**
     * @function sort
     * @syntax
     * function sort(): WixDataSort
     * @summary Creates a sort to be used with the dataset `setSort()` function.
     * @description
     *  This function is not used on its own. It is only used to create a sort
     *  for a dataset using the [`setSort()`](wix-dataset.html#setSort) function.
     * @snippet [WixData-sort.es6=Sort a dataset]
     * @returns {wix-data.WixDataSort} A sort object.
     * @memberof wix-data
     * @instance
     */
  }, {
    key: 'sort',
    value: function sort() {
      return (0, _sortSortBuilder2['default'])();
    }
  }, {
    key: 'find',
    value: function find(collectionName, filter, order, skip, limit, options, includes) {
      return this.provider.find(collectionName, filter, order, skip, limit, options, includes).then(wrapReferences);
    }

    /**
     * @function remove
     * @syntax
     * function remove(collectionName: String, itemId: String,
     *   [options:WixDataOptions]): Promise&lt;Object&gt;
     * @summary Removes an item from a collection.
     * @description
     *  The `remove()` function returns a Promise that resolves to the removed item
     *  after the specified item has been deleted from the collection `collectionName`.
     *  The Promise is rejected if the current user does not have delete permissions
     *  for the collection.
     *
     *  Calling the `remove()` function triggers the [`beforeRemove()`](wix-data.Hooks.html#beforeRemove)
     *  and [`afterRemove()`](wix-data.Hooks.html#afterRemove) hooks if they have been defined.
     *
     *  Use the `options` parameter to run `remove()` without checking for permissions
     *  or without its registered hooks.
     * @snippet [WixData-remove.es6=Remove an item from a collection]
     * @snippet [WixData-remove_options.es6=Remove an item from a collection using data options]
     * @param {external:String} collectionName - The collection to remove the item from.
     * @param {external:String} itemId - The ID of the item to remove.
     * @param {wix-data~WixDataOptions} [options] - An object with one or both of the following boolean properties: suppressAuth, suppressHooks.
     * @returns {external:Promise}
     * @fulfill {external:Object} The removed item.
     * @reject {external:Error} The error that caused the rejection.
     *
     * @memberof wix-data
     * @instance
     *
     */
  }, {
    key: 'remove',
    value: function remove(collectionName, itemId, options) {
      var _this3 = this;

      return (0, _sharedValidations.apiValidator)().arity('remove', arguments, 2, 3).collectionName(collectionName).itemId(itemId).options(options).validateAndReject().then(function () {
        return _this3.provider.remove(collectionName, itemId, options);
      }).then(passOrWrap);
    }

    /**
     * @function save
     * @syntax
     * function save(collectionName: String, item: object,
     *   [options:WixDataOptions]): Promise&lt;Object&gt;
     * @summary Inserts or updates an item in a collection.
     * @description
     *  The `save()` function returns a Promise that resolves to the inserted or
     *  updated item after the specified item has been added or updated in
     *  the collection `collectionName`. The Promise is rejected with an error if:
     *
     *  + The specified collection does not exist.
     *  + The specified item is not of type `Object`.
     *  + The current user does not have the necessary permissions for the collection.
     *
     *
     *  The `save` function inserts or updates the specified item, depending on
     *  whether it already exists in the collection. It compares the `_id` property
     *  value of the specified item with the `_id` property values of the items in
     *  the specified collection. If an item in the collection has that `_id` value,
     *  `save` uses {@link wix-data#update|update} to update the item in the
     *  collection, triggering the [`beforeUpdate()`](wix-data.Hooks.html#beforeUpdate)
     *  and [`afterUpdate()`](wix-data.Hooks.html#afterUpdate) hooks if they have
     *  been defined. If no items in the collection have that `_id` value, or if the
     *  specified item does not have an `_id` property, `save` uses
     *  {@link wix-data#insert|insert} to add the specified item into the
     *  collection, triggering the [`beforeInsert()`](wix-data.Hooks.html#beforeInsert)
     *  and [`afterInsert()`](wix-data.Hooks.html#afterInsert) hooks if they have
     *  been defined.
     *
     *  Use the `options` parameter to run `save()` without checking for permissions
     *  or without its registered hooks.
     *
     *  When saving an item to a collection that has a reference field, set
     *  the value of the reference field to the referenced item's `_id` value or
     *  the entire referenced item object.
     *
     * @snippet [WixData-save.es6=Save an item in a collection]
     * @snippet [WixData-save_id.es6=Save an item with a specified ID in a collection]
     * @snippet [WixData-save_options.es6=Save an item in a collection using data options]
     * @snippet [WixData-save_ref_id.es6=Save an item including a reference to another item]
     * @snippet [WixData-save_ref_item.es6=Save an item including a reference to another item]
     * @param {external:String} collectionName - The name of the collection to save the item to.
     * @param {external:Object} item - The item to insert or update.
     * @param {wix-data~WixDataOptions} [options] - An object with one or both of the following boolean properties: suppressAuth, suppressHooks.
     * @returns {external:Promise}
     * @fulfill {external:Object} The item that was either inserted or updated, depending on whether it previously existed in the collection.
     * @reject {external:Error} The error that caused the rejection.
     * @memberof wix-data
     * @instance
     */
  }, {
    key: 'save',
    value: function save(collectionName, item, options) {
      var _this4 = this;

      return (0, _sharedValidations.apiValidator)().arity('save', arguments, 2, 3).validateAndReject().then(function () {
        return mutate(_this4.provider, 'save')(collectionName, item, options);
      });
    }

    /**
     * @function update
     * @syntax
     * function update(collectionName: String, item: Object,
     *   [options:WixDataOptions]): Promise&lt;Object&gt;
     * @summary Updates an item in a collection.
     * @description
     *  The `update()` function returns a Promise that resolves to the updated
     *  item from collection `collectionName`. The Promise is rejected if:
     *
     *  + The specified collection does not exist.
     *  + The specified item is not of type `Object`.
     *  + No item in the collection has the specified `_id` value.
     *  + The specified item does not have an `_id` property.
     *  + The current user does not have update permissions for the collection.
     *
     *
     *  Calling the `update()` function triggers the [`beforeUpdate()`](wix-data.Hooks.html#beforeUpdate)
     *  and [`afterUpdate()`](wix-data.Hooks.html#afterUpdate) hooks if they have been defined.
     *
     *  The `update()` function compares the `_id` property of the specified
     *  `item` with the `_id` property values of the items in the specified
     *  collection. If an item in the collection has that `_id` value, `update`
     *  replaced the item's property values with the ones in the specified `item`.
     *  If the existing item had properties with values and those properties were not
     *  included in the supplied `item`, the values in those properties are lost. The
     *  item's `_updatedDate` property is also updated to the current date.
     *
     *  Any valid JavaScript object can be used as a property value. The `update()`
     *  function maintains the structure of the specified object. For example,
     *  objects that contain nested objects, Arrays, or Arrays with nested objects
     *  are all added to the collection as defined.
     *
     *  Use the `options` parameter to run `update()` without checking for permissions
     *  or without its registered hooks.
     *
     *  When updating an item in a collection that has a reference field, set
     *  the value of the reference field to the referenced item's `_id` value or
     *  the entire referenced item object.
     *
     * The maximum size of an item that you can update in a collection is 200kb.
     * @snippet [WixData-update_id.es6=Update an item with a specified ID in a collection]
     * @snippet [WixData-update_options.es6=Update an item in a collection using data options]
     * @snippet [WixData-update_ref_id.es6=Update an item including a reference to another item]
     * @snippet [WixData-update_ref_item.es6=Update an item including a reference to another item]
     * @param {external:String} collectionName - The name of the collection that contains the item to update.
     * @param {external:Object} item - The item to update.
     * @param {wix-data~WixDataOptions} [options] - An object with one or both of the following boolean properties: suppressAuth, suppressHooks.
     * @returns {external:Promise}
     * @fulfill {external:Object} The object that was updated.
     * @reject {external:Error} The error that caused the rejection.
     * @memberof wix-data
     * @instance
     */
  }, {
    key: 'update',
    value: function update(collectionName, item, options) {
      var _this5 = this;

      return (0, _sharedValidations.apiValidator)().arity('update', arguments, 2, 3).validateAndReject().then(function () {
        return mutate(_this5.provider, 'update', true)(collectionName, item, options);
      });
    }
  }, {
    key: 'queryReferenced',
    value: function queryReferenced(collectionName, holdingItem, relationshipAttribute, options) {
      var _this6 = this;

      return (0, _sharedValidations.apiValidator)().arity('queryReferenced', arguments, 3, 4).referenceParameter(holdingItem).validateAndReject().then(function () {
        var itemId = (0, _sharedTypeUtils.isObject)(holdingItem) ? holdingItem._id : holdingItem;

        return _this6.provider.queryReferenced(collectionName, itemId, relationshipAttribute, options).then(function (result) {
          return new _multiref.WixDataQueryReferencedResult(_this6.provider, collectionName, itemId, relationshipAttribute, result, options);
        });
      });
    }
  }, {
    key: 'insertReference',
    value: function insertReference(collectionName, relationshipAttribute, left, right, options) {
      var _this7 = this;

      return (0, _sharedValidations.apiValidator)().arity('insertReference', arguments, 4, 5).referenceParameter(left).referenceParameter(right).validateAndReject().then(function () {
        return _this7.provider.insertReference(collectionName, relationshipAttribute, (0, _sharedTypeUtils.isObject)(left) ? left._id : left, (0, _sharedTypeUtils.isObject)(right) ? right._id : right, options);
      });
    }
  }, {
    key: 'removeReference',
    value: function removeReference(collectionName, relationshipAttribute, left, right, options) {
      var _this8 = this;

      return (0, _sharedValidations.apiValidator)().arity('removeReference', arguments, 4, 5).referenceParameter(left).referenceParameter(right).validateAndReject().then(function () {
        return _this8.provider.removeReference(collectionName, relationshipAttribute, (0, _sharedTypeUtils.isObject)(left) ? left._id : left, (0, _sharedTypeUtils.isObject)(right) ? right._id : right, options);
      });
    }
  }, {
    key: 'isReferenced',
    value: function isReferenced(collectionName, relationshipAttribute, left, right, options) {
      var _this9 = this;

      return (0, _sharedValidations.apiValidator)().arity('isReferenced', arguments, 4, 5).referenceParameter(left).referenceParameter(right).validateAndReject().then(function () {
        return _this9.provider.isReferenced(collectionName, relationshipAttribute, (0, _sharedTypeUtils.isObject)(left) ? left._id : left, (0, _sharedTypeUtils.isObject)(right) ? right._id : right, options);
      });
    }
  }, {
    key: 'bulkInsert',
    value: function bulkInsert(collectionName, items, options) {
      var _this10 = this;

      return (0, _sharedValidations.apiValidator)().arity('bulkInsert', arguments, 2, 3).validateAndReject().then(function () {
        return _this10.provider.bulkInsert(collectionName, items, options);
      }).then(function (bulkResult) {
        var errors = bulkResult.errors.map(function (err) {
          return new _errors.BulkError(err.message, err.code, err.item);
        });
        return Object.assign({}, bulkResult, { errors: errors });
      });
    }
  }, {
    key: 'getSchema',
    value: function getSchema() {
      return this.provider.getSchema();
    }
  }]);

  return WixDataApi;
})();

exports['default'] = WixDataApi;

function wrapReferences(result) {
  var totalCount = result.totalCount;
  if (result.hasOwnProperty('schema') && result.hasOwnProperty('items')) {
    var items = (0, _postprocessingRefDeduplicator.wrapAndDeduplicate)(result.items, result.schema, result.references);
    return { totalCount: totalCount, items: items };
  } else {
    var items = result.items;
    return { totalCount: totalCount, items: items };
  }
}

function mutate(wixData, functionName) {
  var requireId = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];

  return function (collectionName, item, options) {
    return (0, _sharedValidations.apiValidator)().collectionName(collectionName).item(item, collectionName, requireId).options(options).validateAndReject().then(function () {
      return wixData[functionName](collectionName, item, options);
    }).then(passOrWrap).then(updateOriginalItem(item));
  };
}

function passOrWrap(item) {
  if (item && item.hasOwnProperty('schema') && item.hasOwnProperty('item')) {
    return (0, _postprocessingRefTransformer.wrapAllReferences)(item.schema, item.item);
  } else {
    return item;
  }
}

function updateOriginalItem(originalItem) {
  return function onItemResponse(item) {
    if (item) {
      for (var prop in item) {
        if (item.hasOwnProperty(prop)) {
          if (!originalItem.hasOwnProperty(prop) || Object.getOwnPropertyDescriptor(originalItem, prop).writable === true) {
            originalItem[prop] = item[prop];
          }
        }
      }

      for (var prop in originalItem) {
        if (!item.hasOwnProperty(prop)) {
          delete originalItem[prop];
        }
      }

      return originalItem;
    } else {
      return undefined;
    }
  };
}

function reflessJoinsEnabled() {
  return true;
}
module.exports = exports['default'];

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});

var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

exports.queryFactory = queryFactory;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _sharedTypeUtils = __webpack_require__(14);

var _utilsClone = __webpack_require__(37);

var _utilsClone2 = _interopRequireDefault(_utilsClone);

var _postprocessingRefDeduplicator = __webpack_require__(109);

var _errors = __webpack_require__(9);

var _utilsBaseValidator = __webpack_require__(40);

var _filterFilterMixin = __webpack_require__(111);

var _filterFilterMixin2 = _interopRequireDefault(_filterFilterMixin);

var _sortSortMixin = __webpack_require__(112);

var _sortSortMixin2 = _interopRequireDefault(_sortSortMixin);

var _sharedValidations = __webpack_require__(113);

var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * @class wix-data.WixDataQuery
 * @borrows wix-data.WixDataSort#ascending
 * @borrows wix-data.WixDataSort#descending
 * @borrows wix-data.WixDataFilter#between
 * @borrows wix-data.WixDataFilter#contains
 * @borrows wix-data.WixDataFilter#endsWith
 * @borrows wix-data.WixDataFilter#eq
 * @borrows wix-data.WixDataFilter#ge
 * @borrows wix-data.WixDataFilter#gt
 * @borrows wix-data.WixDataFilter#hasAll
 * @borrows wix-data.WixDataFilter#hasSome
 * @borrows wix-data.WixDataFilter#isEmpty
 * @borrows wix-data.WixDataFilter#isNotEmpty
 * @borrows wix-data.WixDataFilter#le
 * @borrows wix-data.WixDataFilter#lt
 * @borrows wix-data.WixDataFilter#ne
 * @borrows wix-data.WixDataFilter#not
 * @borrows wix-data.WixDataFilter#or
 * @borrows wix-data.WixDataFilter#startsWith
 * @summary Contains functionality for refining a data query.
 * @classdesc
 *  The `WixDataQuery` functions enable you to run, sort, filter, and controls
 *  which results a query returns.
 *
 *  Typically, you build a query using the [`query()`](#wix-data.html#query) function,
 *  refine the query by chaining `WixDataQuery` functions, and then execute the
 *  query by chaining the [`find()`](#find) or [`count()`](#count) functions.
 *
 *  For example, the following code queries a collection for all male customers
 *  over the age of 20 and logs the first 15 results to the console, sorted in
 *  ascending order by name:
 *
 *  ```javascript
 *  import wixData from 'wix-data';
 *
 *  wixData.query("Customer")
 *    .gt("age", 20)
 *    .ascending("name")
 *    .limit(15)
 *    .find()
 *    .then( (results) => {
 *      console.log(results.items);
 *    } );
 *  ```
 */

var WixDataQuery = (function (_filterMixin) {
  _inherits(WixDataQuery, _filterMixin);

  function WixDataQuery(obj) {
    _classCallCheck(this, WixDataQuery);

    _get(Object.getPrototypeOf(WixDataQuery.prototype), 'constructor', this).call(this, obj);
    this.provider = obj.provider;
    this.collectionName = obj.collectionName;
    this.limitNumber = obj.limitNumber;
    this.invalidArguments = obj.invalidArguments;
    this.orderBy = obj.orderBy;
    this.skipNumber = obj.skipNumber;
    this.included = obj.included;
  }

  _createClass(WixDataQuery, [{
    key: 'count',

    /**
     * @function count
     * @summary Returns the number of items that match the query.
     * @syntax
     * function count([options: WixDataOptions]): Promise&lt;Number&gt;
     * @param {wix-data~WixDataOptions} [options] - An object with one or both of the following boolean properties: suppressAuth, suppressHooks.
     * @returns {external:Promise}
     * @fulfill {external:Number} The number of items that match the query.
     * @reject {external:Error} The errors that caused the rejection.
     * @description
     *  The `count()` function returns a Promise that resolves to the number of
     *  items that match the query. The Promise is rejected if `count()` is called
     *  with incorrect permissions or if any of the functions used to refine the
     *  query is invalid.
     *
     *  Calling the `count()` function triggers the [`beforeCount()`](wix-data.Hooks.html#beforeCount)
     *  and [`afterCount()`](wix-data.Hooks.html#afterCount) hooks if they have been defined.
     *
     *  Use the `options` parameter to run `count()` without checking for permissions
     *  or without its registered hooks.
     *
     *  Any function that does not filter query results (e.g., [`ascending()`](#ascending))
     *  does not affect the result of `count()`.
     *
     *  If you build a query and don't refine it with any `WixDataQuery` functions,
     *  `count()` returns the total number of items in the collection.
     *
     *  If you have already run a query with [`find()`](#find), you can retrieve
     *  the number of query results without calling `count()`. The [`find()`](#find)
     *  function returns a Promise that resolves to a {@link wix-data.WixDataQueryResult|WixDataQueryResult}
     *  object, which has a `totalCount` property whose value is the number of results.
     * @snippet [WixDataQuery-count.es6=Perform a count on a query]
     * @snippet [WixDataQuery-count_scenario.es6=Create a query and perfom a count on it]
     * @snippet [WixDataQuery-count_scenario_plus.es6=Create a query and perfom a count on it]
     * @memberof wix-data.WixDataQuery
     * @instance
     */
    value: function count(options) {
      var _this = this;

      return rejectIfInvalid(this.invalidArguments, this.collectionName).then(function () {
        return (0, _sharedValidations.apiValidator)().options(options).validateAndReject();
      }).then(function () {
        return _this.provider.count(_this.collectionName, _this.filterTree, options);
      }).then(function (result) {
        return result.totalCount;
      });
    }

    /**
     * @function find
     * @summary Returns the items that match the query.
     * @syntax
     * function find([options: WixDataOptions]): Promise&lt;WixDataQueryResult&gt;
     * @param {wix-data~WixDataOptions} [options] An object with one or both of the following boolean properties: suppressAuth, suppressHooks.
     * @returns {external:Promise}
     * @fulfill {wix-data.WixDataQueryResult} A Promise that resolves to the results of the query.
     * @reject {external:Error} Any errors that caused the query to fail, returned as an array.
     * @description
     *  The `find()` function returns a Promise that resolves to the results found
     *  by the query and some information about the results. The Promise is
     *  rejected if `find()` is called with incorrect permissions or if any of the
     *  functions used to refine the query is invalid.
     *
     *  Calling the `find()` function triggers the [`beforeQuery()`](wix-data.Hooks.html#beforeQuery)
     *  and [`afterQuery()`](wix-data.Hooks.html#afterQuery) hooks if they have been defined.
     *  If the query being run contains an [`include()`](#include), calling `find()`
     *  triggers [`beforeQuery()`](wix-data.Hooks.html#beforeQuery) and
     *  [`afterQuery()`](wix-data.Hooks.html#afterQuery) hooks for the referenced
     *  collection as well.
     *
     *  Use the `options` parameter to run `find()` without checking for permissions
     *  or without its registered hooks.
     *
     *  If you build a query and don't refine it with any `wixDataQuery` functions,
     *  `find()` returns the entire collection.
     * @snippet [WixDataQuery-find.es6=Perform a find on a query]
     * @snippet [WixDataQuery-find_scenario.es6=Create a query and run it]
     * @snippet [WixDataQuery-find_scenario_plus.es6=Create a query and run it]
     * @memberof wix-data.WixDataQuery
     * @instance
     */
  }, {
    key: 'find',
    value: function find(options) {
      var _this2 = this;

      var self = this;

      return rejectIfInvalid(this.invalidArguments, this.collectionName).then(function () {
        return (0, _sharedValidations.apiValidator)().options(options).validateAndReject();
      }).then(function () {
        return _this2.provider.find(_this2.collectionName, _this2.filterTree, _this2.orderBy, _this2.skipNumber, _this2.limitNumber, options, _this2.included);
      }).then(function (result) {
        if (requiredPropertiesIn(result)) {
          var items = (0, _postprocessingRefDeduplicator.wrapAndDeduplicate)(result.items, result.schema, result.references);
          return new WixDataQueryResult({
            length: items.length,
            totalCount: result.totalCount,
            query: self,
            items: items,
            partialIncludes: result.partialIncludes
          });
        } else {
          return new WixDataQueryResult({
            length: result.items.length,
            totalCount: result.totalCount,
            query: self,
            items: result.items,
            partialIncludes: result.partialIncludes
          });
        }
      });
    }

    /**
     * @function limit
     * @summary Limits the number of items the query returns.
     * @syntax
     * function limit(limit: Number): WixDataQuery
     * @param {external:Number} limit The number of items to return, which is also the [`pageSize`](wix-data.WixDataQueryResult.html#pageSize) of the results object.
     * @returns {wix-data.WixDataQuery} A `WixDataQuery` object representing the refined query.
     * @description
     *  The `limit` function defines the number of results a query returns in each
     *  page. Only one page of results is retreived at a time. The {@link wix-data.WixDataQueryResult#next|next()}
     *  and {@link wix-data.WixDataQueryResult#prev|prev()} functions are used to
     *  navigate the pages of a query result.
     *
     *  By default, `limit` is set to `50`.
     *
     *  The maximum value that `limit()` can accept is `1000`.
     * @snippet [WixDataQuery-limit.es6=Add a limit to a query]
     * @snippet [WixDataQuery-limit_scenario.es6=Create a query, add a limit, and run it]
     * @snippet [WixDataQuery-limit_scenario_plus.es6=Create a query, add a limit, and run it]
     * @memberof wix-data.WixDataQuery
     * @instance
     */
  }, {
    key: 'limit',
    value: function limit(limitNumber) {
      var _queryValidator$arityIsOne$isPositiveNumber$isInteger$validateAndAggregate = this._queryValidator('.limit').arityIsOne(arguments).isPositiveNumber(limitNumber).isInteger(limitNumber).validateAndAggregate();

      var _queryValidator$arityIsOne$isPositiveNumber$isInteger$validateAndAggregate2 = _slicedToArray(_queryValidator$arityIsOne$isPositiveNumber$isInteger$validateAndAggregate, 1);

      var newInvalidArguments = _queryValidator$arityIsOne$isPositiveNumber$isInteger$validateAndAggregate2[0];

      return new WixDataQuery({
        provider: this.provider,
        collectionName: this.collectionName,
        filterTree: this.filterTree,
        orderBy: this.orderBy,
        skipNumber: this.skipNumber,
        limitNumber: limitNumber,
        included: this.included,
        invalidArguments: newInvalidArguments
      });
    }

    /**
     * @function skip
     * @summary Sets the number of items to skip before returning query results.
     * @syntax
     * function skip(skip: Number): WixDataQuery
     * @param {external:Number} skip The number of items to skip in the query results before returning the results.
     * @returns {wix-data.WixDataQuery} A `WixDataQuery` object representing the refined query.
     * @description
     *  The `skip()` function defines the number of results to skip in the query
     *  results before returning new query results.
     *
     *  For example, if you query a collection and 50 items match your query, but
     *  you set `skip` to 10, the results returned will skip the first 10 items
     *  that match and return the 11th through 50th items.
     *
     *  By default, `skip` is set to 0.
     * @snippet [WixDataQuery-skip.es6=Add a skip to a query]
     * @snippet [WixDataQuery-skip_scenario.es6=Create a query, add a skip, and run it]
     * @snippet [WixDataQuery-skip_scenario_plus.es6=Create a query, add a skip, and run it]
     * @memberof wix-data.WixDataQuery
     * @instance
     */
  }, {
    key: 'skip',
    value: function skip(skipNumber) {
      var _queryValidator$arityIsOne$isNonNegativeNumber$isInteger$validateAndAggregate = this._queryValidator('.skip').arityIsOne(arguments).isNonNegativeNumber(skipNumber).isInteger(skipNumber).validateAndAggregate();

      var _queryValidator$arityIsOne$isNonNegativeNumber$isInteger$validateAndAggregate2 = _slicedToArray(_queryValidator$arityIsOne$isNonNegativeNumber$isInteger$validateAndAggregate, 1);

      var newInvalidArguments = _queryValidator$arityIsOne$isNonNegativeNumber$isInteger$validateAndAggregate2[0];

      return new WixDataQuery({
        provider: this.provider,
        collectionName: this.collectionName,
        filterTree: this.filterTree,
        orderBy: this.orderBy,
        skipNumber: skipNumber,
        limitNumber: this.limitNumber,
        included: this.included,
        invalidArguments: newInvalidArguments
      });
    }

    /**
     * @function include
     * @summary Includes referenced items for the specified properties in a query's results.
     * @syntax
     * function include(...propertyName: String): WixDataQuery
     * @param {...external:String} propertyName The properties for which to include referenced items.
     * @returns {wix-data.WixDataQuery} A `WixDataQuery` object representing the query.
     * @description
     *  The `include()` function refines a query so that the items returned in the
     *  query's results include the full referenced items for the specified properties.
     *
     *  For example, suppose you have a **books** collection with an **author**
     *  field that references an **authors** collection. Querying the **books**
     *  collection with an `include("author")` will return the relevant book items
     *  and each item will include the full referenced author item in the book's
     *  `author` property.
     *
     *  Querying a collection that contains reference fields without using the
     *  `include()` function returns items that contain only the ID of the
     *  referenced item, and not the full referenced items.
     * @snippet [WixDataQuery-include.es6=Add an include to a query]
     * @snippet [WixDataQuery-include_scenario.es6=Create a query, include a reference field, and run it]
     * @snippet [WixDataQuery-include_scenario_books.es6=Create a query, include a reference field, and run it]
     *  In this example there is a **books** collection which has two reference fields
     *  that reference an **authors** collection and a **publishers** collection.
     *
     *  The query includes the **author** and **publisher** properties so that each
     *  returned book will also include the full items of its referenced author and
     *  publisher.
     * @snippet [WixDataQuery-include_scenario_books_plus.es6=Create a query, include a reference field, and run it]
     *  In this example there is a **books** collection which as two reference fields
     *  that reference an **authors** collection and a **publishers** collection.
     *
     *  The query is refined to only include books from a specific publisher using
     *  the `eq()` function and the publisher's ID.
     *
     *  The query also includes the **author** property so that each returned
     *  book will include the full item of its referenced author.
     * @memberof wix-data.WixDataQuery
     * @instance
     */
  }, {
    key: 'include',
    value: function include() {
      var newIncludedFields = (0, _utilsClone2['default'])(this.included);

      for (var i = 0; i < arguments.length; i++) {
        newIncludedFields.push(arguments[i]);
      }

      return new WixDataQuery({
        provider: this.provider,
        collectionName: this.collectionName,
        filterTree: this.filterTree,
        orderBy: this.orderBy,
        skipNumber: this.skipNumber,
        limitNumber: this.limitNumber,
        invalidArguments: this.invalidArguments,
        included: newIncludedFields
      });
    }
  }, {
    key: '_queryValidator',
    value: function _queryValidator(operatorName) {
      return new QueryValidator(operatorName, this.invalidArguments);
    }
  }, {
    key: 'constructorName',
    get: function get() {
      return 'WixDataQuery';
    }
  }]);

  return WixDataQuery;
})((0, _filterFilterMixin2['default'])((0, _sortSortMixin2['default'])()));

exports.WixDataQuery = WixDataQuery;

function requiredPropertiesIn(result) {
  return result.hasOwnProperty('schema') && result.hasOwnProperty('items');
}

function rejectIfInvalid(invalidArguments, collectionName) {
  if (invalidArguments.length > 0) {
    return Promise.reject((0, _errors.validationError)(_errors.messages.queryInvalid(collectionName, invalidArguments)));
  } else {
    return Promise.resolve();
  }
}

function queryFactory(provider, collectionName) {
  var invalidArguments = (0, _sharedTypeUtils.isString)(collectionName) ? [] : [_errors.messages.queryValidations.collectionNameIsRequired()];
  return new WixDataQuery({
    provider: provider,
    collectionName: collectionName,
    filterTree: {},
    orderBy: undefined,
    skipNumber: undefined,
    limitNumber: 50,
    invalidArguments: invalidArguments,
    included: []
  });
}

function calcSkipNumber(query, len, next) {
  var a = query.skipNumber || 0;
  var b = query.limitNumber === undefined ? len : query.limitNumber;
  if (next) {
    b = Math.min(b, len); //limit how far we can go
  }
  return next ? a + b : a - b;
}

/**
 * @class wix-data.WixDataQueryResult
 * @summary The results of a data query, containing the retrieved items.
 * @classdesc
 *  When you execute a query with the [`find()`](#wix-data.WixDataQuery.html#find)
 *  function, it returns a Promise that resolves to a `WixDataQueryResult` object.
 *  This object contains the items that match the query, information about the
 *  query itself, and functions for paging through the query results.
 */

var WixDataQueryResult = (function () {
  function WixDataQueryResult(obj) {
    _classCallCheck(this, WixDataQueryResult);

    if (!obj) {
      return;
    }

    this._items = obj.items;
    this._totalCount = obj.totalCount;
    this._query = obj.query;
    this._partialIncludes = obj.partialIncludes;

    //todo: to not forget
    //these properties are used by the client - they shouldn't be defined here....BUT since they are, we'll keep them for now, and move them later on to the client.
    this.nextSkipNumber = calcSkipNumber(this.query, this.length, true);
    this.prevSkipNumber = calcSkipNumber(this.query, this.length, false);
  }

  /**
   * @member items
   * @label property
   * @memberof wix-data.WixDataQueryResult
   * @readonly
   * @type {external:Object[]}
   * @syntax
   * get items(): Object[]
   * @summary Returns the items that match the query.
   * @description
   *  The current page of items retrieved by the query.
   *
   *  The page size is defined by the [`limit()`](wix-data.WixDataQuery.html#limit)
   *  function, can be retrieved using the [`pageSize`](#pageSize) property, and
   *  navigating through pages is done with the [`prev()`](#prev) and
   *  [`next()`](#next) functions.
   * @snippet [WixDataQueryResult-items.es6=Get the items of a query result]
   * @snippet [WixDataQueryResult-items_scenario.es6=Perform a query and get the items of the result]
   */

  _createClass(WixDataQueryResult, [{
    key: 'next',

    /**
     * @function next
     * @summary Retrieves the next page of query results.
     * @syntax
     * function next(): Promise&lt;WixDataQueryResult&gt;
     * @description
     *  The `next()` function retrieves the next page of query results.
     *
     *  The page size is defined by the [`limit()`](wix-data.WixDataQuery.html#limit)
     *  function, can be retrieved using the [`pageSize`](#pageSize) property, and
     *  navigating through pages is done with the [`prev()`](#prev) and
     *  [`next()`](#next) functions.
     *
     *  If items are added or removed between calls to `next()` the values returned
     *  by `WixDataQueryResult` may change.
     * @snippet [WixDataQueryResult-next.es6=Get the next page of a query result]
     * @returns {external:Promise}
     * @fulfill {wix-data.WixDataQueryResult} A query result object with the next page of query results.
     * @reject {external:Error} The errors that caused the rejection.
     * @memberof wix-data.WixDataQueryResult
     * @instance
     */
    value: function next() {
      return new WixDataQuery({
        provider: this.query.provider,
        collectionName: this.query.collectionName,
        filterTree: this.query.filterTree,
        orderBy: this.query.orderBy,
        skipNumber: calcSkipNumber(this.query, this.length, true),
        limitNumber: this.query.limitNumber,
        included: this.query.included,
        invalidArguments: []
      }).find();
    }

    /**
     * @function prev
     * @summary Retrieves the previous page of query results.
     * @syntax
     * function prev(): Promise&lt;WixDataQueryResult&gt;
     * @description
     *  The `prev()` function retrieves the previous page of query results.
     *
     *  The page size is defined by the [`limit()`](wix-data.WixDataQuery.html#limit)
     *  function, can be retrieved using the [`pageSize`](#pageSize) property, and
     *  navigating through pages is done with the [`prev()`](#prev) and
     *  [`next()`](#next) functions.
     *
     *  If items are added or removed between calls to `prev()` the values returned
     *  by `WixDataQueryResult` may change.
     * @snippet [WixDataQueryResult-prev.es6=Get the previous page of a query result]
     * @returns {external:Promise}
     * @fulfill {wix-data.WixDataQueryResult} A query result object with the next page of query results.
     * @reject {external:Error} The errors that caused the rejection.
     * @memberof wix-data.WixDataQueryResult
     * @instance
     */
  }, {
    key: 'prev',
    value: function prev() {
      var skip = calcSkipNumber(this.query, this.length, false);
      if (skip < 0) {
        return Promise.reject((0, _errors.validationError)('Failed to perform query on [' + this.query.collectionName + '].\nInvalid prev positioned query skip on a negative number ' + skip + '.'));
      } else {
        return new WixDataQuery({
          provider: this.query.provider,
          collectionName: this.query.collectionName,
          filterTree: this.query.filterTree,
          orderBy: this.query.orderBy,
          skipNumber: skip,
          limitNumber: this.query.limitNumber,
          included: this.query.included,
          invalidArguments: []
        }).find();
      }
    }

    /**
     * @summary Indicates the query has more results.
     * @syntax
     * function hasNext(): boolean
     * @returns {external:Boolean} `true` if there are more results.
     * @function hasNext
     * @memberof wix-data.WixDataQueryResult
     * @snippet [WixDataQueryResult-hasNext.es6=Get whether the query result object has more results]
     * @instance
     */
  }, {
    key: 'hasNext',
    value: function hasNext() {
      if (this.totalCount <= 0) {
        return false;
      }
      var skip = calcSkipNumber(this.query, this.length, true);
      return skip < this.totalCount;
    }

    /**
     * @summary Indicates the query has previous results.
     * @syntax
     * function hasPrev(): boolean
     * @returns {external:Boolean} `true` if there are previous results.
     * @function hasPrev
     * @memberof wix-data.WixDataQueryResult
     * @snippet [WixDataQueryResult-hasPrev.es6=Get whether the query result object has previous results]
     * @instance
     */
  }, {
    key: 'hasPrev',
    value: function hasPrev() {
      if (this.totalCount <= 0) {
        return false;
      }
      var skip = calcSkipNumber(this.query, this.length, false);
      return skip >= 0;
    }
  }, {
    key: 'toJSON',
    value: function toJSON() {
      return {
        items: this._items,
        length: this._items ? this._items.length : 0,
        totalCount: this._totalCount,
        query: this._query
      };
    }
  }, {
    key: 'items',
    get: function get() {
      return this._items;
    }

    /**
     * @member length
     * @label property
     * @memberof wix-data.WixDataQueryResult
     * @readonly
     * @type {external:Number}
     * @syntax
     * get length(): Number
     * @summary Returns the number of items in the current results page.
     * @description
     *  The page size is defined by the [`limit()`](wix-data.WixDataQuery.html#limit)
     *  function, can be retrieved using the [`pageSize`](#pageSize) property, and
     *  navigating through pages is done with the [`prev()`](#prev) and
     *  [`next()`](#next) functions.
     * @snippet [WixDataQueryResult-length.es6=Get the length of a query result]
     * @snippet [WixDataQueryResult-length_scenario.es6=Perform a query and get the length of the result]
     */
  }, {
    key: 'length',
    get: function get() {
      return this.items.length;
    }

    /**
     * @member totalCount
     * @label property
     * @memberof wix-data.WixDataQueryResult
     * @readonly
     * @type {external:Number}
     * @syntax
     * get totalCount(): Number
     * @summary Returns the total number of items that match the query.
     * @description
     *  The `totalCount` returns the total number of items that match the query,
     *  not just the number of items in the current page.
     * @snippet [WixDataQueryResult-totalCount.es6=Get the length of a query result]
     * @snippet [WixDataQueryResult-totalCount_scenario.es6=Perform a query and get the length of the result]
     */
  }, {
    key: 'totalCount',
    get: function get() {
      return this._totalCount;
    }

    /**
     * @member query
     * @label property
     * @memberof wix-data.WixDataQueryResult
     * @readonly
     * @type {wix-data.WixDataQuery}
     * @syntax
     * get query(): WixDataQuery
     * @summary Returns the query used to get the current results.
     * @snippet [WixDataQueryResult-query.es6=Get the query that produced a query result]
     * @snippet [WixDataQueryResult-query_scenario.es6=Perform a query and get the query that produced the result]
     */
  }, {
    key: 'query',
    get: function get() {
      return this._query;
    }

    /**
     * @member pageSize
     * @label property
     * @memberof wix-data.WixDataQueryResult
     * @readonly
     * @type {external:Number}
     * @syntax
     * get pageSize(): Number
     * @summary Returns the query page size.
     * @description
     *  The page size is defined by the [`limit()`](wix-data.WixDataQuery.html#limit)
     *  function, can be retrieved using the [`pageSize`](#pageSize) property, and
     *  navigating through pages is done with the [`prev()`](#prev) and
     *  [`next()`](#next) functions.
     * @snippet [WixDataQueryResult-pageSize.es6=Get the page size of a query result]
     * @snippet [WixDataQueryResult-pageSize_scenario.es6=Perform a query and get the page size of the query result]
     */
  }, {
    key: 'pageSize',
    get: function get() {
      return this._query.limitNumber || 50; //force default
    }

    /**
     * @member totalPages
     * @label property
     * @memberof wix-data.WixDataQueryResult
     * @readonly
     * @type {external:Number}
     * @syntax
     * get totalPages(): Number
     * @summary Returns the total number of pages the query produced.
     * @description
     *  The page size is defined by the [`limit()`](wix-data.WixDataQuery.html#limit)
     *  function, can be retrieved using the [`pageSize`](#pageSize) property, and
     *  navigating through pages is done with the [`prev()`](#prev) and
     *  [`next()`](#next) functions.
     * @snippet [WixDataQueryResult-totalPages.es6=Get the total number of pages in a query result]
     * @snippet [WixDataQueryResult-totalPages_scenario.es6=Perform a query and get the total number of pages in the query result]
     */
  }, {
    key: 'totalPages',
    get: function get() {
      return Math.ceil(this.totalCount / this.pageSize);
    }

    /**
     * @member currentPage
     * @label property
     * @memberof wix-data.WixDataQueryResult
     * @readonly
     * @type {external:Number}
     * @syntax
     * get currentPage(): Number
     * @summary Returns the index of the current results page number.
     * @description
     *  The `currentPage` is a zero-based index of the current page of results.
     *
     *  The page size is defined by the [`limit()`](wix-data.WixDataQuery.html#limit)
     *  function, can be retrieved using the [`pageSize`](#pageSize) property, and
     *  navigating through pages is done with the [`prev()`](#prev) and
     *  [`next()`](#next) functions.
     *
     *  The `currentPage` property returns `undefined` if the query returned no results.
     * @snippet [WixDataQueryResult-currentPage.es6=Get the current page index of a query result]
     * @snippet [WixDataQueryResult-currentPage_scenario.es6=Perform a query and get the current page index of the query result]
     */
  }, {
    key: 'currentPage',
    get: function get() {
      return this.totalCount > 0 && (this.query.skipNumber || 0) < this.totalCount ? Math.floor(this.totalPages * (this.query.skipNumber || 0) / this.totalCount) : undefined;
    }
  }, {
    key: 'partialIncludes',
    get: function get() {
      return this._partialIncludes;
    }
  }]);

  return WixDataQueryResult;
})();

var WixDataQueryReferencedResult = (function () {
  function WixDataQueryReferencedResult(provider, collectionName, referenceAttribute, holdingItemId, totalCount, skip, limit) {
    _classCallCheck(this, WixDataQueryReferencedResult);

    this.provider = provider;
    this.collectionName = collectionName;
    this.referenceAttribute = referenceAttribute;
    this.holdingItemId = holdingItemId;
    this.totalCount = totalCount;
    this.skip = skip;
    this.limit = limit;
  }

  _createClass(WixDataQueryReferencedResult, [{
    key: 'hasNext',
    value: function hasNext() {
      return this.skip + this.limit < this.totalCount;
    }
  }, {
    key: 'hasPrev',
    value: function hasPrev() {
      return this.skip > 0;
    }
  }, {
    key: 'next',
    value: function next() {
      return this.provider.queryReferenced(this.collectionName, this.holdingItemId, this.referenceAttribute, {
        skip: this.skip + this.limit,
        limit: this.limit
      });
    }
  }, {
    key: 'prev',
    value: function prev() {
      var skipCandidate = this.skip - this.limit;
      var actualSkip = skipCandidate >= 0 ? skipCandidate : 0;

      return this.provider.queryReferenced(this.collectionName, this.holdingItemId, this.referenceAttribute, {
        skip: actualSkip,
        limit: this.limit
      });
    }
  }]);

  return WixDataQueryReferencedResult;
})();

exports.WixDataQueryReferencedResult = WixDataQueryReferencedResult;

var QueryValidator = (function (_AggregatingValidator) {
  _inherits(QueryValidator, _AggregatingValidator);

  function QueryValidator(operatorName, previousInvalidArguments) {
    _classCallCheck(this, QueryValidator);

    _get(Object.getPrototypeOf(QueryValidator.prototype), 'constructor', this).call(this, previousInvalidArguments);
    this.operatorName = operatorName;
  }

  _createClass(QueryValidator, [{
    key: '_isNumber',
    value: function _isNumber(specifier, operand) {
      var _this3 = this;

      return this.addValidation(function () {
        return (0, _sharedTypeUtils.isNumber)(operand);
      }, function () {
        return _errors.messages.queryValidations.isNumber(_this3.operatorName, specifier, operand);
      });
    }
  }, {
    key: 'isPositiveNumber',
    value: function isPositiveNumber(operand) {
      var _this4 = this;

      return this._isNumber('positive', operand).addValidation(function () {
        return !Number.isNaN(operand) && operand > 0;
      }, function () {
        return _errors.messages.queryValidations.isPositiveNumber(_this4.operatorName, operand);
      });
    }
  }, {
    key: 'isNonNegativeNumber',
    value: function isNonNegativeNumber(operand) {
      var _this5 = this;

      return this._isNumber('non-negative', operand).addValidation(function () {
        return !Number.isNaN(operand) && operand >= 0;
      }, function () {
        return _errors.messages.queryValidations.isNonNegativeNumber(_this5.operatorName, operand);
      });
    }
  }, {
    key: 'isInteger',
    value: function isInteger(operand) {
      var _this6 = this;

      return this.addValidation(function () {
        return !Number.isNaN(operand) && Number.isFinite(operand) && Number.isInteger(operand) && operand < MAX_SAFE_INTEGER && operand > -MAX_SAFE_INTEGER;
      }, function () {
        return _errors.messages.queryValidations.isInteger(_this6.operatorName, operand);
      });
    }
  }, {
    key: 'notGreaterThan',
    value: function notGreaterThan(operand, value) {
      var _this7 = this;

      return this.addValidation(function () {
        return operand <= value;
      }, function () {
        return _errors.messages.queryValidations.notGreaterThan(_this7.operatorName, operand, value);
      });
    }
  }]);

  return QueryValidator;
})(_utilsBaseValidator.AggregatingValidator);

/***/ }),
/* 249 */
/***/ (function(module, exports) {

var toString = Object.prototype.toString;

/**
 * Get the native `typeof` a value.
 *
 * @param  {*} `val`
 * @return {*} Native javascript type
 */

module.exports = function kindOf(val) {
  var type = typeof val;

  // primitivies
  if (type === 'undefined') {
    return 'undefined';
  }
  if (val === null) {
    return 'null';
  }
  if (val === true || val === false || val instanceof Boolean) {
    return 'boolean';
  }
  if (type === 'string' || val instanceof String) {
    return 'string';
  }
  if (type === 'number' || val instanceof Number) {
    return 'number';
  }

  // functions
  if (type === 'function' || val instanceof Function) {
    if (typeof val.constructor.name !== 'undefined' && val.constructor.name.slice(0, 9) === 'Generator') {
      return 'generatorfunction';
    }
    return 'function';
  }

  // array
  if (typeof Array.isArray !== 'undefined' && Array.isArray(val)) {
    return 'array';
  }

  // check for instances of RegExp and Date before calling `toString`
  if (val instanceof RegExp) {
    return 'regexp';
  }
  if (val instanceof Date) {
    return 'date';
  }

  // other objects
  type = toString.call(val);

  if (type === '[object RegExp]') {
    return 'regexp';
  }
  if (type === '[object Date]') {
    return 'date';
  }
  if (type === '[object Arguments]') {
    return 'arguments';
  }
  if (type === '[object Error]') {
    return 'error';
  }
  if (type === '[object Promise]') {
    return 'promise';
  }

  // buffer
  if (isBuffer(val)) {
    return 'buffer';
  }

  // es6: Map, WeakMap, Set, WeakSet
  if (type === '[object Set]') {
    return 'set';
  }
  if (type === '[object WeakSet]') {
    return 'weakset';
  }
  if (type === '[object Map]') {
    return 'map';
  }
  if (type === '[object WeakMap]') {
    return 'weakmap';
  }
  if (type === '[object Symbol]') {
    return 'symbol';
  }
  if (type === '[object Map Iterator]') {
    return 'mapiterator';
  }
  if (type === '[object Set Iterator]') {
    return 'setiterator';
  }

  // typed arrays
  if (type === '[object Int8Array]') {
    return 'int8array';
  }
  if (type === '[object Uint8Array]') {
    return 'uint8array';
  }
  if (type === '[object Uint8ClampedArray]') {
    return 'uint8clampedarray';
  }
  if (type === '[object Int16Array]') {
    return 'int16array';
  }
  if (type === '[object Uint16Array]') {
    return 'uint16array';
  }
  if (type === '[object Int32Array]') {
    return 'int32array';
  }
  if (type === '[object Uint32Array]') {
    return 'uint32array';
  }
  if (type === '[object Float32Array]') {
    return 'float32array';
  }
  if (type === '[object Float64Array]') {
    return 'float64array';
  }

  // must be a plain object
  return 'object';
};

/**
 * If you need to support Safari 5-7 (8-10 yr-old browser),
 * take a look at https://github.com/feross/is-buffer
 */

function isBuffer(val) {
  return val.constructor
    && typeof val.constructor.isBuffer === 'function'
    && val.constructor.isBuffer(val);
}


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/**
 * Adds the key-value `pair` to `map`.
 *
 * @private
 * @param {Object} map The map to modify.
 * @param {Array} pair The key-value pair to add.
 * @returns {Object} Returns `map`.
 */
function addMapEntry(map, pair) {
  // Don't return `map.set` because it's not chainable in IE 11.
  map.set(pair[0], pair[1]);
  return map;
}

/**
 * Adds `value` to `set`.
 *
 * @private
 * @param {Object} set The set to modify.
 * @param {*} value The value to add.
 * @returns {Object} Returns `set`.
 */
function addSetEntry(set, value) {
  // Don't return `set.add` because it's not chainable in IE 11.
  set.add(value);
  return set;
}

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array ? array.length : 0;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array ? array.length : 0;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    getPrototype = overArg(Object.getPrototypeOf, Object),
    objectCreate = Object.create,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols,
    nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
    nativeKeys = overArg(Object.keys, Object);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap'),
    nativeCreate = getNative(Object, 'create');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  this.__data__ = new ListCache(entries);
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  return this.__data__['delete'](key);
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var cache = this.__data__;
  if (cache instanceof ListCache) {
    var pairs = cache.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      return this;
    }
    cache = this.__data__ = new MapCache(pairs);
  }
  cache.set(key, value);
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    object[key] = value;
  }
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @param {boolean} [isFull] Specify a clone including symbols.
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
  var result;
  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      if (isHostObject(value)) {
        return object ? value : {};
      }
      result = initCloneObject(isFunc ? {} : value);
      if (!isDeep) {
        return copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, baseClone, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (!isArr) {
    var props = isFull ? getAllKeys(value) : keys(value);
  }
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, isDeep, isFull, customizer, key, value, stack));
  });
  return result;
}

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} prototype The object to inherit from.
 * @returns {Object} Returns the new object.
 */
function baseCreate(proto) {
  return isObject(proto) ? objectCreate(proto) : {};
}

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  return objectToString.call(value);
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var result = new buffer.constructor(buffer.length);
  buffer.copy(result);
  return result;
}

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

/**
 * Creates a clone of `map`.
 *
 * @private
 * @param {Object} map The map to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned map.
 */
function cloneMap(map, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(mapToArray(map), true) : mapToArray(map);
  return arrayReduce(array, addMapEntry, new map.constructor);
}

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

/**
 * Creates a clone of `set`.
 *
 * @private
 * @param {Object} set The set to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned set.
 */
function cloneSet(set, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
  return arrayReduce(array, addSetEntry, new set.constructor);
}

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    assignValue(object, key, newValue === undefined ? source[key] : newValue);
  }
  return object;
}

/**
 * Copies own symbol properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Creates an array of the own enumerable symbol properties of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = objectToString.call(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : undefined;

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, cloneFunc, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return cloneMap(object, isDeep, cloneFunc);

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return cloneSet(object, isDeep, cloneFunc);

    case symbolTag:
      return cloneSymbol(object);
  }
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return baseClone(value, true, true);
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = cloneDeep;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7), __webpack_require__(39)(module)))

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(38);

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

exports.filterBuilderFactory = filterBuilderFactory;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _filterMixin2 = __webpack_require__(111);

var _filterMixin3 = _interopRequireDefault(_filterMixin2);

var _errors = __webpack_require__(9);

var FilterBuilder = (function (_filterMixin) {
  _inherits(FilterBuilder, _filterMixin);

  function FilterBuilder() {
    _classCallCheck(this, FilterBuilder);

    _get(Object.getPrototypeOf(FilterBuilder.prototype), 'constructor', this).apply(this, arguments);
  }

  _createClass(FilterBuilder, [{
    key: '_build',
    value: function _build() {
      throwErrorIfInvalid(this.invalidArguments);
      return this.filterTree;
    }
  }, {
    key: 'constructorName',
    get: function get() {
      return 'FilterBuilder';
    }
  }]);

  return FilterBuilder;
})((0, _filterMixin3['default'])());

function throwErrorIfInvalid(invalidArguments) {
  if (invalidArguments.length > 0) {
    throw (0, _errors.validationError)(_errors.messages.filterBuilderInvalid(invalidArguments));
  }
}

function filterBuilderFactory() {
  return new FilterBuilder({});
}

exports['default'] = filterBuilderFactory;

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

exports.sortBuilderFactory = sortBuilderFactory;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _sortMixin2 = __webpack_require__(112);

var _sortMixin3 = _interopRequireDefault(_sortMixin2);

var _errors = __webpack_require__(9);

var QuerySort = (function (_sortMixin) {
  _inherits(QuerySort, _sortMixin);

  function QuerySort() {
    _classCallCheck(this, QuerySort);

    _get(Object.getPrototypeOf(QuerySort.prototype), 'constructor', this).apply(this, arguments);
  }

  _createClass(QuerySort, [{
    key: '_build',
    value: function _build() {
      throwErrorIfInvalid(this.invalidArguments);
      return this.orderBy;
    }
  }]);

  return QuerySort;
})((0, _sortMixin3['default'])());

function throwErrorIfInvalid(invalidArguments) {
  if (invalidArguments.length > 0) {
    throw (0, _errors.validationError)(_errors.messages.sortBuilderInvalid(invalidArguments));
  }
}

function sortBuilderFactory() {
  return new QuerySort(undefined);
}

exports['default'] = sortBuilderFactory;

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var WixDataQueryReferencedResult = (function () {
  function WixDataQueryReferencedResult(provider, collectionName, referenceAttribute, holdingItemId, result) {
    var options = arguments.length <= 5 || arguments[5] === undefined ? {} : arguments[5];

    _classCallCheck(this, WixDataQueryReferencedResult);

    this.provider = provider;
    this.collectionName = collectionName;
    this.referenceAttribute = referenceAttribute;
    this.holdingItemId = holdingItemId;
    this.result = result;
    this.options = options;

    var _options$skip = options.skip;
    var skip = _options$skip === undefined ? 0 : _options$skip;
    var _options$limit = options.limit;
    var limit = _options$limit === undefined ? 50 : _options$limit;

    this.skip = skip;
    this.limit = limit;
  }

  _createClass(WixDataQueryReferencedResult, [{
    key: "hasNext",
    value: function hasNext() {
      return this.skip + this.limit < this.result.totalCount;
    }
  }, {
    key: "hasPrev",
    value: function hasPrev() {
      return this.skip > 0;
    }
  }, {
    key: "next",
    value: function next() {
      return _queryForPage.call(this, this.skip + this.limit);
    }
  }, {
    key: "prev",
    value: function prev() {
      return _queryForPage.call(this, this.skip - this.limit);
    }
  }, {
    key: "items",
    get: function get() {
      return this.result.items;
    }
  }, {
    key: "totalCount",
    get: function get() {
      return this.result.totalCount;
    }
  }]);

  return WixDataQueryReferencedResult;
})();

exports.WixDataQueryReferencedResult = WixDataQueryReferencedResult;

function _queryForPage(skip) {
  var _this = this;

  var actualSkip = skip >= 0 ? skip : 0;
  var optionsToPass = Object.assign({}, this.options, { skip: actualSkip, limit: this.limit });

  return this.provider.queryReferenced(this.collectionName, this.holdingItemId, this.referenceAttribute, optionsToPass).then(function (result) {
    return new WixDataQueryReferencedResult(_this.provider, _this.collectionName, _this.holdingItemId, _this.referenceAttribute, result, optionsToPass);
  });
}

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createWixDataProxy = createWixDataProxy;
function createWixDataProxy(elementorySupportInstance) {
  return {
    save: function save() {
      return elementorySupportInstance.getJSON('/wix/data-web.jsw/save.ajax', arguments);
    },
    insert: function insert() {
      return elementorySupportInstance.getJSON('/wix/data-web.jsw/insert.ajax', arguments);
    },
    update: function update() {
      return elementorySupportInstance.getJSON('/wix/data-web.jsw/update.ajax', arguments);
    },
    get: function get() {
      return elementorySupportInstance.getJSON('/wix/data-web.jsw/get.ajax', arguments);
    },
    remove: function remove() {
      return elementorySupportInstance.getJSON('/wix/data-web.jsw/remove.ajax', arguments);
    },
    find: function find() {
      return elementorySupportInstance.getJSON('/wix/data-web.jsw/find.ajax', arguments);
    },
    count: function count() {
      return elementorySupportInstance.getJSON('/wix/data-web.jsw/count.ajax', arguments);
    },
    bulkInsert: function bulkInsert() {
      return elementorySupportInstance.getJSON('/wix/data-web.jsw/bulkInsert.ajax', arguments);
    },
    queryReferenced: function queryReferenced() {
      return elementorySupportInstance.getJSON('/wix/data-web.jsw/queryReferenced.ajax', arguments);
    },
    insertReference: function insertReference() {
      return elementorySupportInstance.getJSON('/wix/data-web.jsw/insertReference.ajax', arguments);
    },
    removeReference: function removeReference() {
      return elementorySupportInstance.getJSON('/wix/data-web.jsw/removeReference.ajax', arguments);
    },
    isReferenced: function isReferenced() {
      return elementorySupportInstance.getJSON('/wix/data-web.jsw/isReferenced.ajax', arguments);
    },
    getSchema: function getSchema() {
      return elementorySupportInstance.getJSON('/wix/data-web.jsw/getSchema.ajax', arguments);
    }

  };
}

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(257).default


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createWixDataSchemas;
var WixDataSchemaApi = __webpack_require__(258);

function createWixDataSchemas(elementorySupportInstance) {
  return new WixDataSchemaApi(createWixDataSchemaApiProxy(elementorySupportInstance));
}

function createWixDataSchemaApiProxy(elementorySupportInstance) {
  return {
    get: function get() {
      return elementorySupportInstance.getJSON('/wix/schema-api-web.jsw/get.ajax', arguments);
    },
    list: function list() {
      return elementorySupportInstance.getJSON('/wix/schema-api-web.jsw/list.ajax', arguments);
    },
    save: function save() {
      return elementorySupportInstance.getJSON('/wix/schema-api-web.jsw/save.ajax', arguments);
    }
  };
}

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(259)


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

module.exports = function () {
  function WixDataSchemaApi(provider) {
    _classCallCheck(this, WixDataSchemaApi);

    this.provider = provider;
  }

  _createClass(WixDataSchemaApi, [{
    key: "get",
    value: function get() {
      var _provider;

      return (_provider = this.provider).get.apply(_provider, arguments);
    }
  }, {
    key: "list",
    value: function list() {
      var _provider2;

      return (_provider2 = this.provider).list.apply(_provider2, arguments);
    }
  }, {
    key: "save",
    value: function save() {
      var _provider3;

      return (_provider3 = this.provider).save.apply(_provider3, arguments);
    }
  }]);

  return WixDataSchemaApi;
}();

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var values_ = __webpack_require__(0).values;
var includes_ = __webpack_require__(0).includes;
var merge_ = __webpack_require__(0).merge;
var negate_ = __webpack_require__(0).negate;
var pick_ = __webpack_require__(0).pick;

var createDatasetController = __webpack_require__(261);
var DATASET_TYPES = __webpack_require__(41);
var sendBiOnError = __webpack_require__(470);
var addRavenData = __webpack_require__(473);
var schemaAPICreator = __webpack_require__(474);
var wixDataProxyCreator = __webpack_require__(477);

var _require = __webpack_require__(13),
    isDatasetError = _require.isDatasetError;

var errorBoundariesCreator = __webpack_require__(105);
var createRavenProxy = __webpack_require__(478);
var createFedopsLogger = __webpack_require__(479).create;
var createRavenHooksForFedops = __webpack_require__(497);

var _require2 = __webpack_require__(144),
    parseUrlPattern = _require2.parseUrlPattern;

var extractDynamicUrlPatternFieldsValuesFromRecord = function extractDynamicUrlPatternFieldsValuesFromRecord(dynamicUrl, record) {
  var patternFields = dynamicUrl && record ? parseUrlPattern(dynamicUrl).fields : null;
  return patternFields ? pick_(record, patternFields) : null;
};

var extractRouterPayload = function extractRouterPayload(payload, parser) {
  var dynamicUrl = payload.dynamicUrl,
      userDefinedFilter = payload.userDefinedFilter,
      items = payload.items,
      totalCount = payload.totalCount;

  var parsedItems = parser(items);
  var record = parsedItems ? parsedItems[0] : null;
  var dynamicUrlPatternFieldsValues = extractDynamicUrlPatternFieldsValuesFromRecord(dynamicUrl, record);

  return {
    prefetchedData: {
      items: parsedItems,
      totalCount: totalCount
    },
    dynamicPagesData: {
      dynamicUrl: dynamicUrl,
      userDefinedFilter: userDefinedFilter,
      dynamicUrlPatternFieldsValues: dynamicUrlPatternFieldsValues
    }
  };
};

var mergeRouterDatasetConfig = function mergeRouterDatasetConfig(routerConfig, controllerConfig) {
  return merge_({}, controllerConfig, routerConfig);
};

module.exports = function (_ref) {
  var wixDataCreator = _ref.wixDataCreator,
      elementorySupport = _ref.elementorySupport,
      errorReporter = _ref.errorReporter,
      Raven = _ref.Raven,
      UserRaven = _ref.UserRaven,
      WixDataRaven = _ref.WixDataRaven,
      biLogger = _ref.biLogger,
      errorBiLogger = _ref.errorBiLogger;

  var _createRavenHooksForF = createRavenHooksForFedops(Raven),
      startHook = _createRavenHooksForF.startHook,
      endHook = _createRavenHooksForF.endHook;
  // custom timeoutHook for viewer-app fedops logger. Logs with level info until stabilized, to prevent false alarms


  var timeoutHook = function timeoutHook(_ref2) {
    var name = _ref2.name,
        timeout = _ref2.timeout;
    return Raven.captureMessage('interaction ' + name + ' timed out', {
      level: 'info',
      extra: {
        interactionTimeout: timeout
      }
    });
  };
  var fedopsLogger = createFedopsLogger('wix-code-dbsm-viewer-app', {
    interactionTimeout: 50000,
    startHook: startHook,
    endHook: endHook,
    timeoutHook: timeoutHook
  });

  var ravenProxy = createRavenProxy(Raven);
  var userRavenProxy = createRavenProxy(UserRaven);
  var wixDataRavenProxy = createRavenProxy(WixDataRaven);
  var errorBoundaries = errorBoundariesCreator({
    Raven: ravenProxy,
    UserRaven: userRavenProxy,
    WixDataRaven: wixDataRavenProxy
  });

  var wixDataProxy = void 0;
  var wixDataSchemasProxy = void 0;
  var routerPayload = void 0;
  var platformUtilities = void 0;
  var schemaAPI = void 0;
  var wixSdk = void 0;

  sendBiOnError(errorBiLogger, Raven, negate_(isDatasetError));

  return {
    initAppForPage: function initAppForPage(_ref3, platformUtils, wix) {
      var routerReturnedData = _ref3.routerReturnedData;

      wixSdk = wix;

      var _fedopsLogger$interac = fedopsLogger.interactionStarted('databinding/initAppForPage'),
          timeoutId = _fedopsLogger$interac.timeoutId;

      [Raven, UserRaven, WixDataRaven].forEach(function (raven) {
        raven.setUserContext({
          id: wixSdk.user.currentUser.id
        });
      });

      addRavenData(Raven, routerReturnedData, 'routerReturnedData');
      try {
        ;
        var _wixDataProxyCreator = wixDataProxyCreator(errorBoundaries.wixDataCodeZone, wixDataCreator);

        wixDataProxy = _wixDataProxyCreator.wixDataProxy;
        wixDataSchemasProxy = _wixDataProxyCreator.wixDataSchemasProxy;

        routerPayload = routerReturnedData || {};
        platformUtilities = platformUtils;
        schemaAPI = schemaAPICreator(wixDataSchemasProxy, Raven);
        fedopsLogger.interactionEnded('databinding/initAppForPage', {
          timeoutId: timeoutId
        });
        return Promise.resolve();
      } catch (e) {
        Raven.captureException(e);
        return Promise.reject(e);
      }
    },

    createControllers: function createControllers(controllerConfigs) {
      try {
        var _fedopsLogger$interac2 = fedopsLogger.interactionStarted('databinding/createControllers'),
            createControllersTimeoutId = _fedopsLogger$interac2.timeoutId;

        if (controllerConfigs.length) {
          var _fedopsLogger$interac3 = fedopsLogger.interactionStarted('databinding/loadSchemas'),
              loadSchemasTimeoutId = _fedopsLogger$interac3.timeoutId;

          schemaAPI.loadSchemas().then(function () {
            fedopsLogger.interactionEnded('databinding/loadSchemas', {
              timeoutId: loadSchemasTimeoutId
            });
          }).catch(function () {});
        }

        var datasetTypes = values_(DATASET_TYPES);
        var controllers = controllerConfigs.map(function (_ref4, controllerIndex) {
          var type = _ref4.type,
              config = _ref4.config,
              connections = _ref4.connections,
              $w = _ref4.$w;

          if (!includes_(datasetTypes, type)) {
            throw new Error('type of controller MUST be one of ' + datasetTypes + ' but is ' + type);
          }
          var uniqueId = controllerIndex + '_' + type;
          var datasetConfiguration = type === DATASET_TYPES.ROUTER_DATASET ? mergeRouterDatasetConfig(routerPayload.config, config) : config;

          var routerData = type === DATASET_TYPES.ROUTER_DATASET ? extractRouterPayload(routerPayload, elementorySupport.wireFormatParser) : undefined;

          var datasetController = createDatasetController({
            controllerConfig: datasetConfiguration,
            datasetType: type,
            connections: connections,
            wixDataProxy: wixDataProxy,
            wixDataSchemasProxy: wixDataSchemasProxy,
            firePlatformEvent: errorBoundaries.userCodeZone($w.fireEvent),
            errorBoundaries: errorBoundaries,
            wixSdk: wixSdk,
            errorReporter: errorReporter,
            platformUtilities: platformUtilities,
            routerData: routerData,
            ravenProxy: ravenProxy,
            uniqueId: uniqueId,
            schemaAPI: schemaAPI,
            fedopsLogger: fedopsLogger,
            biLogger: biLogger
          });
          return Promise.resolve(datasetController);
        });
        fedopsLogger.interactionEnded('databinding/createControllers', {
          timeoutId: createControllersTimeoutId
        });
        return controllers;
      } catch (e) {
        Raven.captureException(e);
        return [];
      }
    }
  };
};

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* global VERBOSE */


function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _require = __webpack_require__(114),
    createStore = _require.createStore,
    applyMiddleware = _require.applyMiddleware;

var _require2 = __webpack_require__(276),
    thunk = _require2.default;

var uniq_ = __webpack_require__(0).uniq;
var mapValues_ = __webpack_require__(0).mapValues;
var groupBy_ = __webpack_require__(0).groupBy;
var has_ = __webpack_require__(0).has;
var get_ = __webpack_require__(0).get;
var isEqual_ = __webpack_require__(0).isEqual;
var maybe = __webpack_require__(1);

var servicesCreator = __webpack_require__(277);

var _require3 = __webpack_require__(120),
    queuedThunkMiddleware = _require3.queuedThunkMiddleware;

var ravenMiddleware = __webpack_require__(279);
var DATASET_TYPES = __webpack_require__(41);

var _require4 = __webpack_require__(20),
    uploadButtonSdkType = _require4.UploadButton;

var _require5 = __webpack_require__(280),
    SCOPE_TYPES = _require5.SCOPE_TYPES;

var rootReducer = __webpack_require__(2);
var recordActions = __webpack_require__(25);
var dynamicPagesActions = __webpack_require__(292);

var _require6 = __webpack_require__(133),
    recordExecutor = _require6.executor;

var configActions = __webpack_require__(134);
var rootActions = __webpack_require__(43);

var _require7 = __webpack_require__(135),
    setDependencies = _require7.setDependencies,
    waitForDependencies = _require7.waitForDependencies,
    performHandshake = _require7.performHandshake,
    resolveMissingDependencies = _require7.resolveMissingDependencies;

var adapterApiCreator = __webpack_require__(294);

var _require8 = __webpack_require__(137),
    adapterApiExecutor = _require8.executor;

var _require9 = __webpack_require__(138),
    dynamicPagesExecutor = _require9.executor;

var datasetApiCreator = __webpack_require__(308);
var eventListenersCreator = __webpack_require__(311);
var syncComponentsWithState = __webpack_require__(312);
var createBreadcrumbMessage = __webpack_require__(142);
var getFieldType = __webpack_require__(316);
var createScopeStore = __webpack_require__(317);
var createScopeFactory = __webpack_require__(318);

var _require10 = __webpack_require__(319),
    findConnectedComponents = _require10.findConnectedComponents,
    createComponentAdapterContexts = _require10.createComponentAdapterContexts,
    createDetailsRepeatersAdapterContexts = _require10.createDetailsRepeatersAdapterContexts,
    resolveHandshakes = _require10.resolveHandshakes;

var _require11 = __webpack_require__(325),
    extractDependencies = _require11.extractDependencies,
    createFilterResolver = _require11.createFilterResolver,
    createValueResolvers = _require11.createValueResolvers;

var dependenciesManagerCreator = __webpack_require__(328);
var recordStoreServiceCreator = __webpack_require__(329);
var queryResults = __webpack_require__(26);

var _require12 = __webpack_require__(464),
    setConnectedComponents = _require12.setConnectedComponents;

var _require13 = __webpack_require__(27),
    isSameRecord = _require13.isSameRecord;

var _require14 = __webpack_require__(10),
    createSerialEffectsMiddleware = _require14.createMiddleware;

var _require15 = __webpack_require__(188),
    fireEventExecutor = _require15.executor;

var _require16 = __webpack_require__(465),
    reportDatasetActiveOnPage = _require16.reportDatasetActiveOnPage;

var rootSubscriber = __webpack_require__(466);
var dynamicPagesSubscriber = __webpack_require__(468);

var hasDependencies = function hasDependencies(store, controllerConfig) {
  return extractDependencies(get_(controllerConfig, ['dataset', 'filter'])).length > 0;
};

var waitForControllerDependencies = function waitForControllerDependencies(store, controllerConfig) {
  var dependenciesIds = extractDependencies(get_(controllerConfig, ['dataset', 'filter']));
  store.dispatch(setDependencies(dependenciesIds));
  return store.dispatch(waitForDependencies(store));
};

var onChangeHandler = function onChangeHandler(getState, dispatch, adapterApi) {
  var updateComponentsBasedOnRecord = recordActions.updateComponentsBasedOnRecord(adapterApi);

  return function (before, after, componentIdToExclude) {
    var currentRecordIndex = rootReducer.selectCurrentRecordIndex(getState());
    var currentRecord = rootReducer.selectCurrentRecord(getState());
    var updatedFields = after && before ? Object.keys(after).filter(function (key) {
      return !isEqual_(after[key], before[key]);
    }) : [];
    var isSame = after && currentRecord && isSameRecord(currentRecord, after);
    var isBeforeSame = before && currentRecord && isSameRecord(currentRecord, before);
    var sameFieldSet = after && before && isEqual_(Object.keys(before), Object.keys(after));

    if (isSame && (updatedFields.length > 0 || !sameFieldSet)) {
      dispatch(recordActions.setCurrentRecord(after, currentRecordIndex));
      updateComponentsBasedOnRecord(componentIdToExclude, updatedFields);
    } else if (before === null || after === null) {
      if (isBeforeSame) {
        dispatch(recordActions.refreshCurrentRecord()).then(function () {
          return updateComponentsBasedOnRecord(componentIdToExclude);
        });
      }
      dispatch(recordActions.refreshCurrentView());
    }
  };
};

var createRecordStoreService = function createRecordStoreService(_ref) {
  var wixDataProxy = _ref.wixDataProxy,
      controllerConfig = _ref.controllerConfig,
      datasetType = _ref.datasetType,
      dynamicPagesData = _ref.dynamicPagesData,
      Raven = _ref.Raven,
      getSchema = _ref.getSchema;

  var datasetConfig = maybe.fromNullable(controllerConfig).chain(function (_ref2) {
    var dataset = _ref2.dataset;
    return maybe.fromNullable(dataset);
  });
  var collectionName = datasetConfig.chain(function (_ref3) {
    var collectionName = _ref3.collectionName;
    return maybe.fromNullable(collectionName);
  });

  return collectionName.map(function (mainCollectionName) {
    var includes = get_(controllerConfig, ['dataset', 'includes']);
    var readWriteType = get_(controllerConfig, ['dataset', 'readWriteType']);

    return recordStoreServiceCreator({
      wixDataProxy: wixDataProxy,
      mainCollectionName: mainCollectionName,
      includes: includes,
      readWriteType: readWriteType,
      datasetType: datasetType,
      dynamicPagesData: dynamicPagesData,
      Raven: Raven,
      getSchema: getSchema
    });
  });
};

var createRecordStore = function createRecordStore(recordStoreService, getState, prefetchedData, controllerId, filterResolver) {
  return function (byRefField) {
    var state = getState();
    var config = rootReducer.getConfig(state);
    var pageSize = rootReducer.getCurrentPageSize(state);
    var sort = config.sort;

    return recordStoreService.apply(maybe.fromNullable(byRefField).matchWith({
      Nothing: function Nothing() {
        return filterResolver(config.filter).map(function (filter) {
          return {
            pageSize: pageSize,
            sort: sort,
            filter: filter,
            seed: queryResults.fromWixDataQueryResults(prefetchedData),
            controllerId: controllerId
          };
        });
      },
      Just: function Just(_ref4) {
        var value = _ref4.value;
        return maybe.Just({
          pageSize: pageSize,
          sort: null,
          filter: null,
          seed: queryResults.fromWixDataQueryResults(undefined),
          controllerId: controllerId,
          byRefField: byRefField
        });
      }
    }));
  };
};

var createDatasetStore = function createDatasetStore(services, ravenProxy, uniqueId, fireEvent) {
  var _createSerialEffectsM = createSerialEffectsMiddleware(),
      serialEffects = _createSerialEffectsM.middleware,
      subscribe = _createSerialEffectsM.subscribe,
      registerExecutors = _createSerialEffectsM.registerExecutors;

  var store = createStore(rootReducer, undefined, applyMiddleware(queuedThunkMiddleware(services()), thunk.withExtraArgument(services()), serialEffects, ravenMiddleware(ravenProxy, function (breadCrumb) {
    return Object.assign({}, breadCrumb, {
      message: createBreadcrumbMessage(breadCrumb.message, uniqueId)
    });
  })));

  return {
    store: store,
    subscribe: subscribe,
    registerExecutors: registerExecutors
  };
};

function waitForAllChildScopesToBeReady(scopeStore) {
  return Promise.all(scopeStore.getAll().map(function (scope) {
    return new Promise(function (resolve) {
      scope.staticExports.onReady(resolve);
    });
  }));
}

var createDataset = function createDataset(_ref5) {
  var controllerConfig = _ref5.controllerConfig,
      datasetType = _ref5.datasetType,
      connections = _ref5.connections,
      wixDataProxy = _ref5.wixDataProxy,
      wixSdk = _ref5.wixSdk,
      firePlatformEvent = _ref5.firePlatformEvent,
      errorReporter = _ref5.errorReporter,
      platformUtilities = _ref5.platformUtilities,
      routerData = _ref5.routerData,
      ravenProxy = _ref5.ravenProxy,
      errorBoundaries = _ref5.errorBoundaries,
      uniqueId = _ref5.uniqueId,
      isScoped = _ref5.isScoped,
      _ref5$handshakes = _ref5.handshakes,
      handshakes = _ref5$handshakes === undefined ? [] : _ref5$handshakes,
      schemaAPI = _ref5.schemaAPI,
      recordStoreService = _ref5.recordStoreService,
      fedopsLogger = _ref5.fedopsLogger,
      biLogger = _ref5.biLogger,
      _ref5$isFixedItem = _ref5.isFixedItem,
      isFixedItem = _ref5$isFixedItem === undefined ? false : _ref5$isFixedItem;

  var unsubscribeHandlers = [];
  var eventListeners = eventListenersCreator(firePlatformEvent, errorReporter);

  var _ref6 = routerData || {},
      prefetchedData = _ref6.prefetchedData,
      dynamicPagesData = _ref6.dynamicPagesData;

  var fireEvent = eventListeners.fireEvent;

  unsubscribeHandlers.push(eventListeners.dispose);

  var services = servicesCreator();

  var _createDatasetStore = createDatasetStore(services, ravenProxy, uniqueId, fireEvent),
      store = _createDatasetStore.store,
      subscribe = _createDatasetStore.subscribe,
      registerExecutors = _createDatasetStore.registerExecutors;

  registerExecutors(fireEventExecutor(fireEvent, errorBoundaries));

  unsubscribeHandlers.push(ravenProxy.addDataCallback(function () {
    return _defineProperty({}, uniqueId, {
      state: store.getState(),
      connections: connections
    });
  }));

  if (controllerConfig && controllerConfig.dataset) {
    store.dispatch(rootActions.setConfig(controllerConfig.dataset));
  }

  var scopeStore = createScopeStore(ravenProxy);
  services({ scopeStore: scopeStore });
  unsubscribeHandlers.push(ravenProxy.addDataCallback(function () {
    return {
      scopes: scopeStore.getAll()
    };
  }));

  var dependenciesManager = dependenciesManagerCreator();
  unsubscribeHandlers.push(dependenciesManager.unsubscribe);

  var dependenciesPromise = void 0;
  if (hasDependencies(store, controllerConfig)) {
    dependenciesPromise = waitForControllerDependencies(store, controllerConfig);
  }

  var datasetCollectionName = get_(controllerConfig, ['dataset', 'collectionName']);

  var getSchema = function getSchema() {
    var schemaName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : datasetCollectionName;

    return schemaAPI.getSchema(schemaName);
  };

  if (!recordStoreService) {
    recordStoreService = createRecordStoreService({
      wixDataProxy: wixDataProxy,
      controllerConfig: controllerConfig,
      datasetType: datasetType,
      dynamicPagesData: dynamicPagesData,
      Raven: ravenProxy,
      getSchema: getSchema
    });
  }

  var valueResolvers = createValueResolvers(dependenciesManager.get(), wixSdk);
  var filterResolver = createFilterResolver(valueResolvers);

  var recordStore = createRecordStore(recordStoreService, store.getState, prefetchedData, uniqueId, filterResolver);

  if (datasetType === DATASET_TYPES.ROUTER_DATASET) {
    registerExecutors(dynamicPagesExecutor(recordStore));
    subscribe(dynamicPagesSubscriber());
    store.dispatch(dynamicPagesActions.initialize(connections));
  }

  var getFieldTypeFunc = function getFieldTypeFunc(fieldName) {
    var schema = getSchema(datasetCollectionName);
    var referencedCollectionsSchemas = schemaAPI.getReferencedCollectionsSchemas(datasetCollectionName);
    return getFieldType(schema, referencedCollectionsSchemas)(fieldName);
  };

  var componentAdapterContexts = [];
  var adapterApi = function adapterApi() {
    return adapterApiCreator({
      adapterParams: {
        getState: store.getState,
        datasetApi: appDatasetApi,
        wixSdk: wixSdk,
        errorReporter: errorReporter,
        platformUtilities: platformUtilities,
        eventListeners: eventListeners,
        roles: uniqueRoles,
        getFieldType: getFieldTypeFunc,
        getSchema: getSchema,
        wixDataProxy: wixDataProxy,
        services: services,
        errorBoundaries: errorBoundaries
      },
      dispatch: store.dispatch,
      recordStore: recordStore,
      componentAdapterContexts: componentAdapterContexts
    });
  };

  unsubscribeHandlers.push(recordStoreService.chain(function (service) {
    return service.onChange(onChangeHandler(store.getState, store.dispatch, adapterApi));
  }));

  services({
    wixDataProxy: wixDataProxy,
    eventListeners: eventListeners,
    dependenciesManager: dependenciesManager,
    handshakes: handshakes,
    Raven: ravenProxy,
    recordStore: recordStore,
    adapterApi: adapterApi,
    errorReporter: errorReporter,
    fedopsLogger: fedopsLogger
  });

  var uniqueRoles = uniq_(connections.map(function (conn) {
    return conn.role;
  }));

  var datasetApi = datasetApiCreator({
    store: store,
    recordStore: recordStore,
    services: services(),
    datasetId: uniqueId,
    datasetType: datasetType,
    errorBoundaries: errorBoundaries,
    isFixedItem: isFixedItem
  });

  var appDatasetApi = datasetApi(false);
  registerExecutors(recordExecutor(recordStore, adapterApi, getFieldTypeFunc, eventListeners.executeHooks, ravenProxy, uniqueId));

  var hasPrefetchedData = !!prefetchedData;
  if (controllerConfig && !rootReducer.isWriteOnly(store.getState())) {
    store.dispatch(recordActions.fetchInitialDataAndSetInitialCurrentRecord(hasPrefetchedData, errorReporter));
  }

  handshakes.forEach(function (handshake) {
    return store.dispatch(performHandshake(handshake));
  });

  var shouldRefreshDataset = function shouldRefreshDataset() {
    var isWriteOnly = rootReducer.isWriteOnly(store.getState());
    var currentRecordIndex = rootReducer.selectCurrentRecordIndex(store.getState());
    var isPristine = recordStore().matchWith({
      Nothing: function Nothing() {
        return false;
      },
      Just: function Just(_ref8) {
        var service = _ref8.value;
        return service.isPristine(currentRecordIndex);
      }
    });

    return isPristine && !isWriteOnly;
  };

  var pageReady = errorBoundaries.applicationCodeZone(function () {
    var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2($w) {
      var _this = this;

      var _fedopsLogger$interac, timeoutId, connectedComponents, controllersToHandshake, dependencies, scopeFactory, detailsRepeatersAdapterContexts, defaultRecord;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              try {
                reportDatasetActiveOnPage(biLogger, store.getState(), connections, datasetType, isScoped, uniqueId, wixSdk);
              } catch (err) {
                ravenProxy.captureException(err);
              }

              wixSdk.user.onLogin(function () {
                // THIS SHOULD HAPPEN SYNCHRONOUSLY SO TESTS WILL REMAIN MEANINGFUL
                // IF YOU EVER FIND THE NEED TO MAKE IT ASYNC - TALK TO morg@wix.com OR leeor@wix.com
                if (shouldRefreshDataset()) {
                  appDatasetApi.refresh();
                }
              });
              _fedopsLogger$interac = fedopsLogger.interactionStarted('dataset/pageReady'), timeoutId = _fedopsLogger$interac.timeoutId;
              connectedComponents = findConnectedComponents(uniqueRoles, $w);

              store.dispatch(setConnectedComponents(connectedComponents.map(function (_ref10) {
                var component = _ref10.component;
                return component.uniqueId;
              })));

              // THIS SHOULD HAPPEN SYNCHRONOUSLY AFTER PAGE READY IS CALLED TO KEEP CONTROLLERS RUNNING SEQUENCE
              controllersToHandshake = resolveHandshakes(appDatasetApi, connectedComponents);

              controllersToHandshake.forEach(function (_ref11) {
                var controller = _ref11.controller,
                    handshakeInfo = _ref11.handshakeInfo;
                return controller.handshake(handshakeInfo);
              });

              if (!dependenciesPromise) {
                _context2.next = 11;
                break;
              }

              // if by now we are still waiting for dependencies, mark them as resolved
              // since they are guaranteed to perform a handshake with us before our pageReady.
              // A missing dependency can happen in a master-detail scenario where the user
              // deleted the master dataset
              store.dispatch(resolveMissingDependencies());

              _context2.next = 11;
              return dependenciesPromise;

            case 11:
              dependencies = dependenciesManager.get();

              // scoped datasets are sure to have the schema resolved and therefore don't have to wait

              if (isScoped) {
                _context2.next = 15;
                break;
              }

              _context2.next = 15;
              return schemaAPI.loadSchemas();

            case 15:
              scopeFactory = createScopeFactory(createDataset, {
                controllerConfig: controllerConfig,
                datasetType: datasetType,
                connections: connections,
                wixDataProxy: wixDataProxy,
                wixSdk: wixSdk,
                errorReporter: errorReporter,
                platformUtilities: platformUtilities,
                ravenProxy: ravenProxy,
                errorBoundaries: errorBoundaries,
                uniqueId: uniqueId,
                services: services,
                schemaAPI: schemaAPI,
                recordStoreService: recordStoreService,
                fedopsLogger: fedopsLogger,
                biLogger: biLogger
              });


              componentAdapterContexts.push.apply(componentAdapterContexts, _toConsumableArray(createComponentAdapterContexts({
                connectedComponents: connectedComponents,
                $w: $w,
                adapterApi: adapterApi,
                getFieldType: getFieldTypeFunc,
                ignoreItemsInRepeater: !isScoped,
                dependencies: dependencies
              })));

              if (!isScoped) {
                detailsRepeatersAdapterContexts = createDetailsRepeatersAdapterContexts(connectedComponents, getFieldTypeFunc, dependencies);

                componentAdapterContexts.push.apply(componentAdapterContexts, _toConsumableArray(detailsRepeatersAdapterContexts));
              }

              registerExecutors(adapterApiExecutor(adapterApi, componentAdapterContexts));
              subscribe(rootSubscriber({ recordStore: recordStore }));

              services({
                $w: $w,
                getFieldType: getFieldTypeFunc,
                componentAdapterContexts: componentAdapterContexts,
                scopeFactory: scopeFactory
              });

              unsubscribeHandlers.push(addComponentDataToRaven(componentAdapterContexts, ravenProxy, uniqueId));

              unsubscribeHandlers.push(syncComponentsWithState(store, componentAdapterContexts, ravenProxy, uniqueId, recordStore));

              defaultRecord = getDefaultRecord(componentAdapterContexts);

              store.dispatch(recordActions.setDefaultRecord(defaultRecord));
              if (rootReducer.isWriteOnly(store.getState())) {
                store.dispatch(recordActions.initWriteOnly(isScoped));
              }

              return _context2.abrupt('return', store.dispatch(recordActions.initAdapters(hasPrefetchedData)).then(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return waitForAllChildScopesToBeReady(scopeStore);

                      case 2:
                        store.dispatch(configActions.setIsDatasetReady(true));
                        fireEvent('datasetReady');
                        if (false) {
                          console.verbose('wix-dataset ' + uniqueId + ' fired datasetReady event'); // eslint-disable-line no-console
                        }
                        fedopsLogger.interactionEnded('dataset/pageReady', { timeoutId: timeoutId });

                      case 6:
                      case 'end':
                        return _context.stop();
                    }
                  }
                }, _callee, _this);
              }))));

            case 27:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    return function (_x2) {
      return _ref9.apply(this, arguments);
    };
  }());

  var userCodeDatasetApi = datasetApi(true);
  var dynamicExports = function dynamicExports(scope /*, $w*/) {
    switch (scope.type) {
      case SCOPE_TYPES.COMPONENT:
        return userCodeDatasetApi.inScope(scope.compId, scope.additionalData.itemId);
      default:
        return userCodeDatasetApi;
    }
  };

  var dispose = function dispose() {
    componentAdapterContexts.splice(0);
    unsubscribeHandlers.forEach(function (h) {
      return h();
    });
  };

  return {
    pageReady: errorBoundaries.applicationCodeZone(pageReady),
    exports: dynamicExports,
    staticExports: userCodeDatasetApi,
    dispose: dispose
  };
};

var extractControllerAPI = function extractControllerAPI(_ref13) {
  var pageReady = _ref13.pageReady,
      exports = _ref13.exports;
  return {
    pageReady: pageReady,
    exports: exports
  };
};
var createDatasetController = function createDatasetController() {
  return extractControllerAPI(createDataset.apply(undefined, arguments));
};

var getDefaultRecord = function getDefaultRecord(componentAdapterContexts) {
  var inputComponentsProps = ['value', 'checked']; //todo: export to constant
  return Object.assign.apply(Object, [{}].concat(_toConsumableArray(componentAdapterContexts.filter(function (_ref14) {
    var component = _ref14.component;
    return component.type !== uploadButtonSdkType;
  }).map(function (_ref15) {
    var component = _ref15.component,
        properties = _ref15.connectionConfig.properties;
    return Object.assign.apply(Object, [{}].concat(_toConsumableArray(inputComponentsProps.map(function (propName) {
      return has_(properties, propName) ? _defineProperty({}, properties[propName].fieldName, component[propName]) : undefined;
    }))));
  }))));
};

var addComponentDataToRaven = function addComponentDataToRaven(componentAdapterContexts, ravenProxy, uniqueId) {
  var componentIdToRole = mapValues_(groupBy_(componentAdapterContexts, function (cac) {
    return cac.component.id;
  }), function (cacArray) {
    return cacArray.map(function (cac) {
      return cac.role;
    }).join();
  });

  return ravenProxy.addDataCallback(function () {
    return _defineProperty({}, uniqueId, {
      components: componentIdToRole
    });
  });
};

module.exports = createDatasetController;

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(266);




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? Object(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value)
    : Object(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);


/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(264);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(7)))

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(117);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);


/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);


/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(268);


/** Built-in value references. */
var getPrototype = Object(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = (getPrototype);


/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);


/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__ = __webpack_require__(272);
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = Object(__WEBPACK_IMPORTED_MODULE_0__ponyfill_js__["a" /* default */])(root);
/* harmony default export */ __webpack_exports__["a"] = (result);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(7), __webpack_require__(271)(module)))

/***/ }),
/* 271 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};


/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = combineReducers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_warning__ = __webpack_require__(118);




function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';

  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__["a" /* default */])(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  var unexpectedKeyCache = void 0;
  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError = void 0;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }
      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bindActionCreators;
function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(undefined, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = applyMiddleware;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__compose__ = __webpack_require__(119);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function (reducer, preloadedState, enhancer) {
      var store = createStore(reducer, preloadedState, enhancer);
      var _dispatch = store.dispatch;
      var chain = [];

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch(action) {
          return _dispatch(action);
        }
      };
      chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = __WEBPACK_IMPORTED_MODULE_0__compose__["a" /* default */].apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
function createThunkMiddleware(extraArgument) {
  return function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        if (typeof action === 'function') {
          return action(dispatch, getState, extraArgument);
        }

        return next(action);
      };
    };
  };
}

var thunk = createThunkMiddleware();
thunk.withExtraArgument = createThunkMiddleware;

exports['default'] = thunk;

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
  var services = {};

  var setterGetter = function setterGetter() {
    var newServices = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;

    if (newServices) {
      Object.assign(services, newServices);
    }

    return services;
  };

  setterGetter.clear = function () {
    return Object.keys(services).forEach(function (key) {
      return delete services[key];
    });
  };

  return setterGetter;
};

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
  var promiseMap = new Map();

  return function (func, queueKey) {
    if (!promiseMap.has(queueKey)) {
      promiseMap.set(queueKey, Promise.resolve());
    }

    var promise = promiseMap.get(queueKey).then(func).catch(function (err) {
      promiseMap.delete(queueKey);

      return Promise.reject(err);
    });

    promiseMap.set(queueKey, promise);

    return promise;
  };
};

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var omit_ = __webpack_require__(0).omit;

var id = function id(x) {
  return x;
};

module.exports = function (Raven) {
  var breadCrumbCallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : id;
  return function (store) {
    return function (next) {
      return function (action) {
        Raven.captureBreadcrumb(breadCrumbCallback({
          category: 'redux',
          message: action.type,
          data: omit_(action, 'type', 'record')
        }));

        return next(action);
      };
    };
  };
};

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var SCOPE_TYPES = {
  COMPONENT: 'COMPONENT_SCOPE',
  GLOBAL: 'GLOBAL_SCOPE'
};

module.exports.SCOPE_TYPES = SCOPE_TYPES;

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(282),
    isPromise = _require.isPromise;

var _require2 = __webpack_require__(122),
    sequence = _require2.sequence,
    try_ = _require2.try_;

var _require3 = __webpack_require__(123),
    fromError = _require3.fromError,
    fromSuccess = _require3.fromSuccess;

var createTransition = __webpack_require__(124);

var isCmd = function isCmd(_) {
  return _ != null && typeof _.isQueued === 'boolean' && typeof _.type === 'string';
};
var isImmediateCommand = function isImmediateCommand(_) {
  return isCmd(_) && !_.isQueued;
};
var isQueuedCommand = function isQueuedCommand(_) {
  return isCmd(_) && _.isQueued;
};

var registrar = function registrar(list) {
  return function (fn) {
    list.push(fn);
    return function () {
      var index = list.indexOf(fn);
      if (index >= 0) {
        list.splice(index, 1);
      }
    };
  };
};

var createMiddleware = function createMiddleware(extraArgument) {
  var subscribers = [];
  var executors = {};
  var queuePromise = Promise.resolve();

  var middleware = function middleware(store) {
    return function (next) {
      return function (action) {
        var executeCommand = function executeCommand(cmd) {
          var result = try_(function () {
            return executors[cmd.type](cmd.command);
          });
          return result.fold(function (error) {
            var downstreamPromise = cmd.actionType ? store.dispatch(fromError(cmd.actionType, error)) : Promise.resolve();
            return [result, downstreamPromise];
          }, function (value) {
            if (isPromise(value)) {
              var downstreamPromise = value.then(function (resolvedValue) {
                return cmd.actionType ? store.dispatch(fromSuccess(cmd.actionType, resolvedValue)) : Promise.resolve();
              }, function (error) {
                if (cmd.actionType) {
                  store.dispatch(fromError(cmd.actionType, error)).catch(function () {});
                }
                throw error;
              });
              return [result, downstreamPromise];
            } else {
              var _downstreamPromise = cmd.actionType ? store.dispatch(fromSuccess(cmd.actionType, value)) : Promise.resolve();
              return [result, _downstreamPromise];
            }
          });
        };

        var runImmediateCommands = function runImmediateCommands(commands) {
          var immediateCommands = commands.filter(isImmediateCommand);
          var promiseTuples = immediateCommands.map(executeCommand);
          promiseTuples.map(function (tuple) {
            return tuple[0];
          }).map(function (result) {
            return result.fold(function (error) {
              throw error;
            }, function (value) {
              return value;
            });
          });
          promiseTuples.map(function (tuple) {
            return tuple[1];
          }).map(function (downstreamPromise) {
            return downstreamPromise.catch(function () {});
          });
          return commands.filter(isQueuedCommand);
        };

        var executeQueuedCommands = function executeQueuedCommands(resolve, reject) {
          return function (commands) {
            if (commands.length > 0) {
              var promiseTuples = commands.filter(isQueuedCommand).map(executeCommand);
              Promise.all(promiseTuples.map(function (tuple) {
                return tuple[1];
              })).then(function () {
                return resolve();
              }, reject);

              return Promise.all(promiseTuples.map(function (tuple) {
                return tuple[0];
              }).map(function (result) {
                return result.fold(function (error) {
                  return Promise.reject(error);
                }, function (value) {
                  return value;
                });
              })).catch(reject);
            } else {
              resolve();
              return Promise.resolve();
            }
          };
        };

        var scheduleExecution = function scheduleExecution() {
          var trigger = undefined;
          var gate = new Promise(function (resolve) {
            return trigger = resolve;
          });
          var promise = new Promise(function (resolve, reject) {
            queuePromise = queuePromise.then(function () {
              return gate;
            }).then(executeQueuedCommands(resolve, reject), reject).catch(reject);
          });

          return { promise: promise, trigger: trigger };
        };

        var queueAndRunCommands = function queueAndRunCommands(commands) {
          var _scheduleExecution = scheduleExecution(),
              promise = _scheduleExecution.promise,
              trigger = _scheduleExecution.trigger;

          return try_(function () {
            return runImmediateCommands(commands);
          }).fold(function (e) {
            trigger([]);
            throw e;
          }, function (commands) {
            trigger(commands);
            return promise;
          });
        };

        var from = store.getState();
        var result = next(action);
        var to = store.getState();

        if (from !== to) {
          return sequence(subscribers.slice().map(function (subscriber) {
            return try_(function () {
              return subscriber(createTransition(from, to), extraArgument);
            });
          })).fold(function (e) {
            throw e;
          }, function (commands) {
            return queueAndRunCommands(commands.filter(isCmd));
          });
        }

        return Promise.resolve(result);
      };
    };
  };

  var subscribe = registrar(subscribers);

  var registerExecutors = function registerExecutors() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    args.forEach(function (executor) {
      return executors[executor.type] = executor.execute;
    });
  };

  return {
    middleware: middleware,
    registerExecutors: registerExecutors,
    subscribe: subscribe
  };
};

module.exports = createMiddleware;

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isPromise = function isPromise(maybePromise) {
  return maybePromise != null && typeof maybePromise.then === 'function';
};

module.exports.isPromise = isPromise;

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(284),
    flatten = _require.flatten;

var createTransition = __webpack_require__(124);

var combineSubscribers = function combineSubscribers(subscriberMap) {
  return function (transition, extraArgument) {
    return flatten(Object.keys(subscriberMap).map(function (key) {
      return transition.from[key] !== transition.to[key] && subscriberMap[key] ? [].concat(subscriberMap[key](createTransition(transition.from[key], transition.to[key]), extraArgument)) : [];
    }));
  };
};

module.exports = combineSubscribers;

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var flatten = function flatten(array) {
  return array.reduce(function (acc, val) {
    return acc.concat(val);
  }, []);
};

module.exports.flatten = flatten;

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var create = function create(type, isQueued, command, actionType) {
  return Object.assign({}, { type: type, isQueued: isQueued, command: command, actionType: actionType });
};

var createImmediateCmd = function createImmediateCmd(type, command, actionType) {
  return create(type, false, command, actionType);
};

var createQueuedCmd = function createQueuedCmd(type, command, actionType) {
  return create(type, true, command, actionType);
};

module.exports.createImmediateCmd = createImmediateCmd;
module.exports.createQueuedCmd = createQueuedCmd;

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports.DEFAULT_PAGE_SIZE = 20;

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var get_ = __webpack_require__(0).get;
var actionReducerCreator = __webpack_require__(61);
var defaultDatasetConfiguration = __webpack_require__(125);
var readWriteModes = __webpack_require__(24);
var actionTypes = __webpack_require__(127);
var rootActions = __webpack_require__(43);

var initialState = defaultDatasetConfiguration;

module.exports = actionReducerCreator(initialState, new (function () {
  function _class() {
    _classCallCheck(this, _class);
  }

  _createClass(_class, [{
    key: rootActions.actionTypes.SET_CONTROLLER_CONFIG,
    value: function value(state, action) {
      return Object.assign({}, state, defaultDatasetConfiguration, { isDuringSave: false, isDatasetReady: false }, action.config);
    }
  }, {
    key: actionTypes.SET_FILTER,
    value: function value(state, action) {
      var filter = action.filter;


      return Object.assign({}, state, { filter: filter });
    }
  }, {
    key: actionTypes.SET_SORT,
    value: function value(state, action) {
      var sort = action.sort;


      return Object.assign({}, state, { sort: sort });
    }
  }, {
    key: actionTypes.SET_IS_DURING_SAVE,
    value: function value(state, action) {
      var isDuringSave = action.isDuringSave;


      return Object.assign({}, state, { isDuringSave: isDuringSave });
    }
  }, {
    key: actionTypes.SET_IS_DATASET_READY,
    value: function value(state, action) {
      var isDatasetReady = action.isDatasetReady;


      return Object.assign({}, state, { isDatasetReady: isDatasetReady });
    }
  }, {
    key: actionTypes.SET_FIXED_FILTER_ITEM,
    value: function value(state, action) {
      var fixedFilterItem = action.fixedFilterItem;


      return Object.assign({}, state, { fixedFilterItem: fixedFilterItem });
    }
  }]);

  return _class;
}())());

module.exports.getConfig = function (state) {
  return state;
};

module.exports.isWriteOnly = function (state) {
  return state.readWriteType === readWriteModes.WRITE;
};

module.exports.isReadOnly = function (state) {
  return state.readWriteType === readWriteModes.READ;
};

module.exports.getReadWriteMode = function (state) {
  return state.readWriteType;
};

module.exports.isDuringSave = function (state) {
  return state.isDuringSave;
};

module.exports.isDatasetReady = function (state) {
  return state.isDatasetReady;
};

module.exports.isDatasetConfigured = function (state) {
  return !!get_(state, 'collectionName');
};

module.exports.getPageSize = function (state) {
  return state.pageSize;
};

module.exports.getFixedFilterItem = function (state) {
  return state.fixedFilterItem;
};

module.exports.getCollectionName = function (state) {
  return state.collectionName;
};

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var maybe = __webpack_require__(1);
var every_ = __webpack_require__(0).every;
var values_ = __webpack_require__(0).values;
var actionReducerCreator = __webpack_require__(61);
var actionTypes = __webpack_require__(128);

var initialState = maybe.Nothing();

var DEPENDENCY_STATE = {
  UNKNOWN: 'UNKNOWN',
  PERFORMED_HANDSHAKE: 'PERFORMED_HANDSHAKE',
  READY: 'READY',
  MISSING: 'MISSING'
};

var changeDependenciesState = function changeDependenciesState(dependencies, state) {
  var initialDependencies = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  return dependencies.reduce(function (acc, dependencyId) {
    acc[dependencyId] = state;
    return acc;
  }, initialDependencies);
};

module.exports = actionReducerCreator(initialState, new (function () {
  function _class() {
    _classCallCheck(this, _class);
  }

  _createClass(_class, [{
    key: actionTypes.SET_DEPENDENCIES,
    value: function value(state, action) {
      return maybe.Just(changeDependenciesState(action.dependenciesIds, DEPENDENCY_STATE.UNKNOWN));
    }
  }, {
    key: actionTypes.RESOLVE_DEPENDENCIES,
    value: function value(state, action) {
      return state.map(function (dependencyMap) {
        return changeDependenciesState(action.dependenciesIds, DEPENDENCY_STATE.READY, dependencyMap);
      });
    }
  }, {
    key: actionTypes.PERFORM_HANDSHAKES,
    value: function value(state, action) {
      return state.map(function (dependencyMap) {
        return changeDependenciesState(action.dependenciesIds, DEPENDENCY_STATE.PERFORMED_HANDSHAKE, dependencyMap);
      });
    }
  }, {
    key: actionTypes.RESOLVE_MISSING_DEPENDENCIES,
    value: function value(state) {
      return state.map(function (dependencyMap) {
        return Object.keys(dependencyMap).reduce(function (acc, dependencyId) {
          acc[dependencyId] = acc[dependencyId] === DEPENDENCY_STATE.UNKNOWN ? DEPENDENCY_STATE.MISSING : acc[dependencyId];
          return acc;
        }, dependencyMap);
      });
    }
  }]);

  return _class;
}())());

module.exports.areDependenciesResolved = function (state) {
  return state.map(function (dependencyMap) {
    return every_(values_(dependencyMap), function (depState) {
      return depState === DEPENDENCY_STATE.MISSING || depState === DEPENDENCY_STATE.READY;
    });
  }).getOrElse(false);
};

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var actionReducerCreator = __webpack_require__(61);
var actionTypes = __webpack_require__(129);

module.exports = actionReducerCreator([], new (function () {
  function _class() {
    _classCallCheck(this, _class);
  }

  _createClass(_class, [{
    key: actionTypes.SET_CONNECTED_COMPONENTS,
    value: function value(state, action) {
      return action.connectedComponents;
    }
  }]);

  return _class;
}())());

module.exports.getConnectedComponents = function (state) {
  return state;
};

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var union = __webpack_require__(8);
var deriveMethods = __webpack_require__(131);

function ToJSON(variant) {
  var tag = variant.tag,
      type = variant.type;

  variant.prototype.toJSON = function () {
    var _this = this;

    var json = { tag: type + ':' + tag };
    Object.keys(this).forEach(function (key) {
      var value = _this[key];
      if (value && typeof value.toJSON === 'function') {
        json[key] = value.toJSON();
      } else {
        json[key] = value;
      }
    });
    return json;
  };
}

var DynamicPageUrlLoadState = union('DynamicPageUrlLoadState', {
  Empty: function Empty() {},
  Loading: function Loading() {},

  Loaded: function Loaded(url) {
    if (!url) {
      throw new Error('url must exist');
    }

    return { url: url };
  }
}).derive(ToJSON);

deriveMethods(DynamicPageUrlLoadState, {
  hasUrl: {
    Empty: function Empty() {
      return false;
    },
    Loading: function Loading() {
      return false;
    },
    Loaded: function Loaded() {
      return true;
    }
  },
  shouldLoadUrl: {
    Empty: function Empty() {
      return false;
    },
    Loading: function Loading() {
      return true;
    },
    Loaded: function Loaded() {
      return false;
    }
  }
});

DynamicPageUrlLoadState.fromUrl = function (url) {
  return url ? DynamicPageUrlLoadState.Loaded(url) : DynamicPageUrlLoadState.Empty();
};

module.exports = DynamicPageUrlLoadState;

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (adapterApi) {
  adapterApi().bindToComponent();
  return Promise.all(adapterApi().recordSetLoaded());
};

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var actionTypes = __webpack_require__(62);

var initialize = function initialize(connections) {
  return {
    type: actionTypes.INITIALIZE,
    connections: connections
  };
};

var setNextDynamicPageUrl = function setNextDynamicPageUrl(url) {
  return {
    type: actionTypes.NEXT_DYNAMIC_PAGE_URL_RESULT,
    url: url
  };
};

var setPreviousDynamicPageUrl = function setPreviousDynamicPageUrl(url) {
  return {
    type: actionTypes.PREVIOUS_DYNAMIC_PAGE_URL_RESULT,
    url: url
  };
};

module.exports.initialize = initialize;
module.exports.setNextDynamicPageUrl = setNextDynamicPageUrl;
module.exports.setPreviousDynamicPageUrl = setPreviousDynamicPageUrl;

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  GET_RECORD_BY_INDEX: 'GET_RECORD_BY_INDEX',
  SET_FIELDS_IN_CURRENT_RECORD: 'SET_FIELDS_IN_CURRENT_RECORD',
  REVERT_CHANGES: 'REVERT_CHANGES',
  CALL_BEFORE_SAVE_HOOKS: 'CALL_BEFORE_SAVE_HOOKS',
  CHECK_DRAFT: 'CHECK_DRAFT',
  SAVE_RECORD: 'SAVE_RECORD',
  REMOVE_RECORD: 'REMOVE_RECORD',
  NEW_RECORD: 'NEW_RECORD'
};

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var cloneDeep_ = __webpack_require__(0).cloneDeep;

var defaultAdapter = __webpack_require__(295);
var gridAdapter = __webpack_require__(297);
var dropdownOptionsAdapter = __webpack_require__(298);
var galleryAdapter = __webpack_require__(299);
var uploadButtonAdapter = __webpack_require__(300);
var nullAdapter = __webpack_require__(301);
var connectedRepeaterAdapter = __webpack_require__(302);
var detailsRepeaterAdapter = __webpack_require__(303);
var paginationAdapter = __webpack_require__(304);
var queryResults = __webpack_require__(26);

var _require = __webpack_require__(25),
    _setCurrentIndex = _require.setCurrentIndex,
    updateFields = _require.updateFields,
    _refresh = _require.refresh,
    fetchCurrentPage = _require.fetchCurrentPage,
    doFetch = _require.doFetch;

var _require2 = __webpack_require__(2),
    selectCurrentRecordIndex = _require2.selectCurrentRecordIndex;

var _require3 = __webpack_require__(44),
    GRID = _require3.GRID,
    DROPDOWN_OPTIONS = _require3.DROPDOWN_OPTIONS,
    GALLERY = _require3.GALLERY,
    UPLOAD_BUTTON = _require3.UPLOAD_BUTTON,
    DETAILS_DATASET = _require3.DETAILS_DATASET,
    REPEATER = _require3.REPEATER,
    PAGINATION = _require3.PAGINATION,
    DETAILS_REPEATER = _require3.DETAILS_REPEATER;

module.exports = function (_ref) {
  var _rolesToApis;

  var adapterParams = _ref.adapterParams,
      dispatch = _ref.dispatch,
      recordStore = _ref.recordStore,
      componentAdapterContexts = _ref.componentAdapterContexts;

  var rolesToApis = (_rolesToApis = {
    default: defaultAdapter(adapterParams)
  }, _defineProperty(_rolesToApis, GRID, gridAdapter(adapterParams)), _defineProperty(_rolesToApis, DROPDOWN_OPTIONS, dropdownOptionsAdapter(adapterParams)), _defineProperty(_rolesToApis, GALLERY, galleryAdapter(adapterParams)), _defineProperty(_rolesToApis, UPLOAD_BUTTON, uploadButtonAdapter(adapterParams)), _defineProperty(_rolesToApis, DETAILS_DATASET, nullAdapter(adapterParams)), _defineProperty(_rolesToApis, REPEATER, connectedRepeaterAdapter(adapterParams)), _defineProperty(_rolesToApis, PAGINATION, paginationAdapter(adapterParams)), _defineProperty(_rolesToApis, DETAILS_REPEATER, detailsRepeaterAdapter(adapterParams)), _rolesToApis);
  var apiOf = function apiOf(_ref2) {
    var role = _ref2.role;
    return rolesToApis[role] || rolesToApis.default;
  };

  var actions = {
    fetchRecordById: function fetchRecordById(recordId, byRefField) {
      return recordStore(byRefField).chain(function (service) {
        return service.getRecordById(recordId);
      });
    },

    fetchAll: function fetchAll(byRefField) {
      return doFetch(recordStore, 0, 1000, byRefField);
    },

    fetchCurrentItems: function fetchCurrentItems(state) {
      return fetchCurrentPage(recordStore, state).catch(function () {
        return queryResults.Empty().get();
      });
    },

    fetchOne: function fetchOne() {
      return doFetch(recordStore, 0, 1);
    },

    fetch: function fetch() {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return doFetch.apply(undefined, [recordStore].concat(args));
    },

    getInitialData: function getInitialData() {
      return recordStore().matchWith({
        Nothing: function Nothing() {
          return queryResults.Empty();
        },
        Just: function Just(_ref3) {
          var service = _ref3.value;
          return service.getSeedRecords();
        }
      });
    },

    setCurrentIndex: function setCurrentIndex() {
      return dispatch(_setCurrentIndex.apply(undefined, arguments));
    },

    setFieldInCurrentRecordAndSynchronize: function setFieldInCurrentRecordAndSynchronize(field, value, componentIdToExcludeFromUpdatingComponentsBasedOnRecord) {
      return dispatch(updateFields(_defineProperty({}, field, cloneDeep_(value)), componentIdToExcludeFromUpdatingComponentsBasedOnRecord));
    },

    refresh: function refresh() {
      return dispatch(_refresh());
    },

    isCurrentRecordNew: function isCurrentRecordNew(state) {
      return recordStore().matchWith({
        Nothing: function Nothing() {
          return false;
        },
        Just: function Just(_ref4) {
          var service = _ref4.value;
          return service.isNewRecord(selectCurrentRecordIndex(state));
        }
      });
    },

    isCurrentRecordPristine: function isCurrentRecordPristine(state) {
      return recordStore().matchWith({
        Nothing: function Nothing() {
          return false;
        },
        Just: function Just(_ref5) {
          var service = _ref5.value;
          return service.isPristine(selectCurrentRecordIndex(state));
        }
      });
    }
  };

  var api = {
    isValidContext: function isValidContext(componentAdapterContext) {
      return apiOf(componentAdapterContext).isValidContext(componentAdapterContext);
    },

    bindToComponent: function bindToComponent() {
      return componentAdapterContexts.map(function (componentAdapterContext) {
        return apiOf(componentAdapterContext).bindToComponent(componentAdapterContext, actions, api);
      });
    },

    currentRecordModified: function currentRecordModified() {
      var updatedFields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var compIdToFilter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      return componentAdapterContexts.filter(function (context) {
        return !compIdToFilter || context.component.uniqueId !== compIdToFilter;
      }).map(function (componentAdapterContext) {
        return apiOf(componentAdapterContext).currentRecordModified(componentAdapterContext, actions, updatedFields, api);
      });
    },

    recordSetLoaded: function recordSetLoaded() {
      return componentAdapterContexts.map(function (componentAdapterContext) {
        return apiOf(componentAdapterContext).recordSetLoaded(componentAdapterContext, actions, api);
      });
    },

    currentViewChanged: function currentViewChanged() {
      return componentAdapterContexts.map(function (componentAdapterContext) {
        return apiOf(componentAdapterContext).currentViewChanged(componentAdapterContext, actions, api);
      });
    },

    currentIndexChanged: function currentIndexChanged() {
      return componentAdapterContexts.map(function (componentAdapterContext) {
        return apiOf(componentAdapterContext).currentIndexChanged(componentAdapterContext, actions, api);
      });
    }
  };

  return api;
};

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var forEach_ = __webpack_require__(0).forEach;
var includes_ = __webpack_require__(0).includes;
var unescape_ = __webpack_require__(0).unescape;
var maybe = __webpack_require__(1);
var result = __webpack_require__(18);

var _require = __webpack_require__(2),
    selectCurrentRecord = _require.selectCurrentRecord;

var isInputComponent = __webpack_require__(64);
var convertValueToString = __webpack_require__(65);
var getFieldValue = __webpack_require__(45);
var values_ = __webpack_require__(0).values;
var isEmpty_ = __webpack_require__(0).isEmpty;
var get_ = __webpack_require__(0).get;
var set_ = __webpack_require__(0).set;

var _require2 = __webpack_require__(136),
    FIELD_TYPES = _require2.FIELD_TYPES;

var addComponentEventListener = __webpack_require__(15);

var _require3 = __webpack_require__(2),
    selectNextDynamicPageUrl = _require3.selectNextDynamicPageUrl,
    selectPreviousDynamicPageUrl = _require3.selectPreviousDynamicPageUrl;

var _require4 = __webpack_require__(66),
    isFieldFromReferencedCollection = _require4.isFieldFromReferencedCollection,
    getReferenceFieldName = _require4.getReferenceFieldName;

module.exports = function (_ref) {
  var getState = _ref.getState,
      datasetApi = _ref.datasetApi,
      wixSdk = _ref.wixSdk,
      errorReporter = _ref.errorReporter,
      platformUtilities = _ref.platformUtilities,
      register = _ref.eventListeners.register,
      getFieldType = _ref.getFieldType,
      errorBoundaries = _ref.errorBoundaries;

  var setFieldOnComponentChange = function setFieldOnComponentChange(component, properties, actions) {
    var getValue = function getValue(fieldName, value) {
      if (getFieldType(fieldName) === 'reference') {
        return result.try(function () {
          return JSON.parse(value);
        }).matchWith({
          Error: function Error() {
            return value;
          },
          Ok: function Ok(_ref2) {
            var _ref2$value = _ref2.value,
                id = _ref2$value.id,
                field = _ref2$value.field;

            var referencedRecord = actions.fetchRecordById(id, field);
            return referencedRecord.getOrElse(id);
          }
        });
      }
      return value;
    };

    addComponentEventListener(component, 'onChange', function (event) {
      var propName = properties.checked ? 'checked' : 'value';
      var fieldName = properties[propName].fieldName;
      var value = getValue(fieldName, event.target[propName]);

      actions.setFieldInCurrentRecordAndSynchronize(fieldName, value, component.uniqueId);
    }, errorBoundaries);
  };

  var getNavigateUrl = function getNavigateUrl(navigate, record) {
    if (navigate.fieldName) {
      return record[navigate.fieldName];
    }

    if (navigate.linkObject) {
      return platformUtilities.links.toUrl(navigate.linkObject);
    }
  };

  var navigateToDynamicPage = function navigateToDynamicPage(dynamicPageUrlState) {
    return dynamicPageUrlState.matchWith({
      Empty: function Empty() {},
      Loading: function Loading() {},
      Loaded: function Loaded(_ref3) {
        var url = _ref3.url;

        wixSdk.location.to(url);
      }
    });
  };

  var dispatchActionOnComponentEvent = function dispatchActionOnComponentEvent(component, eventName, action, postAction) {
    component[eventName](_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var record, url;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;

              if (!(action === 'nextDynamicPage')) {
                _context.next = 4;
                break;
              }

              navigateToDynamicPage(selectNextDynamicPageUrl(getState()));
              return _context.abrupt('return');

            case 4:
              if (!(action === 'previousDynamicPage')) {
                _context.next = 7;
                break;
              }

              navigateToDynamicPage(selectPreviousDynamicPageUrl(getState()));
              return _context.abrupt('return');

            case 7:
              _context.next = 9;
              return Promise.resolve(datasetApi[action]());

            case 9:
              record = _context.sent;

              if (postAction && postAction.navigate) {
                url = getNavigateUrl(postAction.navigate, record);

                wixSdk.location.to(url);
              }
              _context.next = 16;
              break;

            case 13:
              _context.prev = 13;
              _context.t0 = _context['catch'](0);

              errorReporter(action + ' operation failed:', _context.t0);

            case 16:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this, [[0, 13]]);
    })));
  };

  var setValueToComponent = function setValueToComponent(component, propPath, newValue, fieldType) {
    var oldValue = get_(component, propPath);

    if (isInputComponent(component)) {
      set_(component, propPath, newValue);
      //set_ doesn't work if oldValue and newValue are the same.
      //Input components have setter for value(checked, etc) which updates validityIndictor.
      //this is why we update it manually here.
      if (oldValue === newValue) {
        component.updateValidityIndication();
      }
      return;
    }
    set_(component, propPath, convertValueToString(newValue));
    if (fieldType === FIELD_TYPES.URL) {
      component.text = '<a href=' + component.text + ' target="_blank" style="text-decoration: underline">' + component.text + '</a>';
      var compHTML = component.html;
      component.text = '';
      component.html = unescape_(compHTML);
      return;
    }
  };

  var updateComponentFromCurrentRecord = function updateComponentFromCurrentRecord(_ref5, actions) {
    var properties = _ref5.connectionConfig.properties,
        component = _ref5.component;
    var updatedFields = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

    var data = maybe.fromNullable(selectCurrentRecord(getState()));
    data.matchWith({
      Nothing: function Nothing() {},
      Just: function Just(_ref6) {
        var record = _ref6.value;

        forEach_(properties, function (_ref7, propPath) {
          var fieldName = _ref7.fieldName;

          try {
            if (updatedFields.length === 0 || includes_(updatedFields, isFieldFromReferencedCollection(fieldName) ? getReferenceFieldName(fieldName) : fieldName)) {
              setValueToComponent(component, propPath, getFieldValue(record, fieldName), getFieldType(fieldName));
            }
          } catch (e) {
            errorReporter('Failed setting ' + propPath + ':', e);
          }
        });
      }
    });
  };

  var syncValidityIndication = function syncValidityIndication(_ref8, actions) {
    var component = _ref8.component;

    var pristine = actions.isCurrentRecordPristine(getState());
    var newRecord = actions.isCurrentRecordNew(getState());
    var inputComponent = isInputComponent(component);
    if (pristine && newRecord && inputComponent) {
      component.resetValidityIndication();
    }
  };

  var sync = function sync(actions) {
    return function () {
      actions.refresh();
    };
  };

  var applyBehaviorToComponent = function applyBehaviorToComponent(behavior, component) {
    var ignoreNextIndexChange = false;
    switch (behavior) {
      case 'saveSuccessFeedback':
        register('beforeSave', function () {
          return component.hide();
        });
        register('afterSave', function () {
          component.show();
          ignoreNextIndexChange = true;
        });
        register('currentIndexChanged', function () {
          if (ignoreNextIndexChange) {
            ignoreNextIndexChange = false;
          } else {
            component.hide();
          }
        });
        register('itemValuesChanged', function () {
          return component.hide();
        });
        break;
      case 'saveFailureFeedback':
        register('beforeSave', function () {
          return component.hide();
        });
        register('currentIndexChanged', function () {
          return component.hide();
        });
        register('datasetError', function (operationName) {
          if (operationName === 'save') {
            component.show();
          }
        });
        break;
    }
  };

  var isBoundToInputProperty = function isBoundToInputProperty(properties) {
    return get_(properties, 'value') || get_(properties, 'checked');
  };

  return {
    isValidContext: function isValidContext(_ref9) {
      var connectionConfig = _ref9.connectionConfig;

      return values_(connectionConfig).find(function (configValue) {
        return !isEmpty_(configValue);
      });
    },
    bindToComponent: function bindToComponent(_ref10, actions) {
      var connectionConfig = _ref10.connectionConfig,
          component = _ref10.component;
      var properties = connectionConfig.properties,
          events = connectionConfig.events,
          filters = connectionConfig.filters,
          behaviors = connectionConfig.behaviors;


      if (isBoundToInputProperty(properties)) {
        setFieldOnComponentChange(component, properties, actions);
      }

      if (events) {
        forEach_(events, function (_ref11, eventName) {
          var action = _ref11.action,
              postAction = _ref11.postAction;

          dispatchActionOnComponentEvent(component, eventName, action, postAction);
        });
      }

      if (filters) {
        if (typeof component.onChange === 'function') {
          addComponentEventListener(component, 'onChange', sync(actions), errorBoundaries);
        }
      }

      if (behaviors) {
        forEach_(behaviors, function (_ref12) {
          var behavior = _ref12.type;

          applyBehaviorToComponent(behavior, component);
        });
      }
    },
    currentRecordModified: function currentRecordModified(componentAdapterContext, actions, updatedFields) {
      updateComponentFromCurrentRecord(componentAdapterContext, actions, updatedFields);
      syncValidityIndication(componentAdapterContext, actions);
    },
    recordSetLoaded: function recordSetLoaded(componentAdapterContext, actions) {
      updateComponentFromCurrentRecord(componentAdapterContext, actions);
      syncValidityIndication(componentAdapterContext, actions);

      var behaviors = componentAdapterContext.connectionConfig.behaviors;

      if (behaviors) {
        forEach_(behaviors, function (_ref13) {
          var behavior = _ref13.type;

          if (behavior === 'saveSuccessFeedback') {
            componentAdapterContext.component.hide();
          }
        });
      }
    },
    currentViewChanged: function currentViewChanged(componentAdapterContext, actions) {
      updateComponentFromCurrentRecord(componentAdapterContext, actions);
      syncValidityIndication(componentAdapterContext, actions);
    },
    currentIndexChanged: function currentIndexChanged(componentAdapterContext, actions) {
      updateComponentFromCurrentRecord(componentAdapterContext, actions);
      syncValidityIndication(componentAdapterContext, actions);
    }
  };
};

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(20),
    TextInput = _require.TextInput,
    TextBox = _require.TextBox,
    Checkbox = _require.Checkbox,
    DatePicker = _require.DatePicker,
    RadioButtonGroup = _require.RadioButtonGroup,
    Dropdown = _require.Dropdown,
    UploadButton = _require.UploadButton,
    ToggleSwitch = _require.ToggleSwitch,
    Slider = _require.Slider;

module.exports = [TextInput, TextBox, Checkbox, DatePicker, RadioButtonGroup, Dropdown, UploadButton, ToggleSwitch, Slider];

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var addComponentEventListener = __webpack_require__(15);

module.exports = function (_ref) {
  var datasetApi = _ref.datasetApi,
      getState = _ref.getState,
      errorBoundaries = _ref.errorBoundaries;

  var getRows = function getRows(fetch) {
    return function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(startRow, endRow /*, sorting, filter*/) {
        var _ref3, items, totalCount;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return fetch(startRow, endRow - startRow);

              case 2:
                _ref3 = _context.sent;
                items = _ref3.items;
                totalCount = _ref3.totalCount;
                return _context.abrupt('return', {
                  pageRows: items,
                  totalRowsCount: totalCount
                });

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      return function (_x, _x2) {
        return _ref2.apply(this, arguments);
      };
    }();
  };

  return {
    isValidContext: function isValidContext() {
      return true;
    },
    bindToComponent: function bindToComponent(_ref4, actions) {
      var grid = _ref4.component;

      // Synchronously set initial data for SEO rendering
      actions.getInitialData().chain(function (_ref5) {
        var items = _ref5.items;

        grid.rows = items;
      });

      grid.dataFetcher = getRows(actions.fetch);

      addComponentEventListener(grid, 'onCellSelect', function (_ref6) {
        var cellRowIndex = _ref6.cellRowIndex;

        datasetApi.setCurrentItemIndex(cellRowIndex);
      }, errorBoundaries);

      addComponentEventListener(grid, 'onRowSelect', function (_ref7) {
        var rowIndex = _ref7.rowIndex;

        datasetApi.setCurrentItemIndex(rowIndex);
      }, errorBoundaries);
    },
    currentRecordModified: function currentRecordModified(_ref8, actions, updatedFields) {
      var grid = _ref8.component;

      grid.refresh();
    },
    recordSetLoaded: function recordSetLoaded(_ref9, actions) {
      var grid = _ref9.component;

      grid.refresh();
    },
    currentViewChanged: function currentViewChanged(_ref10, actions) {
      var grid = _ref10.component;

      grid.refresh();
    },
    currentIndexChanged: function currentIndexChanged(_ref11, actions) {
      var grid = _ref11.component;
    }
  };
};

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var isEmpty_ = __webpack_require__(0).isEmpty;

var convertValueToString = __webpack_require__(65);
var getFieldValue = __webpack_require__(45);

module.exports = function (_ref) {
  var getFieldType = _ref.getFieldType,
      getSchema = _ref.getSchema,
      wixDataProxy = _ref.wixDataProxy;

  var createOption = function createOption(record, _ref2) {
    var value = _ref2.value;
    return {
      value: convertValueToString(getFieldValue(record, value.fieldName)),
      label: convertValueToString(getFieldValue(record, value.fieldName)) || ''
    };
  };

  var createOptionForReference = function createOptionForReference(record, displayField, fieldName) {
    return {
      value: JSON.stringify({ id: record._id, field: fieldName }),
      label: convertValueToString(record[displayField])
    };
  };

  var getDropdownOptions = function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(properties, actions) {
      var isReference, schema, refCollection, refSchema, displayField, _ref4, items, _ref5, _items;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              isReference = getFieldType(properties.value.fieldName) === 'reference';

              if (!isReference) {
                _context.next = 13;
                break;
              }

              schema = getSchema();
              refCollection = schema.fields[properties.value.fieldName].referencedCollection;
              refSchema = getSchema(refCollection);
              displayField = refSchema.displayField;
              _context.next = 8;
              return actions.fetchAll(properties.value.fieldName);

            case 8:
              _ref4 = _context.sent;
              items = _ref4.items;
              return _context.abrupt('return', items.map(function (record) {
                return createOptionForReference(record, displayField, properties.value.fieldName);
              }));

            case 13:
              _context.next = 15;
              return actions.fetchAll();

            case 15:
              _ref5 = _context.sent;
              _items = _ref5.items;
              return _context.abrupt('return', _items.map(function (record) {
                return createOption(record, properties);
              }));

            case 18:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, undefined);
    }));

    return function getDropdownOptions(_x, _x2) {
      return _ref3.apply(this, arguments);
    };
  }();

  var updateComponent = function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(_ref6, actions) {
      var properties = _ref6.connectionConfig.properties,
          dropdown = _ref6.component;
      var options;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if ('value' in properties) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt('return');

            case 2:
              _context2.next = 4;
              return getDropdownOptions(properties, actions);

            case 4:
              options = _context2.sent;

              dropdown.options = options;

            case 6:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, undefined);
    }));

    return function updateComponent(_x3, _x4) {
      return _ref7.apply(this, arguments);
    };
  }();

  return {
    isValidContext: function isValidContext(_ref8) {
      var properties = _ref8.connectionConfig.properties;

      return !isEmpty_(properties);
    },
    bindToComponent: function bindToComponent(_ref9, actions) {
      var dropdown = _ref9.component;
    },


    currentRecordModified: updateComponent,

    recordSetLoaded: updateComponent,

    currentViewChanged: function currentViewChanged(componentAdapterContext, actions) {},
    currentIndexChanged: function currentIndexChanged(_ref10, actions) {
      var dropdown = _ref10.component;
    }
  };
};

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var forEach_ = __webpack_require__(0).forEach;
var has_ = __webpack_require__(0).has;
var isEmpty_ = __webpack_require__(0).isEmpty;

var convertValueToString = __webpack_require__(65);

var getFieldValue = __webpack_require__(45);

var _require = __webpack_require__(2),
    selectCurrentRecord = _require.selectCurrentRecord,
    selectCurrentRecordIndex = _require.selectCurrentRecordIndex;

var addComponentEventListener = __webpack_require__(15);

module.exports = function (_ref) {
  var getState = _ref.getState,
      errorBoundaries = _ref.errorBoundaries;

  var copyRecordToImage = function copyRecordToImage(image, record, properties) {
    return forEach_(properties || [], function (_ref2, propName) {
      var fieldName = _ref2.fieldName;
      return image[propName] = convertValueToString(getFieldValue(record, fieldName));
    });
  };

  var setCurrentIndexOfGallery = function setCurrentIndexOfGallery(component) {
    try {
      if (component.galleryCapabilities['hasCurrentItem']) {
        component.currentIndex = selectCurrentRecordIndex(getState());
      }
    } catch (e) {
      // see comments in CLNT-7339, we will use a new API that will allow us to know if we can set the current index
    }
  };

  var refreshView = function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref3, actions) {
      var properties = _ref3.connectionConfig.properties,
          component = _ref3.component;

      var _ref5, records;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return actions.fetchAll();

            case 2:
              _ref5 = _context.sent;
              records = _ref5.items;


              component.items = records.map(function (record) {
                var image = {};
                copyRecordToImage(image, record, properties);
                return image;
              });

              setCurrentIndexOfGallery(component);

            case 6:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, undefined);
    }));

    return function refreshView(_x, _x2) {
      return _ref4.apply(this, arguments);
    };
  }();

  return {
    isValidContext: function isValidContext(_ref6) {
      var properties = _ref6.connectionConfig.properties;

      return !isEmpty_(properties);
    },
    bindToComponent: function bindToComponent(_ref7, actions) {
      var properties = _ref7.connectionConfig.properties,
          component = _ref7.component;

      if (has_(properties, 'link')) {
        //set gallery settings to "when clicked --> a link opens"
        component.clickAction = 'link';
      }

      if (component.galleryCapabilities['hasCurrentItem']) {
        addComponentEventListener(component, 'onCurrentItemChanged', function () {
          actions.setCurrentIndex(component.currentIndex);
        }, errorBoundaries);
      }
    },
    currentRecordModified: function currentRecordModified(_ref8, actions, updatedFields) {
      var properties = _ref8.connectionConfig.properties,
          component = _ref8.component;

      var record = selectCurrentRecord(getState());
      var currentIndex = selectCurrentRecordIndex(getState());

      var imagesToBeChanged = component.items || [];
      var imageToBeChanged = imagesToBeChanged[currentIndex];

      if (imageToBeChanged) {
        copyRecordToImage(imageToBeChanged, record, properties);
      }

      component.items = imagesToBeChanged;
      setCurrentIndexOfGallery(component);
    },


    recordSetLoaded: refreshView,

    currentViewChanged: refreshView,

    currentIndexChanged: function currentIndexChanged(_ref9, actions) {
      var component = _ref9.component;

      setCurrentIndexOfGallery(component);
    }
  };
};

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var get_ = __webpack_require__(0).get;
var isEmpty_ = __webpack_require__(0).isEmpty;
var includes_ = __webpack_require__(0).includes;
var values_ = __webpack_require__(0).values;
var addComponentEventListener = __webpack_require__(15);
var getFieldValue = __webpack_require__(45);

var _require = __webpack_require__(2),
    selectCurrentRecord = _require.selectCurrentRecord,
    isReadOnly = _require.isReadOnly;

var getValueFieldName = function getValueFieldName(connectionConfig) {
  return get_(connectionConfig, 'properties.value.fieldName');
};

module.exports = function (_ref) {
  var getState = _ref.getState,
      datasetApi = _ref.datasetApi,
      wixSdk = _ref.wixSdk,
      errorReporter = _ref.errorReporter,
      platformUtilities = _ref.platformUtilities,
      getFieldType = _ref.getFieldType,
      errorBoundaries = _ref.errorBoundaries;

  var modified = {};

  var resetComponent = function resetComponent(component) {
    if (component.reset) {
      component.reset();
    }
  };

  var syncValidityIndicationAndValue = function syncValidityIndicationAndValue(_ref2, actions) {
    var component = _ref2.component,
        connectionConfig = _ref2.connectionConfig;
    var valueFieldChanged = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    var record = selectCurrentRecord(getState());
    var fieldName = getValueFieldName(connectionConfig);

    var newRecord = actions.isCurrentRecordNew(getState());
    var valueIsInvalid = isEmpty_(getFieldValue(record, fieldName));
    var pristine = actions.isCurrentRecordPristine(getState());

    if (pristine || valueFieldChanged) {
      resetComponent(component);
    }

    if (valueIsInvalid && (!newRecord || valueFieldChanged)) {
      component.updateValidityIndication();
    }
  };

  return {
    isValidContext: function isValidContext(_ref3) {
      var connectionConfig = _ref3.connectionConfig;

      return values_(connectionConfig).find(function (configValue) {
        return !isEmpty_(configValue);
      });
    },
    bindToComponent: function bindToComponent(_ref4, actions) {
      var properties = _ref4.connectionConfig.properties,
          component = _ref4.component;

      if (isReadOnly(getState())) {
        return;
      }

      var connectedFieldName = properties.value.fieldName;

      addComponentEventListener(component, 'onChange', function () {
        modified[component.uniqueId] = true;
      }, errorBoundaries);

      datasetApi.onBeforeSave(function () {
        if (modified[component.uniqueId] && component.value.length) {
          return component.startUpload().then(function (uploadedFile) {
            modified[component.uniqueId] = false;

            actions.setFieldInCurrentRecordAndSynchronize(connectedFieldName, uploadedFile.url, component.uniqueId);
          }, function (e) {
            errorReporter('The ' + (get_(component, 'value[0].name') || 'unknown') + ' file failed to upload. Please try again later.');
            throw e;
          });
        }
      });

      switch (getFieldType(connectedFieldName)) {
        case 'image':
          component.fileType = 'Image';
          break;
        case 'document':
          component.fileType = 'Document';
          break;
      }
    },
    currentRecordModified: function currentRecordModified(_ref5, actions, updatedFields) {
      var component = _ref5.component,
          connectionConfig = _ref5.connectionConfig;

      var fieldName = getValueFieldName(connectionConfig);
      var valueFieldChanged = includes_(updatedFields, fieldName);
      if (valueFieldChanged) {
        modified[component.uniqueId] = false;
      }
      syncValidityIndicationAndValue({ component: component, connectionConfig: connectionConfig }, actions, valueFieldChanged);
    },
    recordSetLoaded: function recordSetLoaded(componentAdapterContext, actions) {
      syncValidityIndicationAndValue(componentAdapterContext, actions);
    },
    currentViewChanged: function currentViewChanged(componentAdapterContext, actions) {
      syncValidityIndicationAndValue(componentAdapterContext, actions);
    },
    currentIndexChanged: function currentIndexChanged(componentAdapterContext, actions) {
      syncValidityIndicationAndValue(componentAdapterContext, actions);
    }
  };
};

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
  return {
    isValidContext: function isValidContext() {
      return false;
    }
  };
};

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var addComponentEventListener = __webpack_require__(15);

var _require = __webpack_require__(2),
    selectCurrentRecord = _require.selectCurrentRecord;

module.exports = function (_ref) {
  var getState = _ref.getState,
      services = _ref.services,
      errorBoundaries = _ref.errorBoundaries;

  var itemReady = function itemReady(actions, api, component) {
    return function (scoped$w, itemData, index) {
      var scopeId = { componentId: component.uniqueId, itemId: itemData._id };

      var _services = services(),
          scopeStore = _services.scopeStore,
          scopeFactory = _services.scopeFactory;

      var scope = scopeFactory.createFixedItemScope(scopeId, itemData);
      scopeStore.setScope(scopeId, scope);
      scope.pageReady(scoped$w.scoped);
    };
  };

  var itemRemoved = function itemRemoved(component) {
    return function (itemData) {
      var scopeId = { componentId: component.uniqueId, itemId: itemData._id };
      services().scopeStore.removeScope(scopeId);
    };
  };

  var refreshView = function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref2, actions) {
      var properties = _ref2.connectionConfig.properties,
          component = _ref2.component;

      var _ref4, newItems;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return actions.fetchCurrentItems(getState());

            case 2:
              _ref4 = _context.sent;
              newItems = _ref4.items;


              component.data = newItems;

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, undefined);
    }));

    return function refreshView(_x, _x2) {
      return _ref3.apply(this, arguments);
    };
  }();

  return {
    isValidContext: function isValidContext(_ref5) {
      var connectionConfig = _ref5.connectionConfig;

      return true;
    },
    bindToComponent: function bindToComponent(_ref6, actions, api) {
      var _ref6$connectionConfi = _ref6.connectionConfig,
          properties = _ref6$connectionConfi.properties,
          events = _ref6$connectionConfi.events,
          filters = _ref6$connectionConfi.filters,
          component = _ref6.component;

      addComponentEventListener(component, 'onItemReady', itemReady(actions, api, component), errorBoundaries);
      addComponentEventListener(component, 'onItemRemoved', itemRemoved(component), errorBoundaries);
    },
    currentRecordModified: function currentRecordModified(_ref7, actions, updatedFields) {
      var component = _ref7.component;

      var updatedItem = selectCurrentRecord(getState());
      var existingItems = component.data || [];

      var newItems = existingItems.map(function (existingItem) {
        return existingItem._id === updatedItem._id ? updatedItem : existingItem;
      });
      component.data = newItems;
    },


    recordSetLoaded: refreshView,

    currentViewChanged: refreshView,

    currentIndexChanged: function currentIndexChanged(componentAdapterContext, actions, isNewRecord) {}
  };
};

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var addComponentEventListener = __webpack_require__(15);

module.exports = function (_ref) {
  var services = _ref.services,
      errorBoundaries = _ref.errorBoundaries;

  var itemReady = function itemReady(actions, api, component) {
    return function (scoped$w, itemData, index) {
      var scopeId = { componentId: component.uniqueId, itemId: itemData._id };
      var scope = services().scopeFactory.createDetailsScope(scopeId);
      services().scopeStore.setScope(scopeId, scope);
      scope.pageReady(scoped$w.scoped);
    };
  };

  var itemRemoved = function itemRemoved(component) {
    return function (itemData) {
      var scopeId = { componentId: component.uniqueId, itemId: itemData._id };
      services().scopeStore.removeScope(scopeId);
    };
  };

  return {
    isValidContext: function isValidContext(_ref2) {
      var connectionConfig = _ref2.connectionConfig;

      return true;
    },
    bindToComponent: function bindToComponent(_ref3, actions, api) {
      var _ref3$connectionConfi = _ref3.connectionConfig,
          properties = _ref3$connectionConfi.properties,
          events = _ref3$connectionConfi.events,
          filters = _ref3$connectionConfi.filters,
          component = _ref3.component;

      addComponentEventListener(component, 'onItemReady', itemReady(actions, api, component), errorBoundaries);
      addComponentEventListener(component, 'onItemRemoved', itemRemoved(component), errorBoundaries);
    },
    currentRecordModified: function currentRecordModified(_ref4, actions, updatedFields) {
      var component = _ref4.component;
    },
    recordSetLoaded: function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref5, actions) {
        var properties = _ref5.connectionConfig.properties,
            component = _ref5.component;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function recordSetLoaded(_x, _x2) {
        return _ref6.apply(this, arguments);
      }

      return recordSetLoaded;
    }(),
    currentViewChanged: function currentViewChanged(componentAdapterContext, actions) {},
    currentIndexChanged: function currentIndexChanged(componentAdapterContext, actions, isNewRecord) {}
  };
};

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var addComponentEventListener = __webpack_require__(15);
var getPage = __webpack_require__(2).getPaginationData;

var _require = __webpack_require__(2),
    getCurrentPage = _require.getCurrentPage;

module.exports = function (_ref) {
  var datasetApi = _ref.datasetApi,
      getState = _ref.getState,
      errorBoundaries = _ref.errorBoundaries;

  var beginningOfPage = function beginningOfPage(pageNumber, pageSize) {
    return pageSize * (pageNumber - 1);
  };

  var refreshView = function refreshView(_ref2) {
    var pagination = _ref2.component;

    var totalPages = datasetApi.getTotalPageCount();
    var currentPage = getCurrentPage(getState());
    pagination.totalPages = totalPages;
    pagination.currentPage = currentPage;
  };

  return {
    isValidContext: function isValidContext() {
      return true;
    },


    // Initial setting of values + binding the event handler
    bindToComponent: function bindToComponent(_ref3) {
      var component = _ref3.component;

      addComponentEventListener(component, 'onChange', function (event) {
        var requestedPage = event.target.currentPage;
        var page = getPage(getState());
        var totalPages = datasetApi.getTotalPageCount();

        if (requestedPage < 1) {
          datasetApi.setCurrentItemIndex(0);
        } else if (requestedPage > totalPages) {
          datasetApi.setCurrentItemIndex(beginningOfPage(totalPages, page.size));
        } else {
          datasetApi.setCurrentItemIndex(beginningOfPage(requestedPage, page.size));
        }
      }, errorBoundaries);
    },


    currentRecordModified: function currentRecordModified() {},

    // These are both important -> don't need to set handler again, but need to
    // re-set values
    recordSetLoaded: refreshView,

    currentViewChanged: refreshView,

    currentIndexChanged: function currentIndexChanged() {}
  };
};

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var some_ = __webpack_require__(0).some;
var values_ = __webpack_require__(0).values;
var omit_ = __webpack_require__(0).omit;
var get_ = __webpack_require__(0).get;
var isEmpty_ = __webpack_require__(0).isEmpty;
var isInputComponent = __webpack_require__(64);

var _require = __webpack_require__(20),
    uploadButtonSdkType = _require.UploadButton;

var isUploadButtonValid = function isUploadButtonValid(component, record, connectionConfig) {
  if (component.validity.valid) {
    return true;
  }

  var hasErrorOtherThanValueMissing = some_(values_(omit_(component.validity, ['valid', 'valueMissing'])), function (value) {
    return value;
  });
  if (hasErrorOtherThanValueMissing) {
    return false;
  }

  var fieldConnectedToValue = get_(connectionConfig, 'properties.value.fieldName');

  return !isEmpty_(record[fieldConnectedToValue]);
};

module.exports = function (_ref, currentRecord) {
  var component = _ref.component,
      connectionConfig = _ref.connectionConfig;

  if (!isInputComponent(component)) {
    return true;
  }

  if (component.type !== uploadButtonSdkType) {
    return component.validity.valid;
  }

  return isUploadButtonValid(component, currentRecord, connectionConfig);
};

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  BIND_TO_COMPONENT: 'BIND_TO_COMPONENT',
  CURRENT_RECORD_MODIFIED: 'CURRENT_RECORD_MODIFIED',
  RECORD_SET_LOADED: 'RECORD_SET_LOADED',
  CURRENT_VIEW_CHANGED: 'CURRENT_VIEW_CHANGED',
  CURRENT_INDEX_CHANGED: 'CURRENT_INDEX_CHANGED'
};

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  SHOULD_GET_NEXT_DYNAMIC_PAGE_URL: 'SHOULD_GET_NEXT_DYNAMIC_PAGE_URL',
  SHOULD_GET_PREVIOUS_DYNAMIC_PAGE_URL: 'SHOULD_GET_PREVIOUS_DYNAMIC_PAGE_URL'
};

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* global VERBOSE */


function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var cloneDeep_ = __webpack_require__(0).cloneDeep;
var mapValues_ = __webpack_require__(0).mapValues;
var identity_ = __webpack_require__(0).identity;
var flow_ = __webpack_require__(0).flow;
var partial_ = __webpack_require__(0).partial;
var noop_ = __webpack_require__(0).noop;

var datasetActions = __webpack_require__(43);
var routerDatasetApiCreator = __webpack_require__(309);
var recordActions = __webpack_require__(25);
var configActions = __webpack_require__(134);

var _require = __webpack_require__(135),
    performHandshake = _require.performHandshake;

var reducer = __webpack_require__(2);
var DatasetError = __webpack_require__(13);

var _require2 = __webpack_require__(24),
    READ = _require2.READ,
    WRITE = _require2.WRITE,
    READ_WRITE = _require2.READ_WRITE;

var breadcrumbWrapper = __webpack_require__(63);

var _require3 = __webpack_require__(139),
    assertDatasetLimitations = _require3.assertDatasetLimitations,
    assertDatasetReady = _require3.assertDatasetReady,
    assertHasCurrentItem = _require3.assertHasCurrentItem,
    assertValidIndex = _require3.assertValidIndex,
    assertValidNumberArgument = _require3.assertValidNumberArgument,
    assertValidCallback = _require3.assertValidCallback,
    assertValidFilter = _require3.assertValidFilter,
    assertValidSort = _require3.assertValidSort,
    assertScopeIsNotFixedItem = _require3.assertScopeIsNotFixedItem,
    assertValidPageIndex = _require3.assertValidPageIndex,
    assertValidNaturalNumber = _require3.assertValidNaturalNumber;

var _require4 = __webpack_require__(140),
    reportCallbackError = _require4.reportCallbackError;

var _require5 = __webpack_require__(310),
    verboseWrapper = _require5.verboseWrapper,
    verboseIfNeeded = _require5.verboseIfNeeded;

var datasetApiCreator = function datasetApiCreator(_ref) {
  var _ref$store = _ref.store,
      dispatch = _ref$store.dispatch,
      getState = _ref$store.getState,
      recordStore = _ref.recordStore,
      services = _ref.services,
      datasetId = _ref.datasetId,
      datasetType = _ref.datasetType,
      errorBoundaries = _ref.errorBoundaries,
      isForUser = _ref.isForUser,
      isFixedItem = _ref.isFixedItem;
  var Raven = services.Raven,
      _services$eventListen = services.eventListeners,
      fireEvent = _services$eventListen.fireEvent,
      register = _services$eventListen.register,
      handshakes = services.handshakes,
      scopeStore = services.scopeStore,
      errorReporter = services.errorReporter;


  var q = Promise.resolve();
  var queue = function queue(f) {
    return new Promise(function (resolve, reject) {
      q = q.then(function () {
        return Promise.resolve().then(f).then(resolve).catch(reject);
      });
    });
  };

  var createBreadcrumb = function createBreadcrumb(fnName, args) {
    return {
      category: 'datasetAPI',
      level: 'info',
      message: fnName + '-' + datasetId
    };
  };

  var _breadcrumbWrapper = breadcrumbWrapper(Raven, createBreadcrumb, function (value) {
    return undefined;
  } // we only want to trace user calls, no need for return value
  ),
      withBreadcrumbs = _breadcrumbWrapper.withBreadcrumbs;

  var getCurrentIndex = function getCurrentIndex() {
    return reducer.selectCurrentRecordIndex(getState());
  };
  var _getTotalCount = function _getTotalCount() {
    return recordStore().matchWith({
      Nothing: function Nothing() {
        return null;
      },
      Just: function Just(_ref2) {
        var service = _ref2.value;
        return service.getMatchingRecordCount();
      }
    });
  };

  var flushDraft = function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var updatedRecord;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;

              dispatch(configActions.setIsDuringSave(true));
              _context.next = 4;
              return dispatch(recordActions.flushDraft());

            case 4:
              // the save process must return the record as it was returned from wixData, ignoring any
              // changes made to it afterwards (e.g., after save callback). If there was no draft to flush,
              // it must return the current record.
              updatedRecord = reducer.selectLastSavedRecord(getState()) || reducer.selectCurrentRecord(getState());
              return _context.abrupt('return', cloneDeep_(updatedRecord));

            case 8:
              _context.prev = 8;
              _context.t0 = _context['catch'](0);

              fireEvent('datasetError', 'save', _context.t0);
              throw _context.t0;

            case 12:
              _context.prev = 12;

              dispatch(configActions.setIsDuringSave(false));
              return _context.finish(12);

            case 15:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this, [[0, 8, 12, 15]]);
    }));

    return function flushDraft() {
      return _ref3.apply(this, arguments);
    };
  }();

  /**
   * @namespace wix-dataset
   * @summary A dataset connects page elements to a set of items in a data collection.
   * @description
   *  A dataset serves as an intermediary between page elements, such as input
   *  elements and buttons, and the data in a collection. The dataset
   *  controls which collection is available to be used by page elements, what
   *  those elements can do with the collection data (display, add, modify),
   *  which item is currently active and whether the data is filtered or sorted.
   *
   *  A dataset can be in one of three modes, which are set in Dataset Settings
   *  panel in the Editor. The dataset's mode cannot be changed programmatically.
   *
   *    + **Read &amp; Write**: Display and modify data.
   *    + **Read-only**: Display data.
   *    + **Write-only**: Add new data.
   *
   *
   *  ![Dataset modes](images/dataset_modes.png "Dataset modes")
   *
   *  Another way to work with collection data and page elements is to use the
   *  [Data API](wix-data.html). The Data API lets you work directly with your
   *  collections. However, you'll need to write code to read from and write to
   *  your page elements. Using the Dataset API allows you to take advantage of
   *  the [data binding](https://support.wix.com/en/article/data-binding) that
   *  can be set up in the Editor's connect panels.
   *
   *  The wix-dataset API can only be used in your site’s front-end code.
   *
   *  You do not need to import `wix-dataset`.
   *
   *  <h3 id="data-paging">Dataset Pages</h3>
   *  Datasets retrieve information from your collections in chunks of items.
   *  Each of these chunks is called a page.
   *
   *  A dataset's page size determines how many items are initially displayed
   *  in repeaters that are connected to it. Elements that have their own
   *  settings for how many items are shown at once, such as tables and
   *  galleries, are not affected by the dataset's page size.
   *
   *  Elements that display data from the dataset's current item, such as images
   *  and text elements, are affected when you change the current dataset page
   *  because the dataset's current item also changes.
   *
   *  You set the page size of a dataset:
   *  + In the Editor using the **Number of items to display** setting in the **Dataset Settings** panel.
   *  + In code using the [`setPageSize()`](#setPageSize) function.
   *
   *
   */

  return function (isForUser) {
    var userCodeZone = isForUser ? errorBoundaries.userCodeZone : identity_;

    var baseApi = {
      isIdle: function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return queue(noop_);

                case 2:
                  return _context2.abrupt('return', _context2.sent);

                case 3:
                case 'end':
                  return _context2.stop();
              }
            }
          }, _callee2, this);
        }));

        function isIdle() {
          return _ref4.apply(this, arguments);
        }

        return isIdle;
      }(),


      /**
       * @callback BeforeSaveHandler
       * @summary A before save event handler.
       * @returns {Promise}
       * @fulfill {external:Boolean} Indication whether to continue with save.
       * @memberof wix-dataset
       **/

      /**
       * @function onBeforeSave
       * @syntax
       * function onBeforeSave(handler: BeforeSaveHandler): void
       * callback BeforeSaveHandler(): Promise&lt;boolean&gt;
       * @summary Adds an event handler that runs just before a save.
       * @param {wix-dataset.BeforeSaveHandler} handler The before save event handler.
       * @description
       *  The `onBeforeSave()` function allows you to optionally perform actions
       *  right before a [`save()`](#save) operation. When you call `save()`, the
       *  callback is run before the save operation. If the callback function
       *  returns either `false`, a rejected Promise, or it throws an error, the
       *  save operation is canceled.
       *
       *  Calling `onBeforeSave()` on a read-only dataset causes an error.
       * @snippet [onBeforeSave_continue.es6=Register a callback to run before a save and continue with the save]
       * @snippet [onBeforeSave_cancel.es6=Register a callback to run before a save and cancel the save]
       * @memberof wix-dataset
       * @instance
       */
      onBeforeSave: function onBeforeSave(cb) {
        assertValidCallback('onBeforeSave', cb);
        assertDatasetLimitations(getState, 'onBeforeSave', [WRITE, READ_WRITE], false);
        return register('beforeSave', verboseIfNeeded(userCodeZone(cb), 'beforeSave callback'));
      },

      /**
       * @callback AfterSaveHandler
       * @summary An after save event handler.
       * @param {external:Object} itemBeforeSave The item before being saved.
       * @param {external:Object} itemAfterSave The item after being saved.
       * @returns {void}
       * @memberof wix-dataset
       **/

      /**
       * @function onAfterSave
       * @syntax
       * function onAfterSave(handler: AfterSaveHandler): void
       * callback AfterSaveHandler(itemBeforeSave: Object, itemAfterSave: Object): void
       * @summary Adds an event handler that runs just after a save.
       * @param {wix-dataset.AfterSaveHandler} handler The after save event handler.
       * @description
       *  The `onAfterSave()` function allows you to optionally perform actions
       *  right after a [`save()`](#save) operation. When you call `save()`, the
       *  callback is run after the save has successfully completed.
       *
       *  Calling `onAfterSave()` on a read-only dataset causes an error.
       * @snippet [onAfterSave.es6=Register a callback to run after a save]
       * @memberof wix-dataset
       * @instance
       */
      onAfterSave: function onAfterSave(cb) {
        assertValidCallback('onAfterSave', cb);
        assertDatasetLimitations(getState, 'onAfterSave', [WRITE, READ_WRITE], false);
        return register('afterSave', verboseIfNeeded(userCodeZone(cb), 'afterSave callback'));
      },

      /**
       * @function save
       * @memberof wix-dataset
       * @summary Saves the current item.
       * @syntax
       * function save(): Promise&lt;Object&gt;
       * @description
       *  The `save()` function returns a Promise that is resolved to the saved item
       *  when:
       *  + The current item is saved in the collection.
       *  + Any connected page elements have been updated with the current item’s new
       *    values (read &amp; write mode) or a new blank item (write-only mode).
       *
       *
       *  Calling `save()` on a read-only dataset causes the Promise to reject.
       *
       * @note
       *  A dataset needs to load its data before you call its `save()` function.
       *  Usually a dataset finishes loading a short time after the page it is on finishes
       *  loading. So if you call `save()` inside the page’s [`onReady()`]($w.html#onReady)
       *  event handler, the dataset might not be ready yet.
       *
       *  To call `save()` as soon as possible after a page loads, use the **dataset's**
       *  [`onReady()`](#onReady) function inside the **page’s** [`onReady()`]($w.html#onReady)
       *  event handler to ensure that both the page and the dataset have finished loading.
       * @snippet [save.es6=Save the current item]
       * @snippet [save_onReady.es6=Save the current item when the page loads]
       * @returns {Promise}
       * @fulfill {external:Object} The saved item.
       * @reject {String} An error message.
       * @see [revert( )](#revert)
       * @see [refresh( )](#refresh)
       * @instance
       */
      save: function () {
        var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
          var _this = this;

          return regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  assertDatasetLimitations(getState, 'save', [WRITE, READ_WRITE], false);
                  _context4.next = 3;
                  return queue(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                    var updatedRecord;
                    return regeneratorRuntime.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            _context3.next = 2;
                            return flushDraft();

                          case 2:
                            updatedRecord = _context3.sent;

                            if (!reducer.isWriteOnly(getState())) {
                              _context3.next = 6;
                              break;
                            }

                            _context3.next = 6;
                            return dispatch(recordActions.reInitWriteOnly());

                          case 6:
                            return _context3.abrupt('return', updatedRecord);

                          case 7:
                          case 'end':
                            return _context3.stop();
                        }
                      }
                    }, _callee3, _this);
                  })));

                case 3:
                  return _context4.abrupt('return', _context4.sent);

                case 4:
                case 'end':
                  return _context4.stop();
              }
            }
          }, _callee4, this);
        }));

        function save() {
          return _ref5.apply(this, arguments);
        }

        return save;
      }(),


      /**
       * @typedef wix-dataset~GetItemsResult
       * @summary An object used by the `getItems()` function that contains the items retrieved and the total number of items in the dataset that match its filter criteria
       * @property {external:Object[]} items List of items objects where key:value pairs are the field names and field values of the retrieved items, including all hidden fields.
       * @property {external:Number} totalCount The number of items in the dataset that match its filter criteria.
       * @property {external:Number} offset The index in the dataset of the first item in the items property.
       * @snippet [getItems.es6=Get items from the dataset]
       * @see [getItems( )](#getItems)
       */

      /**
       * @function getItems
       * @memberof wix-dataset
       * @syntax
       * function getItems(fromIndex: Number, numberOfItems: Number):
       *   Promise&lt;GetItemsResult&gt;
       * @summary Returns the selected items.
       * @description
       *  The `getItems()` function returns a Promise that is resolved to
       *  a [`GetItemsResult`](#GetItemsResult) object when the items have been
       *  retrieved.
       *
       *  Calling `getItems()` on a write-only dataset causes an error.
       *
       * @note
       *  A dataset needs to load its data before you call its `getItems()` function.
       *  Usually a dataset finishes loading a short time after the page it is on finishes
       *  loading. So if you call `getItems()` inside the page’s [`onReady()`]($w.html#onReady)
       *  event handler, the dataset might not be ready yet.
       *
       *  To call `getItems()` as soon as possible after a page loads, use the **dataset's**
       *  [`onReady()`](#onReady) function inside the **page’s** [`onReady()`]($w.html#onReady)
       *  event handler to ensure that both the page and the dataset have finished loading.
       * @param {external:Number} fromIndex The index of the first item to return.
       * @param {external:Number} numberOfItems The number of items to return.
       * @returns {Promise}
       * @fulfill {wix-dataset~GetItemsResult} The items retrieved and the total number of items in the dataset that match its filter criteria.
       * @reject {external:Error}  An error object.
       * @snippet [getItems.es6=Get items from the dataset]
       * @snippet [getItems_onReady.es6=Get items from the dataset when the page loads]
       * @see [getCurrentItem( )](#getCurrentItem)
       */
      getItems: function getItems(fromIndex, numberOfItems) {
        assertDatasetLimitations(getState, 'getItems', [READ, READ_WRITE], false);
        assertValidNumberArgument('fromIndex', fromIndex);
        assertValidNumberArgument('numberOfItems', numberOfItems);
        return recordActions.doFetch(recordStore, fromIndex, numberOfItems);
      },

      /**
       * @function getTotalCount
       * @memberof wix-dataset
       * @syntax
       * function getTotalCount(): Number
       * @summary Returns the number of items in the dataset that match its filter criteria.
       * @description
       *  Calling `getTotalCount()` on a write-only dataset causes an error.
       *
       * @note
       *  A dataset needs to load its data before you call its `getTotalCount()` function.
       *  Usually a dataset finishes loading a short time after the page it is on finishes
       *  loading. So if you call `getTotalCount()` inside the page’s [`onReady()`]($w.html#onReady)
       *  event handler, the dataset might not be ready yet.
       *
       *  To call `getTotalCount()` as soon as possible after a page loads, use the **dataset's**
       *  [`onReady()`](#onReady) function inside the **page’s** [`onReady()`]($w.html#onReady)
       *  event handler to ensure that both the page and the dataset have finished loading.
       * @snippet [getTotalCount.es6=Get the number of items in the dataset that match its filter criteria]
       * @snippet [getTotalCount_onReady.es6=Get the number of items in the dataset that match its filter criteria when the page loads]
       * @returns {external:Number}
       */
      getTotalCount: function getTotalCount() {
        assertDatasetLimitations(getState, 'getTotalCount', [READ, READ_WRITE], false);
        return _getTotalCount();
      },

      /**
       * @function getCurrentItem
       * @memberof wix-dataset
       * @summary Returns the current item.
       * @syntax
       * function getCurrentItem(): Object
       * @returns {external:Object} The current item, or null if there is no current item.
       * @description
       *  The `getCurrentItem()` function returns an object whose key:value pairs
       *  are the field names and field values of the current item, including all
       *  hidden fields. Fields that do not have a value are omitted from the
       *  returned object.
       *
       *  When called on a write-only or read &amp; write dataset,
       *  `getCurrentItem()` returns the unsaved state of the current item.
       *
       *  Returns `null` or `undefined` if the dataset:
       *  * Is filtered to not match any items in the collection.
       *  * Is empty.
       *  * Has not loaded yet.
       *
       *
       * @note
       *  A dataset needs to load its data before you call its `getCurrentItem()` function.
       *  Usually a dataset finishes loading a short time after the page it is on finishes
       *  loading. So if you call `getCurrentItem()` inside the page’s [`onReady()`]($w.html#onReady)
       *  event handler, the dataset might not be ready yet.
       *
       *  To call `getCurrentItem()` as soon as possible after a page loads, use the **dataset's**
       *  [`onReady()`](#onReady) function inside the **page’s** [`onReady()`]($w.html#onReady)
       *  event handler to ensure that both the page and the dataset have finished loading.
       *
       *  If the current item is changed from a non-dataset source, such as by
       *  selecting a row in a table connected to a dataset or clicking a button set
       *  to advance to the next item in a dataset, the dataset's current item is
       *  not updated immediately. Therefore, to get the dataset's new current item,
       *  call `getCurrentItem()` in the dataset's [`onCurrentIndexChanged()`](#onCurrentIndexChanged)
       *  event handler. Do not use the events of the non-dataset source, such as
       *  [`onRowSelect`]($w.Table.html#onRowSelect) or [`onClick`]($w.ClickableMixin.html#onClick),
       *  to call `getCurrentItem()` because they will fire before the dataset's
       *  current item is updated.
       * @snippet [getCurrentItem.es6=Get the dataset's current item]
       * @snippet [getCurrentItem_onReady.es6=Get the dataset's current item when the page loads]
       * @see [getCurrentItemIndex( )](#getCurrentItemIndex)
       * @see [setCurrentItemIndex( )](#setCurrentItemIndex)
       */
      getCurrentItem: function getCurrentItem() {
        assertDatasetLimitations(getState, 'getCurrentItem', [READ, WRITE, READ_WRITE]);
        var record = reducer.selectCurrentRecord(getState());
        if (!record) {
          return null;
        }
        return cloneDeep_(record);
      },

      /**
       * @function getCurrentItemIndex
       * @memberof wix-dataset
       * @summary Returns the current item's index.
       * @syntax
       * function getCurrentItemIndex(): Number
       * @returns {external:Number} The index of the current item, or null if there is no current item.
       * @description
       *  The `getCurrentItemIndex()` function returns the index of current item
       *  within the items of the dataset. The indicies of the items in a dataset
       *  are zero-based. For example, if the third item is the current item, then
       *  `getCurrentItemIndex()` returns `2`.
       *
       *  Calling `getCurrentItemIndex()` on a write-only dataset causes an error.
       *
       *  Returns `null` if one of the following is true if the dataset:
       *  * Is filtered to not match any items in the collection.
       *  * Is empty.
       *  * Has not loaded yet.
       *
       *
       * @note
       *  A dataset needs to load its data before you call its `getCurrentItemIndex()` function.
       *  Usually a dataset finishes loading a short time after the page it is on finishes
       *  loading. So if you call `getCurrentItemIndex()` inside the page’s [`onReady()`]($w.html#onReady)
       *  event handler, the dataset might not be ready yet.
       *
       *  To call `getCurrentItemIndex()` as soon as possible after a page loads, use the **dataset's**
       *  [`onReady()`](#onReady) function inside the **page’s** [`onReady()`]($w.html#onReady)
       *  event handler to ensure that both the page and the dataset have finished loading.
       *
       *  If the current item is changed from a non-dataset source, such as by
       *  selecting a row in a table connected to a dataset or clicking a button set
       *  to advance to the next item in a dataset, the dataset's current item is
       *  not updated immediately. Therefore, to get the dataset's new current item index,
       *  call `getCurrentItemIndex()` in the dataset's [`onCurrentIndexChanged()`](#onCurrentIndexChanged)
       *  event handler. Do not use the events of the non-dataset source, such as
       *  [`onRowSelect`]($w.Table.html#onRowSelect) or [`onClick`]($w.ClickableMixin.html#onClick),
       *  to call `getCurrentItemIndex()` because they will fire before the dataset's
       *  current item is updated.
       * @see [setCurrentItemIndex( )](#setCurrentItemIndex)
       * @see [getCurrentItem( )](#getCurrentItem)
       */
      getCurrentItemIndex: function getCurrentItemIndex() {
        assertDatasetLimitations(getState, 'getCurrentItemIndex', [READ, READ_WRITE]);
        var index = reducer.selectCurrentRecordIndex(getState());
        if (index === undefined) {
          return null;
        }
        return index;
      },

      /**
       * @function setCurrentItemIndex
       * @memberof wix-dataset
       * @summary Sets the current item by index.
       * @syntax
       * function setCurrentItemIndex(index: Number): Promise&lt;void&gt;
       * @description
       *  The `setCurrentItemIndex()` function returns a Promise that is resolved when:
       *  + The current item has been saved in the collection (if necessary).
       *  + The current item has been updated to be the item with the given index.
       *  + Any connected page elements have been updated with the new current item’s values.
       *
       *
       *  Calling `setCurrentItemIndex()` on a write-only dataset causes the
       *  Promise to reject.
       *
       * @note
       *  A dataset needs to load its data before you call its `setCurrentItemIndex()` function.
       *  Usually a dataset finishes loading a short time after the page it is on finishes
       *  loading. So if you call `setCurrentItemIndex()` inside the page’s [`onReady()`]($w.html#onReady)
       *  event handler, the dataset might not be ready yet.
       *
       *  To call `setCurrentItemIndex()` as soon as possible after a page loads, use the **dataset's**
       *  [`onReady()`](#onReady) function inside the **page’s** [`onReady()`]($w.html#onReady)
       *  event handler to ensure that both the page and the dataset have finished loading.
       *
       *  `setCurrentItemIndex()` saves the current item even if the requested item is same as the current item.
       * @param {external:Number} index The index of the item to set as the current item.
       * @returns {Promise}
       * @fulfill {void} When the item with the given index is set to the current item.
       * @reject {external:Error} Rejects if the item with the given index does not exist or it cannot be set to the current item.
       * @snippet [setCurrentItemIndex.es6=Set the dataset's current item]
       * @snippet [setCurrentItemIndex_onReady.es6=Set the dataset's current item when the page loads]
       * @see [getCurrentItemIndex( )](#getCurrentItemIndex)
       * @see [getCurrentItem( )](#getCurrentItem)
       */
      setCurrentItemIndex: function () {
        var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(index) {
          var _this2 = this;

          return regeneratorRuntime.wrap(function _callee6$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  assertScopeIsNotFixedItem(isFixedItem, 'setCurrentItemIndex');
                  assertDatasetLimitations(getState, 'setCurrentItemIndex', [READ, READ_WRITE], false);
                  assertValidIndex(index);

                  _context6.next = 5;
                  return new Promise(function (resolve) {
                    return api.onReady(resolve);
                  });

                case 5:
                  _context6.prev = 5;
                  _context6.next = 8;
                  return queue(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
                    return regeneratorRuntime.wrap(function _callee5$(_context5) {
                      while (1) {
                        switch (_context5.prev = _context5.next) {
                          case 0:
                            if (reducer.isReadOnly(getState())) {
                              _context5.next = 3;
                              break;
                            }

                            _context5.next = 3;
                            return flushDraft();

                          case 3:
                            _context5.next = 5;
                            return dispatch(recordActions.setCurrentIndex(index));

                          case 5:
                          case 'end':
                            return _context5.stop();
                        }
                      }
                    }, _callee5, _this2);
                  })));

                case 8:
                  _context6.next = 14;
                  break;

                case 10:
                  _context6.prev = 10;
                  _context6.t0 = _context6['catch'](5);

                  fireEvent('datasetError', 'setCurrentItemIndex', _context6.t0);
                  throw _context6.t0;

                case 14:
                case 'end':
                  return _context6.stop();
              }
            }
          }, _callee6, this, [[5, 10]]);
        }));

        function setCurrentItemIndex(_x) {
          return _ref7.apply(this, arguments);
        }

        return setCurrentItemIndex;
      }(),


      /**
       * @function setFieldValue
       * @memberof wix-dataset
       * @summary Updates the value of a field in the current item.
       * @syntax
       * function setFieldValue(fieldName: string, value: *): void
       * @param {external:String} fieldName The field name of the field to update.
       * @param {external:Object} value The new value.
       * @description
       *  The `setFieldValue` function sets the value of a field in the current item.
       *  Setting a field value fires an `onItemValuesChanged` event when the page
       *  elements connected to the field have been updated with the new value.
       *
       *  Setting the value of a field in a dataset item does not immediately set
       *  that value in the collection that the dataset is connected to. You still
       *  need to call the dataset `save()` function or any other function that
       *  performs a save to have the new value reflecting in the collection.
       *
       *  Calling `setFieldValue()` on a read-only dataset causes an error.
       *
       * @note
       *  A dataset needs to load its data before you call its `setFieldValue()` function.
       *  Usually a dataset finishes loading a short time after the page it is on finishes
       *  loading. So if you call `setFieldValue()` inside the page’s [`onReady()`]($w.html#onReady)
       *  event handler, the dataset might not be ready yet.
       *
       *  To call `setFieldValue()` as soon as possible after a page loads, use the **dataset's**
       *  [`onReady()`](#onReady) function inside the **page’s** [`onReady()`]($w.html#onReady)
       *  event handler to ensure that both the page and the dataset have finished loading.
       * @snippet [setFieldValue.es6=Set a field's value]
       * @snippet [setFieldValue_save.es6=Set a field's value and save the item to the connected collection]
       * @snippet [setFieldValue_onReady.es6=Set a field's value when the page loads]
       * @see [setFieldValues( )](#setFieldValues)
       */
      setFieldValue: function setFieldValue(fieldName, value) {
        assertDatasetReady(getState, 'setFieldValue');
        assertDatasetLimitations(getState, 'setFieldValue', [WRITE, READ_WRITE]);
        assertHasCurrentItem(getState);
        return dispatch(recordActions.updateFields(_defineProperty({}, fieldName, cloneDeep_(value))));
      },

      /**
       * @function setFieldValues
       * @memberof wix-dataset
       * @summary Updates the values of a set of fields in the current item.
       * @syntax
       * function setFieldValues(fieldValues: Object): void
       * @param {external:Object} fieldValues A map of field names to new values.
       * @description
       *  The `setFieldValues` function sets the value of a set of fields in the current item.
       *  Setting the field values fires one `onItemValuesChanged` event when the page
       *  elements connected to the fields have been updated with the new values.
       *
       *  Calling `setFieldValues()` on a read-only dataset causes an error.
       *
       * @note
       *  A dataset needs to load its data before you call its `setFieldValues()` function.
       *  Usually a dataset finishes loading a short time after the page it is on finishes
       *  loading. So if you call `setFieldValues()` inside the page’s [`onReady()`]($w.html#onReady)
       *  event handler, the dataset might not be ready yet.
       *
       *  To call `setFieldValues()` as soon as possible after a page loads, use the **dataset's**
       *  [`onReady()`](#onReady) function inside the **page’s** [`onReady()`]($w.html#onReady)
       *  event handler to ensure that both the page and the dataset have finished loading.
       * @snippet [setFieldValues.es6=Set several fields' values]
       * @snippet [setFieldValues_onReady.es6=Set several fields' values when the page loads]
       * @see [setFieldValue( )](#setFieldValue)
       */
      setFieldValues: function setFieldValues(fieldValues) {
        assertDatasetReady(getState, 'setFieldValues');
        assertDatasetLimitations(getState, 'setFieldValues', [WRITE, READ_WRITE]);
        assertHasCurrentItem(getState);
        return dispatch(recordActions.updateFields(mapValues_(fieldValues, cloneDeep_)));
      },

      /**
       * @function next
       * @memberof wix-dataset
       * @summary Saves the current item and moves to the next item.
       * @syntax
       * function next(): Promise&lt;Object&gt;
       * @description
       *  The `next()` function returns a Promise that is resolved to the next item
       *  when:
       *  + The current item is saved in the collection (if necessary).
       *  + Any connected page elements have been updated with the new current item’s values.
       *
       *
       *  Calling `next()` on a write-only dataset causes the
       *  Promise to reject.
       *
       *  If the dataset is read-write, the current item is saved even if there is
       *  no next item.
       *
       * @note
       *  A dataset needs to load its data before you call its `next()` function.
       *  Usually a dataset finishes loading a short time after the page it is on finishes
       *  loading. So if you call `next()` inside the page’s [`onReady()`]($w.html#onReady)
       *  event handler, the dataset might not be ready yet.
       *
       *  To call `next()` as soon as possible after a page loads, use the **dataset's**
       *  [`onReady()`](#onReady) function inside the **page’s** [`onReady()`]($w.html#onReady)
       *  event handler to ensure that both the page and the dataset have finished loading.
       * @snippet [next.es6=Move to the next item]
       * @snippet [next_onReady.es6=Move to the next item when the page loads]
       * @returns {Promise}
       * @fulfill {external:Object} The next item in the dataset.
       * @reject {String} An error message.
       * @see [previous( )](#previous)
       * @see [hasNext( )](#hasNext)
       */
      next: function () {
        var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
          var _this3 = this;

          return regeneratorRuntime.wrap(function _callee8$(_context8) {
            while (1) {
              switch (_context8.prev = _context8.next) {
                case 0:
                  assertScopeIsNotFixedItem(isFixedItem, 'next');
                  assertDatasetReady(getState, 'next');
                  assertDatasetLimitations(getState, 'next', [READ, READ_WRITE], false);
                  _context8.prev = 3;
                  _context8.next = 6;
                  return queue(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
                    return regeneratorRuntime.wrap(function _callee7$(_context7) {
                      while (1) {
                        switch (_context7.prev = _context7.next) {
                          case 0:
                            if (reducer.isReadOnly(getState())) {
                              _context7.next = 3;
                              break;
                            }

                            _context7.next = 3;
                            return flushDraft();

                          case 3:
                            if (api.hasNext()) {
                              _context7.next = 5;
                              break;
                            }

                            throw new DatasetError('NO_SUCH_ITEM', 'There are no more items in the dataset');

                          case 5:
                            _context7.next = 7;
                            return dispatch(recordActions.setCurrentIndex(getCurrentIndex() + 1));

                          case 7:
                            return _context7.abrupt('return', api.getCurrentItem());

                          case 8:
                          case 'end':
                            return _context7.stop();
                        }
                      }
                    }, _callee7, _this3);
                  })));

                case 6:
                  return _context8.abrupt('return', _context8.sent);

                case 9:
                  _context8.prev = 9;
                  _context8.t0 = _context8['catch'](3);

                  fireEvent('datasetError', 'next', _context8.t0);
                  throw _context8.t0;

                case 13:
                case 'end':
                  return _context8.stop();
              }
            }
          }, _callee8, this, [[3, 9]]);
        }));

        function next() {
          return _ref9.apply(this, arguments);
        }

        return next;
      }(),


      /**
       * @function previous
       * @memberof wix-dataset
       * @summary Saves the current item and moves to the previous item.
       * @syntax
       * function previous(): Promise&lt;Object&gt;
       * @description
       *  The `previous()` function returns a Promise that is resolved to the previous item
       *  when:
       *  + The current item is saved in the collection (if necessary).
       *  + Any connected page elements have been updated with the new current item’s values.
       *
       *
       *  Calling `previous()` on a write-only dataset causes the
       *  Promise to reject.
       *
       *  If the dataset is read-write, the current item is saved even if there is
       *  no previous item.
       *
       * @note
       *  A dataset needs to load its data before you call its `previous()` function.
       *  Usually a dataset finishes loading a short time after the page it is on finishes
       *  loading. So if you call `previous()` inside the page’s [`onReady()`]($w.html#onReady)
       *  event handler, the dataset might not be ready yet.
       *
       *  To call `previous()` as soon as possible after a page loads, use the **dataset's**
       *  [`onReady()`](#onReady) function inside the **page’s** [`onReady()`]($w.html#onReady)
       *  event handler to ensure that both the page and the dataset have finished loading.
       * @snippet [previous.es6=Move to the previous item]
       * @snippet [previous_onReady.es6=Move to the previous item when page loads]
       * @returns {Promise}
       * @fulfill {external:Object} The previous item in the dataset.
       * @reject {String} An error message.
       * @see [next( )](#next)
       * @see [hasPrevious( )](#hasPrevious)
       */
      previous: function () {
        var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
          var _this4 = this;

          return regeneratorRuntime.wrap(function _callee10$(_context10) {
            while (1) {
              switch (_context10.prev = _context10.next) {
                case 0:
                  assertScopeIsNotFixedItem(isFixedItem, 'previous');
                  assertDatasetReady(getState, 'previous');
                  assertDatasetLimitations(getState, 'previous', [READ, READ_WRITE], false);
                  _context10.prev = 3;
                  _context10.next = 6;
                  return queue(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
                    return regeneratorRuntime.wrap(function _callee9$(_context9) {
                      while (1) {
                        switch (_context9.prev = _context9.next) {
                          case 0:
                            if (reducer.isReadOnly(getState())) {
                              _context9.next = 3;
                              break;
                            }

                            _context9.next = 3;
                            return flushDraft();

                          case 3:
                            if (api.hasPrevious()) {
                              _context9.next = 5;
                              break;
                            }

                            throw new DatasetError('NO_SUCH_ITEM', 'This is the first item in the dataset');

                          case 5:
                            _context9.next = 7;
                            return dispatch(recordActions.setCurrentIndex(getCurrentIndex() - 1));

                          case 7:
                            return _context9.abrupt('return', api.getCurrentItem());

                          case 8:
                          case 'end':
                            return _context9.stop();
                        }
                      }
                    }, _callee9, _this4);
                  })));

                case 6:
                  return _context10.abrupt('return', _context10.sent);

                case 9:
                  _context10.prev = 9;
                  _context10.t0 = _context10['catch'](3);

                  fireEvent('datasetError', 'previous', _context10.t0);
                  throw _context10.t0;

                case 13:
                case 'end':
                  return _context10.stop();
              }
            }
          }, _callee10, this, [[3, 9]]);
        }));

        function previous() {
          return _ref11.apply(this, arguments);
        }

        return previous;
      }(),


      /**
       * @function hasNext
       * @memberof wix-dataset
       * @summary Indicates if there is a next item.
       * @syntax
       * function hasNext(): boolean
       * @returns {external:Boolean}
       * @description
       *  Returns `true` if the current item is not the last item in the dataset.
       *
       *  Returns `false` if the current item is the last item in the dataset.
       *
       *  Calling `hasNext()` on a write-only dataset causes an error.
       *
       * @note
       *  A dataset needs to load its data before you call its `hasNext()` function.
       *  Usually a dataset finishes loading a short time after the page it is on finishes
       *  loading. So if you call `hasNext()` inside the page’s [`onReady()`]($w.html#onReady)
       *  event handler, the dataset might not be ready yet.
       *
       *  To call `hasNext()` as soon as possible after a page loads, use the **dataset's**
       *  [`onReady()`](#onReady) function inside the **page’s** [`onReady()`]($w.html#onReady)
       *  event handler to ensure that both the page and the dataset have finished loading.
       * @snippet [hasNext.es6=Get whether the current item is the last item]
       * @snippet [hasNext_onReady.es6=Get whether the current item is the last item when the page loads]
       * @see [hasPrevious( )](#hasPrevious)
       */
      hasNext: function hasNext() {
        assertDatasetLimitations(getState, 'hasNext', [READ, READ_WRITE]);
        var currentRecordIndex = reducer.selectCurrentRecordIndex(getState());
        return currentRecordIndex != null && currentRecordIndex < _getTotalCount() - 1;
      },

      /**
       * @function hasPrevious
       * @memberof wix-dataset
       * @summary Indicates if there is a previous item.
       * @syntax
       * function hasPrevious(): boolean
       * @returns {external:Boolean}
       * @description
       *  Returns `true` if the current item is not the first item in the dataset.
       *
       *  Returns `false` if the current item is the first item in the dataset.
       *
       *  Calling `hasPrevious()` on a write-only dataset causes an error.
       *
       * @note
       *  A dataset needs to load its data before you call its `hasPrevious()` function.
       *  Usually a dataset finishes loading a short time after the page it is on finishes
       *  loading. So if you call `hasPrevious()` inside the page’s [`onReady()`]($w.html#onReady)
       *  event handler, the dataset might not be ready yet.
       *
       *  To call `hasPrevious()` as soon as possible after a page loads, use the **dataset's**
       *  [`onReady()`](#onReady) function inside the **page’s** [`onReady()`]($w.html#onReady)
       *  event handler to ensure that both the page and the dataset have finished loading.
       * @snippet [hasPrevious.es6=Get whether the current item is the first item]
       * @snippet [hasPrevious_onReady.es6=Get whether the current item is the first item when the page loads]
       * @see [hasNext( )](#hasPrevious)
       */
      hasPrevious: function hasPrevious() {
        assertDatasetLimitations(getState, 'hasPrevious', [READ, READ_WRITE]);
        var currentRecordIndex = reducer.selectCurrentRecordIndex(getState());
        return currentRecordIndex != null && currentRecordIndex > 0;
      },

      /**
       * @function new
       * @memberof wix-dataset
       * @syntax
       * function new(): Promise&lt;void&gt;
       * @summary Create a new blank item.
       * @description
       *  The `new()` function saves the current item and then creates a new blank
       *  item. When the editing of the new item is complete, you will need to
       *  call another function that will save the new item.
       *
       *  The index of the new item is one after the index of the current item, or
       *  zero if there is no current item.
       *
       *  Note that since the `new()` function begins by saving the current item,
       *  if the current item cannot be saved for any reason, such as it does not
       *  pass validation, calling the function will cause an error.
       *
       *  Calling `new()` on a read-only dataset causes an error.
       *
       * @note
       *  A dataset needs to load its data before you call its `new()` function.
       *  Usually a dataset finishes loading a short time after the page it is on finishes
       *  loading. So if you call `new()` inside the page’s [`onReady()`]($w.html#onReady)
       *  event handler, the dataset might not be ready yet.
       *
       *  To call `new()` as soon as possible after a page loads, use the **dataset's**
       *  [`onReady()`](#onReady) function inside the **page’s** [`onReady()`]($w.html#onReady)
       *  event handler to ensure that both the page and the dataset have finished loading.
       * @snippet [new.es6=Save the current item and create a new blank item]
       * @snippet [new_onReady.es6=Save the current item and create a new blank item when the page loads]
       * @returns {Promise}
       * @fulfill {void} When a new empty item is the current item of the dataset.
       * @reject {String} An error message.
       */
      new: function () {
        var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
          var _this5 = this;

          return regeneratorRuntime.wrap(function _callee12$(_context12) {
            while (1) {
              switch (_context12.prev = _context12.next) {
                case 0:
                  assertDatasetReady(getState, 'new');
                  assertDatasetLimitations(getState, 'new', [WRITE, READ_WRITE], false);
                  _context12.prev = 2;
                  _context12.next = 5;
                  return queue(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
                    var currentIndex, newIndex;
                    return regeneratorRuntime.wrap(function _callee11$(_context11) {
                      while (1) {
                        switch (_context11.prev = _context11.next) {
                          case 0:
                            _context11.next = 2;
                            return flushDraft();

                          case 2:
                            currentIndex = getCurrentIndex();
                            newIndex = currentIndex == null ? 0 : currentIndex + 1;
                            _context11.next = 6;
                            return dispatch(recordActions.newRecord(newIndex));

                          case 6:
                          case 'end':
                            return _context11.stop();
                        }
                      }
                    }, _callee11, _this5);
                  })));

                case 5:
                  _context12.next = 11;
                  break;

                case 7:
                  _context12.prev = 7;
                  _context12.t0 = _context12['catch'](2);

                  fireEvent('datasetError', 'new', _context12.t0);
                  throw _context12.t0;

                case 11:
                case 'end':
                  return _context12.stop();
              }
            }
          }, _callee12, this, [[2, 7]]);
        }));

        function _new() {
          return _ref13.apply(this, arguments);
        }

        return _new;
      }(),


      /**
       * @function remove
       * @memberof wix-dataset
       * @summary Removes the current item.
       * @syntax
       * function remove(): Promise&lt;void&gt;
       * @description
       *  The `remove()` function returns a Promise that is resolved
       *  when:
       *  + The current item is deleted in the collection.
       *  + Any connected page elements have been updated with the next item’s
       *    values if there is a next item, or the previous item's values if the
       *    removed item was the last item.
       *
       *
       *  Calling `remove()` on a write-only or read-only dataset causes an error.
       *
       * @note
       *  A dataset needs to load its data before you call its `remove()` function.
       *  Usually a dataset finishes loading a short time after the page it is on finishes
       *  loading. So if you call `remove()` inside the page’s [`onReady()`]($w.html#onReady)
       *  event handler, the dataset might not be ready yet.
       *
       *  To call `remove()` as soon as possible after a page loads, use the **dataset's**
       *  [`onReady()`](#onReady) function inside the **page’s** [`onReady()`]($w.html#onReady)
       *  event handler to ensure that both the page and the dataset have finished loading.
       * @snippet [remove.es6=Remove the current item]
       * @snippet [remove_onReady.es6=Remove the current item when the page loads]
       * @returns {Promise}
       * @fulfill {void} When the current item has been removed from the collection.
       * @see [revert( )](#revert)
       * @see [refresh( )](#refresh)
       */
      remove: function () {
        var _ref15 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14() {
          var _this6 = this;

          return regeneratorRuntime.wrap(function _callee14$(_context14) {
            while (1) {
              switch (_context14.prev = _context14.next) {
                case 0:
                  assertDatasetReady(getState, 'remove');
                  assertDatasetLimitations(getState, 'remove', [READ_WRITE], false);
                  _context14.prev = 2;
                  _context14.next = 5;
                  return queue(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
                    var index;
                    return regeneratorRuntime.wrap(function _callee13$(_context13) {
                      while (1) {
                        switch (_context13.prev = _context13.next) {
                          case 0:
                            index = getCurrentIndex();

                            if (!(index == null)) {
                              _context13.next = 3;
                              break;
                            }

                            throw new DatasetError('DS_INDEX_OUT_OF_RANGE', 'Invalid index');

                          case 3:
                            _context13.next = 5;
                            return dispatch(recordActions.remove());

                          case 5:
                          case 'end':
                            return _context13.stop();
                        }
                      }
                    }, _callee13, _this6);
                  })));

                case 5:
                  _context14.next = 11;
                  break;

                case 7:
                  _context14.prev = 7;
                  _context14.t0 = _context14['catch'](2);

                  fireEvent('datasetError', 'remove', _context14.t0);
                  throw _context14.t0;

                case 11:
                case 'end':
                  return _context14.stop();
              }
            }
          }, _callee14, this, [[2, 7]]);
        }));

        function remove() {
          return _ref15.apply(this, arguments);
        }

        return remove;
      }(),


      /**
       * @function revert
       * @memberof wix-dataset
       * @summary Reverts the current item to its saved value.
       * @syntax
       * function revert(): Promise&lt;void&gt;
       * @description
       *  The `revert()` function returns a Promise that is resolved
       *  when:
       *  + The current item is reverted to its saved state in the collection.
       *  + Any connected page elements have been updated with the current item’s
       *    old values (read &amp; write mode) or blank values (write-only mode).
       *
       *
       *  Calling `revert()` on a read-only dataset causes the Promise to reject.
       *
       * @note
       *  A dataset needs to load its data before you call its `revert()` function.
       *  Usually a dataset finishes loading a short time after the page it is on finishes
       *  loading. So if you call `revert()` inside the page’s [`onReady()`]($w.html#onReady)
       *  event handler, the dataset might not be ready yet.
       *
       *  To call `revert()` as soon as possible after a page loads, use the **dataset's**
       *  [`onReady()`](#onReady) function inside the **page’s** [`onReady()`]($w.html#onReady)
       *  event handler to ensure that both the page and the dataset have finished loading.
       * @snippet [revert.es6=Revert the current item]
       * @snippet [revert_onReady.es6=Revert the current item when the page loads]
       * @returns {Promise}
       * @fulfill {void} When the item has been reverted to its saved state.
       * @reject {String} An error message.
       * @see [refresh( )](#refresh)
       * @see [save( )](#save)
       */
      revert: function () {
        var _ref17 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15() {
          return regeneratorRuntime.wrap(function _callee15$(_context15) {
            while (1) {
              switch (_context15.prev = _context15.next) {
                case 0:
                  assertDatasetReady(getState, 'revert');
                  assertDatasetLimitations(getState, 'revert', [WRITE, READ_WRITE], false);
                  assertHasCurrentItem(getState);
                  return _context15.abrupt('return', dispatch(recordActions.revert()));

                case 4:
                case 'end':
                  return _context15.stop();
              }
            }
          }, _callee15, this);
        }));

        function revert() {
          return _ref17.apply(this, arguments);
        }

        return revert;
      }(),


      /**
       * @function refresh
       * @memberof wix-dataset
       * @summary Refetches the contents of the dataset from the collection.
       * @syntax
       * function refresh(): Promise&lt;void&gt;
       * @description
       *  The `refresh()` function returns a Promise that is resolved
       *  when:
       *  + The dataset's contents are refetched from the collection, discarding
       *    current edits.
       *  + Any connected page elements have been updated with the values from
       *    the collection (read &amp; write mode) or blank values (write-only mode).
       *
       *
       *  Refreshing the dataset sets the current item back to the first item in
       *  the dataset regardless of what the current item was before refreshing.
       *
       * @note
       *  A dataset needs to load its data before you call its `refresh()` function.
       *  Usually a dataset finishes loading a short time after the page it is on finishes
       *  loading. So if you call `refresh()` inside the page’s [`onReady()`]($w.html#onReady)
       *  event handler, the dataset might not be ready yet.
       *
       *  To call `refresh()` as soon as possible after a page loads, use the **dataset's**
       *  [`onReady()`](#onReady) function inside the **page’s** [`onReady()`]($w.html#onReady)
       *  event handler to ensure that both the page and the dataset have finished loading.
       * @snippet [refresh.es6=Refresh the dataset contents]
       * @snippet [refresh_onReady.es6=Refresh the dataset contents when the page loads]
       * @returns {Promise}
       * @fulfill {void} When the refresh is finished.
       * @reject {String} An error message.
       * @see [revert( )](#revert)
       * @see [save( )](#save)
       */
      refresh: function () {
        var _ref18 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee17() {
          var _this7 = this;

          return regeneratorRuntime.wrap(function _callee17$(_context17) {
            while (1) {
              switch (_context17.prev = _context17.next) {
                case 0:
                  assertDatasetReady(getState, 'refresh');
                  assertDatasetLimitations(getState, 'refresh', [READ, WRITE, READ_WRITE], false);
                  _context17.prev = 2;
                  _context17.next = 5;
                  return queue(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16() {
                    return regeneratorRuntime.wrap(function _callee16$(_context16) {
                      while (1) {
                        switch (_context16.prev = _context16.next) {
                          case 0:
                            _context16.next = 2;
                            return dispatch(recordActions.refresh());

                          case 2:
                          case 'end':
                            return _context16.stop();
                        }
                      }
                    }, _callee16, _this7);
                  })));

                case 5:
                  _context17.next = 11;
                  break;

                case 7:
                  _context17.prev = 7;
                  _context17.t0 = _context17['catch'](2);

                  fireEvent('datasetError', 'refresh', _context17.t0);
                  throw _context17.t0;

                case 11:
                case 'end':
                  return _context17.stop();
              }
            }
          }, _callee17, this, [[2, 7]]);
        }));

        function refresh() {
          return _ref18.apply(this, arguments);
        }

        return refresh;
      }(),


      /**
       * @callback CurrentIndexChangedHandler
       * @summary A current item index change event handler.
       * @param {external:Number} index The new index.
       * @memberof wix-dataset
       **/

      /**
       * @function onCurrentIndexChanged
       * @syntax
       * function onCurrentIndexChanged(handler: CurrentIndexChangedHandler): void
       * callback CurrentIndexChangedHandler(index: Number): void
       * @summary Adds an event handler that runs when the current index changes.
       * @param {wix-dataset.CurrentIndexChangedHandler} handler The current index change event handler.
       * @description
       *  The `onCurrentIndexChanged()` function allows you to optionally perform actions
       *  right after the current index changes.
       *
       *  Calling `onCurrentIndexChanged()` on a write-only dataset causes an error.
       * @snippet [onCurrentIndexChanged.es6=Register a callback to run when the current index changes]
       * @memberof wix-dataset
       */
      onCurrentIndexChanged: function onCurrentIndexChanged(cb) {
        assertValidCallback('onCurrentIndexChanged', cb);
        assertDatasetLimitations(getState, 'onCurrentIndexChanged', [READ_WRITE, READ], false);
        return register('currentIndexChanged', verboseIfNeeded(userCodeZone(cb), 'currentIndexChanged callback'));
      },

      /**
       * @callback ItemValuesChangedHandler
       * @summary A current item value change event handler.
       * @param {external:Object} itemBeforeChange The item before the change.
       * @param {external:Object} updatedItem The updated item.
       * @memberof wix-dataset
       **/

      /**
       * @function onItemValuesChanged
       * @memberof wix-dataset
       * @syntax
       * function onItemValuesChanged(handler: ItemValuesChangedHandler): void
       * callback ItemValuesChangedHandler(itemBeforeChange: Object,
       *   updatedItem: Object): void
       * @summary Adds an event handler that runs when a value of the current item changes.
       * @param {wix-dataset.ItemValuesChangedHandler} handler The current value changed event handler.
       * @description
       *  The `onItemValuesChanged()` function allows you to optionally perform actions
       *  right after the current item's values change. The item's value changes
       *  when a user changes the value in one of the item's connected page elements
       *  or you change the value programmatically.
       *
       *  Calling `onItemValuesChanged()` on a read-only dataset causes an error.
       * @snippet [onItemValuesChanged.es6=Register a callback to run when the current item's values change]
       */
      onItemValuesChanged: function onItemValuesChanged(cb) {
        assertValidCallback('onItemValuesChanged', cb);
        assertDatasetLimitations(getState, 'onItemValuesChanged', [READ_WRITE, WRITE], false);
        return register('itemValuesChanged', verboseIfNeeded(userCodeZone(cb), 'itemValuesChanged callback'));
      },

      /**
       * @callback ErrorHandler
       * @summary An error event handler.
       * @param {external:String} operation The operation during which the error occurred.
       * @param {external:Error} error The error that occurred.
       * @memberof wix-dataset
       **/

      /**
       * @function onError
       * @memberof wix-dataset
       * @summary Adds an event handler that runs when an error occurs.
       * @param {wix-dataset.ErrorHandler} handler The error handler.
       * @syntax
       * function onError(handler: ErrorHandler): void
       * callback ErrorHandler(operation: string, error: Error): void
       * @description
       *  The `onError()` function allows you to perform actions after a dataset
       *  operation causes an error such as a field failing validation.
       *
       *  The value of the handler's `operation` property is the
       *  name of the function that caused the error.
       *
       *  For example, the `operation` property could be any of the following:
       *  + `"new"`
       *  + `"next"`
       *  + `"save"`
       *  + `"previous"`
       *
       *
       * @snippet [onError.es6=Register a callback to run when an error occurs]
       */
      onError: function onError(cb) {
        assertValidCallback('onError', cb);
        assertDatasetLimitations(getState, 'onError', [READ_WRITE, READ, WRITE], false);
        return register('datasetError', verboseIfNeeded(userCodeZone(cb), 'datasetError callback'));
      },

      /**
       * @callback ReadyHandler
       * @summary A dataset ready event handler.
       * @memberof wix-dataset
       **/

      /**
       * @function onReady
       * @memberof wix-dataset
       * @syntax
       * function onReady(handler: ReadyHandler): void
       * callback ReadyHandler(): void
       * @summary Adds an event handler that runs when the dataset is ready.
       * @description
       *  The `onReady()` function allows you to optionally perform actions
       *  right after the dataset has loaded its data from the collection and
       *  updated all connected page elements with their corresponding values.
       * @snippet [onReady.es6=Register a callback to run after the dataset is ready]
       */
      onReady: function onReady(cb) {
        assertValidCallback('onReady', cb);
        assertDatasetLimitations(getState, 'onReady', [READ, WRITE, READ_WRITE], false);
        if (!reducer.isDatasetReady(getState())) {
          return register('datasetReady', verboseIfNeeded(userCodeZone(cb), 'datasetReady callback'));
        } else {
          Promise.resolve(verboseIfNeeded(userCodeZone(cb), 'datasetReady callback')()).catch(reportCallbackError('onReady', errorReporter));
          return noop_;
        }
      },

      /**
       * @function setSort
       * @memberof wix-dataset
       * @summary Sets the dataset sort order.
       * @param {wix-data.WixDataSort} sort A wix-data sort object.
       * @instance
       * @syntax
       * function setSort(sort: WixDataSort): Promise&lt;void&gt;
       * @description
       *  The `setSort` function sorts the items in the dataset.
       *
       *  The `WixDataSort` object is created by calling the [`sort()`](wix-data.html#sort)
       *  function on `wixData` and chaining one or more of the following Wix Data
       *  sort functions.
       *
       *  + [ascending](wix-data.WixDataQuery.html#ascending)
       *  + [descending](wix-data.WixDataQuery.html#descending)
       *
       *
       *  To clear a dataset's current sort, call `setSort()` and pass it an
       *  empty sort. You create an empty sort by calling the [`sort()`](wix-data.html#sort)
       *  function without chaining any of the additional sort functions mentioned above.
       *
       *  Calling `setSort()` on a write-only dataset causes an error.
       *
       *  You will need to import `wix-data` to create a `WixDataSort` object.
       * @snippet [setSort.es6=Set a dataset's sort]
       *  This example sorts a dataset by `lastname` field in ascending order and
       *  when more than one item has the same `lastname` value they are sorted
       *  by the `age` field in descending order.
       * @snippet [setSort_build.es6=Build and set a dataset's sort]
       *  This example builds a sort based on certain conditions. It then uses the
       *  built sort to sort a dataset.
       * @snippet [setSort_then.es6=Set a dataset's sort]
       * @snippet [setSort_clear.es6=Clear a dataset's sorts]
       * @returns {Promise}
       * @fulfill {void} When the sort has been set.
       * @reject {external:String} An error message.
       * @see [setFilter( )](#setFilter)
       */
      setSort: function () {
        var _ref20 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee19(sort) {
          var _this8 = this;

          return regeneratorRuntime.wrap(function _callee19$(_context19) {
            while (1) {
              switch (_context19.prev = _context19.next) {
                case 0:
                  assertScopeIsNotFixedItem(isFixedItem, 'setSort');
                  assertDatasetLimitations(getState, 'setSort', [READ, READ_WRITE], false);
                  assertValidSort(sort);

                  _context19.next = 5;
                  return queue(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee18() {
                    var buildSort;
                    return regeneratorRuntime.wrap(function _callee18$(_context18) {
                      while (1) {
                        switch (_context18.prev = _context18.next) {
                          case 0:
                            _context18.next = 2;
                            return new Promise(function (resolve) {
                              return api.onReady(resolve);
                            });

                          case 2:
                            if (reducer.isReadOnly(getState())) {
                              _context18.next = 5;
                              break;
                            }

                            _context18.next = 5;
                            return flushDraft();

                          case 5:
                            _context18.prev = 5;
                            buildSort = userCodeZone(function () {
                              return sort._build();
                            });

                            dispatch(configActions.setSort(cloneDeep_(buildSort())));
                            _context18.next = 13;
                            break;

                          case 10:
                            _context18.prev = 10;
                            _context18.t0 = _context18['catch'](5);
                            throw _context18.t0;

                          case 13:
                            _context18.next = 15;
                            return dispatch(recordActions.refresh());

                          case 15:
                            return _context18.abrupt('return', _context18.sent);

                          case 16:
                          case 'end':
                            return _context18.stop();
                        }
                      }
                    }, _callee18, _this8, [[5, 10]]);
                  })));

                case 5:
                  return _context19.abrupt('return', _context19.sent);

                case 6:
                case 'end':
                  return _context19.stop();
              }
            }
          }, _callee19, this);
        }));

        function setSort(_x2) {
          return _ref20.apply(this, arguments);
        }

        return setSort;
      }(),


      /**
       * @function setFilter
       * @memberof wix-dataset
       * @summary Sets the dataset filter.
       * @param {wix-data.WixDataFilter} filter A wix-data filter object.
       * @instance
       * @syntax
       * function setFilter(filter: WixDataFilter): Promise&lt;void&gt;
       * @description
       *  The `setFilter()` function filters out items that don't match the filter
       *  criteria.
       *
       *  The `WixDataFilter` object is created by calling the [`filter()`](wix-data.html#filter)
       *  function on `wixData` and chaining one or more of the following Wix Data
       *  filter functions.
       *
       *  + [between](wix-data.WixDataQuery.html#between)
       *  + [contains](wix-data.WixDataQuery.html#contains)
       *  + [endsWith](wix-data.WixDataQuery.html#endsWith)
       *  + [eq](wix-data.WixDataQuery.html#eq)
       *  + [ge](wix-data.WixDataQuery.html#ge)
       *  + [gt](wix-data.WixDataQuery.html#gt)
       *  + [hasAll](wix-data.WixDataQuery.html#hasAll)
       *  + [hasSome](wix-data.WixDataQuery.html#hasSome)
       *  + [le](wix-data.WixDataQuery.html#le)
       *  + [lt](wix-data.WixDataQuery.html#lt)
       *  + [ne](wix-data.WixDataQuery.html#ne)
       *  + [not](wix-data.WixDataQuery.html#not) - See note below.
       *  + [or](wix-data.WixDataQuery.html#or) - See note below.
       *  + [startsWith](wix-data.WixDataQuery.html#startsWith)
       *
       *
       *  To clear a dataset's current filter, call `setFilter()` and pass it an
       *  empty filter. You create an empty filter by calling the [`filter()`](wix-data.html#filter)
       *  function without chaining any of the additional filter functions mentioned above.
       *
       *  Calling `setFilter()` on a write-only dataset causes an error.
       *
       *  You will need to import `wix-data` in order to create a `WixDataFilter` object.
       * @note
       *  When using the [not](wix-data.WixDataQuery.html#not) or [or](wix-data.WixDataQuery.html#or)
       *  functions, be sure to pass them a `WixDataFilter` object created by calling the [`filter()`](wix-data.html#filter)
       *  function and not a `WixDataQuery` object.
       * @snippet [setFilter.es6=Set a dataset's filter]
       *  This example filters a dataset to only have items where the `lastname`
       *  field starts with "D" and the `age` field is greater or equal to 21.
       * @snippet [setFilter_build.es6=Build and set a dataset's filter]
       *  This example builds a filter based on certain conditions. It then uses the
       *  built filter to filter a dataset.
       * @snippet [setFilter_then.es6=Set a dataset's filter]
       * @snippet [setFilter_clear.es6=Clear a dataset's filters]
       * @snippet [setFilter_or.es6=Set a dataset's filter with an or condition]
       * @returns {Promise}
       * @fulfill {void} When the filter has been set.
       * @reject {external:Error} An error object.
       * @see [setSort( )](#setSort)
       */
      setFilter: function () {
        var _ref22 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee21(filter) {
          var _this9 = this;

          return regeneratorRuntime.wrap(function _callee21$(_context21) {
            while (1) {
              switch (_context21.prev = _context21.next) {
                case 0:
                  assertScopeIsNotFixedItem(isFixedItem, 'setFilter');
                  assertDatasetLimitations(getState, 'setFilter', [READ, READ_WRITE], false);
                  assertValidFilter(filter);

                  _context21.next = 5;
                  return queue(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee20() {
                    var buildFilter;
                    return regeneratorRuntime.wrap(function _callee20$(_context20) {
                      while (1) {
                        switch (_context20.prev = _context20.next) {
                          case 0:
                            _context20.next = 2;
                            return new Promise(function (resolve) {
                              return api.onReady(resolve);
                            });

                          case 2:
                            if (reducer.isReadOnly(getState())) {
                              _context20.next = 5;
                              break;
                            }

                            _context20.next = 5;
                            return flushDraft();

                          case 5:
                            _context20.prev = 5;
                            buildFilter = userCodeZone(function () {
                              return filter._build();
                            });

                            dispatch(configActions.setFilter(cloneDeep_(buildFilter())));
                            _context20.next = 13;
                            break;

                          case 10:
                            _context20.prev = 10;
                            _context20.t0 = _context20['catch'](5);
                            throw _context20.t0;

                          case 13:
                            _context20.next = 15;
                            return dispatch(recordActions.refresh());

                          case 15:
                            return _context20.abrupt('return', _context20.sent);

                          case 16:
                          case 'end':
                            return _context20.stop();
                        }
                      }
                    }, _callee20, _this9, [[5, 10]]);
                  })));

                case 5:
                  return _context21.abrupt('return', _context21.sent);

                case 6:
                case 'end':
                  return _context21.stop();
              }
            }
          }, _callee21, this);
        }));

        function setFilter(_x3) {
          return _ref22.apply(this, arguments);
        }

        return setFilter;
      }(),


      /**
       * @function loadMore
       * @memberof wix-dataset
       * @summary Loads the next page of data in addition to the current data.
       * @syntax
       * function loadMore(): Promise&lt;void&gt;
       * @description
       *  The `loadMore()` function returns a Promise that is resolved
       *  when:
       *  + The dataset loads the next [page of data](#data-paging).
       *  + Any connected elements have been updated with the new data.
       *
       *
       *  Loading more data into a dataset adds more items to any connected
       *  repeaters. Elements that have their own settings for how many items
       *  are shown at once, such as tables and galleries, are not affected.
       *
       *  Loading more data into a dataset does not:
       *  + Remove any of the items that were previously shown in any connected elements
       *  + Change the dataset's [page](#data-paging) size.
       *  + Change the dataset's current item.
       *
       *
       * @note
       *  A dataset needs to load its data before you call its `loadMore()` function.
       *  Usually a dataset finishes loading a short time after the page it is on finishes
       *  loading. So if you call `loadMore()` inside the page’s [`onReady()`]($w.html#onReady)
       *  event handler, the dataset might not be ready yet.
       *
       *  To call `loadMore()` as soon as possible after a page loads, use the **dataset's**
       *  [`onReady()`](#onReady) function inside the **page’s** [`onReady()`]($w.html#onReady)
       *  event handler to ensure that both the page and the dataset have finished loading.
       * @snippet [loadMore.es6=Load more dataset content]
       * @snippet [loadMore_onReady.es6=Load more dataset content when the page loads]
       * @returns {Promise}
       * @fulfill {void} When the additional data has been loaded and any connected repeaters have been updated.
       * @reject {String} An error message.
       */
      loadMore: function () {
        var _ref24 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee23() {
          return regeneratorRuntime.wrap(function _callee23$(_context23) {
            while (1) {
              switch (_context23.prev = _context23.next) {
                case 0:
                  assertScopeIsNotFixedItem(isFixedItem, 'loadMore');
                  assertDatasetReady(getState, 'loadMore');
                  assertDatasetLimitations(getState, 'loadMore', [READ, READ_WRITE], false);
                  _context23.next = 5;
                  return queue(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee22() {
                    return regeneratorRuntime.wrap(function _callee22$(_context22) {
                      while (1) {
                        switch (_context22.prev = _context22.next) {
                          case 0:
                            _context22.next = 2;
                            return dispatch(recordActions.incrementNumOfPagesToShow());

                          case 2:
                          case 'end':
                            return _context22.stop();
                        }
                      }
                    }, _callee22, undefined);
                  })));

                case 5:
                case 'end':
                  return _context23.stop();
              }
            }
          }, _callee23, undefined);
        }));

        function loadMore() {
          return _ref24.apply(this, arguments);
        }

        return loadMore;
      }(),

      /**
       * @function nextPage
       * @memberof wix-dataset
       * @summary Moves to the next page of data.
       * @syntax
       * function nextPage(): Promise&lt;Object[]&gt;
       * @description
       *  The `nextPage()` function returns a Promise that is resolved to
       *  an array of the next [page](#data-paging)'s items when:
       *  + The current item is saved in the collection (if necessary).
       *  + The next [page of data](#data-paging) is loaded.
       *  + Any connected elements have been updated with the new data.
       *  + The current item is updated to the first item in the next page.
       *
       *
       *  Going to the next [page of data](#data-paging) replaces the current items
       *  in any connected elements with the new items that correspond to the
       *  next [page of data](#data-paging). Elements that have their own settings for how many items
       *  are shown at once, such as tables and galleries, are not affected.
       *
       *  Calling `nextPage()` on a write-only dataset causes an error.
       * @note
       *  A dataset needs to load its data before you call its `nextPage()` function.
       *  Usually a dataset finishes loading a short time after the page it is on finishes
       *  loading. So if you call `nextPage()` inside the page’s [`onReady()`]($w.html#onReady)
       *  event handler, the dataset might not be ready yet.
       *
       *  To call `nextPage()` as soon as possible after a page loads, use the **dataset's**
       *  [`onReady()`](#onReady) function inside the **page’s** [`onReady()`]($w.html#onReady)
       *  event handler to ensure that both the page and the dataset have finished loading.
       * @snippet [nextPage.es6=Move to the next page of dataset content]
       * @snippet [nextPage_onReady.es6=Move to the next page of dataset content when the page loads]
       * @returns {Promise}
       * @fulfill {external:Object[]} When the next page of data has been loaded and any connected elements have been updated.
       * @reject {String} An error message.
       * @see [previousPage( )](#previousPage)
       * @see [hasNextPage( )](#hasNextPage)
       * @see [loadPage( )](#loadPage)
       */
      nextPage: function () {
        var _ref26 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee25() {
          var _this10 = this;

          return regeneratorRuntime.wrap(function _callee25$(_context25) {
            while (1) {
              switch (_context25.prev = _context25.next) {
                case 0:
                  assertScopeIsNotFixedItem(isFixedItem, 'nextPage');
                  assertDatasetReady(getState, 'nextPage');
                  assertDatasetLimitations(getState, 'nextPage', [READ, READ_WRITE], false);
                  _context25.prev = 3;
                  _context25.next = 6;
                  return queue(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee24() {
                    var _ref28, items;

                    return regeneratorRuntime.wrap(function _callee24$(_context24) {
                      while (1) {
                        switch (_context24.prev = _context24.next) {
                          case 0:
                            if (reducer.isReadOnly(getState())) {
                              _context24.next = 3;
                              break;
                            }

                            _context24.next = 3;
                            return flushDraft();

                          case 3:
                            if (api.hasNextPage()) {
                              _context24.next = 5;
                              break;
                            }

                            throw new DatasetError('NO_SUCH_PAGE', 'There are no more pages in the dataset');

                          case 5:
                            _context24.next = 7;
                            return dispatch(recordActions.nextPage());

                          case 7:
                            _context24.next = 9;
                            return recordActions.fetchCurrentPage(recordStore, getState());

                          case 9:
                            _ref28 = _context24.sent;
                            items = _ref28.items;
                            return _context24.abrupt('return', items);

                          case 12:
                          case 'end':
                            return _context24.stop();
                        }
                      }
                    }, _callee24, _this10);
                  })));

                case 6:
                  return _context25.abrupt('return', _context25.sent);

                case 9:
                  _context25.prev = 9;
                  _context25.t0 = _context25['catch'](3);

                  fireEvent('datasetError', 'nextPage', _context25.t0);
                  throw _context25.t0;

                case 13:
                case 'end':
                  return _context25.stop();
              }
            }
          }, _callee25, this, [[3, 9]]);
        }));

        function nextPage() {
          return _ref26.apply(this, arguments);
        }

        return nextPage;
      }(),


      /**
       * @function previousPage
       * @memberof wix-dataset
       * @summary Moves to the previous page of data.
       * @syntax
       * function previousPage(): Promise&lt;Object[]&gt;
       * @description
       *  The `previousPage()` function returns a Promise that is resolved to
       *  an array of the next [page](#data-paging)'s items when:
       *  + The current item is saved in the collection (if necessary).
       *  + The previous [page of data](#data-paging) is loaded.
       *  + Any connected elements have been updated with the new data.
       *  + The current item is updated to the first item in the previous page.
       *
       *
       *  Going to the previous [page of data](#data-paging) replaces the current items
       *  in any connected elements with the new items that correspond to the
       *  previous [page of data](#data-paging). Elements that have their own settings for how many items
       *  are shown at once, such as tables and galleries, are not affected.
       *
       *  Calling `previousPage()` on a write-only dataset causes an error.
       * @note
       *  A dataset needs to load its data before you call its `previousPage()` function.
       *  Usually a dataset finishes loading a short time after the page it is on finishes
       *  loading. So if you call `previousPage()` inside the page’s [`onReady()`]($w.html#onReady)
       *  event handler, the dataset might not be ready yet.
       *
       *  To call `previousPage()` as soon as possible after a page loads, use the **dataset's**
       *  [`onReady()`](#onReady) function inside the **page’s** [`onReady()`]($w.html#onReady)
       *  event handler to ensure that both the page and the dataset have finished loading.
       * @snippet [previousPage.es6=Move to the previous page of dataset content]
       * @snippet [previousPage_onReady.es6=Move to the previous page of dataset content when the page loads]
       * @returns {Promise}
       * @fulfill {external:Object[]} When the previous page of data has been loaded and any connected repeaters have been updated.
       * @reject {String} An error message.
       * @see [nextPage( )](#previousPage)
       * @see [hasPreviousPage( )](#hasNextPage)
       * @see [loadPage( )](#loadPage)
       */
      previousPage: function () {
        var _ref29 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee27() {
          var _this11 = this;

          return regeneratorRuntime.wrap(function _callee27$(_context27) {
            while (1) {
              switch (_context27.prev = _context27.next) {
                case 0:
                  assertScopeIsNotFixedItem(isFixedItem, 'previousPage');
                  assertDatasetReady(getState, 'previousPage');
                  assertDatasetLimitations(getState, 'previousPage', [READ, READ_WRITE], false);
                  _context27.prev = 3;
                  _context27.next = 6;
                  return queue(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee26() {
                    var _ref31, items;

                    return regeneratorRuntime.wrap(function _callee26$(_context26) {
                      while (1) {
                        switch (_context26.prev = _context26.next) {
                          case 0:
                            if (reducer.isReadOnly(getState())) {
                              _context26.next = 3;
                              break;
                            }

                            _context26.next = 3;
                            return flushDraft();

                          case 3:
                            if (api.hasPreviousPage()) {
                              _context26.next = 5;
                              break;
                            }

                            throw new DatasetError('NO_SUCH_PAGE', 'This is the first page in the dataset');

                          case 5:
                            _context26.next = 7;
                            return dispatch(recordActions.previousPage());

                          case 7:
                            _context26.next = 9;
                            return recordActions.fetchCurrentPage(recordStore, getState());

                          case 9:
                            _ref31 = _context26.sent;
                            items = _ref31.items;
                            return _context26.abrupt('return', items);

                          case 12:
                          case 'end':
                            return _context26.stop();
                        }
                      }
                    }, _callee26, _this11);
                  })));

                case 6:
                  return _context27.abrupt('return', _context27.sent);

                case 9:
                  _context27.prev = 9;
                  _context27.t0 = _context27['catch'](3);

                  fireEvent('datasetError', 'previousPage', _context27.t0);
                  throw _context27.t0;

                case 13:
                case 'end':
                  return _context27.stop();
              }
            }
          }, _callee27, this, [[3, 9]]);
        }));

        function previousPage() {
          return _ref29.apply(this, arguments);
        }

        return previousPage;
      }(),


      /**
       * @function hasNextPage
       * @memberof wix-dataset
       * @summary Indicates if there is a next page of data.
       * @syntax
       * function hasNextPage(): boolean
       * @returns {external:Boolean}
       * @description
       *  Returns `true` if the current [page](#data-paging) is not the last
       *  [page](#data-paging) in the dataset.
       *
       *  Returns `false` if the current [page](#data-paging) is the last
       *  [page](#data-paging) in the dataset.
       *
       *  Calling `hasNextPage()` on a write-only dataset causes an error.
       * @note
       *  A dataset needs to load its data before you call its `hasNextPage()` function.
       *  Usually a dataset finishes loading a short time after the page it is on finishes
       *  loading. So if you call `hasNextPage()` inside the page’s [`onReady()`]($w.html#onReady)
       *  event handler, the dataset might not be ready yet.
       *
       *  To call `hasNextPage()` as soon as possible after a page loads, use the **dataset's**
       *  [`onReady()`](#onReady) function inside the **page’s** [`onReady()`]($w.html#onReady)
       *  event handler to ensure that both the page and the dataset have finished loading.
       * @snippet [hasNextPage.es6=Get whether the current page is the last page of data]
       * @snippet [hasNextPage_onReady.es6=Get whether the current page is the last page of data when the page loads]
       * @see [nextPage( )](#previousPage)
       * @see [hasPreviousPage( )](#hasNextPage)
       */
      hasNextPage: function hasNextPage() {
        assertDatasetLimitations(getState, 'hasNextPage', [READ, READ_WRITE]);
        var state = getState();
        var paginationData = reducer.getPaginationData(state);
        return paginationData.offset + reducer.getCurrentPageSize(state) < _getTotalCount();
      },


      /**
       * @function hasPreviousPage
       * @memberof wix-dataset
       * @summary Indicates if there is a previous page of data.
       * @syntax
       * function hasPreviousPage(): boolean
       * @returns {external:Boolean}
       * @description
       *  Returns `true` if the current [page](#data-paging) is not the first
       *  [page](#data-paging) in the dataset.
       *
       *  Returns `false` if the current [page](#data-paging) is the first
       *  [page](#data-paging) in the dataset.
       *
       *  Calling `hasPreviousPage()` on a write-only dataset causes an error.
       *
       * @note
       *  A dataset needs to load its data before you call its `hasPreviousPage()` function.
       *  Usually a dataset finishes loading a short time after the page it is on finishes
       *  loading. So if you call `hasPreviousPage()` inside the page’s [`onReady()`]($w.html#onReady)
       *  event handler, the dataset might not be ready yet.
       *
       *  To call `hasPreviousPage()` as soon as possible after a page loads, use the **dataset's**
       *  [`onReady()`](#onReady) function inside the **page’s** [`onReady()`]($w.html#onReady)
       *  event handler to ensure that both the page and the dataset have finished loading.
       * @snippet [hasPreviousPage.es6=Get whether the current page is the first page of data]
       * @snippet [hasPreviousPage_onReady.es6=Get whether the current page is the first page of data when the page loads]
       * @see [previousPage( )](#previousPage)
       * @see [hasNextPage( )](#hasNextPage)
       */
      hasPreviousPage: function hasPreviousPage() {
        assertDatasetLimitations(getState, 'hasPreviousPage', [READ, READ_WRITE]);
        var paginationData = reducer.getPaginationData(getState());
        return paginationData.offset > 0;
      },


      /**
       * @function getTotalPageCount
       * @memberof wix-dataset
       * @summary Gets the number of pages in the dataset.
       * @syntax
       * function getTotalPageCount(): number
       * @returns {external:Number}
       * @description
       *  The number of [pages](#data-paging) in a dataset is the number of total items divided
       *  by the page size. If there are any left over items, one more page is added.
       *
       *  For example, if you have 20 items and your page size is 6, you have
       *  4 pages. The first 3 pages have 6 items each and the last page has 2 items.
       * @note
       *  A dataset needs to load its data before you call its `getTotalPageCount()` function.
       *  Usually a dataset finishes loading a short time after the page it is on finishes
       *  loading. So if you call `getTotalPageCount()` inside the page’s [`onReady()`]($w.html#onReady)
       *  event handler, the dataset might not be ready yet.
       *
       *  To call `getTotalPageCount()` as soon as possible after a page loads, use the **dataset's**
       *  [`onReady()`](#onReady) function inside the **page’s** [`onReady()`]($w.html#onReady)
       *  event handler to ensure that both the page and the dataset have finished loading.
       * @snippet [getTotalPageCount.es6=Get the number of pages in the dataset]
       */
      getTotalPageCount: function getTotalPageCount() {
        assertDatasetLimitations(getState, 'getTotalPageCount', [READ, READ_WRITE]);

        return reducer.getTotalPageCount(getState(), _getTotalCount());
      },


      /**
       * @function getCurrentPageIndex
       * @memberof wix-dataset
       * @summary Gets the index of the dataset's current page.
       * @syntax
       * function getCurrentPageIndex(): number
       * @returns {external:Number}
       * @description
       *  The `getCurrentPageIndex()` function returns the index of current dataset
       *  [page](#data-paging). The indicies of the dataset's pages start at `1`.
       * @note
       *  A dataset needs to load its data before you call its `getCurrentPageIndex()` function.
       *  Usually a dataset finishes loading a short time after the page it is on finishes
       *  loading. So if you call `getCurrentPageIndex()` inside the page’s [`onReady()`]($w.html#onReady)
       *  event handler, the dataset might not be ready yet.
       *
       *  To call `getCurrentPageIndex()` as soon as possible after a page loads, use the **dataset's**
       *  [`onReady()`](#onReady) function inside the **page’s** [`onReady()`]($w.html#onReady)
       *  event handler to ensure that both the page and the dataset have finished loading.
       * @snippet [getCurrentPageIndex.es6=Get the current page's index]
       */
      getCurrentPageIndex: function getCurrentPageIndex() {
        assertDatasetLimitations(getState, 'getCurrentPageIndex', [READ, READ_WRITE]);

        return getCurrentIndex() === undefined ? null : reducer.getCurrentPageIndex(getState());
      },


      /**
       * @function loadPage
       * @memberof wix-dataset
       * @summary Loads the specified page.
       * @syntax
       * function loadPage(pageIndex: number): Promise&lt;<Object[]>&gt;
       * @param {external:Number} pageIndex The index of the page to load.
       * @description
       *  The `loadPage()` function returns a Promise that is resolved to
       *  an array of the specified [page](#data-paging)'s items when:
       *  + The current item is saved in the collection (if necessary).
       *  + The specified [page of data](#data-paging) is loaded.
       *  + Any connected elements have been updated with the new data.
       *  + The current item is updated to the first item in the loaded page.
       *
       *
       *  The indicies of the dataset's [pages](#data-paging) start at `1`.
       * @note
       *  A dataset needs to load its data before you call its `loadPage()` function.
       *  Usually a dataset finishes loading a short time after the page it is on finishes
       *  loading. So if you call `loadPage()` inside the page’s [`onReady()`]($w.html#onReady)
       *  event handler, the dataset might not be ready yet.
       *
       *  To call `loadPage()` as soon as possible after a page loads, use the **dataset's**
       *  [`onReady()`](#onReady) function inside the **page’s** [`onReady()`]($w.html#onReady)
       *  event handler to ensure that both the page and the dataset have finished loading.
       * @snippet [loadPage.es6=Move to the fourth page of dataset content]
       * @snippet [loadPage_onReady.es6=Move to the fourth page of dataset content when the page loads]
       * @returns {Promise}
       * @fulfill {external:Object[]} When the specified page has been loaded and any connected elements have been updated.
       * @reject {String} An error message.
       * @see [previousPage( )](#previousPage)
       * @see [nextPage( )](#nextPage)
       */
      loadPage: function () {
        var _ref32 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee29(pageNumber) {
          var _this12 = this;

          return regeneratorRuntime.wrap(function _callee29$(_context29) {
            while (1) {
              switch (_context29.prev = _context29.next) {
                case 0:
                  assertDatasetLimitations(getState, 'loadPage', [READ, READ_WRITE], false);
                  assertScopeIsNotFixedItem(isFixedItem, 'loadPage');
                  assertDatasetReady(getState, 'loadPage');
                  assertValidPageIndex(pageNumber, api.getTotalPageCount());

                  _context29.prev = 4;
                  _context29.next = 7;
                  return queue(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee28() {
                    var _ref34, items;

                    return regeneratorRuntime.wrap(function _callee28$(_context28) {
                      while (1) {
                        switch (_context28.prev = _context28.next) {
                          case 0:
                            if (reducer.isReadOnly(getState())) {
                              _context28.next = 3;
                              break;
                            }

                            _context28.next = 3;
                            return flushDraft();

                          case 3:
                            _context28.next = 5;
                            return dispatch(recordActions.loadPage(pageNumber));

                          case 5:
                            _context28.next = 7;
                            return recordActions.fetchCurrentPage(recordStore, getState());

                          case 7:
                            _ref34 = _context28.sent;
                            items = _ref34.items;
                            return _context28.abrupt('return', items);

                          case 10:
                          case 'end':
                            return _context28.stop();
                        }
                      }
                    }, _callee28, _this12);
                  })));

                case 7:
                  return _context29.abrupt('return', _context29.sent);

                case 10:
                  _context29.prev = 10;
                  _context29.t0 = _context29['catch'](4);

                  fireEvent('datasetError', 'loadPage', _context29.t0);
                  throw _context29.t0;

                case 14:
                case 'end':
                  return _context29.stop();
              }
            }
          }, _callee29, this, [[4, 10]]);
        }));

        function loadPage(_x4) {
          return _ref32.apply(this, arguments);
        }

        return loadPage;
      }(),
      handshake: function handshake(handshakeInfo) {
        assertDatasetLimitations(getState, 'handshake', [READ, READ_WRITE, WRITE], false);
        handshakes.push(handshakeInfo);
        dispatch(performHandshake(handshakeInfo));
      },


      inScope: function inScope(componentId, itemId) {
        assertDatasetLimitations(getState, 'inScope', [READ, WRITE, READ_WRITE], false);
        var scope = scopeStore.getScope({ componentId: componentId, itemId: itemId });
        return scope ? scope.staticExports : api;
      },

      isConnectedToComponent: function isConnectedToComponent(componentId) {
        assertDatasetLimitations(getState, 'isConnectedToComponent', [READ, WRITE, READ_WRITE], false);
        return reducer.getConnectedComponents(getState()).includes(componentId);
      },

      /**
       * @function getPageSize
       * @memberof wix-dataset
       * @summary Gets the dataset's page size.
       * @syntax
       * function getPageSize(): number
       * @returns {external:Number}
       * @description
       *  Gets the current [page](#data-paging) size set in the Editor or using the
       *  [`setPageSize`](#setPageSize) function.
       * @snippet [getPageSize.es6=Get the current page size]
       * @see [setPageSize( )](#setPageSize)
       */
      getPageSize: function getPageSize() {
        assertDatasetLimitations(getState, 'getPageSize', [READ, READ_WRITE]);
        return reducer.getPaginationData(getState()).size;
      },

      /**
       * @function setPageSize
       * @memberof wix-dataset
       * @summary Sets the dataset's page size.
       * @param {external:Number} pageSize The new page size.
       * @instance
       * @syntax
       * function setPageSize(pageSize: number): Promise&lt;void&gt;
       * @description
       *  The `setPage()` function returns a Promise that is resolved when:
       *  + The current item is saved in the collection (if necessary).
       *  + The dataset's [page](#data-paging) size is reset.
       *  + The dataset is refreshed, and any connected elements have been updated.
       *
       *
       *  Because setting the [page](#data-paging) size refreshes the dataset, the dataset's
       *  current item is reset to the first item in the dataset.
       *
       *  Calling `setPageSize()` on a read-only dataset causes an error.
       * @snippet [setPageSize.es6=Set a dataset's page size]
       * @returns {Promise}
       * @fulfill {void} When the page size has been set.
       * @reject {external:Error} An error object.
       * @see [getPageSize( )](#getPageSize)
       */
      setPageSize: function () {
        var _ref35 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee30(size) {
          return regeneratorRuntime.wrap(function _callee30$(_context30) {
            while (1) {
              switch (_context30.prev = _context30.next) {
                case 0:
                  assertDatasetLimitations(getState, 'setPageSize', [READ, READ_WRITE], false);
                  assertValidNaturalNumber('size', size);

                  _context30.prev = 2;

                  if (reducer.isReadOnly(getState())) {
                    _context30.next = 6;
                    break;
                  }

                  _context30.next = 6;
                  return flushDraft();

                case 6:
                  dispatch(datasetActions.setPaginationData({ size: size }));
                  _context30.next = 9;
                  return dispatch(recordActions.refresh());

                case 9:
                  _context30.next = 15;
                  break;

                case 11:
                  _context30.prev = 11;
                  _context30.t0 = _context30['catch'](2);

                  fireEvent('datasetError', 'setPageSize', _context30.t0);
                  throw _context30.t0;

                case 15:
                case 'end':
                  return _context30.stop();
              }
            }
          }, _callee30, this, [[2, 11]]);
        }));

        function setPageSize(_x5) {
          return _ref35.apply(this, arguments);
        }

        return setPageSize;
      }()
    };

    var routerDatasetApi = routerDatasetApiCreator({
      recordStore: recordStore,
      getState: getState,
      datasetType: datasetType
    });

    var api = mapValues_(Object.assign({}, baseApi, routerDatasetApi), function (apiFunction, functionName) {
      return  false ? verboseWrapper(apiFunction, functionName) : apiFunction;
    });
    return mapValues_(api, function (apiFunction, functionName) {
      return flow_(errorBoundaries.applicationCodeZone, partial_(withBreadcrumbs, functionName))(apiFunction);
    });
  };
};

module.exports = function (_ref36) {
  var store = _ref36.store,
      recordStore = _ref36.recordStore,
      services = _ref36.services,
      datasetId = _ref36.datasetId,
      datasetType = _ref36.datasetType,
      errorBoundaries = _ref36.errorBoundaries,
      isFixedItem = _ref36.isFixedItem;
  return datasetApiCreator({
    store: store,
    recordStore: recordStore,
    services: services,
    datasetId: datasetId,
    datasetType: datasetType,
    errorBoundaries: errorBoundaries,
    isFixedItem: isFixedItem
  });
};

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var mapValues_ = __webpack_require__(0).mapValues;

var _require = __webpack_require__(139),
    assertDatasetTypeIsRouter = _require.assertDatasetTypeIsRouter;

var routerDatasetApiCreator = function routerDatasetApiCreator(_ref) {
  var recordStore = _ref.recordStore,
      getState = _ref.getState,
      datasetType = _ref.datasetType;

  var routerDatasetApi = {
    getNextDynamicPage: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return recordStore().matchWith({
                  Nothing: function Nothing() {
                    return null;
                  },
                  Just: function Just(_ref3) {
                    var service = _ref3.value;

                    return service.getNextDynamicPage();
                  }
                });

              case 2:
                return _context.abrupt('return', _context.sent);

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getNextDynamicPage() {
        return _ref2.apply(this, arguments);
      }

      return getNextDynamicPage;
    }(),
    getPreviousDynamicPage: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return recordStore().matchWith({
                  Nothing: function Nothing() {
                    return null;
                  },
                  Just: function Just(_ref5) {
                    var service = _ref5.value;

                    return service.getPreviousDynamicPage();
                  }
                });

              case 2:
                return _context2.abrupt('return', _context2.sent);

              case 3:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getPreviousDynamicPage() {
        return _ref4.apply(this, arguments);
      }

      return getPreviousDynamicPage;
    }()
  };
  return mapValues_(routerDatasetApi, function (fn, functionName) {
    return function () {
      assertDatasetTypeIsRouter(datasetType, functionName);
      return fn.apply(undefined, arguments);
    };
  });
};

module.exports = routerDatasetApiCreator;

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* global VERBOSE */

var verboseWrapper = function verboseWrapper(func, explicitName) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    // eslint-disable-next-line no-console
    console.verbose("wix-dataset " + explicitName + " was called with " + JSON.stringify(args));
    try {
      var result = func.apply(undefined, args);
      // eslint-disable-next-line no-console
      console.verbose("wix-dataset " + explicitName + " response " + JSON.stringify(result));
      return result;
    } catch (e) {
      // eslint-disable-next-line no-console
      console.verbose("wix-dataset " + explicitName + " response " + e);
      throw e;
    }
  };
};

var verboseIfNeeded = function verboseIfNeeded(func, explicitName) {
  return  false ? verboseWrapper(func, explicitName) : func;
};

module.exports.verboseWrapper = verboseWrapper;
module.exports.verboseIfNeeded = verboseIfNeeded;

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var noop_ = __webpack_require__(0).noop;
var remove_ = __webpack_require__(0).remove;

var _require = __webpack_require__(140),
    reportCallbackError = _require.reportCallbackError;

module.exports = function () {
  var firePlatformEvent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : noop_;
  var errorReporter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop_;

  var isDisposed = false;
  var callbacks = {};

  var getCallbacks = function getCallbacks(eventName) {
    return callbacks[eventName] ? callbacks[eventName] : callbacks[eventName] = [];
  }; // WeakSet is not iterable.

  var register = function register(eventName, cb) {
    if (isDisposed) {
      return noop_;
    }

    getCallbacks(eventName).push(cb);
    return function () {
      remove_(getCallbacks(eventName), function (f) {
        return f === cb;
      });
    };
  };

  var executeHooks = function executeHooks(eventName) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return Promise.all(getCallbacks(eventName).map(function (cb) {
      try {
        return Promise.resolve(cb.apply(undefined, args));
      } catch (err) {
        return Promise.reject(err);
      }
    }));
  };

  var fireEvent = function fireEvent(eventName) {
    for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    firePlatformEvent.apply(undefined, [eventName].concat(args));
    executeHooks.apply(undefined, [eventName].concat(args)).catch(reportCallbackError(eventName, errorReporter));
  };

  var dispose = function dispose() {
    isDisposed = true;
    callbacks = {};
  };

  return {
    register: register,
    executeHooks: executeHooks,
    fireEvent: fireEvent,
    dispose: dispose
  };
};

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var includes_ = __webpack_require__(0).includes;
var get_ = __webpack_require__(0).get;

var _require = __webpack_require__(2),
    isDatasetReady = _require.isDatasetReady,
    hasCurrentRecord = _require.hasCurrentRecord,
    selectCurrentRecordIndex = _require.selectCurrentRecordIndex,
    isReadOnly = _require.isReadOnly,
    getPaginationData = _require.getPaginationData,
    selectNextDynamicPageUrl = _require.selectNextDynamicPageUrl,
    selectPreviousDynamicPageUrl = _require.selectPreviousDynamicPageUrl;

var isLinkableDisableableComponent = __webpack_require__(313);
var getDisableableInputComponents = __webpack_require__(314);
var getUniqueComponents = __webpack_require__(141);
var createBreadcrumbMessage = __webpack_require__(142);

var syncEnabledStateForComponentsNotDisabledByUser = function syncEnabledStateForComponentsNotDisabledByUser(store, componentAdapterContexts, Raven, datasetId, recordStore) {
  var getMatchingRecordCount = function getMatchingRecordCount() {
    return recordStore().chain(function (service) {
      return service.getMatchingRecordCount();
    });
  };

  var hasNextRecord = function hasNextRecord(state) {
    return hasCurrentRecord(state) && selectCurrentRecordIndex(state) < getMatchingRecordCount() - 1;
  };

  var hasPreviousRecord = function hasPreviousRecord(state) {
    return hasCurrentRecord(state) && selectCurrentRecordIndex(state) > 0;
  };

  var hasPreviousPage = function hasPreviousPage(state) {
    return getPaginationData(state).offset > 0;
  };

  var hasNextPage = function hasNextPage(state) {
    var _getPaginationData = getPaginationData(state),
        offset = _getPaginationData.offset,
        size = _getPaginationData.size,
        numPagesToShow = _getPaginationData.numPagesToShow;

    return size * numPagesToShow + offset < getMatchingRecordCount();
  };

  var isEditable = function isEditable(state) {
    return hasCurrentRecord(state) && !isReadOnly(state);
  };
  var shouldEnableLinkedComponent = function shouldEnableLinkedComponent(action, state) {
    return shouldEnableByAction[action](state);
  };
  var shouldEnableByAction = {
    new: function _new(state) {
      return !isReadOnly(state);
    },
    save: isEditable,
    revert: isEditable,
    remove: isEditable,
    next: hasNextRecord,
    previous: hasPreviousRecord,
    nextPage: hasNextPage,
    previousPage: hasPreviousPage,
    nextDynamicPage: function nextDynamicPage(state) {
      return selectNextDynamicPageUrl(state).hasUrl();
    },
    previousDynamicPage: function previousDynamicPage(state) {
      return selectPreviousDynamicPageUrl(state).hasUrl();
    },
    loadMore: hasNextPage
  };

  var DISABLEABLE_ACTIONS = Object.keys(shouldEnableByAction);
  var isBoundToDisableableAction = function isBoundToDisableableAction(comp) {
    return includes_(DISABLEABLE_ACTIONS, get_(comp, 'connectionConfig.events.onClick.action'));
  };
  var getDisableableLinkedComponents = function getDisableableLinkedComponents(cac) {
    return getUniqueComponents(cac.map(function (_ref) {
      var component = _ref.component;
      return component;
    })).filter(isLinkableDisableableComponent).filter(isBoundToDisableableAction);
  };

  var updateComponentEnabledState = function updateComponentEnabledState(comp, shouldBeEnabled, Raven, datasetId) {
    if (comp.enabled !== shouldBeEnabled) {
      shouldBeEnabled ? comp.enable() : comp.disable();
      Raven.captureBreadcrumb({
        category: 'components',
        message: createBreadcrumbMessage(comp.uniqueId + ' changed to ' + (shouldBeEnabled ? 'enabled' : 'disabled'), datasetId)
      });
    }
  };

  var isEnabled = function isEnabled(comp) {
    return comp.enabled;
  };
  var inputComponents = getDisableableInputComponents(componentAdapterContexts).filter(isEnabled);
  var linkedComponents = getDisableableLinkedComponents(componentAdapterContexts).filter(isEnabled);

  var unsubscribe = store.subscribe(function () {
    var state = store.getState();
    if (!isDatasetReady(state)) {
      return;
    }

    var shouldInputComponentsBeEnabled = isEditable(state);
    inputComponents.forEach(function (component) {
      updateComponentEnabledState(component, shouldInputComponentsBeEnabled, Raven, datasetId);
    });

    linkedComponents.forEach(function (component) {
      var action = component.connectionConfig.events.onClick.action;
      var shouldBeEnabled = shouldEnableLinkedComponent(action, state);
      updateComponentEnabledState(component, shouldBeEnabled, Raven, datasetId);
    });
  });

  return unsubscribe;
};

module.exports = function (store, componentAdapterContexts, Raven, datasetId, recordStore) {
  return syncEnabledStateForComponentsNotDisabledByUser(store, componentAdapterContexts, Raven, datasetId, recordStore);
};

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var includes_ = __webpack_require__(0).includes;

var _require = __webpack_require__(20),
    Button = _require.Button,
    IconButton = _require.IconButton;

var LINKABLE_COMPONENTS = [Button, IconButton];

module.exports = function (component) {
  return includes_(LINKABLE_COMPONENTS, component.type);
};

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getInputComponents = __webpack_require__(315);

var _require = __webpack_require__(44),
    DROPDOWN_OPTIONS = _require.DROPDOWN_OPTIONS;

module.exports = function (contexts) {
  return getInputComponents(contexts.filter(function (_ref) {
    var role = _ref.role;
    return role !== DROPDOWN_OPTIONS;
  }));
};

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var map_ = __webpack_require__(0).map;
var getUniqueComponents = __webpack_require__(141);
var isInputComponent = __webpack_require__(64);

module.exports = function (contexts) {
  return getUniqueComponents(map_(contexts, 'component').filter(isInputComponent));
};

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(66),
    isFieldFromReferencedCollection = _require.isFieldFromReferencedCollection,
    getReferenceFieldName = _require.getReferenceFieldName,
    getFieldFromReferencedCollectionName = _require.getFieldFromReferencedCollectionName;

var get_ = __webpack_require__(0).get;

module.exports = function (schema, relatedSchemas) {
  return function (fieldName) {
    if (isFieldFromReferencedCollection(fieldName)) {
      var referenceFieldName = getReferenceFieldName(fieldName);
      var fieldFromReferencedCollectionName = getFieldFromReferencedCollectionName(fieldName);
      var referencedCollection = schema.fields[referenceFieldName].referencedCollection;
      return get_(relatedSchemas[referencedCollection].fields, [fieldFromReferencedCollectionName, 'type']);
    }
    return get_(schema, ['fields', fieldName, 'type']);
  };
};

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var unset_ = __webpack_require__(0).unset;

module.exports = function (ravenProxy) {
  var scopesMap = {};
  return {
    setScope: function setScope(_ref, scope) {
      var componentId = _ref.componentId,
          itemId = _ref.itemId;

      ravenProxy.captureBreadcrumb({
        level: 'info',
        category: 'scopeStore',
        message: 'adding scope',
        data: { componentId: componentId, itemId: itemId }
      });
      scopesMap[componentId] = scopesMap[componentId] || {};
      scopesMap[componentId][itemId] = scope;
    },
    getScope: function getScope(_ref2) {
      var componentId = _ref2.componentId,
          itemId = _ref2.itemId;

      var componentScopes = scopesMap[componentId];
      return componentScopes && componentScopes[itemId];
    },
    removeScope: function removeScope(_ref3) {
      var componentId = _ref3.componentId,
          itemId = _ref3.itemId;

      ravenProxy.captureBreadcrumb({
        level: 'info',
        category: 'scopeStore',
        message: 'removing scope',
        data: { componentId: componentId, itemId: itemId }
      });
      var componentScopes = scopesMap[componentId];
      if (componentScopes) {
        componentScopes[itemId].dispose();
        unset_(componentScopes, itemId);
      }
    },
    getAll: function getAll() {
      return Object.values(scopesMap).reduce(function (acc, curr) {
        return acc.concat(Object.values(curr));
      }, []);
    }
  };
};

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var cloneDeep_ = __webpack_require__(0).cloneDeep;
var noop_ = __webpack_require__(0).noop;

var addScopeToAllHandshakes = function addScopeToAllHandshakes(handshakes, _ref) {
  var componentId = _ref.componentId,
      itemId = _ref.itemId;
  return handshakes.map(function (handshake) {
    return Object.assign({}, handshake, {
      controllerApi: handshake.controllerApi.inScope(componentId, itemId)
    });
  });
};

var createScopeUniqueId = function createScopeUniqueId(uniqueId, scopeId) {
  return [uniqueId, 'componentId', scopeId.componentId, 'itemId', scopeId.itemId].join('_');
};

module.exports = function (createDataset, datasetParams) {
  return {
    createDetailsScope: function createDetailsScope(scopeId) {
      return createDataset(Object.assign({}, datasetParams, {
        firePlatformEvent: noop_,
        uniqueId: createScopeUniqueId(datasetParams.uniqueId, scopeId),
        isScoped: true,
        handshakes: addScopeToAllHandshakes(datasetParams.services().handshakes, scopeId)
      }));
    },
    createFixedItemScope: function createFixedItemScope(scopeId, fixedItem) {
      var newControllerConfig = cloneDeep_(datasetParams.controllerConfig);
      newControllerConfig.dataset.filter = datasetParams.wixDataProxy.filter().eq('_id', fixedItem._id)._build();

      return createDataset(Object.assign({}, datasetParams, {
        controllerConfig: newControllerConfig,
        firePlatformEvent: noop_,
        routerData: { prefetchedData: { items: [fixedItem], totalCount: 1 } },
        uniqueId: createScopeUniqueId(datasetParams.uniqueId, scopeId),
        isScoped: true,
        isFixedItem: true
      }));
    }
  };
};

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var uniqBy_ = __webpack_require__(0).uniqBy;

var _require = __webpack_require__(320),
    findContainer = _require.findContainer;

var _require2 = __webpack_require__(321),
    createAdapterContext = _require2.createAdapterContext;

var _require3 = __webpack_require__(44),
    DETAILS_REPEATER = _require3.DETAILS_REPEATER,
    DETAILS_DATASET = _require3.DETAILS_DATASET;

var _require4 = __webpack_require__(324),
    getScopeType = _require4.getScopeType,
    SCOPE_TYPES = _require4.SCOPE_TYPES;

module.exports.findConnectedComponents = function (roles, $w) {
  var results = [];
  roles.forEach(function (role) {
    var components = $w('@' + role);
    components && components.forEach(function (component) {
      return component && results.push({ role: role, component: component });
    });
  });
  return results;
};

module.exports.createComponentAdapterContexts = function (_ref) {
  var connectedComponents = _ref.connectedComponents,
      adapterApi = _ref.adapterApi,
      getFieldType = _ref.getFieldType,
      ignoreItemsInRepeater = _ref.ignoreItemsInRepeater,
      $w = _ref.$w,
      dependencies = _ref.dependencies;

  var cacs = [];

  connectedComponents.forEach(function (_ref2) {
    var component = _ref2.component,
        role = _ref2.role;

    if (ignoreItemsInRepeater) {
      var isComponentInsidePrimaryOrDetailsRepeater = findContainer(component).map(function (container) {
        return getScopeType(container.uniqueId, dependencies, connectedComponents);
      }).map(function (scopeType) {
        return scopeType === SCOPE_TYPES.PRIMARY || scopeType === SCOPE_TYPES.DETAILS;
      }).getOrElse(false);

      if (isComponentInsidePrimaryOrDetailsRepeater) {
        return;
      }
    }

    var adapterContext = createAdapterContext({
      getFieldType: getFieldType,
      role: role,
      component: component,
      $w: $w
    });

    if (adapterApi().isValidContext(adapterContext)) {
      cacs.push(adapterContext);
    }
  });

  return cacs;
};

module.exports.createDetailsRepeatersAdapterContexts = function (connectedComponents, getFieldType, dependencies) {
  var detailsRepeaters = [];

  connectedComponents.forEach(function (_ref3) {
    var component = _ref3.component;

    findContainer(component).chain(function (container) {
      var scopeType = getScopeType(container.uniqueId, dependencies, connectedComponents);
      if (scopeType === SCOPE_TYPES.DETAILS) {
        detailsRepeaters.push(container);
      }
    });
  });

  var uniqDetailsRepeaters = uniqBy_(detailsRepeaters, 'id');
  return uniqDetailsRepeaters.map(function (detailsRepeater) {
    return createAdapterContext({
      getFieldType: getFieldType,
      role: DETAILS_REPEATER,
      component: detailsRepeater
    });
  });
};

module.exports.resolveHandshakes = function (datasetApi, components) {
  return components.filter(function (_ref4) {
    var role = _ref4.role;
    return role === DETAILS_DATASET;
  }).map(function (_ref5) {
    var component = _ref5.component,
        role = _ref5.role;
    return {
      controller: component,
      handshakeInfo: {
        controllerApi: datasetApi,
        connectionConfig: component.connectionConfig,
        role: DETAILS_DATASET
      }
    };
  });
};

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var maybe = __webpack_require__(1);

var _require = __webpack_require__(20),
    Repeater = _require.Repeater;

// isContainerType :: Type -> Bool


var isContainerType = function isContainerType(type) {
  return [Repeater].includes(type);
};

// Component = { id, component, role, children, parent }
// findContainer :: Component -> Maybe Container
var findContainer = function findContainer(component) {
  var parent = maybe.fromNullable(component).chain(function (_ref) {
    var parent = _ref.parent;
    return maybe.fromNullable(parent);
  });
  var container = parent.filter(function (_ref2) {
    var type = _ref2.type;
    return isContainerType(type);
  });
  return container.orElse(function () {
    return parent.chain(function (parent) {
      return findContainer(parent);
    });
  });
};

module.exports.findContainer = findContainer;

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var maybe = __webpack_require__(1);
var isPlainObject_ = __webpack_require__(0).isPlainObject;

var _require = __webpack_require__(322),
    resolveDynamicProperties = _require.resolveDynamicProperties;

var emptyConnectionConfig = __webpack_require__(323);
var componentTypes = __webpack_require__(20);

var swapComponentByTypeHandlers = _defineProperty({}, componentTypes.Page, function (_ref) {
  var $w = _ref.$w;
  return $w('Document');
});

var createAdapterContext = function createAdapterContext(_ref2) {
  var getFieldType = _ref2.getFieldType,
      role = _ref2.role,
      component = _ref2.component,
      $w = _ref2.$w;

  var swapComponentByType = swapComponentByTypeHandlers[component.type];
  var connectionConfig = maybe.fromNullable(component.connectionConfig).filter(isPlainObject_).map(function (connectionConfig) {
    return resolveDynamicProperties({ connectionConfig: connectionConfig }, role, getFieldType);
  }).getOrElse(emptyConnectionConfig);

  var adapterContext = {
    role: role,
    connectionConfig: connectionConfig,
    component: swapComponentByType ? swapComponentByType({ $w: $w }) : component
  };

  return adapterContext;
};

module.exports.createAdapterContext = createAdapterContext;

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var mapKeys_ = __webpack_require__(0).mapKeys;
var startsWith_ = __webpack_require__(0).startsWith;
var assign_ = __webpack_require__(0).assign;
var get_ = __webpack_require__(0).get;
var maybe = __webpack_require__(1);

var _require = __webpack_require__(136),
    FIELD_TYPES = _require.FIELD_TYPES;

var dynamicPropertiesHandlers = {
  $text: function $text(fieldType) {
    return fieldType === FIELD_TYPES.RICHTEXT ? 'html' : 'text';
  }
};

var resolveDynamicProperty = function resolveDynamicProperty(propName, propertyConfig, getFieldType) {
  return maybe.fromNullable(dynamicPropertiesHandlers[propName]).map(function (propHandler) {
    var fieldType = getFieldType(propertyConfig.fieldName);
    return propHandler(fieldType);
  }).getOrElse(propName);
};

exports.resolveDynamicProperties = function (_ref, role, getFieldType) {
  var connectionConfig = _ref.connectionConfig;
  return maybe.fromNullable(get_(connectionConfig, 'properties')).map(function (properties) {
    return mapKeys_(connectionConfig.properties, function (property, propName) {
      return startsWith_(propName, '$') ? resolveDynamicProperty(propName, property, getFieldType) : propName;
    });
  }).map(function (properties) {
    return assign_({}, connectionConfig, { properties: properties });
  }).getOrElse(connectionConfig);
};

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  properties: {},
  events: {}
};

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var SCOPE_TYPES = {
  PRIMARY: 'PRIMARY',
  DETAILS: 'DETAILS',
  OTHER: 'OTHER'
};

var getScopeType = function getScopeType(repeaterId, dependencies, connectedComponents) {
  if (connectedComponents.some(function (_ref) {
    var component = _ref.component;
    return component.uniqueId === repeaterId;
  })) {
    return SCOPE_TYPES.PRIMARY;
  }

  var isOneOfMyMastersConnectedToRepeater = Object.values(dependencies).some(function (dependency) {
    return dependency.controllerApi && dependency.controllerApi.isConnectedToComponent && dependency.controllerApi.isConnectedToComponent(repeaterId);
  });

  if (isOneOfMyMastersConnectedToRepeater) {
    return SCOPE_TYPES.DETAILS;
  }

  return SCOPE_TYPES.OTHER;
};

module.exports.SCOPE_TYPES = SCOPE_TYPES;
module.exports.getScopeType = getScopeType;

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var maybe = __webpack_require__(1);
var isPlainObject_ = __webpack_require__(0).isPlainObject;
var flatMap_ = __webpack_require__(0).flatMap;
var set_ = __webpack_require__(0).set;
var cloneDeep_ = __webpack_require__(0).cloneDeep;

var _require = __webpack_require__(326),
    shouldCurrentUserResolve = _require.shouldResolve;

var _require2 = __webpack_require__(327),
    shouldDataBindingResolve = _require2.shouldResolve;

var shouldResolve = function shouldResolve(filterExpression) {
  return shouldCurrentUserResolve(filterExpression) || shouldDataBindingResolve(filterExpression);
};

var getFilterExpressionsToResolve = function getFilterExpressionsToResolve(filterPart) {
  var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  if (shouldResolve(filterPart)) {
    return [{
      path: path.slice(),
      filterExpression: filterPart
    }];
  }

  if (Array.isArray(filterPart) || isPlainObject_(filterPart)) {
    return flatMap_(filterPart, function (value, key) {
      return getFilterExpressionsToResolve(value, path.concat(key));
    });
  }

  return [];
};

var resolveFilter = function resolveFilter(filterResolvers) {
  return function (filter) {
    var resolveValue = function resolveValue(filterExpression) {
      if (shouldCurrentUserResolve(filterExpression)) {
        return filterResolvers.currentUser();
      }

      if (shouldDataBindingResolve(filterExpression)) {
        return filterResolvers.dataBinding(filterExpression);
      }
    };

    var filterExpressionsToResolve = getFilterExpressionsToResolve(filter);

    var resolvedExpressions = filterExpressionsToResolve.reduce(function (acc, _ref) {
      var filterExpression = _ref.filterExpression,
          path = _ref.path;
      return acc.concat({
        path: path,
        resolvedValue: resolveValue(filterExpression)
      });
    }, []);

    var applyResolvedValue = function applyResolvedValue(filter, path, resolvedValue) {
      return resolvedValue.map(function (resolvedValue) {
        return set_(filter, path, resolvedValue);
      });
    };

    return resolvedExpressions.reduce(function (maybeResolvedFilter, _ref2) {
      var path = _ref2.path,
          resolvedValue = _ref2.resolvedValue;
      return maybeResolvedFilter.chain(function (filter) {
        return applyResolvedValue(filter, path, resolvedValue);
      });
    }, maybe.Just(cloneDeep_(filter)));
  };
};

var extractDependencies = function extractDependencies(filter) {
  var filterExpressionsToResolve = getFilterExpressionsToResolve(filter);
  return filterExpressionsToResolve.map(function (_ref3) {
    var filterExpression = _ref3.filterExpression;
    return filterExpression.filterId;
  });
};

var currentUserFilterResolver = function currentUserFilterResolver(wixCodeSdk) {
  return function () {
    return maybe.fromNullable(wixCodeSdk.user.currentUser).chain(function (currentUser) {
      return maybe.fromNullable(currentUser.id);
    });
  };
};

var dataBindingFilterResolver = function dataBindingFilterResolver(dependenciesMap) {
  return function (_ref4) {
    var filterId = _ref4.filterId;
    return maybe.fromNullable(dependenciesMap[filterId]).chain(function (_ref5) {
      var controllerApi = _ref5.controllerApi,
          fieldName = _ref5.fieldName;
      return maybe.fromNullable(controllerApi.getCurrentItem()).map(function (item) {
        return item[fieldName];
      });
    });
  };
};

module.exports.createFilterResolver = resolveFilter;
module.exports.extractDependencies = extractDependencies;
module.exports.createValueResolvers = function (dependenciesMap, wixSdk) {
  return {
    dataBinding: dataBindingFilterResolver(dependenciesMap),
    currentUser: currentUserFilterResolver(wixSdk)
  };
};

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var isPlainObject_ = __webpack_require__(0).isPlainObject;

var RESOLVER_KEY = __webpack_require__(143);
var RESOLVER_VALUE = 'currentUser';

module.exports.addResolver = function () {
  return _defineProperty({}, RESOLVER_KEY, RESOLVER_VALUE);
};

module.exports.shouldResolve = function (filterExpression) {
  return isPlainObject_(filterExpression) && filterExpression[RESOLVER_KEY] === RESOLVER_VALUE;
};

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var isPlainObject_ = __webpack_require__(0).isPlainObject;

var RESOLVER_KEY = __webpack_require__(143);
var RESOLVER_VALUE = 'dataBinding';

module.exports.addResolver = function (filterExpression) {
  return Object.assign({}, filterExpression, _defineProperty({}, RESOLVER_KEY, RESOLVER_VALUE));
};

module.exports.shouldResolve = function (filterExpression) {
  return isPlainObject_(filterExpression) && filterExpression[RESOLVER_KEY] === RESOLVER_VALUE;
};

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
  var dependencies = {};

  var unsubscribeHandles = [];

  return {
    get: function get() {
      return dependencies;
    },
    add: function add(entries) {
      return Object.assign(dependencies, entries);
    },
    saveHandle: function saveHandle(handle) {
      return unsubscribeHandles.push(handle);
    },
    unsubscribe: function unsubscribe() {
      unsubscribeHandles.forEach(function (h) {
        return h();
      });
      unsubscribeHandles = [];
    }
  };
};

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var flow_ = __webpack_require__(0).flow;
var times_ = __webpack_require__(0).times;
var flatten_ = __webpack_require__(0).flatten;
var isEqual_ = __webpack_require__(0).isEqual;
var range_ = __webpack_require__(0).range;
var isPlainObject_ = __webpack_require__(0).isPlainObject;
var maybe = __webpack_require__(1);
var result = __webpack_require__(18);

var _require = __webpack_require__(144),
    constructUrl = _require.constructUrl,
    parseUrl = _require.parseUrl,
    parseUrlPattern = _require.parseUrlPattern;

var breadcrumbWrapper = __webpack_require__(63);
var sequence = __webpack_require__(330);
var readWriteModes = __webpack_require__(24);

var queryResults = __webpack_require__(26);

var _require2 = __webpack_require__(27),
    cleanseRecord = _require2.cleanseRecord,
    createDraft = _require2.createDraft,
    getRecordId = _require2.getRecordId,
    hasDraft = _require2.hasDraft,
    isRecordPristine = _require2.isRecordPristine;

var _require3 = __webpack_require__(334),
    collectMissingRanges = _require3.collectMissingRanges,
    freshScope = _require3.freshScope,
    insertRecordAtIndex = _require3.insertRecordAtIndex,
    overwriteRecordAtIndex = _require3.overwriteRecordAtIndex,
    recordIndexById = _require3.recordIndexById,
    removeRecordById = _require3.removeRecordById,
    scopeHasRecord = _require3.scopeHasRecord,
    setNewRecordMarkers = _require3.setNewRecordMarkers,
    setSeedInScope = _require3.setSeedInScope,
    storeResultsInScope = _require3.storeResultsInScope,
    updateNewRecordMarkers = _require3.updateNewRecordMarkers,
    updateNumMatchingRecords = _require3.updateNumMatchingRecords;

var _require4 = __webpack_require__(187),
    doesRecordExist = _require4.doesRecordExist,
    freshCollection = _require4.freshCollection,
    getDraftOrRecord = _require4.getDraftOrRecord,
    getScope = _require4.getScope,
    insertDraft = _require4.insertDraft,
    insertRecord = _require4.insertRecord,
    iterateScopes = _require4.iterateScopes,
    readFromCollection = _require4.readFromCollection,
    removeDraft = _require4.removeDraft,
    removeRecord = _require4.removeRecord,
    resetDraft = _require4.resetDraft,
    setScope = _require4.setScope,
    storeQueryResults = _require4.storeQueryResults,
    updateRecordFields = _require4.updateRecordFields,
    updateScope = _require4.updateScope;

var _require5 = __webpack_require__(463),
    freshStore = _require5.freshStore,
    getCollection = _require5.getCollection,
    setCollection = _require5.setCollection,
    updateCollection = _require5.updateCollection;

var _require6 = __webpack_require__(54),
    registrar = _require6.registrar;

var WIXDATA_MAX_RECORD_LIMIT = 1000;
var ignoreArgs = ['setFieldsValues', 'newRecord'];

module.exports = function (_ref) {
  var wixDataProxy = _ref.wixDataProxy,
      mainCollectionName = _ref.mainCollectionName,
      includes = _ref.includes,
      readWriteType = _ref.readWriteType,
      datasetType = _ref.datasetType,
      dynamicPagesData = _ref.dynamicPagesData,
      Raven = _ref.Raven,
      getSchema = _ref.getSchema;

  var theStore = freshStore(mainCollectionName);
  var onChangeHandlers = [];

  var service = function service(_ref2) {
    var pageSize = _ref2.pageSize,
        sort = _ref2.sort,
        filter = _ref2.filter,
        seed = _ref2.seed,
        controllerId = _ref2.controllerId,
        byRefField = _ref2.byRefField;

    var scopeKey = JSON.stringify({ filter: filter, sort: sort });
    var collectionName = byRefField ? getSchema().fields[byRefField].referencedCollection : mainCollectionName;
    var getCurrentCollection = getCollection(collectionName);
    var updateCurrentCollection = updateCollection(collectionName);
    var getCurrentScope = flow_(getCurrentCollection, getScope(scopeKey));
    var updateCurrentScope = updateScope(scopeKey);

    // pageAlign :: Integer -> Integer
    var pageAlignedFromIndex = function pageAlignedFromIndex(from) {
      return from - from % pageSize;
    };

    // pageAlign :: (Integer, Integer) -> Integer
    var pageAlignedToIndex = function pageAlignedToIndex(from, to) {
      return Math.ceil((pageAlignedFromIndex(from) + (to - pageAlignedFromIndex(from))) / pageSize) * pageSize;
    };

    // findRecords :: (Integer, Integer) -> Promise QueryResults
    var findRecords = function findRecords(offset, length) {
      return wixDataProxy.find(collectionName, filter, sort, offset, length, undefined, byRefField ? undefined : includes).then(function (wixDataQueryResults) {
        return queryResults.fromWixDataQueryResults(wixDataQueryResults, offset);
      });
    };

    // siblingDynamicPage :: (RELATIVE_DIRECTION) -> Promise
    var siblingDynamicPage = function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref3) {
        var _ref3$relativeDirecti = _ref3.relativeDirectionIsBackwards,
            relativeDirectionIsBackwards = _ref3$relativeDirecti === undefined ? false : _ref3$relativeDirecti;

        var dynamicUrl, userDefinedFilter, dynamicUrlPatternFieldsValues, _parseUrl, pattern, _parseUrlPattern, patternFields, recursiveSiblingDynamicPage, joinedQueries, _ref5, items, firstRecord;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                recursiveSiblingDynamicPage = function recursiveSiblingDynamicPage(currentFieldIndex) {
                  if (currentFieldIndex === undefined) currentFieldIndex = patternFields.length - 1;
                  if (currentFieldIndex === -1) return [];

                  var indexField = patternFields[currentFieldIndex];

                  var query = wixDataProxy.query(collectionName);
                  query.filterTree = userDefinedFilter;

                  if (relativeDirectionIsBackwards) {
                    var _query;

                    query = (_query = query).descending.apply(_query, _toConsumableArray(patternFields));
                  } else {
                    var _query2;

                    query = (_query2 = query).ascending.apply(_query2, _toConsumableArray(patternFields));
                  }

                  if (relativeDirectionIsBackwards) {
                    query = query.lt(indexField, dynamicUrlPatternFieldsValues[indexField]);
                  } else {
                    query = query.gt(indexField, dynamicUrlPatternFieldsValues[indexField]);
                  }

                  range_(currentFieldIndex).forEach(function (i) {
                    return query = query.eq(patternFields[i], dynamicUrlPatternFieldsValues[patternFields[i]]);
                  });

                  return [query.limit(1)].concat(recursiveSiblingDynamicPage(currentFieldIndex - 1));
                };

                dynamicUrl = dynamicPagesData.dynamicUrl, userDefinedFilter = dynamicPagesData.userDefinedFilter, dynamicUrlPatternFieldsValues = dynamicPagesData.dynamicUrlPatternFieldsValues;
                _parseUrl = parseUrl(dynamicUrl), pattern = _parseUrl.pattern;
                _parseUrlPattern = parseUrlPattern(pattern), patternFields = _parseUrlPattern.fields;
                joinedQueries = recursiveSiblingDynamicPage().reduce(function (result, query) {
                  return result.or(query);
                });
                _context.next = 7;
                return joinedQueries.find();

              case 7:
                _ref5 = _context.sent;
                items = _ref5.items;
                firstRecord = items.length > 0 ? items[0] : null;
                return _context.abrupt('return', firstRecord ? constructUrl(firstRecord, dynamicUrl) : null);

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      return function siblingDynamicPage(_x) {
        return _ref4.apply(this, arguments);
      };
    }();

    // fetchMissingRanges :: (Scope, Integer, Integer) -> Promise ([QueryResults])
    var fetchMissingRanges = function fetchMissingRanges(scope, fromIndex, toIndex) {
      var fetchFrom = pageAlignedFromIndex(fromIndex);
      var fetchTo = pageAlignedToIndex(fromIndex, toIndex);
      var missingRanges = collectMissingRanges(scope, fetchFrom, fetchTo);
      var correctedRanges = missingRanges.filter(function (_ref6) {
        var _ref7 = _slicedToArray(_ref6, 2),
            from = _ref7[0],
            length = _ref7[1];

        return length <= WIXDATA_MAX_RECORD_LIMIT;
      }).concat(flatten_(missingRanges.filter(function (_ref8) {
        var _ref9 = _slicedToArray(_ref8, 2),
            from = _ref9[0],
            length = _ref9[1];

        return length > WIXDATA_MAX_RECORD_LIMIT;
      }).map(function (_ref10) {
        var _ref11 = _slicedToArray(_ref10, 2),
            from = _ref11[0],
            length = _ref11[1];

        return times_(Math.ceil(length / WIXDATA_MAX_RECORD_LIMIT), function (x) {
          return [from + x * WIXDATA_MAX_RECORD_LIMIT, Math.min(WIXDATA_MAX_RECORD_LIMIT, length - x * WIXDATA_MAX_RECORD_LIMIT)];
        });
      })));

      return Promise.all(correctedRanges.map(function (range) {
        return findRecords.apply(undefined, _toConsumableArray(range));
      }));
    };

    // notify :: (Integer, Record, Record, ComponentId) -> Result [*] Error
    var notify = function notify(before, after, componentIdToExclude) {
      return sequence(result, onChangeHandlers.map(function (handler) {
        return result.try(function () {
          return handler(cleanseRecord(before), cleanseRecord(after), componentIdToExclude);
        });
      }));
    };

    // runApiCommand
    //   :: (([Store -> Store] -> (), Record, Integer, [*]) -> *, () -> *, Integer, [*]) -> *
    var runApiCommand = function runApiCommand(f, g, index) {
      for (var _len = arguments.length, args = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
        args[_key - 3] = arguments[_key];
      }

      var recordId = getCurrentScope(theStore).records[index];
      var record = getDraftOrRecord(recordId, getCurrentCollection(theStore));

      return record.matchWith({
        Nothing: function Nothing() {
          return g();
        },
        Just: function Just(_ref12) {
          var value = _ref12.value;

          var update = function update() {
            theStore = flow_.apply(undefined, arguments)(theStore);
          };

          var notifyIfChanged = function notifyIfChanged(componentIdToExclude) {
            var updatedRecord = getDraftOrRecord(recordId, getCurrentCollection(theStore)).getOrElse(null);
            if (!isEqual_(value, updatedRecord)) {
              return notify(value, updatedRecord, componentIdToExclude);
            } else {
              return result.Ok([]);
            }
          };

          return f.apply(undefined, [{ update: update, notifyIfChanged: notifyIfChanged }, value, index].concat(args));
        }
      });
    };

    // withRecordByIndex
    //   :: (([Store -> Store] -> (), Record, Integer, [*]) -> *, () -> *) -> (Integer, [*]) -> *
    var withRecordByIndex = function withRecordByIndex(f, g) {
      return function (index) {
        for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          args[_key2 - 1] = arguments[_key2];
        }

        return runApiCommand.apply(undefined, [f, g, index].concat(args));
      };
    };

    // withRecordByIndexAsync
    //   :: (([Store -> Store] -> (), Record, Integer, [*]) -> *, () -> *) -> (Integer, [*]) -> *
    var withRecordByIndexAsync = function withRecordByIndexAsync(f, g) {
      return function () {
        var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(index) {
          for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
            args[_key3 - 1] = arguments[_key3];
          }

          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return runApiCommand.apply(undefined, [f, g, index].concat(_toConsumableArray(args)));

                case 2:
                  return _context2.abrupt('return', _context2.sent);

                case 3:
                case 'end':
                  return _context2.stop();
              }
            }
          }, _callee2, undefined);
        }));

        return function (_x2) {
          return _ref13.apply(this, arguments);
        };
      }();
    };

    // sanitise :: * -> *
    var sanitise = function sanitise(something) {
      var go = function go(object) {
        return Object.keys(object).filter(function (key) {
          return key.startsWith('_');
        }).reduce(function (acc, key) {
          return Object.assign(acc, _defineProperty({}, key, isPlainObject_(object[key]) ? go(object[key]) : object[key]));
        }, {});
      };

      if (queryResults.Results.hasInstance(something)) {
        return something.map(function (_ref14) {
          var items = _ref14.items;

          var sanitisedItems = items.map(function (item) {
            return go(item);
          });

          return { items: sanitisedItems };
        });
      } else if ((typeof something === 'undefined' ? 'undefined' : _typeof(something)) === 'object' && something) {
        return go(something);
      } else {
        return something;
      }
    };

    // createBreadcrumb :: (String, [*]) -> Breadcrumb
    var createBreadcrumb = function createBreadcrumb(fnName) {
      var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      return {
        category: 'recordStore',
        level: 'info',
        message: fnName + '(' + (ignoreArgs.includes(fnName) ? '..' + args.length + ' arguments..' : args.map(JSON.stringify)) + ') (' + controllerId + ')',
        data: {
          scope: scopeKey
        }
      };
    };

    var _breadcrumbWrapper = breadcrumbWrapper(Raven, createBreadcrumb, sanitise),
        withBreadcrumbs = _breadcrumbWrapper.withBreadcrumbs,
        withBreadcrumbsAsync = _breadcrumbWrapper.withBreadcrumbsAsync;

    var isNewRecord = function isNewRecord(record) {
      return record && !doesRecordExist(getRecordId(record), getCurrentCollection(theStore));
    };

    var api = {
      // getRecords :: (Integer, Integer) -> Promise QueryResults
      getRecords: withBreadcrumbsAsync('getRecords', function () {
        var _ref15 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(fromIndex, length) {
          var reader, isWriteOnly;
          return regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  reader = readFromCollection(scopeKey, fromIndex, fromIndex + length);
                  isWriteOnly = readWriteType === readWriteModes.WRITE;
                  return _context4.abrupt('return', reader(getCurrentCollection(theStore), isWriteOnly).orElse(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                    var missingRanges, notifyUpdatedRecords, go, oldStore;
                    return regeneratorRuntime.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            _context3.next = 2;
                            return fetchMissingRanges(getCurrentScope(theStore), fromIndex, fromIndex + length);

                          case 2:
                            missingRanges = _context3.sent;

                            notifyUpdatedRecords = function notifyUpdatedRecords(old, current) {
                              return Object.keys(old.records).filter(function (key) {
                                return isPlainObject_(current.records[key]) && current.records[key]._updatedDate > old.records[key]._updatedDate;
                              }).forEach(function (key) {
                                return notify(old.records[key], current.records[key]);
                              });
                            };

                            go = updateCurrentCollection(flow_.apply(undefined, _toConsumableArray(missingRanges.map(function (range) {
                              return flow_(storeQueryResults(range), updateCurrentScope(storeResultsInScope(range)));
                            }))));
                            oldStore = theStore;

                            theStore = go(theStore);
                            notifyUpdatedRecords(getCurrentCollection(oldStore), getCurrentCollection(theStore));
                            return _context3.abrupt('return', reader(getCurrentCollection(theStore), true));

                          case 9:
                          case 'end':
                            return _context3.stop();
                        }
                      }
                    }, _callee3, undefined);
                  }))));

                case 3:
                case 'end':
                  return _context4.stop();
              }
            }
          }, _callee4, undefined);
        }));

        return function (_x4, _x5) {
          return _ref15.apply(this, arguments);
        };
      }()),

      // seed :: () -> Promise ()
      seed: withBreadcrumbsAsync('seed', function () {
        if (getCurrentScope(theStore).numSeedRecords === 0) {
          return findRecords(0, pageSize).then(function (queryResult) {
            var go = updateCurrentCollection(flow_(storeQueryResults(queryResult), updateCurrentScope(setSeedInScope(queryResult))));

            theStore = go(theStore);
          });
        } else {
          return Promise.resolve();
        }
      }),

      // getSeedRecords :: () -> QueryResults
      getSeedRecords: withBreadcrumbs('getSeedRecords', function () {
        return readFromCollection(scopeKey, 0, getCurrentScope(theStore).numSeedRecords, getCurrentCollection(theStore), true);
      }),
      // getNextDynamicPage :: () -> Promise ()
      getNextDynamicPage: withBreadcrumbs('getNextDynamicPage', function () {
        return siblingDynamicPage({ relativeDirectionIsBackwards: false });
      }),

      // getPreviousDynamicPage :: () -> Promise ()
      getPreviousDynamicPage: withBreadcrumbs('getNextDynamicPage', function () {
        return siblingDynamicPage({ relativeDirectionIsBackwards: true });
      }),

      // getTotalCount :: () -> Integer
      getMatchingRecordCount: withBreadcrumbs('getMatchingRecordCount', function () {
        return getCurrentScope(theStore).numMatchingRecords;
      }),

      // getRecordById :: RecordId -> Maybe Record
      getRecordById: withBreadcrumbs('getRecordById', function (recordId) {
        return maybe.fromNullable(getCurrentCollection(theStore).records[recordId]);
      }),

      // removeRecord :: Integer -> Promise (Result)
      // recordId is a maybe because new records don't have IDs
      removeRecord: withBreadcrumbsAsync('removeRecord', withRecordByIndexAsync(function () {
        var _ref18 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(_ref17, record, index) {
          var update = _ref17.update,
              notifyIfChanged = _ref17.notifyIfChanged;
          var recordId, doUpdateMarkers, updateScopesFlow;
          return regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  recordId = getRecordId(record);

                  if (!(!isNewRecord(record) && recordId)) {
                    _context5.next = 4;
                    break;
                  }

                  _context5.next = 4;
                  return wixDataProxy.remove(collectionName, recordId);

                case 4:
                  doUpdateMarkers = function doUpdateMarkers(recordIndex) {
                    return function (markers) {
                      return markers.filter(function (marker) {
                        return marker !== recordIndex;
                      });
                    };
                  };

                  updateScopesFlow = iterateScopes(function (scope, scopeKey) {
                    return updateScope(scopeKey, flow_(removeRecordById(recordId), updateNumMatchingRecords(function (x) {
                      return x - 1;
                    }), updateNewRecordMarkers(doUpdateMarkers(recordIndexById(recordId, scope)))));
                  }, scopeHasRecord(recordId), getCurrentCollection(theStore));

                  update(updateCurrentCollection(flow_.apply(undefined, [flow_(removeDraft(record), removeRecord(recordId))].concat(_toConsumableArray(updateScopesFlow)))));
                  return _context5.abrupt('return', notifyIfChanged());

                case 8:
                case 'end':
                  return _context5.stop();
              }
            }
          }, _callee5, undefined);
        }));

        return function (_x6, _x7, _x8) {
          return _ref18.apply(this, arguments);
        };
      }(), function () {
        return Promise.resolve(result.Error('cannot remove record: index not found'));
      })),

      // reset :: () -> ()
      reset: withBreadcrumbs('reset', function () {
        return theStore = updateCurrentCollection(setScope(scopeKey, freshScope()))(theStore);
      }),

      // newRecord :: (Integer, DefaultDraft) -> ()
      newRecord: withBreadcrumbs('newRecord', function (index, defaultDraft) {
        // There Can Only Be One new record
        var draft = createDraft(Object.create(null), defaultDraft);
        var go = updateCurrentCollection(flow_(insertDraft(draft), updateCurrentScope(flow_(updateNumMatchingRecords(function (x) {
          return x + 1;
        }), setNewRecordMarkers([index]), insertRecordAtIndex(index, draft)))));

        theStore = go(theStore);
        notify(null, draft);
        return cleanseRecord(draft);
      }),

      // save :: Integer -> Promise(Record)
      saveRecord: withBreadcrumbsAsync('saveRecord', withRecordByIndexAsync(function () {
        var _ref20 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(_ref19, record, index) {
          var update = _ref19.update,
              notifyIfChanged = _ref19.notifyIfChanged;
          var postSaveRecord, doUpdateMarkers;
          return regeneratorRuntime.wrap(function _callee6$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  _context6.next = 2;
                  return wixDataProxy.save(collectionName, cleanseRecord(record), { includeReferences: true });

                case 2:
                  postSaveRecord = _context6.sent;

                  doUpdateMarkers = function doUpdateMarkers(markers) {
                    return markers.filter(function (marker) {
                      return marker !== index;
                    });
                  };

                  update(updateCurrentCollection(flow_(insertRecord(postSaveRecord), removeDraft(record), updateCurrentScope(flow_(overwriteRecordAtIndex(index, postSaveRecord), updateNewRecordMarkers(doUpdateMarkers))))));
                  notifyIfChanged();

                  return _context6.abrupt('return', cleanseRecord(postSaveRecord));

                case 7:
                case 'end':
                  return _context6.stop();
              }
            }
          }, _callee6, undefined);
        }));

        return function (_x9, _x10, _x11) {
          return _ref20.apply(this, arguments);
        };
      }(), function () {
        return Promise.reject(new Error('cannot save record: index not found'));
      })),

      // setFieldsValues :: (Integer, FieldsValues) -> Result
      setFieldsValues: withBreadcrumbs('setFieldsValues', withRecordByIndex(function (_ref21, record, _, fieldValues, componentIdToExclude) {
        var update = _ref21.update,
            notifyIfChanged = _ref21.notifyIfChanged;

        update(updateCurrentCollection(updateRecordFields(getRecordId(record), fieldValues)));
        return notifyIfChanged(componentIdToExclude);
      }, function () {
        return result.Error('cannot update field values: index not found');
      })),

      // isPristine :: Integer -> Boolean
      isPristine: withBreadcrumbs('isPristine', withRecordByIndex(function (_, record) {
        return isRecordPristine(record);
      }, function () {
        return true;
      })),

      // hasDraft :: Integer -> Boolean
      hasDraft: withBreadcrumbs('hasDraft', withRecordByIndex(function (_, record) {
        return hasDraft(record);
      }, function () {
        return false;
      })),

      // isNewRecord :: Integer -> Boolean
      isNewRecord: withBreadcrumbs('isNewRecord', withRecordByIndex(function (_, record) {
        return isNewRecord(record);
      }, function () {
        return true;
      })),

      // resetDraft :: (Integer, DefaultDraft) -> Result
      resetDraft: withBreadcrumbs('resetDraft', withRecordByIndex(function (_ref22, record, index, defaultDraft) {
        var update = _ref22.update,
            notifyIfChanged = _ref22.notifyIfChanged;

        update(updateCurrentCollection(isNewRecord(record) ? resetDraft(record, defaultDraft) : removeDraft(record)));
        return notifyIfChanged();
      }, function () {
        return result.Error('cannot reset draft: index not found');
      }))
    };

    if (!getCurrentCollection(theStore)) {
      theStore = setCollection(collectionName, freshCollection())(theStore);
    }

    if (!getCurrentCollection(theStore).scopes[scopeKey]) {
      theStore = updateCurrentCollection(flow_(storeQueryResults(seed), setScope(scopeKey, freshScope()), updateCurrentScope(setSeedInScope(seed))))(theStore);
    }

    return api;
  };

  service.onChange = registrar(onChangeHandlers);

  return service;
};

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var sequence = function sequence(f, ms) {
  return ms.reduce(function (acc, m) {
    return acc.chain(function (list) {
      return m.map(function (val) {
        return list.concat(val);
      });
    });
  }, f.of([]));
};

module.exports = sequence;

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

//     uuid.js
//
//     Copyright (c) 2010-2012 Robert Kieffer
//     MIT License - http://opensource.org/licenses/mit-license.php

// Unique ID creation requires a high quality random # generator.  We feature
// detect to determine the best RNG source, normalizing to a function that
// returns 128-bits of randomness, since that's what's usually required
var _rng = __webpack_require__(332);

// Maps for number <-> hex string conversion
var _byteToHex = [];
var _hexToByte = {};
for (var i = 0; i < 256; i++) {
  _byteToHex[i] = (i + 0x100).toString(16).substr(1);
  _hexToByte[_byteToHex[i]] = i;
}

// **`parse()` - Parse a UUID into it's component bytes**
function parse(s, buf, offset) {
  var i = (buf && offset) || 0, ii = 0;

  buf = buf || [];
  s.toLowerCase().replace(/[0-9a-f]{2}/g, function(oct) {
    if (ii < 16) { // Don't overflow!
      buf[i + ii++] = _hexToByte[oct];
    }
  });

  // Zero out remaining bytes if string was short
  while (ii < 16) {
    buf[i + ii++] = 0;
  }

  return buf;
}

// **`unparse()` - Convert UUID byte array (ala parse()) into a string**
function unparse(buf, offset) {
  var i = offset || 0, bth = _byteToHex;
  return  bth[buf[i++]] + bth[buf[i++]] +
          bth[buf[i++]] + bth[buf[i++]] + '-' +
          bth[buf[i++]] + bth[buf[i++]] + '-' +
          bth[buf[i++]] + bth[buf[i++]] + '-' +
          bth[buf[i++]] + bth[buf[i++]] + '-' +
          bth[buf[i++]] + bth[buf[i++]] +
          bth[buf[i++]] + bth[buf[i++]] +
          bth[buf[i++]] + bth[buf[i++]];
}

// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html

// random #'s we need to init node and clockseq
var _seedBytes = _rng();

// Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
var _nodeId = [
  _seedBytes[0] | 0x01,
  _seedBytes[1], _seedBytes[2], _seedBytes[3], _seedBytes[4], _seedBytes[5]
];

// Per 4.2.2, randomize (14 bit) clockseq
var _clockseq = (_seedBytes[6] << 8 | _seedBytes[7]) & 0x3fff;

// Previous uuid creation time
var _lastMSecs = 0, _lastNSecs = 0;

// See https://github.com/broofa/node-uuid for API details
function v1(options, buf, offset) {
  var i = buf && offset || 0;
  var b = buf || [];

  options = options || {};

  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;

  // UUID timestamps are 100 nano-second units since the Gregorian epoch,
  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();

  // Per 4.2.1.2, use count of uuid's generated during the current clock
  // cycle to simulate higher resolution clock
  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;

  // Time since last uuid creation (in msecs)
  var dt = (msecs - _lastMSecs) + (nsecs - _lastNSecs)/10000;

  // Per 4.2.1.2, Bump clockseq on clock regression
  if (dt < 0 && options.clockseq === undefined) {
    clockseq = clockseq + 1 & 0x3fff;
  }

  // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
  // time interval
  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
    nsecs = 0;
  }

  // Per 4.2.1.2 Throw error if too many uuids are requested
  if (nsecs >= 10000) {
    throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
  }

  _lastMSecs = msecs;
  _lastNSecs = nsecs;
  _clockseq = clockseq;

  // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
  msecs += 12219292800000;

  // `time_low`
  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
  b[i++] = tl >>> 24 & 0xff;
  b[i++] = tl >>> 16 & 0xff;
  b[i++] = tl >>> 8 & 0xff;
  b[i++] = tl & 0xff;

  // `time_mid`
  var tmh = (msecs / 0x100000000 * 10000) & 0xfffffff;
  b[i++] = tmh >>> 8 & 0xff;
  b[i++] = tmh & 0xff;

  // `time_high_and_version`
  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
  b[i++] = tmh >>> 16 & 0xff;

  // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
  b[i++] = clockseq >>> 8 | 0x80;

  // `clock_seq_low`
  b[i++] = clockseq & 0xff;

  // `node`
  var node = options.node || _nodeId;
  for (var n = 0; n < 6; n++) {
    b[i + n] = node[n];
  }

  return buf ? buf : unparse(b);
}

// **`v4()` - Generate random UUID**

// See https://github.com/broofa/node-uuid for API details
function v4(options, buf, offset) {
  // Deprecated - 'format' argument, as supported in v1.2
  var i = buf && offset || 0;

  if (typeof(options) == 'string') {
    buf = options == 'binary' ? new Array(16) : null;
    options = null;
  }
  options = options || {};

  var rnds = options.random || (options.rng || _rng)();

  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
  rnds[6] = (rnds[6] & 0x0f) | 0x40;
  rnds[8] = (rnds[8] & 0x3f) | 0x80;

  // Copy bytes to buffer, if provided
  if (buf) {
    for (var ii = 0; ii < 16; ii++) {
      buf[i + ii] = rnds[ii];
    }
  }

  return buf || unparse(rnds);
}

// Export public API
var uuid = v4;
uuid.v1 = v1;
uuid.v4 = v4;
uuid.parse = parse;
uuid.unparse = unparse;

module.exports = uuid;


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {
var rng;

var crypto = global.crypto || global.msCrypto; // for IE 11
if (crypto && crypto.getRandomValues) {
  // WHATWG crypto-based RNG - http://wiki.whatwg.org/wiki/Crypto
  // Moderately fast, high quality
  var _rnds8 = new Uint8Array(16);
  rng = function whatwgRNG() {
    crypto.getRandomValues(_rnds8);
    return _rnds8;
  };
}

if (!rng) {
  // Math.random()-based (RNG)
  //
  // If all else fails, use Math.random().  It's fast, but is of unspecified
  // quality.
  var  _rnds = new Array(16);
  rng = function() {
    for (var i = 0, r; i < 16; i++) {
      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
      _rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
    }

    return _rnds;
  };
}

module.exports = rng;


/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isPristine = Symbol('isPristine');

module.exports.isPristine = isPristine;

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var flow_ = __webpack_require__(0).flow;
var takeWhile_ = __webpack_require__(335);

var _require = __webpack_require__(54),
    assign = _require.assign,
    bind = _require.bind;

var _require2 = __webpack_require__(27),
    getRecordId = _require2.getRecordId;

// freshScope :: () -> Scope


var freshScope = function freshScope() {
  return Object.assign({}, {
    records: [],
    numMatchingRecords: 0,
    numSeedRecords: 0,
    newRecordMarkers: []
  });
};

// setScopeRecords :: [Record] -> Scope -> Scope
var setScopeRecords = function setScopeRecords(records) {
  return assign({ records: records });
};

// updateNumMatchingRecords :: (Integer -> Integer) -> Scope -> Scope
var updateNumMatchingRecords = function updateNumMatchingRecords(fn) {
  return function (scope) {
    return Object.assign({}, scope, {
      numMatchingRecords: fn(scope.numMatchingRecords)
    });
  };
};

// setNumMatchingRecords :: Integer -> Scope -> Scope
var setNumMatchingRecords = function setNumMatchingRecords(numMatchingRecords) {
  return function (scope) {
    return Object.assign({}, scope, {
      numMatchingRecords: numMatchingRecords + newRecordMarkersOffset(scope, 0)
    });
  };
};

// setNumSeedRecords :: Scope -> Scope
var setNumSeedRecords = function setNumSeedRecords(scope) {
  return Object.assign({}, scope, {
    numSeedRecords: Object.keys(scope.records).length
  });
};

// setSeedInScope :: QueryResult -> Scope -> Scope
var setSeedInScope = function setSeedInScope(seed) {
  return seed.matchWith({
    Empty: function Empty() {
      return function (_) {
        return _;
      };
    },
    Results: function Results(_ref) {
      var items = _ref.items,
          totalCount = _ref.totalCount,
          offset = _ref.offset;
      return flow_(setScopeRecords(items.map(function (item) {
        return getRecordId(item);
      })), setNumMatchingRecords(totalCount), setNumSeedRecords);
    }
  });
};

// setNewRecordMarkers :: Integer -> Scope -> Scope
var setNewRecordMarkers = function setNewRecordMarkers(newRecordMarkers) {
  return assign({ newRecordMarkers: newRecordMarkers });
};

// updateNewRecordMarkers :: (Integer -> Integer) -> Scope -> Scope
var updateNewRecordMarkers = function updateNewRecordMarkers(fn) {
  return function (scope) {
    return Object.assign({}, scope, { newRecordMarkers: fn(scope.newRecordMarkers) });
  };
};

// newRecordMarkersOffset :: (Scope, Integer) -> Integer
var newRecordMarkersOffset = function newRecordMarkersOffset(scope, index) {
  return scope.newRecordMarkers.filter(function (marker) {
    return marker <= index;
  }).length;
};

// storeResultsInScope :: QueryResults -> Scope -> Scope
var storeResultsInScope = function storeResultsInScope(queryResult) {
  return queryResult.matchWith({
    Empty: function Empty() {
      return function (_) {
        return _;
      };
    },
    Results: function Results(_ref2) {
      var items = _ref2.items,
          totalCount = _ref2.totalCount,
          offset = _ref2.offset;
      return flow_(setNumMatchingRecords(totalCount), items.length > 0 ? mergeRecords(offset, items) : function (_) {
        return _;
      });
    }
  });
};

// mergeRecords :: (Integer, [Record], Options) -> Scope -> Scope
var mergeRecords = function mergeRecords(startIndex, addedRecords) {
  var _ref3 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref3$overwrite = _ref3.overwrite,
      overwrite = _ref3$overwrite === undefined ? true : _ref3$overwrite,
      _ref3$fixIndex = _ref3.fixIndex,
      fixIndex = _ref3$fixIndex === undefined ? true : _ref3$fixIndex;

  var doMerge = function doMerge(scope) {
    var correctedStartIndex = startIndex + (fixIndex ? newRecordMarkersOffset(scope, startIndex) : 0);
    var padLength = Math.max(0, correctedStartIndex - scope.records.length);
    var tailIndex = correctedStartIndex + (overwrite ? addedRecords.length : 0);

    return scope.records.slice(0, correctedStartIndex).concat(Array(padLength)).concat(addedRecords.map(function (record) {
      return getRecordId(record);
    })).concat(scope.records.slice(tailIndex));
  };

  return bind(doMerge, setScopeRecords);
};

// overwriteRecordAtIndex :: (Integer, Record) -> Scope -> Scope
var overwriteRecordAtIndex = function overwriteRecordAtIndex(at, record) {
  return mergeRecords(at, [record], { fixIndex: false });
};

// insertRecordAtIndex :: (Integer, Record) -> Scope -> Scope
var insertRecordAtIndex = function insertRecordAtIndex(at, record) {
  return mergeRecords(at, [record], { overwrite: false, fixIndex: false });
};

// removeRecordById :: RecordId -> Scope -> Scope
var removeRecordById = function removeRecordById(id) {
  return bind(function (scope) {
    return scope.records.filter(function (recordId) {
      return recordId !== id;
    });
  }, setScopeRecords);
};

// recordIndexById :: (RecordId, Scope) -> Integer
var recordIndexById = function recordIndexById(id, scope) {
  return scope.records.indexOf(id);
};

// scopeHasRecord :: RecordId -> Scope -> Bool
var scopeHasRecord = function scopeHasRecord(id) {
  return function (scope) {
    return scope.records.includes(id);
  };
};

// countMissingRecords :: (Integer, Integer, [Record]) -> Integer
var countMissingRecords = function countMissingRecords(records, from, to) {
  return takeWhile_(function (_) {
    return typeof _ !== 'string';
  }, records.slice(from, to)).length;
};

// collectMissingRanges :: (Scope, Integer, Integer, [(Integer, Integer)]) -> [(Integer, Integer)]
var collectMissingRanges = function collectMissingRanges(scope, from, to) {
  var acc = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];

  var addMissingRange = function addMissingRange(acc, rangeStart, rangeEnd) {
    var indexCorrection = newRecordMarkersOffset(scope, from);
    var correctedFrom = rangeStart - indexCorrection;
    var correctedTo = rangeEnd - indexCorrection;
    return acc.concat([[correctedFrom, correctedTo - correctedFrom]]);
  };

  if (from >= scope.records.length) {
    return addMissingRange(acc, from, to);
  } else if (from >= to) {
    return acc;
  }

  var countNextMissingRecords = countMissingRecords(scope.records, from, to);
  if (countNextMissingRecords) {
    return collectMissingRanges(scope, from + countNextMissingRecords, to, addMissingRange(acc, from, from + countNextMissingRecords));
  } else {
    return collectMissingRanges(scope, from + 1, to, acc);
  }
};

module.exports.collectMissingRanges = collectMissingRanges;
module.exports.freshScope = freshScope;
module.exports.insertRecordAtIndex = insertRecordAtIndex;
module.exports.newRecordMarkersOffset = newRecordMarkersOffset;
module.exports.overwriteRecordAtIndex = overwriteRecordAtIndex;
module.exports.recordIndexById = recordIndexById;
module.exports.removeRecordById = removeRecordById;
module.exports.scopeHasRecord = scopeHasRecord;
module.exports.setNewRecordMarkers = setNewRecordMarkers;
module.exports.setSeedInScope = setSeedInScope;
module.exports.storeResultsInScope = storeResultsInScope;
module.exports.updateNewRecordMarkers = updateNewRecordMarkers;
module.exports.updateNumMatchingRecords = updateNumMatchingRecords;

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(145),
    func = convert('takeWhile', __webpack_require__(455));

func.placeholder = __webpack_require__(67);
module.exports = func;


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

var mapping = __webpack_require__(337),
    fallbackHolder = __webpack_require__(67);

/** Built-in value reference. */
var push = Array.prototype.push;

/**
 * Creates a function, with an arity of `n`, that invokes `func` with the
 * arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} n The arity of the new function.
 * @returns {Function} Returns the new function.
 */
function baseArity(func, n) {
  return n == 2
    ? function(a, b) { return func.apply(undefined, arguments); }
    : function(a) { return func.apply(undefined, arguments); };
}

/**
 * Creates a function that invokes `func`, with up to `n` arguments, ignoring
 * any additional arguments.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @param {number} n The arity cap.
 * @returns {Function} Returns the new function.
 */
function baseAry(func, n) {
  return n == 2
    ? function(a, b) { return func(a, b); }
    : function(a) { return func(a); };
}

/**
 * Creates a clone of `array`.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the cloned array.
 */
function cloneArray(array) {
  var length = array ? array.length : 0,
      result = Array(length);

  while (length--) {
    result[length] = array[length];
  }
  return result;
}

/**
 * Creates a function that clones a given object using the assignment `func`.
 *
 * @private
 * @param {Function} func The assignment function.
 * @returns {Function} Returns the new cloner function.
 */
function createCloner(func) {
  return function(object) {
    return func({}, object);
  };
}

/**
 * A specialized version of `_.spread` which flattens the spread array into
 * the arguments of the invoked `func`.
 *
 * @private
 * @param {Function} func The function to spread arguments over.
 * @param {number} start The start position of the spread.
 * @returns {Function} Returns the new function.
 */
function flatSpread(func, start) {
  return function() {
    var length = arguments.length,
        lastIndex = length - 1,
        args = Array(length);

    while (length--) {
      args[length] = arguments[length];
    }
    var array = args[start],
        otherArgs = args.slice(0, start);

    if (array) {
      push.apply(otherArgs, array);
    }
    if (start != lastIndex) {
      push.apply(otherArgs, args.slice(start + 1));
    }
    return func.apply(this, otherArgs);
  };
}

/**
 * Creates a function that wraps `func` and uses `cloner` to clone the first
 * argument it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} cloner The function to clone arguments.
 * @returns {Function} Returns the new immutable function.
 */
function wrapImmutable(func, cloner) {
  return function() {
    var length = arguments.length;
    if (!length) {
      return;
    }
    var args = Array(length);
    while (length--) {
      args[length] = arguments[length];
    }
    var result = args[0] = cloner.apply(undefined, args);
    func.apply(undefined, args);
    return result;
  };
}

/**
 * The base implementation of `convert` which accepts a `util` object of methods
 * required to perform conversions.
 *
 * @param {Object} util The util object.
 * @param {string} name The name of the function to convert.
 * @param {Function} func The function to convert.
 * @param {Object} [options] The options object.
 * @param {boolean} [options.cap=true] Specify capping iteratee arguments.
 * @param {boolean} [options.curry=true] Specify currying.
 * @param {boolean} [options.fixed=true] Specify fixed arity.
 * @param {boolean} [options.immutable=true] Specify immutable operations.
 * @param {boolean} [options.rearg=true] Specify rearranging arguments.
 * @returns {Function|Object} Returns the converted function or object.
 */
function baseConvert(util, name, func, options) {
  var setPlaceholder,
      isLib = typeof name == 'function',
      isObj = name === Object(name);

  if (isObj) {
    options = func;
    func = name;
    name = undefined;
  }
  if (func == null) {
    throw new TypeError;
  }
  options || (options = {});

  var config = {
    'cap': 'cap' in options ? options.cap : true,
    'curry': 'curry' in options ? options.curry : true,
    'fixed': 'fixed' in options ? options.fixed : true,
    'immutable': 'immutable' in options ? options.immutable : true,
    'rearg': 'rearg' in options ? options.rearg : true
  };

  var forceCurry = ('curry' in options) && options.curry,
      forceFixed = ('fixed' in options) && options.fixed,
      forceRearg = ('rearg' in options) && options.rearg,
      placeholder = isLib ? func : fallbackHolder,
      pristine = isLib ? func.runInContext() : undefined;

  var helpers = isLib ? func : {
    'ary': util.ary,
    'assign': util.assign,
    'clone': util.clone,
    'curry': util.curry,
    'forEach': util.forEach,
    'isArray': util.isArray,
    'isError': util.isError,
    'isFunction': util.isFunction,
    'isWeakMap': util.isWeakMap,
    'iteratee': util.iteratee,
    'keys': util.keys,
    'rearg': util.rearg,
    'toInteger': util.toInteger,
    'toPath': util.toPath
  };

  var ary = helpers.ary,
      assign = helpers.assign,
      clone = helpers.clone,
      curry = helpers.curry,
      each = helpers.forEach,
      isArray = helpers.isArray,
      isError = helpers.isError,
      isFunction = helpers.isFunction,
      isWeakMap = helpers.isWeakMap,
      keys = helpers.keys,
      rearg = helpers.rearg,
      toInteger = helpers.toInteger,
      toPath = helpers.toPath;

  var aryMethodKeys = keys(mapping.aryMethod);

  var wrappers = {
    'castArray': function(castArray) {
      return function() {
        var value = arguments[0];
        return isArray(value)
          ? castArray(cloneArray(value))
          : castArray.apply(undefined, arguments);
      };
    },
    'iteratee': function(iteratee) {
      return function() {
        var func = arguments[0],
            arity = arguments[1],
            result = iteratee(func, arity),
            length = result.length;

        if (config.cap && typeof arity == 'number') {
          arity = arity > 2 ? (arity - 2) : 1;
          return (length && length <= arity) ? result : baseAry(result, arity);
        }
        return result;
      };
    },
    'mixin': function(mixin) {
      return function(source) {
        var func = this;
        if (!isFunction(func)) {
          return mixin(func, Object(source));
        }
        var pairs = [];
        each(keys(source), function(key) {
          if (isFunction(source[key])) {
            pairs.push([key, func.prototype[key]]);
          }
        });

        mixin(func, Object(source));

        each(pairs, function(pair) {
          var value = pair[1];
          if (isFunction(value)) {
            func.prototype[pair[0]] = value;
          } else {
            delete func.prototype[pair[0]];
          }
        });
        return func;
      };
    },
    'nthArg': function(nthArg) {
      return function(n) {
        var arity = n < 0 ? 1 : (toInteger(n) + 1);
        return curry(nthArg(n), arity);
      };
    },
    'rearg': function(rearg) {
      return function(func, indexes) {
        var arity = indexes ? indexes.length : 0;
        return curry(rearg(func, indexes), arity);
      };
    },
    'runInContext': function(runInContext) {
      return function(context) {
        return baseConvert(util, runInContext(context), options);
      };
    }
  };

  /*--------------------------------------------------------------------------*/

  /**
   * Casts `func` to a function with an arity capped iteratee if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @returns {Function} Returns the cast function.
   */
  function castCap(name, func) {
    if (config.cap) {
      var indexes = mapping.iterateeRearg[name];
      if (indexes) {
        return iterateeRearg(func, indexes);
      }
      var n = !isLib && mapping.iterateeAry[name];
      if (n) {
        return iterateeAry(func, n);
      }
    }
    return func;
  }

  /**
   * Casts `func` to a curried function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity of `func`.
   * @returns {Function} Returns the cast function.
   */
  function castCurry(name, func, n) {
    return (forceCurry || (config.curry && n > 1))
      ? curry(func, n)
      : func;
  }

  /**
   * Casts `func` to a fixed arity function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity cap.
   * @returns {Function} Returns the cast function.
   */
  function castFixed(name, func, n) {
    if (config.fixed && (forceFixed || !mapping.skipFixed[name])) {
      var data = mapping.methodSpread[name],
          start = data && data.start;

      return start  === undefined ? ary(func, n) : flatSpread(func, start);
    }
    return func;
  }

  /**
   * Casts `func` to an rearged function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity of `func`.
   * @returns {Function} Returns the cast function.
   */
  function castRearg(name, func, n) {
    return (config.rearg && n > 1 && (forceRearg || !mapping.skipRearg[name]))
      ? rearg(func, mapping.methodRearg[name] || mapping.aryRearg[n])
      : func;
  }

  /**
   * Creates a clone of `object` by `path`.
   *
   * @private
   * @param {Object} object The object to clone.
   * @param {Array|string} path The path to clone by.
   * @returns {Object} Returns the cloned object.
   */
  function cloneByPath(object, path) {
    path = toPath(path);

    var index = -1,
        length = path.length,
        lastIndex = length - 1,
        result = clone(Object(object)),
        nested = result;

    while (nested != null && ++index < length) {
      var key = path[index],
          value = nested[key];

      if (value != null &&
          !(isFunction(value) || isError(value) || isWeakMap(value))) {
        nested[key] = clone(index == lastIndex ? value : Object(value));
      }
      nested = nested[key];
    }
    return result;
  }

  /**
   * Converts `lodash` to an immutable auto-curried iteratee-first data-last
   * version with conversion `options` applied.
   *
   * @param {Object} [options] The options object. See `baseConvert` for more details.
   * @returns {Function} Returns the converted `lodash`.
   */
  function convertLib(options) {
    return _.runInContext.convert(options)(undefined);
  }

  /**
   * Create a converter function for `func` of `name`.
   *
   * @param {string} name The name of the function to convert.
   * @param {Function} func The function to convert.
   * @returns {Function} Returns the new converter function.
   */
  function createConverter(name, func) {
    var realName = mapping.aliasToReal[name] || name,
        methodName = mapping.remap[realName] || realName,
        oldOptions = options;

    return function(options) {
      var newUtil = isLib ? pristine : helpers,
          newFunc = isLib ? pristine[methodName] : func,
          newOptions = assign(assign({}, oldOptions), options);

      return baseConvert(newUtil, realName, newFunc, newOptions);
    };
  }

  /**
   * Creates a function that wraps `func` to invoke its iteratee, with up to `n`
   * arguments, ignoring any additional arguments.
   *
   * @private
   * @param {Function} func The function to cap iteratee arguments for.
   * @param {number} n The arity cap.
   * @returns {Function} Returns the new function.
   */
  function iterateeAry(func, n) {
    return overArg(func, function(func) {
      return typeof func == 'function' ? baseAry(func, n) : func;
    });
  }

  /**
   * Creates a function that wraps `func` to invoke its iteratee with arguments
   * arranged according to the specified `indexes` where the argument value at
   * the first index is provided as the first argument, the argument value at
   * the second index is provided as the second argument, and so on.
   *
   * @private
   * @param {Function} func The function to rearrange iteratee arguments for.
   * @param {number[]} indexes The arranged argument indexes.
   * @returns {Function} Returns the new function.
   */
  function iterateeRearg(func, indexes) {
    return overArg(func, function(func) {
      var n = indexes.length;
      return baseArity(rearg(baseAry(func, n), indexes), n);
    });
  }

  /**
   * Creates a function that invokes `func` with its first argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function() {
      var length = arguments.length;
      if (!length) {
        return func();
      }
      var args = Array(length);
      while (length--) {
        args[length] = arguments[length];
      }
      var index = config.rearg ? 0 : (length - 1);
      args[index] = transform(args[index]);
      return func.apply(undefined, args);
    };
  }

  /**
   * Creates a function that wraps `func` and applys the conversions
   * rules by `name`.
   *
   * @private
   * @param {string} name The name of the function to wrap.
   * @param {Function} func The function to wrap.
   * @returns {Function} Returns the converted function.
   */
  function wrap(name, func) {
    var result,
        realName = mapping.aliasToReal[name] || name,
        wrapped = func,
        wrapper = wrappers[realName];

    if (wrapper) {
      wrapped = wrapper(func);
    }
    else if (config.immutable) {
      if (mapping.mutate.array[realName]) {
        wrapped = wrapImmutable(func, cloneArray);
      }
      else if (mapping.mutate.object[realName]) {
        wrapped = wrapImmutable(func, createCloner(func));
      }
      else if (mapping.mutate.set[realName]) {
        wrapped = wrapImmutable(func, cloneByPath);
      }
    }
    each(aryMethodKeys, function(aryKey) {
      each(mapping.aryMethod[aryKey], function(otherName) {
        if (realName == otherName) {
          var data = mapping.methodSpread[realName],
              afterRearg = data && data.afterRearg;

          result = afterRearg
            ? castFixed(realName, castRearg(realName, wrapped, aryKey), aryKey)
            : castRearg(realName, castFixed(realName, wrapped, aryKey), aryKey);

          result = castCap(realName, result);
          result = castCurry(realName, result, aryKey);
          return false;
        }
      });
      return !result;
    });

    result || (result = wrapped);
    if (result == func) {
      result = forceCurry ? curry(result, 1) : function() {
        return func.apply(this, arguments);
      };
    }
    result.convert = createConverter(realName, func);
    if (mapping.placeholder[realName]) {
      setPlaceholder = true;
      result.placeholder = func.placeholder = placeholder;
    }
    return result;
  }

  /*--------------------------------------------------------------------------*/

  if (!isObj) {
    return wrap(name, func);
  }
  var _ = func;

  // Convert methods by ary cap.
  var pairs = [];
  each(aryMethodKeys, function(aryKey) {
    each(mapping.aryMethod[aryKey], function(key) {
      var func = _[mapping.remap[key] || key];
      if (func) {
        pairs.push([key, wrap(key, func)]);
      }
    });
  });

  // Convert remaining methods.
  each(keys(_), function(key) {
    var func = _[key];
    if (typeof func == 'function') {
      var length = pairs.length;
      while (length--) {
        if (pairs[length][0] == key) {
          return;
        }
      }
      func.convert = createConverter(key, func);
      pairs.push([key, func]);
    }
  });

  // Assign to `_` leaving `_.prototype` unchanged to allow chaining.
  each(pairs, function(pair) {
    _[pair[0]] = pair[1];
  });

  _.convert = convertLib;
  if (setPlaceholder) {
    _.placeholder = placeholder;
  }
  // Assign aliases.
  each(keys(_), function(key) {
    each(mapping.realToAlias[key] || [], function(alias) {
      _[alias] = _[key];
    });
  });

  return _;
}

module.exports = baseConvert;


/***/ }),
/* 337 */
/***/ (function(module, exports) {

/** Used to map aliases to their real names. */
exports.aliasToReal = {

  // Lodash aliases.
  'each': 'forEach',
  'eachRight': 'forEachRight',
  'entries': 'toPairs',
  'entriesIn': 'toPairsIn',
  'extend': 'assignIn',
  'extendAll': 'assignInAll',
  'extendAllWith': 'assignInAllWith',
  'extendWith': 'assignInWith',
  'first': 'head',

  // Methods that are curried variants of others.
  'conforms': 'conformsTo',
  'matches': 'isMatch',
  'property': 'get',

  // Ramda aliases.
  '__': 'placeholder',
  'F': 'stubFalse',
  'T': 'stubTrue',
  'all': 'every',
  'allPass': 'overEvery',
  'always': 'constant',
  'any': 'some',
  'anyPass': 'overSome',
  'apply': 'spread',
  'assoc': 'set',
  'assocPath': 'set',
  'complement': 'negate',
  'compose': 'flowRight',
  'contains': 'includes',
  'dissoc': 'unset',
  'dissocPath': 'unset',
  'dropLast': 'dropRight',
  'dropLastWhile': 'dropRightWhile',
  'equals': 'isEqual',
  'identical': 'eq',
  'indexBy': 'keyBy',
  'init': 'initial',
  'invertObj': 'invert',
  'juxt': 'over',
  'omitAll': 'omit',
  'nAry': 'ary',
  'path': 'get',
  'pathEq': 'matchesProperty',
  'pathOr': 'getOr',
  'paths': 'at',
  'pickAll': 'pick',
  'pipe': 'flow',
  'pluck': 'map',
  'prop': 'get',
  'propEq': 'matchesProperty',
  'propOr': 'getOr',
  'props': 'at',
  'symmetricDifference': 'xor',
  'symmetricDifferenceBy': 'xorBy',
  'symmetricDifferenceWith': 'xorWith',
  'takeLast': 'takeRight',
  'takeLastWhile': 'takeRightWhile',
  'unapply': 'rest',
  'unnest': 'flatten',
  'useWith': 'overArgs',
  'where': 'conformsTo',
  'whereEq': 'isMatch',
  'zipObj': 'zipObject'
};

/** Used to map ary to method names. */
exports.aryMethod = {
  '1': [
    'assignAll', 'assignInAll', 'attempt', 'castArray', 'ceil', 'create',
    'curry', 'curryRight', 'defaultsAll', 'defaultsDeepAll', 'floor', 'flow',
    'flowRight', 'fromPairs', 'invert', 'iteratee', 'memoize', 'method', 'mergeAll',
    'methodOf', 'mixin', 'nthArg', 'over', 'overEvery', 'overSome','rest', 'reverse',
    'round', 'runInContext', 'spread', 'template', 'trim', 'trimEnd', 'trimStart',
    'uniqueId', 'words', 'zipAll'
  ],
  '2': [
    'add', 'after', 'ary', 'assign', 'assignAllWith', 'assignIn', 'assignInAllWith',
    'at', 'before', 'bind', 'bindAll', 'bindKey', 'chunk', 'cloneDeepWith',
    'cloneWith', 'concat', 'conformsTo', 'countBy', 'curryN', 'curryRightN',
    'debounce', 'defaults', 'defaultsDeep', 'defaultTo', 'delay', 'difference',
    'divide', 'drop', 'dropRight', 'dropRightWhile', 'dropWhile', 'endsWith', 'eq',
    'every', 'filter', 'find', 'findIndex', 'findKey', 'findLast', 'findLastIndex',
    'findLastKey', 'flatMap', 'flatMapDeep', 'flattenDepth', 'forEach',
    'forEachRight', 'forIn', 'forInRight', 'forOwn', 'forOwnRight', 'get',
    'groupBy', 'gt', 'gte', 'has', 'hasIn', 'includes', 'indexOf', 'intersection',
    'invertBy', 'invoke', 'invokeMap', 'isEqual', 'isMatch', 'join', 'keyBy',
    'lastIndexOf', 'lt', 'lte', 'map', 'mapKeys', 'mapValues', 'matchesProperty',
    'maxBy', 'meanBy', 'merge', 'mergeAllWith', 'minBy', 'multiply', 'nth', 'omit',
    'omitBy', 'overArgs', 'pad', 'padEnd', 'padStart', 'parseInt', 'partial',
    'partialRight', 'partition', 'pick', 'pickBy', 'propertyOf', 'pull', 'pullAll',
    'pullAt', 'random', 'range', 'rangeRight', 'rearg', 'reject', 'remove',
    'repeat', 'restFrom', 'result', 'sampleSize', 'some', 'sortBy', 'sortedIndex',
    'sortedIndexOf', 'sortedLastIndex', 'sortedLastIndexOf', 'sortedUniqBy',
    'split', 'spreadFrom', 'startsWith', 'subtract', 'sumBy', 'take', 'takeRight',
    'takeRightWhile', 'takeWhile', 'tap', 'throttle', 'thru', 'times', 'trimChars',
    'trimCharsEnd', 'trimCharsStart', 'truncate', 'union', 'uniqBy', 'uniqWith',
    'unset', 'unzipWith', 'without', 'wrap', 'xor', 'zip', 'zipObject',
    'zipObjectDeep'
  ],
  '3': [
    'assignInWith', 'assignWith', 'clamp', 'differenceBy', 'differenceWith',
    'findFrom', 'findIndexFrom', 'findLastFrom', 'findLastIndexFrom', 'getOr',
    'includesFrom', 'indexOfFrom', 'inRange', 'intersectionBy', 'intersectionWith',
    'invokeArgs', 'invokeArgsMap', 'isEqualWith', 'isMatchWith', 'flatMapDepth',
    'lastIndexOfFrom', 'mergeWith', 'orderBy', 'padChars', 'padCharsEnd',
    'padCharsStart', 'pullAllBy', 'pullAllWith', 'rangeStep', 'rangeStepRight',
    'reduce', 'reduceRight', 'replace', 'set', 'slice', 'sortedIndexBy',
    'sortedLastIndexBy', 'transform', 'unionBy', 'unionWith', 'update', 'xorBy',
    'xorWith', 'zipWith'
  ],
  '4': [
    'fill', 'setWith', 'updateWith'
  ]
};

/** Used to map ary to rearg configs. */
exports.aryRearg = {
  '2': [1, 0],
  '3': [2, 0, 1],
  '4': [3, 2, 0, 1]
};

/** Used to map method names to their iteratee ary. */
exports.iterateeAry = {
  'dropRightWhile': 1,
  'dropWhile': 1,
  'every': 1,
  'filter': 1,
  'find': 1,
  'findFrom': 1,
  'findIndex': 1,
  'findIndexFrom': 1,
  'findKey': 1,
  'findLast': 1,
  'findLastFrom': 1,
  'findLastIndex': 1,
  'findLastIndexFrom': 1,
  'findLastKey': 1,
  'flatMap': 1,
  'flatMapDeep': 1,
  'flatMapDepth': 1,
  'forEach': 1,
  'forEachRight': 1,
  'forIn': 1,
  'forInRight': 1,
  'forOwn': 1,
  'forOwnRight': 1,
  'map': 1,
  'mapKeys': 1,
  'mapValues': 1,
  'partition': 1,
  'reduce': 2,
  'reduceRight': 2,
  'reject': 1,
  'remove': 1,
  'some': 1,
  'takeRightWhile': 1,
  'takeWhile': 1,
  'times': 1,
  'transform': 2
};

/** Used to map method names to iteratee rearg configs. */
exports.iterateeRearg = {
  'mapKeys': [1],
  'reduceRight': [1, 0]
};

/** Used to map method names to rearg configs. */
exports.methodRearg = {
  'assignInAllWith': [1, 0],
  'assignInWith': [1, 2, 0],
  'assignAllWith': [1, 0],
  'assignWith': [1, 2, 0],
  'differenceBy': [1, 2, 0],
  'differenceWith': [1, 2, 0],
  'getOr': [2, 1, 0],
  'intersectionBy': [1, 2, 0],
  'intersectionWith': [1, 2, 0],
  'isEqualWith': [1, 2, 0],
  'isMatchWith': [2, 1, 0],
  'mergeAllWith': [1, 0],
  'mergeWith': [1, 2, 0],
  'padChars': [2, 1, 0],
  'padCharsEnd': [2, 1, 0],
  'padCharsStart': [2, 1, 0],
  'pullAllBy': [2, 1, 0],
  'pullAllWith': [2, 1, 0],
  'rangeStep': [1, 2, 0],
  'rangeStepRight': [1, 2, 0],
  'setWith': [3, 1, 2, 0],
  'sortedIndexBy': [2, 1, 0],
  'sortedLastIndexBy': [2, 1, 0],
  'unionBy': [1, 2, 0],
  'unionWith': [1, 2, 0],
  'updateWith': [3, 1, 2, 0],
  'xorBy': [1, 2, 0],
  'xorWith': [1, 2, 0],
  'zipWith': [1, 2, 0]
};

/** Used to map method names to spread configs. */
exports.methodSpread = {
  'assignAll': { 'start': 0 },
  'assignAllWith': { 'start': 0 },
  'assignInAll': { 'start': 0 },
  'assignInAllWith': { 'start': 0 },
  'defaultsAll': { 'start': 0 },
  'defaultsDeepAll': { 'start': 0 },
  'invokeArgs': { 'start': 2 },
  'invokeArgsMap': { 'start': 2 },
  'mergeAll': { 'start': 0 },
  'mergeAllWith': { 'start': 0 },
  'partial': { 'start': 1 },
  'partialRight': { 'start': 1 },
  'without': { 'start': 1 },
  'zipAll': { 'start': 0 }
};

/** Used to identify methods which mutate arrays or objects. */
exports.mutate = {
  'array': {
    'fill': true,
    'pull': true,
    'pullAll': true,
    'pullAllBy': true,
    'pullAllWith': true,
    'pullAt': true,
    'remove': true,
    'reverse': true
  },
  'object': {
    'assign': true,
    'assignAll': true,
    'assignAllWith': true,
    'assignIn': true,
    'assignInAll': true,
    'assignInAllWith': true,
    'assignInWith': true,
    'assignWith': true,
    'defaults': true,
    'defaultsAll': true,
    'defaultsDeep': true,
    'defaultsDeepAll': true,
    'merge': true,
    'mergeAll': true,
    'mergeAllWith': true,
    'mergeWith': true,
  },
  'set': {
    'set': true,
    'setWith': true,
    'unset': true,
    'update': true,
    'updateWith': true
  }
};

/** Used to track methods with placeholder support */
exports.placeholder = {
  'bind': true,
  'bindKey': true,
  'curry': true,
  'curryRight': true,
  'partial': true,
  'partialRight': true
};

/** Used to map real names to their aliases. */
exports.realToAlias = (function() {
  var hasOwnProperty = Object.prototype.hasOwnProperty,
      object = exports.aliasToReal,
      result = {};

  for (var key in object) {
    var value = object[key];
    if (hasOwnProperty.call(result, value)) {
      result[value].push(key);
    } else {
      result[value] = [key];
    }
  }
  return result;
}());

/** Used to map method names to other names. */
exports.remap = {
  'assignAll': 'assign',
  'assignAllWith': 'assignWith',
  'assignInAll': 'assignIn',
  'assignInAllWith': 'assignInWith',
  'curryN': 'curry',
  'curryRightN': 'curryRight',
  'defaultsAll': 'defaults',
  'defaultsDeepAll': 'defaultsDeep',
  'findFrom': 'find',
  'findIndexFrom': 'findIndex',
  'findLastFrom': 'findLast',
  'findLastIndexFrom': 'findLastIndex',
  'getOr': 'get',
  'includesFrom': 'includes',
  'indexOfFrom': 'indexOf',
  'invokeArgs': 'invoke',
  'invokeArgsMap': 'invokeMap',
  'lastIndexOfFrom': 'lastIndexOf',
  'mergeAll': 'merge',
  'mergeAllWith': 'mergeWith',
  'padChars': 'pad',
  'padCharsEnd': 'padEnd',
  'padCharsStart': 'padStart',
  'propertyOf': 'get',
  'rangeStep': 'range',
  'rangeStepRight': 'rangeRight',
  'restFrom': 'rest',
  'spreadFrom': 'spread',
  'trimChars': 'trim',
  'trimCharsEnd': 'trimEnd',
  'trimCharsStart': 'trimStart',
  'zipAll': 'zip'
};

/** Used to track methods that skip fixing their arity. */
exports.skipFixed = {
  'castArray': true,
  'flow': true,
  'flowRight': true,
  'iteratee': true,
  'mixin': true,
  'rearg': true,
  'runInContext': true
};

/** Used to track methods that skip rearranging arguments. */
exports.skipRearg = {
  'add': true,
  'assign': true,
  'assignIn': true,
  'bind': true,
  'bindKey': true,
  'concat': true,
  'difference': true,
  'divide': true,
  'eq': true,
  'gt': true,
  'gte': true,
  'isEqual': true,
  'lt': true,
  'lte': true,
  'matchesProperty': true,
  'merge': true,
  'multiply': true,
  'overArgs': true,
  'partial': true,
  'partialRight': true,
  'propertyOf': true,
  'random': true,
  'range': true,
  'rangeRight': true,
  'subtract': true,
  'zip': true,
  'zipObject': true,
  'zipObjectDeep': true
};


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
  'ary': __webpack_require__(339),
  'assign': __webpack_require__(164),
  'clone': __webpack_require__(374),
  'curry': __webpack_require__(419),
  'forEach': __webpack_require__(74),
  'isArray': __webpack_require__(4),
  'isError': __webpack_require__(420),
  'isFunction': __webpack_require__(70),
  'isWeakMap': __webpack_require__(422),
  'iteratee': __webpack_require__(423),
  'keys': __webpack_require__(169),
  'rearg': __webpack_require__(448),
  'toInteger': __webpack_require__(77),
  'toPath': __webpack_require__(454)
};


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

var createWrap = __webpack_require__(68);

/** Used to compose bitmasks for function metadata. */
var WRAP_ARY_FLAG = 128;

/**
 * Creates a function that invokes `func`, with up to `n` arguments,
 * ignoring any additional arguments.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} func The function to cap arguments for.
 * @param {number} [n=func.length] The arity cap.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the new capped function.
 * @example
 *
 * _.map(['6', '8', '10'], _.ary(parseInt, 1));
 * // => [6, 8, 10]
 */
function ary(func, n, guard) {
  n = guard ? undefined : n;
  n = (func && n == null) ? func.length : n;
  return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
}

module.exports = ary;


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(70),
    isMasked = __webpack_require__(343),
    isObject = __webpack_require__(12),
    toSource = __webpack_require__(150);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(21);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 342 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(344);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(3);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 345 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

var createCtor = __webpack_require__(46),
    root = __webpack_require__(3);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1;

/**
 * Creates a function that wraps `func` to invoke it with the optional `this`
 * binding of `thisArg`.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createBind(func, bitmask, thisArg) {
  var isBind = bitmask & WRAP_BIND_FLAG,
      Ctor = createCtor(func);

  function wrapper() {
    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
    return fn.apply(isBind ? thisArg : this, arguments);
  }
  return wrapper;
}

module.exports = createBind;


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(71),
    createCtor = __webpack_require__(46),
    createHybrid = __webpack_require__(151),
    createRecurry = __webpack_require__(154),
    getHolder = __webpack_require__(163),
    replaceHolders = __webpack_require__(76),
    root = __webpack_require__(3);

/**
 * Creates a function that wraps `func` to enable currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {number} arity The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createCurry(func, bitmask, arity) {
  var Ctor = createCtor(func);

  function wrapper() {
    var length = arguments.length,
        args = Array(length),
        index = length,
        placeholder = getHolder(wrapper);

    while (index--) {
      args[index] = arguments[index];
    }
    var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
      ? []
      : replaceHolders(args, placeholder);

    length -= holders.length;
    if (length < arity) {
      return createRecurry(
        func, bitmask, createHybrid, wrapper.placeholder, undefined,
        args, holders, undefined, undefined, arity - length);
    }
    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
    return apply(fn, this, args);
  }
  return wrapper;
}

module.exports = createCurry;


/***/ }),
/* 348 */
/***/ (function(module, exports) {

/**
 * Gets the number of `placeholder` occurrences in `array`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} placeholder The placeholder to search for.
 * @returns {number} Returns the placeholder count.
 */
function countHolders(array, placeholder) {
  var length = array.length,
      result = 0;

  while (length--) {
    if (array[length] === placeholder) {
      ++result;
    }
  }
  return result;
}

module.exports = countHolders;


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(72),
    getData = __webpack_require__(155),
    getFuncName = __webpack_require__(351),
    lodash = __webpack_require__(353);

/**
 * Checks if `func` has a lazy counterpart.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
 *  else `false`.
 */
function isLaziable(func) {
  var funcName = getFuncName(func),
      other = lodash[funcName];

  if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
    return false;
  }
  if (func === other) {
    return true;
  }
  var data = getData(other);
  return !!data && func === data[0];
}

module.exports = isLaziable;


/***/ }),
/* 350 */
/***/ (function(module, exports) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

var realNames = __webpack_require__(352);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the name of `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {string} Returns the function name.
 */
function getFuncName(func) {
  var result = (func.name + ''),
      array = realNames[result],
      length = hasOwnProperty.call(realNames, result) ? array.length : 0;

  while (length--) {
    var data = array[length],
        otherFunc = data.func;
    if (otherFunc == null || otherFunc == func) {
      return data.name;
    }
  }
  return result;
}

module.exports = getFuncName;


/***/ }),
/* 352 */
/***/ (function(module, exports) {

/** Used to lookup unminified function names. */
var realNames = {};

module.exports = realNames;


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(72),
    LodashWrapper = __webpack_require__(156),
    baseLodash = __webpack_require__(73),
    isArray = __webpack_require__(4),
    isObjectLike = __webpack_require__(5),
    wrapperClone = __webpack_require__(354);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates a `lodash` object which wraps `value` to enable implicit method
 * chain sequences. Methods that operate on and return arrays, collections,
 * and functions can be chained together. Methods that retrieve a single value
 * or may return a primitive value will automatically end the chain sequence
 * and return the unwrapped value. Otherwise, the value must be unwrapped
 * with `_#value`.
 *
 * Explicit chain sequences, which must be unwrapped with `_#value`, may be
 * enabled using `_.chain`.
 *
 * The execution of chained methods is lazy, that is, it's deferred until
 * `_#value` is implicitly or explicitly called.
 *
 * Lazy evaluation allows several methods to support shortcut fusion.
 * Shortcut fusion is an optimization to merge iteratee calls; this avoids
 * the creation of intermediate arrays and can greatly reduce the number of
 * iteratee executions. Sections of a chain sequence qualify for shortcut
 * fusion if the section is applied to an array and iteratees accept only
 * one argument. The heuristic for whether a section qualifies for shortcut
 * fusion is subject to change.
 *
 * Chaining is supported in custom builds as long as the `_#value` method is
 * directly or indirectly included in the build.
 *
 * In addition to lodash methods, wrappers have `Array` and `String` methods.
 *
 * The wrapper `Array` methods are:
 * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
 *
 * The wrapper `String` methods are:
 * `replace` and `split`
 *
 * The wrapper methods that support shortcut fusion are:
 * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
 * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
 * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
 *
 * The chainable wrapper methods are:
 * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
 * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
 * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
 * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
 * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
 * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
 * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
 * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
 * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
 * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
 * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
 * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
 * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
 * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
 * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
 * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
 * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
 * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
 * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
 * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
 * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
 * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
 * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
 * `zipObject`, `zipObjectDeep`, and `zipWith`
 *
 * The wrapper methods that are **not** chainable by default are:
 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
 * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
 * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
 * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
 * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
 * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
 * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
 * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
 * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
 * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
 * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
 * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
 * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
 * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
 * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
 * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
 * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
 * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
 * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
 * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
 * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
 * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
 * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
 * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
 * `upperFirst`, `value`, and `words`
 *
 * @name _
 * @constructor
 * @category Seq
 * @param {*} value The value to wrap in a `lodash` instance.
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var wrapped = _([1, 2, 3]);
 *
 * // Returns an unwrapped value.
 * wrapped.reduce(_.add);
 * // => 6
 *
 * // Returns a wrapped value.
 * var squares = wrapped.map(square);
 *
 * _.isArray(squares);
 * // => false
 *
 * _.isArray(squares.value());
 * // => true
 */
function lodash(value) {
  if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
    if (value instanceof LodashWrapper) {
      return value;
    }
    if (hasOwnProperty.call(value, '__wrapped__')) {
      return wrapperClone(value);
    }
  }
  return new LodashWrapper(value);
}

// Ensure wrappers are instances of `baseLodash`.
lodash.prototype = baseLodash.prototype;
lodash.prototype.constructor = lodash;

module.exports = lodash;


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(72),
    LodashWrapper = __webpack_require__(156),
    copyArray = __webpack_require__(48);

/**
 * Creates a clone of `wrapper`.
 *
 * @private
 * @param {Object} wrapper The wrapper to clone.
 * @returns {Object} Returns the cloned wrapper.
 */
function wrapperClone(wrapper) {
  if (wrapper instanceof LazyWrapper) {
    return wrapper.clone();
  }
  var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
  result.__actions__ = copyArray(wrapper.__actions__);
  result.__index__  = wrapper.__index__;
  result.__values__ = wrapper.__values__;
  return result;
}

module.exports = wrapperClone;


/***/ }),
/* 355 */
/***/ (function(module, exports) {

/** Used to match wrap detail comments. */
var reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
    reSplitDetails = /,? & /;

/**
 * Extracts wrapper details from the `source` body comment.
 *
 * @private
 * @param {string} source The source to inspect.
 * @returns {Array} Returns the wrapper details.
 */
function getWrapDetails(source) {
  var match = source.match(reWrapDetails);
  return match ? match[1].split(reSplitDetails) : [];
}

module.exports = getWrapDetails;


/***/ }),
/* 356 */
/***/ (function(module, exports) {

/** Used to match wrap detail comments. */
var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;

/**
 * Inserts wrapper `details` in a comment at the top of the `source` body.
 *
 * @private
 * @param {string} source The source to modify.
 * @returns {Array} details The details to insert.
 * @returns {string} Returns the modified source.
 */
function insertWrapDetails(source, details) {
  var length = details.length;
  if (!length) {
    return source;
  }
  var lastIndex = length - 1;
  details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
  details = details.join(length > 2 ? ', ' : ' ');
  return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
}

module.exports = insertWrapDetails;


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(358),
    defineProperty = __webpack_require__(161),
    identity = __webpack_require__(69);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),
/* 358 */
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEach = __webpack_require__(74),
    arrayIncludes = __webpack_require__(360);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64,
    WRAP_ARY_FLAG = 128,
    WRAP_REARG_FLAG = 256,
    WRAP_FLIP_FLAG = 512;

/** Used to associate wrap methods with their bit flags. */
var wrapFlags = [
  ['ary', WRAP_ARY_FLAG],
  ['bind', WRAP_BIND_FLAG],
  ['bindKey', WRAP_BIND_KEY_FLAG],
  ['curry', WRAP_CURRY_FLAG],
  ['curryRight', WRAP_CURRY_RIGHT_FLAG],
  ['flip', WRAP_FLIP_FLAG],
  ['partial', WRAP_PARTIAL_FLAG],
  ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
  ['rearg', WRAP_REARG_FLAG]
];

/**
 * Updates wrapper `details` based on `bitmask` flags.
 *
 * @private
 * @returns {Array} details The details to modify.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Array} Returns `details`.
 */
function updateWrapDetails(details, bitmask) {
  arrayEach(wrapFlags, function(pair) {
    var value = '_.' + pair[0];
    if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
      details.push(value);
    }
  });
  return details.sort();
}

module.exports = updateWrapDetails;


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(162);

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),
/* 361 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),
/* 362 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),
/* 363 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

var copyArray = __webpack_require__(48),
    isIndex = __webpack_require__(75);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Reorder `array` according to the specified indexes where the element at
 * the first index is assigned as the first element, the element at
 * the second index is assigned as the second element, and so on.
 *
 * @private
 * @param {Array} array The array to reorder.
 * @param {Array} indexes The arranged array indexes.
 * @returns {Array} Returns `array`.
 */
function reorder(array, indexes) {
  var arrLength = array.length,
      length = nativeMin(indexes.length, arrLength),
      oldArray = copyArray(array);

  while (length--) {
    var index = indexes[length];
    array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
  }
  return array;
}

module.exports = reorder;


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(71),
    createCtor = __webpack_require__(46),
    root = __webpack_require__(3);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1;

/**
 * Creates a function that wraps `func` to invoke it with the `this` binding
 * of `thisArg` and `partials` prepended to the arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} partials The arguments to prepend to those provided to
 *  the new function.
 * @returns {Function} Returns the new wrapped function.
 */
function createPartial(func, bitmask, thisArg, partials) {
  var isBind = bitmask & WRAP_BIND_FLAG,
      Ctor = createCtor(func);

  function wrapper() {
    var argsIndex = -1,
        argsLength = arguments.length,
        leftIndex = -1,
        leftLength = partials.length,
        args = Array(leftLength + argsLength),
        fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

    while (++leftIndex < leftLength) {
      args[leftIndex] = partials[leftIndex];
    }
    while (argsLength--) {
      args[leftIndex++] = arguments[++argsIndex];
    }
    return apply(fn, isBind ? thisArg : this, args);
  }
  return wrapper;
}

module.exports = createPartial;


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

var composeArgs = __webpack_require__(152),
    composeArgsRight = __webpack_require__(153),
    replaceHolders = __webpack_require__(76);

/** Used as the internal argument placeholder. */
var PLACEHOLDER = '__lodash_placeholder__';

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_BOUND_FLAG = 4,
    WRAP_CURRY_FLAG = 8,
    WRAP_ARY_FLAG = 128,
    WRAP_REARG_FLAG = 256;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Merges the function metadata of `source` into `data`.
 *
 * Merging metadata reduces the number of wrappers used to invoke a function.
 * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
 * may be applied regardless of execution order. Methods like `_.ary` and
 * `_.rearg` modify function arguments, making the order in which they are
 * executed important, preventing the merging of metadata. However, we make
 * an exception for a safe combined case where curried functions have `_.ary`
 * and or `_.rearg` applied.
 *
 * @private
 * @param {Array} data The destination metadata.
 * @param {Array} source The source metadata.
 * @returns {Array} Returns `data`.
 */
function mergeData(data, source) {
  var bitmask = data[1],
      srcBitmask = source[1],
      newBitmask = bitmask | srcBitmask,
      isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

  var isCombo =
    ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
    ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
    ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

  // Exit early if metadata can't be merged.
  if (!(isCommon || isCombo)) {
    return data;
  }
  // Use source `thisArg` if available.
  if (srcBitmask & WRAP_BIND_FLAG) {
    data[2] = source[2];
    // Set when currying a bound function.
    newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
  }
  // Compose partial arguments.
  var value = source[3];
  if (value) {
    var partials = data[3];
    data[3] = partials ? composeArgs(partials, value, source[4]) : value;
    data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
  }
  // Compose partial right arguments.
  value = source[5];
  if (value) {
    partials = data[5];
    data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
    data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
  }
  // Use source `argPos` if available.
  value = source[7];
  if (value) {
    data[7] = value;
  }
  // Use source `ary` if it's smaller.
  if (srcBitmask & WRAP_ARY_FLAG) {
    data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
  }
  // Use source `arity` if one is not provided.
  if (data[9] == null) {
    data[9] = source[9];
  }
  // Use source `func` and merge bitmasks.
  data[0] = source[0];
  data[1] = newBitmask;

  return data;
}

module.exports = mergeData;


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

var toNumber = __webpack_require__(368);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(12),
    isSymbol = __webpack_require__(28);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 369 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(11),
    isObjectLike = __webpack_require__(5);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 371 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(11),
    isLength = __webpack_require__(81),
    isObjectLike = __webpack_require__(5);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(170);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__(171);

/** Used to compose bitmasks for cloning. */
var CLONE_SYMBOLS_FLAG = 4;

/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */
function clone(value) {
  return baseClone(value, CLONE_SYMBOLS_FLAG);
}

module.exports = clone;


/***/ }),
/* 375 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(51);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(51);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(51);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(51);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(50);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 381 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 382 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 383 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(50),
    Map = __webpack_require__(87),
    MapCache = __webpack_require__(88);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(386),
    ListCache = __webpack_require__(50),
    Map = __webpack_require__(87);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(387),
    hashDelete = __webpack_require__(388),
    hashGet = __webpack_require__(389),
    hashHas = __webpack_require__(390),
    hashSet = __webpack_require__(391);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(52);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 388 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(52);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(52);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(52);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(53);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 393 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(53);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(53);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(53);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(49),
    keysIn = __webpack_require__(172);

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

module.exports = baseAssignIn;


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(12),
    isPrototype = __webpack_require__(84),
    nativeKeysIn = __webpack_require__(399);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),
/* 399 */
/***/ (function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(3);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(39)(module)))

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(49),
    getSymbols = __webpack_require__(89);

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

module.exports = copySymbols;


/***/ }),
/* 402 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(49),
    getSymbolsIn = __webpack_require__(174);

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

module.exports = copySymbolsIn;


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(176),
    getSymbolsIn = __webpack_require__(174),
    keysIn = __webpack_require__(172);

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

module.exports = getAllKeysIn;


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(16),
    root = __webpack_require__(3);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(16),
    root = __webpack_require__(3);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(16),
    root = __webpack_require__(3);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 408 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

module.exports = initCloneArray;


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(92),
    cloneDataView = __webpack_require__(410),
    cloneRegExp = __webpack_require__(411),
    cloneSymbol = __webpack_require__(412),
    cloneTypedArray = __webpack_require__(413);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return new Ctor;

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return new Ctor;

    case symbolTag:
      return cloneSymbol(object);
  }
}

module.exports = initCloneByTag;


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(92);

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

module.exports = cloneDataView;


/***/ }),
/* 411 */
/***/ (function(module, exports) {

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

module.exports = cloneRegExp;


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(21);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

module.exports = cloneSymbol;


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(92);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(47),
    getPrototype = __webpack_require__(91),
    isPrototype = __webpack_require__(84);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMap = __webpack_require__(416),
    baseUnary = __webpack_require__(82),
    nodeUtil = __webpack_require__(83);

/* Node.js helper references. */
var nodeIsMap = nodeUtil && nodeUtil.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

module.exports = isMap;


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(30),
    isObjectLike = __webpack_require__(5);

/** `Object#toString` result references. */
var mapTag = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike(value) && getTag(value) == mapTag;
}

module.exports = baseIsMap;


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsSet = __webpack_require__(418),
    baseUnary = __webpack_require__(82),
    nodeUtil = __webpack_require__(83);

/* Node.js helper references. */
var nodeIsSet = nodeUtil && nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

module.exports = isSet;


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(30),
    isObjectLike = __webpack_require__(5);

/** `Object#toString` result references. */
var setTag = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike(value) && getTag(value) == setTag;
}

module.exports = baseIsSet;


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

var createWrap = __webpack_require__(68);

/** Used to compose bitmasks for function metadata. */
var WRAP_CURRY_FLAG = 8;

/**
 * Creates a function that accepts arguments of `func` and either invokes
 * `func` returning its result, if at least `arity` number of arguments have
 * been provided, or returns a function that accepts the remaining `func`
 * arguments, and so on. The arity of `func` may be specified if `func.length`
 * is not sufficient.
 *
 * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
 * may be used as a placeholder for provided arguments.
 *
 * **Note:** This method doesn't set the "length" property of curried functions.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Function
 * @param {Function} func The function to curry.
 * @param {number} [arity=func.length] The arity of `func`.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the new curried function.
 * @example
 *
 * var abc = function(a, b, c) {
 *   return [a, b, c];
 * };
 *
 * var curried = _.curry(abc);
 *
 * curried(1)(2)(3);
 * // => [1, 2, 3]
 *
 * curried(1, 2)(3);
 * // => [1, 2, 3]
 *
 * curried(1, 2, 3);
 * // => [1, 2, 3]
 *
 * // Curried with placeholders.
 * curried(1)(_, 3)(2);
 * // => [1, 2, 3]
 */
function curry(func, arity, guard) {
  arity = guard ? undefined : arity;
  var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
  result.placeholder = curry.placeholder;
  return result;
}

// Assign default placeholders.
curry.placeholder = {};

module.exports = curry;


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(11),
    isObjectLike = __webpack_require__(5),
    isPlainObject = __webpack_require__(421);

/** `Object#toString` result references. */
var domExcTag = '[object DOMException]',
    errorTag = '[object Error]';

/**
 * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
 * `SyntaxError`, `TypeError`, or `URIError` object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
 * @example
 *
 * _.isError(new Error);
 * // => true
 *
 * _.isError(Error);
 * // => false
 */
function isError(value) {
  if (!isObjectLike(value)) {
    return false;
  }
  var tag = baseGetTag(value);
  return tag == errorTag || tag == domExcTag ||
    (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
}

module.exports = isError;


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(11),
    getPrototype = __webpack_require__(91),
    isObjectLike = __webpack_require__(5);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(30),
    isObjectLike = __webpack_require__(5);

/** `Object#toString` result references. */
var weakMapTag = '[object WeakMap]';

/**
 * Checks if `value` is classified as a `WeakMap` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
 * @example
 *
 * _.isWeakMap(new WeakMap);
 * // => true
 *
 * _.isWeakMap(new Map);
 * // => false
 */
function isWeakMap(value) {
  return isObjectLike(value) && getTag(value) == weakMapTag;
}

module.exports = isWeakMap;


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__(171),
    baseIteratee = __webpack_require__(178);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1;

/**
 * Creates a function that invokes `func` with the arguments of the created
 * function. If `func` is a property name, the created function returns the
 * property value for a given element. If `func` is an array or object, the
 * created function returns `true` for elements that contain the equivalent
 * source properties, otherwise it returns `false`.
 *
 * @static
 * @since 4.0.0
 * @memberOf _
 * @category Util
 * @param {*} [func=_.identity] The value to convert to a callback.
 * @returns {Function} Returns the callback.
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
 * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, _.iteratee(['user', 'fred']));
 * // => [{ 'user': 'fred', 'age': 40 }]
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, _.iteratee('user'));
 * // => ['barney', 'fred']
 *
 * // Create custom iteratee shorthands.
 * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
 *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
 *     return func.test(string);
 *   };
 * });
 *
 * _.filter(['abc', 'def'], /ef/);
 * // => ['def']
 */
function iteratee(func) {
  return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
}

module.exports = iteratee;


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(425),
    getMatchData = __webpack_require__(436),
    matchesStrictComparable = __webpack_require__(182);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(86),
    baseIsEqual = __webpack_require__(179);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(86),
    equalArrays = __webpack_require__(180),
    equalByTag = __webpack_require__(432),
    equalObjects = __webpack_require__(435),
    getTag = __webpack_require__(30),
    isArray = __webpack_require__(4),
    isBuffer = __webpack_require__(80),
    isTypedArray = __webpack_require__(168);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(88),
    setCacheAdd = __webpack_require__(428),
    setCacheHas = __webpack_require__(429);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 428 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 429 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 430 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 431 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(21),
    Uint8Array = __webpack_require__(177),
    eq = __webpack_require__(78),
    equalArrays = __webpack_require__(180),
    mapToArray = __webpack_require__(433),
    setToArray = __webpack_require__(434);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 433 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 434 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(175);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(181),
    keys = __webpack_require__(29);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(179),
    get = __webpack_require__(438),
    hasIn = __webpack_require__(442),
    isKey = __webpack_require__(93),
    isStrictComparable = __webpack_require__(181),
    matchesStrictComparable = __webpack_require__(182),
    toKey = __webpack_require__(31);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(183);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(440);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(88);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(21),
    arrayMap = __webpack_require__(94),
    isArray = __webpack_require__(4),
    isSymbol = __webpack_require__(28);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(443),
    hasPath = __webpack_require__(444);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 443 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(184),
    isArguments = __webpack_require__(79),
    isArray = __webpack_require__(4),
    isIndex = __webpack_require__(75),
    isLength = __webpack_require__(81),
    toKey = __webpack_require__(31);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(446),
    basePropertyDeep = __webpack_require__(447),
    isKey = __webpack_require__(93),
    toKey = __webpack_require__(31);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 446 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(183);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

var createWrap = __webpack_require__(68),
    flatRest = __webpack_require__(449);

/** Used to compose bitmasks for function metadata. */
var WRAP_REARG_FLAG = 256;

/**
 * Creates a function that invokes `func` with arguments arranged according
 * to the specified `indexes` where the argument value at the first index is
 * provided as the first argument, the argument value at the second index is
 * provided as the second argument, and so on.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} func The function to rearrange arguments for.
 * @param {...(number|number[])} indexes The arranged argument indexes.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var rearged = _.rearg(function(a, b, c) {
 *   return [a, b, c];
 * }, [2, 0, 1]);
 *
 * rearged('b', 'c', 'a')
 * // => ['a', 'b', 'c']
 */
var rearg = flatRest(function(func, indexes) {
  return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
});

module.exports = rearg;


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

var flatten = __webpack_require__(450),
    overRest = __webpack_require__(453),
    setToString = __webpack_require__(160);

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest(func) {
  return setToString(overRest(func, undefined, flatten), func + '');
}

module.exports = flatRest;


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(451);

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}

module.exports = flatten;


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(90),
    isFlattenable = __webpack_require__(452);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(21),
    isArguments = __webpack_require__(79),
    isArray = __webpack_require__(4);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(71);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(94),
    copyArray = __webpack_require__(48),
    isArray = __webpack_require__(4),
    isSymbol = __webpack_require__(28),
    stringToPath = __webpack_require__(185),
    toKey = __webpack_require__(31),
    toString = __webpack_require__(186);

/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */
function toPath(value) {
  if (isArray(value)) {
    return arrayMap(value, toKey);
  }
  return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
}

module.exports = toPath;


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(178),
    baseWhile = __webpack_require__(456);

/**
 * Creates a slice of `array` with elements taken from the beginning. Elements
 * are taken until `predicate` returns falsey. The predicate is invoked with
 * three arguments: (value, index, array).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.takeWhile(users, function(o) { return !o.active; });
 * // => objects for ['barney', 'fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.takeWhile(users, { 'user': 'barney', 'active': false });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.takeWhile(users, ['active', false]);
 * // => objects for ['barney', 'fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.takeWhile(users, 'active');
 * // => []
 */
function takeWhile(array, predicate) {
  return (array && array.length)
    ? baseWhile(array, baseIteratee(predicate, 3))
    : [];
}

module.exports = takeWhile;


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(457);

/**
 * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
 * without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to query.
 * @param {Function} predicate The function invoked per iteration.
 * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the slice of `array`.
 */
function baseWhile(array, predicate, isDrop, fromRight) {
  var length = array.length,
      index = fromRight ? length : -1;

  while ((fromRight ? index-- : ++index < length) &&
    predicate(array[index], index, array)) {}

  return isDrop
    ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
    : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
}

module.exports = baseWhile;


/***/ }),
/* 457 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(145),
    func = convert('includes', __webpack_require__(459));

func.placeholder = __webpack_require__(67);
module.exports = func;


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(162),
    isArrayLike = __webpack_require__(85),
    isString = __webpack_require__(460),
    toInteger = __webpack_require__(77),
    values = __webpack_require__(461);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Checks if `value` is in `collection`. If `collection` is a string, it's
 * checked for a substring of `value`, otherwise
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * is used for equality comparisons. If `fromIndex` is negative, it's used as
 * the offset from the end of `collection`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 * @example
 *
 * _.includes([1, 2, 3], 1);
 * // => true
 *
 * _.includes([1, 2, 3], 1, 2);
 * // => false
 *
 * _.includes({ 'a': 1, 'b': 2 }, 1);
 * // => true
 *
 * _.includes('abcd', 'bc');
 * // => true
 */
function includes(collection, value, fromIndex, guard) {
  collection = isArrayLike(collection) ? collection : values(collection);
  fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

  var length = collection.length;
  if (fromIndex < 0) {
    fromIndex = nativeMax(length + fromIndex, 0);
  }
  return isString(collection)
    ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
    : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
}

module.exports = includes;


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(11),
    isArray = __webpack_require__(4),
    isObjectLike = __webpack_require__(5);

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
}

module.exports = isString;


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

var baseValues = __webpack_require__(462),
    keys = __webpack_require__(29);

/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */
function values(object) {
  return object == null ? [] : baseValues(object, keys(object));
}

module.exports = values;


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(94);

/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */
function baseValues(object, props) {
  return arrayMap(props, function(key) {
    return object[key];
  });
}

module.exports = baseValues;


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var flow_ = __webpack_require__(0).flow;
var curry_ = __webpack_require__(0).curry;

var _require = __webpack_require__(54),
    assign = _require.assign,
    bind = _require.bind;

var _require2 = __webpack_require__(187),
    freshCollection = _require2.freshCollection;

// freshStore :: (MainCollectionName, FieldToReferencedCollectipnsMap) -> Store


var freshStore = function freshStore(mainCollectionName) {
  return Object.assign({}, _defineProperty({}, mainCollectionName, Object.assign({}, freshCollection())));
};

// setCollection :: (ReferenceFieldName, Collection) -> Store -> Store
var setCollection = curry_(function (name, collection) {
  return assign(_defineProperty({}, name, collection));
});

// getCollection :: CollectionName -> Store -> Collection
var getCollection = function getCollection(collectionName) {
  return function (store) {
    return store[collectionName];
  };
};

// updateCollectionStore :: (CollectionName, Collection -> Collection) -> Store -> Store
var updateCollection = curry_(function (collectionName, updateFn) {
  return bind(flow_(getCollection(collectionName), updateFn), setCollection(collectionName));
});

module.exports.freshStore = freshStore;
module.exports.getCollection = getCollection;
module.exports.setCollection = setCollection;
module.exports.updateCollection = updateCollection;

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var actionTypes = __webpack_require__(129);

module.exports.setConnectedComponents = function (connectedComponents) {
  return {
    type: actionTypes.SET_CONNECTED_COMPONENTS,
    connectedComponents: connectedComponents
  };
};

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isEmpty_ = __webpack_require__(0).isEmpty;
var DATASET_TYPES = __webpack_require__(41);

var _require = __webpack_require__(2),
    isDatasetConfigured = _require.isDatasetConfigured,
    getReadWriteMode = _require.getReadWriteMode;

var reportDatasetActiveOnPage = function reportDatasetActiveOnPage(biLogger, state, connections, datasetType, isScoped, uniqueId, wixSdk) {
  if (!isScoped && !isEmpty_(connections) && wixSdk.window.viewMode !== 'Preview' && isDatasetConfigured(state)) {
    biLogger({
      evid: datasetType === DATASET_TYPES.ROUTER_DATASET ? 135 : 134,
      mode: getReadWriteMode(state),
      page_url: wixSdk.location.url,
      viewmode: wixSdk.window.viewMode,
      ds_id: uniqueId, // we do not yet get the real dataset id
      ds_type: datasetType
    });
  }
};

module.exports.reportDatasetActiveOnPage = reportDatasetActiveOnPage;

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(10),
    combineSubscribers = _require.combineSubscribers;

var records = __webpack_require__(467);

module.exports = function (_ref) {
  var recordStore = _ref.recordStore;
  return combineSubscribers({ records: records(recordStore) });
};

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var cloneDeep_ = __webpack_require__(0).cloneDeep;
var isEqual_ = __webpack_require__(0).isEqual;
var flatten_ = __webpack_require__(0).flatten;
var omit_ = __webpack_require__(0).omit;

var _require = __webpack_require__(27),
    isSameRecord = _require.isSameRecord;

var _require2 = __webpack_require__(126),
    isNone = _require2.isNone,
    isCallBeforeSaveHooks = _require2.isCallBeforeSaveHooks,
    isCheckHasDraft = _require2.isCheckHasDraft,
    isAssertValidity = _require2.isAssertValidity,
    isSaveRecord = _require2.isSaveRecord;

var _require3 = __webpack_require__(121),
    getPaginationData = _require3.getPaginationData,
    selectCurrentRecord = _require3.selectCurrentRecord,
    selectCurrentRecordIndex = _require3.selectCurrentRecordIndex,
    selectDefaultDraft = _require3.selectDefaultDraft,
    selectDesiredRecordIndex = _require3.selectDesiredRecordIndex,
    selectFieldsToUpdate = _require3.selectFieldsToUpdate,
    selectRefreshCurrentRecord = _require3.selectRefreshCurrentRecord,
    selectRemoveCurrentRecord = _require3.selectRemoveCurrentRecord,
    selectRefreshCurrentView = _require3.selectRefreshCurrentView,
    selectRevertChanges = _require3.selectRevertChanges,
    selectSaveState = _require3.selectSaveState,
    selectUpdateSource = _require3.selectUpdateSource,
    selectNewRecordIndex = _require3.selectNewRecordIndex;

var _require4 = __webpack_require__(137),
    assertValidityCmd = _require4.assertValidityCmd,
    notifyIndexChangeCmd = _require4.notifyIndexChangeCmd,
    notifyRecordSetLoadedCmd = _require4.notifyRecordSetLoadedCmd,
    updateCurrentViewCmd = _require4.updateCurrentViewCmd;

var _require5 = __webpack_require__(133),
    callBeforeSaveHooksCmd = _require5.callBeforeSaveHooksCmd,
    checkHasDraftCmd = _require5.checkHasDraftCmd,
    getRecordByIndexCmd = _require5.getRecordByIndexCmd,
    revertChangesCmd = _require5.revertChangesCmd,
    removeCurrentRecordCmd = _require5.removeCurrentRecordCmd,
    saveRecordCmd = _require5.saveRecordCmd,
    setFieldsInCurrentRecordCmd = _require5.setFieldsInCurrentRecordCmd,
    newRecordCmd = _require5.newRecordCmd;

var _require6 = __webpack_require__(188),
    fireEventCmd = _require6.fireEventCmd;

var omitSystemFields = function omitSystemFields(record) {
  return omit_(record, ['_id', '_createdDate', '_updatedDate']);
};

var subscriber = function subscriber(recordStore) {
  var processIndexChanges = function processIndexChanges(_ref) {
    var from = _ref.from,
        to = _ref.to,
        hasChanged = _ref.hasChanged,
        hasChangedToMatch = _ref.hasChangedToMatch;

    var toCurrentIndex = selectCurrentRecordIndex(to);
    var fromCurrentIndex = selectCurrentRecordIndex(from);
    var toDesiredIndex = selectDesiredRecordIndex(to);
    var toRefreshCurrentRecord = selectRefreshCurrentRecord(to);
    var fromRefreshCurrentRecord = selectRefreshCurrentRecord(from);
    var commandsToReturn = [];

    if (hasChangedToMatch(selectDesiredRecordIndex, function (desiredRecordIndex) {
      return desiredRecordIndex >= 0 && desiredRecordIndex !== toCurrentIndex;
    }) || toRefreshCurrentRecord && !fromRefreshCurrentRecord) {
      recordStore().matchWith({
        Nothing: function Nothing() {
          throw new Error('Record store service not ready yet');
        },
        Just: function Just(_ref2) {
          var service = _ref2.value;

          var totalCount = service.getMatchingRecordCount();
          var realIndex = Math.max(Math.min(toDesiredIndex, totalCount - 1), 0);

          if (fromCurrentIndex !== realIndex || toRefreshCurrentRecord) {
            commandsToReturn.push(getRecordByIndexCmd(realIndex));
          }
        }
      });
    }

    if (hasChanged(selectCurrentRecordIndex) && fromCurrentIndex >= 0) {
      commandsToReturn.push(notifyIndexChangeCmd());
      commandsToReturn.push(fireEventCmd('currentIndexChanged', selectCurrentRecordIndex(to)));
    }

    return commandsToReturn;
  };

  var processRecordChanges = function processRecordChanges(_ref3) {
    var from = _ref3.from,
        to = _ref3.to,
        hasChangedToMatch = _ref3.hasChangedToMatch,
        hasChangedToTrue = _ref3.hasChangedToTrue;

    var toCurrentIndex = selectCurrentRecordIndex(to);
    var toCurrentRecord = selectCurrentRecord(to);
    var fromCurrentRecord = selectCurrentRecord(from);
    var commandsToReturn = [];

    if (isSameRecord(fromCurrentRecord, toCurrentRecord) && !isEqual_(omitSystemFields(fromCurrentRecord), omitSystemFields(toCurrentRecord))) {
      commandsToReturn.push(fireEventCmd('itemValuesChanged', cloneDeep_(fromCurrentRecord), cloneDeep_(toCurrentRecord)));
    }

    var toFieldsToUpdate = selectFieldsToUpdate(to);
    if (hasChangedToMatch(selectFieldsToUpdate, function (fieldsToUpdate) {
      return fieldsToUpdate != null;
    })) {
      commandsToReturn.push(setFieldsInCurrentRecordCmd(toFieldsToUpdate, toCurrentIndex, selectUpdateSource(to)));
    }

    if (hasChangedToTrue(selectRevertChanges)) {
      commandsToReturn.push(revertChangesCmd(toCurrentIndex, selectDefaultDraft(to)));
    }

    if (hasChangedToTrue(selectRemoveCurrentRecord)) {
      commandsToReturn.push(removeCurrentRecordCmd(toCurrentIndex));
    }

    return commandsToReturn;
  };

  var processViewChanges = function processViewChanges(_ref4) {
    var hasChanged = _ref4.hasChanged,
        hasChangedToTrue = _ref4.hasChangedToTrue;

    var commandsToReturn = [];

    if (hasChanged(getPaginationData)) {
      commandsToReturn.push(notifyRecordSetLoadedCmd());
    }

    if (hasChangedToTrue(selectRefreshCurrentView)) {
      commandsToReturn.push(updateCurrentViewCmd());
    }

    return commandsToReturn;
  };

  var processSaveStates = function processSaveStates(_ref5) {
    var from = _ref5.from,
        to = _ref5.to,
        hasChangedToMatch = _ref5.hasChangedToMatch;

    var toCurrentIndex = selectCurrentRecordIndex(to);
    var toCurrentRecord = selectCurrentRecord(to);
    var fromCurrentRecord = selectCurrentRecord(from);

    if (hasChangedToMatch(selectSaveState, isCallBeforeSaveHooks)) {
      return callBeforeSaveHooksCmd();
    } else if (hasChangedToMatch(selectSaveState, isCheckHasDraft)) {
      return checkHasDraftCmd(toCurrentIndex);
    } else if (hasChangedToMatch(selectSaveState, isAssertValidity)) {
      return assertValidityCmd(toCurrentRecord);
    } else if (hasChangedToMatch(selectSaveState, isSaveRecord)) {
      return saveRecordCmd(toCurrentIndex);
    } else if (isSaveRecord(selectSaveState(from)) && isNone(selectSaveState(to))) {
      return fireEventCmd('afterSave', cloneDeep_(fromCurrentRecord), cloneDeep_(toCurrentRecord));
    }
  };

  var processNewRecord = function processNewRecord(_ref6) {
    var from = _ref6.from,
        to = _ref6.to,
        hasChangedToNotNull = _ref6.hasChangedToNotNull;

    var commandsToReturn = [];
    if (hasChangedToNotNull(selectNewRecordIndex)) {
      commandsToReturn.push(newRecordCmd(selectNewRecordIndex(to), selectDefaultDraft(to)));
    }

    return commandsToReturn;
  };

  return function (transition) {
    return flatten_([processIndexChanges, processRecordChanges, processViewChanges, processSaveStates, processNewRecord].map(function (fn) {
      return fn(transition);
    }));
  };
};

module.exports = subscriber;

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(10),
    combineSubscribers = _require.combineSubscribers;

var dynamicPages = __webpack_require__(469);

module.exports = function () {
  return combineSubscribers({ dynamicPages: dynamicPages() });
};

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var flatten_ = __webpack_require__(0).flatten;

var _require = __webpack_require__(130),
    selectNextDynamicPageUrl = _require.selectNextDynamicPageUrl,
    selectPreviousDynamicPageUrl = _require.selectPreviousDynamicPageUrl;

var _require2 = __webpack_require__(138),
    getNextDynamicPageCmd = _require2.getNextDynamicPageCmd,
    getPreviousDynamicPageCmd = _require2.getPreviousDynamicPageCmd;

var shouldLoadNextDynamicPageUrl = function shouldLoadNextDynamicPageUrl(state) {
  return selectNextDynamicPageUrl(state).shouldLoadUrl();
};

var shouldLoadPreviousDynamicPageUrl = function shouldLoadPreviousDynamicPageUrl(state) {
  return selectPreviousDynamicPageUrl(state).shouldLoadUrl();
};

var subscriber = function subscriber() {
  var processDynamicPagesStates = function processDynamicPagesStates(_ref) {
    var hasChangedToTrue = _ref.hasChangedToTrue;

    var commandsToReturn = [];

    if (hasChangedToTrue(shouldLoadNextDynamicPageUrl)) {
      commandsToReturn.push(getNextDynamicPageCmd());
    }
    if (hasChangedToTrue(shouldLoadPreviousDynamicPageUrl)) {
      commandsToReturn.push(getPreviousDynamicPageCmd());
    }

    return commandsToReturn;
  };

  return function (transition) {
    return flatten_([processDynamicPagesStates].map(function (fn) {
      return fn(transition);
    }));
  };
};

module.exports = subscriber;

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(471),
    ERROR = _require.ERROR;

var identity_ = __webpack_require__(0).identity;
var isError_ = __webpack_require__(0).isError;
var has_ = __webpack_require__(0).has;
var get_ = __webpack_require__(0).get;
var getUrlFromEvent = __webpack_require__(472);

function getExtraInfoFromBIError(biError) {
  return has_(biError, 'isTrusted') ? {
    biUrl: getUrlFromEvent(biError, 'Failed to get BI url from the DOM event')
  } : { biError: biError };
}

function getBIErrorInfo(biPayload, biError) {
  if (isError_(biError)) {
    return {
      exception: biError,
      extra: { biPayload: biPayload }
    };
  } else {
    return {
      exception: new Error('Failed to send error to BI'),
      extra: Object.assign({ biPayload: biPayload }, getExtraInfoFromBIError(biError))
    };
  }
}

function reportBIErrorToRaven(_ref) {
  var Raven = _ref.Raven,
      biPayload = _ref.biPayload,
      biError = _ref.biError;

  var _getBIErrorInfo = getBIErrorInfo(biPayload, biError),
      exception = _getBIErrorInfo.exception,
      extra = _getBIErrorInfo.extra;

  Raven.captureException(exception, {
    ignoreBI: true,
    level: 'info',
    extra: extra
  });
}

function safeLog(_ref2) {
  var logger = _ref2.logger,
      biPayload = _ref2.biPayload,
      Raven = _ref2.Raven;

  try {
    logger(biPayload).catch(function (biError) {
      return reportBIErrorToRaven({ Raven: Raven, biPayload: biPayload, biError: biError });
    });
  } catch (biError) {
    reportBIErrorToRaven({ Raven: Raven, biPayload: biPayload, biError: biError });
  }
}

module.exports = function (logger, Raven) {
  var shouldSend = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {
    return true;
  };

  var shouldSendBI = function shouldSendBI(data) {
    return !data.ignoreBI && (!data.level || data.level === 'error') && shouldSend(get_(data, 'exception.values[0].type'));
  };

  Raven.setDataCallback(function (data) {
    var originalCallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : identity_;

    var finalData = originalCallback(data); // BI should be last in the chain in order to have all the info
    if (shouldSendBI(finalData)) {
      if (finalData.exception) {
        var exception = finalData.exception.values[0];
        var biPayload = {
          dsc: exception.value,
          errn: exception.value,
          errc: ERROR
        };
        safeLog({ logger: logger, biPayload: biPayload, Raven: Raven });
      } else {
        var _biPayload = {
          errn: finalData.message,
          errc: ERROR
        };
        safeLog({ logger: logger, biPayload: _biPayload, Raven: Raven });
      }
    }

    return finalData;
  });
};

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Do not remove/change exsiting values

module.exports = {
  ERROR: 1,
  UNHANDLED_REJECTION: 2, // unused

  //DBSM Load Failures
  DATASET_FAILED_TO_LOAD: 3,
  CONNECTION_CONFIG_FAILED_TO_LOAD: 4,
  FILTER_PANEL_FAILED_TO_LOAD: 5,
  SORT_PANEL_FAILED_TO_LOAD: 6,
  ADD_COLUMN_PANEL_FAILED_TO_LOAD: 7,
  CHANGE_COLLECTION_PANEL_FAILED_TO_LOAD: 8,
  CREATE_DATASET_PANEL_FAILED_TO_LOAD: 9,
  NEW_DYNAMIC_PAGE_PANEL_FAILED_TO_LOAD: 10,
  DELETE_DYNAMIC_PAGE_PANEL_FAILED_TO_LOAD: 11,
  DYNAMIC_PAGE_INFO_PANEL_FAILED_TO_LOAD: 12,
  DYNAMIC_PAGE_SEO_PANEL_FAILED_TO_LOAD: 13,
  DYNAMIC_PAGES_HOOKS_PANEL_FAILED_TO_LOAD: 14,
  ERROR_PANEL_FAILED_TO_LOAD: 15,

  //Custom Router Load Failures
  CONNECT_PAGE_FAILED_TO_LOAD: 21,
  DELETE_PAGE_FAILED_TO_LOAD: 22,
  NEW_PAGE_FAILED_TO_LOAD: 23,
  PAGE_INFO_FAILED_TO_LOAD: 24,
  PAGE_SEO_FAILED_TO_LOAD: 25,
  UPDATE_PREFIX_FAILED_TO_LOAD: 26,
  WEB_MODULES_PERMISSONS_FAILED_TO_LOAD: 27
};

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var get_ = __webpack_require__(0).get;
var result = __webpack_require__(18);
var maybe = __webpack_require__(1);

module.exports = function (event, fallbackValue) {
  return maybe.fromNullable(get_(event, ['target', 'src'])).map(function (url) {
    return result.try(function () {
      return decodeURIComponent(url);
    }).getOrElse(url);
  }).getOrElse(fallbackValue);
};

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var identity_ = __webpack_require__(0).identity;

var addRavenData = function addRavenData(Raven, extraData, key) {
  Raven.setDataCallback(function (data) {
    var originalCallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : identity_;

    data.extra = data.extra || {};
    data.extra[key] = Object.assign({}, data.extra[key], extraData);

    return originalCallback(data);
  });
};

module.exports = addRavenData;

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var pick_ = __webpack_require__(0).pick;
var maybe = __webpack_require__(1);

var getReferencedCollectionsNames = __webpack_require__(475);
var promiseRetry = __webpack_require__(476);

var NUMBER_OF_SCHEMA_RETRIES = 5;

var SCHEMA_FETCH_FAILURE_BREADCRUMB = function SCHEMA_FETCH_FAILURE_BREADCRUMB(retry, error) {
  return {
    category: 'schema',
    message: 'LOAD_SCHEMA_FAILURE retry ' + retry + '/' + NUMBER_OF_SCHEMA_RETRIES,
    data: { error: error }
  };
};

var SCHEMA_FETCH_SUCCESS_BREADCRUMB = function SCHEMA_FETCH_SUCCESS_BREADCRUMB(retry) {
  return {
    category: 'schema',
    message: 'LOAD_SCHEMA_SUCCESS after ' + retry + ' retries'
  };
};

module.exports = function (wixDataSchemasProxy, Raven) {
  var isLoadingSchemas = false;
  var schemasPromise = void 0;
  var cachedSchemas = maybe.Nothing();

  var fetchSchemas = function fetchSchemas() {
    isLoadingSchemas = true;
    var schemaLoadRetryNum = 1;
    return promiseRetry(function () {
      return wixDataSchemasProxy.list().catch(function (error) {
        Raven.captureBreadcrumb(SCHEMA_FETCH_FAILURE_BREADCRUMB(schemaLoadRetryNum, error));
        schemaLoadRetryNum++;
        throw error;
      });
    }, NUMBER_OF_SCHEMA_RETRIES).then(function (schemas) {
      if (schemaLoadRetryNum > 1) {
        Raven.captureException(new Error('Fetching schemas required retries'), { level: 'info' });
      }
      Raven.captureBreadcrumb(SCHEMA_FETCH_SUCCESS_BREADCRUMB(schemaLoadRetryNum));
      cachedSchemas = maybe.Just(schemas);
      isLoadingSchemas = false;
      return schemas;
    }).catch(function (error) {
      isLoadingSchemas = false;
      throw error;
    });
  };

  var loadSchemas = function loadSchemas() {
    var isSchemaLoaded = cachedSchemas.matchWith({
      Just: function Just() {
        return true;
      },
      Nothing: function Nothing() {
        return false;
      }
    });
    if (!isLoadingSchemas && !isSchemaLoaded) {
      schemasPromise = fetchSchemas();
    }
    return schemasPromise;
  };

  return {
    loadSchemas: loadSchemas,
    getSchema: function getSchema(collectionName) {
      return _getSchema(cachedSchemas, collectionName);
    },
    getReferencedCollectionsSchemas: function getReferencedCollectionsSchemas(collectionName) {
      return _getReferencedCollectionsSchemas(cachedSchemas, collectionName);
    }
  };
};

var _getSchema = function _getSchema(schemas, collectionName) {
  return schemas.map(function (schemas) {
    return schemas[collectionName];
  }).getOrElse(maybe.Nothing());
};

var _getReferencedCollectionsSchemas = function _getReferencedCollectionsSchemas(schemas, collectionName) {
  return schemas.chain(function (schemas) {
    return maybe.fromNullable(schemas[collectionName]);
  }).map(function (mainSchema) {
    return getReferencedCollectionsNames(mainSchema);
  }).chain(function (referencedCollectionsNames) {
    return schemas.map(function (schemas) {
      return pick_(schemas, referencedCollectionsNames);
    });
  }).getOrElse(maybe.Nothing());
};

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var values_ = __webpack_require__(0).values;
var map_ = __webpack_require__(0).map;
var pickBy_ = __webpack_require__(0).pickBy;
var uniq_ = __webpack_require__(0).uniq;
var maybe = __webpack_require__(1);

var getReferencedCollection = function getReferencedCollection(field) {
  return field.referencedCollection;
};

module.exports = function (schema) {
  return maybe.fromNullable(schema.fields).map(function (fields) {
    return pickBy_(fields, getReferencedCollection);
  }).map(values_).map(function (refFields) {
    return map_(refFields, getReferencedCollection);
  }).map(uniq_).getOrElse(maybe.Nothing());
};

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

module.exports = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(method, numberOfRetries) {
    var lastError, index;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            lastError = null;
            index = 0;

          case 2:
            if (!(index < numberOfRetries)) {
              _context.next = 15;
              break;
            }

            _context.prev = 3;
            _context.next = 6;
            return method();

          case 6:
            return _context.abrupt('return', _context.sent);

          case 9:
            _context.prev = 9;
            _context.t0 = _context['catch'](3);

            lastError = _context.t0;

          case 12:
            index++;
            _context.next = 2;
            break;

          case 15:
            throw lastError;

          case 16:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this, [[3, 9]]);
  }));

  function promiseRetry(_x, _x2) {
    return _ref.apply(this, arguments);
  }

  return promiseRetry;
}();

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var wixDataFunctions = ['save', 'remove', 'find', 'filter', 'query'];
var wixDataSchemasFunctions = ['list'];

var wrapWixDataFunctions = function wrapWixDataFunctions(wixData, functions, errorWrapper) {
  return functions.reduce(function (proxy, f) {
    proxy[f] = errorWrapper(function () {
      return wixData[f].apply(wixData, arguments);
    });
    return proxy;
  }, {});
};

module.exports = function (wixDataCodeZone, wixDataCreator) {
  var _wixDataCreator = wixDataCreator(),
      wixData = _wixDataCreator.wixData,
      wixDataSchemas = _wixDataCreator.wixDataSchemas;

  return {
    wixDataProxy: wrapWixDataFunctions(wixData, wixDataFunctions, wixDataCodeZone),
    wixDataSchemasProxy: wrapWixDataFunctions(wixDataSchemas, wixDataSchemasFunctions, wixDataCodeZone)
  };
};

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var identity_ = __webpack_require__(0).identity;
var mergeWith_ = __webpack_require__(0).mergeWith;
var pull_ = __webpack_require__(0).pull;
var mapValues_ = __webpack_require__(0).mapValues;
var omit_ = __webpack_require__(0).omit;
var has_ = __webpack_require__(0).has;

var retry = function retry(Raven, ravenFunction) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    try {
      Raven[ravenFunction].apply(Raven, args);
    } catch (e) {
      try {
        Raven[ravenFunction]('Failed on ' + ravenFunction + '. Got exception: ' + e.name + ' - ' + e.message, {
          extra: {
            'original-error': JSON.stringify(args)
          }
        });
      } catch (e) {
        // well... we really have nothing to do here :(
      }
    }
  };
};

var removeRecordsIfExists = function removeRecordsIfExists(value) {
  return has_(value, 'state.records') ? omit_(value, 'state.records') : value;
};

var removeUserData = function removeUserData(data) {
  return mapValues_(data, removeRecordsIfExists);
};

module.exports = function (Raven) {
  var callbacks = [];

  Raven.setDataCallback(function (data) {
    var originalCallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : identity_;

    callbacks.forEach(function (cb) {
      return mergeWith_(data.extra, cb(), function (objValue, srcValue) {
        // We customize the serializer because of this bug:
        // https://github.com/origamitower/folktale/issues/190
        if (srcValue && srcValue[Symbol.for('@@folktale:adt:tag')]) {
          return srcValue.toJSON();
        }
      });
    });
    var finalData = originalCallback(data);
    finalData.extra = removeUserData(finalData.extra);

    return finalData;
  });

  return {
    addDataCallback: function addDataCallback(cb) {
      callbacks.push(cb);
      return function () {
        return pull_(callbacks, cb);
      };
    },
    setUserContext: function setUserContext() {
      return Raven.setUserContext.apply(Raven, arguments);
    },
    captureBreadcrumb: function captureBreadcrumb() {
      return Raven.captureBreadcrumb.apply(Raven, arguments);
    },
    captureException: function captureException() {
      return retry(Raven, 'captureException').apply(undefined, arguments);
    },
    captureMessage: function captureMessage() {
      return retry(Raven, 'captureMessage').apply(undefined, arguments);
    }
  };
};

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.create = create;

var _loggerBuilder = __webpack_require__(480);

var _loggerBuilder2 = _interopRequireDefault(_loggerBuilder);

var _env = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Creates a logger instance, initialized with application name.
 *
 * @param {String} appName application name (will be used as an application identifier in the monitoring tool, e.g. Grafana)
 * @param {Boolean} isWidgetLogger
 */
function create(appName) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref$baseUrl = _ref.baseUrl,
        baseUrl = _ref$baseUrl === undefined ? null : _ref$baseUrl,
        _ref$appId = _ref.appId,
        appId = _ref$appId === undefined ? null : _ref$appId,
        _ref$isWidgetLogger = _ref.isWidgetLogger,
        isWidgetLogger = _ref$isWidgetLogger === undefined ? false : _ref$isWidgetLogger,
        _ref$errorHandlerTogg = _ref.errorHandlerToggle,
        errorHandlerToggle = _ref$errorHandlerTogg === undefined ? false : _ref$errorHandlerTogg,
        _ref$disableAutoLoadF = _ref.disableAutoLoadFinish,
        disableAutoLoadFinish = _ref$disableAutoLoadF === undefined ? false : _ref$disableAutoLoadF,
        _ref$swallowException = _ref.swallowExceptions,
        swallowExceptions = _ref$swallowException === undefined ? false : _ref$swallowException,
        _ref$interactionTimeo = _ref.interactionTimeout,
        interactionTimeout = _ref$interactionTimeo === undefined ? null : _ref$interactionTimeo,
        _ref$timeoutHook = _ref.timeoutHook,
        timeoutHook = _ref$timeoutHook === undefined ? null : _ref$timeoutHook,
        _ref$startHook = _ref.startHook,
        startHook = _ref$startHook === undefined ? null : _ref$startHook,
        _ref$endHook = _ref.endHook,
        endHook = _ref$endHook === undefined ? null : _ref$endHook,
        _ref$networkAnalysis = _ref.networkAnalysis,
        networkAnalysis = _ref$networkAnalysis === undefined ? false : _ref$networkAnalysis,
        _ref$publisher = _ref.publisher,
        publisher = _ref$publisher === undefined ? null : _ref$publisher;

    var appVersion = typeof (0, _env.env)() !== 'undefined' ? (0, _env.env)().__CI_APP_VERSION__ : null;

    (0, _env.env)().fedops = (0, _env.env)().fedops || {};
    (0, _env.env)().fedops.apps = (0, _env.env)().fedops.apps || {};

    return new _loggerBuilder2.default().setAppName(appName).setAppVersion(appVersion).setBaseUrl(baseUrl).setAppId(appId).setErrorHandlerToggle(errorHandlerToggle).setSwallowExceptions(swallowExceptions).setWidgetLogger(isWidgetLogger).setInteractionTimeout(interactionTimeout).setTimeoutHook(timeoutHook).setStartHook(startHook).setEndHook(endHook).setDisableAutoLoadFinish(disableAutoLoadFinish).setNetworkAnalysis(networkAnalysis).setPublisher(publisher).build();
}

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.setFactory = setFactory;

var _tools = __webpack_require__(189);

var _tools2 = _interopRequireDefault(_tools);

var _storage = __webpack_require__(481);

var _storage2 = _interopRequireDefault(_storage);

var _reporter = __webpack_require__(482);

var _reporter2 = _interopRequireDefault(_reporter);

var _loggerInstance = __webpack_require__(485);

var _loggerInstance2 = _interopRequireDefault(_loggerInstance);

var _widgetLoggerInstance = __webpack_require__(493);

var _widgetLoggerInstance2 = _interopRequireDefault(_widgetLoggerInstance);

var _errorHandler = __webpack_require__(495);

var _errorHandler2 = _interopRequireDefault(_errorHandler);

var _conf = __webpack_require__(496);

var _publishers = __webpack_require__(190);

var _env = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function getSessionId() {
  var res = typeof (0, _env.env)() !== 'undefined' && (0, _env.env)().fedops && (0, _env.env)().fedops.sessionId;
  res = res || _storage2.default.getItem(_conf.SESSION_ID_STORAGE_KEY);
  res = res || _tools2.default.generateGuid();

  _storage2.default.setItem(_conf.SESSION_ID_STORAGE_KEY, res);

  return res;
}

var ReporterFactory = _reporter2.default; // good for tests

function setFactory(factory) {
  ReporterFactory = factory;
}
/**
 * Builds a logger instance.
 */

var BaseLogger = function () {
  function BaseLogger() {
    _classCallCheck(this, BaseLogger);
  }

  _createClass(BaseLogger, [{
    key: 'setAppName',
    value: function setAppName(name) {
      this.appName = name;
      return this;
    }
  }, {
    key: 'setAppVersion',
    value: function setAppVersion(version) {
      this.appVersion = version;
      return this;
    }
  }, {
    key: 'setErrorHandlerToggle',
    value: function setErrorHandlerToggle(toggle) {
      this.errorHandlerToggle = toggle;
      return this;
    }
  }, {
    key: 'setSwallowExceptions',
    value: function setSwallowExceptions(swallow) {
      this.swallowExceptions = swallow;
      return this;
    }
  }, {
    key: 'setAppId',
    value: function setAppId(appId) {
      this.appId = appId;
      return this;
    }
  }, {
    key: 'setBaseUrl',
    value: function setBaseUrl(url) {
      this.baseUrl = url;
      return this;
    }
  }, {
    key: 'setWidgetLogger',
    value: function setWidgetLogger(isWidgetLogger) {
      this.isWidgetLogger = isWidgetLogger;
      return this;
    }
  }, {
    key: 'setInteractionTimeout',
    value: function setInteractionTimeout(interactionTimeout) {
      this.interactionTimeout = interactionTimeout;
      return this;
    }
  }, {
    key: 'setTimeoutHook',
    value: function setTimeoutHook(timeoutHook) {
      this.timeoutHook = timeoutHook;
      return this;
    }
  }, {
    key: 'setStartHook',
    value: function setStartHook(startHook) {
      this.startHook = startHook;
      return this;
    }
  }, {
    key: 'setEndHook',
    value: function setEndHook(endHook) {
      this.endHook = endHook;
      return this;
    }
  }, {
    key: 'setDisableAutoLoadFinish',
    value: function setDisableAutoLoadFinish(disableAutoLoadFinish) {
      this.disableAutoLoadFinish = disableAutoLoadFinish;
      return this;
    }
  }, {
    key: 'setNetworkAnalysis',
    value: function setNetworkAnalysis() {
      // TODO - remove this API once no usage across wix
      return this;
    }
  }, {
    key: 'setPublisher',
    value: function setPublisher(publisher) {
      this.publisher = publisher;
      return this;
    }
  }, {
    key: 'build',
    value: function build() {
      if (!this.appName) {
        return null;
      }

      if (!this.appVersion) {
        this.appVersion = _conf.DEFAULT_APP_VERSION;
      }

      var reporter = this._createReporterInstance(this.baseUrl || _conf.BI_BASE_URL, (0, _publishers.getPublisherByType)(this.publisher));
      var errorHandlerToggle = this.errorHandlerToggle;
      var swallowExceptions = this.swallowExceptions;
      var interactionTimeout = this.interactionTimeout;
      var timeoutHook = this.timeoutHook;
      var startHook = this.startHook;
      var endHook = this.endHook;
      var disableAutoLoadFinish = this.disableAutoLoadFinish;

      if (errorHandlerToggle) {
        (0, _env.env)().fedopsLoggerErrorHandler = (0, _env.env)().fedopsLoggerErrorHandler || new _errorHandler2.default({ swallowExceptions: swallowExceptions });
      }

      var logger = null;

      if (this.isWidgetLogger) {
        logger = new _widgetLoggerInstance2.default(this.appName, this.appVersion, reporter, { sessionId: getSessionId(), errorHandlerToggle: errorHandlerToggle, swallowExceptions: swallowExceptions, disableAutoLoadFinish: disableAutoLoadFinish });
      } else {
        logger = new _loggerInstance2.default(this.appName, this.appVersion, reporter, { sessionId: getSessionId(), errorHandlerToggle: errorHandlerToggle, swallowExceptions: swallowExceptions, disableAutoLoadFinish: disableAutoLoadFinish, interactionTimeout: interactionTimeout, timeoutHook: timeoutHook, startHook: startHook, endHook: endHook });
      }

      return logger;
    }
  }, {
    key: '_createReporterInstance',
    value: function _createReporterInstance(baseUrl, publisher) {

      try {

        return new ReporterFactory(baseUrl, publisher);
      } catch (err) {

        return ReporterFactory(baseUrl, publisher); // eslint-disable-line
      }
    }
  }]);

  return BaseLogger;
}();

exports.default = BaseLogger;

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _env = __webpack_require__(6);

/**
 * Local storage wrapper (for tests mainly)
 */
exports.default = {
  getItem: function getItem(key) {
    try {
      return (0, _env.env)().localStorage.getItem(key);
    } catch (e) {}
  },
  setItem: function setItem(key, value) {
    try {
      return (0, _env.env)().localStorage.setItem(key, value);
    } catch (e) {}
  }
};

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _publishers = __webpack_require__(190);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Reporter = function () {
  function Reporter(baseUrl, publisher) {
    _classCallCheck(this, Reporter);

    this.baseUrl = baseUrl;
    this.publisher = publisher;

    if (!this.publisher) {
      this.publisher = (0, _publishers.getPublisherByType)();
    }
  }

  _createClass(Reporter, [{
    key: 'getBaseUrl',
    value: function getBaseUrl() {
      return this.baseUrl;
    }
  }, {
    key: 'getPublisher',
    value: function getPublisher() {
      return this.publisher;
    }
  }, {
    key: 'report',
    value: function report(data) {
      if (!data) {
        return null;
      }

      return this.publisher(this.baseUrl, data);
    }
  }]);

  return Reporter;
}();

exports.default = Reporter;

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _env = __webpack_require__(6);

/**
 * Simple GET request wrapper (for tests mainly)
 */
exports.default = {
  fetch: function fetch(url) {

    var Image = (0, _env.env)().Image;
    return new Image().src = url;
  }
};

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.listen = listen;
exports.sendBeacon = sendBeacon;

var _env = __webpack_require__(191);

function hook(obj, fnName, hook) {
  if (!obj || !obj[fnName]) {
    return;
  }

  var original = obj[fnName];
  obj[fnName] = function () {
    hook.apply(null, arguments);
    return original.apply(obj, arguments);
  };
}

function onLoad(cb) {
  setTimeout(function () {
    return (0, _env.provideBrowsingContext)(function (window) {
      return cb(window.location.href);
    });
  });
}

function onPushState(cb) {
  (0, _env.provideBrowsingContext)(function (_ref) {
    var history = _ref.history;
    return ['pushState', 'replaceState'].forEach(function (fnName) {
      hook(history, fnName, function (_, __, url) {
        return cb(url);
      });
    });
  });
}

function onPopState(cb) {
  (0, _env.provideBrowsingContext)(function (window) {
    return window.addEventListener('popstate', function () {
      return cb(window.location.href);
    });
  });
}

function listen(cb) {
  var fromUrl = '';

  [onLoad, onPushState, onPopState].forEach(function (event) {
    return event(function (toUrl) {
      cb(fromUrl, toUrl);
      fromUrl = toUrl;
    });
  });
}

function sendBeacon(url) {
  if (typeof navigator === 'undefined' || !navigator || !navigator.sendBeacon) {
    return false;
  }

  return navigator.sendBeacon(url);
}

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _baseLogger = __webpack_require__(192);

var _baseLogger2 = _interopRequireDefault(_baseLogger);

var _biLoadFinishItem = __webpack_require__(490);

var _biLoadFinishItem2 = _interopRequireDefault(_biLoadFinishItem);

var _durationItem = __webpack_require__(193);

var _durationItem2 = _interopRequireDefault(_durationItem);

var _biInteractionStartItem = __webpack_require__(491);

var _biInteractionStartItem2 = _interopRequireDefault(_biInteractionStartItem);

var _biInteractionEndItem = __webpack_require__(492);

var _biInteractionEndItem2 = _interopRequireDefault(_biInteractionEndItem);

var _biErrorItem = __webpack_require__(196);

var _biErrorItem2 = _interopRequireDefault(_biErrorItem);

var _performance = __webpack_require__(55);

var _performance2 = _interopRequireDefault(_performance);

var _env = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var callHook = function callHook(hook, hookArgs) {
  if (hook) {
    return hook(hookArgs);
  }
};

/**
 * Logs application load phases.
 *
 * Before adding new parameters to the reported events, please make sure the BI schema supports them:
 * http://bo.wix.com/bi-catalog-webapp/#/sources/72
 */

var LoggerInstance = function (_BaseLogger) {
  _inherits(LoggerInstance, _BaseLogger);

  function LoggerInstance(appName, appVersion, reporter, _ref) {
    var sessionId = _ref.sessionId,
        errorHandlerToggle = _ref.errorHandlerToggle,
        disableAutoLoadFinish = _ref.disableAutoLoadFinish,
        interactionTimeout = _ref.interactionTimeout,
        timeoutHook = _ref.timeoutHook,
        startHook = _ref.startHook,
        endHook = _ref.endHook;

    _classCallCheck(this, LoggerInstance);

    var _this = _possibleConstructorReturn(this, (LoggerInstance.__proto__ || Object.getPrototypeOf(LoggerInstance)).call(this, appName, appVersion, reporter, { sessionId: sessionId, errorHandlerToggle: errorHandlerToggle, disableAutoLoadFinish: disableAutoLoadFinish }));

    _this._outgoingInteractions = {};
    _this.interactionTimeout = interactionTimeout;
    _this.timeoutHook = timeoutHook;
    _this.startHook = startHook;
    _this.endHook = endHook;
    return _this;
  }

  /**
   * Final phase (http://bo.wix.com/bi-catalog-webapp/#/sources/72/events/11)
   * Call this method when your application finishes loading and after all custom phases.
   */


  _createClass(LoggerInstance, [{
    key: 'appLoaded',
    value: function appLoaded() {
      if (this._appLoadedCalled) {
        return;
      }

      if ((0, _env.env)() && (0, _env.env)().fedops && typeof (0, _env.env)().fedops.clearLoadTimeout === 'function') {
        (0, _env.env)().fedops.clearLoadTimeout();
      }

      var dataSource = this.dataSource.clone().addItem(new _biLoadFinishItem2.default(this.sessionId)).addItem(new _durationItem2.default(this.appName).setFirstRequestDuration());

      this._appLoadedCalled = true;
      _performance2.default.mark('[fedops] app-loaded');
      _performance2.default.measure('[fedops] app-loaded', 'navigationStart', '[fedops] app-loaded');
      this.reportNetworkAnalysis();
      return this._report(dataSource);
    }

    /**
     * Custom interaction start (http://bo.wix.com/bi-catalog-webapp/#/sources/72/events/15)
     *
     * @param {String} interactionName  interaction name
     */

  }, {
    key: 'interactionStarted',
    value: function interactionStarted(interactionName) {
      var _this2 = this;

      var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          interactionTimeout = _ref2.interactionTimeout,
          startHook = _ref2.startHook,
          timeoutHook = _ref2.timeoutHook;

      _performance2.default.mark(interactionName + ' started');
      var scheduleTimeoutEvent = function scheduleTimeoutEvent() {
        if (interactionTimeout || _this2.interactionTimeout) {
          return setTimeout(function () {
            var dataSource = _this2.dataSource.clone().addItem({ interactionName: interactionName }).addItem({ errorType: 'timeout' }).addItem(new _biErrorItem2.default(_this2.sessionId));

            _this2._report(dataSource);
            callHook(timeoutHook || _this2.timeoutHook, { name: interactionName, timeout: interactionTimeout || _this2.interactionTimeout });
          }, interactionTimeout || _this2.interactionTimeout);
        }
      };
      var dataSource = this.dataSource.clone().addItem({ name: interactionName }).addItem(new _biInteractionStartItem2.default(this.sessionId));

      this._outgoingInteractions[interactionName] = {
        timestamp: _performance2.default.now(),
        timeout: interactionTimeout || this.interactionTimeout
      };
      this._report(dataSource);
      callHook(startHook || this.startHook, { name: interactionName });

      var timeoutId = scheduleTimeoutEvent();
      return {
        timeoutId: timeoutId
      };
    }

    /**
     * Custom interaction end (http://bo.wix.com/bi-catalog-webapp/#/sources/72/events/16)
     *
     * @param {String} interactionName  interaction name
     */

  }, {
    key: 'interactionEnded',
    value: function interactionEnded(interactionName) {
      var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          timeoutId = _ref3.timeoutId,
          endHook = _ref3.endHook;

      _performance2.default.mark(interactionName + ' ended');
      _performance2.default.measure(interactionName + ' duration', interactionName + ' started', interactionName + ' ended');

      if (timeoutId) {
        clearTimeout(timeoutId);
      }

      var duration = this._outgoingInteractions[interactionName] ? Math.floor(_performance2.default.now() - this._outgoingInteractions[interactionName].timestamp) : '';

      callHook(endHook || this.endHook, {
        name: interactionName,
        duration: duration,
        timeout: this._outgoingInteractions[interactionName] && this._outgoingInteractions[interactionName].timeout
      });

      var dataSource = this.dataSource.clone().addItem({ name: interactionName }).addItem({ duration: duration }).addItem(new _biInteractionEndItem2.default(this.sessionId));

      delete this._outgoingInteractions[interactionName];

      this._report(dataSource);
    }
  }, {
    key: 'isDisableAutoLoadFinish',
    value: function isDisableAutoLoadFinish() {
      return this._isDisableAutoLoadFinish();
    }
  }]);

  return LoggerInstance;
}(_baseLogger2.default);

// vim: set ts=2 sw=2 tw=80 et :


exports.default = LoggerInstance;

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dataItem = __webpack_require__(95);

var _dataItem2 = _interopRequireDefault(_dataItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Data accumulator
 */
var DataSource = function () {
  function DataSource() {
    var _this = this;

    var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    _classCallCheck(this, DataSource);

    this.items = [];

    if (item) {
      (typeof item.length === 'undefined' ? [item] : item).forEach(function (item) {
        return _this.addItem(item);
      });
    }
  }

  /**
   * Creates a new DataSource instance and clones internal state.
   *
   * @returns {DataSource}
   */


  _createClass(DataSource, [{
    key: 'clone',
    value: function clone() {
      return new DataSource(this.items.slice());
    }

    /**
     * Adds a new item.
     *
     * @param {Object | DataItem} item
     *
     * @return {DataSource} self
     */

  }, {
    key: 'addItem',
    value: function addItem(item) {
      this.items.push(item instanceof _dataItem2.default ? item : new _dataItem2.default(item));

      return this;
    }

    /**
     * Merges all added items into one plain object.
     *
     * @returns {Object}
     */

  }, {
    key: 'mergeItems',
    value: function mergeItems() {
      var res = {};

      for (var i = 0; i < this.items.length; i++) {
        var item = this.items[i];

        if (!item.isActive()) {
          res = null;
          break;
        }

        var data = item.export();

        for (var key in data) {
          if (data.hasOwnProperty(key)) {
            // eslint-disable-line
            res[key] = data[key];
          }
        }
      }

      return res;
    }
  }]);

  return DataSource;
}();

exports.default = DataSource;

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _biBaseItem = __webpack_require__(17);

var _biBaseItem2 = _interopRequireDefault(_biBaseItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Represents the "load phase" bi event:
 * http://bo.wix.com/bi-catalog-webapp/#/sources/72/events/13
 *
 * It should be used to monitor custom application load phases.
 */
var BiLoadPhaseDataItem = function (_BiBaseDataItem) {
  _inherits(BiLoadPhaseDataItem, _BiBaseDataItem);

  function BiLoadPhaseDataItem(sessionId) {
    _classCallCheck(this, BiLoadPhaseDataItem);

    return _possibleConstructorReturn(this, (BiLoadPhaseDataItem.__proto__ || Object.getPrototypeOf(BiLoadPhaseDataItem)).call(this, 13, sessionId));
  }

  return BiLoadPhaseDataItem;
}(_biBaseItem2.default);

exports.default = BiLoadPhaseDataItem;

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _biBaseItem = __webpack_require__(17);

var _biBaseItem2 = _interopRequireDefault(_biBaseItem);

var _location = __webpack_require__(489);

var _location2 = _interopRequireDefault(_location);

var _performance = __webpack_require__(55);

var _performance2 = _interopRequireDefault(_performance);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RESOURCES_TYPES = {
  xmlhttprequest: {
    count: 'countXhr',
    unsupported: 'unsprtXhr',
    duration: 'timeXhr',
    total: 'sizeXhr',
    longest: 'longXhr',
    http2: 'h2Xhr'
  },
  script: {
    count: 'countJs',
    unsupported: 'unsprtJs',
    duration: 'timeJs',
    total: 'sizeJs',
    cached: 'cachedJs',
    http2: 'h2Js'
  },
  link: { // css
    count: 'countCss',
    unsupported: 'unsprtCss',
    duration: 'timeCss',
    total: 'sizeCss',
    cached: 'cachedCss',
    http2: 'h2Css'
  },
  img: {
    count: 'countImg',
    unsupported: 'unsprtImg',
    duration: 'timeImg',
    total: 'sizeImg',
    cached: 'cachedImages',
    http2: 'h2Images'
  }
};

var CUSTOM_VALIDATORS = {
  link: function link(resource) {
    return (/(.\.css$|.\.css?.)/g.test(resource.name)
    );
  }
};

var durationOf = function durationOf(item) {
  return item.responseEnd - item.startTime;
};

function filterResourcesByType(resources, type) {
  var validator = CUSTOM_VALIDATORS[type];
  return resources.filter(function (r) {
    return type === r.initiatorType && (validator ? validator(r) : true);
  });
}

function calculateTotalSizeOfResource(resources) {
  return resources.reduce(function (totalSize, resource) {
    return totalSize + resource.transferSize;
  }, 0);
}

function calculateResourceLoadLongestDuration(resources) {
  if (resources.length === 0) {
    return 0;
  }
  var longest = resources.reduce(function (acc, cur) {
    return durationOf(cur) >= durationOf(acc) ? cur : acc;
  });
  return durationOf(longest);
}

function calculateResourceLoadDuration(resources) {
  if (resources.length === 0) {
    return 0;
  }
  var loadStartStop = {
    startTime: Infinity,
    responseEnd: 0
  };
  resources.forEach(function (r) {
    if (loadStartStop.startTime > r.startTime) {
      loadStartStop.startTime = r.startTime;
    }
    if (loadStartStop.responseEnd < r.responseEnd) {
      loadStartStop.responseEnd = r.responseEnd;
    }
  });
  return loadStartStop.responseEnd - loadStartStop.startTime;
}

function calculatePercentageOfUnsupportedResources(resources) {
  var totalCount = resources.length;
  if (totalCount === 0) {
    return 0;
  }
  var unsupportedCount = resources.filter(isResourceUnsupported).length;
  return Math.round(unsupportedCount / totalCount * 100);
}

function calculateCachedResourcesPercentage(resources) {
  if (resources.length === 0) {
    return 0;
  }
  var cached = resources.filter(function (r) {
    return r.transferSize === 0;
  });
  return Math.round(cached.length / resources.length * 100);
}

function calculatePercentageOfHttp2(resources) {
  if (resources.length === 0) {
    return 0;
  }
  var supported = false;
  var res = Math.round(resources.filter(function (r) {
    supported = supported || 'nextHopProtocol' in r;
    return r.nextHopProtocol === 'h2';
  }).length / resources.length * 100);
  return supported ? res : NaN;
}

function isResourceRelevant(resource) {
  return !resource.name.match(/http(s)?:\/\/frog.wix.com\//);
}

function isResourceUnsupported(resource) {
  return isCORS(resource.name) && resource.transferSize === 0 && resource.requestStart === 0;
}

function isCORS(resourceName) {
  var host = _location2.default.getHost();
  return host && resourceName.indexOf(host) === -1;
}

function normalizeValues(analysis) {
  return Object.keys(analysis).reduce(function (result, key) {
    var n = parseInt(analysis[key]);
    if (!isNaN(n) && typeof n === 'number') {
      result[key] = n;
    }
    return result;
  }, {});
}

function countAllResourcesByType(resources) {
  var supportedResources = resources.filter(function (r) {
    return !isResourceUnsupported(r);
  });
  return Object.keys(RESOURCES_TYPES).reduce(function (result, currentType) {
    var allSameTypeResources = filterResourcesByType(resources, currentType);
    var supportedSameTypeResources = filterResourcesByType(supportedResources, currentType);
    var type = RESOURCES_TYPES[currentType];
    result[type.count] = supportedSameTypeResources.length;
    result[type.duration] = calculateResourceLoadDuration(supportedSameTypeResources);
    result[type.total] = calculateTotalSizeOfResource(supportedSameTypeResources);
    result[type.unsupported] = calculatePercentageOfUnsupportedResources(allSameTypeResources);
    result[type.http2] = calculatePercentageOfHttp2(allSameTypeResources);
    if (type.longest) {
      result[type.longest] = calculateResourceLoadLongestDuration(supportedSameTypeResources);
    }
    if (type.cached) {
      result[type.cached] = calculateCachedResourcesPercentage(supportedSameTypeResources);
    }
    return result;
  }, {});
}

function extractResourceMetrics(resource) {
  return {
    url: resource.name,
    downloadDuration: resource.responseEnd - resource.startTime,
    bytesTransferred: resource.transferSize,
    isHTTP2: resource.nextHopProtocol === 'h2'
  };
}

function getResourcesBreakdown(resources) {
  var resourcesPartition = resources.reduce(function (result, r) {
    if (isResourceUnsupported(r)) {
      result.unsupported.push(r);
    } else {
      result.supported.push(r);
    }
    return result;
  }, { supported: [], unsupported: [] });
  return Object.keys(RESOURCES_TYPES).reduce(function (result, currentType) {
    result[currentType] = {};
    result[currentType].supported = filterResourcesByType(resourcesPartition.supported, currentType).map(function (r) {
      return extractResourceMetrics(r);
    });
    result[currentType].unsupported = filterResourcesByType(resourcesPartition.unsupported, currentType).map(function (r) {
      return extractResourceMetrics(r);
    });
    return result;
  }, {});
}

var ResourceDataItem = function (_BiBaseDataItem) {
  _inherits(ResourceDataItem, _BiBaseDataItem);

  function ResourceDataItem(sessionId) {
    _classCallCheck(this, ResourceDataItem);

    return _possibleConstructorReturn(this, (ResourceDataItem.__proto__ || Object.getPrototypeOf(ResourceDataItem)).call(this, 18, sessionId));
  }

  _createClass(ResourceDataItem, [{
    key: 'performNetworkAnalysis',
    value: function performNetworkAnalysis(resources) {
      if (resources.length === 0) {
        return null;
      }
      var t0 = _performance2.default.now();
      var resourcesToHandle = resources.filter(isResourceRelevant);
      var analysis = countAllResourcesByType(resourcesToHandle);
      analysis.overhead = _performance2.default.now() - t0;
      var result = normalizeValues(analysis);
      if (console.debug && _location2.default.isFedopsDev()) {
        var resourcesBreakdown = getResourcesBreakdown(resourcesToHandle);
        console.debug('[fedops network analysis] [bytes analysis]\n' + JSON.stringify(result, null, 4));
        console.debug('[fedops network analysis] [resources breakdown]\n', resourcesBreakdown);
      }
      return result;
    }
  }]);

  return ResourceDataItem;
}(_biBaseItem2.default);

exports.default = ResourceDataItem;

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _env = __webpack_require__(6);

var location = function location() {
  return typeof (0, _env.env)() !== 'undefined' && (0, _env.env)().location;
};

exports.default = {
  getHost: function getHost() {
    return location() && (0, _env.env)().location.host;
  },
  isFedopsDev: function isFedopsDev() {
    var q = (location() || {}).search || '';
    return q.indexOf('fedops=dev') > -1;
  }
};

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _biBaseItem = __webpack_require__(17);

var _biBaseItem2 = _interopRequireDefault(_biBaseItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Represents the "load finished" bi event:
 * http://bo.wix.com/bi-catalog-webapp/#/sources/72/events/11
 *
 * It should be used to monitor the initial application load.
 */
var BiLoadFinishDataItem = function (_BiBaseDataItem) {
  _inherits(BiLoadFinishDataItem, _BiBaseDataItem);

  function BiLoadFinishDataItem(sessionId) {
    _classCallCheck(this, BiLoadFinishDataItem);

    return _possibleConstructorReturn(this, (BiLoadFinishDataItem.__proto__ || Object.getPrototypeOf(BiLoadFinishDataItem)).call(this, 11, sessionId));
  }

  return BiLoadFinishDataItem;
}(_biBaseItem2.default);

exports.default = BiLoadFinishDataItem;

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.INTERACTION_START_EVID = undefined;

var _biBaseItem = __webpack_require__(17);

var _biBaseItem2 = _interopRequireDefault(_biBaseItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var INTERACTION_START_EVID = exports.INTERACTION_START_EVID = 15;
/**
 * Represents the "load finished" bi event:
 * http://bo.wix.com/bi-catalog-webapp/#/sources/72/events/11
 *
 * It should be used to monitor the initial application load.
 */

var BiInteractionStartDataItem = function (_BiBaseDataItem) {
  _inherits(BiInteractionStartDataItem, _BiBaseDataItem);

  function BiInteractionStartDataItem(sessionId) {
    _classCallCheck(this, BiInteractionStartDataItem);

    return _possibleConstructorReturn(this, (BiInteractionStartDataItem.__proto__ || Object.getPrototypeOf(BiInteractionStartDataItem)).call(this, INTERACTION_START_EVID, sessionId));
  }

  return BiInteractionStartDataItem;
}(_biBaseItem2.default);

exports.default = BiInteractionStartDataItem;

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.INTERACTION_END_EVID = undefined;

var _biBaseItem = __webpack_require__(17);

var _biBaseItem2 = _interopRequireDefault(_biBaseItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var INTERACTION_END_EVID = exports.INTERACTION_END_EVID = 16;

/**
 * Represents the "load finished" bi event:
 * http://bo.wix.com/bi-catalog-webapp/#/sources/72/events/11
 *
 * It should be used to monitor the initial application load.
 */

var BiInteractionEndDataItem = function (_BiBaseDataItem) {
  _inherits(BiInteractionEndDataItem, _BiBaseDataItem);

  function BiInteractionEndDataItem(sessionId) {
    _classCallCheck(this, BiInteractionEndDataItem);

    return _possibleConstructorReturn(this, (BiInteractionEndDataItem.__proto__ || Object.getPrototypeOf(BiInteractionEndDataItem)).call(this, INTERACTION_END_EVID, sessionId));
  }

  return BiInteractionEndDataItem;
}(_biBaseItem2.default);

exports.default = BiInteractionEndDataItem;

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _baseLogger = __webpack_require__(192);

var _baseLogger2 = _interopRequireDefault(_baseLogger);

var _biLoadStartItem = __webpack_require__(494);

var _biLoadStartItem2 = _interopRequireDefault(_biLoadStartItem);

var _time = __webpack_require__(194);

var _time2 = _interopRequireDefault(_time);

var _appData = __webpack_require__(195);

var _appData2 = _interopRequireDefault(_appData);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Logs application load phases.
 *
 * Before adding new parameters to the reported events, please make sure the BI schema supports them:
 * http://bo.wix.com/bi-catalog-webapp/#/sources/72
 */
var WidgetLoggerInstance = function (_BaseLogger) {
  _inherits(WidgetLoggerInstance, _BaseLogger);

  function WidgetLoggerInstance(appName, appVersion, reporter, _ref) {
    var sessionId = _ref.sessionId,
        disableAutoLoadFinish = _ref.disableAutoLoadFinish;

    _classCallCheck(this, WidgetLoggerInstance);

    var _this = _possibleConstructorReturn(this, (WidgetLoggerInstance.__proto__ || Object.getPrototypeOf(WidgetLoggerInstance)).call(this, appName, appVersion, reporter, { sessionId: sessionId, disableAutoLoadFinish: disableAutoLoadFinish }));

    _appData2.default.init(_this.appName);
    return _this;
  }

  /**
   * Manual report for widget load start (http://bo.wix.com/bi-catalog-webapp/#/sources/72/events/14)
   * Call this method at the earliest point possible when your widget starts loading
   */


  _createClass(WidgetLoggerInstance, [{
    key: 'appLoadStarted',
    value: function appLoadStarted() {

      _time2.default.loadStarted(this.appName);

      var dataSource = this.dataSource.clone().addItem(new _biLoadStartItem2.default(this.sessionId));

      return this._report(dataSource);
    }
  }, {
    key: 'isDisableAutoLoadFinish',
    value: function isDisableAutoLoadFinish() {
      return this._isDisableAutoLoadFinish();
    }
  }]);

  return WidgetLoggerInstance;
}(_baseLogger2.default);

exports.default = WidgetLoggerInstance;

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _biBaseItem = __webpack_require__(17);

var _biBaseItem2 = _interopRequireDefault(_biBaseItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Represents the "load started" bi event:
 * http://bo.wix.com/bi-catalog-webapp/#/sources/72/events/14
 *
 * It should be used to monitor the initial application load.
 */
var BiLoadStartDataItem = function (_BiBaseDataItem) {
  _inherits(BiLoadStartDataItem, _BiBaseDataItem);

  function BiLoadStartDataItem(sessionId) {
    _classCallCheck(this, BiLoadStartDataItem);

    return _possibleConstructorReturn(this, (BiLoadStartDataItem.__proto__ || Object.getPrototypeOf(BiLoadStartDataItem)).call(this, 14, sessionId));
  }

  return BiLoadStartDataItem;
}(_biBaseItem2.default);

exports.default = BiLoadStartDataItem;

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /*eslint-disable camelcase*/


var _env = __webpack_require__(6);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ErrorHandler = function () {
  function ErrorHandler(_ref) {
    var swallowExceptions = _ref.swallowExceptions;

    _classCallCheck(this, ErrorHandler);

    this.swallowExceptions = swallowExceptions;
    this.listeners = {};

    //*************************************************************************
    // We are wrapping the browser's native methods with try/catch for several
    // reasons:
    //
    // 1. It provides us with a more elaborate stack trace.
    //    Currently we ignore the stack trace due to BI limitations, but it can
    //    be very useful for future support.
    //
    // 2. Makes it easier to classify the error types.
    //
    // 3. Some browsers don't support a global error handler.
    //*************************************************************************

    this.instrumentAjax();
    this.instrumentSetTimeout();
    this.instrumentSetInterval();
    this.instrumentAddEventListener();
    this.instrumentFetch();
    this.instrumentPromise();

    //Sometimes catches one of the instruments above? Need to verify...
    this.instrumentGloballyUnhandledError();
  }

  _createClass(ErrorHandler, [{
    key: 'subscribeListener',
    value: function subscribeListener(appName, cb) {
      this.listeners[appName] = cb;
    }
  }, {
    key: 'removeListener',
    value: function removeListener(appName) {
      delete this.listeners[appName];
    }
  }, {
    key: 'instrumentAjax',
    value: function instrumentAjax() {
      var self = this;

      if ('XMLHttpRequest' in (0, _env.env)()) {
        var xhrproto = XMLHttpRequest.prototype;

        this._wrap(xhrproto, 'open', function (orig) {
          return function (method, url) {
            this.__fedops_xhr = {
              method: method,
              url: url,
              status_code: null
            };

            return orig.apply(this, arguments);
          };
        }, 'xhr');

        this._wrap(xhrproto, 'send', function (orig) {
          return function () {
            var xhr = this;

            function saveStatusCode() {
              if (xhr.readyState === 1 || xhr.readyState === 4) {
                try {
                  xhr.__fedops_xhr.status_code = xhr.status;
                } catch (e) {}

                if (self._isErrorStatusCode(xhr.__fedops_xhr.status_code)) {
                  self._reportError(xhr.__fedops_xhr, 'xhr', xhr.__fedops_xhr.status_code);
                }
              }
            }

            self._wrap(this, 'onload', function (orig) {
              return function () {
                orig && orig.apply(this, arguments);
              };
            }, 'xhr');

            self._wrap(this, 'onerror', function (orig) {
              return function () {
                orig && orig.apply(this, arguments);
              };
            }, 'xhr');

            self._wrap(this, 'onprogress', function (orig) {
              return function () {
                orig && orig.apply(this, arguments);
              };
            }, 'xhr');

            if ('onreadystatechange' in xhr && typeof xhr.onreadystatechange === 'function') {
              self._wrap(xhr, 'onreadystatechange', function (orig) {
                return function () {
                  saveStatusCode();
                  return orig.apply(this, arguments);
                };
              });
            } else {
              xhr.onreadystatechange = saveStatusCode;
            }

            return orig.apply(this, arguments);
          };
        }, 'xhr');
      }
    }
  }, {
    key: 'instrumentSetTimeout',
    value: function instrumentSetTimeout() {
      var self = this;

      this._wrap((0, _env.env)(), 'setTimeout', function (globalSetTimeout) {
        return function (fn) {
          for (var _len = arguments.length, rest = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            rest[_key - 1] = arguments[_key];
          }

          return globalSetTimeout.call.apply(globalSetTimeout, [this, self._wrapCallback(fn, 'setTimeout')].concat(rest));
        };
      });
    }
  }, {
    key: 'instrumentSetInterval',
    value: function instrumentSetInterval() {
      var self = this;

      this._wrap((0, _env.env)(), 'setInterval', function (globalSetInterval) {
        return function (fn) {
          for (var _len2 = arguments.length, rest = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            rest[_key2 - 1] = arguments[_key2];
          }

          return globalSetInterval.call.apply(globalSetInterval, [this, self._wrapCallback(fn, 'setInterval')].concat(rest));
        };
      });
    }
  }, {
    key: 'instrumentAddEventListener',
    value: function instrumentAddEventListener() {
      var self = this;

      function instrumentEventTarget(name) {
        var origTarget = (0, _env.env)()[name] && (0, _env.env)()[name].prototype;

        if (origTarget && Object.prototype.hasOwnProperty.call(origTarget, 'addEventListener')) {
          self._wrap(origTarget, 'addEventListener', function (orig) {
            return function (eventName, fn, capture, secure) {
              var wrapped = self._wrapCallback(fn, 'addEventListener');

              if (fn) {
                fn.__fedopsWrapper__ = wrapped;
              }

              return orig.call(this, eventName, wrapped, capture, secure);
            };
          });

          self._wrap(origTarget, 'removeEventListener', function (orig) {
            return function (eventName, fn, capture, secure) {
              fn = fn && (fn.__fedopsWrapper__ || fn);
              return orig.call(this, eventName, fn, capture, secure);
            };
          });
        }
      }

      var eventTargets = ['EventTarget', 'env()', 'Node', 'ApplicationCache', 'AudioTrackList', 'ChannelMergerNode', 'CryptoOperation', 'EventSource', 'FileReader', 'HTMLUnknownElement', 'IDBDatabase', 'IDBRequest', 'IDBTransaction', 'KeyOperation', 'MediaController', 'MessagePort', 'Modalenv()', 'Notification', 'SVGElementInstance', 'Screen', 'TextTrack', 'TextTrackCue', 'TextTrackList', 'WebSocket', 'WebSocketWorker', 'Worker', 'XMLHttpRequest', 'XMLHttpRequestEventTarget', 'XMLHttpRequestUpload'];
      eventTargets.forEach(function (name) {
        return instrumentEventTarget(name);
      });
    }
  }, {
    key: 'instrumentRequestAnimationFrame',
    value: function instrumentRequestAnimationFrame() {}
  }, {
    key: 'instrumentFetch',
    value: function instrumentFetch() {
      var self = this;

      this._wrap((0, _env.env)(), 'fetch', function (globalFetch) {
        return function (url, fetchOptions) {
          return globalFetch.apply(this, arguments).then(function (response) {
            var statusCode = response.status;

            if (self._isErrorStatusCode(statusCode)) {
              var requestInfo = {
                url: url,
                method: fetchOptions ? fetchOptions.method : 'GET',
                status_code: statusCode
              };

              self._reportError(requestInfo, 'fetch', statusCode);
            }

            return response;
          });
        };
      });
    }
  }, {
    key: 'instrumentPromise',
    value: function instrumentPromise() {
      var self = this;

      (0, _env.env)().addEventListener('unhandledrejection', function (err) {
        self._reportError(err, 'promise');
      });
    }
  }, {
    key: 'instrumentGloballyUnhandledError',
    value: function instrumentGloballyUnhandledError() {
      var _this = this;

      (0, _env.env)().addEventListener('error', function (err) {
        _this._reportError(err, 'env()OnError');
      });
    }
  }, {
    key: 'instrumentHistory',
    value: function instrumentHistory() {}
  }, {
    key: '_wrap',
    value: function _wrap(obj, fnName, replaced, errorType) {
      var self = this;
      var orig = obj[fnName];
      var r = replaced(orig);

      var wrapped = function wrapped() {
        try {
          return r.apply(this, arguments);
        } catch (err) {
          self._reportError(err, errorType);

          if (!self.swallowExceptions) {
            throw err;
          }
        }
      };

      obj[fnName] = wrapped;
    }
  }, {
    key: '_wrapCallback',
    value: function _wrapCallback(fn, errorType) {
      var self = this;

      return function () {
        try {
          return fn.apply(this, arguments);
        } catch (err) {
          self._reportError(err, errorType);

          if (!self.swallowExceptions) {
            throw err;
          }
        }
      };
    }
  }, {
    key: '_reportError',
    value: function _reportError(err, errorType, errorInfo) {
      var self = this;

      var actualError = err && (err.error || err);

      if (!actualError.__fedopsHandledError__) {
        var appNames = Object.keys(this.listeners);

        appNames.forEach(function (appName) {
          self.listeners[appName](actualError, errorType, errorInfo);
        });

        actualError.__fedopsHandledError__ = true;
      }
    }
  }, {
    key: '_isErrorStatusCode',
    value: function _isErrorStatusCode(statusCode) {
      return statusCode >= 400 || statusCode === 0;
    }
  }]);

  return ErrorHandler;
}();

/*eslint-enable camelcase*/


exports.default = ErrorHandler;

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var BI_BASE_URL = exports.BI_BASE_URL = 'https://frog.wix.com/fed';
var SESSION_ID_STORAGE_KEY = exports.SESSION_ID_STORAGE_KEY = 'fedops.logger.sessionId';
var DEFAULT_APP_VERSION = exports.DEFAULT_APP_VERSION = '0.0.0';

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (Raven) {
  function startHook(_ref) {
    var name = _ref.name;

    Raven.captureBreadcrumb({
      category: 'interaction start',
      message: 'interaction ' + name + ' started'
    });
  }

  function endHook(_ref2) {
    var name = _ref2.name,
        timeout = _ref2.timeout,
        duration = _ref2.duration;

    if (duration > timeout) {
      Raven.captureMessage('interaction ' + name + ' ended after timeout', {
        level: 'info',
        extra: {
          interactionDuration: duration
        }
      });
    } else {
      Raven.captureBreadcrumb({
        category: 'interaction end',
        message: 'interaction ' + name + ' ended after ' + duration + ' ms'
      });
    }
  }

  function timeoutHook(_ref3) {
    var name = _ref3.name,
        timeout = _ref3.timeout;

    Raven.captureMessage('interaction ' + name + ' timed out', {
      level: 'warning',
      extra: {
        interactionTimeout: timeout
      }
    });
  }

  return {
    startHook: startHook,
    endHook: endHook,
    timeoutHook: timeoutHook
  };
};

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// app.js